// src/abis/generated.ts
var allocatedMerkleAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      {
        name: "permissions_",
        internalType: "struct Callbacks.Permissions",
        type: "tuple",
        components: [
          { name: "onCreate", internalType: "bool", type: "bool" },
          { name: "onCancel", internalType: "bool", type: "bool" },
          { name: "onCurate", internalType: "bool", type: "bool" },
          { name: "onPurchase", internalType: "bool", type: "bool" },
          { name: "onBid", internalType: "bool", type: "bool" },
          { name: "onSettle", internalType: "bool", type: "bool" },
          { name: "receiveQuoteTokens", internalType: "bool", type: "bool" },
          { name: "sendBaseTokens", internalType: "bool", type: "bool" }
        ]
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "buyer", internalType: "address", type: "address" }
    ],
    name: "lotBuyerSpent",
    outputs: [{ name: "spent", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotMerkleRoot",
    outputs: [{ name: "merkleRoot", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "merkleRoot_", internalType: "bytes32", type: "bytes32" }
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: false },
      {
        name: "merkleRoot",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "MerkleRootSet"
  },
  { type: "error", inputs: [], name: "Callback_ExceedsLimit" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  }
];
var baselineAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "baselineKernel_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" },
      { name: "owner_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "BPOOL",
    outputs: [{ name: "", internalType: "contract IBPOOLv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "CREDT",
    outputs: [{ name: "", internalType: "contract ICREDTv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LOOPS",
    outputs: [{ name: "", internalType: "contract ILOOPSv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "RESERVE",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "bAsset",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "newKernel_", internalType: "contract Kernel", type: "address" }
    ],
    name: "changeKernel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "configureDependencies",
    outputs: [
      { name: "dependencies", internalType: "Keycode[]", type: "bytes5[]" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "floorReservesPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "isActive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "kernel",
    outputs: [{ name: "", internalType: "contract Kernel", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "lotId",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolTargetTick",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "recipient",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "requestPermissions",
    outputs: [
      {
        name: "requests",
        internalType: "struct Permissions[]",
        type: "tuple[]",
        components: [
          { name: "keycode", internalType: "Keycode", type: "bytes5" },
          { name: "funcSelector", internalType: "bytes4", type: "bytes4" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "bAssetDelta_", internalType: "int256", type: "int256" },
      { name: "", internalType: "int256", type: "int256" },
      { name: "data_", internalType: "bytes", type: "bytes" }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "floorTickLower",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "anchorTickUpper",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "floorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "anchorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "LiquidityDeployed"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  { type: "error", inputs: [], name: "Callback_AlreadyComplete" },
  { type: "error", inputs: [], name: "Callback_BPOOLInvalidAddress" },
  { type: "error", inputs: [], name: "Callback_BPOOLReserveMismatch" },
  {
    type: "error",
    inputs: [
      { name: "capacityRatio", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InvalidCapacityRatio"
  },
  { type: "error", inputs: [], name: "Callback_InvalidInitialization" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_MissingFunds" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "bAsset_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_BAssetTokenMismatch"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickUpper" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickWidth" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidDiscoveryTickWidth"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidFloorRangeGap" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidFloorReservesPercent"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidPoolPercent" },
  {
    type: "error",
    inputs: [
      { name: "anchorRangeLower", internalType: "int24", type: "int24" },
      { name: "anchorRangeUpper", internalType: "int24", type: "int24" }
    ],
    name: "Callback_Params_InvalidPoolTargetTick"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidRecipient" },
  { type: "error", inputs: [], name: "Callback_Params_RangeOutOfBounds" },
  {
    type: "error",
    inputs: [
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_ReserveTokenMismatch"
  },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_UnsupportedAuctionFormat"
  },
  { type: "error", inputs: [], name: "Callback_Params_UnsupportedPoolFeeTier" },
  {
    type: "error",
    inputs: [
      { name: "currentTick", internalType: "int24", type: "int24" },
      { name: "auctionTick", internalType: "int24", type: "int24" }
    ],
    name: "Callback_PoolLessThanAuctionPrice"
  },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCaller" },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCase" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "KernelAdapter_OnlyKernel"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "Policy_ModuleDoesNotExist"
  },
  {
    type: "error",
    inputs: [{ name: "expected_", internalType: "bytes", type: "bytes" }],
    name: "Policy_WrongModuleVersion"
  },
  { type: "error", inputs: [], name: "R" },
  { type: "error", inputs: [], name: "T" },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var baselineAllocatedAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "baselineKernel_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" },
      { name: "owner_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "BPOOL",
    outputs: [{ name: "", internalType: "contract IBPOOLv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "CREDT",
    outputs: [{ name: "", internalType: "contract ICREDTv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LOOPS",
    outputs: [{ name: "", internalType: "contract ILOOPSv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "RESERVE",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "bAsset",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "buyerSpent",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "newKernel_", internalType: "contract Kernel", type: "address" }
    ],
    name: "changeKernel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "configureDependencies",
    outputs: [
      { name: "dependencies", internalType: "Keycode[]", type: "bytes5[]" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "floorReservesPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "isActive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "kernel",
    outputs: [{ name: "", internalType: "contract Kernel", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "lotId",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "merkleRoot",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolTargetTick",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "recipient",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "requestPermissions",
    outputs: [
      {
        name: "requests",
        internalType: "struct Permissions[]",
        type: "tuple[]",
        components: [
          { name: "keycode", internalType: "Keycode", type: "bytes5" },
          { name: "funcSelector", internalType: "bytes4", type: "bytes4" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "merkleRoot_", internalType: "bytes32", type: "bytes32" }],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "bAssetDelta_", internalType: "int256", type: "int256" },
      { name: "", internalType: "int256", type: "int256" },
      { name: "data_", internalType: "bytes", type: "bytes" }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "floorTickLower",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "anchorTickUpper",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "floorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "anchorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "LiquidityDeployed"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "merkleRoot",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "MerkleRootSet"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  { type: "error", inputs: [], name: "Callback_AlreadyComplete" },
  { type: "error", inputs: [], name: "Callback_BPOOLInvalidAddress" },
  { type: "error", inputs: [], name: "Callback_BPOOLReserveMismatch" },
  { type: "error", inputs: [], name: "Callback_ExceedsLimit" },
  {
    type: "error",
    inputs: [
      { name: "capacityRatio", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InvalidCapacityRatio"
  },
  { type: "error", inputs: [], name: "Callback_InvalidInitialization" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_InvalidState" },
  { type: "error", inputs: [], name: "Callback_MissingFunds" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "bAsset_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_BAssetTokenMismatch"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickUpper" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickWidth" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidDiscoveryTickWidth"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidFloorRangeGap" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidFloorReservesPercent"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidPoolPercent" },
  {
    type: "error",
    inputs: [
      { name: "anchorRangeLower", internalType: "int24", type: "int24" },
      { name: "anchorRangeUpper", internalType: "int24", type: "int24" }
    ],
    name: "Callback_Params_InvalidPoolTargetTick"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidRecipient" },
  { type: "error", inputs: [], name: "Callback_Params_RangeOutOfBounds" },
  {
    type: "error",
    inputs: [
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_ReserveTokenMismatch"
  },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_UnsupportedAuctionFormat"
  },
  { type: "error", inputs: [], name: "Callback_Params_UnsupportedPoolFeeTier" },
  {
    type: "error",
    inputs: [
      { name: "currentTick", internalType: "int24", type: "int24" },
      { name: "auctionTick", internalType: "int24", type: "int24" }
    ],
    name: "Callback_PoolLessThanAuctionPrice"
  },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCaller" },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCase" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "KernelAdapter_OnlyKernel"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "Policy_ModuleDoesNotExist"
  },
  {
    type: "error",
    inputs: [{ name: "expected_", internalType: "bytes", type: "bytes" }],
    name: "Policy_WrongModuleVersion"
  },
  { type: "error", inputs: [], name: "R" },
  { type: "error", inputs: [], name: "T" },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var baselineAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "baselineKernel_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" },
      { name: "owner_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "BPOOL",
    outputs: [{ name: "", internalType: "contract IBPOOLv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "CREDT",
    outputs: [{ name: "", internalType: "contract ICREDTv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LOOPS",
    outputs: [{ name: "", internalType: "contract ILOOPSv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "RESERVE",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "bAsset",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "newKernel_", internalType: "contract Kernel", type: "address" }
    ],
    name: "changeKernel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "configureDependencies",
    outputs: [
      { name: "dependencies", internalType: "Keycode[]", type: "bytes5[]" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "floorReservesPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "isActive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "kernel",
    outputs: [{ name: "", internalType: "contract Kernel", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "lotId",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "merkleRoot",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolTargetTick",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "recipient",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "requestPermissions",
    outputs: [
      {
        name: "requests",
        internalType: "struct Permissions[]",
        type: "tuple[]",
        components: [
          { name: "keycode", internalType: "Keycode", type: "bytes5" },
          { name: "funcSelector", internalType: "bytes4", type: "bytes4" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "merkleRoot_", internalType: "bytes32", type: "bytes32" }],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "bAssetDelta_", internalType: "int256", type: "int256" },
      { name: "", internalType: "int256", type: "int256" },
      { name: "data_", internalType: "bytes", type: "bytes" }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "floorTickLower",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "anchorTickUpper",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "floorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "anchorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "LiquidityDeployed"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "merkleRoot",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "MerkleRootSet"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  { type: "error", inputs: [], name: "Callback_AlreadyComplete" },
  { type: "error", inputs: [], name: "Callback_BPOOLInvalidAddress" },
  { type: "error", inputs: [], name: "Callback_BPOOLReserveMismatch" },
  {
    type: "error",
    inputs: [
      { name: "capacityRatio", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InvalidCapacityRatio"
  },
  { type: "error", inputs: [], name: "Callback_InvalidInitialization" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_InvalidState" },
  { type: "error", inputs: [], name: "Callback_MissingFunds" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "bAsset_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_BAssetTokenMismatch"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickUpper" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickWidth" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidDiscoveryTickWidth"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidFloorRangeGap" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidFloorReservesPercent"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidPoolPercent" },
  {
    type: "error",
    inputs: [
      { name: "anchorRangeLower", internalType: "int24", type: "int24" },
      { name: "anchorRangeUpper", internalType: "int24", type: "int24" }
    ],
    name: "Callback_Params_InvalidPoolTargetTick"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidRecipient" },
  { type: "error", inputs: [], name: "Callback_Params_RangeOutOfBounds" },
  {
    type: "error",
    inputs: [
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_ReserveTokenMismatch"
  },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_UnsupportedAuctionFormat"
  },
  { type: "error", inputs: [], name: "Callback_Params_UnsupportedPoolFeeTier" },
  {
    type: "error",
    inputs: [
      { name: "currentTick", internalType: "int24", type: "int24" },
      { name: "auctionTick", internalType: "int24", type: "int24" }
    ],
    name: "Callback_PoolLessThanAuctionPrice"
  },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCaller" },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCase" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "KernelAdapter_OnlyKernel"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "Policy_ModuleDoesNotExist"
  },
  {
    type: "error",
    inputs: [{ name: "expected_", internalType: "bytes", type: "bytes" }],
    name: "Policy_WrongModuleVersion"
  },
  { type: "error", inputs: [], name: "R" },
  { type: "error", inputs: [], name: "T" },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var baselineCappedAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "baselineKernel_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" },
      { name: "owner_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "BPOOL",
    outputs: [{ name: "", internalType: "contract IBPOOLv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "CREDT",
    outputs: [{ name: "", internalType: "contract ICREDTv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LOOPS",
    outputs: [{ name: "", internalType: "contract ILOOPSv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "RESERVE",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "bAsset",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "buyerLimit",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "buyerSpent",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "newKernel_", internalType: "contract Kernel", type: "address" }
    ],
    name: "changeKernel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "configureDependencies",
    outputs: [
      { name: "dependencies", internalType: "Keycode[]", type: "bytes5[]" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "floorReservesPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "isActive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "kernel",
    outputs: [{ name: "", internalType: "contract Kernel", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "lotId",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "merkleRoot",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolTargetTick",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "recipient",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "requestPermissions",
    outputs: [
      {
        name: "requests",
        internalType: "struct Permissions[]",
        type: "tuple[]",
        components: [
          { name: "keycode", internalType: "Keycode", type: "bytes5" },
          { name: "funcSelector", internalType: "bytes4", type: "bytes4" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "merkleRoot_", internalType: "bytes32", type: "bytes32" }],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "bAssetDelta_", internalType: "int256", type: "int256" },
      { name: "", internalType: "int256", type: "int256" },
      { name: "data_", internalType: "bytes", type: "bytes" }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "floorTickLower",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "anchorTickUpper",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "floorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "anchorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "LiquidityDeployed"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "merkleRoot",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "MerkleRootSet"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  { type: "error", inputs: [], name: "Callback_AlreadyComplete" },
  { type: "error", inputs: [], name: "Callback_BPOOLInvalidAddress" },
  { type: "error", inputs: [], name: "Callback_BPOOLReserveMismatch" },
  { type: "error", inputs: [], name: "Callback_ExceedsLimit" },
  {
    type: "error",
    inputs: [
      { name: "capacityRatio", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InvalidCapacityRatio"
  },
  { type: "error", inputs: [], name: "Callback_InvalidInitialization" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_InvalidState" },
  { type: "error", inputs: [], name: "Callback_MissingFunds" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "bAsset_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_BAssetTokenMismatch"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickUpper" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickWidth" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidDiscoveryTickWidth"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidFloorRangeGap" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidFloorReservesPercent"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidPoolPercent" },
  {
    type: "error",
    inputs: [
      { name: "anchorRangeLower", internalType: "int24", type: "int24" },
      { name: "anchorRangeUpper", internalType: "int24", type: "int24" }
    ],
    name: "Callback_Params_InvalidPoolTargetTick"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidRecipient" },
  { type: "error", inputs: [], name: "Callback_Params_RangeOutOfBounds" },
  {
    type: "error",
    inputs: [
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_ReserveTokenMismatch"
  },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_UnsupportedAuctionFormat"
  },
  { type: "error", inputs: [], name: "Callback_Params_UnsupportedPoolFeeTier" },
  {
    type: "error",
    inputs: [
      { name: "currentTick", internalType: "int24", type: "int24" },
      { name: "auctionTick", internalType: "int24", type: "int24" }
    ],
    name: "Callback_PoolLessThanAuctionPrice"
  },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCaller" },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCase" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "KernelAdapter_OnlyKernel"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "Policy_ModuleDoesNotExist"
  },
  {
    type: "error",
    inputs: [{ name: "expected_", internalType: "bytes", type: "bytes" }],
    name: "Policy_WrongModuleVersion"
  },
  { type: "error", inputs: [], name: "R" },
  { type: "error", inputs: [], name: "T" },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var baselineTokenAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "baselineKernel_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" },
      { name: "owner_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "BPOOL",
    outputs: [{ name: "", internalType: "contract IBPOOLv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "CREDT",
    outputs: [{ name: "", internalType: "contract ICREDTv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LOOPS",
    outputs: [{ name: "", internalType: "contract ILOOPSv1", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "RESERVE",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionComplete",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "bAsset",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "newKernel_", internalType: "contract Kernel", type: "address" }
    ],
    name: "changeKernel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "configureDependencies",
    outputs: [
      { name: "dependencies", internalType: "Keycode[]", type: "bytes5[]" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "floorReservesPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "isActive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "kernel",
    outputs: [{ name: "", internalType: "contract Kernel", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "lotId",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolPercent",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "poolTargetTick",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "recipient",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "requestPermissions",
    outputs: [
      {
        name: "requests",
        internalType: "struct Permissions[]",
        type: "tuple[]",
        components: [
          { name: "keycode", internalType: "Keycode", type: "bytes5" },
          { name: "funcSelector", internalType: "bytes4", type: "bytes4" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "tokenCheck",
    outputs: [
      {
        name: "token",
        internalType: "contract ITokenBalance",
        type: "address"
      },
      { name: "threshold", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "bAssetDelta_", internalType: "int256", type: "int256" },
      { name: "", internalType: "int256", type: "int256" },
      { name: "data_", internalType: "bytes", type: "bytes" }
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "floorTickLower",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "anchorTickUpper",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "floorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "anchorLiquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "LiquidityDeployed"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  { type: "error", inputs: [], name: "Callback_AlreadyComplete" },
  { type: "error", inputs: [], name: "Callback_BPOOLInvalidAddress" },
  { type: "error", inputs: [], name: "Callback_BPOOLReserveMismatch" },
  {
    type: "error",
    inputs: [
      { name: "capacityRatio", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InvalidCapacityRatio"
  },
  { type: "error", inputs: [], name: "Callback_InvalidInitialization" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_MissingFunds" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "bAsset_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_BAssetTokenMismatch"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickUpper" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAnchorTickWidth" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidDiscoveryTickWidth"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidFloorRangeGap" },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_InvalidFloorReservesPercent"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidPoolPercent" },
  {
    type: "error",
    inputs: [
      { name: "anchorRangeLower", internalType: "int24", type: "int24" },
      { name: "anchorRangeUpper", internalType: "int24", type: "int24" }
    ],
    name: "Callback_Params_InvalidPoolTargetTick"
  },
  { type: "error", inputs: [], name: "Callback_Params_InvalidRecipient" },
  { type: "error", inputs: [], name: "Callback_Params_RangeOutOfBounds" },
  {
    type: "error",
    inputs: [
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "reserve_", internalType: "address", type: "address" }
    ],
    name: "Callback_Params_ReserveTokenMismatch"
  },
  {
    type: "error",
    inputs: [],
    name: "Callback_Params_UnsupportedAuctionFormat"
  },
  { type: "error", inputs: [], name: "Callback_Params_UnsupportedPoolFeeTier" },
  {
    type: "error",
    inputs: [
      { name: "currentTick", internalType: "int24", type: "int24" },
      { name: "auctionTick", internalType: "int24", type: "int24" }
    ],
    name: "Callback_PoolLessThanAuctionPrice"
  },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCaller" },
  { type: "error", inputs: [], name: "Callback_Swap_InvalidCase" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "KernelAdapter_OnlyKernel"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "Policy_ModuleDoesNotExist"
  },
  {
    type: "error",
    inputs: [{ name: "expected_", internalType: "bytes", type: "bytes" }],
    name: "Policy_WrongModuleVersion"
  },
  { type: "error", inputs: [], name: "R" },
  { type: "error", inputs: [], name: "T" },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var batchAuctionHouseAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "owner_", internalType: "address", type: "address" },
      { name: "protocol_", internalType: "address", type: "address" },
      { name: "permit2_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "abort",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      {
        name: "routing_",
        internalType: "struct IAuctionHouse.RoutingParams",
        type: "tuple",
        components: [
          { name: "auctionType", internalType: "Keycode", type: "bytes5" },
          { name: "baseToken", internalType: "address", type: "address" },
          { name: "quoteToken", internalType: "address", type: "address" },
          { name: "curator", internalType: "address", type: "address" },
          { name: "referrerFee", internalType: "uint48", type: "uint48" },
          {
            name: "callbacks",
            internalType: "contract ICallback",
            type: "address"
          },
          { name: "callbackData", internalType: "bytes", type: "bytes" },
          { name: "derivativeType", internalType: "Keycode", type: "bytes5" },
          { name: "derivativeParams", internalType: "bytes", type: "bytes" },
          { name: "wrapDerivative", internalType: "bool", type: "bool" }
        ]
      },
      {
        name: "params_",
        internalType: "struct IAuction.AuctionParams",
        type: "tuple",
        components: [
          { name: "start", internalType: "uint48", type: "uint48" },
          { name: "duration", internalType: "uint48", type: "uint48" },
          { name: "capacityInQuote", internalType: "bool", type: "bool" },
          { name: "capacity", internalType: "uint256", type: "uint256" },
          { name: "implParams", internalType: "bytes", type: "bytes" }
        ]
      },
      { name: "infoHash_", internalType: "string", type: "string" }
    ],
    name: "auction",
    outputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      {
        name: "params_",
        internalType: "struct IBatchAuctionHouse.BidParams",
        type: "tuple",
        components: [
          { name: "lotId", internalType: "uint96", type: "uint96" },
          { name: "bidder", internalType: "address", type: "address" },
          { name: "referrer", internalType: "address", type: "address" },
          { name: "amount", internalType: "uint256", type: "uint256" },
          { name: "auctionData", internalType: "bytes", type: "bytes" },
          { name: "permit2Data", internalType: "bytes", type: "bytes" }
        ]
      },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "bid",
    outputs: [{ name: "bidId", internalType: "uint64", type: "uint64" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "protocolFee_", internalType: "uint48", type: "uint48" },
      { name: "referrerFee_", internalType: "uint48", type: "uint48" },
      { name: "hasReferrer_", internalType: "bool", type: "bool" },
      { name: "amount_", internalType: "uint256", type: "uint256" }
    ],
    name: "calculateQuoteFees",
    outputs: [
      { name: "toReferrer", internalType: "uint256", type: "uint256" },
      { name: "toProtocol", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "cancel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidIds_", internalType: "uint64[]", type: "uint64[]" }
    ],
    name: "claimBids",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionRef", internalType: "Veecode", type: "bytes7" },
      { name: "derivativeRef", internalType: "Veecode", type: "bytes7" }
    ],
    name: "condensers",
    outputs: [
      { name: "condenserRef", internalType: "Veecode", type: "bytes7" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "curate",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "veecode_", internalType: "Veecode", type: "bytes7" },
      { name: "callData_", internalType: "bytes", type: "bytes" }
    ],
    name: "execOnModule",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "Keycode", type: "bytes5" }],
    name: "fees",
    outputs: [
      { name: "protocol", internalType: "uint48", type: "uint48" },
      { name: "maxReferrerFee", internalType: "uint48", type: "uint48" },
      { name: "maxCuratorFee", internalType: "uint48", type: "uint48" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getAuctionModuleForId",
    outputs: [{ name: "", internalType: "contract IAuction", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getBatchModuleForId",
    outputs: [
      {
        name: "",
        internalType: "contract BatchAuctionModule",
        type: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionType_", internalType: "Keycode", type: "bytes5" },
      { name: "curator_", internalType: "address", type: "address" }
    ],
    name: "getCuratorFee",
    outputs: [{ name: "curatorFee", internalType: "uint48", type: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getDerivativeModuleForId",
    outputs: [
      { name: "", internalType: "contract IDerivative", type: "address" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "auctionType_", internalType: "Keycode", type: "bytes5" }],
    name: "getFees",
    outputs: [
      { name: "protocol", internalType: "uint48", type: "uint48" },
      { name: "maxReferrerFee", internalType: "uint48", type: "uint48" },
      { name: "maxCuratorFee", internalType: "uint48", type: "uint48" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "Veecode", type: "bytes7" }],
    name: "getModuleForVeecode",
    outputs: [{ name: "", internalType: "contract Module", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "Keycode", type: "bytes5" }],
    name: "getModuleStatus",
    outputs: [
      { name: "latestVersion", internalType: "uint8", type: "uint8" },
      { name: "sunset", internalType: "bool", type: "bool" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "getProtocol",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "recipient_", internalType: "address", type: "address" },
      { name: "token_", internalType: "address", type: "address" }
    ],
    name: "getRewards",
    outputs: [{ name: "reward", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "newModule_", internalType: "contract Module", type: "address" }
    ],
    name: "installModule",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "isExecOnModule",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "lotCounter",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotFees",
    outputs: [
      { name: "curator", internalType: "address", type: "address" },
      { name: "curated", internalType: "bool", type: "bool" },
      { name: "curatorFee", internalType: "uint48", type: "uint48" },
      { name: "protocolFee", internalType: "uint48", type: "uint48" },
      { name: "referrerFee", internalType: "uint48", type: "uint48" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotRouting",
    outputs: [
      { name: "seller", internalType: "address", type: "address" },
      { name: "baseToken", internalType: "address", type: "address" },
      { name: "quoteToken", internalType: "address", type: "address" },
      { name: "auctionReference", internalType: "Veecode", type: "bytes7" },
      { name: "funding", internalType: "uint256", type: "uint256" },
      {
        name: "callbacks",
        internalType: "contract ICallback",
        type: "address"
      },
      { name: "derivativeReference", internalType: "Veecode", type: "bytes7" },
      { name: "wrapDerivative", internalType: "bool", type: "bool" },
      { name: "derivativeParams", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    name: "modules",
    outputs: [{ name: "", internalType: "Keycode", type: "bytes5" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "modulesCount",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" },
      { name: "index_", internalType: "uint256", type: "uint256" }
    ],
    name: "refundBid",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "contract ERC20", type: "address" }
    ],
    name: "rewards",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionRef_", internalType: "Veecode", type: "bytes7" },
      { name: "derivativeRef_", internalType: "Veecode", type: "bytes7" },
      { name: "condenserRef_", internalType: "Veecode", type: "bytes7" }
    ],
    name: "setCondenser",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionType_", internalType: "Keycode", type: "bytes5" },
      { name: "fee_", internalType: "uint48", type: "uint48" }
    ],
    name: "setCuratorFee",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionType_", internalType: "Keycode", type: "bytes5" },
      {
        name: "type_",
        internalType: "enum IFeeManager.FeeType",
        type: "uint8"
      },
      { name: "fee_", internalType: "uint48", type: "uint48" }
    ],
    name: "setFee",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "protocol_", internalType: "address", type: "address" }],
    name: "setProtocol",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "num_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "settle",
    outputs: [
      { name: "totalIn", internalType: "uint256", type: "uint256" },
      { name: "totalOut", internalType: "uint256", type: "uint256" },
      { name: "finished", internalType: "bool", type: "bool" },
      { name: "auctionOutput", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "sunsetModule",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "newOwner", internalType: "address", type: "address" }],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true }
    ],
    name: "Abort"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      {
        name: "auctionRef",
        internalType: "Veecode",
        type: "bytes7",
        indexed: true
      }
    ],
    name: "AuctionCancelled"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      {
        name: "auctionRef",
        internalType: "Veecode",
        type: "bytes7",
        indexed: true
      },
      {
        name: "infoHash",
        internalType: "string",
        type: "string",
        indexed: false
      }
    ],
    name: "AuctionCreated"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      { name: "bidId", internalType: "uint96", type: "uint96", indexed: true },
      {
        name: "bidder",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Bid"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      { name: "bidId", internalType: "uint96", type: "uint96", indexed: true },
      {
        name: "bidder",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "ClaimBid"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      {
        name: "curator",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "Curated"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "keycode",
        internalType: "Keycode",
        type: "bytes5",
        indexed: true
      },
      { name: "version", internalType: "uint8", type: "uint8", indexed: true },
      {
        name: "location",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "ModuleInstalled"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "keycode",
        internalType: "Keycode",
        type: "bytes5",
        indexed: true
      }
    ],
    name: "ModuleSunset"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "user", internalType: "address", type: "address", indexed: true },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnershipTransferred"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      { name: "bidId", internalType: "uint96", type: "uint96", indexed: true },
      {
        name: "bidder",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "RefundBid"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true }
    ],
    name: "Settle"
  },
  { type: "error", inputs: [], name: "AmountLessThanMinimum" },
  { type: "error", inputs: [], name: "FailedCallback" },
  { type: "error", inputs: [], name: "InsufficientFunding" },
  { type: "error", inputs: [], name: "InvalidCallback" },
  { type: "error", inputs: [], name: "InvalidCallbackResponse" },
  { type: "error", inputs: [], name: "InvalidFee" },
  {
    type: "error",
    inputs: [{ name: "id_", internalType: "uint96", type: "uint96" }],
    name: "InvalidLotId"
  },
  {
    type: "error",
    inputs: [
      { name: "keycode_", internalType: "Keycode", type: "bytes5" },
      { name: "version_", internalType: "uint8", type: "uint8" }
    ],
    name: "InvalidModuleInstall"
  },
  { type: "error", inputs: [], name: "InvalidParams" },
  { type: "error", inputs: [], name: "InvalidParams" },
  { type: "error", inputs: [], name: "InvalidState" },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "ModuleAlreadySunset"
  },
  {
    type: "error",
    inputs: [{ name: "error_", internalType: "bytes", type: "bytes" }],
    name: "ModuleExecutionReverted"
  },
  {
    type: "error",
    inputs: [{ name: "keycode_", internalType: "Keycode", type: "bytes5" }],
    name: "ModuleIsSunset"
  },
  {
    type: "error",
    inputs: [
      { name: "keycode_", internalType: "Keycode", type: "bytes5" },
      { name: "version_", internalType: "uint8", type: "uint8" }
    ],
    name: "ModuleNotInstalled"
  },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "NotPermitted"
  },
  {
    type: "error",
    inputs: [{ name: "target_", internalType: "address", type: "address" }],
    name: "TargetNotAContract"
  },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  },
  { type: "error", inputs: [], name: "Auction_AmountLessThanMinimum" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_DedicatedSettlePeriod"
  },
  { type: "error", inputs: [], name: "Auction_InsufficientCapacity" },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint96", type: "uint96" }
    ],
    name: "Auction_InvalidBidId"
  },
  {
    type: "error",
    inputs: [
      { name: "duration_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidDuration"
  },
  { type: "error", inputs: [], name: "Auction_InvalidKey" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_InvalidLotId"
  },
  { type: "error", inputs: [], name: "Auction_InvalidParams" },
  {
    type: "error",
    inputs: [
      { name: "start_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidStart"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotConcluded"
  },
  { type: "error", inputs: [], name: "Auction_NotAuthorized" },
  { type: "error", inputs: [], name: "Auction_NotBidder" },
  { type: "error", inputs: [], name: "Auction_NotImplemented" },
  { type: "error", inputs: [], name: "Auction_OnlyLotOwner" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_WrongState"
  },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" }
    ],
    name: "Bid_WrongState"
  },
  {
    type: "error",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    name: "Module_InvalidParent"
  },
  { type: "error", inputs: [], name: "Module_OnlyInternal" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "Module_OnlyParent"
  },
  {
    type: "error",
    inputs: [{ name: "caller", internalType: "address", type: "address" }],
    name: "NotPermitted"
  },
  { type: "error", inputs: [], name: "Auction_AmountLessThanMinimum" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_DedicatedSettlePeriod"
  },
  { type: "error", inputs: [], name: "Auction_InsufficientCapacity" },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint96", type: "uint96" }
    ],
    name: "Auction_InvalidBidId"
  },
  {
    type: "error",
    inputs: [
      { name: "duration_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidDuration"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_InvalidLotId"
  },
  { type: "error", inputs: [], name: "Auction_InvalidParams" },
  {
    type: "error",
    inputs: [
      { name: "start_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidStart"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotConcluded"
  },
  { type: "error", inputs: [], name: "Auction_NotAuthorized" },
  { type: "error", inputs: [], name: "Auction_NotBidder" },
  { type: "error", inputs: [], name: "Auction_NotImplemented" },
  { type: "error", inputs: [], name: "Auction_OnlyLotOwner" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_WrongState"
  },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" }
    ],
    name: "Bid_WrongState"
  },
  {
    type: "error",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    name: "Module_InvalidParent"
  },
  { type: "error", inputs: [], name: "Module_OnlyInternal" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "Module_OnlyParent"
  },
  {
    type: "error",
    inputs: [{ name: "caller", internalType: "address", type: "address" }],
    name: "NotPermitted"
  },
  { type: "error", inputs: [], name: "BrokenInvariant" },
  { type: "error", inputs: [], name: "Derivative_NotImplemented" },
  { type: "error", inputs: [], name: "InsufficientBalance" },
  { type: "error", inputs: [], name: "InvalidParams" },
  {
    type: "error",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    name: "Module_InvalidParent"
  },
  { type: "error", inputs: [], name: "Module_OnlyInternal" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "Module_OnlyParent"
  },
  { type: "error", inputs: [], name: "NotPermitted" },
  {
    type: "error",
    inputs: [
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "length", internalType: "uint256", type: "uint256" }
    ],
    name: "StringsInsufficientHexLength"
  },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var batchCatalogueAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionHouse",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByBaseToken",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "curator_", internalType: "address", type: "address" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByCurator",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "derivativeReference_", internalType: "Veecode", type: "bytes7" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByDerivative",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionFormat_", internalType: "Keycode", type: "bytes5" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByFormat",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "auctionReference_", internalType: "Veecode", type: "bytes7" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByModule",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByQuoteToken",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "curator_", internalType: "address", type: "address" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsByRequestedCurator",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "seller_", internalType: "address", type: "address" },
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getAuctionsBySeller",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" }
    ],
    name: "getBidClaim",
    outputs: [
      {
        name: "",
        internalType: "struct IBatchAuction.BidClaim",
        type: "tuple",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "referrer", internalType: "address", type: "address" },
          { name: "paid", internalType: "uint256", type: "uint256" },
          { name: "payout", internalType: "uint256", type: "uint256" },
          { name: "refund", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "index_", internalType: "uint256", type: "uint256" }
    ],
    name: "getBidIdAtIndex",
    outputs: [{ name: "", internalType: "uint64", type: "uint64" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "start_", internalType: "uint256", type: "uint256" },
      { name: "count_", internalType: "uint256", type: "uint256" }
    ],
    name: "getBidIds",
    outputs: [{ name: "", internalType: "uint64[]", type: "uint64[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getFeeData",
    outputs: [
      {
        name: "",
        internalType: "struct IAuctionHouse.FeeData",
        type: "tuple",
        components: [
          { name: "curator", internalType: "address", type: "address" },
          { name: "curated", internalType: "bool", type: "bool" },
          { name: "curatorFee", internalType: "uint48", type: "uint48" },
          { name: "protocolFee", internalType: "uint48", type: "uint48" },
          { name: "referrerFee", internalType: "uint48", type: "uint48" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getLiveAuctions",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "getMaxLotId",
    outputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getNumBids",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getRouting",
    outputs: [
      {
        name: "",
        internalType: "struct IAuctionHouse.Routing",
        type: "tuple",
        components: [
          { name: "seller", internalType: "address", type: "address" },
          { name: "baseToken", internalType: "address", type: "address" },
          { name: "quoteToken", internalType: "address", type: "address" },
          { name: "auctionReference", internalType: "Veecode", type: "bytes7" },
          { name: "funding", internalType: "uint256", type: "uint256" },
          {
            name: "callbacks",
            internalType: "contract ICallback",
            type: "address"
          },
          {
            name: "derivativeReference",
            internalType: "Veecode",
            type: "bytes7"
          },
          { name: "wrapDerivative", internalType: "bool", type: "bool" },
          { name: "derivativeParams", internalType: "bytes", type: "bytes" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "startId_", internalType: "uint96", type: "uint96" },
      { name: "count_", internalType: "uint96", type: "uint96" }
    ],
    name: "getUpcomingAuctions",
    outputs: [{ name: "", internalType: "uint96[]", type: "uint96[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "hasEnded",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "isLive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "isUpcoming",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "remainingCapacity",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  { type: "error", inputs: [], name: "InvalidParams" },
  {
    type: "error",
    inputs: [{ name: "veecode_", internalType: "Veecode", type: "bytes7" }],
    name: "InvalidVeecode"
  }
];
var bpoolAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "_kernel", internalType: "contract Kernel", type: "address" },
      { name: "_name", internalType: "string", type: "string" },
      { name: "_symbol", internalType: "string", type: "string" },
      { name: "_decimals", internalType: "uint8", type: "uint8" },
      { name: "_factory", internalType: "address", type: "address" },
      { name: "_reserve", internalType: "address", type: "address" },
      { name: "_feeTier", internalType: "uint24", type: "uint24" },
      { name: "_initialActiveTick", internalType: "int24", type: "int24" },
      { name: "_blast", internalType: "address", type: "address" },
      { name: "_blastGovernor", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "FEE_TIER",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "INIT",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "KEYCODE",
    outputs: [{ name: "", internalType: "Keycode", type: "bytes5" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [],
    name: "TICK_SPACING",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "VERSION",
    outputs: [
      { name: "major", internalType: "uint8", type: "uint8" },
      { name: "minor", internalType: "uint8", type: "uint8" }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "_range", internalType: "enum Range", type: "uint8" },
      { name: "_liquidity", internalType: "uint128", type: "uint128" }
    ],
    name: "addLiquidityTo",
    outputs: [
      { name: "bAssetsAdded_", internalType: "uint256", type: "uint256" },
      { name: "reservesAdded_", internalType: "uint256", type: "uint256" },
      { name: "liquidityFinal_", internalType: "uint128", type: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "_range", internalType: "enum Range", type: "uint8" },
      { name: "_reserves", internalType: "uint256", type: "uint256" }
    ],
    name: "addReservesTo",
    outputs: [
      { name: "bAssetsAdded_", internalType: "uint256", type: "uint256" },
      { name: "reservesAdded_", internalType: "uint256", type: "uint256" },
      { name: "liquidityFinal_", internalType: "uint128", type: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" }
    ],
    name: "allowance",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "spender", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint256", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "burnAllBAssetsInContract",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "newKernel_", internalType: "contract Kernel", type: "address" }
    ],
    name: "changeKernel",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "decimals",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "getActiveTS",
    outputs: [{ name: "activeTS_", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_sqrtPriceL", internalType: "uint160", type: "uint160" },
      { name: "_sqrtPriceU", internalType: "uint160", type: "uint160" },
      { name: "_liquidity", internalType: "uint128", type: "uint128" }
    ],
    name: "getBalancesForLiquidity",
    outputs: [
      { name: "bAssets_", internalType: "uint256", type: "uint256" },
      { name: "reserves_", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "getBaselineValue",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_sqrtPriceL", internalType: "uint160", type: "uint160" },
      { name: "_sqrtPriceU", internalType: "uint160", type: "uint160" },
      { name: "_liquidity", internalType: "uint128", type: "uint128" },
      { name: "_sqrtPriceA", internalType: "uint160", type: "uint160" }
    ],
    name: "getCapacityForLiquidity",
    outputs: [{ name: "capacity_", internalType: "uint256", type: "uint256" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "_sqrtPriceL", internalType: "uint160", type: "uint160" },
      { name: "_sqrtPriceU", internalType: "uint160", type: "uint160" },
      { name: "_reserves", internalType: "uint256", type: "uint256" }
    ],
    name: "getCapacityForReserves",
    outputs: [{ name: "capacity_", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_sqrtPriceL", internalType: "uint160", type: "uint160" },
      { name: "_sqrtPriceU", internalType: "uint160", type: "uint160" },
      { name: "_reserves", internalType: "uint256", type: "uint256" },
      { name: "_targetSqrtPrice", internalType: "uint160", type: "uint160" }
    ],
    name: "getCapacityForReservesAtPrice",
    outputs: [{ name: "capacity_", internalType: "uint256", type: "uint256" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "enum Range", type: "uint8" }],
    name: "getLiquidity",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_sqrtPriceL", internalType: "uint160", type: "uint160" },
      { name: "_sqrtPriceU", internalType: "uint160", type: "uint160" },
      { name: "_reserves", internalType: "uint256", type: "uint256" },
      { name: "_sqrtPriceA", internalType: "uint160", type: "uint160" }
    ],
    name: "getLiquidityForReserves",
    outputs: [{ name: "liquidity_", internalType: "uint128", type: "uint128" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [{ name: "_range", internalType: "enum Range", type: "uint8" }],
    name: "getPosition",
    outputs: [
      {
        name: "position_",
        internalType: "struct Position",
        type: "tuple",
        components: [
          { name: "liquidity", internalType: "uint128", type: "uint128" },
          { name: "sqrtPriceL", internalType: "uint160", type: "uint160" },
          { name: "sqrtPriceU", internalType: "uint160", type: "uint160" },
          { name: "bAssets", internalType: "uint256", type: "uint256" },
          { name: "reserves", internalType: "uint256", type: "uint256" },
          { name: "capacity", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "enum Range", type: "uint8" }],
    name: "getTicks",
    outputs: [
      { name: "lower", internalType: "int24", type: "int24" },
      { name: "upper", internalType: "int24", type: "int24" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "kernel",
    outputs: [{ name: "", internalType: "contract Kernel", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "locked",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_to", internalType: "address", type: "address" },
      { name: "_amount", internalType: "uint256", type: "uint256" }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "nonces",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "owner", internalType: "address", type: "address" },
      { name: "spender", internalType: "address", type: "address" },
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "deadline", internalType: "uint256", type: "uint256" },
      { name: "v", internalType: "uint8", type: "uint8" },
      { name: "r", internalType: "bytes32", type: "bytes32" },
      { name: "s", internalType: "bytes32", type: "bytes32" }
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "pool",
    outputs: [
      { name: "", internalType: "contract IUniswapV3Pool", type: "address" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "_range", internalType: "enum Range", type: "uint8" }],
    name: "removeAllFrom",
    outputs: [
      { name: "bAssetsRemoved_", internalType: "uint256", type: "uint256" },
      { name: "bAssetFees_", internalType: "uint256", type: "uint256" },
      { name: "reservesRemoved_", internalType: "uint256", type: "uint256" },
      { name: "reserveFees_", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "reserve",
    outputs: [{ name: "", internalType: "contract ERC20", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_range", internalType: "enum Range", type: "uint8" },
      { name: "_lower", internalType: "int24", type: "int24" },
      { name: "_upper", internalType: "int24", type: "int24" }
    ],
    name: "setTicks",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "_lock", internalType: "bool", type: "bool" }],
    name: "setTransferLock",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "_to", internalType: "address", type: "address" },
      { name: "_amount", internalType: "uint256", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "_from", internalType: "address", type: "address" },
      { name: "_to", internalType: "address", type: "address" },
      { name: "_amount", internalType: "uint256", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "_bAssetsOwed", internalType: "uint256", type: "uint256" },
      { name: "_reservesOwed", internalType: "uint256", type: "uint256" },
      { name: "_data", internalType: "bytes", type: "bytes" }
    ],
    name: "uniswapV3MintCallback",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "spender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Approval"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Transfer"
  },
  { type: "error", inputs: [], name: "InvalidAction" },
  { type: "error", inputs: [], name: "InvalidCaller" },
  { type: "error", inputs: [], name: "InvalidTickRange" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "KernelAdapter_OnlyKernel"
  },
  {
    type: "error",
    inputs: [{ name: "policy_", internalType: "address", type: "address" }],
    name: "Module_PolicyNotPermitted"
  },
  { type: "error", inputs: [], name: "T" },
  { type: "error", inputs: [], name: "TransferLocked" }
];
var cappedMerkleAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      {
        name: "permissions_",
        internalType: "struct Callbacks.Permissions",
        type: "tuple",
        components: [
          { name: "onCreate", internalType: "bool", type: "bool" },
          { name: "onCancel", internalType: "bool", type: "bool" },
          { name: "onCurate", internalType: "bool", type: "bool" },
          { name: "onPurchase", internalType: "bool", type: "bool" },
          { name: "onBid", internalType: "bool", type: "bool" },
          { name: "onSettle", internalType: "bool", type: "bool" },
          { name: "receiveQuoteTokens", internalType: "bool", type: "bool" },
          { name: "sendBaseTokens", internalType: "bool", type: "bool" }
        ]
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotBuyerLimit",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "uint96", type: "uint96" },
      { name: "", internalType: "address", type: "address" }
    ],
    name: "lotBuyerSpent",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotMerkleRoot",
    outputs: [{ name: "merkleRoot", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "merkleRoot_", internalType: "bytes32", type: "bytes32" }
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: false },
      {
        name: "merkleRoot",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "MerkleRootSet"
  },
  { type: "error", inputs: [], name: "Callback_ExceedsLimit" },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  }
];
var encryptedMarginalPriceAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "INIT",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "PARENT",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "TYPE",
    outputs: [{ name: "", internalType: "enum Module.Type", type: "uint8" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [],
    name: "VEECODE",
    outputs: [{ name: "", internalType: "Veecode", type: "bytes7" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "abort",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      {
        name: "params_",
        internalType: "struct IAuction.AuctionParams",
        type: "tuple",
        components: [
          { name: "start", internalType: "uint48", type: "uint48" },
          { name: "duration", internalType: "uint48", type: "uint48" },
          { name: "capacityInQuote", internalType: "bool", type: "bool" },
          { name: "capacity", internalType: "uint256", type: "uint256" },
          { name: "implParams", internalType: "bytes", type: "bytes" }
        ]
      },
      { name: "quoteTokenDecimals_", internalType: "uint8", type: "uint8" },
      { name: "baseTokenDecimals_", internalType: "uint8", type: "uint8" }
    ],
    name: "auction",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "auctionData",
    outputs: [
      { name: "nextBidId", internalType: "uint64", type: "uint64" },
      { name: "nextDecryptIndex", internalType: "uint64", type: "uint64" },
      {
        name: "status",
        internalType: "enum IEncryptedMarginalPrice.LotStatus",
        type: "uint8"
      },
      { name: "marginalBidId", internalType: "uint64", type: "uint64" },
      { name: "marginalPrice", internalType: "uint256", type: "uint256" },
      { name: "minPrice", internalType: "uint256", type: "uint256" },
      { name: "minFilled", internalType: "uint256", type: "uint256" },
      { name: "minBidSize", internalType: "uint256", type: "uint256" },
      {
        name: "publicKey",
        internalType: "struct Point",
        type: "tuple",
        components: [
          { name: "x", internalType: "uint256", type: "uint256" },
          { name: "y", internalType: "uint256", type: "uint256" }
        ]
      },
      { name: "privateKey", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionType",
    outputs: [
      { name: "", internalType: "enum IAuction.AuctionType", type: "uint8" }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidder_", internalType: "address", type: "address" },
      { name: "referrer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "auctionData_", internalType: "bytes", type: "bytes" }
    ],
    name: "bid",
    outputs: [{ name: "bidId", internalType: "uint64", type: "uint64" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" }
    ],
    name: "bids",
    outputs: [
      { name: "bidder", internalType: "address", type: "address" },
      { name: "amount", internalType: "uint96", type: "uint96" },
      { name: "minAmountOut", internalType: "uint96", type: "uint96" },
      { name: "referrer", internalType: "address", type: "address" },
      {
        name: "status",
        internalType: "enum IEncryptedMarginalPrice.BidStatus",
        type: "uint8"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "cancelAuction",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "capacityInQuote",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidIds_", internalType: "uint64[]", type: "uint64[]" }
    ],
    name: "claimBids",
    outputs: [
      {
        name: "bidClaims",
        internalType: "struct IBatchAuction.BidClaim[]",
        type: "tuple[]",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "referrer", internalType: "address", type: "address" },
          { name: "paid", internalType: "uint256", type: "uint256" },
          { name: "payout", internalType: "uint256", type: "uint256" },
          { name: "refund", internalType: "uint256", type: "uint256" }
        ]
      },
      { name: "auctionOutput", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "num_", internalType: "uint64", type: "uint64" },
      { name: "sortHints_", internalType: "bytes32[]", type: "bytes32[]" }
    ],
    name: "decryptAndSortBids",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" }
    ],
    name: "decryptBid",
    outputs: [{ name: "amountOut", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "decryptedBids",
    outputs: [{ name: "numBids", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "dedicatedSettlePeriod",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" }
    ],
    name: "encryptedBids",
    outputs: [
      { name: "encryptedAmountOut", internalType: "uint256", type: "uint256" },
      {
        name: "bidPubKey",
        internalType: "struct Point",
        type: "tuple",
        components: [
          { name: "x", internalType: "uint256", type: "uint256" },
          { name: "y", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getAuctionData",
    outputs: [
      {
        name: "auctionData_",
        internalType: "struct IEncryptedMarginalPrice.AuctionData",
        type: "tuple",
        components: [
          { name: "nextBidId", internalType: "uint64", type: "uint64" },
          { name: "nextDecryptIndex", internalType: "uint64", type: "uint64" },
          {
            name: "status",
            internalType: "enum IEncryptedMarginalPrice.LotStatus",
            type: "uint8"
          },
          { name: "marginalBidId", internalType: "uint64", type: "uint64" },
          { name: "marginalPrice", internalType: "uint256", type: "uint256" },
          { name: "minPrice", internalType: "uint256", type: "uint256" },
          { name: "minFilled", internalType: "uint256", type: "uint256" },
          { name: "minBidSize", internalType: "uint256", type: "uint256" },
          {
            name: "publicKey",
            internalType: "struct Point",
            type: "tuple",
            components: [
              { name: "x", internalType: "uint256", type: "uint256" },
              { name: "y", internalType: "uint256", type: "uint256" }
            ]
          },
          { name: "privateKey", internalType: "uint256", type: "uint256" },
          { name: "bidIds", internalType: "uint64[]", type: "uint64[]" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" }
    ],
    name: "getBid",
    outputs: [
      {
        name: "bid",
        internalType: "struct IEncryptedMarginalPrice.Bid",
        type: "tuple",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "amount", internalType: "uint96", type: "uint96" },
          { name: "minAmountOut", internalType: "uint96", type: "uint96" },
          { name: "referrer", internalType: "address", type: "address" },
          {
            name: "status",
            internalType: "enum IEncryptedMarginalPrice.BidStatus",
            type: "uint8"
          }
        ]
      },
      {
        name: "encryptedBid",
        internalType: "struct IEncryptedMarginalPrice.EncryptedBid",
        type: "tuple",
        components: [
          {
            name: "encryptedAmountOut",
            internalType: "uint256",
            type: "uint256"
          },
          {
            name: "bidPubKey",
            internalType: "struct Point",
            type: "tuple",
            components: [
              { name: "x", internalType: "uint256", type: "uint256" },
              { name: "y", internalType: "uint256", type: "uint256" }
            ]
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" }
    ],
    name: "getBidClaim",
    outputs: [
      {
        name: "bidClaim",
        internalType: "struct IBatchAuction.BidClaim",
        type: "tuple",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "referrer", internalType: "address", type: "address" },
          { name: "paid", internalType: "uint256", type: "uint256" },
          { name: "payout", internalType: "uint256", type: "uint256" },
          { name: "refund", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "index_", internalType: "uint256", type: "uint256" }
    ],
    name: "getBidIdAtIndex",
    outputs: [{ name: "", internalType: "uint64", type: "uint64" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "startIndex_", internalType: "uint256", type: "uint256" },
      { name: "num_", internalType: "uint256", type: "uint256" }
    ],
    name: "getBidIds",
    outputs: [{ name: "", internalType: "uint64[]", type: "uint64[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getLot",
    outputs: [
      {
        name: "",
        internalType: "struct IAuction.Lot",
        type: "tuple",
        components: [
          { name: "start", internalType: "uint48", type: "uint48" },
          { name: "conclusion", internalType: "uint48", type: "uint48" },
          { name: "quoteTokenDecimals", internalType: "uint8", type: "uint8" },
          { name: "baseTokenDecimals", internalType: "uint8", type: "uint8" },
          { name: "capacityInQuote", internalType: "bool", type: "bool" },
          { name: "capacity", internalType: "uint256", type: "uint256" },
          { name: "sold", internalType: "uint256", type: "uint256" },
          { name: "purchased", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "key_", internalType: "bytes32", type: "bytes32" }
    ],
    name: "getNextInQueue",
    outputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getNumBids",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getNumBidsInQueue",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getPartialFill",
    outputs: [
      { name: "hasPartialFill", internalType: "bool", type: "bool" },
      {
        name: "partialFill",
        internalType: "struct IEncryptedMarginalPrice.PartialFill",
        type: "tuple",
        components: [
          { name: "bidId", internalType: "uint64", type: "uint64" },
          { name: "refund", internalType: "uint96", type: "uint96" },
          { name: "payout", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "hasEnded",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "isLive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "isUpcoming",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotAuctionOutput",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "id", internalType: "uint96", type: "uint96" }],
    name: "lotData",
    outputs: [
      { name: "start", internalType: "uint48", type: "uint48" },
      { name: "conclusion", internalType: "uint48", type: "uint48" },
      { name: "quoteTokenDecimals", internalType: "uint8", type: "uint8" },
      { name: "baseTokenDecimals", internalType: "uint8", type: "uint8" },
      { name: "capacityInQuote", internalType: "bool", type: "bool" },
      { name: "capacity", internalType: "uint256", type: "uint256" },
      { name: "sold", internalType: "uint256", type: "uint256" },
      { name: "purchased", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "minAuctionDuration",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" },
      { name: "index_", internalType: "uint256", type: "uint256" },
      { name: "caller_", internalType: "address", type: "address" }
    ],
    name: "refundBid",
    outputs: [{ name: "refund", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "remainingCapacity",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "period_", internalType: "uint48", type: "uint48" }],
    name: "setDedicatedSettlePeriod",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "duration_", internalType: "uint48", type: "uint48" }],
    name: "setMinAuctionDuration",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "num_", internalType: "uint256", type: "uint256" }
    ],
    name: "settle",
    outputs: [
      { name: "totalIn", internalType: "uint256", type: "uint256" },
      { name: "totalOut", internalType: "uint256", type: "uint256" },
      { name: "capacity", internalType: "uint256", type: "uint256" },
      { name: "finished", internalType: "bool", type: "bool" },
      { name: "auctionOutput", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "privateKey_", internalType: "uint256", type: "uint256" },
      { name: "num_", internalType: "uint64", type: "uint64" },
      { name: "sortHints_", internalType: "bytes32[]", type: "bytes32[]" }
    ],
    name: "submitPrivateKey",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true },
      { name: "bidId", internalType: "uint64", type: "uint64", indexed: true },
      {
        name: "amountIn",
        internalType: "uint96",
        type: "uint96",
        indexed: false
      },
      {
        name: "amountOut",
        internalType: "uint96",
        type: "uint96",
        indexed: false
      }
    ],
    name: "BidDecrypted"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: true }
    ],
    name: "PrivateKeySubmitted"
  },
  { type: "error", inputs: [], name: "Auction_AmountLessThanMinimum" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_DedicatedSettlePeriod"
  },
  { type: "error", inputs: [], name: "Auction_InsufficientCapacity" },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint96", type: "uint96" }
    ],
    name: "Auction_InvalidBidId"
  },
  {
    type: "error",
    inputs: [
      { name: "duration_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidDuration"
  },
  { type: "error", inputs: [], name: "Auction_InvalidKey" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_InvalidLotId"
  },
  { type: "error", inputs: [], name: "Auction_InvalidParams" },
  {
    type: "error",
    inputs: [
      { name: "start_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidStart"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotConcluded"
  },
  { type: "error", inputs: [], name: "Auction_NotAuthorized" },
  { type: "error", inputs: [], name: "Auction_NotBidder" },
  { type: "error", inputs: [], name: "Auction_NotImplemented" },
  { type: "error", inputs: [], name: "Auction_OnlyLotOwner" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_WrongState"
  },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" }
    ],
    name: "Bid_WrongState"
  },
  {
    type: "error",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    name: "Module_InvalidParent"
  },
  { type: "error", inputs: [], name: "Module_OnlyInternal" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "Module_OnlyParent"
  },
  {
    type: "error",
    inputs: [{ name: "caller", internalType: "address", type: "address" }],
    name: "NotPermitted"
  }
];
var fixedPriceBatchAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "INIT",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "PARENT",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "TYPE",
    outputs: [{ name: "", internalType: "enum Module.Type", type: "uint8" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [],
    name: "VEECODE",
    outputs: [{ name: "", internalType: "Veecode", type: "bytes7" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "abort",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      {
        name: "params_",
        internalType: "struct IAuction.AuctionParams",
        type: "tuple",
        components: [
          { name: "start", internalType: "uint48", type: "uint48" },
          { name: "duration", internalType: "uint48", type: "uint48" },
          { name: "capacityInQuote", internalType: "bool", type: "bool" },
          { name: "capacity", internalType: "uint256", type: "uint256" },
          { name: "implParams", internalType: "bytes", type: "bytes" }
        ]
      },
      { name: "quoteTokenDecimals_", internalType: "uint8", type: "uint8" },
      { name: "baseTokenDecimals_", internalType: "uint8", type: "uint8" }
    ],
    name: "auction",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "auctionType",
    outputs: [
      { name: "", internalType: "enum IAuction.AuctionType", type: "uint8" }
    ],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidder_", internalType: "address", type: "address" },
      { name: "referrer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "auctionData_", internalType: "bytes", type: "bytes" }
    ],
    name: "bid",
    outputs: [{ name: "bidId", internalType: "uint64", type: "uint64" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "cancelAuction",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "capacityInQuote",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidIds_", internalType: "uint64[]", type: "uint64[]" }
    ],
    name: "claimBids",
    outputs: [
      {
        name: "bidClaims",
        internalType: "struct IBatchAuction.BidClaim[]",
        type: "tuple[]",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "referrer", internalType: "address", type: "address" },
          { name: "paid", internalType: "uint256", type: "uint256" },
          { name: "payout", internalType: "uint256", type: "uint256" },
          { name: "refund", internalType: "uint256", type: "uint256" }
        ]
      },
      { name: "auctionOutput", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "dedicatedSettlePeriod",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getAuctionData",
    outputs: [
      {
        name: "auctionData_",
        internalType: "struct IFixedPriceBatch.AuctionData",
        type: "tuple",
        components: [
          { name: "price", internalType: "uint256", type: "uint256" },
          {
            name: "status",
            internalType: "enum IFixedPriceBatch.LotStatus",
            type: "uint8"
          },
          { name: "nextBidId", internalType: "uint64", type: "uint64" },
          { name: "settlementCleared", internalType: "bool", type: "bool" },
          { name: "totalBidAmount", internalType: "uint256", type: "uint256" },
          { name: "minFilled", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" }
    ],
    name: "getBid",
    outputs: [
      {
        name: "bid",
        internalType: "struct IFixedPriceBatch.Bid",
        type: "tuple",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "amount", internalType: "uint96", type: "uint96" },
          { name: "referrer", internalType: "address", type: "address" },
          {
            name: "status",
            internalType: "enum IFixedPriceBatch.BidStatus",
            type: "uint8"
          }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" }
    ],
    name: "getBidClaim",
    outputs: [
      {
        name: "bidClaim",
        internalType: "struct IBatchAuction.BidClaim",
        type: "tuple",
        components: [
          { name: "bidder", internalType: "address", type: "address" },
          { name: "referrer", internalType: "address", type: "address" },
          { name: "paid", internalType: "uint256", type: "uint256" },
          { name: "payout", internalType: "uint256", type: "uint256" },
          { name: "refund", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "uint96", type: "uint96" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "getBidIdAtIndex",
    outputs: [{ name: "", internalType: "uint64", type: "uint64" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "uint96", type: "uint96" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "getBidIds",
    outputs: [{ name: "", internalType: "uint64[]", type: "uint64[]" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getLot",
    outputs: [
      {
        name: "",
        internalType: "struct IAuction.Lot",
        type: "tuple",
        components: [
          { name: "start", internalType: "uint48", type: "uint48" },
          { name: "conclusion", internalType: "uint48", type: "uint48" },
          { name: "quoteTokenDecimals", internalType: "uint8", type: "uint8" },
          { name: "baseTokenDecimals", internalType: "uint8", type: "uint8" },
          { name: "capacityInQuote", internalType: "bool", type: "bool" },
          { name: "capacity", internalType: "uint256", type: "uint256" },
          { name: "sold", internalType: "uint256", type: "uint256" },
          { name: "purchased", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "getNumBids",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "getPartialFill",
    outputs: [
      { name: "hasPartialFill", internalType: "bool", type: "bool" },
      {
        name: "partialFill",
        internalType: "struct IFixedPriceBatch.PartialFill",
        type: "tuple",
        components: [
          { name: "bidId", internalType: "uint64", type: "uint64" },
          { name: "refund", internalType: "uint96", type: "uint96" },
          { name: "payout", internalType: "uint256", type: "uint256" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "hasEnded",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "isLive",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "isUpcoming",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotAuctionOutput",
    outputs: [{ name: "", internalType: "bytes", type: "bytes" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "id", internalType: "uint96", type: "uint96" }],
    name: "lotData",
    outputs: [
      { name: "start", internalType: "uint48", type: "uint48" },
      { name: "conclusion", internalType: "uint48", type: "uint48" },
      { name: "quoteTokenDecimals", internalType: "uint8", type: "uint8" },
      { name: "baseTokenDecimals", internalType: "uint8", type: "uint8" },
      { name: "capacityInQuote", internalType: "bool", type: "bool" },
      { name: "capacity", internalType: "uint256", type: "uint256" },
      { name: "sold", internalType: "uint256", type: "uint256" },
      { name: "purchased", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "minAuctionDuration",
    outputs: [{ name: "", internalType: "uint48", type: "uint48" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId_", internalType: "uint64", type: "uint64" },
      { name: "index_", internalType: "uint256", type: "uint256" },
      { name: "caller_", internalType: "address", type: "address" }
    ],
    name: "refundBid",
    outputs: [{ name: "refund", internalType: "uint256", type: "uint256" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "lotId_", internalType: "uint96", type: "uint96" }],
    name: "remainingCapacity",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "period_", internalType: "uint48", type: "uint48" }],
    name: "setDedicatedSettlePeriod",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "duration_", internalType: "uint48", type: "uint48" }],
    name: "setMinAuctionDuration",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "num_", internalType: "uint256", type: "uint256" }
    ],
    name: "settle",
    outputs: [
      { name: "totalIn", internalType: "uint256", type: "uint256" },
      { name: "totalOut", internalType: "uint256", type: "uint256" },
      { name: "capacity", internalType: "uint256", type: "uint256" },
      { name: "finished", internalType: "bool", type: "bool" },
      { name: "auctionOutput", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "nonpayable"
  },
  { type: "error", inputs: [], name: "Auction_AmountLessThanMinimum" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_DedicatedSettlePeriod"
  },
  { type: "error", inputs: [], name: "Auction_InsufficientCapacity" },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint96", type: "uint96" }
    ],
    name: "Auction_InvalidBidId"
  },
  {
    type: "error",
    inputs: [
      { name: "duration_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidDuration"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_InvalidLotId"
  },
  { type: "error", inputs: [], name: "Auction_InvalidParams" },
  {
    type: "error",
    inputs: [
      { name: "start_", internalType: "uint48", type: "uint48" },
      { name: "minimum_", internalType: "uint48", type: "uint48" }
    ],
    name: "Auction_InvalidStart"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotActive"
  },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_LotNotConcluded"
  },
  { type: "error", inputs: [], name: "Auction_NotAuthorized" },
  { type: "error", inputs: [], name: "Auction_NotBidder" },
  { type: "error", inputs: [], name: "Auction_NotImplemented" },
  { type: "error", inputs: [], name: "Auction_OnlyLotOwner" },
  {
    type: "error",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "Auction_WrongState"
  },
  {
    type: "error",
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" }
    ],
    name: "Bid_WrongState"
  },
  {
    type: "error",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    name: "Module_InvalidParent"
  },
  { type: "error", inputs: [], name: "Module_OnlyInternal" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "Module_OnlyParent"
  },
  {
    type: "error",
    inputs: [{ name: "caller", internalType: "address", type: "address" }],
    name: "NotPermitted"
  }
];
var linearVestingAbi = [
  {
    type: "constructor",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "INIT",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "PARENT",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "TYPE",
    outputs: [{ name: "", internalType: "enum Module.Type", type: "uint8" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [],
    name: "VEECODE",
    outputs: [{ name: "", internalType: "Veecode", type: "bytes7" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "allowance",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "approve",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "balanceOf",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "underlyingToken_", internalType: "address", type: "address" },
      { name: "params_", internalType: "bytes", type: "bytes" }
    ],
    name: "computeId",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId_", internalType: "uint256", type: "uint256" }],
    name: "decimals",
    outputs: [{ name: "", internalType: "uint8", type: "uint8" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "underlyingToken_", internalType: "address", type: "address" },
      { name: "params_", internalType: "bytes", type: "bytes" },
      { name: "wrapped_", internalType: "bool", type: "bool" }
    ],
    name: "deploy",
    outputs: [
      { name: "tokenId_", internalType: "uint256", type: "uint256" },
      { name: "wrappedAddress_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "exercise",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "exerciseCost",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "getTokenMetadata",
    outputs: [
      {
        name: "",
        internalType: "struct IDerivative.Token",
        type: "tuple",
        components: [
          { name: "exists", internalType: "bool", type: "bool" },
          { name: "wrapped", internalType: "address", type: "address" },
          { name: "underlyingToken", internalType: "address", type: "address" },
          { name: "supply", internalType: "uint256", type: "uint256" },
          { name: "data", internalType: "bytes", type: "bytes" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId_", internalType: "uint256", type: "uint256" }],
    name: "getTokenVestingParams",
    outputs: [
      {
        name: "",
        internalType: "struct ILinearVesting.VestingParams",
        type: "tuple",
        components: [
          { name: "start", internalType: "uint48", type: "uint48" },
          { name: "expiry", internalType: "uint48", type: "uint48" }
        ]
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" }
    ],
    name: "isOperator",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "to_", internalType: "address", type: "address" },
      { name: "tokenId_", internalType: "uint256", type: "uint256" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "wrapped_", internalType: "bool", type: "bool" }
    ],
    name: "mint",
    outputs: [
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "to_", internalType: "address", type: "address" },
      { name: "underlyingToken_", internalType: "address", type: "address" },
      { name: "params_", internalType: "bytes", type: "bytes" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "wrapped_", internalType: "bool", type: "bool" }
    ],
    name: "mint",
    outputs: [
      { name: "tokenId_", internalType: "uint256", type: "uint256" },
      { name: "wrappedAddress_", internalType: "address", type: "address" },
      { name: "amountCreated_", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId_", internalType: "uint256", type: "uint256" }],
    name: "name",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    name: "reclaim",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "tokenId_", internalType: "uint256", type: "uint256" },
      { name: "amount_", internalType: "uint256", type: "uint256" }
    ],
    name: "redeem",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId_", internalType: "uint256", type: "uint256" }],
    name: "redeemMax",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "owner_", internalType: "address", type: "address" },
      { name: "tokenId_", internalType: "uint256", type: "uint256" }
    ],
    name: "redeemable",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "operator", internalType: "address", type: "address" },
      { name: "approved", internalType: "bool", type: "bool" }
    ],
    name: "setOperator",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "interfaceId", internalType: "bytes4", type: "bytes4" }],
    name: "supportsInterface",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId_", internalType: "uint256", type: "uint256" }],
    name: "symbol",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "tokenMetadata",
    outputs: [
      { name: "exists", internalType: "bool", type: "bool" },
      { name: "wrapped", internalType: "address", type: "address" },
      { name: "underlyingToken", internalType: "address", type: "address" },
      { name: "supply", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId_", internalType: "uint256", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ name: "", internalType: "string", type: "string" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "tokenId", internalType: "uint256", type: "uint256" }],
    name: "totalSupply",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "transfer",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "transferFrom",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "", internalType: "uint256", type: "uint256" },
      { name: "", internalType: "address", type: "address" },
      { name: "", internalType: "uint256", type: "uint256" }
    ],
    name: "transform",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "tokenId_", internalType: "uint256", type: "uint256" },
      { name: "amount_", internalType: "uint256", type: "uint256" }
    ],
    name: "unwrap",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "owner_", internalType: "address", type: "address" },
      { name: "tokenId_", internalType: "uint256", type: "uint256" }
    ],
    name: "userClaimed",
    outputs: [{ name: "claimed_", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "underlyingToken_", internalType: "address", type: "address" },
      { name: "params_", internalType: "bytes", type: "bytes" }
    ],
    name: "validate",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "pure"
  },
  {
    type: "function",
    inputs: [
      { name: "tokenId_", internalType: "uint256", type: "uint256" },
      { name: "amount_", internalType: "uint256", type: "uint256" }
    ],
    name: "wrap",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "spender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      { name: "id", internalType: "uint256", type: "uint256", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Approval"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      { name: "start", internalType: "uint48", type: "uint48", indexed: false },
      {
        name: "expiry",
        internalType: "uint48",
        type: "uint48",
        indexed: false
      },
      {
        name: "baseToken",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "DerivativeCreated"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "operator",
        internalType: "address",
        type: "address",
        indexed: true
      },
      { name: "approved", internalType: "bool", type: "bool", indexed: false }
    ],
    name: "OperatorSet"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Redeemed"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "caller",
        internalType: "address",
        type: "address",
        indexed: false
      },
      { name: "from", internalType: "address", type: "address", indexed: true },
      { name: "to", internalType: "address", type: "address", indexed: true },
      { name: "id", internalType: "uint256", type: "uint256", indexed: true },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Transfer"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "wrappedToken",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "Unwrapped"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "wrappedToken",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "Wrapped"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "tokenId",
        internalType: "uint256",
        type: "uint256",
        indexed: true
      },
      {
        name: "wrappedToken",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "WrappedDerivativeCreated"
  },
  { type: "error", inputs: [], name: "BrokenInvariant" },
  { type: "error", inputs: [], name: "Derivative_NotImplemented" },
  { type: "error", inputs: [], name: "InsufficientBalance" },
  { type: "error", inputs: [], name: "InvalidParams" },
  {
    type: "error",
    inputs: [{ name: "parent_", internalType: "address", type: "address" }],
    name: "Module_InvalidParent"
  },
  { type: "error", inputs: [], name: "Module_OnlyInternal" },
  {
    type: "error",
    inputs: [{ name: "caller_", internalType: "address", type: "address" }],
    name: "Module_OnlyParent"
  },
  { type: "error", inputs: [], name: "NotPermitted" },
  {
    type: "error",
    inputs: [
      { name: "value", internalType: "uint256", type: "uint256" },
      { name: "length", internalType: "uint256", type: "uint256" }
    ],
    name: "StringsInsufficientHexLength"
  },
  {
    type: "error",
    inputs: [{ name: "token_", internalType: "address", type: "address" }],
    name: "UnsupportedToken"
  }
];
var merkleAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      {
        name: "permissions_",
        internalType: "struct Callbacks.Permissions",
        type: "tuple",
        components: [
          { name: "onCreate", internalType: "bool", type: "bool" },
          { name: "onCancel", internalType: "bool", type: "bool" },
          { name: "onCurate", internalType: "bool", type: "bool" },
          { name: "onPurchase", internalType: "bool", type: "bool" },
          { name: "onBid", internalType: "bool", type: "bool" },
          { name: "onSettle", internalType: "bool", type: "bool" },
          { name: "receiveQuoteTokens", internalType: "bool", type: "bool" },
          { name: "sendBaseTokens", internalType: "bool", type: "bool" }
        ]
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotMerkleRoot",
    outputs: [{ name: "merkleRoot", internalType: "bytes32", type: "bytes32" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "merkleRoot_", internalType: "bytes32", type: "bytes32" }
    ],
    name: "setMerkleRoot",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "lotId", internalType: "uint96", type: "uint96", indexed: false },
      {
        name: "merkleRoot",
        internalType: "bytes32",
        type: "bytes32",
        indexed: false
      }
    ],
    name: "MerkleRootSet"
  },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  }
];
var tokenAllowlistAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      {
        name: "permissions_",
        internalType: "struct Callbacks.Permissions",
        type: "tuple",
        components: [
          { name: "onCreate", internalType: "bool", type: "bool" },
          { name: "onCancel", internalType: "bool", type: "bool" },
          { name: "onCurate", internalType: "bool", type: "bool" },
          { name: "onPurchase", internalType: "bool", type: "bool" },
          { name: "onBid", internalType: "bool", type: "bool" },
          { name: "onSettle", internalType: "bool", type: "bool" },
          { name: "receiveQuoteTokens", internalType: "bool", type: "bool" },
          { name: "sendBaseTokens", internalType: "bool", type: "bool" }
        ]
      }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotChecks",
    outputs: [
      {
        name: "token",
        internalType: "contract ITokenBalance",
        type: "address"
      },
      { name: "threshold", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  }
];
var uniV2DtlAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "uniswapV2Factory_", internalType: "address", type: "address" },
      { name: "uniswapV2Router_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LINEAR_VESTING_KEYCODE",
    outputs: [{ name: "", internalType: "bytes5", type: "bytes5" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "ONE_HUNDRED_PERCENT",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotConfiguration",
    outputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "lotCapacity", internalType: "uint256", type: "uint256" },
      { name: "lotCuratorPayout", internalType: "uint256", type: "uint256" },
      {
        name: "proceedsUtilisationPercent",
        internalType: "uint24",
        type: "uint24"
      },
      { name: "vestingStart", internalType: "uint48", type: "uint48" },
      { name: "vestingExpiry", internalType: "uint48", type: "uint48" },
      {
        name: "linearVestingModule",
        internalType: "contract LinearVesting",
        type: "address"
      },
      { name: "active", internalType: "bool", type: "bool" },
      { name: "implParams", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "uniV2Factory",
    outputs: [
      { name: "", internalType: "contract IUniswapV2Factory", type: "address" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "uniV2Router",
    outputs: [
      {
        name: "",
        internalType: "contract IUniswapV2Router02",
        type: "address"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "error",
    inputs: [
      { name: "token_", internalType: "address", type: "address" },
      { name: "account_", internalType: "address", type: "address" },
      { name: "balance_", internalType: "uint256", type: "uint256" },
      { name: "required_", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InsufficientBalance"
  },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_LinearVestingModuleNotFound" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAddress" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidVestingParams" },
  {
    type: "error",
    inputs: [
      { name: "actual_", internalType: "uint24", type: "uint24" },
      { name: "min_", internalType: "uint24", type: "uint24" },
      { name: "max_", internalType: "uint24", type: "uint24" }
    ],
    name: "Callback_Params_PercentOutOfBounds"
  },
  { type: "error", inputs: [], name: "Callback_Params_PoolExists" },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  }
];
var uniV2FactoryAbi = [
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    name: "allPairs",
    outputs: [{ name: "pair", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "allPairsLength",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "tokenA", internalType: "address", type: "address" },
      { name: "tokenB", internalType: "address", type: "address" }
    ],
    name: "createPair",
    outputs: [{ name: "pair", internalType: "address", type: "address" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "feeTo",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "feeToSetter",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "tokenA", internalType: "address", type: "address" },
      { name: "tokenB", internalType: "address", type: "address" }
    ],
    name: "getPair",
    outputs: [{ name: "pair", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "setFeeTo",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "address", type: "address" }],
    name: "setFeeToSetter",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token0",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "token1",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "pair",
        internalType: "address",
        type: "address",
        indexed: false
      },
      { name: "", internalType: "uint256", type: "uint256", indexed: false }
    ],
    name: "PairCreated"
  }
];
var uniV3DtlAbi = [
  {
    type: "constructor",
    inputs: [
      { name: "auctionHouse_", internalType: "address", type: "address" },
      { name: "uniV3Factory_", internalType: "address", type: "address" },
      { name: "gUniFactory_", internalType: "address", type: "address" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "AUCTION_HOUSE",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "LINEAR_VESTING_KEYCODE",
    outputs: [{ name: "", internalType: "bytes5", type: "bytes5" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "ONE_HUNDRED_PERCENT",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "gUniFactory",
    outputs: [
      { name: "", internalType: "contract IGUniFactory", type: "address" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "lotId", internalType: "uint96", type: "uint96" }],
    name: "lotConfiguration",
    outputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "lotCapacity", internalType: "uint256", type: "uint256" },
      { name: "lotCuratorPayout", internalType: "uint256", type: "uint256" },
      {
        name: "proceedsUtilisationPercent",
        internalType: "uint24",
        type: "uint24"
      },
      { name: "vestingStart", internalType: "uint48", type: "uint48" },
      { name: "vestingExpiry", internalType: "uint48", type: "uint48" },
      {
        name: "linearVestingModule",
        internalType: "contract LinearVesting",
        type: "address"
      },
      { name: "active", internalType: "bool", type: "bool" },
      { name: "implParams", internalType: "bytes", type: "bytes" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint96", type: "uint96" }],
    name: "lotIdRegistered",
    outputs: [{ name: "", internalType: "bool", type: "bool" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "bidId", internalType: "uint64", type: "uint64" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onBid",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCancel",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "seller_", internalType: "address", type: "address" },
      { name: "baseToken_", internalType: "address", type: "address" },
      { name: "quoteToken_", internalType: "address", type: "address" },
      { name: "capacity_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCreate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "curatorFee_", internalType: "uint256", type: "uint256" },
      { name: "prefund_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onCurate",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "buyer_", internalType: "address", type: "address" },
      { name: "amount_", internalType: "uint256", type: "uint256" },
      { name: "payout_", internalType: "uint256", type: "uint256" },
      { name: "prefunded_", internalType: "bool", type: "bool" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onPurchase",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "lotId_", internalType: "uint96", type: "uint96" },
      { name: "proceeds_", internalType: "uint256", type: "uint256" },
      { name: "refund_", internalType: "uint256", type: "uint256" },
      { name: "callbackData_", internalType: "bytes", type: "bytes" }
    ],
    name: "onSettle",
    outputs: [{ name: "", internalType: "bytes4", type: "bytes4" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "uniV3Factory",
    outputs: [
      { name: "", internalType: "contract IUniswapV3Factory", type: "address" }
    ],
    stateMutability: "view"
  },
  {
    type: "error",
    inputs: [
      { name: "token_", internalType: "address", type: "address" },
      { name: "account_", internalType: "address", type: "address" },
      { name: "balance_", internalType: "uint256", type: "uint256" },
      { name: "required_", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_InsufficientBalance"
  },
  { type: "error", inputs: [], name: "Callback_InvalidParams" },
  { type: "error", inputs: [], name: "Callback_LinearVestingModuleNotFound" },
  { type: "error", inputs: [], name: "Callback_NotAuthorized" },
  { type: "error", inputs: [], name: "Callback_NotImplemented" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidAddress" },
  { type: "error", inputs: [], name: "Callback_Params_InvalidVestingParams" },
  {
    type: "error",
    inputs: [
      { name: "actual_", internalType: "uint24", type: "uint24" },
      { name: "min_", internalType: "uint24", type: "uint24" },
      { name: "max_", internalType: "uint24", type: "uint24" }
    ],
    name: "Callback_Params_PercentOutOfBounds"
  },
  { type: "error", inputs: [], name: "Callback_Params_PoolExists" },
  { type: "error", inputs: [], name: "Callback_Params_PoolFeeNotEnabled" },
  {
    type: "error",
    inputs: [
      { name: "token_", internalType: "address", type: "address" },
      { name: "amountActual_", internalType: "uint256", type: "uint256" },
      { name: "amountMin_", internalType: "uint256", type: "uint256" }
    ],
    name: "Callback_Slippage"
  },
  {
    type: "error",
    inputs: [{ name: "callbacks", internalType: "address", type: "address" }],
    name: "CallbacksAddressNotValid"
  }
];
var uniV3FactoryAbi = [
  {
    type: "function",
    inputs: [
      { name: "tokenA", internalType: "address", type: "address" },
      { name: "tokenB", internalType: "address", type: "address" },
      { name: "fee", internalType: "uint24", type: "uint24" }
    ],
    name: "createPool",
    outputs: [{ name: "pool", internalType: "address", type: "address" }],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "fee", internalType: "uint24", type: "uint24" },
      { name: "tickSpacing", internalType: "int24", type: "int24" }
    ],
    name: "enableFeeAmount",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "fee", internalType: "uint24", type: "uint24" }],
    name: "feeAmountTickSpacing",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "tokenA", internalType: "address", type: "address" },
      { name: "tokenB", internalType: "address", type: "address" },
      { name: "fee", internalType: "uint24", type: "uint24" }
    ],
    name: "getPool",
    outputs: [{ name: "pool", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "owner",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "_owner", internalType: "address", type: "address" }],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      { name: "fee", internalType: "uint24", type: "uint24", indexed: true },
      {
        name: "tickSpacing",
        internalType: "int24",
        type: "int24",
        indexed: true
      }
    ],
    name: "FeeAmountEnabled"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "oldOwner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "newOwner",
        internalType: "address",
        type: "address",
        indexed: true
      }
    ],
    name: "OwnerChanged"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "token0",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "token1",
        internalType: "address",
        type: "address",
        indexed: true
      },
      { name: "fee", internalType: "uint24", type: "uint24", indexed: true },
      {
        name: "tickSpacing",
        internalType: "int24",
        type: "int24",
        indexed: false
      },
      {
        name: "pool",
        internalType: "address",
        type: "address",
        indexed: false
      }
    ],
    name: "PoolCreated"
  }
];
var uniV3PoolAbi = [
  { type: "constructor", inputs: [], stateMutability: "nonpayable" },
  {
    type: "function",
    inputs: [
      { name: "tickLower", internalType: "int24", type: "int24" },
      { name: "tickUpper", internalType: "int24", type: "int24" },
      { name: "amount", internalType: "uint128", type: "uint128" }
    ],
    name: "burn",
    outputs: [
      { name: "amount0", internalType: "uint256", type: "uint256" },
      { name: "amount1", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "tickLower", internalType: "int24", type: "int24" },
      { name: "tickUpper", internalType: "int24", type: "int24" },
      { name: "amount0Requested", internalType: "uint128", type: "uint128" },
      { name: "amount1Requested", internalType: "uint128", type: "uint128" }
    ],
    name: "collect",
    outputs: [
      { name: "amount0", internalType: "uint128", type: "uint128" },
      { name: "amount1", internalType: "uint128", type: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "amount0Requested", internalType: "uint128", type: "uint128" },
      { name: "amount1Requested", internalType: "uint128", type: "uint128" }
    ],
    name: "collectProtocol",
    outputs: [
      { name: "amount0", internalType: "uint128", type: "uint128" },
      { name: "amount1", internalType: "uint128", type: "uint128" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "factory",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "fee",
    outputs: [{ name: "", internalType: "uint24", type: "uint24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "feeGrowthGlobal0X128",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "feeGrowthGlobal1X128",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "amount0", internalType: "uint256", type: "uint256" },
      { name: "amount1", internalType: "uint256", type: "uint256" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "flash",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      {
        name: "observationCardinalityNext",
        internalType: "uint16",
        type: "uint16"
      }
    ],
    name: "increaseObservationCardinalityNext",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [
      { name: "sqrtPriceX96", internalType: "uint160", type: "uint160" }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "liquidity",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "maxLiquidityPerTick",
    outputs: [{ name: "", internalType: "uint128", type: "uint128" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "tickLower", internalType: "int24", type: "int24" },
      { name: "tickUpper", internalType: "int24", type: "int24" },
      { name: "amount", internalType: "uint128", type: "uint128" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "mint",
    outputs: [
      { name: "amount0", internalType: "uint256", type: "uint256" },
      { name: "amount1", internalType: "uint256", type: "uint256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    name: "observations",
    outputs: [
      { name: "blockTimestamp", internalType: "uint32", type: "uint32" },
      { name: "tickCumulative", internalType: "int56", type: "int56" },
      {
        name: "secondsPerLiquidityCumulativeX128",
        internalType: "uint160",
        type: "uint160"
      },
      { name: "initialized", internalType: "bool", type: "bool" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "secondsAgos", internalType: "uint32[]", type: "uint32[]" }
    ],
    name: "observe",
    outputs: [
      { name: "tickCumulatives", internalType: "int56[]", type: "int56[]" },
      {
        name: "secondsPerLiquidityCumulativeX128s",
        internalType: "uint160[]",
        type: "uint160[]"
      }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "bytes32", type: "bytes32" }],
    name: "positions",
    outputs: [
      { name: "liquidity", internalType: "uint128", type: "uint128" },
      {
        name: "feeGrowthInside0LastX128",
        internalType: "uint256",
        type: "uint256"
      },
      {
        name: "feeGrowthInside1LastX128",
        internalType: "uint256",
        type: "uint256"
      },
      { name: "tokensOwed0", internalType: "uint128", type: "uint128" },
      { name: "tokensOwed1", internalType: "uint128", type: "uint128" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "protocolFees",
    outputs: [
      { name: "token0", internalType: "uint128", type: "uint128" },
      { name: "token1", internalType: "uint128", type: "uint128" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "feeProtocol0", internalType: "uint8", type: "uint8" },
      { name: "feeProtocol1", internalType: "uint8", type: "uint8" }
    ],
    name: "setFeeProtocol",
    outputs: [],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [],
    name: "slot0",
    outputs: [
      { name: "sqrtPriceX96", internalType: "uint160", type: "uint160" },
      { name: "tick", internalType: "int24", type: "int24" },
      { name: "observationIndex", internalType: "uint16", type: "uint16" },
      {
        name: "observationCardinality",
        internalType: "uint16",
        type: "uint16"
      },
      {
        name: "observationCardinalityNext",
        internalType: "uint16",
        type: "uint16"
      },
      { name: "feeProtocol", internalType: "uint8", type: "uint8" },
      { name: "unlocked", internalType: "bool", type: "bool" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "tickLower", internalType: "int24", type: "int24" },
      { name: "tickUpper", internalType: "int24", type: "int24" }
    ],
    name: "snapshotCumulativesInside",
    outputs: [
      { name: "tickCumulativeInside", internalType: "int56", type: "int56" },
      {
        name: "secondsPerLiquidityInsideX128",
        internalType: "uint160",
        type: "uint160"
      },
      { name: "secondsInside", internalType: "uint32", type: "uint32" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [
      { name: "recipient", internalType: "address", type: "address" },
      { name: "zeroForOne", internalType: "bool", type: "bool" },
      { name: "amountSpecified", internalType: "int256", type: "int256" },
      { name: "sqrtPriceLimitX96", internalType: "uint160", type: "uint160" },
      { name: "data", internalType: "bytes", type: "bytes" }
    ],
    name: "swap",
    outputs: [
      { name: "amount0", internalType: "int256", type: "int256" },
      { name: "amount1", internalType: "int256", type: "int256" }
    ],
    stateMutability: "nonpayable"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "int16", type: "int16" }],
    name: "tickBitmap",
    outputs: [{ name: "", internalType: "uint256", type: "uint256" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "tickSpacing",
    outputs: [{ name: "", internalType: "int24", type: "int24" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [{ name: "", internalType: "int24", type: "int24" }],
    name: "ticks",
    outputs: [
      { name: "liquidityGross", internalType: "uint128", type: "uint128" },
      { name: "liquidityNet", internalType: "int128", type: "int128" },
      {
        name: "feeGrowthOutside0X128",
        internalType: "uint256",
        type: "uint256"
      },
      {
        name: "feeGrowthOutside1X128",
        internalType: "uint256",
        type: "uint256"
      },
      { name: "tickCumulativeOutside", internalType: "int56", type: "int56" },
      {
        name: "secondsPerLiquidityOutsideX128",
        internalType: "uint160",
        type: "uint160"
      },
      { name: "secondsOutside", internalType: "uint32", type: "uint32" },
      { name: "initialized", internalType: "bool", type: "bool" }
    ],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "token0",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "function",
    inputs: [],
    name: "token1",
    outputs: [{ name: "", internalType: "address", type: "address" }],
    stateMutability: "view"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "tickLower",
        internalType: "int24",
        type: "int24",
        indexed: true
      },
      {
        name: "tickUpper",
        internalType: "int24",
        type: "int24",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "amount0",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "amount1",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Burn"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "recipient",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "tickLower",
        internalType: "int24",
        type: "int24",
        indexed: true
      },
      {
        name: "tickUpper",
        internalType: "int24",
        type: "int24",
        indexed: true
      },
      {
        name: "amount0",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "amount1",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "Collect"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "recipient",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount0",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "amount1",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      }
    ],
    name: "CollectProtocol"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "recipient",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount0",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "amount1",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "paid0",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "paid1",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Flash"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "observationCardinalityNextOld",
        internalType: "uint16",
        type: "uint16",
        indexed: false
      },
      {
        name: "observationCardinalityNextNew",
        internalType: "uint16",
        type: "uint16",
        indexed: false
      }
    ],
    name: "IncreaseObservationCardinalityNext"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sqrtPriceX96",
        internalType: "uint160",
        type: "uint160",
        indexed: false
      },
      { name: "tick", internalType: "int24", type: "int24", indexed: false }
    ],
    name: "Initialize"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: false
      },
      {
        name: "owner",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "tickLower",
        internalType: "int24",
        type: "int24",
        indexed: true
      },
      {
        name: "tickUpper",
        internalType: "int24",
        type: "int24",
        indexed: true
      },
      {
        name: "amount",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      {
        name: "amount0",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      },
      {
        name: "amount1",
        internalType: "uint256",
        type: "uint256",
        indexed: false
      }
    ],
    name: "Mint"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "feeProtocol0Old",
        internalType: "uint8",
        type: "uint8",
        indexed: false
      },
      {
        name: "feeProtocol1Old",
        internalType: "uint8",
        type: "uint8",
        indexed: false
      },
      {
        name: "feeProtocol0New",
        internalType: "uint8",
        type: "uint8",
        indexed: false
      },
      {
        name: "feeProtocol1New",
        internalType: "uint8",
        type: "uint8",
        indexed: false
      }
    ],
    name: "SetFeeProtocol"
  },
  {
    type: "event",
    anonymous: false,
    inputs: [
      {
        name: "sender",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "recipient",
        internalType: "address",
        type: "address",
        indexed: true
      },
      {
        name: "amount0",
        internalType: "int256",
        type: "int256",
        indexed: false
      },
      {
        name: "amount1",
        internalType: "int256",
        type: "int256",
        indexed: false
      },
      {
        name: "sqrtPriceX96",
        internalType: "uint160",
        type: "uint160",
        indexed: false
      },
      {
        name: "liquidity",
        internalType: "uint128",
        type: "uint128",
        indexed: false
      },
      { name: "tick", internalType: "int24", type: "int24", indexed: false }
    ],
    name: "Swap"
  },
  { type: "error", inputs: [], name: "AI" },
  { type: "error", inputs: [], name: "AS" },
  { type: "error", inputs: [], name: "F0" },
  { type: "error", inputs: [], name: "F1" },
  { type: "error", inputs: [], name: "I" },
  { type: "error", inputs: [], name: "IIA" },
  { type: "error", inputs: [], name: "L" },
  { type: "error", inputs: [], name: "LO" },
  { type: "error", inputs: [], name: "LOK" },
  { type: "error", inputs: [], name: "M0" },
  { type: "error", inputs: [], name: "M1" },
  { type: "error", inputs: [], name: "NP" },
  { type: "error", inputs: [], name: "OLD" },
  { type: "error", inputs: [], name: "R" },
  { type: "error", inputs: [], name: "T" },
  { type: "error", inputs: [], name: "TF" },
  { type: "error", inputs: [], name: "TLM" },
  { type: "error", inputs: [], name: "TLU" },
  { type: "error", inputs: [], name: "TUM" }
];

// src/abis/index.ts
var abis_default = {
  batchAuctionHouse: batchAuctionHouseAbi,
  batchCatalogue: batchCatalogueAbi,
  encryptedMarginalPrice: encryptedMarginalPriceAbi,
  fixedPriceBatch: fixedPriceBatchAbi,
  batchLinearVesting: linearVestingAbi,
  merkleAllowlist: merkleAllowlistAbi,
  cappedMerkleAllowlist: cappedMerkleAllowlistAbi,
  tokenAllowlist: tokenAllowlistAbi,
  allocatedMerkleAllowlist: allocatedMerkleAllowlistAbi,
  uniV2Dtl: uniV2DtlAbi,
  uniV3Dtl: uniV3DtlAbi,
  uniV2Factory: uniV2FactoryAbi,
  uniV3Factory: uniV3FactoryAbi,
  uniV3Pool: uniV3PoolAbi,
  baseline: baselineAbi,
  baselineAllowlist: baselineAllowlistAbi,
  baselineAllocatedAllowlist: baselineAllocatedAllowlistAbi,
  baselineCappedAllowlist: baselineCappedAllowlistAbi,
  baselineTokenAllowlist: baselineTokenAllowlistAbi,
  bpool: bpoolAbi,
  uniswapV3DtlWithAllocatedMerkleAllowlist: uniV3DtlAbi
};

// src/abis/sources/BatchAuctionHouse.json
var BatchAuctionHouse_default = {
  abi: [
    {
      type: "constructor",
      inputs: [
        {
          name: "owner_",
          type: "address",
          internalType: "address"
        },
        {
          name: "protocol_",
          type: "address",
          internalType: "address"
        },
        {
          name: "permit2_",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "abort",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "auction",
      inputs: [
        {
          name: "routing_",
          type: "tuple",
          internalType: "struct IAuctionHouse.RoutingParams",
          components: [
            {
              name: "auctionType",
              type: "bytes5",
              internalType: "Keycode"
            },
            {
              name: "baseToken",
              type: "address",
              internalType: "address"
            },
            {
              name: "quoteToken",
              type: "address",
              internalType: "address"
            },
            {
              name: "curator",
              type: "address",
              internalType: "address"
            },
            {
              name: "referrerFee",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "callbacks",
              type: "address",
              internalType: "contract ICallback"
            },
            {
              name: "callbackData",
              type: "bytes",
              internalType: "bytes"
            },
            {
              name: "derivativeType",
              type: "bytes5",
              internalType: "Keycode"
            },
            {
              name: "derivativeParams",
              type: "bytes",
              internalType: "bytes"
            },
            {
              name: "wrapDerivative",
              type: "bool",
              internalType: "bool"
            }
          ]
        },
        {
          name: "params_",
          type: "tuple",
          internalType: "struct IAuction.AuctionParams",
          components: [
            {
              name: "start",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "duration",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "capacityInQuote",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "capacity",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "implParams",
              type: "bytes",
              internalType: "bytes"
            }
          ]
        },
        {
          name: "infoHash_",
          type: "string",
          internalType: "string"
        }
      ],
      outputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "bid",
      inputs: [
        {
          name: "params_",
          type: "tuple",
          internalType: "struct IBatchAuctionHouse.BidParams",
          components: [
            {
              name: "lotId",
              type: "uint96",
              internalType: "uint96"
            },
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "amount",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "auctionData",
              type: "bytes",
              internalType: "bytes"
            },
            {
              name: "permit2Data",
              type: "bytes",
              internalType: "bytes"
            }
          ]
        },
        {
          name: "callbackData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "calculateQuoteFees",
      inputs: [
        {
          name: "protocolFee_",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "referrerFee_",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "hasReferrer_",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "toReferrer",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "toProtocol",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "cancel",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "callbackData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "claimBids",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidIds_",
          type: "uint64[]",
          internalType: "uint64[]"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "claimRewards",
      inputs: [
        {
          name: "token_",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "condensers",
      inputs: [
        {
          name: "auctionRef",
          type: "bytes7",
          internalType: "Veecode"
        },
        {
          name: "derivativeRef",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      outputs: [
        {
          name: "condenserRef",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "curate",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "callbackData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "execOnModule",
      inputs: [
        {
          name: "veecode_",
          type: "bytes7",
          internalType: "Veecode"
        },
        {
          name: "callData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "fees",
      inputs: [
        {
          name: "",
          type: "bytes5",
          internalType: "Keycode"
        }
      ],
      outputs: [
        {
          name: "protocol",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "maxReferrerFee",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "maxCuratorFee",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getAuctionModuleForId",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "contract IAuction"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBatchModuleForId",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "contract BatchAuctionModule"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getCuratorFee",
      inputs: [
        {
          name: "auctionType_",
          type: "bytes5",
          internalType: "Keycode"
        },
        {
          name: "curator_",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [
        {
          name: "curatorFee",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getDerivativeModuleForId",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "contract IDerivative"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getFees",
      inputs: [
        {
          name: "auctionType_",
          type: "bytes5",
          internalType: "Keycode"
        }
      ],
      outputs: [
        {
          name: "protocol",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "maxReferrerFee",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "maxCuratorFee",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getModuleForVeecode",
      inputs: [
        {
          name: "",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "contract Module"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getModuleStatus",
      inputs: [
        {
          name: "",
          type: "bytes5",
          internalType: "Keycode"
        }
      ],
      outputs: [
        {
          name: "latestVersion",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "sunset",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getProtocol",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getRewards",
      inputs: [
        {
          name: "recipient_",
          type: "address",
          internalType: "address"
        },
        {
          name: "token_",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [
        {
          name: "reward",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "installModule",
      inputs: [
        {
          name: "newModule_",
          type: "address",
          internalType: "contract Module"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "isExecOnModule",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotCounter",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotFees",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "curator",
          type: "address",
          internalType: "address"
        },
        {
          name: "curated",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "curatorFee",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "protocolFee",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "referrerFee",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotRouting",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "seller",
          type: "address",
          internalType: "address"
        },
        {
          name: "baseToken",
          type: "address",
          internalType: "address"
        },
        {
          name: "quoteToken",
          type: "address",
          internalType: "address"
        },
        {
          name: "auctionReference",
          type: "bytes7",
          internalType: "Veecode"
        },
        {
          name: "funding",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "callbacks",
          type: "address",
          internalType: "contract ICallback"
        },
        {
          name: "derivativeReference",
          type: "bytes7",
          internalType: "Veecode"
        },
        {
          name: "wrapDerivative",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "derivativeParams",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "modules",
      inputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bytes5",
          internalType: "Keycode"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "modulesCount",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "owner",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "refundBid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "index_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "rewards",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "address",
          internalType: "contract ERC20"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "setCondenser",
      inputs: [
        {
          name: "auctionRef_",
          type: "bytes7",
          internalType: "Veecode"
        },
        {
          name: "derivativeRef_",
          type: "bytes7",
          internalType: "Veecode"
        },
        {
          name: "condenserRef_",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "setCuratorFee",
      inputs: [
        {
          name: "auctionType_",
          type: "bytes5",
          internalType: "Keycode"
        },
        {
          name: "fee_",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "setFee",
      inputs: [
        {
          name: "auctionType_",
          type: "bytes5",
          internalType: "Keycode"
        },
        {
          name: "type_",
          type: "uint8",
          internalType: "enum IFeeManager.FeeType"
        },
        {
          name: "fee_",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "setProtocol",
      inputs: [
        {
          name: "protocol_",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "settle",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "num_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "callbackData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "totalIn",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "totalOut",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "finished",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "auctionOutput",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "sunsetModule",
      inputs: [
        {
          name: "keycode_",
          type: "bytes5",
          internalType: "Keycode"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "transferOwnership",
      inputs: [
        {
          name: "newOwner",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "event",
      name: "Abort",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "AuctionCancelled",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "auctionRef",
          type: "bytes7",
          indexed: true,
          internalType: "Veecode"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "AuctionCreated",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "auctionRef",
          type: "bytes7",
          indexed: true,
          internalType: "Veecode"
        },
        {
          name: "infoHash",
          type: "string",
          indexed: false,
          internalType: "string"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Bid",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidder",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "ClaimBid",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidder",
          type: "address",
          indexed: true,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Curated",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "curator",
          type: "address",
          indexed: true,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "ModuleInstalled",
      inputs: [
        {
          name: "keycode",
          type: "bytes5",
          indexed: true,
          internalType: "Keycode"
        },
        {
          name: "version",
          type: "uint8",
          indexed: true,
          internalType: "uint8"
        },
        {
          name: "location",
          type: "address",
          indexed: true,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "ModuleSunset",
      inputs: [
        {
          name: "keycode",
          type: "bytes5",
          indexed: true,
          internalType: "Keycode"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "OwnershipTransferred",
      inputs: [
        {
          name: "user",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "newOwner",
          type: "address",
          indexed: true,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "RefundBid",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidder",
          type: "address",
          indexed: true,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Settle",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        }
      ],
      anonymous: false
    },
    {
      type: "error",
      name: "AmountLessThanMinimum",
      inputs: []
    },
    {
      type: "error",
      name: "FailedCallback",
      inputs: []
    },
    {
      type: "error",
      name: "InsufficientFunding",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidCallback",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidCallbackResponse",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidFee",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidLotId",
      inputs: [
        {
          name: "id_",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "InvalidModuleInstall",
      inputs: [
        {
          name: "keycode_",
          type: "bytes5",
          internalType: "Keycode"
        },
        {
          name: "version_",
          type: "uint8",
          internalType: "uint8"
        }
      ]
    },
    {
      type: "error",
      name: "InvalidParams",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidParams",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidState",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidVeecode",
      inputs: [
        {
          name: "veecode_",
          type: "bytes7",
          internalType: "Veecode"
        }
      ]
    },
    {
      type: "error",
      name: "ModuleAlreadySunset",
      inputs: [
        {
          name: "keycode_",
          type: "bytes5",
          internalType: "Keycode"
        }
      ]
    },
    {
      type: "error",
      name: "ModuleExecutionReverted",
      inputs: [
        {
          name: "error_",
          type: "bytes",
          internalType: "bytes"
        }
      ]
    },
    {
      type: "error",
      name: "ModuleIsSunset",
      inputs: [
        {
          name: "keycode_",
          type: "bytes5",
          internalType: "Keycode"
        }
      ]
    },
    {
      type: "error",
      name: "ModuleNotInstalled",
      inputs: [
        {
          name: "keycode_",
          type: "bytes5",
          internalType: "Keycode"
        },
        {
          name: "version_",
          type: "uint8",
          internalType: "uint8"
        }
      ]
    },
    {
      type: "error",
      name: "NotPermitted",
      inputs: [
        {
          name: "caller_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "TargetNotAContract",
      inputs: [
        {
          name: "target_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "UnsupportedToken",
      inputs: [
        {
          name: "token_",
          type: "address",
          internalType: "address"
        }
      ]
    }
  ],
  bytecode: {
    object: "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",
    sourceMap: "985:20721:115:-:0;;;454:1:61;429:26;;1693:139:115;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1045:5:55;:14;;-1:-1:-1;;;;;;1045:14:55;-1:-1:-1;;;;;1045:14:55;;;;;;;1075:40;;1045:14;;1809:9:115;;1820:8;;1809:9;;1045:14:55;;;;;;:5;1075:40;;1045:5;;1075:40;-1:-1:-1;;1325:9:119;:21;;-1:-1:-1;;;;;;1325:21:119;-1:-1:-1;;;;;1325:21:119;;;;;;2301:19:117::2;;::::0;-1:-1:-1;985:20721:115;;-1:-1:-1;;;;985:20721:115;14:177:264;93:13;;-1:-1:-1;;;;;135:31:264;;125:42;;115:70;;181:1;178;171:12;115:70;14:177;;;:::o;196:378::-;284:6;292;300;353:2;341:9;332:7;328:23;324:32;321:52;;;369:1;366;359:12;321:52;392:40;422:9;392:40;:::i;:::-;382:50;;451:49;496:2;485:9;481:18;451:49;:::i;:::-;441:59;;519:49;564:2;553:9;549:18;519:49;:::i;:::-;509:59;;196:378;;;;;:::o;:::-;985:20721:115;;;;;;;;;;;;",
    linkReferences: {}
  },
  deployedBytecode: {
    object: "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",
    sourceMap: "985:20721:115:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11439:2469;;;;;;:::i;:::-;;:::i;:::-;;19308:106:117;;;;;;:::i;:::-;;:::i;3234:293:119:-;;;;;;:::i;:::-;-1:-1:-1;;;;;;3432:18:119;3337:15;3432:18;;;:4;:18;;;;;3468:12;;;;;;-1:-1:-1;;;3482:18:119;;;;;-1:-1:-1;;;3502:17:119;;;;;;3234:293;;;;;2065:14:264;2106:15;;;2088:34;;2158:15;;;2153:2;2138:18;;2131:43;2210:15;;2190:18;;;2183:43;;;;2043:2;2028:18;3234:293:119;;;;;;;;1441:896;;;;;;:::i;:::-;;:::i;:::-;;;;3257:25:264;;;3313:2;3298:18;;3291:34;;;;3230:18;1441:896:119;3083:248:264;19497:1981:115;;;;;;:::i;:::-;;:::i;20184:891:117:-;;;;;;:::i;:::-;;:::i;1073:36:119:-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;-1:-1:-1;;;1073:36:119;;;;;-1:-1:-1;;;1073:36:119;;;;;;14474:4311:115;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;;:::i;21536:168::-;;;;;;:::i;:::-;;:::i;:::-;;;-1:-1:-1;;;;;6448:32:264;;;6430:51;;6418:2;6403:18;21536:168:115;6256:231:264;12579:172:117;;;;;;:::i;:::-;;:::i;16068:1429::-;;;;;;:::i;:::-;;:::i;9382:547:173:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;10140:740:115:-;;;;;;:::i;:::-;;:::i;1603:52:173:-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;8823:4:264;8811:17;;;8793:36;;8872:14;;8865:22;8860:2;8845:18;;8838:50;8766:18;1603:52:173;8629:265:264;1662:26:173;;;;;;;;;;;;9064:14:264;;9057:22;9039:41;;9027:2;9012:18;1662:26:173;8899:187:264;8102:1553:115;;;;;;:::i;:::-;;:::i;:::-;;;-1:-1:-1;;;;;12167:31:264;;;12149:50;;12137:2;12122:18;8102:1553:115;12005:200:264;2899:297:119;;;;;;:::i;:::-;;:::i;4229:184::-;;;;;;:::i;:::-;-1:-1:-1;;;;;4372:19:119;;;4339:14;4372:19;;;:7;:19;;;;;;;;:34;;;;;;;;;;;;;4229:184;;;;13123:25:264;;;13111:2;13096:18;4229:184:119;12977:177:264;2668:1116:173;;;;;;:::i;:::-;;:::i;1310:24::-;;;;;;:::i;:::-;;:::i;:::-;;;-1:-1:-1;;;;;;13804:35:264;;;13786:54;;13774:2;13759:18;1310:24:173;13612:234:264;3692:5679:117;;;;;;:::i;:::-;;:::i;:::-;;;-1:-1:-1;;;;;14993:39:264;;;14975:58;;14963:2;14948:18;3692:5679:117;14831:208:264;690:20:55;;;;;-1:-1:-1;;;;;690:20:55;;;1812:50:117;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;;;;;;;:::i;1478:53:173:-;;;;;;:::i;:::-;;;;;;;;;;;;-1:-1:-1;;;;;1478:53:173;;;1747:24:117;;;;;-1:-1:-1;;;;;1747:24:117;;;18378:793;;;;;;:::i;:::-;;:::i;4607:483:173:-;;;;;;:::i;:::-;;:::i;10880:850:117:-;;;;;;:::i;:::-;;:::i;4500:86:119:-;4570:9;;-1:-1:-1;;;;;4570:9:119;4500:86;;1172:60;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;3565:196;;;;;;:::i;:::-;-1:-1:-1;;;;;;3718:18:119;;3682:17;3718:18;;;:4;:18;;;;;;;;-1:-1:-1;;;;;3718:36:119;;;;:26;;:36;;;;;;;;3565:196;;;;;;;;18312:14:264;18300:27;;;18282:46;;18270:2;18255:18;3565:196:119;18138::264;1903:47:117;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;1903:47:117;;;;-1:-1:-1;;;1903:47:117;;;;;-1:-1:-1;;;1903:47:117;;;;;;;;;;-1:-1:-1;;;1903:47:117;;;;;;;;;-1:-1:-1;;;;;18604:32:264;;;18586:51;;18680:14;;18673:22;18668:2;18653:18;;18646:50;18715:14;18765:15;;;18745:18;;;18738:43;;;;18817:15;;18812:2;18797:18;;18790:43;18870:15;18864:3;18849:19;;18842:44;18573:3;18558:19;1903:47:117;18339:553:264;3932:259:119;;;;;;:::i;:::-;;:::i;1312:161:55:-;;;;;;:::i;:::-;;:::i;1390:27:173:-;;;;;;1991:111:117;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;12954:181::-;;;;;;:::i;:::-;;:::i;11439:2469:115:-;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;;;;;;;;;558:1;549:6;:10;11541:19:115::1;11553:6:::0;11541:11:::1;:19::i;:::-;11715:41;11758:26:::0;11800:27:::1;11820:6;11800:19;:27::i;:::-;-1:-1:-1::0;;;;;11800:37:115::1;;11838:6;11846:7;;11800:54;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;::::0;;::::1;-1:-1:-1::0;;11800:54:115::1;::::0;::::1;;::::0;::::1;::::0;;;::::1;::::0;::::1;:::i;:::-;-1:-1:-1::0;;;;;11932:18:115;::::1;11906:23;11932:18:::0;;;:10:::1;:18;::::0;;;;;;;11985::::1;::::0;::::1;::::0;12061:7:::1;:15:::0;;;;;;11985:18;12061:27:::1;::::0;12242:16;;11714:140;;-1:-1:-1;11714:140:115;;-1:-1:-1;11932:18:115;-1:-1:-1;;;;;11985:18:115;;::::1;::::0;12061:27:::1;::::0;;::::1;::::0;-1:-1:-1;;;12119:27:115;;::::1;;::::0;12242:16;12268:1634:::1;12292:12;12288:1;:16;12268:1634;;;12325:38;12366:9;12376:1;12366:12;;;;;;;;:::i;:::-;;;;;;;12325:53;;12675:1;12657:8;:15;;;:19;12653:705;;;12756:292;12796:11;12829;12862:8;:17;;;12901:7;:14;;;;;;;;;;-1:-1:-1::0;;;;;12901:14:115::1;12937:10;12985:8;:15;;;12969:8;:13;;;:31;;;;:::i;:::-;12756:18;:292::i;:::-;-1:-1:-1::0;13173:15:115::1;::::0;;::::1;::::0;13154::::1;::::0;::::1;:34:::0;;;;::::1;::::0;;;;13286:15;;13274:69:::1;::::0;;::::1;::::0;::::1;::::0;;;;-1:-1:-1;;;;;13274:69:115;;::::1;::::0;;-1:-1:-1;13274:69:115;::::1;::::0;;::::1;-1:-1:-1::0;13274:69:115;::::1;::::0;::::1;::::0;::::1;::::0;;;::::1;::::0;;;;;;;-1:-1:-1;;;13274:69:115;;;::::1;;::::0;;::::1;-1:-1:-1::0;;;;;;13274:69:115;;::::1;::::0;;;;;;;;;;;;;;::::1;::::0;::::1;::::0;;;::::1;::::0;;;;;;::::1;::::0;;::::1;::::0;;::::1;::::0;;;;-1:-1:-1;;;13274:69:115;;::::1;;;;;::::0;;;;::::1;::::0;::::1;::::0;;::::1;::::0;13286:15;13173;13274:69;13154:15;;13274:69:::1;::::0;;;;::::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;13329:13;13274:11;:69::i;:::-;13376:15;::::0;::::1;::::0;:19;13372:429:::1;;13716:70;13734:10;13746:8;:15;;;13763:8;:15;;;13780:5;13716:17;:70::i;:::-;13875:15:::0;;-1:-1:-1;;;;;13846:45:115::1;13863:7:::0;;13871:1;13863:10;;::::1;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1::0;;;;;13846:45:115::1;13855:6;-1:-1:-1::0;;;;;13846:45:115::1;;;;;;;;;;;-1:-1:-1::0;12306:3:115;::::1;::::0;::::1;:::i;:::-;;;;12268:1634;;;-1:-1:-1::0;;591:1:61;582:6;:10;-1:-1:-1;;;;;;;;;11439:2469:115:o;19308:106:117:-;778:5:55;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;19386:9:117::1;:21:::0;;-1:-1:-1;;;;;;19386:21:117::1;-1:-1:-1::0;;;;;19386:21:117;;;::::1;::::0;;;::::1;::::0;;19308:106::o;1441:896:119:-;1606:18;1626;1660:12;1656:675;;;1958:53;1974:7;1958:53;;;862:5;1958:15;:53::i;:::-;1945:66;-1:-1:-1;1945:66:119;2054:68;2070:7;2079:27;2094:12;2079;:27;:::i;:::-;2054:68;;862:5;2054:15;:68::i;:::-;:81;;;;:::i;:::-;2025:110;;1656:675;;;2252:68;2268:7;2277:27;2292:12;2277;:27;:::i;2252:68::-;2239:81;;1656:675;1441:896;;;;;;;:::o;19497:1981:115:-;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;19590:19:115::1;19602:6:::0;19590:11:::1;:19::i;:::-;19705:27;19725:6;19705:19;:27::i;:::-;:41;::::0;-1:-1:-1;;;19705:41:115;;-1:-1:-1;;;;;14993:39:264;;19705:41:115::1;::::0;::::1;14975:58:264::0;-1:-1:-1;;;;;19705:33:115;;;::::1;::::0;::::1;::::0;14948:18:264;;19705:41:115::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;-1:-1:-1::0;;;;;;;;;19864:18:115;::::1;19838:23;19864:18:::0;;;:10:::1;:18;::::0;;;;19909:15:::1;::::0;::::1;::::0;19864:18;;19938:11;;;19934:45:::1;;19958:21;;-1:-1:-1::0;;;19958:21:115::1;;;;;;;;;;;19934:45;20007:1;19989:15;::::0;::::1;:19:::0;;;-1:-1:-1;;;;;20130:18:115;::::1;::::0;;:10:::1;:18;::::0;;;;:28:::1;::::0;::::1;::::0;20228::::1;::::0;::::1;::::0;20258:25;;20093:253:::1;::::0;-1:-1:-1;;;;;20130:28:115;;::::1;::::0;20173:124:::1;::::0;20228:28;;::::1;::::0;20258:25:::1;20173:37;:124::i;:::-;20311:6;20331:5;20093:17;:253::i;:::-;-1:-1:-1::0;;;;;20724:18:115;::::1;20774:1;20724:18:::0;;;:10:::1;:18;::::0;;;;:28:::1;;::::0;-1:-1:-1;;;;;20724:28:115::1;:53:::0;20720:723:::1;;-1:-1:-1::0;;;;;20995:18:115;::::1;20830:29;20995:18:::0;;;:10:::1;:18;::::0;;;;:28:::1;;::::0;-1:-1:-1;;;20902:27:115;20995:18;;20971:6;;-1:-1:-1;;;8425:38:153;:43;;21088:14:115::1;;;;;;25202:2:264::0;25184:21;;;25241:1;25221:18;;;25214:29;25275:2;25260:18;;25000:284;21088:14:115::1;;::::0;;-1:-1:-1;;21088:14:115;;::::1;::::0;;;;;;;20862:254:::1;::::0;;;;::::1;;;:::i;:::-;;::::0;;-1:-1:-1;;20862:254:115;;::::1;::::0;;;;;;::::1;::::0;;::::1;::::0;;-1:-1:-1;;;;;20862:254:115::1;-1:-1:-1::0;;;;;;20862:254:115;;::::1;::::0;;;::::1;::::0;;;-1:-1:-1;;;;;21380:18:115;::::1;-1:-1:-1::0;21380:18:115;;;:10:::1;:18:::0;;;;;;;:28:::1;;::::0;21372:60;;20862:254;;-1:-1:-1;;;;;;21380:28:115;;::::1;::::0;21372:60:::1;::::0;20862:254;;21372:60:::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;20779:664;20720:723;21458:13;::::0;-1:-1:-1;;;;;21458:13:115;::::1;::::0;::::1;::::0;;;::::1;-1:-1:-1::0;;591:1:61;582:6;:10;-1:-1:-1;19497:1981:115:o;20184:891:117:-;778:5:55;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;20498:19:117::1;20452:34;20474:11;20452:21;:34::i;:::-;-1:-1:-1::0;;;;;20438:54:117::1;;:56;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:79;;;;;;;;:::i;:::-;;;20437:253;;;-1:-1:-1::0;20650:22:117::1;20577:37;20599:14;20577:21;:37::i;:::-;-1:-1:-1::0;;;;;20560:60:117::1;;:62;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:112;;;;;;;;:::i;:::-;;;20437:253;:493;;;-1:-1:-1::0;;;;;;;20732:39:117;::::1;::::0;;::::1;::::0;:180:::1;;-1:-1:-1::0;20891:21:117::1;20815:36;20837:13;20815:21;:36::i;:::-;-1:-1:-1::0;;;;;20799:58:117::1;;:60;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:113;;;;;;;;:::i;:::-;;;20732:180;20420:543;;;20948:15;;-1:-1:-1::0;;;20948:15:117::1;;;;;;;;;;;20420:543;-1:-1:-1::0;;;;;;21013:23:117;;::::1;;::::0;;;:10:::1;:23;::::0;;;;;;;:39;;;::::1;::::0;;;;;;;;;:55;;-1:-1:-1;;21013:55:117::1;;::::0;;;::::1;::::0;;;::::1;::::0;;20184:891::o;14474:4311:115:-;14651:15;14668:16;14686:13;14701:26;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;14765:19:115::1;14777:6:::0;14765:11:::1;:19::i;:::-;14825:16;15002:25:::0;15030:27:::1;15050:6;15030:19;:27::i;:::-;15128;::::0;-1:-1:-1;;;15128:27:115;;-1:-1:-1;;;;;26656:39:264;;15128:27:115::1;::::0;::::1;26638:58:264::0;26712:18;;;26705:34;;;15002:55:115;;-1:-1:-1;;;;;;15128:13:115;::::1;::::0;::::1;::::0;26611:18:264;;15128:27:115::1;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;::::0;;::::1;-1:-1:-1::0;;15128:27:115::1;::::0;::::1;;::::0;::::1;::::0;;;::::1;::::0;::::1;:::i;:::-;15071:84:::0;;-1:-1:-1;15071:84:115;;-1:-1:-1;15071:84:115;;-1:-1:-1;15071:84:115;;-1:-1:-1;15071:84:115;-1:-1:-1;15218:17:115;::::1;;15230:5;15218:17:::0;15214:107:::1;;15255:51;;;;15214:107;-1:-1:-1::0;;;;;;15492:18:115;::::1;15466:23;15492:18:::0;;;:10:::1;:18;::::0;;;;;;;15546:7:::1;:15:::0;;;;;15955:19:::1;::::0;::::1;::::0;15492:18;;15546:15;;15466:23;;15936:76:::1;::::0;15955:19:::1;::::0;;::::1;::::0;-1:-1:-1;;;15976:19:115;::::1;;15466:23:::0;16004:7;15936:18:::1;:76::i;:::-;16462:14:::0;;16501:18:::1;::::0;::::1;::::0;16522:17:::1;::::0;::::1;::::0;16072:20;;::::1;::::0;-1:-1:-1;16449:91:115::1;::::0;-1:-1:-1;;;;;;16462:14:115;;::::1;::::0;-1:-1:-1;16072:20:115;;16501:18;;::::1;::::0;16522:17:::1;16449:12;:91::i;:::-;17144:15:::0;;16958:24:::1;::::0;;;17123:67:::1;::::0;-1:-1:-1;;;17144:15:115;::::1;;;::::0;-1:-1:-1;;;17161:18:115;::::1;;;17181:8:::0;17123:20:::1;:67::i;:::-;17083:107:::0;-1:-1:-1;17271:17:115;;17267:783:::1;;17502:27;::::0;::::1;::::0;-1:-1:-1;;;17502:27:115;::::1;;;-1:-1:-1::0;;;;;;17490:54:115::1;::::0;17486:402:::1;;17638:15:::0;;17626:67:::1;::::0;;::::1;::::0;::::1;::::0;;;;-1:-1:-1;;;;;17626:67:115;;::::1;::::0;;17638:15;17626:67;::::1;::::0;;::::1;;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;;::::1;::::0;;;;;;;-1:-1:-1;;;17626:67:115;;;::::1;;::::0;;::::1;-1:-1:-1::0;;;;;;17626:67:115;;::::1;::::0;;;;::::1;::::0;::::1;::::0;;;;;::::1;::::0;::::1;::::0;;;::::1;::::0;;;;;;::::1;::::0;;::::1;;::::0;;;;-1:-1:-1;;;17626:67:115;;::::1;;;;;::::0;;;;::::1;::::0;::::1;::::0;;::::1;::::0;17638:15;;;::::1;::::0;17655:13;;17626:67;;;17638:15:::1;17626:67:::0;;;;::::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;17679:13;17626:11;:67::i;:::-;17486:402;;;17810:15:::0;;-1:-1:-1;;;;;17810:15:115;;::::1;17802:24;::::0;;;:7:::1;:24;::::0;;;;;;;17810:15;17833:17;::::1;::::0;;;::::1;17802:50:::0;;;;;;;;:67;;17856:13;;17802:24;:67:::1;::::0;17856:13;;17802:67:::1;:::i;:::-;::::0;;;-1:-1:-1;;17486:402:115::1;17985:15;::::0;::::1;:32:::0;;;;::::1;::::0;;17267:783:::1;18128:15:::0;;18064:24:::1;::::0;18107:67:::1;::::0;-1:-1:-1;;;18128:15:115;::::1;;;::::0;-1:-1:-1;;;18145:18:115;::::1;;;18165:8:::0;18107:20:::1;:67::i;:::-;18064:110:::0;-1:-1:-1;18248:13:115;18064:110;18207:19:::1;18218:8:::0;18207;:19:::1;:::i;:::-;:38;;;;:::i;:::-;:54;;;;:::i;:::-;18305:15;::::0;::::1;:35:::0;;;;::::1;::::0;;-1:-1:-1;18397:17:115;::::1;::::0;18467::::1;::::0;::::1;::::0;18486:14;;18188:73;;-1:-1:-1;18360:200:115::1;::::0;-1:-1:-1;;;;;;18397:17:115;;::::1;::::0;-1:-1:-1;18429:72:115::1;::::0;18467:17;;::::1;::::0;18486:14:::1;18429:37;:72::i;18360:200::-;18641:17;::::0;::::1;::::0;18609:117:::1;::::0;-1:-1:-1;;;;;18641:17:115::1;18660:6:::0;18668:15;18685:16;18703:13;;18609:18:::1;:117::i;:::-;18764:14;::::0;-1:-1:-1;;;;;18764:14:115;::::1;::::0;::::1;::::0;;;::::1;14733:4052;;;;;570:1:61;591::::0;582:6;:10;;;;14474:4311:115;;;;;;;;;:::o;21536:168::-;21601:18;21665:30;21688:6;21665:22;:30::i;:::-;21631:66;21536:168;-1:-1:-1;;21536:168:115:o;12579:172:117:-;12657:8;12677:19;12689:6;12677:11;:19::i;:::-;12714:30;12737:6;12714:22;:30::i;16068:1429::-;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;16170:19:117::1;16182:6:::0;16170:11:::1;:19::i;:::-;-1:-1:-1::0;;;;;16226:15:117;::::1;16200:23;16226:15:::0;;;:7:::1;:15;::::0;;;;16327;;-1:-1:-1;;;;;16327:15:117::1;16313:10;:29;16309:66;;16351:24;::::0;-1:-1:-1;;;16351:24:117;;16364:10:::1;16351:24;::::0;::::1;6430:51:264::0;6403:18;;16351:24:117::1;6256:231:264::0;16309:66:117::1;16386:20;16409:30;16432:6;16409:22;:30::i;:::-;16591:15:::0;;16386:53;;-1:-1:-1;;;;16591:15:117;::::1;;;::::0;:50:::1;;-1:-1:-1::0;16610:23:117::1;::::0;-1:-1:-1;;;16610:23:117;;-1:-1:-1;;;;;14993:39:264;;16610:23:117::1;::::0;::::1;14975:58:264::0;-1:-1:-1;;;;;16610:15:117;::::1;::::0;::::1;::::0;14948:18:264;;16610:23:117::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:31;;16637:4;16610:31;16591:50;16587:77;;;16650:14;;-1:-1:-1::0;;;16650:14:117::1;;;;;;;;;;;16587:77;-1:-1:-1::0;;;;;16701:18:117;::::1;16675:23;16701:18:::0;;;:10:::1;:18;::::0;;;;;16769:22;;-1:-1:-1;;;;16769:22:117::1;-1:-1:-1::0;;;16769:22:117;;::::1;::::0;;;17017:32;;-1:-1:-1;;;17017:32:117;;::::1;::::0;::::1;14975:58:264::0;;;;16701:18:117;;16946:113:::1;::::0;16980:15;;::::1;16769:22;16980:15;::::0;16997:18:::1;-1:-1:-1::0;;;16997:18:117;;::::1;;::::0;-1:-1:-1;;;;;17017:24:117;::::1;::::0;::::1;::::0;14948:18:264;;17017:32:117::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;16946:20;:113::i;:::-;16919:140;;17121:22;17147:48;17155:6;17163:16;17181:13;;17147:7;:48::i;:::-;17120:75;;17249:17;17244:134;;17301:17;::::0;::::1;::::0;17282:85:::1;::::0;-1:-1:-1;;;;;17301:17:117::1;17320:6:::0;17328:16;17301:17:::1;17353:13:::0;;17282:18:::1;:85::i;:::-;17463:27;::::0;17479:10:::1;::::0;-1:-1:-1;;;;;17463:27:117;::::1;::::0;::::1;::::0;;;::::1;-1:-1:-1::0;;591:1:61;582:6;:10;-1:-1:-1;;;;;;16068:1429:117:o;9382:547:173:-;778:5:55;;9498:12:173;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;9554:14:173::1;:21:::0;;-1:-1:-1;;9554:21:173::1;9571:4;9554:21;::::0;;:14:::1;::::0;9713:31:::1;9735:8:::0;9713:21:::1;:31::i;:::-;-1:-1:-1::0;;;;;9713:36:173::1;9750:9;;9713:47;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;9671:89;;;;9775:7;9770:56;;9815:10;9791:35;;-1:-1:-1::0;;;9791:35:173::1;;;;;;;;:::i;9770:56::-;9872:14;:22:::0;;-1:-1:-1;;9872:22:173::1;::::0;;9912:10;-1:-1:-1;;811:1:55::1;9382:547:173::0;;;;;:::o;10140:740:115:-;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;10276:19:115::1;10288:6:::0;10276:11:::1;:19::i;:::-;-1:-1:-1::0;;;;;10477:18:115;::::1;;::::0;;;:10:::1;:18;::::0;;;;:29:::1;;::::0;10440:358:::1;::::0;-1:-1:-1;;;;;10477:29:115::1;10521:10;10696:27;10488:6:::0;10696:19:::1;:27::i;:::-;:73;::::0;-1:-1:-1;;;10696:73:115;;-1:-1:-1;;;;;28487:39:264;;10696:73:115::1;::::0;::::1;28469:58:264::0;-1:-1:-1;;;;;28563:31:264;;28543:18;;;28536:59;28611:18;;;28604:34;;;10758:10:115::1;28654:18:264::0;;;28647:60;-1:-1:-1;;;;;10696:37:115;;;::::1;::::0;::::1;::::0;28441:19:264;;10696:73:115::1;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;10783:5;10440:17;:358::i;:::-;10836:37;::::0;10862:10:::1;::::0;-1:-1:-1;;;;;10836:37:115;::::1;::::0;-1:-1:-1;;;;;10836:37:115;::::1;::::0;::::1;::::0;;;::::1;-1:-1:-1::0;;591:1:61;582:6;:10;-1:-1:-1;10140:740:115:o;8102:1553::-;8233:12;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;8269:13:115;;8257:26:::1;::::0;:11:::1;:26::i;:::-;8356:14;::::0;::::1;::::0;8339::::1;::::0;-1:-1:-1;;;;;8356:28:115::1;::::0;:58:::1;;8400:7;:14;;;8356:58;;;8387:10;8356:58;8339:75;;8593:34;8613:7;:13;;;8593:19;:34::i;:::-;-1:-1:-1::0;;;;;8593:38:115::1;;8645:7;:13;;;8660:6;8668:7;:16;;;8686:7;:14;;;8702:7;:19;;;8593:138;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;9067:14;::::0;::::1;::::0;9112:13;;-1:-1:-1;;;;;9101:25:115::1;;::::0;;;:10:::1;:25;::::0;;;;:36:::1;;::::0;9183:19:::1;::::0;::::1;::::0;8585:146;;-1:-1:-1;9038:175:115::1;::::0;-1:-1:-1;;;;;9101:36:115;;::::1;::::0;9152:51:::1;::::0;:30:::1;:51::i;:::-;9038:15;:175::i;:::-;9299:13:::0;;-1:-1:-1;;;;;9288:25:115::1;;::::0;;;:10:::1;:25;::::0;;;;:35:::1;;::::0;9337:13;;9487:14:::1;::::0;::::1;::::0;9259:279:::1;::::0;-1:-1:-1;;;;;9288:35:115::1;::::0;9337:13;9364:5;;9383:6;;9515:13;;9259:15:::1;:279::i;:::-;9602:6;-1:-1:-1::0;;;;;9576:49:115::1;9595:5;-1:-1:-1::0;;;;;9576:49:115::1;9580:7;:13;;;-1:-1:-1::0;;;;;9576:49:115::1;;9610:7;:14;;;9576:49;;;;13123:25:264::0;;13111:2;13096:18;;12977:177;9576:49:115::1;;;;;;;;9636:12;591:1:61::0;582:6;:10;8102:1553:115;;-1:-1:-1;;;8102:1553:115:o;2899:297:119:-;-1:-1:-1;;;;;;3042:18:119;;;;;;:4;:18;;;;;:32;;-1:-1:-1;;;3042:32:119;;;;;3035:39;;;;3031:64;;;3083:12;;-1:-1:-1;;;3083:12:119;;;;;;;;;;;3031:64;-1:-1:-1;;;;;;3144:18:119;;;;;;;;:4;:18;;;;;;;;3171:10;3144:38;;:26;;:38;;;;;:45;;-1:-1:-1;;3144:45:119;;;;;;;;;;;2899:297::o;2668:1116:173:-;778:5:55;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;2827:36:173::1;2851:10;2827:15;:36::i;:::-;2873:15;2891:10;-1:-1:-1::0;;;;;2891:18:173::1;;:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;2873:38;;2921:27;2940:7;2921:18;:27::i;:::-;2959:15;2976:13:::0;2993:22:::1;3007:7;2993:13;:22::i;:::-;-1:-1:-1::0;;;;;;3136:24:173;::::1;3109;3136::::0;;;:15:::1;:24;::::0;;;;3185:20;;2958:57;;-1:-1:-1;2958:57:173;;-1:-1:-1;3136:24:173;3185::::1;::::0;:20:::1;;::::0;:24:::1;:::i;:::-;3174:35;;:7;:35;;;3170:86;;3239:7;3248;3218:38;;-1:-1:-1::0;;;3218:38:173::1;;;;;;;;;:::i;3170:86::-;3325:30:::0;;-1:-1:-1;;3325:30:173::1;;::::0;;::::1;::::0;;;::::1;::::0;;;::::1;3369:13:::0;::::1;;3365:40;;;3384:21:::0;;-1:-1:-1;;3384:21:173::1;::::0;;3365:40:::1;-1:-1:-1::0;;;;;;3415:28:173;::::1;;::::0;;;:19:::1;:28;::::0;;;;:41;;-1:-1:-1;;;;;;3415:41:173::1;-1:-1:-1::0;;;;;3415:41:173;::::1;;::::0;;3552:19:::1;::::0;::::1;-1:-1:-1::0;;3552:19:173;3548:99:::1;;3587:7;:21:::0;;;;::::1;::::0;;-1:-1:-1;3587:21:173;;;;::::1;::::0;;::::1;::::0;;;::::1;::::0;;::::1;::::0;;;::::1;;;;;::::0;;::::1;;::::0;;::::1;;::::0;;::::1;::::0;;;::::1;;::::0;;3622:12:::1;:14:::0;;;::::1;::::0;::::1;:::i;:::-;;;;;;3548:99;3690:10;-1:-1:-1::0;;;;;3690:15:173::1;;:17;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;-1:-1:-1::0;;3723:54:173::1;::::0;-1:-1:-1;;;;;3723:54:173;::::1;::::0;-1:-1:-1;3723:54:173::1;::::0;::::1;::::0;-1:-1:-1;;;;;;;3723:54:173;::::1;::::0;::::1;::::0;;;::::1;2729:1055;;;;2668:1116:::0;:::o;1310:24::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;3692:5679:117:-;3885:12;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;4102:1:117::1;4071:18;::::0;;;::::1;::::0;::::1;;:::i;:::-;-1:-1:-1::0;;;;;4063:41:117::1;;:87;;;-1:-1:-1::0;4148:1:117::1;4116:19;::::0;;;::::1;::::0;::::1;;:::i;:::-;-1:-1:-1::0;;;;;4108:42:117::1;;4063:87;4059:148;;;4181:15;;-1:-1:-1::0;;;4181:15:117::1;;;;;;;;;;;4059:148;4267:10;:12:::0;;-1:-1:-1;;;;;4267:12:117::1;::::0;:10:::1;:12;::::0;::::1;:::i;:::-;::::0;;::::1;::::0;;;::::1;-1:-1:-1::0;;;;;4267:12:117;;::::1;;::::0;;::::1;::::0;;::::1;;;::::0;;;4353:17;::::1;-1:-1:-1::0;4353:17:117;;;:10:::1;:17;::::0;;;;;;;;4380:27;;4397:10:::1;-1:-1:-1::0;;;;;;4380:27:117;;::::1;;::::0;;4353:17;;-1:-1:-1;4437:18:117::1;::::0;;;;;::::1;;:::i;:::-;4417:17;::::0;::::1;:38:::0;;-1:-1:-1;;;;;;4417:38:117::1;-1:-1:-1::0;;;;;4417:38:117;;;::::1;::::0;;;::::1;::::0;;4486:19:::1;::::0;;;::::1;::::0;::::1;;:::i;:::-;4465:18;::::0;::::1;:40:::0;;-1:-1:-1;;;;;;4465:40:117::1;-1:-1:-1::0;;;;;4465:40:117;;;::::1;::::0;;;::::1;::::0;;-1:-1:-1;4727:46:117::1;4752:20;;::::0;::::1;::::0;::::1;:::i;:::-;4727:24;:46::i;:::-;4667:107;;4857:23;4889:7;:17;;;;;;;;;;-1:-1:-1::0;;;;;4889:17:117::1;-1:-1:-1::0;;;;;4883:33:117::1;;:35;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;4857:61;;4932:24;4965:7;:18;;;;;;;;;;-1:-1:-1::0;;;;;4965:18:117::1;-1:-1:-1::0;;;;;4959:34:117::1;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;4932:63:::0;-1:-1:-1;5055:19:117::1;5031:13;-1:-1:-1::0;;;;;5031:18:117::1;;:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:43;;;;;;;;:::i;:::-;;;:68;;;;5098:1;5078:17;:21;;;5031:68;:114;;;;5143:2;5123:17;:22;;;5031:114;:140;;;;5170:1;5149:18;:22;;;5031:140;:167;;;;5196:2;5175:18;:23;;;5031:167;5010:225;;;5220:15;;-1:-1:-1::0;;;5220:15:117::1;;;;;;;;;;;5010:225;5332:76;::::0;-1:-1:-1;;;5332:76:117;;-1:-1:-1;;;;;5332:21:117;::::1;::::0;::::1;::::0;:76:::1;::::0;5354:5;;5361:7;;5370:18;;5390:17;;5332:76:::1;;;:::i;:::-;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;;;;;5449:13;-1:-1:-1::0;;;;;5449:21:117::1;;:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;5422:24;::::0;::::1;:50:::0;;::::1;::::0;;;::::1;-1:-1:-1::0;;;5422:50:117::1;-1:-1:-1::0;;;;5422:50:117;;::::1;::::0;;;::::1;::::0;;-1:-1:-1;;;;;;;;5607:14:117;::::1;-1:-1:-1::0;5607:14:117;;;:7:::1;:14;::::0;;;;5652:16:::1;::::0;;;::::1;::::0;::::1;;:::i;:::-;5635:33:::0;;-1:-1:-1;;;;;;5682:22:117;-1:-1:-1;;;;;5635:33:117;;;::::1;5682:22:::0;;;5635:14:::1;5746:4;5635:14:::0;5751:20:::1;;::::0;::::1;:8:::0;:20:::1;:::i;:::-;-1:-1:-1::0;;;;;;5746:26:117::1;::::0;;::::1;::::0;::::1;::::0;;;;;;-1:-1:-1;5746:26:117;;;5948:25;;5746:26;;-1:-1:-1;;;;5948:25:117;::::1;;;::::0;6007:19:::1;::::0;::::1;-1:-1:-1::0;6027:16:117::1;::::0;;;::::1;::::0;::::1;;:::i;:::-;-1:-1:-1::0;;;;;6007:37:117::1;::::0;;::::1;::::0;::::1;::::0;;;;;;-1:-1:-1;6007:37:117;;::::1;::::0;;::::1;::::0;-1:-1:-1;6078:26:117;::::1;::::0;::::1;:55;;6123:10;6078:55;;;6107:13;6078:55;6058:75:::0;;-1:-1:-1;;;;6058:75:117::1;-1:-1:-1::0;;;6058:75:117::1;::::0;;::::1;;;::::0;;6467:26;;-1:-1:-1;;;6467:26:117;::::1;;6444:20;::::0;;;::::1;::::0;::::1;;:::i;:::-;:49;;;6440:77;;;6502:15;;-1:-1:-1::0;;;6502:15:117::1;;;;;;;;;;;6440:77;6552:20;::::0;;;::::1;::::0;::::1;;:::i;:::-;6531:18;::::0;;::::1;:41:::0;;::::1;::::0;;::::1;-1:-1:-1::0;;;6531:41:117::1;-1:-1:-1::0;;6531:41:117;::::1;::::0;::::1;::::0;;6649:20;;-1:-1:-1;;6628:41:117;;;-1:-1:-1;;6628:41:117;;;;6649:20;;;::::1;6628:41:::0;;;::::1;::::0;;;-1:-1:-1;;;;6716:36:117::1;6728:23;6531:41;6728:23:::0;;::::1;::::0;::::1;;:::i;:::-;1399:8:172::0;1310:101;6716:36:117::1;-1:-1:-1::0;;;;;;6716:50:117::1;;6712:931;;6855:33;6924:49;6949:23;::::0;;;::::1;::::0;::::1;;:::i;6924:49::-;6855:119:::0;-1:-1:-1;7193:22:117::1;7166:16;-1:-1:-1::0;;;;;7166:21:117::1;;:23;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:49;;;;;;;;:::i;:::-;;;:154;;;-1:-1:-1::0;7274:17:117::1;::::0;::::1;::::0;-1:-1:-1;;;;;7240:25:117;;::::1;::::0;::::1;::::0;7274:17:::1;7294:25;7274:17;7294:25:::0;::::1;:8:::0;:25:::1;:::i;:::-;7240:80;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;7239:81;7166:154;7145:245;;;7360:15;;-1:-1:-1::0;;;7360:15:117::1;;;;;;;;;;;7145:245;7478:16;-1:-1:-1::0;;;;;7478:24:117::1;;:26;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;7448:27;::::0;::::1;:56:::0;;::::1;::::0;;;::::1;-1:-1:-1::0;;;7448:56:117::1;-1:-1:-1::0;;;;7448:56:117;;::::1;::::0;;;::::1;::::0;;7545:25:::1;7448:56;7545:25:::0;::::1;:8:::0;:25:::1;:::i;:::-;7518:24;::::0;::::1;::::0;:52:::1;::::0;;:24;:52:::1;:::i;:::-;-1:-1:-1::0;7609:23:117::1;::::0;;;::::1;::::0;::::1;;:::i;:::-;7584:22;::::0;::::1;:48:::0;;;::::1;;-1:-1:-1::0;;;7584:48:117::1;-1:-1:-1::0;;;;7584:48:117;;::::1;::::0;;;::::1;::::0;;-1:-1:-1;6712:931:117::1;7761:24;::::0;::::1;::::0;-1:-1:-1;;;;;;;;;7761:24:117;;;::::1;;::::0;;::::1;7750:36:::0;::::1;7727:20;7750:36:::0;;;:10:::1;:36;::::0;;;;;;;7787:27:::1;::::0;::::1;::::0;;;;::::1;::::0;::::1;7750:65:::0;::::1;::::0;;;;;;;;;;;;::::1;::::0;7903:38;::::1;::::0;7899:510:::1;;8073:21;8002:35;8024:12;8002:21;:35::i;:::-;-1:-1:-1::0;;;;;7986:57:117::1;;:59;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:108;;;;;;;;:::i;:::-;;7961:174;;8120:15;;-1:-1:-1::0;;;8120:15:117::1;;;;;;;;;;;7961:174;8193:21;8217:32;8236:12;8217:18;:32::i;:::-;-1:-1:-1::0;;;;;;8271:30:117;::::1;;::::0;;;:15:::1;:30;::::0;;;;:37;:30;;-1:-1:-1;8271:37:117::1;::::0;::::1;;;:45;;:37;:45:::0;8267:128:::1;;8347:29;::::0;-1:-1:-1;;;8347:29:117;;-1:-1:-1;;;;;;13804:35:264;;8347:29:117::1;::::0;::::1;13786:54:264::0;13759:18;;8347:29:117::1;13612:234:264::0;8267:128:117::1;7943:466;7899:510;-1:-1:-1::0;8627:53:117::1;8661:18;::::0;;;::::1;::::0;::::1;;:::i;:::-;8627:33;:53::i;:::-;8622:82;;8689:15;;-1:-1:-1::0;;;8689:15:117::1;;;;;;;;;;;8622:82;8881:1;8850:18;::::0;;;::::1;::::0;::::1;;:::i;:::-;-1:-1:-1::0;;;;;8842:41:117::1;;8838:85;;8905:18;::::0;;;::::1;::::0;::::1;;:::i;:::-;8885:17;::::0;::::1;:38:::0;;-1:-1:-1;;;;;;8885:38:117::1;-1:-1:-1::0;;;;;8885:38:117;;;::::1;::::0;;;::::1;::::0;;8838:85:::1;8996:22;9021:34;9030:5;9037:8;9047:7;9021:8;:34::i;:::-;8996:59;;9150:17;9145:108;;9183:59;9201:8;9211:5;9218:7;:16;;;9236:5;9183:17;:59::i;:::-;9328:7;:24;;;;;;;;;;;;-1:-1:-1::0;;;;;9306:58:117::1;;9321:5;-1:-1:-1::0;;;;;9306:58:117::1;;9354:9;;9306:58;;;;;;;:::i;:::-;;;;;;;;-1:-1:-1::0;;591:1:61;582:6;:10;3692:5679:117;;-1:-1:-1;;;;3692:5679:117:o;1812:50::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;1812:50:117;;;;;;;;;;;;-1:-1:-1;;;1812:50:117;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;1812:50:117;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;18378:793::-;778:5:55;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;862:5:119::1;18538:20:117;::::0;::::1;;18534:45;;;18567:12;;-1:-1:-1::0;;;18567:12:117::1;;;;;;;;;;;18534:45;18696:16;18687:5;:25;;;;;;;;:::i;:::-;::::0;18683:482:::1;;-1:-1:-1::0;;;;;;18739:18:117;::::1;;::::0;;;:4:::1;:18;::::0;;;;:33;862:5:119::1;::::0;18732:40:117::1;::::0;-1:-1:-1;;;18739:33:117;::::1;18732:56;18739:33;18732:4:::0;:40:::1;:::i;:::-;:56;;;18728:81;;;18797:12;;-1:-1:-1::0;;;18797:12:117::1;;;;;;;;;;;18728:81;-1:-1:-1::0;;;;;;18823:18:117;::::1;;::::0;;;:4:::1;:18;::::0;;;;:34;;-1:-1:-1;;18823:34:117::1;;::::0;::::1;;::::0;;18378:793;;;:::o;18683:482::-:1;18887:19;18878:5;:28;;;;;;;;:::i;:::-;::::0;18874:291:::1;;-1:-1:-1::0;;;;;;18933:18:117;::::1;;::::0;;;:4:::1;:18;::::0;;;;:27;862:5:119::1;::::0;18926:34:117::1;::::0;:50:::1;18933:27;18926:4:::0;:34:::1;:::i;:::-;:50;;;18922:75;;;18985:12;;-1:-1:-1::0;;;18985:12:117::1;;;;;;;;;;;18922:75;-1:-1:-1::0;;;;;;19011:18:117;::::1;;::::0;;;:4:::1;:18;::::0;;;;:40;;-1:-1:-1;;19011:40:117::1;-1:-1:-1::0;;;19011:40:117::1;::::0;::::1;;;::::0;;18378:793;;;:::o;18874:291::-:1;19081:18;19072:5;:27;;;;;;;;:::i;:::-;::::0;19068:97:::1;;-1:-1:-1::0;;;;;;19115:18:117;::::1;;::::0;;;:4:::1;:18;::::0;;;;:39;;-1:-1:-1;;;;19115:39:117::1;-1:-1:-1::0;;;19115:39:117::1;::::0;::::1;;;::::0;;19068:97:::1;18378:793:::0;;;:::o;4607:483:173:-;778:5:55;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;-1:-1:-1;;;;;;5544:25:173;;5382:4;5544:25;;;:15;:25;;;;;:39;:51;:39;4722:73:::1;;4783:8;4793:1;4764:31;;-1:-1:-1::0;;;4764:31:173::1;;;;;;;;;:::i;4722:73::-;-1:-1:-1::0;;;;;;4888:25:173;::::1;4861:24;4888:25:::0;;;:15:::1;:25;::::0;;;;4927:13;;::::1;::::0;::::1;;;4923:55;;;4949:29;::::0;-1:-1:-1;;;4949:29:173;;-1:-1:-1;;;;;;13804:35:264;;4949:29:173::1;::::0;::::1;13786:54:264::0;13759:18;;4949:29:173::1;13612:234:264::0;4923:55:173::1;5025:20:::0;;-1:-1:-1;;5025:20:173::1;;;::::0;;5061:22:::1;::::0;-1:-1:-1;;;;;;5061:22:173;::::1;::::0;::::1;::::0;5025:13:::1;::::0;5061:22:::1;4666:424;4607:483:::0;:::o;10880:850:117:-;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;10995:19:117::1;11007:6:::0;10995:11:::1;:19::i;:::-;-1:-1:-1::0;;;;;11051:18:117;::::1;11025:23;11051:18:::0;;;:10:::1;:18;::::0;;;;11125:14;;-1:-1:-1;;;;;11125:14:117::1;11111:10;:28;11107:65;;11148:24;::::0;-1:-1:-1;;;11148:24:117;;11161:10:::1;11148:24;::::0;::::1;6430:51:264::0;6403:18;;11148:24:117::1;6256:231:264::0;11107:65:117::1;11227:30;11250:6;11227:22;:30::i;:::-;:52;::::0;-1:-1:-1;;;11227:52:117;;-1:-1:-1;;;;;14993:39:264;;11227:52:117::1;::::0;::::1;14975:58:264::0;-1:-1:-1;;;;;11227:44:117;;;::::1;::::0;::::1;::::0;14948:18:264;;11227:52:117::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;;;;;11331:22;11356:30;11364:6;11372:13;;11356:7;:30::i;:::-;11331:55;;11481:17;11476:182;;11596:17;::::0;::::1;::::0;11577:70:::1;::::0;-1:-1:-1;;;;;11596:17:117::1;11615:6:::0;11596:17:::1;::::0;11633:13;;11577:18:::1;:70::i;:::-;11698:24;::::0;::::1;::::0;11673:50:::1;::::0;-1:-1:-1;;;11698:24:117;;::::1;;;-1:-1:-1::0;;;;;;11673:50:117::1;::::0;-1:-1:-1;;;;;11673:50:117;::::1;::::0;::::1;::::0;;;::::1;-1:-1:-1::0;;591:1:61;582:6;:10;-1:-1:-1;;;10880:850:117:o;3932:259:119:-;512:6:61;;522:1;512:11;504:34;;;;-1:-1:-1;;;504:34:61;;;;;;;:::i;:::-;558:1;549:6;:10;4064::119::1;4002:11;4056:19:::0;;;:7:::1;:19;::::0;;;;;;;-1:-1:-1;;;;;4056:26:119;::::1;::::0;;;;;;;;;4092:30;;;;4056:26;;;;4133:51:::1;::::0;4056:26;;;;4133:17:::1;:51::i;:::-;-1:-1:-1::0;;591:1:61;582:6;:10;-1:-1:-1;3932:259:119:o;1312:161:55:-;778:5;;-1:-1:-1;;;;;778:5:55;764:10;:19;756:44;;;;-1:-1:-1;;;756:44:55;;;;;;;:::i;:::-;1392:5:::1;:16:::0;;-1:-1:-1;;;;;;1392:16:55::1;-1:-1:-1::0;;;;;1392:16:55;::::1;::::0;;::::1;::::0;;1424:42:::1;::::0;1392:16;;1445:10:::1;::::0;1424:42:::1;::::0;1392:5;1424:42:::1;1312:161:::0;:::o;12954:181:117:-;13035:11;13058:19;13070:6;13058:11;:19::i;:::-;13095:33;13121:6;13095:25;:33::i;15186:120::-;15260:10;;-1:-1:-1;;;;;15260:10:117;;;15250:20;;;;15246:53;;15279:20;;-1:-1:-1;;;15279:20:117;;-1:-1:-1;;;;;14993:39:264;;15279:20:117;;;14975:58:264;14948:18;;15279:20:117;14831:208:264;15246:53:117;15186:120;:::o;26472:693::-;26686:17;;;26797:126;26829:12;26843;-1:-1:-1;;;;;26857:23:117;;;;;;:47;;;26897:7;-1:-1:-1;;;;;26884:20:117;:9;-1:-1:-1;;;;;26884:20:117;;;26857:47;26906:7;26797:18;:126::i;:::-;26754:169;;-1:-1:-1;26754:169:117;-1:-1:-1;26981:14:117;;26977:65;;-1:-1:-1;;;;;26997:18:117;;;;;;;:7;:18;;;;;;;;:31;;;;;;;;;;;:45;;27032:10;;26997:18;:45;;27032:10;;26997:45;:::i;:::-;;;;-1:-1:-1;;26977:65:117;27056:14;;27052:65;;27080:9;;-1:-1:-1;;;;;27080:9:117;;;27072:18;;;;:7;:18;;;;;;;;:31;;;;;;;;;;;:45;;27107:10;;27072:18;:45;;27107:10;;27072:45;:::i;:::-;;;;-1:-1:-1;;27052:65:117;27135:23;27148:10;27135;:23;:::i;:::-;27128:30;26472:693;-1:-1:-1;;;;;;;;;26472:693:117:o;23799:2085::-;24010:34;;;;24078:24;;;;-1:-1:-1;;;;;;24197:46:117;;24193:1685;;24259:61;24277:9;24288:10;24300:13;24315:4;24259:17;:61::i;:::-;24193:1685;;;24589:23;24632:42;24654:19;24632:21;:42::i;:::-;24722:31;;;;25011;;;;-1:-1:-1;;;;;;25000:43:117;;;24690:29;25000:43;;;:10;:43;;;;;;;;:64;;;;;;;;;;;24589:86;;-1:-1:-1;24722:31:117;;25000:64;;;25082:39;;;25078:353;;25181:25;25225:35;25247:12;25225:21;:35::i;:::-;25364:52;;-1:-1:-1;;;25364:52:117;;25181:80;;-1:-1:-1;;;;;;25364:18:117;;;;;:52;;25383:14;;25399:16;;25364:52;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;25364:52:117;;;;;;;;;;;;:::i;:::-;25345:71;;25123:308;25078:353;25518:59;25535:9;25554:6;25563:13;25518:16;:59::i;:::-;25824:29;;;;25666:201;;-1:-1:-1;;;25666:201:117;;-1:-1:-1;;;;;25666:11:117;;;;;:201;;25695:10;;25731:9;;25759:16;;25793:13;;25824:29;25666:201;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;24433:1445;;;24193:1685;23970:1914;;23799:2085;;;;:::o;1831:842:159:-;1980:21;2015:24;;;2035:4;2015:24;2011:99;;2071:28;;-1:-1:-1;;;2071:28:159;;-1:-1:-1;;;;;6448:32:264;;;2071:28:159;;;6430:51:264;2071:16:159;;;;;6403:18:264;;2071:28:159;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;2055:44;;2011:99;2370:11;;2366:82;;2397:40;-1:-1:-1;;;;;2397:19:159;;2417:10;2429:7;2397:19;:40::i;:::-;2538:4;2518:24;;;;:82;;;;-1:-1:-1;2577:23:159;2593:7;2577:13;:23;:::i;:::-;2546:28;;-1:-1:-1;;;2546:28:159;;-1:-1:-1;;;;;6448:32:264;;;2546:28:159;;;6430:51:264;2546:16:159;;;;;6403:18:264;;2546:28:159;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:54;2518:82;2514:153;;;2623:33;;-1:-1:-1;;;2623:33:159;;-1:-1:-1;;;;;6448:32:264;;2623:33:159;;;6430:51:264;6403:18;;2623:33:159;6256:231:264;2514:153:159;1970:703;1831:842;;;;:::o;1564:526:60:-;1680:9;1928:1;-1:-1:-1;;1911:19:60;1908:1;1905:26;1902:1;1898:34;1891:42;1878:11;1874:60;1864:116;;1964:1;1961;1954:12;1864:116;-1:-1:-1;2051:9:60;;2047:27;;1564:526::o;14688:277:117:-;14819:7;-1:-1:-1;;;8425:38:153;;14845:113:117;;14951:7;14845:113;;;-1:-1:-1;14925:10:117;;14838:120;-1:-1:-1;14688:277:117:o;8254:433:173:-;-1:-1:-1;;;;;;8441:29:173;;8326:7;8441:29;;;:19;:29;;;;;;-1:-1:-1;;;;;8441:29:173;;8480:172;;8527:15;8544:13;8561:23;8575:8;8561:13;:23::i;:::-;8526:58;;;;8624:7;8633;8605:36;;-1:-1:-1;;;8605:36:173;;;;;;;;;:::i;22350:431:117:-;22553:10;-1:-1:-1;;;8425:38:153;;22566:119:117;;22676:9;22566:119;;;22650:10;22566:119;22553:132;;22724:50;22742:11;22755:2;22759:7;22768:5;22724:17;:50::i;2432:381:119:-;2567:17;2653;;;;;2649:31;;-1:-1:-1;2679:1:119;2672:8;;2649:31;2736:70;2752:7;2761:20;;;862:5;2736:15;:70::i;:::-;2724:82;2432:381;-1:-1:-1;;;;2432:381:119:o;7900:420:153:-;-1:-1:-1;;;8425:38:153;;:43;8076:238;;8130:173;8205:27;;;8234:5;8241:8;8251:6;8259:12;;8161:128;;;;;;;;;;;;:::i;:::-;;;;-1:-1:-1;;8161:128:153;;;;;;;;;;;;;;-1:-1:-1;;;;;8161:128:153;-1:-1:-1;;;;;;8161:128:153;;;;;;;;;;-1:-1:-1;;;;;8130:13:153;;;;:173::i;13443:235:117:-;-1:-1:-1;;;;;13634:18:117;;13513:13;13634:18;;;:10;:18;;;;;:35;;;13612:58;;-1:-1:-1;;;13634:35:117;;;;13612:21;:58::i;5892:1570:115:-;-1:-1:-1;;;;;6098:18:115;;6038:22;6098:18;;;:10;:18;;;;;6160:15;;;:36;;6179:17;;6160:15;6038:22;;6160:36;;6179:17;;6160:36;:::i;:::-;;;;-1:-1:-1;;6231:17:115;;;;6462;;;;-1:-1:-1;;;;;6231:17:115;;;;-1:-1:-1;;;8425:38:153;:43;6434:970:115;;6553:34;;-1:-1:-1;;;6553:34:115;;6581:4;6553:34;;;6430:51:264;6529:21:115;;-1:-1:-1;;;;;6553:19:115;;;;;6403:18:264;;6553:34:115;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;6698:17;;;;6529:58;;-1:-1:-1;6679:85:115;;-1:-1:-1;;;;;6698:17:115;6717:6;6725:17;6698;6750:13;;6679:18;:85::i;:::-;6906:33;6922:17;6906:13;:33;:::i;:::-;6869:34;;-1:-1:-1;;;6869:34:115;;6897:4;6869:34;;;6430:51:264;-1:-1:-1;;;;;6869:19:115;;;;;6403:18:264;;6869:34:115;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:70;6865:133;;;6966:17;;-1:-1:-1;;;6966:17:115;;;;;;;;;;;6865:133;6515:493;6434:970;;;7181:14;;7131:119;;7170:9;;-1:-1:-1;;;;;7181:14:115;7205:4;7212:17;7181:14;7131:21;:119::i;:::-;7326:17;;;;7307:86;;-1:-1:-1;;;;;7326:17:115;7345:6;7353:17;7326;7379:13;;7307:18;:86::i;:::-;-1:-1:-1;7451:4:115;;5892:1570;-1:-1:-1;;;;;;5892:1570:115:o;6170:423:153:-;-1:-1:-1;;;8425:38:153;;:43;6346:241;;6400:176;6475:27;;;6504:5;6511:10;6523:7;6532:12;;6431:131;;;;;;;;;;;;:::i;6462:504:159:-;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;6663:5:159;:12;6679:1;6663:17;6659:117;;-1:-1:-1;;6703:62:159;;;;;;;;-1:-1:-1;6703:62:159;;;;;;;;;;6754:9;;;;;;;;;;6703:62;;;;;;;;6462:504::o;6659:117::-;378:3;6846:5;:12;:35;6842:63;;6890:15;;-1:-1:-1;;;6890:15:159;;;;;;;;;;;6842:63;6934:5;6923:36;;;;;;;;;;;;:::i;21563:302:117:-;21723:135;21767:11;21780:8;21790:10;21810:4;21817:7;21826:16;21844:4;21723:30;:135::i;7377:434:153:-;-1:-1:-1;;;8425:38:153;;:43;7569:236;;7620:174;7695:24;;;7721:5;7728;7735;7742:6;7750:12;;7651:129;;;;;;;;;;;;;:::i;:::-;;;;-1:-1:-1;;7651:129:153;;;;;;;;;;;;;;-1:-1:-1;;;;;7651:129:153;-1:-1:-1;;;;;;7651:129:153;;;;;;;;;;-1:-1:-1;;;;;7620:13:153;;;;:174::i;:::-;7377:434;;;;;;;:::o;3790:137:173:-;3860:7;-1:-1:-1;;;;;3860:19:173;;3883:1;3860:24;3856:64;;3893:27;;-1:-1:-1;;;3893:27:173;;-1:-1:-1;;;;;6448:32:264;;3893:27:173;;;6430:51:264;6403:18;;3893:27:173;6256:231:264;2188:986:172;2279:8;2245:16;2294:640;2314:1;2310;:5;2294:640;;;2328:11;2342:9;2352:1;2342:12;;;;;;;:::i;:::-;;;;2328:26;;2372:1;2368;:5;2364:517;;;-1:-1:-1;;;;;;;;;2479:11:172;;;;:26;;-1:-1:-1;;;;;;;;;;2494:11:172;;;2479:26;2475:63;;;2529:8;2514:24;;-1:-1:-1;;;2514:24:172;;;;;;;;:::i;2475:63::-;2364:517;;;2563:1;2559;:5;2555:326;;;-1:-1:-1;;;;;;;;;2646:11:172;;;;:26;;-1:-1:-1;;;;;;;;;;2661:11:172;;;2642:63;;;2696:8;2681:24;;-1:-1:-1;;;2681:24:172;;;;;;;;:::i;2555:326::-;-1:-1:-1;;;;;;2793:12:172;;;;;;:44;;-1:-1:-1;;;;;;;;;;2810:11:172;;;;:26;;-1:-1:-1;;;;;;;;;;2825:11:172;;;2810:26;2789:81;;;2861:8;2846:24;;-1:-1:-1;;;2846:24:172;;;;;;;;:::i;2789:81::-;-1:-1:-1;2914:3:172;;2294:640;;;;3064:19;3087:23;3101:8;3087:13;:23::i;:::-;3061:49;;;3120:13;:18;;3137:1;3120:18;3116:55;;3162:8;3147:24;;-1:-1:-1;;;3147:24:172;;;;;;;;:::i;1413:584::-;1468:7;;1524:8;-1:-1:-1;;;;;;;;;1590:12:172;;;;;:19;;;:42;;-1:-1:-1;;;;1613:9:172;1623:1;1613:12;;;-1:-1:-1;;;;;1613:19:172;;;1590:42;:65;;;-1:-1:-1;;;;1636:9:172;1646:1;1636:12;;;-1:-1:-1;;;;;1636:19:172;;;1590:65;:88;;;-1:-1:-1;;;;1659:9:172;1669:1;1659:12;;;-1:-1:-1;;;;;1659:19:172;;;1590:88;1586:142;;;1712:8;1697:24;;-1:-1:-1;;;1697:24:172;;;;;;;;:::i;1586:142::-;1733:13;1750:26;1772:4;1756:12;;;1750:26;:::i;:::-;1749:33;;1780:2;1749:33;:::i;:::-;1733:49;-1:-1:-1;1799:26:172;1821:4;1815:1;1805:12;;;1799:26;:::i;:::-;1788:37;;;;:::i;:::-;1958:2;1945:15;;;;-1:-1:-1;;;;;;1945:15:172;;;;-1:-1:-1;1945:15:172;;-1:-1:-1;;;1413:584:172:o;5972:737:173:-;-1:-1:-1;;;;;;6138:25:173;;6047:7;6138:25;;;:15;:25;;;;;;;;6112:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6173:76;;6237:8;6247:1;6218:31;;-1:-1:-1;;;6218:31:173;;;;;;;;;:::i;6173:76::-;6311:6;:13;;;6307:50;;;6333:24;;-1:-1:-1;;;6333:24:173;;-1:-1:-1;;;;;;13804:35:264;;6333:24:173;;;13786:54:264;13759:18;;6333:24:173;13612:234:264;6307:50:173;6587:15;6605:43;6617:8;6627:6;:20;;;6605:11;:43::i;:::-;-1:-1:-1;;;;;;6673:28:173;;;;;:19;:28;;;;;;-1:-1:-1;;;;;6673:28:173;;5972:737;-1:-1:-1;;;;5972:737:173:o;1999:142:172:-;2059:7;2075:15;2095:23;2109:8;2095:13;:23::i;:::-;-1:-1:-1;2074:44:172;1999:142;-1:-1:-1;;;1999:142:172:o;3402:872:153:-;3479:4;-1:-1:-1;;;8425:38:153;;:43;;3687:190;;;;-1:-1:-1;;;;8425:38:153;;:43;;3775:84;;-1:-1:-1;;;;8425:38:153;;:43;3775:84;3687:236;;;;-1:-1:-1;;;;8425:38:153;;:43;3687:236;3670:301;;;-1:-1:-1;3955:5:153;;3402:872;-1:-1:-1;3402:872:153:o;3670:301::-;-1:-1:-1;;;;;4192:32:153;;;;:75;;-1:-1:-1;;;;;;;;;;4228:39:153;;;;;;3402:872::o;2435:1792:115:-;2599:22;;2744:46;2769:20;;;;:8;:20;:::i;2744:46::-;2700:91;-1:-1:-1;2836:26:115;2805:13;-1:-1:-1;;;;;2805:25:115;;:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:57;;;;;;;;:::i;:::-;;2801:85;;2871:15;;-1:-1:-1;;;2871:15:115;;;;;;;;;;;2801:85;3027:23;;;;;;;;:::i;:::-;3023:51;;;3059:15;;-1:-1:-1;;;3059:15:115;;;;;;;;;;;3023:51;-1:-1:-1;;;;;3126:18:115;;;;;;:10;:18;;;;;;;;3155:16;;;;3126:26;;;;:45;3206:18;;;;;;;;;:::i;:::-;3182:43;-1:-1:-1;3304:65:115;-1:-1:-1;;;3304:18:115;;;;;;;;:::i;:::-;8425:38:153;-1:-1:-1;;;;;8425:38:153;:43;;;8326:149;3304:65:115;3300:832;;;3409:34;;-1:-1:-1;;;3409:34:115;;3437:4;3409:34;;;6430:51:264;3385:21:115;;-1:-1:-1;;;;;3409:19:115;;;;;6403:18:264;;3409:34:115;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;3385:58;;3543:59;3561:8;3571:6;3579:7;:16;;;3597:4;3543:17;:59::i;:::-;3740:32;3756:16;;;;3740:13;:32;:::i;:::-;3703:34;;-1:-1:-1;;;3703:34:115;;3731:4;3703:34;;;6430:51:264;-1:-1:-1;;;;;3703:19:115;;;;;6403:18:264;;3703:34:115;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:69;3699:132;;;3799:17;;-1:-1:-1;;;3799:17:115;;;;;;;;;;;3699:132;3371:470;3300:832;;;3964:83;3986:9;3997:10;4017:4;4024:7;:16;;;4042:4;3964:21;:83::i;:::-;4061:60;4079:8;4089:6;4097:7;:16;;;4115:5;4061:17;:60::i;:::-;-1:-1:-1;4216:4:115;;2435:1792;-1:-1:-1;;;;;2435:1792:115:o;14228:454:117:-;14408:267;14440:18;;;;;;;;:::i;:::-;14472:6;14492:10;14524:18;;;;;;;;:::i;:::-;14565:19;;;;;;;;:::i;:::-;14599:9;14622:8;14644:21;;;;:8;:21;:::i;:::-;14408:18;:267::i;:::-;14228:454;;;;:::o;4535:987:115:-;-1:-1:-1;;;;;4794:18:115;;4646:22;4794:18;;;:10;:18;;;;;4840:15;;;;;4923:19;;;;-1:-1:-1;5054:17:115;;;5124;;;;5143:14;;5017:191;;-1:-1:-1;;;;;5054:17:115;;;;5086:72;;5124:17;;;;5143:14;5086:37;:72::i;5017:191::-;5320:17;;;;5288:205;;-1:-1:-1;;;;;5320:17:115;;;5351:6;;5371:7;;-1:-1:-1;;;8425:38:153;:43;;5470:13:115;;5662:419:153;-1:-1:-1;;;8425:38:153;;:43;5836:239;;5890:174;5965:27;;;5994:5;6001:6;6009:9;6020:12;;5921:129;;;;;;;;;;;;:::i;13930:292:117:-;-1:-1:-1;;;;;14175:18:117;;14003:16;14175:18;;;:10;:18;;;;;:38;;;14153:61;;-1:-1:-1;;;14175:38:117;;;;14153:21;:61::i;768:129:159:-;853:37;-1:-1:-1;;;;;853:18:159;;872:8;882:7;853:18;:37::i;3116:1607:62:-;3228:12;3398:4;3392:11;-1:-1:-1;;;3521:17:62;3514:93;-1:-1:-1;;;;;3658:2:62;3654:51;3650:1;3631:17;3627:25;3620:86;3792:6;3787:2;3768:17;3764:26;3757:42;4644:2;4641:1;4637:2;4618:17;4615:1;4608:5;4601;4596:51;4165:16;4158:24;4152:2;4134:16;4131:24;4127:1;4123;4117:8;4114:15;4110:46;4107:76;3907:754;3896:765;;;4689:7;4681:35;;;;-1:-1:-1;;;4681:35:62;;42058:2:264;4681:35:62;;;42040:21:264;42097:2;42077:18;;;42070:30;-1:-1:-1;;;42116:18:264;;;42109:45;42171:18;;4681:35:62;41856:339:264;4359:456:153;4431:23;4523:4;4517;4513:15;4507:22;4487:42;;4550:12;4564:19;4595:4;-1:-1:-1;;;;;4587:18:153;4606:4;4587:24;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4549:62;;;;4626:7;4621:29;;4635:15;4643:6;4635:7;:15::i;:::-;4661;4690:6;4679:28;;;;;;;;;;;;:::i;:::-;4661:46;-1:-1:-1;;;;;;;4722:28:153;;;;;;;4718:91;;4773:25;;-1:-1:-1;;;4773:25:153;;;;;;;;;;;3673:888:159;3851:21;3886:24;;;3906:4;3886:24;3882:99;;3942:28;;-1:-1:-1;;;3942:28:159;;-1:-1:-1;;;;;6448:32:264;;;3942:28:159;;;6430:51:264;3942:16:159;;;;;6403:18:264;;3942:28:159;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;3926:44;;3882:99;4245:11;;4241:95;;4272:53;-1:-1:-1;;;;;4272:23:159;;4296:7;4305:10;4317:7;4272:23;:53::i;:::-;4426:4;4406:24;;;;:82;;;;-1:-1:-1;4465:23:159;4481:7;4465:13;:23;:::i;:::-;4434:28;;-1:-1:-1;;;4434:28:159;;-1:-1:-1;;;;;6448:32:264;;;4434:28:159;;;6430:51:264;4434:16:159;;;;;6403:18:264;;4434:28:159;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:54;4406:82;4402:153;;;4511:33;;-1:-1:-1;;;4511:33:159;;-1:-1:-1;;;;;6448:32:264;;4511:33:159;;;6430:51:264;6403:18;;4511:33:159;6256:231:264;5725:731:159;-1:-1:-1;;;;;6075:22:159;;;;;;:56;;;6130:1;6101:9;:19;;;:26;:30;6075:56;6071:379;;;6147:126;6184:6;6192:8;6202:7;6211:10;6223:7;6232:9;6243:16;6147:19;:126::i;:::-;6071:379;;;6371:68;6384:6;6392:7;6401:10;6413:7;6422:16;6371:12;:68::i;758:361:172:-;827:7;;906:13;917:2;906:8;:13;:::i;:::-;:20;;922:4;906:20;:::i;:::-;899:28;;;-1:-1:-1;933:18:172;962:13;973:2;962:8;:13;:::i;:::-;961:22;;979:4;961:22;:::i;:::-;1063:51;;-1:-1:-1;;;;;;43212:15:264;;;1063:51:172;;;43200:28:264;954:30:172;;;;;43257:15:264;;;43244:11;;;43237:36;-1:-1:-1;;;;;;43302:35:264;;43289:11;;;43282:56;954:30:172;;-1:-1:-1;43354:11:264;;1063:51:172;;;;;;;;;;;;1056:59;;;:::i;:::-;1036:80;758:361;-1:-1:-1;;;;;758:361:172:o;4904:669:153:-;-1:-1:-1;;;8425:38:153;;:43;5157:410;;5211:345;5286:27;;;5335:5;5362:6;5390:9;5421:10;5453:8;5483:7;5512:12;;5242:300;;;;;;;;;;;;;;;:::i;:::-;;;;-1:-1:-1;;5242:300:153;;;;;;;;;;;;;;-1:-1:-1;;;;;5242:300:153;-1:-1:-1;;;;;;5242:300:153;;;;;;;;;;-1:-1:-1;;;;;5211:13:153;;;;:345::i;:::-;4904:669;;;;;;;;;:::o;4729:1605:62:-;4840:12;5010:4;5004:11;-1:-1:-1;;;5133:17:62;5126:93;-1:-1:-1;;;;;5270:2:62;5266:51;5262:1;5243:17;5239:25;5232:86;5404:6;5399:2;5380:17;5376:26;5369:42;6256:2;6253:1;6249:2;6230:17;6227:1;6220:5;6213;6208:51;5777:16;5770:24;5764:2;5746:16;5743:24;5739:1;5735;5729:8;5726:15;5722:46;5719:76;5519:754;5508:765;;;6301:7;6293:34;;;;-1:-1:-1;;;6293:34:62;;44736:2:264;6293:34:62;;;44718:21:264;44775:2;44755:18;;;44748:30;-1:-1:-1;;;44794:18:264;;;44787:44;44848:18;;6293:34:62;44534:338:264;8558:249:153;8623:13;;:17;8619:182;;8715:6;8709:13;8700:6;8694:4;8690:17;8683:40;8619:182;8774:16;;-1:-1:-1;;;8774:16:153;;;;;;;;;;;1328:1782:62;1466:12;1636:4;1630:11;-1:-1:-1;;;1759:17:62;1752:93;-1:-1:-1;;;;;1896:4:62;1892:53;1888:1;1869:17;1865:25;1858:88;-1:-1:-1;;;;;2038:2:62;2034:51;2029:2;2010:17;2006:26;1999:87;2172:6;2167:2;2148:17;2144:26;2137:42;3026:2;3023:1;3018:3;2999:17;2996:1;2989:5;2982;2977:52;2545:16;2538:24;2532:2;2514:16;2511:24;2507:1;2503;2497:8;2494:15;2490:46;2487:76;2287:756;2276:767;;;3071:7;3063:40;;;;-1:-1:-1;;;3063:40:62;;45079:2:264;3063:40:62;;;45061:21:264;45118:2;45098:18;;;45091:30;-1:-1:-1;;;45137:18:264;;;45130:50;45197:18;;3063:40:62;44877:344:264;4567:1152:159;4820:21;4855:24;;;4875:4;4855:24;4851:99;;4911:28;;-1:-1:-1;;;4911:28:159;;-1:-1:-1;;;;;6448:32:264;;;4911:28:159;;;6430:51:264;4911:16:159;;;;;6403:18:264;;4911:28:159;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;4895:44;;4851:99;5092:195;;;5141:51;;;;;-1:-1:-1;;;;;5141:51:159;;;5092:195;;;5141:51;;;;;;;;;5092:195;;5141:51;5214:15;;;;5092:195;;;;5251:18;;5092:195;;;;;;5305:77;;;;;;;;;;;;;;;;;;5450:19;;;;5037:446;;-1:-1:-1;;;5037:446:159;;:37;;;;;;:446;;5092:195;;5305:77;5400:7;;5037:446;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;5564:24:159;;;5584:4;5564:24;:82;;;;-1:-1:-1;5623:23:159;5639:7;5623:13;:23;:::i;:::-;5592:28;;-1:-1:-1;;;5592:28:159;;-1:-1:-1;;;;;6448:32:264;;;5592:28:159;;;6430:51:264;5592:16:159;;;;;6403:18:264;;5592:28:159;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:54;5564:82;5560:153;;;5669:33;;-1:-1:-1;;;5669:33:159;;-1:-1:-1;;;;;6448:32:264;;5669:33:159;;;6430:51:264;6403:18;;5669:33:159;6256:231:264;5560:153:159;4810:909;4567:1152;;;;;;;:::o;14:179:264:-;81:20;;-1:-1:-1;;;;;130:38:264;;120:49;;110:77;;183:1;180;173:12;110:77;14:179;;;:::o;198:686::-;291:6;299;307;360:2;348:9;339:7;335:23;331:32;328:52;;;376:1;373;366:12;328:52;399:28;417:9;399:28;:::i;:::-;389:38;;478:2;467:9;463:18;450:32;-1:-1:-1;;;;;542:2:264;534:6;531:14;528:34;;;558:1;555;548:12;528:34;596:6;585:9;581:22;571:32;;641:7;634:4;630:2;626:13;622:27;612:55;;663:1;660;653:12;612:55;703:2;690:16;729:2;721:6;718:14;715:34;;;745:1;742;735:12;715:34;798:7;793:2;783:6;780:1;776:14;772:2;768:23;764:32;761:45;758:65;;;819:1;816;809:12;758:65;850:2;846;842:11;832:21;;872:6;862:16;;;;;198:686;;;;;:::o;889:131::-;-1:-1:-1;;;;;964:31:264;;954:42;;944:70;;1010:1;1007;1000:12;1025:134;1093:20;;1122:31;1093:20;1122:31;:::i;1164:247::-;1223:6;1276:2;1264:9;1255:7;1251:23;1247:32;1244:52;;;1292:1;1289;1282:12;1244:52;1331:9;1318:23;1350:31;1375:5;1350:31;:::i;1416:197::-;1505:20;;-1:-1:-1;;;;;;1554:34:264;;1544:45;;1534:73;;1603:1;1600;1593:12;1618:236;1706:6;1759:2;1747:9;1738:7;1734:23;1730:32;1727:52;;;1775:1;1772;1765:12;1727:52;1798:50;1838:9;1798:50;:::i;2237:125::-;2322:14;2315:5;2311:26;2304:5;2301:37;2291:65;;2352:1;2349;2342:12;2367:118;2453:5;2446:13;2439:21;2432:5;2429:32;2419:60;;2475:1;2472;2465:12;2490:588;2571:6;2579;2587;2595;2648:3;2636:9;2627:7;2623:23;2619:33;2616:53;;;2665:1;2662;2655:12;2616:53;2704:9;2691:23;2723:30;2747:5;2723:30;:::i;:::-;2772:5;-1:-1:-1;2829:2:264;2814:18;;2801:32;2842;2801;2842;:::i;:::-;2893:7;-1:-1:-1;2952:2:264;2937:18;;2924:32;2965:30;2924:32;2965:30;:::i;:::-;2490:588;;;;-1:-1:-1;3014:7:264;;3068:2;3053:18;3040:32;;-1:-1:-1;;2490:588:264:o;3336:184::-;3394:6;3447:2;3435:9;3426:7;3422:23;3418:32;3415:52;;;3463:1;3460;3453:12;3415:52;3486:28;3504:9;3486:28;:::i;3525:159::-;-1:-1:-1;;;;;;3621:38:264;;3611:49;;3601:77;;3674:1;3671;3664:12;3689:679;3853:6;3861;3869;3922:2;3910:9;3901:7;3897:23;3893:32;3890:52;;;3938:1;3935;3928:12;3890:52;3977:9;3964:23;3996:52;4042:5;3996:52;:::i;:::-;4067:5;-1:-1:-1;4124:2:264;4109:18;;4096:32;4137:54;4096:32;4137:54;:::i;:::-;4210:7;-1:-1:-1;4269:2:264;4254:18;;4241:32;4282:54;4241:32;4282:54;:::i;:::-;4355:7;4345:17;;;3689:679;;;;;:::o;4373:347::-;4424:8;4434:6;4488:3;4481:4;4473:6;4469:17;4465:27;4455:55;;4506:1;4503;4496:12;4455:55;-1:-1:-1;4529:20:264;;-1:-1:-1;;;;;4561:30:264;;4558:50;;;4604:1;4601;4594:12;4558:50;4641:4;4633:6;4629:17;4617:29;;4693:3;4686:4;4677:6;4669;4665:19;4661:30;4658:39;4655:59;;;4710:1;4707;4700:12;4655:59;4373:347;;;;;:::o;4725:549::-;4812:6;4820;4828;4836;4889:2;4877:9;4868:7;4864:23;4860:32;4857:52;;;4905:1;4902;4895:12;4857:52;4928:28;4946:9;4928:28;:::i;:::-;4918:38;;5003:2;4992:9;4988:18;4975:32;4965:42;;5058:2;5047:9;5043:18;5030:32;-1:-1:-1;;;;;5077:6:264;5074:30;5071:50;;;5117:1;5114;5107:12;5071:50;5156:58;5206:7;5197:6;5186:9;5182:22;5156:58;:::i;:::-;4725:549;;;;-1:-1:-1;5233:8:264;-1:-1:-1;;;;4725:549:264:o;5279:250::-;5364:1;5374:113;5388:6;5385:1;5382:13;5374:113;;;5464:11;;;5458:18;5445:11;;;5438:39;5410:2;5403:10;5374:113;;;-1:-1:-1;;5521:1:264;5503:16;;5496:27;5279:250::o;5534:270::-;5575:3;5613:5;5607:12;5640:6;5635:3;5628:19;5656:76;5725:6;5718:4;5713:3;5709:14;5702:4;5695:5;5691:16;5656:76;:::i;:::-;5786:2;5765:15;-1:-1:-1;;5761:29:264;5752:39;;;;5793:4;5748:50;;5534:270;-1:-1:-1;;5534:270:264:o;5809:442::-;6034:6;6023:9;6016:25;6077:6;6072:2;6061:9;6057:18;6050:34;6134:6;6127:14;6120:22;6115:2;6104:9;6100:18;6093:50;6179:3;6174:2;6163:9;6159:18;6152:31;5997:4;6200:45;6240:3;6229:9;6225:19;6217:6;6200:45;:::i;:::-;6192:53;5809:442;-1:-1:-1;;;;;;5809:442:264:o;6718:481::-;6796:6;6804;6812;6865:2;6853:9;6844:7;6840:23;6836:32;6833:52;;;6881:1;6878;6871:12;6833:52;6904:28;6922:9;6904:28;:::i;:::-;6894:38;;6983:2;6972:9;6968:18;6955:32;-1:-1:-1;;;;;7002:6:264;6999:30;6996:50;;;7042:1;7039;7032:12;6996:50;7081:58;7131:7;7122:6;7111:9;7107:22;7081:58;:::i;:::-;6718:481;;7158:8;;-1:-1:-1;7055:84:264;;-1:-1:-1;;;;6718:481:264:o;7204:594::-;7312:6;7320;7328;7381:2;7369:9;7360:7;7356:23;7352:32;7349:52;;;7397:1;7394;7387:12;7349:52;7436:9;7423:23;7455:52;7501:5;7455:52;:::i;7803:217::-;7950:2;7939:9;7932:21;7913:4;7970:44;8010:2;7999:9;7995:18;7987:6;7970:44;:::i;8025:129::-;-1:-1:-1;;;;;8103:5:264;8099:30;8092:5;8089:41;8079:69;;8144:1;8141;8134:12;8159:385;8234:6;8242;8250;8303:2;8291:9;8282:7;8278:23;8274:32;8271:52;;;8319:1;8316;8309:12;8271:52;8342:28;8360:9;8342:28;:::i;:::-;8332:38;;8420:2;8409:9;8405:18;8392:32;8433:30;8457:5;8433:30;:::i;:::-;8159:385;;8482:5;;-1:-1:-1;;;8534:2:264;8519:18;;;;8506:32;;8159:385::o;9091:127::-;9152:10;9147:3;9143:20;9140:1;9133:31;9183:4;9180:1;9173:15;9207:4;9204:1;9197:15;9223:253;9295:2;9289:9;9337:4;9325:17;;-1:-1:-1;;;;;9357:34:264;;9393:22;;;9354:62;9351:88;;;9419:18;;:::i;:::-;9455:2;9448:22;9223:253;:::o;9481:::-;9553:2;9547:9;9595:4;9583:17;;-1:-1:-1;;;;;9615:34:264;;9651:22;;;9612:62;9609:88;;;9677:18;;:::i;9739:275::-;9810:2;9804:9;9875:2;9856:13;;-1:-1:-1;;9852:27:264;9840:40;;-1:-1:-1;;;;;9895:34:264;;9931:22;;;9892:62;9889:88;;;9957:18;;:::i;:::-;9993:2;9986:22;9739:275;;-1:-1:-1;9739:275:264:o;10019:186::-;10067:4;-1:-1:-1;;;;;10092:6:264;10089:30;10086:56;;;10122:18;;:::i;:::-;-1:-1:-1;10188:2:264;10167:15;-1:-1:-1;;10163:29:264;10194:4;10159:40;;10019:186::o;10210:462::-;10252:5;10305:3;10298:4;10290:6;10286:17;10282:27;10272:55;;10323:1;10320;10313:12;10272:55;10359:6;10346:20;10390:48;10406:31;10434:2;10406:31;:::i;:::-;10390:48;:::i;:::-;10463:2;10454:7;10447:19;10509:3;10502:4;10497:2;10489:6;10485:15;10481:26;10478:35;10475:55;;;10526:1;10523;10516:12;10475:55;10591:2;10584:4;10576:6;10572:17;10565:4;10556:7;10552:18;10539:55;10639:1;10614:16;;;10632:4;10610:27;10603:38;;;;10618:7;10210:462;-1:-1:-1;;;10210:462:264:o;10677:1323::-;10784:6;10792;10800;10853:2;10841:9;10832:7;10828:23;10824:32;10821:52;;;10869:1;10866;10859:12;10821:52;10909:9;10896:23;-1:-1:-1;;;;;10979:2:264;10971:6;10968:14;10965:34;;;10995:1;10992;10985:12;10965:34;11018:22;;;;11074:4;11056:16;;;11052:27;11049:47;;;11092:1;11089;11082:12;11049:47;11118:22;;:::i;:::-;11163:21;11181:2;11163:21;:::i;:::-;11156:5;11149:36;11217:31;11244:2;11240;11236:11;11217:31;:::i;:::-;11212:2;11205:5;11201:14;11194:55;11281:31;11308:2;11304;11300:11;11281:31;:::i;:::-;11276:2;11269:5;11265:14;11258:55;11366:2;11362;11358:11;11345:25;11340:2;11333:5;11329:14;11322:49;11417:3;11413:2;11409:12;11396:26;11447:2;11437:8;11434:16;11431:36;;;11463:1;11460;11453:12;11431:36;11500:44;11536:7;11525:8;11521:2;11517:17;11500:44;:::i;:::-;11494:3;11487:5;11483:15;11476:69;;11591:3;11587:2;11583:12;11570:26;11621:2;11611:8;11608:16;11605:36;;;11637:1;11634;11627:12;11605:36;11674:44;11710:7;11699:8;11695:2;11691:17;11674:44;:::i;:::-;11668:3;11657:15;;11650:69;-1:-1:-1;11661:5:264;-1:-1:-1;11796:2:264;11781:18;;11768:32;;-1:-1:-1;11812:16:264;;;11809:36;;;11841:1;11838;11831:12;11809:36;;11880:60;11932:7;11921:8;11910:9;11906:24;11880:60;:::i;12210:369::-;12306:6;12314;12367:2;12355:9;12346:7;12342:23;12338:32;12335:52;;;12383:1;12380;12373:12;12335:52;12406:50;12446:9;12406:50;:::i;:::-;12396:60;;12506:2;12495:9;12491:18;12478:32;12519:30;12543:5;12519:30;:::i;:::-;12568:5;12558:15;;;12210:369;;;;;:::o;12584:388::-;12652:6;12660;12713:2;12701:9;12692:7;12688:23;12684:32;12681:52;;;12729:1;12726;12719:12;12681:52;12768:9;12755:23;12787:31;12812:5;12787:31;:::i;:::-;12837:5;-1:-1:-1;12894:2:264;12879:18;;12866:32;12907:33;12866:32;12907:33;:::i;13427:180::-;13486:6;13539:2;13527:9;13518:7;13514:23;13510:32;13507:52;;;13555:1;13552;13545:12;13507:52;-1:-1:-1;13578:23:264;;13427:180;-1:-1:-1;13427:180:264:o;13851:975::-;14008:6;14016;14024;14032;14085:2;14073:9;14064:7;14060:23;14056:32;14053:52;;;14101:1;14098;14091:12;14053:52;14141:9;14128:23;-1:-1:-1;;;;;14211:2:264;14203:6;14200:14;14197:34;;;14227:1;14224;14217:12;14197:34;14250:22;;;;14306:3;14288:16;;;14284:26;14281:46;;;14323:1;14320;14313:12;14281:46;14346:2;;-1:-1:-1;14401:2:264;14386:18;;14373:32;;14417:16;;;14414:36;;;14446:1;14443;14436:12;14414:36;14469:24;;;;14527:3;14509:16;;;14505:26;14502:46;;;14544:1;14541;14534:12;14502:46;14567:2;;-1:-1:-1;14622:2:264;14607:18;;14594:32;;14638:16;;;14635:36;;;14667:1;14664;14657:12;14635:36;;14706:60;14758:7;14747:8;14736:9;14732:24;14706:60;:::i;15252:1034::-;-1:-1:-1;;;;;15752:15:264;;;15734:34;;15804:15;;;15799:2;15784:18;;15777:43;15856:15;;;15851:2;15836:18;;15829:43;-1:-1:-1;;;;;;15953:15:264;;;15948:2;15933:18;;15926:43;16000:3;15985:19;;15978:35;;;16050:15;;;15714:3;16029:19;;16022:44;16103:15;;16097:3;16082:19;;16075:44;16163:14;;16156:22;16150:3;16135:19;;16128:51;15684:3;16210;16195:19;;16188:31;;;15655:4;;16236:44;16261:18;;;16253:6;16236:44;:::i;:::-;16228:52;15252:1034;-1:-1:-1;;;;;;;;;;;;15252:1034:264:o;16291:297::-;16379:6;16432:2;16420:9;16411:7;16407:23;16403:32;16400:52;;;16448:1;16445;16438:12;16400:52;16487:9;16474:23;16506:52;16552:5;16506:52;:::i;16817:532::-;16935:6;16943;16951;17004:2;16992:9;16983:7;16979:23;16975:32;16972:52;;;17020:1;17017;17010:12;16972:52;17043:50;17083:9;17043:50;:::i;:::-;17033:60;;17143:2;17132:9;17128:18;17115:32;17176:1;17169:5;17166:12;17156:40;;17192:1;17189;17182:12;17156:40;17215:5;-1:-1:-1;17272:2:264;17257:18;;17244:32;17285;17244;17285;:::i;17762:371::-;17859:6;17867;17920:2;17908:9;17899:7;17895:23;17891:32;17888:52;;;17936:1;17933;17926:12;17888:52;17959:50;17999:9;17959:50;:::i;18897:488::-;19023:6;19031;19084:2;19072:9;19063:7;19059:23;19055:32;19052:52;;;19100:1;19097;19090:12;19052:52;19139:9;19126:23;19158:52;19204:5;19158:52;:::i;:::-;19229:5;-1:-1:-1;19286:2:264;19271:18;;19258:32;19299:54;19258:32;19299:54;:::i;19390:238::-;-1:-1:-1;;;;;;19582:39:264;;;;19564:58;;19552:2;19537:18;;19390:238::o;19862:334::-;20064:2;20046:21;;;20103:2;20083:18;;;20076:30;-1:-1:-1;;;20137:2:264;20122:18;;20115:40;20187:2;20172:18;;19862:334::o;20201:803::-;-1:-1:-1;;;;;20455:39:264;;20437:58;;20425:2;20514;20532:18;;;20525:30;;;20410:18;;;20590:22;;;20377:4;;20669:6;;20643:2;20628:18;;20377:4;20703:275;20717:6;20714:1;20711:13;20703:275;;;20792:6;20779:20;20812:30;20836:5;20812:30;:::i;:::-;-1:-1:-1;;;;;20867:30:264;20855:43;;20953:15;;;;20918:12;;;;20739:1;20732:9;20703:275;;;-1:-1:-1;20995:3:264;20201:803;-1:-1:-1;;;;;;;20201:803:264:o;21009:441::-;21062:5;21115:3;21108:4;21100:6;21096:17;21092:27;21082:55;;21133:1;21130;21123:12;21082:55;21162:6;21156:13;21193:48;21209:31;21237:2;21209:31;:::i;21193:48::-;21266:2;21257:7;21250:19;21312:3;21305:4;21300:2;21292:6;21288:15;21284:26;21281:35;21278:55;;;21329:1;21326;21319:12;21278:55;21342:77;21416:2;21409:4;21400:7;21396:18;21389:4;21381:6;21377:17;21342:77;:::i;21455:1846::-;21595:6;21603;21634:2;21677;21665:9;21656:7;21652:23;21648:32;21645:52;;;21693:1;21690;21683:12;21645:52;21726:9;21720:16;-1:-1:-1;;;;;21796:2:264;21788:6;21785:14;21782:34;;;21812:1;21809;21802:12;21782:34;21850:6;21839:9;21835:22;21825:32;;21895:7;21888:4;21884:2;21880:13;21876:27;21866:55;;21917:1;21914;21907:12;21866:55;21946:2;21940:9;21968:4;21991:2;21987;21984:10;21981:36;;;21997:18;;:::i;:::-;22037:36;22069:2;22064;22061:1;22057:10;22053:19;22037:36;:::i;:::-;22107:15;;;22169:4;22208:11;;;22200:20;;22196:29;;;22138:12;;;;22095:3;22237:19;;;22234:39;;;22269:1;22266;22259:12;22234:39;22293:11;;;;22313:782;22329:6;22324:3;22321:15;22313:782;;;22409:2;22403:3;22394:7;22390:17;22386:26;22383:116;;;22453:1;22482:2;22478;22471:14;22383:116;22525:22;;:::i;:::-;22581:3;22575:10;22598:33;22623:7;22598:33;:::i;:::-;22644:22;;22700:12;;;22694:19;22726:33;22694:19;22726:33;:::i;:::-;22779:14;;;22772:31;22845:12;;;22839:19;22823:14;;;22816:43;22882:2;22926:12;;;22920:19;22904:14;;;22897:43;22963:3;23008:12;;;23002:19;22986:14;;;22979:43;23035:18;;22346:12;;;;23073;;;;22313:782;;;-1:-1:-1;23150:18:264;;;23144:25;23114:5;;-1:-1:-1;23144:25:264;;-1:-1:-1;;;23181:16:264;;;23178:36;;;23210:1;23207;23200:12;23178:36;;;23233:62;23287:7;23276:8;23265:9;23261:24;23233:62;:::i;:::-;23223:72;;;21455:1846;;;;;:::o;23306:127::-;23367:10;23362:3;23358:20;23355:1;23348:31;23398:4;23395:1;23388:15;23422:4;23419:1;23412:15;23438:127;23499:10;23494:3;23490:20;23487:1;23480:31;23530:4;23527:1;23520:15;23554:4;23551:1;23544:15;23570:128;23637:9;;;23658:11;;;23655:37;;;23672:18;;:::i;23703:380::-;23782:1;23778:12;;;;23825;;;23846:61;;23900:4;23892:6;23888:17;23878:27;;23846:61;23953:2;23945:6;23942:14;23922:18;23919:38;23916:161;;23999:10;23994:3;23990:20;23987:1;23980:31;24034:4;24031:1;24024:15;24062:4;24059:1;24052:15;23916:161;;23703:380;;;:::o;24088:245::-;24146:6;24199:2;24187:9;24178:7;24174:23;24170:32;24167:52;;;24215:1;24212;24205:12;24167:52;24254:9;24241:23;24273:30;24297:5;24273:30;:::i;24338:135::-;24377:3;24398:17;;;24395:43;;24418:18;;:::i;:::-;-1:-1:-1;24465:1:264;24454:13;;24338:135::o;24478:336::-;24680:2;24662:21;;;24719:2;24699:18;;;24692:30;-1:-1:-1;;;24753:2:264;24738:18;;24731:42;24805:2;24790:18;;24478:336::o;24819:176::-;24886:14;24920:10;;;24932;;;24916:27;;24955:11;;;24952:37;;;24969:18;;:::i;:::-;24952:37;24819:176;;;;:::o;25289:473::-;-1:-1:-1;;;;;25516:6:264;25512:39;25501:9;25494:58;25588:6;25583:2;25572:9;25568:18;25561:34;25645:6;25638:14;25631:22;25626:2;25615:9;25611:18;25604:50;25690:3;25685:2;25674:9;25670:18;25663:31;25475:4;25711:45;25751:3;25740:9;25736:19;25728:6;25711:45;:::i;25767:287::-;25896:3;25934:6;25928:13;25950:66;26009:6;26004:3;25997:4;25989:6;25985:17;25950:66;:::i;:::-;26032:16;;;;;25767:287;-1:-1:-1;;25767:287:264:o;26059:127::-;26120:10;26115:3;26111:20;26108:1;26101:31;26151:4;26148:1;26141:15;26175:4;26172:1;26165:15;26191:270;26271:6;26324:2;26312:9;26303:7;26299:23;26295:32;26292:52;;;26340:1;26337;26330:12;26292:52;26372:9;26366:16;26411:1;26404:5;26401:12;26391:40;;26427:1;26424;26417:12;26750:642;26862:6;26870;26878;26886;26894;26947:3;26935:9;26926:7;26922:23;26918:33;26915:53;;;26964:1;26961;26954:12;26915:53;26993:9;26987:16;26977:26;;27043:2;27032:9;27028:18;27022:25;27012:35;;27087:2;27076:9;27072:18;27066:25;27056:35;;27134:2;27123:9;27119:18;27113:25;27147:28;27169:5;27147:28;:::i;:::-;27243:3;27228:19;;27222:26;27194:5;;-1:-1:-1;;;;;;27260:30:264;;27257:50;;;27303:1;27300;27293:12;27257:50;27326:60;27378:7;27369:6;27358:9;27354:22;27326:60;:::i;:::-;27316:70;;;26750:642;;;;;;;;:::o;27397:125::-;27462:9;;;27483:10;;;27480:36;;;27496:18;;:::i;27527:245::-;27594:6;27647:2;27635:9;27626:7;27622:23;27618:32;27615:52;;;27663:1;27660;27653:12;27615:52;27695:9;27689:16;27714:28;27736:5;27714:28;:::i;27777:184::-;27847:6;27900:2;27888:9;27879:7;27875:23;27871:32;27868:52;;;27916:1;27913;27906:12;27868:52;-1:-1:-1;27939:16:264;;27777:184;-1:-1:-1;27777:184:264:o;27966:271::-;28149:6;28141;28136:3;28123:33;28105:3;28175:16;;28200:13;;;28175:16;27966:271;-1:-1:-1;27966:271:264:o;28718:591::-;-1:-1:-1;;;;;28975:39:264;;28957:58;;-1:-1:-1;;;;;29089:15:264;;;29084:2;29069:18;;29062:43;29141:15;;29136:2;29121:18;;29114:43;29188:2;29173:18;;29166:34;;;29042:3;29231;29216:19;;29209:32;;;28938:4;;29258:45;;29283:19;;29275:6;29258:45;:::i;:::-;29250:53;28718:591;-1:-1:-1;;;;;;;28718:591:264:o;29314:249::-;29383:6;29436:2;29424:9;29415:7;29411:23;29407:32;29404:52;;;29452:1;29449;29442:12;29404:52;29484:9;29478:16;29503:30;29527:5;29503:30;:::i;29568:301::-;29667:6;29720:2;29708:9;29699:7;29695:23;29691:32;29688:52;;;29736:1;29733;29726:12;29688:52;29768:9;29762:16;29787:52;29833:5;29787:52;:::i;29874:148::-;29962:4;29941:12;;;29955;;;29937:31;;29980:13;;29977:39;;;29996:18;;:::i;30027:312::-;-1:-1:-1;;;;;;30243:35:264;;;;30225:54;;30327:4;30315:17;30310:2;30295:18;;30288:45;30213:2;30198:18;;30027:312::o;30344:217::-;30382:3;-1:-1:-1;;;;;30471:2:264;30464:5;30460:14;30498:2;30489:7;30486:15;30483:41;;30504:18;;:::i;:::-;30553:1;30540:15;;30344:217;-1:-1:-1;;;30344:217:264:o;30566:273::-;30634:6;30687:2;30675:9;30666:7;30662:23;30658:32;30655:52;;;30703:1;30700;30693:12;30655:52;30735:9;30729:16;30785:4;30778:5;30774:16;30767:5;30764:27;30754:55;;30805:1;30802;30795:12;30844:266;30932:6;30927:3;30920:19;30984:6;30977:5;30970:4;30965:3;30961:14;30948:43;-1:-1:-1;31036:1:264;31011:16;;;31029:4;31007:27;;;31000:38;;;;31092:2;31071:15;;;-1:-1:-1;;31067:29:264;31058:39;;;31054:50;;30844:266::o;31115:1562::-;-1:-1:-1;;;;;31388:6:264;31384:39;31373:9;31366:58;31460:3;31455:2;31444:9;31440:18;31433:31;31347:4;31499:6;31486:20;31515:30;31539:5;31515:30;:::i;:::-;31564:14;31615;;;31609:3;31594:19;;31587:43;31679:2;31667:15;;31654:29;;31692:32;31654:29;31692:32;:::i;:::-;31762:16;31755:4;31740:20;;31733:46;31828:4;31816:17;;31803:31;31843:30;31803:31;31843:30;:::i;:::-;31917:15;31910:23;31904:3;31889:19;;31882:52;31996:4;31984:17;;31971:31;31965:3;31950:19;;31943:60;32063:3;32051:16;;32038:30;32119:14;32115:27;;;-1:-1:-1;;32111:41:264;32087:66;;32077:94;;32167:1;32164;32157:12;32077:94;32195:31;;32307:2;32294:16;;;32249:21;-1:-1:-1;;;;;32322:30:264;;32319:50;;;32365:1;32362;32355:12;32319:50;32414:6;32398:14;32394:27;32385:7;32381:41;32378:61;;;32435:1;32432;32425:12;32378:61;32476:4;32470:3;32459:9;32455:19;32448:33;32498:63;32556:3;32545:9;32541:19;32533:6;32524:7;32498:63;:::i;:::-;32490:71;;;;32570:46;32610:4;32599:9;32595:20;32587:6;8616:4;8605:16;8593:29;;8549:75;32570:46;8616:4;8605:16;;32665:4;32650:20;;8593:29;31115:1562;;;;;;;:::o;32682:245::-;32740:6;32793:2;32781:9;32772:7;32768:23;32764:32;32761:52;;;32809:1;32806;32799:12;32761:52;32848:9;32835:23;32867:30;32891:5;32867:30;:::i;32932:521::-;33009:4;33015:6;33075:11;33062:25;33169:2;33165:7;33154:8;33138:14;33134:29;33130:43;33110:18;33106:68;33096:96;;33188:1;33185;33178:12;33096:96;33215:33;;33267:20;;;-1:-1:-1;;;;;;33299:30:264;;33296:50;;;33342:1;33339;33332:12;33296:50;33375:4;33363:17;;-1:-1:-1;33406:14:264;33402:27;;;33392:38;;33389:58;;;33443:1;33440;33433:12;33458:341;-1:-1:-1;;;;;33643:32:264;;33625:51;;33712:2;33707;33692:18;;33685:30;;;-1:-1:-1;;33732:61:264;;33774:18;;33766:6;33758;33732:61;:::i;33929:544::-;34030:2;34025:3;34022:11;34019:448;;;34066:1;34091:5;34087:2;34080:17;34136:4;34132:2;34122:19;34206:2;34194:10;34190:19;34187:1;34183:27;34177:4;34173:38;34242:4;34230:10;34227:20;34224:47;;;-1:-1:-1;34265:4:264;34224:47;34320:2;34315:3;34311:12;34308:1;34304:20;34298:4;34294:31;34284:41;;34375:82;34393:2;34386:5;34383:13;34375:82;;;34438:17;;;34419:1;34408:13;34375:82;;34649:1202;-1:-1:-1;;;;;34766:3:264;34763:27;34760:53;;;34793:18;;:::i;:::-;34822:93;34911:3;34871:38;34903:4;34897:11;34871:38;:::i;:::-;34865:4;34822:93;:::i;:::-;34941:1;34966:2;34961:3;34958:11;34983:1;34978:615;;;;35637:1;35654:3;35651:93;;;-1:-1:-1;35710:19:264;;;35697:33;35651:93;-1:-1:-1;;34606:1:264;34602:11;;;34598:24;34594:29;34584:40;34630:1;34626:11;;;34581:57;35757:78;;34951:894;;34978:615;33876:1;33869:14;;;33913:4;33900:18;;-1:-1:-1;;35014:17:264;;;35114:9;35136:229;35150:7;35147:1;35144:14;35136:229;;;35239:19;;;35226:33;35211:49;;35346:4;35331:20;;;;35299:1;35287:14;;;;35166:12;35136:229;;;35140:3;35393;35384:7;35381:16;35378:159;;;35517:1;35513:6;35507:3;35501;35498:1;35494:11;35490:21;35486:34;35482:39;35469:9;35464:3;35460:19;35447:33;35443:79;35435:6;35428:95;35378:159;;;35580:1;35574:3;35571:1;35567:11;35563:19;35557:4;35550:33;34951:894;;34649:1202;;;:::o;35856:241::-;35912:6;35965:2;35953:9;35944:7;35940:23;35936:32;35933:52;;;35981:1;35978;35971:12;35933:52;36020:9;36007:23;36039:28;36061:5;36039:28;:::i;36373:246::-;36532:2;36521:9;36514:21;36495:4;36552:61;36609:2;36598:9;36594:18;36586:6;36578;36552:61;:::i;36951:377::-;37144:2;37133:9;37126:21;37107:4;37170:44;37210:2;37199:9;37195:18;37187:6;37170:44;:::i;:::-;37262:9;37254:6;37250:22;37245:2;37234:9;37230:18;37223:50;37290:32;37315:6;37307;37290:32;:::i;37333:335::-;37412:6;37465:2;37453:9;37444:7;37440:23;37436:32;37433:52;;;37481:1;37478;37471:12;37433:52;37514:9;37508:16;-1:-1:-1;;;;;37539:6:264;37536:30;37533:50;;;37579:1;37576;37569:12;37533:50;37602:60;37654:7;37645:6;37634:9;37630:22;37602:60;:::i;37673:570::-;-1:-1:-1;;;;;37964:15:264;;;37946:34;;38016:15;;38011:2;37996:18;;37989:43;37926:3;38063:2;38048:18;;38041:31;;;37889:4;;38089:45;;38114:19;;38106:6;38089:45;:::i;:::-;38165:2;38150:18;;38143:34;;;;-1:-1:-1;38221:14:264;;38214:22;38208:3;38193:19;;;38186:51;38081:53;37673:570;-1:-1:-1;;;37673:570:264:o;38248:373::-;38336:6;38344;38352;38405:2;38393:9;38384:7;38380:23;38376:32;38373:52;;;38421:1;38418;38411:12;38373:52;38450:9;38444:16;38434:26;;38503:2;38492:9;38488:18;38482:25;38516:31;38541:5;38516:31;:::i;:::-;38566:5;38556:15;;;38611:2;38600:9;38596:18;38590:25;38580:35;;38248:373;;;;;:::o;38626:490::-;-1:-1:-1;;;;;38869:6:264;38865:39;38854:9;38847:58;38941:6;38936:2;38925:9;38921:18;38914:34;38984:6;38979:2;38968:9;38964:18;38957:34;39027:3;39022:2;39011:9;39007:18;39000:31;38828:4;39048:62;39105:3;39094:9;39090:19;39082:6;39074;39048:62;:::i;39121:500::-;-1:-1:-1;;;;;39358:6:264;39354:39;39343:9;39336:58;39430:6;39425:2;39414:9;39410:18;39403:34;39487:6;39480:14;39473:22;39468:2;39457:9;39453:18;39446:50;39532:3;39527:2;39516:9;39512:18;39505:31;39317:4;39553:62;39610:3;39599:9;39595:19;39587:6;39579;39553:62;:::i;39626:941::-;39730:6;39783:2;39771:9;39762:7;39758:23;39754:32;39751:52;;;39799:1;39796;39789:12;39751:52;39832:9;39826:16;-1:-1:-1;;;;;39902:2:264;39894:6;39891:14;39888:34;;;39918:1;39915;39908:12;39888:34;39941:22;;;;39997:4;39979:16;;;39975:27;39972:47;;;40015:1;40012;40005:12;39972:47;40048:2;40042:9;40090:4;40082:6;40078:17;40145:6;40133:10;40130:22;40125:2;40113:10;40110:18;40107:46;40104:72;;;40156:18;;:::i;:::-;40192:2;40185:22;40229:9;;40247:30;40229:9;40247:30;:::i;:::-;40286:21;;40354:2;40346:11;;;40340:18;40323:15;;;40316:43;40398:2;40390:11;;40384:18;40414:16;;;40411:36;;;40443:1;40440;40433:12;40411:36;40480:55;40527:7;40516:8;40512:2;40508:17;40480:55;:::i;:::-;40475:2;40463:15;;40456:80;-1:-1:-1;40467:6:264;39626:941;-1:-1:-1;;;;;39626:941:264:o;40572:611::-;-1:-1:-1;;;;;40841:6:264;40837:39;40826:9;40819:58;-1:-1:-1;;;;;40917:6:264;40913:31;40908:2;40897:9;40893:18;40886:59;41010:1;41006;41001:3;40997:11;40993:19;40985:6;40981:32;40976:2;40965:9;40961:18;40954:60;41050:6;41045:2;41034:9;41030:18;41023:34;41094:3;41088;41077:9;41073:19;41066:32;40800:4;41115:62;41172:3;41161:9;41157:19;41149:6;41141;41115:62;:::i;:::-;41107:70;40572:611;-1:-1:-1;;;;;;;;40572:611:264:o;41188:151::-;41278:4;41271:12;;;41257;;;41253:31;;41296:14;;41293:40;;;41313:18;;:::i;41344:225::-;41448:4;41427:12;;;41441;;;41423:31;41474:22;;;;41515:24;;;41505:58;;41543:18;;:::i;41574:277::-;41661:6;41714:2;41702:9;41693:7;41689:23;41685:32;41682:52;;;41730:1;41727;41720:12;41682:52;41762:9;41756:16;41801:1;41794:5;41791:12;41781:40;;41817:1;41814;41807:12;42200:290;42269:6;42322:2;42310:9;42301:7;42297:23;42293:32;42290:52;;;42338:1;42335;42328:12;42290:52;42364:16;;-1:-1:-1;;;;;;42409:32:264;;42399:43;;42389:71;;42456:1;42453;42446:12;42495:127;42556:10;42551:3;42547:20;42544:1;42537:31;42587:4;42584:1;42577:15;42611:4;42608:1;42601:15;42627:165;42665:1;42699:4;42696:1;42692:12;42723:3;42713:37;;42730:18;;:::i;:::-;42782:3;42775:4;42772:1;42768:12;42764:22;42759:27;;;42627:165;;;;:::o;42797:157::-;42827:1;42861:4;42858:1;42854:12;42885:3;42875:37;;42892:18;;:::i;:::-;42944:3;42937:4;42934:1;42930:12;42926:22;42921:27;;;42797:157;;;;:::o;43376:367::-;43493:12;;43541:4;43530:16;;43524:23;-1:-1:-1;;;;;;43610:11:264;;;;43493:12;43524:23;43644:1;43633:13;;43630:107;;;43724:2;43718;43708:6;43705:1;43701:14;43698:1;43694:22;43690:31;43686:2;43682:40;43678:49;43669:58;;43630:107;;;;43376:367;;;:::o;43748:781::-;-1:-1:-1;;;;;44065:39:264;;44047:58;;-1:-1:-1;;;;;44179:15:264;;;44174:2;44159:18;;44152:43;44231:15;;;44226:2;44211:18;;44204:43;44283:15;;44278:2;44263:18;;44256:43;44330:3;44315:19;;44308:35;;;44387:14;;44380:22;44132:3;44359:19;;44352:51;44440:3;44434;44419:19;;44412:32;;;44028:4;;44461:62;;44503:19;;44495:6;44487;44461:62;:::i;:::-;44453:70;43748:781;-1:-1:-1;;;;;;;;;;43748:781:264:o;45414:830::-;45768:4;45797:3;45809:60;45859:9;45850:6;45844:13;45312:12;;-1:-1:-1;;;;;45308:38:264;45296:51;;45396:4;45385:16;;;45379:23;45363:14;;45356:47;45226:183;45809:60;45925:4;45917:6;45913:17;45907:24;45900:4;45889:9;45885:20;45878:54;45988:4;45980:6;45976:17;45970:24;45963:4;45952:9;45948:20;45941:54;46004:63;46062:3;46051:9;46047:19;46039:6;45312:12;;-1:-1:-1;;;;;45308:38:264;45296:51;;45396:4;45385:16;;;45379:23;45363:14;;45356:47;45226:183;46004:63;-1:-1:-1;;;;;46104:32:264;;46098:3;46083:19;;46076:61;46168:3;46153:19;;46146:31;;;46194:44;46219:18;;;46211:6;46194:44;:::i",
    linkReferences: {},
    immutableReferences: {
      "75356": [
        {
          start: 14167,
          length: 32
        }
      ]
    }
  },
  methodIdentifiers: {
    "abort(uint96)": "1ed75f1f",
    "auction((bytes5,address,address,address,uint48,address,bytes,bytes5,bytes,bool),(uint48,uint48,bool,uint256,bytes),string)": "8a9f1315",
    "bid((uint96,address,address,uint256,bytes,bytes),bytes)": "6e9c996d",
    "calculateQuoteFees(uint48,uint48,bool,uint256)": "0bad843b",
    "cancel(uint96,bytes)": "cf042fb0",
    "claimBids(uint96,uint64[])": "0a35511b",
    "claimRewards(address)": "ef5cfb8c",
    "condensers(bytes7,bytes7)": "f4b26181",
    "curate(uint96,bytes)": "505f901a",
    "execOnModule(bytes7,bytes)": "50ab0489",
    "fees(bytes5)": "31d72d6b",
    "getAuctionModuleForId(uint96)": "3bb7098a",
    "getBatchModuleForId(uint96)": "3ab3f98e",
    "getCuratorFee(bytes5,address)": "e814b76a",
    "getDerivativeModuleForId(uint96)": "fc48ba55",
    "getFees(bytes5)": "0ab9a1ee",
    "getModuleForVeecode(bytes7)": "9e55cba3",
    "getModuleStatus(bytes5)": "5bb27aab",
    "getProtocol()": "d16352af",
    "getRewards(address,address)": "779bcb9b",
    "installModule(address)": "7eb1e761",
    "isExecOnModule()": "5c774ed7",
    "lotCounter()": "c4ce88fd",
    "lotFees(uint96)": "ea072e70",
    "lotRouting(uint96)": "9e2e003a",
    "modules(uint256)": "81b2248a",
    "modulesCount()": "f315aafe",
    "owner()": "8da5cb5b",
    "refundBid(uint96,uint64,uint256)": "510bd273",
    "rewards(address,address)": "e70b9e27",
    "setCondenser(bytes7,bytes7,bytes7)": "20b15fe4",
    "setCuratorFee(bytes5,uint48)": "7249c0d5",
    "setFee(bytes5,uint8,uint48)": "c74c149b",
    "setProtocol(address)": "0a9d793d",
    "settle(uint96,uint256,bytes)": "367b02fb",
    "sunsetModule(bytes5)": "c75519ba",
    "transferOwnership(address)": "f2fde38b"
  },
  rawMetadata: '{"compiler":{"version":"0.8.19+commit.7dd6d404"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"owner_","type":"address"},{"internalType":"address","name":"protocol_","type":"address"},{"internalType":"address","name":"permit2_","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"AmountLessThanMinimum","type":"error"},{"inputs":[],"name":"FailedCallback","type":"error"},{"inputs":[],"name":"InsufficientFunding","type":"error"},{"inputs":[],"name":"InvalidCallback","type":"error"},{"inputs":[],"name":"InvalidCallbackResponse","type":"error"},{"inputs":[],"name":"InvalidFee","type":"error"},{"inputs":[{"internalType":"uint96","name":"id_","type":"uint96"}],"name":"InvalidLotId","type":"error"},{"inputs":[{"internalType":"Keycode","name":"keycode_","type":"bytes5"},{"internalType":"uint8","name":"version_","type":"uint8"}],"name":"InvalidModuleInstall","type":"error"},{"inputs":[],"name":"InvalidParams","type":"error"},{"inputs":[],"name":"InvalidParams","type":"error"},{"inputs":[],"name":"InvalidState","type":"error"},{"inputs":[{"internalType":"Veecode","name":"veecode_","type":"bytes7"}],"name":"InvalidVeecode","type":"error"},{"inputs":[{"internalType":"Keycode","name":"keycode_","type":"bytes5"}],"name":"ModuleAlreadySunset","type":"error"},{"inputs":[{"internalType":"bytes","name":"error_","type":"bytes"}],"name":"ModuleExecutionReverted","type":"error"},{"inputs":[{"internalType":"Keycode","name":"keycode_","type":"bytes5"}],"name":"ModuleIsSunset","type":"error"},{"inputs":[{"internalType":"Keycode","name":"keycode_","type":"bytes5"},{"internalType":"uint8","name":"version_","type":"uint8"}],"name":"ModuleNotInstalled","type":"error"},{"inputs":[{"internalType":"address","name":"caller_","type":"address"}],"name":"NotPermitted","type":"error"},{"inputs":[{"internalType":"address","name":"target_","type":"address"}],"name":"TargetNotAContract","type":"error"},{"inputs":[{"internalType":"address","name":"token_","type":"address"}],"name":"UnsupportedToken","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Abort","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"Veecode","name":"auctionRef","type":"bytes7"}],"name":"AuctionCancelled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"Veecode","name":"auctionRef","type":"bytes7"},{"indexed":false,"internalType":"string","name":"infoHash","type":"string"}],"name":"AuctionCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"uint96","name":"bidId","type":"uint96"},{"indexed":true,"internalType":"address","name":"bidder","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Bid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"uint96","name":"bidId","type":"uint96"},{"indexed":true,"internalType":"address","name":"bidder","type":"address"}],"name":"ClaimBid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"address","name":"curator","type":"address"}],"name":"Curated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"Keycode","name":"keycode","type":"bytes5"},{"indexed":true,"internalType":"uint8","name":"version","type":"uint8"},{"indexed":true,"internalType":"address","name":"location","type":"address"}],"name":"ModuleInstalled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"Keycode","name":"keycode","type":"bytes5"}],"name":"ModuleSunset","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"uint96","name":"bidId","type":"uint96"},{"indexed":true,"internalType":"address","name":"bidder","type":"address"}],"name":"RefundBid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Settle","type":"event"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"abort","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"components":[{"internalType":"Keycode","name":"auctionType","type":"bytes5"},{"internalType":"address","name":"baseToken","type":"address"},{"internalType":"address","name":"quoteToken","type":"address"},{"internalType":"address","name":"curator","type":"address"},{"internalType":"uint48","name":"referrerFee","type":"uint48"},{"internalType":"contract ICallback","name":"callbacks","type":"address"},{"internalType":"bytes","name":"callbackData","type":"bytes"},{"internalType":"Keycode","name":"derivativeType","type":"bytes5"},{"internalType":"bytes","name":"derivativeParams","type":"bytes"},{"internalType":"bool","name":"wrapDerivative","type":"bool"}],"internalType":"struct IAuctionHouse.RoutingParams","name":"routing_","type":"tuple"},{"components":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"duration","type":"uint48"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"bytes","name":"implParams","type":"bytes"}],"internalType":"struct IAuction.AuctionParams","name":"params_","type":"tuple"},{"internalType":"string","name":"infoHash_","type":"string"}],"name":"auction","outputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"components":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"address","name":"bidder","type":"address"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes","name":"auctionData","type":"bytes"},{"internalType":"bytes","name":"permit2Data","type":"bytes"}],"internalType":"struct IBatchAuctionHouse.BidParams","name":"params_","type":"tuple"},{"internalType":"bytes","name":"callbackData_","type":"bytes"}],"name":"bid","outputs":[{"internalType":"uint64","name":"bidId","type":"uint64"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint48","name":"protocolFee_","type":"uint48"},{"internalType":"uint48","name":"referrerFee_","type":"uint48"},{"internalType":"bool","name":"hasReferrer_","type":"bool"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"calculateQuoteFees","outputs":[{"internalType":"uint256","name":"toReferrer","type":"uint256"},{"internalType":"uint256","name":"toProtocol","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"bytes","name":"callbackData_","type":"bytes"}],"name":"cancel","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64[]","name":"bidIds_","type":"uint64[]"}],"name":"claimBids","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token_","type":"address"}],"name":"claimRewards","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"Veecode","name":"auctionRef","type":"bytes7"},{"internalType":"Veecode","name":"derivativeRef","type":"bytes7"}],"name":"condensers","outputs":[{"internalType":"Veecode","name":"condenserRef","type":"bytes7"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"bytes","name":"callbackData_","type":"bytes"}],"name":"curate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"Veecode","name":"veecode_","type":"bytes7"},{"internalType":"bytes","name":"callData_","type":"bytes"}],"name":"execOnModule","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"Keycode","name":"","type":"bytes5"}],"name":"fees","outputs":[{"internalType":"uint48","name":"protocol","type":"uint48"},{"internalType":"uint48","name":"maxReferrerFee","type":"uint48"},{"internalType":"uint48","name":"maxCuratorFee","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getAuctionModuleForId","outputs":[{"internalType":"contract IAuction","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getBatchModuleForId","outputs":[{"internalType":"contract BatchAuctionModule","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"Keycode","name":"auctionType_","type":"bytes5"},{"internalType":"address","name":"curator_","type":"address"}],"name":"getCuratorFee","outputs":[{"internalType":"uint48","name":"curatorFee","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getDerivativeModuleForId","outputs":[{"internalType":"contract IDerivative","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"Keycode","name":"auctionType_","type":"bytes5"}],"name":"getFees","outputs":[{"internalType":"uint48","name":"protocol","type":"uint48"},{"internalType":"uint48","name":"maxReferrerFee","type":"uint48"},{"internalType":"uint48","name":"maxCuratorFee","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"Veecode","name":"","type":"bytes7"}],"name":"getModuleForVeecode","outputs":[{"internalType":"contract Module","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"Keycode","name":"","type":"bytes5"}],"name":"getModuleStatus","outputs":[{"internalType":"uint8","name":"latestVersion","type":"uint8"},{"internalType":"bool","name":"sunset","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getProtocol","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient_","type":"address"},{"internalType":"address","name":"token_","type":"address"}],"name":"getRewards","outputs":[{"internalType":"uint256","name":"reward","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"contract Module","name":"newModule_","type":"address"}],"name":"installModule","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isExecOnModule","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"lotCounter","outputs":[{"internalType":"uint96","name":"","type":"uint96"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"lotFees","outputs":[{"internalType":"address","name":"curator","type":"address"},{"internalType":"bool","name":"curated","type":"bool"},{"internalType":"uint48","name":"curatorFee","type":"uint48"},{"internalType":"uint48","name":"protocolFee","type":"uint48"},{"internalType":"uint48","name":"referrerFee","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"lotRouting","outputs":[{"internalType":"address","name":"seller","type":"address"},{"internalType":"address","name":"baseToken","type":"address"},{"internalType":"address","name":"quoteToken","type":"address"},{"internalType":"Veecode","name":"auctionReference","type":"bytes7"},{"internalType":"uint256","name":"funding","type":"uint256"},{"internalType":"contract ICallback","name":"callbacks","type":"address"},{"internalType":"Veecode","name":"derivativeReference","type":"bytes7"},{"internalType":"bool","name":"wrapDerivative","type":"bool"},{"internalType":"bytes","name":"derivativeParams","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"modules","outputs":[{"internalType":"Keycode","name":"","type":"bytes5"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"modulesCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"},{"internalType":"uint256","name":"index_","type":"uint256"}],"name":"refundBid","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"contract ERC20","name":"","type":"address"}],"name":"rewards","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"Veecode","name":"auctionRef_","type":"bytes7"},{"internalType":"Veecode","name":"derivativeRef_","type":"bytes7"},{"internalType":"Veecode","name":"condenserRef_","type":"bytes7"}],"name":"setCondenser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"Keycode","name":"auctionType_","type":"bytes5"},{"internalType":"uint48","name":"fee_","type":"uint48"}],"name":"setCuratorFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"Keycode","name":"auctionType_","type":"bytes5"},{"internalType":"enum IFeeManager.FeeType","name":"type_","type":"uint8"},{"internalType":"uint48","name":"fee_","type":"uint48"}],"name":"setFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"protocol_","type":"address"}],"name":"setProtocol","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint256","name":"num_","type":"uint256"},{"internalType":"bytes","name":"callbackData_","type":"bytes"}],"name":"settle","outputs":[{"internalType":"uint256","name":"totalIn","type":"uint256"},{"internalType":"uint256","name":"totalOut","type":"uint256"},{"internalType":"bool","name":"finished","type":"bool"},{"internalType":"bytes","name":"auctionOutput","type":"bytes"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"Keycode","name":"keycode_","type":"bytes5"}],"name":"sunsetModule","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"events":{"AuctionCancelled(uint96,bytes7)":{"params":{"auctionRef":"Auction module, represented by its Veecode","lotId":"ID of the auction lot"}},"AuctionCreated(uint96,bytes7,string)":{"params":{"auctionRef":"Auction module, represented by its Veecode","infoHash":"IPFS hash of the auction information","lotId":"ID of the auction lot"}},"Curated(uint96,address)":{"params":{"curator":"Address of the curator","lotId":"ID of the auction lot"}}},"kind":"dev","methods":{"abort(uint96)":{"details":"This function handles the following:             - Validates the lot id             - Aborts the auction on the auction module             - Refunds prefunding (in base tokens) to the seller             - Calls the onCancel callback             This function reverts if:             - The lot ID is invalid             - The auction module reverts when aborting the auction             - The refund amount is zero             Note that this function will not revert if the `onCancel` callback reverts.","params":{"lotId_":"The lot ID to abort"}},"auction((bytes5,address,address,address,uint48,address,bytes,bytes5,bytes,bool),(uint48,uint48,bool,uint256,bytes),string)":{"details":"This function performs the following:             - Validates the auction parameters             - Validates the auction module             - Validates the derivative module (if provided)             - Validates the callbacks contract (if provided)             - Stores the auction routing information             - Calls the auction module to store implementation-specific data             - Caches the fees for the lot             - Calls the implementation-specific auction function             - Calls the onCreate callback (if needed)             This function reverts if:             - The module for the auction type is not installed             - The auction type is sunset             - The base token or quote token decimals are not within the required range             - Validation for the auction parameters fails             - The module for the optional specified derivative type is not installed             - Validation for the optional specified derivative type fails             - Validation for the optional specified callbacks contract fails             - Re-entrancy is detected","params":{"infoHash_":"IPFS hash of the auction information","params_":"Auction parameters for the auction lot","routing_":"Routing information for the auction lot"},"returns":{"lotId":"      ID of the auction lot"}},"bid((uint96,address,address,uint256,bytes,bytes),bytes)":{"details":"This function performs the following:             - Validates the lot ID             - Records the bid on the auction module             - Transfers the quote token from the caller             - Calls the onBid callback             This function reverts if:             - `params_.lotId` is invalid             - The auction module reverts when creating a bid             - The quote token transfer fails             - Re-entrancy is detected","params":{"callbackData_":"Custom data provided to the onBid callback","params_":"Bid parameters"},"returns":{"bidId":"          Bid ID"}},"calculateQuoteFees(uint48,uint48,bool,uint256)":{"params":{"amount_":"Amount to calculate fees for","hasReferrer_":"Whether the auction has a referrer","protocolFee_":"Fee charged by the protocol","referrerFee_":"Fee charged by the referrer"},"returns":{"toProtocol":"   Amount to send to the protocol","toReferrer":"   Amount to send to the referrer"}},"cancel(uint96,bytes)":{"details":"This function performs the following:             - Checks that the lot ID is valid             - Checks that caller is the seller             - Calls the auction module to validate state, update records and determine the amount to be refunded             - Calls the implementation-specific logic for auction cancellation             - Calls the onCancel callback (if needed)             The function reverts if:             - The lot ID is invalid             - The caller is not the seller             - The respective auction module reverts             - Re-entrancy is detected","params":{"lotId_":"ID of the auction lot"}},"claimBids(uint96,uint64[])":{"details":"This function performs the following:             - Validates the lot ID             - Claims the bids on the auction module             - Allocates the fees for each successful bid             - Transfers the payout and/or refund to each bidder             This function reverts if:             - The lot ID is invalid             - The auction module reverts when claiming the bids             - Re-entrancy is detected","params":{"bidIds_":"Bid IDs","lotId_":"Lot ID"}},"claimRewards(address)":{"details":"This function reverts if:             - re-entrancy is detected","params":{"token_":"Token to claim rewards for"}},"curate(uint96,bytes)":{"details":"This function performs the following:             - Checks that the lot ID is valid             - Checks that the caller is the proposed curator             - Validates state             - Sets the curated state to true             - Calls the implementation-specific logic for curation             - Calls the onCurate callback (if needed)             This function reverts if:             - The lot ID is invalid             - The caller is not the proposed curator             - The auction has ended or is already curated             - Re-entrancy is detected","params":{"callbackData_":"(optional) abi-encoded data to be sent to the onCurate callback function","lotId_":"Lot ID"}},"execOnModule(bytes7,bytes)":{"details":"This function reverts if:- The caller is not the parent- The module is not installed- The call is made to a prohibited function- The call reverted","params":{"callData_":"The call data","veecode_":"The module Veecode"},"returns":{"_0":"The return data from the call"}},"getAuctionModuleForId(uint96)":{"details":"The function reverts if:             - The lot ID is invalid             - The module for the auction type is not installed","params":{"lotId_":"ID of the auction lot"},"returns":{"_0":" The auction module"}},"getCuratorFee(bytes5,address)":{"params":{"auctionType_":"Auction type to get fees for","curator_":"Curator to get fees for"},"returns":{"curatorFee":"   Fee charged by the curator"}},"getDerivativeModuleForId(uint96)":{"details":"The function reverts if:             - The lot ID is invalid             - The module for the derivative type is not installed","params":{"lotId_":"ID of the auction lot"},"returns":{"_0":" The derivative module"}},"getFees(bytes5)":{"params":{"auctionType_":"Auction type to get fees for"},"returns":{"maxCuratorFee":" Maximum fee that a curator can charge","maxReferrerFee":" Maximum fee that can be paid to a referrer","protocol":"      Fee charged by the protocol"}},"getRewards(address,address)":{"params":{"recipient_":"Recipient to get rewards for","token_":"Token to get rewards for"},"returns":{"reward":"     Reward amount"}},"installModule(address)":{"details":"The version of the installed module must be one greater than the latest version. If it\'s a new module, then the version must be 1.Only one version of a module is active for creation functions at a time. Older versions continue to work for existing data.If a module is currently sunset, installing a new version will remove the sunset.This function reverts if:- The caller is not the owner- The module is not a contract- The module has an invalid Veecode- The module (or other versions) is already installed- The module version is not one greater than the latest version","params":{"newModule_":"The new module"}},"refundBid(uint96,uint64,uint256)":{"details":"This function performs the following:             - Validates the lot ID             - Refunds the bid on the auction module             - Transfers the quote token to the bidder             This function reverts if:             - The lot ID is invalid             - The auction module reverts when cancelling the bid             - Re-entrancy is detected","params":{"bidId_":"Bid ID","index_":"Index of the bid in the auction\'s bid list","lotId_":"Lot ID"}},"setCondenser(bytes7,bytes7,bytes7)":{"details":"To remove a condenser, set the value of `condenserRef_` to a blank Veecode             This function will revert if:             - The caller is not the owner             - `auctionRef_` or `derivativeRef_` are empty             - `auctionRef_` does not belong to an auction module             - `derivativeRef_` does not belong to a derivative module             - `condenserRef_` does not belong to a condenser module","params":{"auctionRef_":"The auction type","condenserRef_":"The condenser type","derivativeRef_":"The derivative type"}},"setCuratorFee(bytes5,uint48)":{"params":{"auctionType_":"Auction type to set fees for","fee_":"Fee to charge"}},"setFee(bytes5,uint8,uint48)":{"details":"Implemented in this contract as it required access to the `onlyOwner` modifier","params":{"auctionType_":"Auction type to set fees for","fee_":"Fee to charge","type_":"Type of fee to set"}},"setProtocol(address)":{"details":"Implemented in this contract as it required access to the `onlyOwner` modifier","params":{"protocol_":"Address of the protocol"}},"settle(uint96,uint256,bytes)":{"details":"This function handles the following:             - Settles the auction on the auction module             - Sends proceeds and/or refund to the seller             - Executes the onSettle callback             - Allocates the curator fee to the curator             This function reverts if:             - The lot ID is invalid             - The auction module reverts when settling the auction             - Re-entrancy is detected","params":{"callbackData_":"Custom data provided to the onSettle callback","lotId_":"Lot ID","num_":"Number of bids to settle in this pass (capped at the remaining number if more is provided)"},"returns":{"auctionOutput":"  Custom data returned by the auction module","finished":"       Boolean indicating if the settlement was completed","totalIn":"        Total amount of quote tokens from bids that were filled","totalOut":"       Total amount of base tokens paid out to winning bids"}},"sunsetModule(bytes5)":{"details":"Sunset is used to disable a module type without installing a new one.This function reverts if:- The caller is not the owner- The module is not installed- The module is already sunset","params":{"keycode_":"The module keycode"}}},"title":"BatchAuctionHouse","version":1},"userdoc":{"errors":{"FailedCallback()":[{"notice":"thrown when a callback fails"}],"InvalidCallbackResponse()":[{"notice":"Callback did not return its selector"}],"NotPermitted(address)":[{"notice":"Used when the caller is not permitted to perform that action"}]},"events":{"AuctionCancelled(uint96,bytes7)":{"notice":"Emitted when an auction lot is cancelled"},"AuctionCreated(uint96,bytes7,string)":{"notice":"Emitted when a new auction lot is created"},"Curated(uint96,address)":{"notice":"Emitted when a curator accepts curation of an auction lot"}},"kind":"user","methods":{"abort(uint96)":{"notice":"Abort a batch auction that cannot be settled, refunding the seller and allowing bidders to claim refunds"},"auction((bytes5,address,address,address,uint48,address,bytes,bytes5,bytes,bool),(uint48,uint48,bool,uint256,bytes),string)":{"notice":"Creates a new auction lot"},"bid((uint96,address,address,uint256,bytes,bytes),bytes)":{"notice":"Bid on a lot in a batch auction"},"calculateQuoteFees(uint48,uint48,bool,uint256)":{"notice":"Calculates and allocates fees that are collected in the quote token"},"cancel(uint96,bytes)":{"notice":"Cancels an auction lot"},"claimBids(uint96,uint64[])":{"notice":"Claim bid payouts and/or refunds after a batch auction has settled"},"claimRewards(address)":{"notice":"Claims the rewards for a specific token and the sender"},"condensers(bytes7,bytes7)":{"notice":"Mapping auction and derivative references to the condenser that is used to pass data between them"},"curate(uint96,bytes)":{"notice":"Accept curation request for a lot.If the curator wishes to charge a fee, it must be set before this function is called.Access controlled. Must be proposed curator for lot."},"execOnModule(bytes7,bytes)":{"notice":"Performs a call on a moduleThis can be used to perform administrative functions on a module, such as setting parameters or calling permissioned functions"},"fees(bytes5)":{"notice":"Fees charged for each auction type"},"getAuctionModuleForId(uint96)":{"notice":"Gets the auction module for a given lot ID"},"getCuratorFee(bytes5,address)":{"notice":"Gets the fee for a specific auction type and curator"},"getDerivativeModuleForId(uint96)":{"notice":"Gets the derivative module for a given lot ID"},"getFees(bytes5)":{"notice":"Gets the fees for a specific auction type"},"getModuleForVeecode(bytes7)":{"notice":"Mapping of Veecode to Module address."},"getModuleStatus(bytes5)":{"notice":"Mapping of Keycode to module status information."},"getProtocol()":{"notice":"Gets the protocol address"},"getRewards(address,address)":{"notice":"Gets the rewards for a specific recipient and token"},"installModule(address)":{"notice":"Installs a module. Can be used to install a new module or upgrade an existing one."},"lotCounter()":{"notice":"The counter tracks the total number of auction lots"},"lotFees(uint96)":{"notice":"Mapping of lot IDs to their fee information"},"lotRouting(uint96)":{"notice":"Mapping of lot IDs to their routing information"},"modules(uint256)":{"notice":"Array of the Keycodes corresponding to the currently installed modules."},"modulesCount()":{"notice":"The number of modules installed."},"refundBid(uint96,uint64,uint256)":{"notice":"Refund a bid on a lot in a batch auction"},"rewards(address,address)":{"notice":"Fees earned by an address, by token"},"setCondenser(bytes7,bytes7,bytes7)":{"notice":"Sets the value of the Condenser for a given auction and derivative combination"},"setCuratorFee(bytes5,uint48)":{"notice":"Sets the fee for a curator (the sender) for a specific auction type"},"setFee(bytes5,uint8,uint48)":{"notice":"Sets the protocol fee, referrer fee, or max curator fee for a specific auction typeAccess controlled: only owner"},"setProtocol(address)":{"notice":"Sets the protocol address"},"settle(uint96,uint256,bytes)":{"notice":"Settle a batch auctionThis function is used for versions with on-chain storage of bids and settlement"},"sunsetModule(bytes5)":{"notice":"Sunsets a moduleSunsetting a module prevents future deployments that use the module, but functionality remains for existing users.Modules should implement functionality such that creation functions are disabled if sunset."}},"notice":"As its name implies, the BatchAuctionHouse is where batch auctions are created, bid on, and settled. The core protocol logic is implemented here.","version":1}},"settings":{"compilationTarget":{"src/BatchAuctionHouse.sol":"BatchAuctionHouse"},"evmVersion":"paris","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[":@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",":@prb/test/=lib/prb-math/node_modules/@prb/test/",":@uniswap/v3-core/=lib/uniswap-v3-core/",":ds-test/=lib/forge-std/lib/ds-test/src/",":erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",":forge-std/=lib/forge-std/src/",":g-uni-v1-core/=lib/g-uni-v1-core/contracts/",":openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/",":prb-math/=lib/prb-math/src/",":solady/=lib/solady/src/",":solmate/=lib/solmate/src/",":uniswap-v2-core/=lib/uniswap-v2-core/contracts/",":uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",":uniswap-v3-core/=lib/uniswap-v3-core/contracts/",":uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"]},"sources":{"lib/solmate/src/auth/Owned.sol":{"keccak256":"0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea","license":"AGPL-3.0-only","urls":["bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4","dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"]},"lib/solmate/src/tokens/ERC20.sol":{"keccak256":"0xcdfd8db76b2a3415620e4d18cc5545f3d50de792dbf2c3dd5adb40cbe6f94b10","license":"AGPL-3.0-only","urls":["bzz-raw://57b3ab70cde374af1cf2c9888636e8de6cf660f087b1c9abd805e9271e19fa35","dweb:/ipfs/QmNrLDBAHYFjpjSd12jerm1AdBkDqEYUUaXgnT854BUZ97"]},"lib/solmate/src/tokens/ERC6909.sol":{"keccak256":"0x767ed60e11d739ed7eb9e10467eb0e0573293238b7a2a56f96b23f145297f1d2","license":"MIT","urls":["bzz-raw://e5bc9f48d84ecc46f2627b2a91948f8060f78d2f548a6c5ca1f282f8778e01e0","dweb:/ipfs/QmeATtgjaDVhxcCs6auJrC8nqCwUqntTi3WygHVRa9xg6M"]},"lib/solmate/src/utils/FixedPointMathLib.sol":{"keccak256":"0x1b62af9baf5b8e991ed7531bc87f45550ba9d61e8dbff5caf237ccaf3a3fd843","license":"AGPL-3.0-only","urls":["bzz-raw://b7b38b977c5305b18ceefbeed4c9ceaaaefa419b520de62de6604ea661f8c0a9","dweb:/ipfs/QmecMRzgfMyDVa2pvBqMMDLYBappaj7Aa3qcMoQYEQrhWi"]},"lib/solmate/src/utils/ReentrancyGuard.sol":{"keccak256":"0xb282dd78aa7375d6b200b9a5d8dd214b2e5df1004f8217a4b4c2b07f0c5bfd01","license":"AGPL-3.0-only","urls":["bzz-raw://5fca62eb8d3dbd2b3b7e4bb051f6da16f4d0ff9cee61c39cebb80f031f6a8800","dweb:/ipfs/QmbrsXPK91iBFwHKwJs2HLRud2KzMoBDRiWYMUtyV5H57j"]},"lib/solmate/src/utils/SafeTransferLib.sol":{"keccak256":"0x6ab948013c2c7ca6351e593600425b0ec6df9035320280c678e735bce16e996b","license":"AGPL-3.0-only","urls":["bzz-raw://2ab977d0eeb2bf458f9798250215c646d2f3b1f90b5a7e2b506fdf3335c0f060","dweb:/ipfs/QmYPRoPhNtBAmCSq7imN1scMVpKNQvMTpoqab3tXUx5Tnv"]},"src/BatchAuctionHouse.sol":{"keccak256":"0x430127a37f4fb719c1da6ea658c4a2dcf37bfdb4475df54659c16ace579d51b0","license":"BSL-1.1","urls":["bzz-raw://e4458f3ab494658b9d6b2fb4e94c3e4bd7eeafc34db0fb240012d53032becac9","dweb:/ipfs/QmNvWhA6Dt1YAkT3qY6AU4dFwuM1qXmYuaqBhA9JJj1ZAt"]},"src/bases/AuctionHouse.sol":{"keccak256":"0x2afee1d10ba992a7f6f4dcb69ad3a1aacbf566b3867654d3c68bc520e1453d52","license":"BSL-1.1","urls":["bzz-raw://7ff2b9ae77404b1ce3e9d9d84e4336f1d8671b42ec57a1b92cdd18294b72db0b","dweb:/ipfs/QmX9GGcpmKXuag1Th9RCJjwaiXTmsBh6dUBJJonCAfz6L8"]},"src/bases/FeeManager.sol":{"keccak256":"0x3f459bf152ff2260948d134b813e7579f605c527b2fe5066f796cf45df2719f3","license":"BSL-1.1","urls":["bzz-raw://b9ded557c4ee2edf7d815453cad46014d43075c0e8ad1702bd7818d8c203517a","dweb:/ipfs/QmTz39VJTGcUVt3sQWSJtL7w7cT3RvZJEP8CFYKHFFkwMq"]},"src/interfaces/IAuctionHouse.sol":{"keccak256":"0xd027663074bc26c8f917f61288956a960d9f3f490789b68eb1e03b01c0dabdcc","license":"AGPL-3.0-or-later","urls":["bzz-raw://d7651f3ed6dce4a0212b74bca1dc1aca4750815597d3f1a86237d8468f4633b9","dweb:/ipfs/QmP3WSHZn8eGzjd7JzPNgHcEoj3TgXQfUe2WPw9LXtMDZg"]},"src/interfaces/IBatchAuctionHouse.sol":{"keccak256":"0x3bfd9e05921f5689650831bfe86babee7ad65616a76bfa3f0fe966f8c8f0028e","license":"AGPL-3.0-or-later","urls":["bzz-raw://834929e27973e1b97d05041c6753ae190996eaa5df376ed51237e56041d7af9f","dweb:/ipfs/QmYvXqGv17uBSXZ9YmqAjais7x16wYwS12bVrj36YWxBsm"]},"src/interfaces/ICallback.sol":{"keccak256":"0xb08760dc184fdf388679cbaf9b854e6d7d800825c71573ae0edbba9d1980fbb8","license":"MIT","urls":["bzz-raw://913a2ad19820fe53ab46dccf6a13127d189f7840ba6a522a6e5d5afdebca41da","dweb:/ipfs/QmSVSQxMYCsLX58utsHo1CzkRRy3YkYGpBbqKH6FLrUhas"]},"src/interfaces/IFeeManager.sol":{"keccak256":"0x7d2326b6735b775170a6da522351a2a288c3d107ef3a8370ee7e42649910421d","license":"AGPL-3.0-or-later","urls":["bzz-raw://cfde5ef0e4c485489479a5c6a291bb82ee3cc38b7bdbaeeef3754a7d32e4b0f8","dweb:/ipfs/QmR7c9xa5x8UJ49kuXvHam2W2CC891aQKNqS8omAEXnH4v"]},"src/interfaces/modules/IAuction.sol":{"keccak256":"0x7039157d051a619b63ce7988be07a43b77a46043f61c5ab4e531084084bcca01","license":"AGPL-3.0-or-later","urls":["bzz-raw://32e0093e843d08deada85cf2649d61aa6b37be858e4fdb32b81bfd2c0cf2c304","dweb:/ipfs/QmPEt15nwpXoBzin32wAQKfSBqcvPdkcgLRxiu3eiN1VFg"]},"src/interfaces/modules/IBatchAuction.sol":{"keccak256":"0xbe814e420085ee1f321fef8d89ddd6b4c668e967bff5eccfbfcc2c994393a02b","license":"AGPL-3.0-or-later","urls":["bzz-raw://c1cf24444584582d87de6df951a80f28da9e611a8118a3796051fcc5087747cc","dweb:/ipfs/QmQss5Fo8wuYoAgjNZYRTUqSEwHeV4SXCVJTQazbEo1aCw"]},"src/interfaces/modules/ICondenser.sol":{"keccak256":"0x3bb335a4426a17e2aaf48647d3c41293c3803872c93cdf4e489064936e63d9cd","license":"AGPL-3.0-or-later","urls":["bzz-raw://aaf82d18618e54e414999d916114ae9a0d103c764ac4a4665bed4c9ecc979e22","dweb:/ipfs/QmTAJYs4EEU6YfNBDGXf7vbExcsfne7hCXkhPXvG2oyxvH"]},"src/interfaces/modules/IDerivative.sol":{"keccak256":"0x953a79012815f4b3315303720b1758d3b6f3666174d5259849609bb1c11f948f","license":"AGPL-3.0-or-later","urls":["bzz-raw://1abc79c0a872cfb4eaf7cadf5794fd509aa401a86fd27bc4c78084f125164daf","dweb:/ipfs/QmSd58DqwwjnXehKFu9DLUFToTVHmWNWstnEMSZ1EX96Yd"]},"src/lib/Callbacks.sol":{"keccak256":"0xc3e2ce87dca53c20a0e013351f80549ed4821c7267963e87e39b0996ccf93836","license":"MIT","urls":["bzz-raw://0fd245ee2582d6ff35a24fd40b8c6c5ccd620dc5d813dcdea583fd4c18492feb","dweb:/ipfs/QmaixXjHYed69t9opaSYAkxP3eb3pigUxiJF79xQwb4vMi"]},"src/lib/ERC6909Metadata.sol":{"keccak256":"0x45cbf0d8d04f5628d34d7eb4bb5e13b7664b1ae03456f2ca2d2eb259d199f9e6","license":"UNLICENSED","urls":["bzz-raw://f7cfbc4fd542200d756f16457917157d838df10aa5f253f205d33a865ca6b0e6","dweb:/ipfs/QmTrgxTzer1yuvy4VoRkyMBtgigfq9kHU6xNHfy9J5Du11"]},"src/lib/Transfer.sol":{"keccak256":"0xd715c7cb14051b0b12feef58fdc8ffa9a99e825c51c994a630928f08a5b8f465","license":"AGPL-3.0-or-later","urls":["bzz-raw://11b7da9dd9b78a13fac23e2a9a53e946e02100ff1a97adf2efdc252df2d49aff","dweb:/ipfs/QmUfiSSJYaWYuhxezZNQjvtZDwtTtCcKQVDJZxHzxhyvDw"]},"src/lib/permit2/interfaces/IPermit2.sol":{"keccak256":"0x240e896f81a7c9574930db416bb25e58a321b5949cfa840f3d183bd8fef72da9","license":"MIT","urls":["bzz-raw://97cb0d04e9fa3b11c5b38f7b645e1c6ff149b5af225a6a209993f2590a42a67e","dweb:/ipfs/QmSN7Dau9dzMA47SPf5pWRRDDdYKW8RhXcmUbmaguSvGQL"]},"src/modules/Auction.sol":{"keccak256":"0x4abc2212016836dbef38428b3a938d299b0f01e8b17b6d13ab86207439fdfd10","license":"BSL-1.1","urls":["bzz-raw://43debb1e08d7f9b4f0a8adfbd982cda068ad934eea123e0dad1a235d8a8c9ce3","dweb:/ipfs/QmZfe5VNfsa79pFt9TUogrbV2dAvpCpW4VWfpAhQiowGLC"]},"src/modules/Condenser.sol":{"keccak256":"0x0eeb0738b78b8b5947a667e64d95e02139ea1cbfbc14b590d23a3d5d320a132b","license":"BSL-1.1","urls":["bzz-raw://f35e32dbe42be81eac514ea392a16ee0ffd3c1ce6e314298233ea31852cd29cd","dweb:/ipfs/QmUoM2MuLpbmWjkFBM8Sm5n1EreDAkWZpDEDWZht7gF5kQ"]},"src/modules/Derivative.sol":{"keccak256":"0x35e7d822254ccf75e0216b8783dfd8c9a431eaa40a90c1254635f161646573e0","license":"BSL-1.1","urls":["bzz-raw://83e5ac5f6f4c0e339841cefc19fc2aec65951dd1b8a3000819d8d9a344964f58","dweb:/ipfs/QmRW2xsdfc8zHvr2XWXK5n2rxnpqYxD9rBwJ9eLWWSrYMP"]},"src/modules/Keycode.sol":{"keccak256":"0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e","license":"AGPL-3.0-or-later","urls":["bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd","dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"]},"src/modules/Modules.sol":{"keccak256":"0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689","license":"AGPL-3.0-or-later","urls":["bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee","dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"]},"src/modules/auctions/BatchAuctionModule.sol":{"keccak256":"0x7fd51c1ba66d2ee5988f96391983d7ac3ce14aa282b56affba69cc55de3f8907","license":"BSL-1.1","urls":["bzz-raw://cb7c98b9a308f6ba21be2cc56398fc719df9a5e0a731f56f49b66213a9476085","dweb:/ipfs/QmWU8pW8AKL3tvfL4EZTRxpkCtvGGwLNDpuFCYauCVjnXf"]}},"version":1}',
  metadata: {
    compiler: {
      version: "0.8.19+commit.7dd6d404"
    },
    language: "Solidity",
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "owner_",
              type: "address"
            },
            {
              internalType: "address",
              name: "protocol_",
              type: "address"
            },
            {
              internalType: "address",
              name: "permit2_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "constructor"
        },
        {
          inputs: [],
          type: "error",
          name: "AmountLessThanMinimum"
        },
        {
          inputs: [],
          type: "error",
          name: "FailedCallback"
        },
        {
          inputs: [],
          type: "error",
          name: "InsufficientFunding"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidCallback"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidCallbackResponse"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidFee"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "id_",
              type: "uint96"
            }
          ],
          type: "error",
          name: "InvalidLotId"
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode_",
              type: "bytes5"
            },
            {
              internalType: "uint8",
              name: "version_",
              type: "uint8"
            }
          ],
          type: "error",
          name: "InvalidModuleInstall"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidParams"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidParams"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidState"
        },
        {
          inputs: [
            {
              internalType: "Veecode",
              name: "veecode_",
              type: "bytes7"
            }
          ],
          type: "error",
          name: "InvalidVeecode"
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode_",
              type: "bytes5"
            }
          ],
          type: "error",
          name: "ModuleAlreadySunset"
        },
        {
          inputs: [
            {
              internalType: "bytes",
              name: "error_",
              type: "bytes"
            }
          ],
          type: "error",
          name: "ModuleExecutionReverted"
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode_",
              type: "bytes5"
            }
          ],
          type: "error",
          name: "ModuleIsSunset"
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode_",
              type: "bytes5"
            },
            {
              internalType: "uint8",
              name: "version_",
              type: "uint8"
            }
          ],
          type: "error",
          name: "ModuleNotInstalled"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller_",
              type: "address"
            }
          ],
          type: "error",
          name: "NotPermitted"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "target_",
              type: "address"
            }
          ],
          type: "error",
          name: "TargetNotAContract"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "token_",
              type: "address"
            }
          ],
          type: "error",
          name: "UnsupportedToken"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            }
          ],
          type: "event",
          name: "Abort",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "Veecode",
              name: "auctionRef",
              type: "bytes7",
              indexed: true
            }
          ],
          type: "event",
          name: "AuctionCancelled",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "Veecode",
              name: "auctionRef",
              type: "bytes7",
              indexed: true
            },
            {
              internalType: "string",
              name: "infoHash",
              type: "string",
              indexed: false
            }
          ],
          type: "event",
          name: "AuctionCreated",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "uint96",
              name: "bidId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "address",
              name: "bidder",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            }
          ],
          type: "event",
          name: "Bid",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "uint96",
              name: "bidId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "address",
              name: "bidder",
              type: "address",
              indexed: true
            }
          ],
          type: "event",
          name: "ClaimBid",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "address",
              name: "curator",
              type: "address",
              indexed: true
            }
          ],
          type: "event",
          name: "Curated",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode",
              type: "bytes5",
              indexed: true
            },
            {
              internalType: "uint8",
              name: "version",
              type: "uint8",
              indexed: true
            },
            {
              internalType: "address",
              name: "location",
              type: "address",
              indexed: true
            }
          ],
          type: "event",
          name: "ModuleInstalled",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode",
              type: "bytes5",
              indexed: true
            }
          ],
          type: "event",
          name: "ModuleSunset",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "user",
              type: "address",
              indexed: true
            },
            {
              internalType: "address",
              name: "newOwner",
              type: "address",
              indexed: true
            }
          ],
          type: "event",
          name: "OwnershipTransferred",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "uint96",
              name: "bidId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "address",
              name: "bidder",
              type: "address",
              indexed: true
            }
          ],
          type: "event",
          name: "RefundBid",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            }
          ],
          type: "event",
          name: "Settle",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "abort"
        },
        {
          inputs: [
            {
              internalType: "struct IAuctionHouse.RoutingParams",
              name: "routing_",
              type: "tuple",
              components: [
                {
                  internalType: "Keycode",
                  name: "auctionType",
                  type: "bytes5"
                },
                {
                  internalType: "address",
                  name: "baseToken",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "quoteToken",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "curator",
                  type: "address"
                },
                {
                  internalType: "uint48",
                  name: "referrerFee",
                  type: "uint48"
                },
                {
                  internalType: "contract ICallback",
                  name: "callbacks",
                  type: "address"
                },
                {
                  internalType: "bytes",
                  name: "callbackData",
                  type: "bytes"
                },
                {
                  internalType: "Keycode",
                  name: "derivativeType",
                  type: "bytes5"
                },
                {
                  internalType: "bytes",
                  name: "derivativeParams",
                  type: "bytes"
                },
                {
                  internalType: "bool",
                  name: "wrapDerivative",
                  type: "bool"
                }
              ]
            },
            {
              internalType: "struct IAuction.AuctionParams",
              name: "params_",
              type: "tuple",
              components: [
                {
                  internalType: "uint48",
                  name: "start",
                  type: "uint48"
                },
                {
                  internalType: "uint48",
                  name: "duration",
                  type: "uint48"
                },
                {
                  internalType: "bool",
                  name: "capacityInQuote",
                  type: "bool"
                },
                {
                  internalType: "uint256",
                  name: "capacity",
                  type: "uint256"
                },
                {
                  internalType: "bytes",
                  name: "implParams",
                  type: "bytes"
                }
              ]
            },
            {
              internalType: "string",
              name: "infoHash_",
              type: "string"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "auction",
          outputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "struct IBatchAuctionHouse.BidParams",
              name: "params_",
              type: "tuple",
              components: [
                {
                  internalType: "uint96",
                  name: "lotId",
                  type: "uint96"
                },
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "uint256",
                  name: "amount",
                  type: "uint256"
                },
                {
                  internalType: "bytes",
                  name: "auctionData",
                  type: "bytes"
                },
                {
                  internalType: "bytes",
                  name: "permit2Data",
                  type: "bytes"
                }
              ]
            },
            {
              internalType: "bytes",
              name: "callbackData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "bid",
          outputs: [
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "protocolFee_",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "referrerFee_",
              type: "uint48"
            },
            {
              internalType: "bool",
              name: "hasReferrer_",
              type: "bool"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            }
          ],
          stateMutability: "pure",
          type: "function",
          name: "calculateQuoteFees",
          outputs: [
            {
              internalType: "uint256",
              name: "toReferrer",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "toProtocol",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "bytes",
              name: "callbackData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "cancel"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64[]",
              name: "bidIds_",
              type: "uint64[]"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "claimBids"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "token_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "claimRewards"
        },
        {
          inputs: [
            {
              internalType: "Veecode",
              name: "auctionRef",
              type: "bytes7"
            },
            {
              internalType: "Veecode",
              name: "derivativeRef",
              type: "bytes7"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "condensers",
          outputs: [
            {
              internalType: "Veecode",
              name: "condenserRef",
              type: "bytes7"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "bytes",
              name: "callbackData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "curate"
        },
        {
          inputs: [
            {
              internalType: "Veecode",
              name: "veecode_",
              type: "bytes7"
            },
            {
              internalType: "bytes",
              name: "callData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "execOnModule",
          outputs: [
            {
              internalType: "bytes",
              name: "",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "",
              type: "bytes5"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "fees",
          outputs: [
            {
              internalType: "uint48",
              name: "protocol",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "maxReferrerFee",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "maxCuratorFee",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getAuctionModuleForId",
          outputs: [
            {
              internalType: "contract IAuction",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBatchModuleForId",
          outputs: [
            {
              internalType: "contract BatchAuctionModule",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "auctionType_",
              type: "bytes5"
            },
            {
              internalType: "address",
              name: "curator_",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getCuratorFee",
          outputs: [
            {
              internalType: "uint48",
              name: "curatorFee",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getDerivativeModuleForId",
          outputs: [
            {
              internalType: "contract IDerivative",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "auctionType_",
              type: "bytes5"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getFees",
          outputs: [
            {
              internalType: "uint48",
              name: "protocol",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "maxReferrerFee",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "maxCuratorFee",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Veecode",
              name: "",
              type: "bytes7"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getModuleForVeecode",
          outputs: [
            {
              internalType: "contract Module",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "",
              type: "bytes5"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getModuleStatus",
          outputs: [
            {
              internalType: "uint8",
              name: "latestVersion",
              type: "uint8"
            },
            {
              internalType: "bool",
              name: "sunset",
              type: "bool"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "getProtocol",
          outputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "recipient_",
              type: "address"
            },
            {
              internalType: "address",
              name: "token_",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getRewards",
          outputs: [
            {
              internalType: "uint256",
              name: "reward",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "contract Module",
              name: "newModule_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "installModule"
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "isExecOnModule",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "lotCounter",
          outputs: [
            {
              internalType: "uint96",
              name: "",
              type: "uint96"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "lotFees",
          outputs: [
            {
              internalType: "address",
              name: "curator",
              type: "address"
            },
            {
              internalType: "bool",
              name: "curated",
              type: "bool"
            },
            {
              internalType: "uint48",
              name: "curatorFee",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "protocolFee",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "referrerFee",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "lotRouting",
          outputs: [
            {
              internalType: "address",
              name: "seller",
              type: "address"
            },
            {
              internalType: "address",
              name: "baseToken",
              type: "address"
            },
            {
              internalType: "address",
              name: "quoteToken",
              type: "address"
            },
            {
              internalType: "Veecode",
              name: "auctionReference",
              type: "bytes7"
            },
            {
              internalType: "uint256",
              name: "funding",
              type: "uint256"
            },
            {
              internalType: "contract ICallback",
              name: "callbacks",
              type: "address"
            },
            {
              internalType: "Veecode",
              name: "derivativeReference",
              type: "bytes7"
            },
            {
              internalType: "bool",
              name: "wrapDerivative",
              type: "bool"
            },
            {
              internalType: "bytes",
              name: "derivativeParams",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "modules",
          outputs: [
            {
              internalType: "Keycode",
              name: "",
              type: "bytes5"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "modulesCount",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "owner",
          outputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            },
            {
              internalType: "uint256",
              name: "index_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "refundBid"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "contract ERC20",
              name: "",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "rewards",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Veecode",
              name: "auctionRef_",
              type: "bytes7"
            },
            {
              internalType: "Veecode",
              name: "derivativeRef_",
              type: "bytes7"
            },
            {
              internalType: "Veecode",
              name: "condenserRef_",
              type: "bytes7"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setCondenser"
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "auctionType_",
              type: "bytes5"
            },
            {
              internalType: "uint48",
              name: "fee_",
              type: "uint48"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setCuratorFee"
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "auctionType_",
              type: "bytes5"
            },
            {
              internalType: "enum IFeeManager.FeeType",
              name: "type_",
              type: "uint8"
            },
            {
              internalType: "uint48",
              name: "fee_",
              type: "uint48"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setFee"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "protocol_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setProtocol"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "num_",
              type: "uint256"
            },
            {
              internalType: "bytes",
              name: "callbackData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "settle",
          outputs: [
            {
              internalType: "uint256",
              name: "totalIn",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "totalOut",
              type: "uint256"
            },
            {
              internalType: "bool",
              name: "finished",
              type: "bool"
            },
            {
              internalType: "bytes",
              name: "auctionOutput",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "Keycode",
              name: "keycode_",
              type: "bytes5"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "sunsetModule"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "newOwner",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "transferOwnership"
        }
      ],
      devdoc: {
        kind: "dev",
        methods: {
          "abort(uint96)": {
            details: "This function handles the following:             - Validates the lot id             - Aborts the auction on the auction module             - Refunds prefunding (in base tokens) to the seller             - Calls the onCancel callback             This function reverts if:             - The lot ID is invalid             - The auction module reverts when aborting the auction             - The refund amount is zero             Note that this function will not revert if the `onCancel` callback reverts.",
            params: {
              lotId_: "The lot ID to abort"
            }
          },
          "auction((bytes5,address,address,address,uint48,address,bytes,bytes5,bytes,bool),(uint48,uint48,bool,uint256,bytes),string)": {
            details: "This function performs the following:             - Validates the auction parameters             - Validates the auction module             - Validates the derivative module (if provided)             - Validates the callbacks contract (if provided)             - Stores the auction routing information             - Calls the auction module to store implementation-specific data             - Caches the fees for the lot             - Calls the implementation-specific auction function             - Calls the onCreate callback (if needed)             This function reverts if:             - The module for the auction type is not installed             - The auction type is sunset             - The base token or quote token decimals are not within the required range             - Validation for the auction parameters fails             - The module for the optional specified derivative type is not installed             - Validation for the optional specified derivative type fails             - Validation for the optional specified callbacks contract fails             - Re-entrancy is detected",
            params: {
              infoHash_: "IPFS hash of the auction information",
              params_: "Auction parameters for the auction lot",
              routing_: "Routing information for the auction lot"
            },
            returns: {
              lotId: "      ID of the auction lot"
            }
          },
          "bid((uint96,address,address,uint256,bytes,bytes),bytes)": {
            details: "This function performs the following:             - Validates the lot ID             - Records the bid on the auction module             - Transfers the quote token from the caller             - Calls the onBid callback             This function reverts if:             - `params_.lotId` is invalid             - The auction module reverts when creating a bid             - The quote token transfer fails             - Re-entrancy is detected",
            params: {
              callbackData_: "Custom data provided to the onBid callback",
              params_: "Bid parameters"
            },
            returns: {
              bidId: "          Bid ID"
            }
          },
          "calculateQuoteFees(uint48,uint48,bool,uint256)": {
            params: {
              amount_: "Amount to calculate fees for",
              hasReferrer_: "Whether the auction has a referrer",
              protocolFee_: "Fee charged by the protocol",
              referrerFee_: "Fee charged by the referrer"
            },
            returns: {
              toProtocol: "   Amount to send to the protocol",
              toReferrer: "   Amount to send to the referrer"
            }
          },
          "cancel(uint96,bytes)": {
            details: "This function performs the following:             - Checks that the lot ID is valid             - Checks that caller is the seller             - Calls the auction module to validate state, update records and determine the amount to be refunded             - Calls the implementation-specific logic for auction cancellation             - Calls the onCancel callback (if needed)             The function reverts if:             - The lot ID is invalid             - The caller is not the seller             - The respective auction module reverts             - Re-entrancy is detected",
            params: {
              lotId_: "ID of the auction lot"
            }
          },
          "claimBids(uint96,uint64[])": {
            details: "This function performs the following:             - Validates the lot ID             - Claims the bids on the auction module             - Allocates the fees for each successful bid             - Transfers the payout and/or refund to each bidder             This function reverts if:             - The lot ID is invalid             - The auction module reverts when claiming the bids             - Re-entrancy is detected",
            params: {
              bidIds_: "Bid IDs",
              lotId_: "Lot ID"
            }
          },
          "claimRewards(address)": {
            details: "This function reverts if:             - re-entrancy is detected",
            params: {
              token_: "Token to claim rewards for"
            }
          },
          "curate(uint96,bytes)": {
            details: "This function performs the following:             - Checks that the lot ID is valid             - Checks that the caller is the proposed curator             - Validates state             - Sets the curated state to true             - Calls the implementation-specific logic for curation             - Calls the onCurate callback (if needed)             This function reverts if:             - The lot ID is invalid             - The caller is not the proposed curator             - The auction has ended or is already curated             - Re-entrancy is detected",
            params: {
              callbackData_: "(optional) abi-encoded data to be sent to the onCurate callback function",
              lotId_: "Lot ID"
            }
          },
          "execOnModule(bytes7,bytes)": {
            details: "This function reverts if:- The caller is not the parent- The module is not installed- The call is made to a prohibited function- The call reverted",
            params: {
              callData_: "The call data",
              veecode_: "The module Veecode"
            },
            returns: {
              _0: "The return data from the call"
            }
          },
          "getAuctionModuleForId(uint96)": {
            details: "The function reverts if:             - The lot ID is invalid             - The module for the auction type is not installed",
            params: {
              lotId_: "ID of the auction lot"
            },
            returns: {
              _0: " The auction module"
            }
          },
          "getCuratorFee(bytes5,address)": {
            params: {
              auctionType_: "Auction type to get fees for",
              curator_: "Curator to get fees for"
            },
            returns: {
              curatorFee: "   Fee charged by the curator"
            }
          },
          "getDerivativeModuleForId(uint96)": {
            details: "The function reverts if:             - The lot ID is invalid             - The module for the derivative type is not installed",
            params: {
              lotId_: "ID of the auction lot"
            },
            returns: {
              _0: " The derivative module"
            }
          },
          "getFees(bytes5)": {
            params: {
              auctionType_: "Auction type to get fees for"
            },
            returns: {
              maxCuratorFee: " Maximum fee that a curator can charge",
              maxReferrerFee: " Maximum fee that can be paid to a referrer",
              protocol: "      Fee charged by the protocol"
            }
          },
          "getRewards(address,address)": {
            params: {
              recipient_: "Recipient to get rewards for",
              token_: "Token to get rewards for"
            },
            returns: {
              reward: "     Reward amount"
            }
          },
          "installModule(address)": {
            details: "The version of the installed module must be one greater than the latest version. If it's a new module, then the version must be 1.Only one version of a module is active for creation functions at a time. Older versions continue to work for existing data.If a module is currently sunset, installing a new version will remove the sunset.This function reverts if:- The caller is not the owner- The module is not a contract- The module has an invalid Veecode- The module (or other versions) is already installed- The module version is not one greater than the latest version",
            params: {
              newModule_: "The new module"
            }
          },
          "refundBid(uint96,uint64,uint256)": {
            details: "This function performs the following:             - Validates the lot ID             - Refunds the bid on the auction module             - Transfers the quote token to the bidder             This function reverts if:             - The lot ID is invalid             - The auction module reverts when cancelling the bid             - Re-entrancy is detected",
            params: {
              bidId_: "Bid ID",
              index_: "Index of the bid in the auction's bid list",
              lotId_: "Lot ID"
            }
          },
          "setCondenser(bytes7,bytes7,bytes7)": {
            details: "To remove a condenser, set the value of `condenserRef_` to a blank Veecode             This function will revert if:             - The caller is not the owner             - `auctionRef_` or `derivativeRef_` are empty             - `auctionRef_` does not belong to an auction module             - `derivativeRef_` does not belong to a derivative module             - `condenserRef_` does not belong to a condenser module",
            params: {
              auctionRef_: "The auction type",
              condenserRef_: "The condenser type",
              derivativeRef_: "The derivative type"
            }
          },
          "setCuratorFee(bytes5,uint48)": {
            params: {
              auctionType_: "Auction type to set fees for",
              fee_: "Fee to charge"
            }
          },
          "setFee(bytes5,uint8,uint48)": {
            details: "Implemented in this contract as it required access to the `onlyOwner` modifier",
            params: {
              auctionType_: "Auction type to set fees for",
              fee_: "Fee to charge",
              type_: "Type of fee to set"
            }
          },
          "setProtocol(address)": {
            details: "Implemented in this contract as it required access to the `onlyOwner` modifier",
            params: {
              protocol_: "Address of the protocol"
            }
          },
          "settle(uint96,uint256,bytes)": {
            details: "This function handles the following:             - Settles the auction on the auction module             - Sends proceeds and/or refund to the seller             - Executes the onSettle callback             - Allocates the curator fee to the curator             This function reverts if:             - The lot ID is invalid             - The auction module reverts when settling the auction             - Re-entrancy is detected",
            params: {
              callbackData_: "Custom data provided to the onSettle callback",
              lotId_: "Lot ID",
              num_: "Number of bids to settle in this pass (capped at the remaining number if more is provided)"
            },
            returns: {
              auctionOutput: "  Custom data returned by the auction module",
              finished: "       Boolean indicating if the settlement was completed",
              totalIn: "        Total amount of quote tokens from bids that were filled",
              totalOut: "       Total amount of base tokens paid out to winning bids"
            }
          },
          "sunsetModule(bytes5)": {
            details: "Sunset is used to disable a module type without installing a new one.This function reverts if:- The caller is not the owner- The module is not installed- The module is already sunset",
            params: {
              keycode_: "The module keycode"
            }
          }
        },
        version: 1
      },
      userdoc: {
        kind: "user",
        methods: {
          "abort(uint96)": {
            notice: "Abort a batch auction that cannot be settled, refunding the seller and allowing bidders to claim refunds"
          },
          "auction((bytes5,address,address,address,uint48,address,bytes,bytes5,bytes,bool),(uint48,uint48,bool,uint256,bytes),string)": {
            notice: "Creates a new auction lot"
          },
          "bid((uint96,address,address,uint256,bytes,bytes),bytes)": {
            notice: "Bid on a lot in a batch auction"
          },
          "calculateQuoteFees(uint48,uint48,bool,uint256)": {
            notice: "Calculates and allocates fees that are collected in the quote token"
          },
          "cancel(uint96,bytes)": {
            notice: "Cancels an auction lot"
          },
          "claimBids(uint96,uint64[])": {
            notice: "Claim bid payouts and/or refunds after a batch auction has settled"
          },
          "claimRewards(address)": {
            notice: "Claims the rewards for a specific token and the sender"
          },
          "condensers(bytes7,bytes7)": {
            notice: "Mapping auction and derivative references to the condenser that is used to pass data between them"
          },
          "curate(uint96,bytes)": {
            notice: "Accept curation request for a lot.If the curator wishes to charge a fee, it must be set before this function is called.Access controlled. Must be proposed curator for lot."
          },
          "execOnModule(bytes7,bytes)": {
            notice: "Performs a call on a moduleThis can be used to perform administrative functions on a module, such as setting parameters or calling permissioned functions"
          },
          "fees(bytes5)": {
            notice: "Fees charged for each auction type"
          },
          "getAuctionModuleForId(uint96)": {
            notice: "Gets the auction module for a given lot ID"
          },
          "getCuratorFee(bytes5,address)": {
            notice: "Gets the fee for a specific auction type and curator"
          },
          "getDerivativeModuleForId(uint96)": {
            notice: "Gets the derivative module for a given lot ID"
          },
          "getFees(bytes5)": {
            notice: "Gets the fees for a specific auction type"
          },
          "getModuleForVeecode(bytes7)": {
            notice: "Mapping of Veecode to Module address."
          },
          "getModuleStatus(bytes5)": {
            notice: "Mapping of Keycode to module status information."
          },
          "getProtocol()": {
            notice: "Gets the protocol address"
          },
          "getRewards(address,address)": {
            notice: "Gets the rewards for a specific recipient and token"
          },
          "installModule(address)": {
            notice: "Installs a module. Can be used to install a new module or upgrade an existing one."
          },
          "lotCounter()": {
            notice: "The counter tracks the total number of auction lots"
          },
          "lotFees(uint96)": {
            notice: "Mapping of lot IDs to their fee information"
          },
          "lotRouting(uint96)": {
            notice: "Mapping of lot IDs to their routing information"
          },
          "modules(uint256)": {
            notice: "Array of the Keycodes corresponding to the currently installed modules."
          },
          "modulesCount()": {
            notice: "The number of modules installed."
          },
          "refundBid(uint96,uint64,uint256)": {
            notice: "Refund a bid on a lot in a batch auction"
          },
          "rewards(address,address)": {
            notice: "Fees earned by an address, by token"
          },
          "setCondenser(bytes7,bytes7,bytes7)": {
            notice: "Sets the value of the Condenser for a given auction and derivative combination"
          },
          "setCuratorFee(bytes5,uint48)": {
            notice: "Sets the fee for a curator (the sender) for a specific auction type"
          },
          "setFee(bytes5,uint8,uint48)": {
            notice: "Sets the protocol fee, referrer fee, or max curator fee for a specific auction typeAccess controlled: only owner"
          },
          "setProtocol(address)": {
            notice: "Sets the protocol address"
          },
          "settle(uint96,uint256,bytes)": {
            notice: "Settle a batch auctionThis function is used for versions with on-chain storage of bids and settlement"
          },
          "sunsetModule(bytes5)": {
            notice: "Sunsets a moduleSunsetting a module prevents future deployments that use the module, but functionality remains for existing users.Modules should implement functionality such that creation functions are disabled if sunset."
          }
        },
        version: 1
      }
    },
    settings: {
      remappings: [
        "@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",
        "@prb/test/=lib/prb-math/node_modules/@prb/test/",
        "@uniswap/v3-core/=lib/uniswap-v3-core/",
        "ds-test/=lib/forge-std/lib/ds-test/src/",
        "erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",
        "forge-std/=lib/forge-std/src/",
        "g-uni-v1-core/=lib/g-uni-v1-core/contracts/",
        "openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "openzeppelin-contracts/=lib/openzeppelin-contracts/",
        "openzeppelin/=lib/openzeppelin-contracts/contracts/",
        "prb-math/=lib/prb-math/src/",
        "solady/=lib/solady/src/",
        "solmate/=lib/solmate/src/",
        "uniswap-v2-core/=lib/uniswap-v2-core/contracts/",
        "uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",
        "uniswap-v3-core/=lib/uniswap-v3-core/contracts/",
        "uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"
      ],
      optimizer: {
        enabled: true,
        runs: 200
      },
      metadata: {
        bytecodeHash: "ipfs"
      },
      compilationTarget: {
        "src/BatchAuctionHouse.sol": "BatchAuctionHouse"
      },
      evmVersion: "paris",
      libraries: {}
    },
    sources: {
      "lib/solmate/src/auth/Owned.sol": {
        keccak256: "0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea",
        urls: [
          "bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4",
          "dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/tokens/ERC20.sol": {
        keccak256: "0xcdfd8db76b2a3415620e4d18cc5545f3d50de792dbf2c3dd5adb40cbe6f94b10",
        urls: [
          "bzz-raw://57b3ab70cde374af1cf2c9888636e8de6cf660f087b1c9abd805e9271e19fa35",
          "dweb:/ipfs/QmNrLDBAHYFjpjSd12jerm1AdBkDqEYUUaXgnT854BUZ97"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/tokens/ERC6909.sol": {
        keccak256: "0x767ed60e11d739ed7eb9e10467eb0e0573293238b7a2a56f96b23f145297f1d2",
        urls: [
          "bzz-raw://e5bc9f48d84ecc46f2627b2a91948f8060f78d2f548a6c5ca1f282f8778e01e0",
          "dweb:/ipfs/QmeATtgjaDVhxcCs6auJrC8nqCwUqntTi3WygHVRa9xg6M"
        ],
        license: "MIT"
      },
      "lib/solmate/src/utils/FixedPointMathLib.sol": {
        keccak256: "0x1b62af9baf5b8e991ed7531bc87f45550ba9d61e8dbff5caf237ccaf3a3fd843",
        urls: [
          "bzz-raw://b7b38b977c5305b18ceefbeed4c9ceaaaefa419b520de62de6604ea661f8c0a9",
          "dweb:/ipfs/QmecMRzgfMyDVa2pvBqMMDLYBappaj7Aa3qcMoQYEQrhWi"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/utils/ReentrancyGuard.sol": {
        keccak256: "0xb282dd78aa7375d6b200b9a5d8dd214b2e5df1004f8217a4b4c2b07f0c5bfd01",
        urls: [
          "bzz-raw://5fca62eb8d3dbd2b3b7e4bb051f6da16f4d0ff9cee61c39cebb80f031f6a8800",
          "dweb:/ipfs/QmbrsXPK91iBFwHKwJs2HLRud2KzMoBDRiWYMUtyV5H57j"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/utils/SafeTransferLib.sol": {
        keccak256: "0x6ab948013c2c7ca6351e593600425b0ec6df9035320280c678e735bce16e996b",
        urls: [
          "bzz-raw://2ab977d0eeb2bf458f9798250215c646d2f3b1f90b5a7e2b506fdf3335c0f060",
          "dweb:/ipfs/QmYPRoPhNtBAmCSq7imN1scMVpKNQvMTpoqab3tXUx5Tnv"
        ],
        license: "AGPL-3.0-only"
      },
      "src/BatchAuctionHouse.sol": {
        keccak256: "0x430127a37f4fb719c1da6ea658c4a2dcf37bfdb4475df54659c16ace579d51b0",
        urls: [
          "bzz-raw://e4458f3ab494658b9d6b2fb4e94c3e4bd7eeafc34db0fb240012d53032becac9",
          "dweb:/ipfs/QmNvWhA6Dt1YAkT3qY6AU4dFwuM1qXmYuaqBhA9JJj1ZAt"
        ],
        license: "BSL-1.1"
      },
      "src/bases/AuctionHouse.sol": {
        keccak256: "0x2afee1d10ba992a7f6f4dcb69ad3a1aacbf566b3867654d3c68bc520e1453d52",
        urls: [
          "bzz-raw://7ff2b9ae77404b1ce3e9d9d84e4336f1d8671b42ec57a1b92cdd18294b72db0b",
          "dweb:/ipfs/QmX9GGcpmKXuag1Th9RCJjwaiXTmsBh6dUBJJonCAfz6L8"
        ],
        license: "BSL-1.1"
      },
      "src/bases/FeeManager.sol": {
        keccak256: "0x3f459bf152ff2260948d134b813e7579f605c527b2fe5066f796cf45df2719f3",
        urls: [
          "bzz-raw://b9ded557c4ee2edf7d815453cad46014d43075c0e8ad1702bd7818d8c203517a",
          "dweb:/ipfs/QmTz39VJTGcUVt3sQWSJtL7w7cT3RvZJEP8CFYKHFFkwMq"
        ],
        license: "BSL-1.1"
      },
      "src/interfaces/IAuctionHouse.sol": {
        keccak256: "0xd027663074bc26c8f917f61288956a960d9f3f490789b68eb1e03b01c0dabdcc",
        urls: [
          "bzz-raw://d7651f3ed6dce4a0212b74bca1dc1aca4750815597d3f1a86237d8468f4633b9",
          "dweb:/ipfs/QmP3WSHZn8eGzjd7JzPNgHcEoj3TgXQfUe2WPw9LXtMDZg"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/IBatchAuctionHouse.sol": {
        keccak256: "0x3bfd9e05921f5689650831bfe86babee7ad65616a76bfa3f0fe966f8c8f0028e",
        urls: [
          "bzz-raw://834929e27973e1b97d05041c6753ae190996eaa5df376ed51237e56041d7af9f",
          "dweb:/ipfs/QmYvXqGv17uBSXZ9YmqAjais7x16wYwS12bVrj36YWxBsm"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/ICallback.sol": {
        keccak256: "0xb08760dc184fdf388679cbaf9b854e6d7d800825c71573ae0edbba9d1980fbb8",
        urls: [
          "bzz-raw://913a2ad19820fe53ab46dccf6a13127d189f7840ba6a522a6e5d5afdebca41da",
          "dweb:/ipfs/QmSVSQxMYCsLX58utsHo1CzkRRy3YkYGpBbqKH6FLrUhas"
        ],
        license: "MIT"
      },
      "src/interfaces/IFeeManager.sol": {
        keccak256: "0x7d2326b6735b775170a6da522351a2a288c3d107ef3a8370ee7e42649910421d",
        urls: [
          "bzz-raw://cfde5ef0e4c485489479a5c6a291bb82ee3cc38b7bdbaeeef3754a7d32e4b0f8",
          "dweb:/ipfs/QmR7c9xa5x8UJ49kuXvHam2W2CC891aQKNqS8omAEXnH4v"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/IAuction.sol": {
        keccak256: "0x7039157d051a619b63ce7988be07a43b77a46043f61c5ab4e531084084bcca01",
        urls: [
          "bzz-raw://32e0093e843d08deada85cf2649d61aa6b37be858e4fdb32b81bfd2c0cf2c304",
          "dweb:/ipfs/QmPEt15nwpXoBzin32wAQKfSBqcvPdkcgLRxiu3eiN1VFg"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/IBatchAuction.sol": {
        keccak256: "0xbe814e420085ee1f321fef8d89ddd6b4c668e967bff5eccfbfcc2c994393a02b",
        urls: [
          "bzz-raw://c1cf24444584582d87de6df951a80f28da9e611a8118a3796051fcc5087747cc",
          "dweb:/ipfs/QmQss5Fo8wuYoAgjNZYRTUqSEwHeV4SXCVJTQazbEo1aCw"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/ICondenser.sol": {
        keccak256: "0x3bb335a4426a17e2aaf48647d3c41293c3803872c93cdf4e489064936e63d9cd",
        urls: [
          "bzz-raw://aaf82d18618e54e414999d916114ae9a0d103c764ac4a4665bed4c9ecc979e22",
          "dweb:/ipfs/QmTAJYs4EEU6YfNBDGXf7vbExcsfne7hCXkhPXvG2oyxvH"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/IDerivative.sol": {
        keccak256: "0x953a79012815f4b3315303720b1758d3b6f3666174d5259849609bb1c11f948f",
        urls: [
          "bzz-raw://1abc79c0a872cfb4eaf7cadf5794fd509aa401a86fd27bc4c78084f125164daf",
          "dweb:/ipfs/QmSd58DqwwjnXehKFu9DLUFToTVHmWNWstnEMSZ1EX96Yd"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/lib/Callbacks.sol": {
        keccak256: "0xc3e2ce87dca53c20a0e013351f80549ed4821c7267963e87e39b0996ccf93836",
        urls: [
          "bzz-raw://0fd245ee2582d6ff35a24fd40b8c6c5ccd620dc5d813dcdea583fd4c18492feb",
          "dweb:/ipfs/QmaixXjHYed69t9opaSYAkxP3eb3pigUxiJF79xQwb4vMi"
        ],
        license: "MIT"
      },
      "src/lib/ERC6909Metadata.sol": {
        keccak256: "0x45cbf0d8d04f5628d34d7eb4bb5e13b7664b1ae03456f2ca2d2eb259d199f9e6",
        urls: [
          "bzz-raw://f7cfbc4fd542200d756f16457917157d838df10aa5f253f205d33a865ca6b0e6",
          "dweb:/ipfs/QmTrgxTzer1yuvy4VoRkyMBtgigfq9kHU6xNHfy9J5Du11"
        ],
        license: "UNLICENSED"
      },
      "src/lib/Transfer.sol": {
        keccak256: "0xd715c7cb14051b0b12feef58fdc8ffa9a99e825c51c994a630928f08a5b8f465",
        urls: [
          "bzz-raw://11b7da9dd9b78a13fac23e2a9a53e946e02100ff1a97adf2efdc252df2d49aff",
          "dweb:/ipfs/QmUfiSSJYaWYuhxezZNQjvtZDwtTtCcKQVDJZxHzxhyvDw"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/lib/permit2/interfaces/IPermit2.sol": {
        keccak256: "0x240e896f81a7c9574930db416bb25e58a321b5949cfa840f3d183bd8fef72da9",
        urls: [
          "bzz-raw://97cb0d04e9fa3b11c5b38f7b645e1c6ff149b5af225a6a209993f2590a42a67e",
          "dweb:/ipfs/QmSN7Dau9dzMA47SPf5pWRRDDdYKW8RhXcmUbmaguSvGQL"
        ],
        license: "MIT"
      },
      "src/modules/Auction.sol": {
        keccak256: "0x4abc2212016836dbef38428b3a938d299b0f01e8b17b6d13ab86207439fdfd10",
        urls: [
          "bzz-raw://43debb1e08d7f9b4f0a8adfbd982cda068ad934eea123e0dad1a235d8a8c9ce3",
          "dweb:/ipfs/QmZfe5VNfsa79pFt9TUogrbV2dAvpCpW4VWfpAhQiowGLC"
        ],
        license: "BSL-1.1"
      },
      "src/modules/Condenser.sol": {
        keccak256: "0x0eeb0738b78b8b5947a667e64d95e02139ea1cbfbc14b590d23a3d5d320a132b",
        urls: [
          "bzz-raw://f35e32dbe42be81eac514ea392a16ee0ffd3c1ce6e314298233ea31852cd29cd",
          "dweb:/ipfs/QmUoM2MuLpbmWjkFBM8Sm5n1EreDAkWZpDEDWZht7gF5kQ"
        ],
        license: "BSL-1.1"
      },
      "src/modules/Derivative.sol": {
        keccak256: "0x35e7d822254ccf75e0216b8783dfd8c9a431eaa40a90c1254635f161646573e0",
        urls: [
          "bzz-raw://83e5ac5f6f4c0e339841cefc19fc2aec65951dd1b8a3000819d8d9a344964f58",
          "dweb:/ipfs/QmRW2xsdfc8zHvr2XWXK5n2rxnpqYxD9rBwJ9eLWWSrYMP"
        ],
        license: "BSL-1.1"
      },
      "src/modules/Keycode.sol": {
        keccak256: "0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e",
        urls: [
          "bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd",
          "dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/Modules.sol": {
        keccak256: "0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689",
        urls: [
          "bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee",
          "dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/auctions/BatchAuctionModule.sol": {
        keccak256: "0x7fd51c1ba66d2ee5988f96391983d7ac3ce14aa282b56affba69cc55de3f8907",
        urls: [
          "bzz-raw://cb7c98b9a308f6ba21be2cc56398fc719df9a5e0a731f56f49b66213a9476085",
          "dweb:/ipfs/QmWU8pW8AKL3tvfL4EZTRxpkCtvGGwLNDpuFCYauCVjnXf"
        ],
        license: "BSL-1.1"
      }
    },
    version: 1
  },
  ast: {
    absolutePath: "src/BatchAuctionHouse.sol",
    id: 75149,
    exportedSymbols: {
      AuctionHouse: [76603],
      AuctionModule: [88011],
      BatchAuctionHouse: [75148],
      BatchAuctionModule: [89550],
      Callbacks: [84003],
      ERC20: [56264],
      IAuction: [82691],
      IBatchAuction: [82847],
      IBatchAuctionHouse: [81989],
      ICallback: [82141],
      Transfer: [86134],
      fromVeecode: [88193]
    },
    nodeType: "SourceUnit",
    src: "36:21671:115",
    nodes: [
      {
        id: 74098,
        nodeType: "PragmaDirective",
        src: "36:23:115",
        nodes: [],
        literals: ["solidity", "0.8", ".19"]
      },
      {
        id: 74100,
        nodeType: "ImportDirective",
        src: "75:61:115",
        nodes: [],
        absolutePath: "src/interfaces/modules/IAuction.sol",
        file: "src/interfaces/modules/IAuction.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 82692,
        symbolAliases: [
          {
            foreign: {
              id: 74099,
              name: "IAuction",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 82691,
              src: "83:8:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74102,
        nodeType: "ImportDirective",
        src: "137:55:115",
        nodes: [],
        absolutePath: "src/interfaces/ICallback.sol",
        file: "src/interfaces/ICallback.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 82142,
        symbolAliases: [
          {
            foreign: {
              id: 74101,
              name: "ICallback",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 82141,
              src: "145:9:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74104,
        nodeType: "ImportDirective",
        src: "193:71:115",
        nodes: [],
        absolutePath: "src/interfaces/modules/IBatchAuction.sol",
        file: "src/interfaces/modules/IBatchAuction.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 82848,
        symbolAliases: [
          {
            foreign: {
              id: 74103,
              name: "IBatchAuction",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 82847,
              src: "201:13:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74106,
        nodeType: "ImportDirective",
        src: "265:73:115",
        nodes: [],
        absolutePath: "src/interfaces/IBatchAuctionHouse.sol",
        file: "src/interfaces/IBatchAuctionHouse.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 81990,
        symbolAliases: [
          {
            foreign: {
              id: 74105,
              name: "IBatchAuctionHouse",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 81989,
              src: "273:18:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74108,
        nodeType: "ImportDirective",
        src: "362:46:115",
        nodes: [],
        absolutePath: "src/lib/Transfer.sol",
        file: "src/lib/Transfer.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 86135,
        symbolAliases: [
          {
            foreign: {
              id: 74107,
              name: "Transfer",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 86134,
              src: "370:8:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74110,
        nodeType: "ImportDirective",
        src: "409:48:115",
        nodes: [],
        absolutePath: "src/lib/Callbacks.sol",
        file: "src/lib/Callbacks.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 84004,
        symbolAliases: [
          {
            foreign: {
              id: 74109,
              name: "Callbacks",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 84003,
              src: "417:9:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74112,
        nodeType: "ImportDirective",
        src: "481:47:115",
        nodes: [],
        absolutePath: "lib/solmate/src/tokens/ERC20.sol",
        file: "solmate/tokens/ERC20.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 56265,
        symbolAliases: [
          {
            foreign: {
              id: 74111,
              name: "ERC20",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 56264,
              src: "489:5:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74114,
        nodeType: "ImportDirective",
        src: "542:56:115",
        nodes: [],
        absolutePath: "src/bases/AuctionHouse.sol",
        file: "src/bases/AuctionHouse.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 76604,
        symbolAliases: [
          {
            foreign: {
              id: 74113,
              name: "AuctionHouse",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 76603,
              src: "550:12:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74116,
        nodeType: "ImportDirective",
        src: "599:54:115",
        nodes: [],
        absolutePath: "src/modules/Auction.sol",
        file: "src/modules/Auction.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 88012,
        symbolAliases: [
          {
            foreign: {
              id: 74115,
              name: "AuctionModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88011,
              src: "607:13:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74118,
        nodeType: "ImportDirective",
        src: "654:79:115",
        nodes: [],
        absolutePath: "src/modules/auctions/BatchAuctionModule.sol",
        file: "src/modules/auctions/BatchAuctionModule.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 89551,
        symbolAliases: [
          {
            foreign: {
              id: 74117,
              name: "BatchAuctionModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 89550,
              src: "662:18:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 74120,
        nodeType: "ImportDirective",
        src: "735:52:115",
        nodes: [],
        absolutePath: "src/modules/Keycode.sol",
        file: "src/modules/Keycode.sol",
        nameLocation: "-1:-1:-1",
        scope: 75149,
        sourceUnit: 88401,
        symbolAliases: [
          {
            foreign: {
              id: 74119,
              name: "fromVeecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88193,
              src: "743:11:115",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 75148,
        nodeType: "ContractDefinition",
        src: "985:20721:115",
        nodes: [
          {
            id: 74129,
            nodeType: "UsingForDirective",
            src: "1054:30:115",
            nodes: [],
            global: false,
            libraryName: {
              id: 74126,
              name: "Callbacks",
              nameLocations: ["1060:9:115"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 84003,
              src: "1060:9:115"
            },
            typeName: {
              id: 74128,
              nodeType: "UserDefinedTypeName",
              pathNode: {
                id: 74127,
                name: "ICallback",
                nameLocations: ["1074:9:115"],
                nodeType: "IdentifierPath",
                referencedDeclaration: 82141,
                src: "1074:9:115"
              },
              referencedDeclaration: 82141,
              src: "1074:9:115",
              typeDescriptions: {
                typeIdentifier: "t_contract$_ICallback_$82141",
                typeString: "contract ICallback"
              }
            }
          },
          {
            id: 74131,
            nodeType: "ErrorDefinition",
            src: "1130:30:115",
            nodes: [],
            errorSelector: "758342a7",
            name: "AmountLessThanMinimum",
            nameLocation: "1136:21:115",
            parameters: {
              id: 74130,
              nodeType: "ParameterList",
              parameters: [],
              src: "1157:2:115"
            }
          },
          {
            id: 74133,
            nodeType: "ErrorDefinition",
            src: "1165:28:115",
            nodes: [],
            errorSelector: "57e000b1",
            name: "InsufficientFunding",
            nameLocation: "1171:19:115",
            parameters: {
              id: 74132,
              nodeType: "ParameterList",
              parameters: [],
              src: "1190:2:115"
            }
          },
          {
            id: 74143,
            nodeType: "EventDefinition",
            src: "1239:94:115",
            nodes: [],
            anonymous: false,
            eventSelector: "a2e7ed6065b3a19c5ea6dce1c2f7a8933195d54aa91cee19103be6655cc3bcf8",
            name: "Bid",
            nameLocation: "1245:3:115",
            parameters: {
              id: 74142,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74135,
                  indexed: true,
                  mutability: "mutable",
                  name: "lotId",
                  nameLocation: "1264:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74143,
                  src: "1249:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74134,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1249:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74137,
                  indexed: true,
                  mutability: "mutable",
                  name: "bidId",
                  nameLocation: "1286:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74143,
                  src: "1271:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74136,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1271:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74139,
                  indexed: true,
                  mutability: "mutable",
                  name: "bidder",
                  nameLocation: "1309:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74143,
                  src: "1293:22:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 74138,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1293:7:115",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74141,
                  indexed: false,
                  mutability: "mutable",
                  name: "amount",
                  nameLocation: "1325:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74143,
                  src: "1317:14:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 74140,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "1317:7:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1248:84:115"
            }
          },
          {
            id: 74151,
            nodeType: "EventDefinition",
            src: "1339:84:115",
            nodes: [],
            anonymous: false,
            eventSelector: "c5e25a727c1d2fa8b8cf2bd4f7a3ba0b6740aaee33d84a3132d47301844f3618",
            name: "RefundBid",
            nameLocation: "1345:9:115",
            parameters: {
              id: 74150,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74145,
                  indexed: true,
                  mutability: "mutable",
                  name: "lotId",
                  nameLocation: "1370:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74151,
                  src: "1355:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74144,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1355:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74147,
                  indexed: true,
                  mutability: "mutable",
                  name: "bidId",
                  nameLocation: "1392:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74151,
                  src: "1377:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74146,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1377:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74149,
                  indexed: true,
                  mutability: "mutable",
                  name: "bidder",
                  nameLocation: "1415:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74151,
                  src: "1399:22:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 74148,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1399:7:115",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1354:68:115"
            }
          },
          {
            id: 74159,
            nodeType: "EventDefinition",
            src: "1429:83:115",
            nodes: [],
            anonymous: false,
            eventSelector: "16c8bb5b68aee6acf37bdd28737b3728e2d041e98a4554f3522f6a7947448c0c",
            name: "ClaimBid",
            nameLocation: "1435:8:115",
            parameters: {
              id: 74158,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74153,
                  indexed: true,
                  mutability: "mutable",
                  name: "lotId",
                  nameLocation: "1459:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74159,
                  src: "1444:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74152,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1444:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74155,
                  indexed: true,
                  mutability: "mutable",
                  name: "bidId",
                  nameLocation: "1481:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74159,
                  src: "1466:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74154,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1466:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74157,
                  indexed: true,
                  mutability: "mutable",
                  name: "bidder",
                  nameLocation: "1504:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74159,
                  src: "1488:22:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 74156,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1488:7:115",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1443:68:115"
            }
          },
          {
            id: 74163,
            nodeType: "EventDefinition",
            src: "1518:35:115",
            nodes: [],
            anonymous: false,
            eventSelector: "5d4a6ac2287eaf5f22deb24e842c4668fd11d8f478a18cf2a37faa0bcebd31c6",
            name: "Settle",
            nameLocation: "1524:6:115",
            parameters: {
              id: 74162,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74161,
                  indexed: true,
                  mutability: "mutable",
                  name: "lotId",
                  nameLocation: "1546:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74163,
                  src: "1531:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74160,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1531:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1530:22:115"
            }
          },
          {
            id: 74167,
            nodeType: "EventDefinition",
            src: "1559:34:115",
            nodes: [],
            anonymous: false,
            eventSelector: "16a4d2776546f16d2ecb9de112ea9b037ce1580dacdcf8013658630c66a921d9",
            name: "Abort",
            nameLocation: "1565:5:115",
            parameters: {
              id: 74166,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74165,
                  indexed: true,
                  mutability: "mutable",
                  name: "lotId",
                  nameLocation: "1586:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74167,
                  src: "1571:20:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74164,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "1571:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1570:22:115"
            }
          },
          {
            id: 74182,
            nodeType: "FunctionDefinition",
            src: "1693:139:115",
            nodes: [],
            body: {
              id: 74181,
              nodeType: "Block",
              src: "1830:2:115",
              nodes: [],
              statements: []
            },
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    id: 74176,
                    name: "owner_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 74169,
                    src: "1801:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  {
                    id: 74177,
                    name: "protocol_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 74171,
                    src: "1809:9:115",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  {
                    id: 74178,
                    name: "permit2_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 74173,
                    src: "1820:8:115",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  }
                ],
                id: 74179,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 74175,
                  name: "AuctionHouse",
                  nameLocations: ["1788:12:115"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 76603,
                  src: "1788:12:115"
                },
                nodeType: "ModifierInvocation",
                src: "1788:41:115"
              }
            ],
            name: "",
            nameLocation: "-1:-1:-1",
            parameters: {
              id: 74174,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74169,
                  mutability: "mutable",
                  name: "owner_",
                  nameLocation: "1722:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74182,
                  src: "1714:14:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 74168,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1714:7:115",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74171,
                  mutability: "mutable",
                  name: "protocol_",
                  nameLocation: "1746:9:115",
                  nodeType: "VariableDeclaration",
                  scope: 74182,
                  src: "1738:17:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 74170,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1738:7:115",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74173,
                  mutability: "mutable",
                  name: "permit2_",
                  nameLocation: "1773:8:115",
                  nodeType: "VariableDeclaration",
                  scope: 74182,
                  src: "1765:16:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 74172,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1765:7:115",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1704:83:115"
            },
            returnParameters: {
              id: 74180,
              nodeType: "ParameterList",
              parameters: [],
              src: "1830:0:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 74310,
            nodeType: "FunctionDefinition",
            src: "2435:1792:115",
            nodes: [],
            body: {
              id: 74309,
              nodeType: "Block",
              src: "2623:1604:115",
              nodes: [],
              statements: [
                {
                  assignments: [74199],
                  declarations: [
                    {
                      constant: false,
                      id: 74199,
                      mutability: "mutable",
                      name: "auctionModule",
                      nameLocation: "2714:13:115",
                      nodeType: "VariableDeclaration",
                      scope: 74309,
                      src: "2700:27:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_AuctionModule_$88011",
                        typeString: "contract AuctionModule"
                      },
                      typeName: {
                        id: 74198,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74197,
                          name: "AuctionModule",
                          nameLocations: ["2700:13:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 88011,
                          src: "2700:13:115"
                        },
                        referencedDeclaration: 88011,
                        src: "2700:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_AuctionModule_$88011",
                          typeString: "contract AuctionModule"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74206,
                  initialValue: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74202,
                              name: "routing_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74188,
                              src: "2769:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                                typeString: "struct IAuctionHouse.RoutingParams calldata"
                              }
                            },
                            id: 74203,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "2778:11:115",
                            memberName: "auctionType",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81749,
                            src: "2769:20:115",
                            typeDescriptions: {
                              typeIdentifier: "t_userDefinedValueType$_Keycode_$88082",
                              typeString: "Keycode"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_userDefinedValueType$_Keycode_$88082",
                              typeString: "Keycode"
                            }
                          ],
                          id: 74201,
                          name: "_getLatestModuleIfActive",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 88733,
                          src: "2744:24:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$_t_userDefinedValueType$_Keycode_$88082_$returns$_t_address_$",
                            typeString: "function (Keycode) view returns (address)"
                          }
                        },
                        id: 74204,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "2744:46:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 74200,
                      name: "AuctionModule",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88011,
                      src: "2730:13:115",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_AuctionModule_$88011_$",
                        typeString: "type(contract AuctionModule)"
                      }
                    },
                    id: 74205,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2730:61:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_AuctionModule_$88011",
                      typeString: "contract AuctionModule"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2700:91:115"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_AuctionType_$82559",
                      typeString: "enum IAuction.AuctionType"
                    },
                    id: 74213,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        expression: {
                          id: 74207,
                          name: "auctionModule",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74199,
                          src: "2805:13:115",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_AuctionModule_$88011",
                            typeString: "contract AuctionModule"
                          }
                        },
                        id: 74208,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "2819:11:115",
                        memberName: "auctionType",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82690,
                        src: "2805:25:115",
                        typeDescriptions: {
                          typeIdentifier: "t_function_external_view$__$returns$_t_enum$_AuctionType_$82559_$",
                          typeString: "function () view external returns (enum IAuction.AuctionType)"
                        }
                      },
                      id: 74209,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2805:27:115",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_AuctionType_$82559",
                        typeString: "enum IAuction.AuctionType"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      expression: {
                        expression: {
                          id: 74210,
                          name: "IAuction",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 82691,
                          src: "2836:8:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_IAuction_$82691_$",
                            typeString: "type(contract IAuction)"
                          }
                        },
                        id: 74211,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "2845:11:115",
                        memberName: "AuctionType",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82559,
                        src: "2836:20:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_AuctionType_$82559_$",
                          typeString: "type(enum IAuction.AuctionType)"
                        }
                      },
                      id: 74212,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "2857:5:115",
                      memberName: "Batch",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82558,
                      src: "2836:26:115",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_AuctionType_$82559",
                        typeString: "enum IAuction.AuctionType"
                      }
                    },
                    src: "2805:57:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 74217,
                  nodeType: "IfStatement",
                  src: "2801:85:115",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 74214,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 81708,
                        src: "2871:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 74215,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2871:15:115",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 74216,
                    nodeType: "RevertStatement",
                    src: "2864:22:115"
                  }
                },
                {
                  condition: {
                    expression: {
                      id: 74218,
                      name: "params_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74191,
                      src: "3027:7:115",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                        typeString: "struct IAuction.AuctionParams calldata"
                      }
                    },
                    id: 74219,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "3035:15:115",
                    memberName: "capacityInQuote",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 82565,
                    src: "3027:23:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 74223,
                  nodeType: "IfStatement",
                  src: "3023:51:115",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 74220,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 81708,
                        src: "3059:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 74221,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "3059:15:115",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 74222,
                    nodeType: "RevertStatement",
                    src: "3052:22:115"
                  }
                },
                {
                  expression: {
                    id: 74230,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 74224,
                          name: "lotRouting",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 75365,
                          src: "3126:10:115",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                            typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                          }
                        },
                        id: 74226,
                        indexExpression: {
                          id: 74225,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74185,
                          src: "3137:6:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "3126:18:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage",
                          typeString: "struct IAuctionHouse.Routing storage ref"
                        }
                      },
                      id: 74227,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "3145:7:115",
                      memberName: "funding",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 81781,
                      src: "3126:26:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 74228,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74191,
                        src: "3155:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                          typeString: "struct IAuction.AuctionParams calldata"
                        }
                      },
                      id: 74229,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "3163:8:115",
                      memberName: "capacity",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82567,
                      src: "3155:16:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "3126:45:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 74231,
                  nodeType: "ExpressionStatement",
                  src: "3126:45:115"
                },
                {
                  assignments: [74234],
                  declarations: [
                    {
                      constant: false,
                      id: 74234,
                      mutability: "mutable",
                      name: "baseToken",
                      nameLocation: "3188:9:115",
                      nodeType: "VariableDeclaration",
                      scope: 74309,
                      src: "3182:15:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ERC20_$56264",
                        typeString: "contract ERC20"
                      },
                      typeName: {
                        id: 74233,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74232,
                          name: "ERC20",
                          nameLocations: ["3182:5:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 56264,
                          src: "3182:5:115"
                        },
                        referencedDeclaration: 56264,
                        src: "3182:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74239,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 74236,
                          name: "routing_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74188,
                          src: "3206:8:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                            typeString: "struct IAuctionHouse.RoutingParams calldata"
                          }
                        },
                        id: 74237,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "3215:9:115",
                        memberName: "baseToken",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81751,
                        src: "3206:18:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 74235,
                      name: "ERC20",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56264,
                      src: "3200:5:115",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                        typeString: "type(contract ERC20)"
                      }
                    },
                    id: 74238,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3200:25:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "3182:43:115"
                },
                {
                  condition: {
                    arguments: [
                      {
                        expression: {
                          id: 74243,
                          name: "Callbacks",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 84003,
                          src: "3337:9:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                            typeString: "type(library Callbacks)"
                          }
                        },
                        id: 74244,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        memberLocation: "3347:21:115",
                        memberName: "SEND_BASE_TOKENS_FLAG",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83497,
                        src: "3337:31:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        expression: {
                          id: 74240,
                          name: "routing_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74188,
                          src: "3304:8:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                            typeString: "struct IAuctionHouse.RoutingParams calldata"
                          }
                        },
                        id: 74241,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "3313:9:115",
                        memberName: "callbacks",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81760,
                        src: "3304:18:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      },
                      id: 74242,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "3323:13:115",
                      memberName: "hasPermission",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83984,
                      src: "3304:32:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_uint256_$returns$_t_bool_$attached_to$_t_contract$_ICallback_$82141_$",
                        typeString: "function (contract ICallback,uint256) pure returns (bool)"
                      }
                    },
                    id: 74245,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3304:65:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 74305,
                    nodeType: "Block",
                    src: "3950:182:115",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 74285,
                              name: "baseToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74234,
                              src: "3986:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            {
                              expression: {
                                id: 74286,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: "3997:3:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg"
                                }
                              },
                              id: 74287,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "4001:6:115",
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              src: "3997:10:115",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              arguments: [
                                {
                                  id: 74290,
                                  name: "this",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: "4017:4:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                ],
                                id: 74289,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "4009:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 74288,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "4009:7:115",
                                  typeDescriptions: {}
                                }
                              },
                              id: 74291,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "4009:13:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              expression: {
                                id: 74292,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74191,
                                src: "4024:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                                  typeString: "struct IAuction.AuctionParams calldata"
                                }
                              },
                              id: 74293,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "4032:8:115",
                              memberName: "capacity",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82567,
                              src: "4024:16:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "74727565",
                              id: 74294,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "4042:4:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "true"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            ],
                            expression: {
                              id: 74282,
                              name: "Transfer",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 86134,
                              src: "3964:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                                typeString: "type(library Transfer)"
                              }
                            },
                            id: 74284,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "3973:12:115",
                            memberName: "transferFrom",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 85955,
                            src: "3964:21:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                              typeString: "function (contract ERC20,address,address,uint256,bool)"
                            }
                          },
                          id: 74295,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3964:83:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74296,
                        nodeType: "ExpressionStatement",
                        src: "3964:83:115"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 74298,
                              name: "routing_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74188,
                              src: "4079:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                                typeString: "struct IAuctionHouse.RoutingParams calldata"
                              }
                            },
                            {
                              id: 74299,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74185,
                              src: "4089:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              expression: {
                                id: 74300,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74191,
                                src: "4097:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                                  typeString: "struct IAuction.AuctionParams calldata"
                                }
                              },
                              id: 74301,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "4105:8:115",
                              memberName: "capacity",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82567,
                              src: "4097:16:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "66616c7365",
                              id: 74302,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "4115:5:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "false"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                                typeString: "struct IAuctionHouse.RoutingParams calldata"
                              },
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            ],
                            id: 74297,
                            name: "_onCreateCallback",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 76009,
                            src: "4061:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_struct$_RoutingParams_$81770_calldata_ptr_$_t_uint96_$_t_uint256_$_t_bool_$returns$__$",
                              typeString: "function (struct IAuctionHouse.RoutingParams calldata,uint96,uint256,bool)"
                            }
                          },
                          id: 74303,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4061:60:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74304,
                        nodeType: "ExpressionStatement",
                        src: "4061:60:115"
                      }
                    ]
                  },
                  id: 74306,
                  nodeType: "IfStatement",
                  src: "3300:832:115",
                  trueBody: {
                    id: 74281,
                    nodeType: "Block",
                    src: "3371:470:115",
                    statements: [
                      {
                        assignments: [74247],
                        declarations: [
                          {
                            constant: false,
                            id: 74247,
                            mutability: "mutable",
                            name: "balanceBefore",
                            nameLocation: "3393:13:115",
                            nodeType: "VariableDeclaration",
                            scope: 74281,
                            src: "3385:21:115",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 74246,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "3385:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 74255,
                        initialValue: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  id: 74252,
                                  name: "this",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: "3437:4:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                ],
                                id: 74251,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "3429:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 74250,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "3429:7:115",
                                  typeDescriptions: {}
                                }
                              },
                              id: 74253,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "3429:13:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            expression: {
                              id: 74248,
                              name: "baseToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74234,
                              src: "3409:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            id: 74249,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "3419:9:115",
                            memberName: "balanceOf",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 55907,
                            src: "3409:19:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                              typeString: "function (address) view external returns (uint256)"
                            }
                          },
                          id: 74254,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3409:34:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "3385:58:115"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 74257,
                              name: "routing_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74188,
                              src: "3561:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                                typeString: "struct IAuctionHouse.RoutingParams calldata"
                              }
                            },
                            {
                              id: 74258,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74185,
                              src: "3571:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              expression: {
                                id: 74259,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74191,
                                src: "3579:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                                  typeString: "struct IAuction.AuctionParams calldata"
                                }
                              },
                              id: 74260,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "3587:8:115",
                              memberName: "capacity",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82567,
                              src: "3579:16:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "74727565",
                              id: 74261,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "3597:4:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "true"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                                typeString: "struct IAuctionHouse.RoutingParams calldata"
                              },
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            ],
                            id: 74256,
                            name: "_onCreateCallback",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 76009,
                            src: "3543:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_struct$_RoutingParams_$81770_calldata_ptr_$_t_uint96_$_t_uint256_$_t_bool_$returns$__$",
                              typeString: "function (struct IAuctionHouse.RoutingParams calldata,uint96,uint256,bool)"
                            }
                          },
                          id: 74262,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3543:59:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74263,
                        nodeType: "ExpressionStatement",
                        src: "3543:59:115"
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 74275,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    id: 74268,
                                    name: "this",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: -28,
                                    src: "3731:4:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                      typeString: "contract BatchAuctionHouse"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                      typeString: "contract BatchAuctionHouse"
                                    }
                                  ],
                                  id: 74267,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "3723:7:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_address_$",
                                    typeString: "type(address)"
                                  },
                                  typeName: {
                                    id: 74266,
                                    name: "address",
                                    nodeType: "ElementaryTypeName",
                                    src: "3723:7:115",
                                    typeDescriptions: {}
                                  }
                                },
                                id: 74269,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "typeConversion",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "3723:13:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              expression: {
                                id: 74264,
                                name: "baseToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74234,
                                src: "3703:9:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_contract$_ERC20_$56264",
                                  typeString: "contract ERC20"
                                }
                              },
                              id: 74265,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "3713:9:115",
                              memberName: "balanceOf",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 55907,
                              src: "3703:19:115",
                              typeDescriptions: {
                                typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                                typeString: "function (address) view external returns (uint256)"
                              }
                            },
                            id: 74270,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "3703:34:115",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "<",
                          rightExpression: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 74274,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 74271,
                              name: "balanceBefore",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74247,
                              src: "3740:13:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "+",
                            rightExpression: {
                              expression: {
                                id: 74272,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74191,
                                src: "3756:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                                  typeString: "struct IAuction.AuctionParams calldata"
                                }
                              },
                              id: 74273,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "3764:8:115",
                              memberName: "capacity",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82567,
                              src: "3756:16:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "3740:32:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "3703:69:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 74280,
                        nodeType: "IfStatement",
                        src: "3699:132:115",
                        trueBody: {
                          id: 74279,
                          nodeType: "Block",
                          src: "3774:57:115",
                          statements: [
                            {
                              errorCall: {
                                arguments: [],
                                expression: {
                                  argumentTypes: [],
                                  id: 74276,
                                  name: "InvalidCallback",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 81716,
                                  src: "3799:15:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_error_pure$__$returns$__$",
                                    typeString: "function () pure"
                                  }
                                },
                                id: 74277,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "3799:17:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_tuple$__$",
                                  typeString: "tuple()"
                                }
                              },
                              id: 74278,
                              nodeType: "RevertStatement",
                              src: "3792:24:115"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  expression: {
                    hexValue: "74727565",
                    id: 74307,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "4216:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 74196,
                  id: 74308,
                  nodeType: "Return",
                  src: "4209:11:115"
                }
              ]
            },
            baseFunctions: [75818],
            documentation: {
              id: 74183,
              nodeType: "StructuredDocumentation",
              src: "1890:540:115",
              text: "@inheritdoc AuctionHouse\n @dev        Handles auction creation for a batch auction.\n             This function performs the following:\n             - Performs additional validation\n             - Collects the payout token from the seller (prefunding)\n             - Calls the onCreate callback, if configured\n             This function reverts if:\n             - The specified auction module is not for batch auctions\n             - The capacity is in quote tokens"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_auction",
            nameLocation: "2444:8:115",
            overrides: {
              id: 74193,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "2581:8:115"
            },
            parameters: {
              id: 74192,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74185,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "2469:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74310,
                  src: "2462:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74184,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "2462:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74188,
                  mutability: "mutable",
                  name: "routing_",
                  nameLocation: "2508:8:115",
                  nodeType: "VariableDeclaration",
                  scope: 74310,
                  src: "2485:31:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_RoutingParams_$81770_calldata_ptr",
                    typeString: "struct IAuctionHouse.RoutingParams"
                  },
                  typeName: {
                    id: 74187,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 74186,
                      name: "RoutingParams",
                      nameLocations: ["2485:13:115"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 81770,
                      src: "2485:13:115"
                    },
                    referencedDeclaration: 81770,
                    src: "2485:13:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_RoutingParams_$81770_storage_ptr",
                      typeString: "struct IAuctionHouse.RoutingParams"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74191,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "2558:7:115",
                  nodeType: "VariableDeclaration",
                  scope: 74310,
                  src: "2526:39:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_AuctionParams_$82570_calldata_ptr",
                    typeString: "struct IAuction.AuctionParams"
                  },
                  typeName: {
                    id: 74190,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 74189,
                      name: "IAuction.AuctionParams",
                      nameLocations: ["2526:8:115", "2535:13:115"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82570,
                      src: "2526:22:115"
                    },
                    referencedDeclaration: 82570,
                    src: "2526:22:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionParams_$82570_storage_ptr",
                      typeString: "struct IAuction.AuctionParams"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2452:119:115"
            },
            returnParameters: {
              id: 74196,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74195,
                  mutability: "mutable",
                  name: "performedCallback",
                  nameLocation: "2604:17:115",
                  nodeType: "VariableDeclaration",
                  scope: 74310,
                  src: "2599:22:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 74194,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "2599:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2598:24:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 74375,
            nodeType: "FunctionDefinition",
            src: "4535:987:115",
            nodes: [],
            body: {
              id: 74374,
              nodeType: "Block",
              src: "4670:852:115",
              nodes: [],
              statements: [
                {
                  assignments: [74323],
                  declarations: [
                    {
                      constant: false,
                      id: 74323,
                      mutability: "mutable",
                      name: "routing",
                      nameLocation: "4784:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 74374,
                      src: "4768:23:115",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing"
                      },
                      typeName: {
                        id: 74322,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74321,
                          name: "Routing",
                          nameLocations: ["4768:7:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 81792,
                          src: "4768:7:115"
                        },
                        referencedDeclaration: 81792,
                        src: "4768:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74327,
                  initialValue: {
                    baseExpression: {
                      id: 74324,
                      name: "lotRouting",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75365,
                      src: "4794:10:115",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                      }
                    },
                    id: 74326,
                    indexExpression: {
                      id: 74325,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74313,
                      src: "4805:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "4794:18:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                      typeString: "struct IAuctionHouse.Routing storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4768:44:115"
                },
                {
                  assignments: [74329],
                  declarations: [
                    {
                      constant: false,
                      id: 74329,
                      mutability: "mutable",
                      name: "funding",
                      nameLocation: "4830:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 74374,
                      src: "4822:15:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 74328,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "4822:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74332,
                  initialValue: {
                    expression: {
                      id: 74330,
                      name: "routing",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74323,
                      src: "4840:7:115",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing storage pointer"
                      }
                    },
                    id: 74331,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "4848:7:115",
                    memberName: "funding",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 81781,
                    src: "4840:15:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4822:33:115"
                },
                {
                  expression: {
                    id: 74337,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 74333,
                        name: "routing",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74323,
                        src: "4923:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing storage pointer"
                        }
                      },
                      id: 74335,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "4931:7:115",
                      memberName: "funding",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 81781,
                      src: "4923:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "30",
                      id: 74336,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "4941:1:115",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "4923:19:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 74338,
                  nodeType: "ExpressionStatement",
                  src: "4923:19:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74343,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74323,
                              src: "5054:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74344,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "5062:9:115",
                            memberName: "baseToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81774,
                            src: "5054:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74342,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "5048:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 74345,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "5048:24:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74347,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74323,
                              src: "5124:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74348,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "5132:9:115",
                            memberName: "callbacks",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81784,
                            src: "5124:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            }
                          },
                          {
                            expression: {
                              id: 74349,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74323,
                              src: "5143:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74350,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "5151:6:115",
                            memberName: "seller",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81772,
                            src: "5143:14:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74346,
                          name: "_getAddressGivenCallbackBaseTokenFlag",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 76032,
                          src: "5086:37:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_address_$returns$_t_address_$",
                            typeString: "function (contract ICallback,address) pure returns (address)"
                          }
                        },
                        id: 74351,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "5086:72:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 74352,
                        name: "funding",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74329,
                        src: "5172:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        hexValue: "66616c7365",
                        id: 74353,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "5193:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "false"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      expression: {
                        id: 74339,
                        name: "Transfer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86134,
                        src: "5017:8:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                          typeString: "type(library Transfer)"
                        }
                      },
                      id: 74341,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "5026:8:115",
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85890,
                      src: "5017:17:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                        typeString: "function (contract ERC20,address,uint256,bool)"
                      }
                    },
                    id: 74354,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "5017:191:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74355,
                  nodeType: "ExpressionStatement",
                  src: "5017:191:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 74359,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74323,
                          src: "5320:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74360,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "5328:9:115",
                        memberName: "callbacks",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81784,
                        src: "5320:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      },
                      {
                        id: 74361,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74313,
                        src: "5351:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 74362,
                        name: "funding",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74329,
                        src: "5371:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74366,
                              name: "Callbacks",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 84003,
                              src: "5424:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                                typeString: "type(library Callbacks)"
                              }
                            },
                            id: 74367,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "5434:21:115",
                            memberName: "SEND_BASE_TOKENS_FLAG",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83497,
                            src: "5424:31:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          expression: {
                            expression: {
                              id: 74363,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74323,
                              src: "5392:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74364,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "5400:9:115",
                            memberName: "callbacks",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81784,
                            src: "5392:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            }
                          },
                          id: 74365,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "5410:13:115",
                          memberName: "hasPermission",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83984,
                          src: "5392:31:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_uint256_$returns$_t_bool_$attached_to$_t_contract$_ICallback_$82141_$",
                            typeString: "function (contract ICallback,uint256) pure returns (bool)"
                          }
                        },
                        id: 74368,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "5392:64:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        id: 74369,
                        name: "callbackData_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74315,
                        src: "5470:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        },
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      ],
                      expression: {
                        id: 74356,
                        name: "Callbacks",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 84003,
                        src: "5288:9:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                          typeString: "type(library Callbacks)"
                        }
                      },
                      id: 74358,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "5298:8:115",
                      memberName: "onCancel",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83801,
                      src: "5288:18:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ICallback_$82141_$_t_uint96_$_t_uint256_$_t_bool_$_t_bytes_calldata_ptr_$returns$__$",
                        typeString: "function (contract ICallback,uint96,uint256,bool,bytes calldata)"
                      }
                    },
                    id: 74370,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "5288:205:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74371,
                  nodeType: "ExpressionStatement",
                  src: "5288:205:115"
                },
                {
                  expression: {
                    hexValue: "74727565",
                    id: 74372,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "5511:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 74320,
                  id: 74373,
                  nodeType: "Return",
                  src: "5504:11:115"
                }
              ]
            },
            baseFunctions: [75896],
            documentation: {
              id: 74311,
              nodeType: "StructuredDocumentation",
              src: "4233:297:115",
              text: "@inheritdoc AuctionHouse\n @dev        Handles cancellation of a batch auction lot.\n             This function performs the following:\n             - Refunds the base token to the seller (or callback)\n             - Calls the onCancel callback, if configured"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_cancel",
            nameLocation: "4544:7:115",
            overrides: {
              id: 74317,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "4628:8:115"
            },
            parameters: {
              id: 74316,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74313,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "4568:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74375,
                  src: "4561:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74312,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "4561:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74315,
                  mutability: "mutable",
                  name: "callbackData_",
                  nameLocation: "4599:13:115",
                  nodeType: "VariableDeclaration",
                  scope: 74375,
                  src: "4584:28:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_calldata_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 74314,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "4584:5:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4551:67:115"
            },
            returnParameters: {
              id: 74320,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74319,
                  mutability: "mutable",
                  name: "performedCallback",
                  nameLocation: "4651:17:115",
                  nodeType: "VariableDeclaration",
                  scope: 74375,
                  src: "4646:22:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 74318,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "4646:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4645:24:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 74484,
            nodeType: "FunctionDefinition",
            src: "5892:1570:115",
            nodes: [],
            body: {
              id: 74483,
              nodeType: "Block",
              src: "6062:1400:115",
              nodes: [],
              statements: [
                {
                  assignments: [74390],
                  declarations: [
                    {
                      constant: false,
                      id: 74390,
                      mutability: "mutable",
                      name: "routing",
                      nameLocation: "6088:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 74483,
                      src: "6072:23:115",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing"
                      },
                      typeName: {
                        id: 74389,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74388,
                          name: "Routing",
                          nameLocations: ["6072:7:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 81792,
                          src: "6072:7:115"
                        },
                        referencedDeclaration: 81792,
                        src: "6072:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74394,
                  initialValue: {
                    baseExpression: {
                      id: 74391,
                      name: "lotRouting",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75365,
                      src: "6098:10:115",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                      }
                    },
                    id: 74393,
                    indexExpression: {
                      id: 74392,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74378,
                      src: "6109:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "6098:18:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                      typeString: "struct IAuctionHouse.Routing storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6072:44:115"
                },
                {
                  expression: {
                    id: 74399,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 74395,
                        name: "routing",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74390,
                        src: "6160:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing storage pointer"
                        }
                      },
                      id: 74397,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6168:7:115",
                      memberName: "funding",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 81781,
                      src: "6160:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "+=",
                    rightHandSide: {
                      id: 74398,
                      name: "curatorFeePayout_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74380,
                      src: "6179:17:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "6160:36:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 74400,
                  nodeType: "ExpressionStatement",
                  src: "6160:36:115"
                },
                {
                  assignments: [74403],
                  declarations: [
                    {
                      constant: false,
                      id: 74403,
                      mutability: "mutable",
                      name: "baseToken",
                      nameLocation: "6213:9:115",
                      nodeType: "VariableDeclaration",
                      scope: 74483,
                      src: "6207:15:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ERC20_$56264",
                        typeString: "contract ERC20"
                      },
                      typeName: {
                        id: 74402,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74401,
                          name: "ERC20",
                          nameLocations: ["6207:5:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 56264,
                          src: "6207:5:115"
                        },
                        referencedDeclaration: 56264,
                        src: "6207:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74408,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 74405,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74390,
                          src: "6231:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74406,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "6239:9:115",
                        memberName: "baseToken",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81774,
                        src: "6231:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 74404,
                      name: "ERC20",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56264,
                      src: "6225:5:115",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                        typeString: "type(contract ERC20)"
                      }
                    },
                    id: 74407,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6225:24:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6207:42:115"
                },
                {
                  condition: {
                    arguments: [
                      {
                        expression: {
                          id: 74411,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74390,
                          src: "6462:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74412,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "6470:9:115",
                        memberName: "callbacks",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81784,
                        src: "6462:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      },
                      {
                        expression: {
                          id: 74413,
                          name: "Callbacks",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 84003,
                          src: "6481:9:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                            typeString: "type(library Callbacks)"
                          }
                        },
                        id: 74414,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        memberLocation: "6491:21:115",
                        memberName: "SEND_BASE_TOKENS_FLAG",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83497,
                        src: "6481:31:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 74409,
                        name: "Callbacks",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 84003,
                        src: "6438:9:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                          typeString: "type(library Callbacks)"
                        }
                      },
                      id: 74410,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "6448:13:115",
                      memberName: "hasPermission",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83984,
                      src: "6438:23:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_uint256_$returns$_t_bool_$",
                        typeString: "function (contract ICallback,uint256) pure returns (bool)"
                      }
                    },
                    id: 74415,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6438:75:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 74479,
                    nodeType: "Block",
                    src: "7014:390:115",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 74457,
                              name: "baseToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74403,
                              src: "7170:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            {
                              expression: {
                                id: 74458,
                                name: "routing",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74390,
                                src: "7181:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                  typeString: "struct IAuctionHouse.Routing storage pointer"
                                }
                              },
                              id: 74459,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "7189:6:115",
                              memberName: "seller",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 81772,
                              src: "7181:14:115",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              arguments: [
                                {
                                  id: 74462,
                                  name: "this",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: "7205:4:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                ],
                                id: 74461,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "7197:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 74460,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "7197:7:115",
                                  typeDescriptions: {}
                                }
                              },
                              id: 74463,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "7197:13:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 74464,
                              name: "curatorFeePayout_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74380,
                              src: "7212:17:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "66616c7365",
                              id: 74465,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "7231:5:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "false"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            ],
                            expression: {
                              id: 74454,
                              name: "Transfer",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 86134,
                              src: "7131:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                                typeString: "type(library Transfer)"
                              }
                            },
                            id: 74456,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "7140:12:115",
                            memberName: "transferFrom",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 85955,
                            src: "7131:21:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                              typeString: "function (contract ERC20,address,address,uint256,bool)"
                            }
                          },
                          id: 74466,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "7131:119:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74467,
                        nodeType: "ExpressionStatement",
                        src: "7131:119:115"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              expression: {
                                id: 74471,
                                name: "routing",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74390,
                                src: "7326:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                  typeString: "struct IAuctionHouse.Routing storage pointer"
                                }
                              },
                              id: 74472,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "7334:9:115",
                              memberName: "callbacks",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 81784,
                              src: "7326:17:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ICallback_$82141",
                                typeString: "contract ICallback"
                              }
                            },
                            {
                              id: 74473,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74378,
                              src: "7345:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              id: 74474,
                              name: "curatorFeePayout_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74380,
                              src: "7353:17:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "66616c7365",
                              id: 74475,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "7372:5:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "false"
                            },
                            {
                              id: 74476,
                              name: "callbackData_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74382,
                              src: "7379:13:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_calldata_ptr",
                                typeString: "bytes calldata"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_ICallback_$82141",
                                typeString: "contract ICallback"
                              },
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              {
                                typeIdentifier: "t_bytes_calldata_ptr",
                                typeString: "bytes calldata"
                              }
                            ],
                            expression: {
                              id: 74468,
                              name: "Callbacks",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 84003,
                              src: "7307:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                                typeString: "type(library Callbacks)"
                              }
                            },
                            id: 74470,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "7317:8:115",
                            memberName: "onCurate",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83838,
                            src: "7307:18:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ICallback_$82141_$_t_uint96_$_t_uint256_$_t_bool_$_t_bytes_calldata_ptr_$returns$__$",
                              typeString: "function (contract ICallback,uint96,uint256,bool,bytes calldata)"
                            }
                          },
                          id: 74477,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "7307:86:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74478,
                        nodeType: "ExpressionStatement",
                        src: "7307:86:115"
                      }
                    ]
                  },
                  id: 74480,
                  nodeType: "IfStatement",
                  src: "6434:970:115",
                  trueBody: {
                    id: 74453,
                    nodeType: "Block",
                    src: "6515:493:115",
                    statements: [
                      {
                        assignments: [74417],
                        declarations: [
                          {
                            constant: false,
                            id: 74417,
                            mutability: "mutable",
                            name: "balanceBefore",
                            nameLocation: "6537:13:115",
                            nodeType: "VariableDeclaration",
                            scope: 74453,
                            src: "6529:21:115",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 74416,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "6529:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 74425,
                        initialValue: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  id: 74422,
                                  name: "this",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: "6581:4:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                    typeString: "contract BatchAuctionHouse"
                                  }
                                ],
                                id: 74421,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "6573:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 74420,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "6573:7:115",
                                  typeDescriptions: {}
                                }
                              },
                              id: 74423,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "6573:13:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            expression: {
                              id: 74418,
                              name: "baseToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74403,
                              src: "6553:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            id: 74419,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6563:9:115",
                            memberName: "balanceOf",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 55907,
                            src: "6553:19:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                              typeString: "function (address) view external returns (uint256)"
                            }
                          },
                          id: 74424,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6553:34:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "6529:58:115"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              expression: {
                                id: 74429,
                                name: "routing",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74390,
                                src: "6698:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                  typeString: "struct IAuctionHouse.Routing storage pointer"
                                }
                              },
                              id: 74430,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "6706:9:115",
                              memberName: "callbacks",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 81784,
                              src: "6698:17:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ICallback_$82141",
                                typeString: "contract ICallback"
                              }
                            },
                            {
                              id: 74431,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74378,
                              src: "6717:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              id: 74432,
                              name: "curatorFeePayout_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74380,
                              src: "6725:17:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "74727565",
                              id: 74433,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "6744:4:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "true"
                            },
                            {
                              id: 74434,
                              name: "callbackData_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74382,
                              src: "6750:13:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_calldata_ptr",
                                typeString: "bytes calldata"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_ICallback_$82141",
                                typeString: "contract ICallback"
                              },
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              {
                                typeIdentifier: "t_bytes_calldata_ptr",
                                typeString: "bytes calldata"
                              }
                            ],
                            expression: {
                              id: 74426,
                              name: "Callbacks",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 84003,
                              src: "6679:9:115",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                                typeString: "type(library Callbacks)"
                              }
                            },
                            id: 74428,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6689:8:115",
                            memberName: "onCurate",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83838,
                            src: "6679:18:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ICallback_$82141_$_t_uint96_$_t_uint256_$_t_bool_$_t_bytes_calldata_ptr_$returns$__$",
                              typeString: "function (contract ICallback,uint96,uint256,bool,bytes calldata)"
                            }
                          },
                          id: 74435,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6679:85:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74436,
                        nodeType: "ExpressionStatement",
                        src: "6679:85:115"
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 74447,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    id: 74441,
                                    name: "this",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: -28,
                                    src: "6897:4:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                      typeString: "contract BatchAuctionHouse"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_contract$_BatchAuctionHouse_$75148",
                                      typeString: "contract BatchAuctionHouse"
                                    }
                                  ],
                                  id: 74440,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "6889:7:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_address_$",
                                    typeString: "type(address)"
                                  },
                                  typeName: {
                                    id: 74439,
                                    name: "address",
                                    nodeType: "ElementaryTypeName",
                                    src: "6889:7:115",
                                    typeDescriptions: {}
                                  }
                                },
                                id: 74442,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "typeConversion",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "6889:13:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              ],
                              expression: {
                                id: 74437,
                                name: "baseToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74403,
                                src: "6869:9:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_contract$_ERC20_$56264",
                                  typeString: "contract ERC20"
                                }
                              },
                              id: 74438,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "6879:9:115",
                              memberName: "balanceOf",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 55907,
                              src: "6869:19:115",
                              typeDescriptions: {
                                typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                                typeString: "function (address) view external returns (uint256)"
                              }
                            },
                            id: 74443,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6869:34:115",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "<",
                          rightExpression: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 74446,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 74444,
                              name: "balanceBefore",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74417,
                              src: "6906:13:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "+",
                            rightExpression: {
                              id: 74445,
                              name: "curatorFeePayout_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74380,
                              src: "6922:17:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "6906:33:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "6869:70:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 74452,
                        nodeType: "IfStatement",
                        src: "6865:133:115",
                        trueBody: {
                          id: 74451,
                          nodeType: "Block",
                          src: "6941:57:115",
                          statements: [
                            {
                              errorCall: {
                                arguments: [],
                                expression: {
                                  argumentTypes: [],
                                  id: 74448,
                                  name: "InvalidCallback",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 81716,
                                  src: "6966:15:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_error_pure$__$returns$__$",
                                    typeString: "function () pure"
                                  }
                                },
                                id: 74449,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "6966:17:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_tuple$__$",
                                  typeString: "tuple()"
                                }
                              },
                              id: 74450,
                              nodeType: "RevertStatement",
                              src: "6959:24:115"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  expression: {
                    hexValue: "74727565",
                    id: 74481,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "7451:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 74387,
                  id: 74482,
                  nodeType: "Return",
                  src: "7444:11:115"
                }
              ]
            },
            baseFunctions: [76168],
            documentation: {
              id: 74376,
              nodeType: "StructuredDocumentation",
              src: "5570:317:115",
              text: "@inheritdoc AuctionHouse\n @dev        Handles curation approval for a batch auction lot.\n             This function performs the following:\n             - Transfers the required base tokens from the seller (or callback)\n             - Calls the onCurate callback, if configured"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_curate",
            nameLocation: "5901:7:115",
            overrides: {
              id: 74384,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "6020:8:115"
            },
            parameters: {
              id: 74383,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74378,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "5925:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74484,
                  src: "5918:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74377,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "5918:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74380,
                  mutability: "mutable",
                  name: "curatorFeePayout_",
                  nameLocation: "5949:17:115",
                  nodeType: "VariableDeclaration",
                  scope: 74484,
                  src: "5941:25:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 74379,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5941:7:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74382,
                  mutability: "mutable",
                  name: "callbackData_",
                  nameLocation: "5991:13:115",
                  nodeType: "VariableDeclaration",
                  scope: 74484,
                  src: "5976:28:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_calldata_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 74381,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "5976:5:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5908:102:115"
            },
            returnParameters: {
              id: 74387,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74386,
                  mutability: "mutable",
                  name: "performedCallback",
                  nameLocation: "6043:17:115",
                  nodeType: "VariableDeclaration",
                  scope: 74484,
                  src: "6038:22:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 74385,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "6038:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "6037:24:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 74582,
            nodeType: "FunctionDefinition",
            src: "8102:1553:115",
            nodes: [],
            body: {
              id: 74581,
              nodeType: "Block",
              src: "8247:1408:115",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 74499,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "8269:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74500,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "8277:5:115",
                        memberName: "lotId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81923,
                        src: "8269:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 74498,
                      name: "_isLotValid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76047,
                      src: "8257:11:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 74501,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "8257:26:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74502,
                  nodeType: "ExpressionStatement",
                  src: "8257:26:115"
                },
                {
                  assignments: [74504],
                  declarations: [
                    {
                      constant: false,
                      id: 74504,
                      mutability: "mutable",
                      name: "bidder",
                      nameLocation: "8347:6:115",
                      nodeType: "VariableDeclaration",
                      scope: 74581,
                      src: "8339:14:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 74503,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "8339:7:115",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74517,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      id: 74511,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 74505,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "8356:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74506,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "8364:6:115",
                        memberName: "bidder",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81925,
                        src: "8356:14:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        arguments: [
                          {
                            hexValue: "30",
                            id: 74509,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "8382:1:115",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            }
                          ],
                          id: 74508,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "8374:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_address_$",
                            typeString: "type(address)"
                          },
                          typeName: {
                            id: 74507,
                            name: "address",
                            nodeType: "ElementaryTypeName",
                            src: "8374:7:115",
                            typeDescriptions: {}
                          }
                        },
                        id: 74510,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "8374:10:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      src: "8356:28:115",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      expression: {
                        id: 74514,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74488,
                        src: "8400:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                          typeString: "struct IBatchAuctionHouse.BidParams memory"
                        }
                      },
                      id: 74515,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "8408:6:115",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 81925,
                      src: "8400:14:115",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    id: 74516,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "8356:58:115",
                    trueExpression: {
                      expression: {
                        id: 74512,
                        name: "msg",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -15,
                        src: "8387:3:115",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_message",
                          typeString: "msg"
                        }
                      },
                      id: 74513,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "8391:6:115",
                      memberName: "sender",
                      nodeType: "MemberAccess",
                      src: "8387:10:115",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "8339:75:115"
                },
                {
                  expression: {
                    id: 74534,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 74518,
                      name: "bidId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74496,
                      src: "8585:5:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          expression: {
                            id: 74524,
                            name: "params_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74488,
                            src: "8645:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                              typeString: "struct IBatchAuctionHouse.BidParams memory"
                            }
                          },
                          id: 74525,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "8653:5:115",
                          memberName: "lotId",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 81923,
                          src: "8645:13:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 74526,
                          name: "bidder",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74504,
                          src: "8660:6:115",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          expression: {
                            id: 74527,
                            name: "params_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74488,
                            src: "8668:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                              typeString: "struct IBatchAuctionHouse.BidParams memory"
                            }
                          },
                          id: 74528,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "8676:8:115",
                          memberName: "referrer",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 81927,
                          src: "8668:16:115",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          expression: {
                            id: 74529,
                            name: "params_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74488,
                            src: "8686:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                              typeString: "struct IBatchAuctionHouse.BidParams memory"
                            }
                          },
                          id: 74530,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "8694:6:115",
                          memberName: "amount",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 81929,
                          src: "8686:14:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          expression: {
                            id: 74531,
                            name: "params_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74488,
                            src: "8702:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                              typeString: "struct IBatchAuctionHouse.BidParams memory"
                            }
                          },
                          id: 74532,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "8710:11:115",
                          memberName: "auctionData",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 81931,
                          src: "8702:19:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bytes_memory_ptr",
                            typeString: "bytes memory"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_bytes_memory_ptr",
                            typeString: "bytes memory"
                          }
                        ],
                        expression: {
                          arguments: [
                            {
                              expression: {
                                id: 74520,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74488,
                                src: "8613:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                                  typeString: "struct IBatchAuctionHouse.BidParams memory"
                                }
                              },
                              id: 74521,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "8621:5:115",
                              memberName: "lotId",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 81923,
                              src: "8613:13:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 74519,
                            name: "getBatchModuleForId",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 75147,
                            src: "8593:19:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_view$_t_uint96_$returns$_t_contract$_BatchAuctionModule_$89550_$",
                              typeString: "function (uint96) view returns (contract BatchAuctionModule)"
                            }
                          },
                          id: 74522,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "8593:34:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                            typeString: "contract BatchAuctionModule"
                          }
                        },
                        id: 74523,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "8628:3:115",
                        memberName: "bid",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89190,
                        src: "8593:38:115",
                        typeDescriptions: {
                          typeIdentifier: "t_function_external_nonpayable$_t_uint96_$_t_address_$_t_address_$_t_uint256_$_t_bytes_memory_ptr_$returns$_t_uint64_$",
                          typeString: "function (uint96,address,address,uint256,bytes memory) external returns (uint64)"
                        }
                      },
                      id: 74533,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "8593:138:115",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "8585:146:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 74535,
                  nodeType: "ExpressionStatement",
                  src: "8585:146:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 74537,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "9067:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74538,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9075:6:115",
                        memberName: "amount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81929,
                        src: "9067:14:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              baseExpression: {
                                id: 74540,
                                name: "lotRouting",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75365,
                                src: "9101:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                  typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                }
                              },
                              id: 74543,
                              indexExpression: {
                                expression: {
                                  id: 74541,
                                  name: "params_",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 74488,
                                  src: "9112:7:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                                    typeString: "struct IBatchAuctionHouse.BidParams memory"
                                  }
                                },
                                id: 74542,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "9120:5:115",
                                memberName: "lotId",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 81923,
                                src: "9112:13:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "9101:25:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage",
                                typeString: "struct IAuctionHouse.Routing storage ref"
                              }
                            },
                            id: 74544,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "9127:10:115",
                            memberName: "quoteToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81776,
                            src: "9101:36:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74539,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "9095:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 74545,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "9095:43:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74548,
                              name: "params_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74488,
                              src: "9183:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                                typeString: "struct IBatchAuctionHouse.BidParams memory"
                              }
                            },
                            id: 74549,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "9191:11:115",
                            memberName: "permit2Data",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81933,
                            src: "9183:19:115",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          ],
                          expression: {
                            id: 74546,
                            name: "Transfer",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 86134,
                            src: "9152:8:115",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                              typeString: "type(library Transfer)"
                            }
                          },
                          id: 74547,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "9161:21:115",
                          memberName: "decodePermit2Approval",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 86133,
                          src: "9152:30:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_struct$_Permit2Approval_$85804_memory_ptr_$",
                            typeString: "function (bytes memory) pure returns (struct Transfer.Permit2Approval memory)"
                          }
                        },
                        id: 74550,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "9152:51:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Permit2Approval_$85804_memory_ptr",
                          typeString: "struct Transfer.Permit2Approval memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_struct$_Permit2Approval_$85804_memory_ptr",
                          typeString: "struct Transfer.Permit2Approval memory"
                        }
                      ],
                      id: 74536,
                      name: "_collectPayment",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76372,
                      src: "9038:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_contract$_ERC20_$56264_$_t_struct$_Permit2Approval_$85804_memory_ptr_$returns$__$",
                        typeString: "function (uint256,contract ERC20,struct Transfer.Permit2Approval memory)"
                      }
                    },
                    id: 74551,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9038:175:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74552,
                  nodeType: "ExpressionStatement",
                  src: "9038:175:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          baseExpression: {
                            id: 74556,
                            name: "lotRouting",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 75365,
                            src: "9288:10:115",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                              typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                            }
                          },
                          id: 74559,
                          indexExpression: {
                            expression: {
                              id: 74557,
                              name: "params_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74488,
                              src: "9299:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                                typeString: "struct IBatchAuctionHouse.BidParams memory"
                              }
                            },
                            id: 74558,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "9307:5:115",
                            memberName: "lotId",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81923,
                            src: "9299:13:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "9288:25:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage",
                            typeString: "struct IAuctionHouse.Routing storage ref"
                          }
                        },
                        id: 74560,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9314:9:115",
                        memberName: "callbacks",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81784,
                        src: "9288:35:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      },
                      {
                        expression: {
                          id: 74561,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "9337:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74562,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9345:5:115",
                        memberName: "lotId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81923,
                        src: "9337:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 74563,
                        name: "bidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74496,
                        src: "9364:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 74564,
                        name: "bidder",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74504,
                        src: "9383:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        expression: {
                          id: 74565,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "9487:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74566,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9495:6:115",
                        memberName: "amount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81929,
                        src: "9487:14:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 74567,
                        name: "callbackData_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74490,
                        src: "9515:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        },
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      ],
                      expression: {
                        id: 74553,
                        name: "Callbacks",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 84003,
                        src: "9259:9:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                          typeString: "type(library Callbacks)"
                        }
                      },
                      id: 74555,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "9269:5:115",
                      memberName: "onBid",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83921,
                      src: "9259:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ICallback_$82141_$_t_uint96_$_t_uint64_$_t_address_$_t_uint256_$_t_bytes_calldata_ptr_$returns$__$",
                        typeString: "function (contract ICallback,uint96,uint64,address,uint256,bytes calldata)"
                      }
                    },
                    id: 74568,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9259:279:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74569,
                  nodeType: "ExpressionStatement",
                  src: "9259:279:115"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        expression: {
                          id: 74571,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "9580:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74572,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9588:5:115",
                        memberName: "lotId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81923,
                        src: "9580:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 74573,
                        name: "bidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74496,
                        src: "9595:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 74574,
                        name: "bidder",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74504,
                        src: "9602:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        expression: {
                          id: 74575,
                          name: "params_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74488,
                          src: "9610:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                            typeString: "struct IBatchAuctionHouse.BidParams memory"
                          }
                        },
                        id: 74576,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9618:6:115",
                        memberName: "amount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81929,
                        src: "9610:14:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 74570,
                      name: "Bid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74143,
                      src: "9576:3:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint96_$_t_uint96_$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (uint96,uint96,address,uint256)"
                      }
                    },
                    id: 74577,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9576:49:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74578,
                  nodeType: "EmitStatement",
                  src: "9571:54:115"
                },
                {
                  expression: {
                    id: 74579,
                    name: "bidId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 74496,
                    src: "9643:5:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  functionReturnParameters: 74497,
                  id: 74580,
                  nodeType: "Return",
                  src: "9636:12:115"
                }
              ]
            },
            baseFunctions: [81945],
            documentation: {
              id: 74485,
              nodeType: "StructuredDocumentation",
              src: "7520:577:115",
              text: "@inheritdoc IBatchAuctionHouse\n @dev        This function performs the following:\n             - Validates the lot ID\n             - Records the bid on the auction module\n             - Transfers the quote token from the caller\n             - Calls the onBid callback\n             This function reverts if:\n             - `params_.lotId` is invalid\n             - The auction module reverts when creating a bid\n             - The quote token transfer fails\n             - Re-entrancy is detected"
            },
            functionSelector: "6e9c996d",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 74494,
                kind: "modifierInvocation",
                modifierName: {
                  id: 74493,
                  name: "nonReentrant",
                  nameLocations: ["8211:12:115"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 56767,
                  src: "8211:12:115"
                },
                nodeType: "ModifierInvocation",
                src: "8211:12:115"
              }
            ],
            name: "bid",
            nameLocation: "8111:3:115",
            overrides: {
              id: 74492,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "8202:8:115"
            },
            parameters: {
              id: 74491,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74488,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "8141:7:115",
                  nodeType: "VariableDeclaration",
                  scope: 74582,
                  src: "8124:24:115",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_BidParams_$81934_memory_ptr",
                    typeString: "struct IBatchAuctionHouse.BidParams"
                  },
                  typeName: {
                    id: 74487,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 74486,
                      name: "BidParams",
                      nameLocations: ["8124:9:115"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 81934,
                      src: "8124:9:115"
                    },
                    referencedDeclaration: 81934,
                    src: "8124:9:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidParams_$81934_storage_ptr",
                      typeString: "struct IBatchAuctionHouse.BidParams"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74490,
                  mutability: "mutable",
                  name: "callbackData_",
                  nameLocation: "8173:13:115",
                  nodeType: "VariableDeclaration",
                  scope: 74582,
                  src: "8158:28:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_calldata_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 74489,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "8158:5:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "8114:78:115"
            },
            returnParameters: {
              id: 74497,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74496,
                  mutability: "mutable",
                  name: "bidId",
                  nameLocation: "8240:5:115",
                  nodeType: "VariableDeclaration",
                  scope: 74582,
                  src: "8233:12:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 74495,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "8233:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "8232:14:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 74631,
            nodeType: "FunctionDefinition",
            src: "10140:740:115",
            nodes: [],
            body: {
              id: 74630,
              nodeType: "Block",
              src: "10266:614:115",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 74596,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74585,
                        src: "10288:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 74595,
                      name: "_isLotValid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76047,
                      src: "10276:11:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 74597,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "10276:19:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74598,
                  nodeType: "ExpressionStatement",
                  src: "10276:19:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              baseExpression: {
                                id: 74603,
                                name: "lotRouting",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75365,
                                src: "10477:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                  typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                }
                              },
                              id: 74605,
                              indexExpression: {
                                id: 74604,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74585,
                                src: "10488:6:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "10477:18:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage",
                                typeString: "struct IAuctionHouse.Routing storage ref"
                              }
                            },
                            id: 74606,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "10496:10:115",
                            memberName: "quoteToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81776,
                            src: "10477:29:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74602,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "10471:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 74607,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "10471:36:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        expression: {
                          id: 74608,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "10521:3:115",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 74609,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "10525:6:115",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "10521:10:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        arguments: [
                          {
                            id: 74614,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74585,
                            src: "10734:6:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          {
                            id: 74615,
                            name: "bidId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74587,
                            src: "10742:6:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          {
                            id: 74616,
                            name: "index_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74589,
                            src: "10750:6:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          {
                            expression: {
                              id: 74617,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: "10758:3:115",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg"
                              }
                            },
                            id: 74618,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "10762:6:115",
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            src: "10758:10:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            },
                            {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          expression: {
                            arguments: [
                              {
                                id: 74611,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74585,
                                src: "10716:6:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              ],
                              id: 74610,
                              name: "getBatchModuleForId",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 75147,
                              src: "10696:19:115",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_view$_t_uint96_$returns$_t_contract$_BatchAuctionModule_$89550_$",
                                typeString: "function (uint96) view returns (contract BatchAuctionModule)"
                              }
                            },
                            id: 74612,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "10696:27:115",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                              typeString: "contract BatchAuctionModule"
                            }
                          },
                          id: 74613,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "10724:9:115",
                          memberName: "refundBid",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 89259,
                          src: "10696:37:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_external_nonpayable$_t_uint96_$_t_uint64_$_t_uint256_$_t_address_$returns$_t_uint256_$",
                            typeString: "function (uint96,uint64,uint256,address) external returns (uint256)"
                          }
                        },
                        id: 74619,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "10696:73:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        hexValue: "66616c7365",
                        id: 74620,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "10783:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "false"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      expression: {
                        id: 74599,
                        name: "Transfer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86134,
                        src: "10440:8:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                          typeString: "type(library Transfer)"
                        }
                      },
                      id: 74601,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "10449:8:115",
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85890,
                      src: "10440:17:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                        typeString: "function (contract ERC20,address,uint256,bool)"
                      }
                    },
                    id: 74621,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "10440:358:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74622,
                  nodeType: "ExpressionStatement",
                  src: "10440:358:115"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 74624,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74585,
                        src: "10846:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 74625,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74587,
                        src: "10854:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        expression: {
                          id: 74626,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "10862:3:115",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 74627,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "10866:6:115",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "10862:10:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 74623,
                      name: "RefundBid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74151,
                      src: "10836:9:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint96_$_t_uint96_$_t_address_$returns$__$",
                        typeString: "function (uint96,uint96,address)"
                      }
                    },
                    id: 74628,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "10836:37:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74629,
                  nodeType: "EmitStatement",
                  src: "10831:42:115"
                }
              ]
            },
            baseFunctions: [81955],
            documentation: {
              id: 74583,
              nodeType: "StructuredDocumentation",
              src: "9661:474:115",
              text: "@inheritdoc IBatchAuctionHouse\n @dev        This function performs the following:\n             - Validates the lot ID\n             - Refunds the bid on the auction module\n             - Transfers the quote token to the bidder\n             This function reverts if:\n             - The lot ID is invalid\n             - The auction module reverts when cancelling the bid\n             - Re-entrancy is detected"
            },
            functionSelector: "510bd273",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 74593,
                kind: "modifierInvocation",
                modifierName: {
                  id: 74592,
                  name: "nonReentrant",
                  nameLocations: ["10253:12:115"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 56767,
                  src: "10253:12:115"
                },
                nodeType: "ModifierInvocation",
                src: "10253:12:115"
              }
            ],
            name: "refundBid",
            nameLocation: "10149:9:115",
            overrides: {
              id: 74591,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "10244:8:115"
            },
            parameters: {
              id: 74590,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74585,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "10175:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74631,
                  src: "10168:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74584,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "10168:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74587,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "10198:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74631,
                  src: "10191:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 74586,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "10191:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74589,
                  mutability: "mutable",
                  name: "index_",
                  nameLocation: "10222:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74631,
                  src: "10214:14:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 74588,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "10214:7:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "10158:76:115"
            },
            returnParameters: {
              id: 74594,
              nodeType: "ParameterList",
              parameters: [],
              src: "10266:0:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 74783,
            nodeType: "FunctionDefinition",
            src: "11439:2469:115",
            nodes: [],
            body: {
              id: 74782,
              nodeType: "Block",
              src: "11531:2377:115",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 74644,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74634,
                        src: "11553:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 74643,
                      name: "_isLotValid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76047,
                      src: "11541:11:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 74645,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11541:19:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74646,
                  nodeType: "ExpressionStatement",
                  src: "11541:19:115"
                },
                {
                  assignments: [74652, 74654],
                  declarations: [
                    {
                      constant: false,
                      id: 74652,
                      mutability: "mutable",
                      name: "bidClaims",
                      nameLocation: "11747:9:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "11715:41:115",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim[]"
                      },
                      typeName: {
                        baseType: {
                          id: 74650,
                          nodeType: "UserDefinedTypeName",
                          pathNode: {
                            id: 74649,
                            name: "IBatchAuction.BidClaim",
                            nameLocations: ["11715:13:115", "11729:8:115"],
                            nodeType: "IdentifierPath",
                            referencedDeclaration: 82721,
                            src: "11715:22:115"
                          },
                          referencedDeclaration: 82721,
                          src: "11715:22:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                            typeString: "struct IBatchAuction.BidClaim"
                          }
                        },
                        id: 74651,
                        nodeType: "ArrayTypeName",
                        src: "11715:24:115",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_storage_$dyn_storage_ptr",
                          typeString: "struct IBatchAuction.BidClaim[]"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 74654,
                      mutability: "mutable",
                      name: "auctionOutput",
                      nameLocation: "11771:13:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "11758:26:115",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_bytes_memory_ptr",
                        typeString: "bytes"
                      },
                      typeName: {
                        id: 74653,
                        name: "bytes",
                        nodeType: "ElementaryTypeName",
                        src: "11758:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage_ptr",
                          typeString: "bytes"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74662,
                  initialValue: {
                    arguments: [
                      {
                        id: 74659,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74634,
                        src: "11838:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 74660,
                        name: "bidIds_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74637,
                        src: "11846:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                          typeString: "uint64[] calldata"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                          typeString: "uint64[] calldata"
                        }
                      ],
                      expression: {
                        arguments: [
                          {
                            id: 74656,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74634,
                            src: "11820:6:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          ],
                          id: 74655,
                          name: "getBatchModuleForId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 75147,
                          src: "11800:19:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$_t_uint96_$returns$_t_contract$_BatchAuctionModule_$89550_$",
                            typeString: "function (uint96) view returns (contract BatchAuctionModule)"
                          }
                        },
                        id: 74657,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "11800:27:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                          typeString: "contract BatchAuctionModule"
                        }
                      },
                      id: 74658,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "11828:9:115",
                      memberName: "claimBids",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89305,
                      src: "11800:37:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_external_nonpayable$_t_uint96_$_t_array$_t_uint64_$dyn_memory_ptr_$returns$_t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr_$_t_bytes_memory_ptr_$",
                        typeString: "function (uint96,uint64[] memory) external returns (struct IBatchAuction.BidClaim memory[] memory,bytes memory)"
                      }
                    },
                    id: 74661,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11800:54:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr_$_t_bytes_memory_ptr_$",
                      typeString: "tuple(struct IBatchAuction.BidClaim memory[] memory,bytes memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "11714:140:115"
                },
                {
                  assignments: [74665],
                  declarations: [
                    {
                      constant: false,
                      id: 74665,
                      mutability: "mutable",
                      name: "routing",
                      nameLocation: "11922:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "11906:23:115",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing"
                      },
                      typeName: {
                        id: 74664,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74663,
                          name: "Routing",
                          nameLocations: ["11906:7:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 81792,
                          src: "11906:7:115"
                        },
                        referencedDeclaration: 81792,
                        src: "11906:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74669,
                  initialValue: {
                    baseExpression: {
                      id: 74666,
                      name: "lotRouting",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75365,
                      src: "11932:10:115",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                      }
                    },
                    id: 74668,
                    indexExpression: {
                      id: 74667,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74634,
                      src: "11943:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "11932:18:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                      typeString: "struct IAuctionHouse.Routing storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "11906:44:115"
                },
                {
                  assignments: [74672],
                  declarations: [
                    {
                      constant: false,
                      id: 74672,
                      mutability: "mutable",
                      name: "quoteToken",
                      nameLocation: "11966:10:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "11960:16:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ERC20_$56264",
                        typeString: "contract ERC20"
                      },
                      typeName: {
                        id: 74671,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74670,
                          name: "ERC20",
                          nameLocations: ["11960:5:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 56264,
                          src: "11960:5:115"
                        },
                        referencedDeclaration: 56264,
                        src: "11960:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74677,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 74674,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74665,
                          src: "11985:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74675,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "11993:10:115",
                        memberName: "quoteToken",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81776,
                        src: "11985:18:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 74673,
                      name: "ERC20",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56264,
                      src: "11979:5:115",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                        typeString: "type(contract ERC20)"
                      }
                    },
                    id: 74676,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11979:25:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "11960:44:115"
                },
                {
                  assignments: [74679],
                  declarations: [
                    {
                      constant: false,
                      id: 74679,
                      mutability: "mutable",
                      name: "protocolFee",
                      nameLocation: "12047:11:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "12040:18:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      },
                      typeName: {
                        id: 74678,
                        name: "uint48",
                        nodeType: "ElementaryTypeName",
                        src: "12040:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74684,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 74680,
                        name: "lotFees",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75371,
                        src: "12061:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_FeeData_$81803_storage_$",
                          typeString: "mapping(uint96 => struct IAuctionHouse.FeeData storage ref)"
                        }
                      },
                      id: 74682,
                      indexExpression: {
                        id: 74681,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74634,
                        src: "12069:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "12061:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_FeeData_$81803_storage",
                        typeString: "struct IAuctionHouse.FeeData storage ref"
                      }
                    },
                    id: 74683,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "12077:11:115",
                    memberName: "protocolFee",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 81800,
                    src: "12061:27:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12040:48:115"
                },
                {
                  assignments: [74686],
                  declarations: [
                    {
                      constant: false,
                      id: 74686,
                      mutability: "mutable",
                      name: "referrerFee",
                      nameLocation: "12105:11:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "12098:18:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      },
                      typeName: {
                        id: 74685,
                        name: "uint48",
                        nodeType: "ElementaryTypeName",
                        src: "12098:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74691,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 74687,
                        name: "lotFees",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75371,
                        src: "12119:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_FeeData_$81803_storage_$",
                          typeString: "mapping(uint96 => struct IAuctionHouse.FeeData storage ref)"
                        }
                      },
                      id: 74689,
                      indexExpression: {
                        id: 74688,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74634,
                        src: "12127:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "12119:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_FeeData_$81803_storage",
                        typeString: "struct IAuctionHouse.FeeData storage ref"
                      }
                    },
                    id: 74690,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "12135:11:115",
                    memberName: "referrerFee",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 81802,
                    src: "12119:27:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12098:48:115"
                },
                {
                  assignments: [74693],
                  declarations: [
                    {
                      constant: false,
                      id: 74693,
                      mutability: "mutable",
                      name: "bidClaimsLen",
                      nameLocation: "12227:12:115",
                      nodeType: "VariableDeclaration",
                      scope: 74782,
                      src: "12219:20:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 74692,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "12219:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74696,
                  initialValue: {
                    expression: {
                      id: 74694,
                      name: "bidClaims",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74652,
                      src: "12242:9:115",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory[] memory"
                      }
                    },
                    id: 74695,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "12252:6:115",
                    memberName: "length",
                    nodeType: "MemberAccess",
                    src: "12242:16:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12219:39:115"
                },
                {
                  body: {
                    id: 74780,
                    nodeType: "Block",
                    src: "12311:1591:115",
                    statements: [
                      {
                        assignments: [74711],
                        declarations: [
                          {
                            constant: false,
                            id: 74711,
                            mutability: "mutable",
                            name: "bidClaim",
                            nameLocation: "12355:8:115",
                            nodeType: "VariableDeclaration",
                            scope: 74780,
                            src: "12325:38:115",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                              typeString: "struct IBatchAuction.BidClaim"
                            },
                            typeName: {
                              id: 74710,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 74709,
                                name: "IBatchAuction.BidClaim",
                                nameLocations: [
                                  "12325:13:115",
                                  "12339:8:115"
                                ],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 82721,
                                src: "12325:22:115"
                              },
                              referencedDeclaration: 82721,
                              src: "12325:22:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                                typeString: "struct IBatchAuction.BidClaim"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 74715,
                        initialValue: {
                          baseExpression: {
                            id: 74712,
                            name: "bidClaims",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74652,
                            src: "12366:9:115",
                            typeDescriptions: {
                              typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                              typeString: "struct IBatchAuction.BidClaim memory[] memory"
                            }
                          },
                          id: 74714,
                          indexExpression: {
                            id: 74713,
                            name: "i",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74698,
                            src: "12376:1:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "12366:12:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                            typeString: "struct IBatchAuction.BidClaim memory"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "12325:53:115"
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 74719,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              id: 74716,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74711,
                              src: "12657:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 74717,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "12666:6:115",
                            memberName: "payout",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82718,
                            src: "12657:15:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: ">",
                          rightExpression: {
                            hexValue: "30",
                            id: 74718,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "12675:1:115",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "12657:19:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 74753,
                        nodeType: "IfStatement",
                        src: "12653:705:115",
                        trueBody: {
                          id: 74752,
                          nodeType: "Block",
                          src: "12678:680:115",
                          statements: [
                            {
                              expression: {
                                arguments: [
                                  {
                                    id: 74721,
                                    name: "protocolFee",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74679,
                                    src: "12796:11:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    }
                                  },
                                  {
                                    id: 74722,
                                    name: "referrerFee",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74686,
                                    src: "12829:11:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 74723,
                                      name: "bidClaim",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74711,
                                      src: "12862:8:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                        typeString: "struct IBatchAuction.BidClaim memory"
                                      }
                                    },
                                    id: 74724,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "12871:8:115",
                                    memberName: "referrer",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 82714,
                                    src: "12862:17:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 74725,
                                      name: "routing",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74665,
                                      src: "12901:7:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                        typeString: "struct IAuctionHouse.Routing storage pointer"
                                      }
                                    },
                                    id: 74726,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "12909:6:115",
                                    memberName: "seller",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 81772,
                                    src: "12901:14:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    id: 74727,
                                    name: "quoteToken",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74672,
                                    src: "12937:10:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_contract$_ERC20_$56264",
                                      typeString: "contract ERC20"
                                    }
                                  },
                                  {
                                    commonType: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    id: 74732,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftExpression: {
                                      expression: {
                                        id: 74728,
                                        name: "bidClaim",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74711,
                                        src: "12969:8:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                          typeString: "struct IBatchAuction.BidClaim memory"
                                        }
                                      },
                                      id: 74729,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "12978:4:115",
                                      memberName: "paid",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 82716,
                                      src: "12969:13:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "BinaryOperation",
                                    operator: "-",
                                    rightExpression: {
                                      expression: {
                                        id: 74730,
                                        name: "bidClaim",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74711,
                                        src: "12985:8:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                          typeString: "struct IBatchAuction.BidClaim memory"
                                        }
                                      },
                                      id: 74731,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "12994:6:115",
                                      memberName: "refund",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 82720,
                                      src: "12985:15:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "12969:31:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    },
                                    {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    },
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_contract$_ERC20_$56264",
                                      typeString: "contract ERC20"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  ],
                                  id: 74720,
                                  name: "_allocateQuoteFees",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 76602,
                                  src: "12756:18:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_nonpayable$_t_uint48_$_t_uint48_$_t_address_$_t_address_$_t_contract$_ERC20_$56264_$_t_uint256_$returns$_t_uint256_$",
                                    typeString: "function (uint48,uint48,address,address,contract ERC20,uint256) returns (uint256)"
                                  }
                                },
                                id: 74733,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "12756:292:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 74734,
                              nodeType: "ExpressionStatement",
                              src: "12756:292:115"
                            },
                            {
                              id: 74742,
                              nodeType: "UncheckedBlock",
                              src: "13122:85:115",
                              statements: [
                                {
                                  expression: {
                                    id: 74740,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 74735,
                                        name: "routing",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74665,
                                        src: "13154:7:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                          typeString: "struct IAuctionHouse.Routing storage pointer"
                                        }
                                      },
                                      id: 74737,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "13162:7:115",
                                      memberName: "funding",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 81781,
                                      src: "13154:15:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "-=",
                                    rightHandSide: {
                                      expression: {
                                        id: 74738,
                                        name: "bidClaim",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74711,
                                        src: "13173:8:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                          typeString: "struct IBatchAuction.BidClaim memory"
                                        }
                                      },
                                      id: 74739,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "13182:6:115",
                                      memberName: "payout",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 82718,
                                      src: "13173:15:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "13154:34:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  id: 74741,
                                  nodeType: "ExpressionStatement",
                                  src: "13154:34:115"
                                }
                              ]
                            },
                            {
                              expression: {
                                arguments: [
                                  {
                                    expression: {
                                      id: 74744,
                                      name: "bidClaim",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74711,
                                      src: "13286:8:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                        typeString: "struct IBatchAuction.BidClaim memory"
                                      }
                                    },
                                    id: 74745,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "13295:6:115",
                                    memberName: "bidder",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 82712,
                                    src: "13286:15:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 74746,
                                      name: "bidClaim",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74711,
                                      src: "13303:8:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                        typeString: "struct IBatchAuction.BidClaim memory"
                                      }
                                    },
                                    id: 74747,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "13312:6:115",
                                    memberName: "payout",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 82718,
                                    src: "13303:15:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  {
                                    id: 74748,
                                    name: "routing",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74665,
                                    src: "13320:7:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                      typeString: "struct IAuctionHouse.Routing storage pointer"
                                    }
                                  },
                                  {
                                    id: 74749,
                                    name: "auctionOutput",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74654,
                                    src: "13329:13:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bytes_memory_ptr",
                                      typeString: "bytes memory"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    {
                                      typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                      typeString: "struct IAuctionHouse.Routing storage pointer"
                                    },
                                    {
                                      typeIdentifier: "t_bytes_memory_ptr",
                                      typeString: "bytes memory"
                                    }
                                  ],
                                  id: 74743,
                                  name: "_sendPayout",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 76534,
                                  src: "13274:11:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_struct$_Routing_$81792_memory_ptr_$_t_bytes_memory_ptr_$returns$__$",
                                    typeString: "function (address,uint256,struct IAuctionHouse.Routing memory,bytes memory)"
                                  }
                                },
                                id: 74750,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "13274:69:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_tuple$__$",
                                  typeString: "tuple()"
                                }
                              },
                              id: 74751,
                              nodeType: "ExpressionStatement",
                              src: "13274:69:115"
                            }
                          ]
                        }
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 74757,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              id: 74754,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74711,
                              src: "13376:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 74755,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "13385:6:115",
                            memberName: "refund",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82720,
                            src: "13376:15:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: ">",
                          rightExpression: {
                            hexValue: "30",
                            id: 74756,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "13394:1:115",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "13376:19:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 74770,
                        nodeType: "IfStatement",
                        src: "13372:429:115",
                        trueBody: {
                          id: 74769,
                          nodeType: "Block",
                          src: "13397:404:115",
                          statements: [
                            {
                              expression: {
                                arguments: [
                                  {
                                    id: 74761,
                                    name: "quoteToken",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74672,
                                    src: "13734:10:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_contract$_ERC20_$56264",
                                      typeString: "contract ERC20"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 74762,
                                      name: "bidClaim",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74711,
                                      src: "13746:8:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                        typeString: "struct IBatchAuction.BidClaim memory"
                                      }
                                    },
                                    id: 74763,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "13755:6:115",
                                    memberName: "bidder",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 82712,
                                    src: "13746:15:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 74764,
                                      name: "bidClaim",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74711,
                                      src: "13763:8:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                        typeString: "struct IBatchAuction.BidClaim memory"
                                      }
                                    },
                                    id: 74765,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "13772:6:115",
                                    memberName: "refund",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 82720,
                                    src: "13763:15:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  {
                                    hexValue: "66616c7365",
                                    id: 74766,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "bool",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "13780:5:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    },
                                    value: "false"
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_contract$_ERC20_$56264",
                                      typeString: "contract ERC20"
                                    },
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  ],
                                  expression: {
                                    id: 74758,
                                    name: "Transfer",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 86134,
                                    src: "13716:8:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                                      typeString: "type(library Transfer)"
                                    }
                                  },
                                  id: 74760,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "13725:8:115",
                                  memberName: "transfer",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 85890,
                                  src: "13716:17:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                                    typeString: "function (contract ERC20,address,uint256,bool)"
                                  }
                                },
                                id: 74767,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "13716:70:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_tuple$__$",
                                  typeString: "tuple()"
                                }
                              },
                              id: 74768,
                              nodeType: "ExpressionStatement",
                              src: "13716:70:115"
                            }
                          ]
                        }
                      },
                      {
                        eventCall: {
                          arguments: [
                            {
                              id: 74772,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74634,
                              src: "13855:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              baseExpression: {
                                id: 74773,
                                name: "bidIds_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74637,
                                src: "13863:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                  typeString: "uint64[] calldata"
                                }
                              },
                              id: 74775,
                              indexExpression: {
                                id: 74774,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74698,
                                src: "13871:1:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "13863:10:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            {
                              expression: {
                                id: 74776,
                                name: "bidClaim",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74711,
                                src: "13875:8:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                  typeString: "struct IBatchAuction.BidClaim memory"
                                }
                              },
                              id: 74777,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "13884:6:115",
                              memberName: "bidder",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82712,
                              src: "13875:15:115",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 74771,
                            name: "ClaimBid",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74159,
                            src: "13846:8:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_event_nonpayable$_t_uint96_$_t_uint96_$_t_address_$returns$__$",
                              typeString: "function (uint96,uint96,address)"
                            }
                          },
                          id: 74778,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "13846:45:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 74779,
                        nodeType: "EmitStatement",
                        src: "13841:50:115"
                      }
                    ]
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 74703,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 74701,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74698,
                      src: "12288:1:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 74702,
                      name: "bidClaimsLen",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74693,
                      src: "12292:12:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "12288:16:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 74781,
                  initializationExpression: {
                    assignments: [74698],
                    declarations: [
                      {
                        constant: false,
                        id: 74698,
                        mutability: "mutable",
                        name: "i",
                        nameLocation: "12281:1:115",
                        nodeType: "VariableDeclaration",
                        scope: 74781,
                        src: "12273:9:115",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        typeName: {
                          id: 74697,
                          name: "uint256",
                          nodeType: "ElementaryTypeName",
                          src: "12273:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        visibility: "internal"
                      }
                    ],
                    id: 74700,
                    initialValue: {
                      hexValue: "30",
                      id: 74699,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "12285:1:115",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    nodeType: "VariableDeclarationStatement",
                    src: "12273:13:115"
                  },
                  loopExpression: {
                    expression: {
                      id: 74705,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "12306:3:115",
                      subExpression: {
                        id: 74704,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74698,
                        src: "12306:1:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 74706,
                    nodeType: "ExpressionStatement",
                    src: "12306:3:115"
                  },
                  nodeType: "ForStatement",
                  src: "12268:1634:115"
                }
              ]
            },
            baseFunctions: [81964],
            documentation: {
              id: 74632,
              nodeType: "StructuredDocumentation",
              src: "10886:548:115",
              text: "@inheritdoc IBatchAuctionHouse\n @dev        This function performs the following:\n             - Validates the lot ID\n             - Claims the bids on the auction module\n             - Allocates the fees for each successful bid\n             - Transfers the payout and/or refund to each bidder\n             This function reverts if:\n             - The lot ID is invalid\n             - The auction module reverts when claiming the bids\n             - Re-entrancy is detected"
            },
            functionSelector: "0a35511b",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 74641,
                kind: "modifierInvocation",
                modifierName: {
                  id: 74640,
                  name: "nonReentrant",
                  nameLocations: ["11518:12:115"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 56767,
                  src: "11518:12:115"
                },
                nodeType: "ModifierInvocation",
                src: "11518:12:115"
              }
            ],
            name: "claimBids",
            nameLocation: "11448:9:115",
            overrides: {
              id: 74639,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "11509:8:115"
            },
            parameters: {
              id: 74638,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74634,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "11465:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 74783,
                  src: "11458:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74633,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "11458:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74637,
                  mutability: "mutable",
                  name: "bidIds_",
                  nameLocation: "11491:7:115",
                  nodeType: "VariableDeclaration",
                  scope: 74783,
                  src: "11473:25:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                    typeString: "uint64[]"
                  },
                  typeName: {
                    baseType: {
                      id: 74635,
                      name: "uint64",
                      nodeType: "ElementaryTypeName",
                      src: "11473:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    id: 74636,
                    nodeType: "ArrayTypeName",
                    src: "11473:8:115",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                      typeString: "uint64[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11457:42:115"
            },
            returnParameters: {
              id: 74642,
              nodeType: "ParameterList",
              parameters: [],
              src: "11531:0:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 75009,
            nodeType: "FunctionDefinition",
            src: "14474:4311:115",
            nodes: [],
            body: {
              id: 75008,
              nodeType: "Block",
              src: "14733:4052:115",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 74805,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74786,
                        src: "14777:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 74804,
                      name: "_isLotValid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76047,
                      src: "14765:11:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 74806,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14765:19:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74807,
                  nodeType: "ExpressionStatement",
                  src: "14765:19:115"
                },
                {
                  assignments: [74809],
                  declarations: [
                    {
                      constant: false,
                      id: 74809,
                      mutability: "mutable",
                      name: "capacity",
                      nameLocation: "14833:8:115",
                      nodeType: "VariableDeclaration",
                      scope: 75008,
                      src: "14825:16:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 74808,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "14825:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74810,
                  nodeType: "VariableDeclarationStatement",
                  src: "14825:16:115"
                },
                {
                  id: 74842,
                  nodeType: "Block",
                  src: "14851:480:115",
                  statements: [
                    {
                      assignments: [74813],
                      declarations: [
                        {
                          constant: false,
                          id: 74813,
                          mutability: "mutable",
                          name: "module",
                          nameLocation: "15021:6:115",
                          nodeType: "VariableDeclaration",
                          scope: 74842,
                          src: "15002:25:115",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                            typeString: "contract BatchAuctionModule"
                          },
                          typeName: {
                            id: 74812,
                            nodeType: "UserDefinedTypeName",
                            pathNode: {
                              id: 74811,
                              name: "BatchAuctionModule",
                              nameLocations: ["15002:18:115"],
                              nodeType: "IdentifierPath",
                              referencedDeclaration: 89550,
                              src: "15002:18:115"
                            },
                            referencedDeclaration: 89550,
                            src: "15002:18:115",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                              typeString: "contract BatchAuctionModule"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 74817,
                      initialValue: {
                        arguments: [
                          {
                            id: 74815,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74786,
                            src: "15050:6:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          ],
                          id: 74814,
                          name: "getBatchModuleForId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 75147,
                          src: "15030:19:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$_t_uint96_$returns$_t_contract$_BatchAuctionModule_$89550_$",
                            typeString: "function (uint96) view returns (contract BatchAuctionModule)"
                          }
                        },
                        id: 74816,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "15030:27:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                          typeString: "contract BatchAuctionModule"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "15002:55:115"
                    },
                    {
                      expression: {
                        id: 74829,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          components: [
                            {
                              id: 74818,
                              name: "totalIn",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74796,
                              src: "15072:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 74819,
                              name: "totalOut",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74798,
                              src: "15081:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 74820,
                              name: "capacity",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74809,
                              src: "15091:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 74821,
                              name: "finished",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74800,
                              src: "15101:8:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            {
                              id: 74822,
                              name: "auctionOutput",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74802,
                              src: "15111:13:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            }
                          ],
                          id: 74823,
                          isConstant: false,
                          isInlineArray: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: true,
                          nodeType: "TupleExpression",
                          src: "15071:54:115",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                            typeString: "tuple(uint256,uint256,uint256,bool,bytes memory)"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "=",
                        rightHandSide: {
                          arguments: [
                            {
                              id: 74826,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74786,
                              src: "15142:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              id: 74827,
                              name: "num_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74788,
                              src: "15150:4:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              id: 74824,
                              name: "module",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74813,
                              src: "15128:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                                typeString: "contract BatchAuctionModule"
                              }
                            },
                            id: 74825,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "15135:6:115",
                            memberName: "settle",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89404,
                            src: "15128:13:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_external_nonpayable$_t_uint96_$_t_uint256_$returns$_t_uint256_$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                              typeString: "function (uint96,uint256) external returns (uint256,uint256,uint256,bool,bytes memory)"
                            }
                          },
                          id: 74828,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "15128:27:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                            typeString: "tuple(uint256,uint256,uint256,bool,bytes memory)"
                          }
                        },
                        src: "15071:84:115",
                        typeDescriptions: {
                          typeIdentifier: "t_tuple$__$",
                          typeString: "tuple()"
                        }
                      },
                      id: 74830,
                      nodeType: "ExpressionStatement",
                      src: "15071:84:115"
                    },
                    {
                      condition: {
                        commonType: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        id: 74833,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 74831,
                          name: "finished",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74800,
                          src: "15218:8:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          hexValue: "66616c7365",
                          id: 74832,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "bool",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "15230:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          },
                          value: "false"
                        },
                        src: "15218:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      id: 74841,
                      nodeType: "IfStatement",
                      src: "15214:107:115",
                      trueBody: {
                        id: 74840,
                        nodeType: "Block",
                        src: "15237:84:115",
                        statements: [
                          {
                            expression: {
                              components: [
                                {
                                  id: 74834,
                                  name: "totalIn",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 74796,
                                  src: "15263:7:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                {
                                  id: 74835,
                                  name: "totalOut",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 74798,
                                  src: "15272:8:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                {
                                  id: 74836,
                                  name: "finished",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 74800,
                                  src: "15282:8:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_bool",
                                    typeString: "bool"
                                  }
                                },
                                {
                                  id: 74837,
                                  name: "auctionOutput",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 74802,
                                  src: "15292:13:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_bytes_memory_ptr",
                                    typeString: "bytes memory"
                                  }
                                }
                              ],
                              id: 74838,
                              isConstant: false,
                              isInlineArray: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "TupleExpression",
                              src: "15262:44:115",
                              typeDescriptions: {
                                typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                                typeString: "tuple(uint256,uint256,bool,bytes memory)"
                              }
                            },
                            functionReturnParameters: 74803,
                            id: 74839,
                            nodeType: "Return",
                            src: "15255:51:115"
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  assignments: [74845],
                  declarations: [
                    {
                      constant: false,
                      id: 74845,
                      mutability: "mutable",
                      name: "routing",
                      nameLocation: "15482:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 75008,
                      src: "15466:23:115",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing"
                      },
                      typeName: {
                        id: 74844,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74843,
                          name: "Routing",
                          nameLocations: ["15466:7:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 81792,
                          src: "15466:7:115"
                        },
                        referencedDeclaration: 81792,
                        src: "15466:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74849,
                  initialValue: {
                    baseExpression: {
                      id: 74846,
                      name: "lotRouting",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75365,
                      src: "15492:10:115",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                      }
                    },
                    id: 74848,
                    indexExpression: {
                      id: 74847,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74786,
                      src: "15503:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "15492:18:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                      typeString: "struct IAuctionHouse.Routing storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "15466:44:115"
                },
                {
                  assignments: [74852],
                  declarations: [
                    {
                      constant: false,
                      id: 74852,
                      mutability: "mutable",
                      name: "feeData",
                      nameLocation: "15536:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 75008,
                      src: "15520:23:115",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                        typeString: "struct IAuctionHouse.FeeData"
                      },
                      typeName: {
                        id: 74851,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 74850,
                          name: "FeeData",
                          nameLocations: ["15520:7:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 81803,
                          src: "15520:7:115"
                        },
                        referencedDeclaration: 81803,
                        src: "15520:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                          typeString: "struct IAuctionHouse.FeeData"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74856,
                  initialValue: {
                    baseExpression: {
                      id: 74853,
                      name: "lotFees",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75371,
                      src: "15546:7:115",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_FeeData_$81803_storage_$",
                        typeString: "mapping(uint96 => struct IAuctionHouse.FeeData storage ref)"
                      }
                    },
                    id: 74855,
                    indexExpression: {
                      id: 74854,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74786,
                      src: "15554:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "15546:15:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_FeeData_$81803_storage",
                      typeString: "struct IAuctionHouse.FeeData storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "15520:41:115"
                },
                {
                  assignments: [74858],
                  declarations: [
                    {
                      constant: false,
                      id: 74858,
                      mutability: "mutable",
                      name: "totalInLessFees",
                      nameLocation: "15856:15:115",
                      nodeType: "VariableDeclaration",
                      scope: 75008,
                      src: "15848:23:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 74857,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "15848:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74859,
                  nodeType: "VariableDeclarationStatement",
                  src: "15848:23:115"
                },
                {
                  id: 74878,
                  nodeType: "Block",
                  src: "15881:236:115",
                  statements: [
                    {
                      assignments: [null, 74861],
                      declarations: [
                        null,
                        {
                          constant: false,
                          id: 74861,
                          mutability: "mutable",
                          name: "toProtocol",
                          nameLocation: "15906:10:115",
                          nodeType: "VariableDeclaration",
                          scope: 74878,
                          src: "15898:18:115",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          typeName: {
                            id: 74860,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "15898:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 74870,
                      initialValue: {
                        arguments: [
                          {
                            expression: {
                              id: 74863,
                              name: "feeData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74852,
                              src: "15955:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                typeString: "struct IAuctionHouse.FeeData storage pointer"
                              }
                            },
                            id: 74864,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "15963:11:115",
                            memberName: "protocolFee",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81800,
                            src: "15955:19:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            }
                          },
                          {
                            expression: {
                              id: 74865,
                              name: "feeData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74852,
                              src: "15976:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                typeString: "struct IAuctionHouse.FeeData storage pointer"
                              }
                            },
                            id: 74866,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "15984:11:115",
                            memberName: "referrerFee",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81802,
                            src: "15976:19:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            }
                          },
                          {
                            hexValue: "66616c7365",
                            id: 74867,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "bool",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "15997:5:115",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            },
                            value: "false"
                          },
                          {
                            id: 74868,
                            name: "totalIn",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74796,
                            src: "16004:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            },
                            {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            },
                            {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 74862,
                          name: "calculateQuoteFees",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 78284,
                          src: "15936:18:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_uint48_$_t_uint48_$_t_bool_$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
                            typeString: "function (uint48,uint48,bool,uint256) pure returns (uint256,uint256)"
                          }
                        },
                        id: 74869,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "15936:76:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
                          typeString: "tuple(uint256,uint256)"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "15895:117:115"
                    },
                    {
                      id: 74877,
                      nodeType: "UncheckedBlock",
                      src: "16026:81:115",
                      statements: [
                        {
                          expression: {
                            id: 74875,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftHandSide: {
                              id: 74871,
                              name: "totalInLessFees",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74858,
                              src: "16054:15:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "Assignment",
                            operator: "=",
                            rightHandSide: {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 74874,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 74872,
                                name: "totalIn",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74796,
                                src: "16072:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "-",
                              rightExpression: {
                                id: 74873,
                                name: "toProtocol",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74861,
                                src: "16082:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "16072:20:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "16054:38:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 74876,
                          nodeType: "ExpressionStatement",
                          src: "16054:38:115"
                        }
                      ]
                    }
                  ]
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 74880,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74845,
                          src: "16462:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74881,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16470:6:115",
                        memberName: "seller",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81772,
                        src: "16462:14:115",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 74882,
                        name: "totalInLessFees",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74858,
                        src: "16478:15:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74884,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74845,
                              src: "16501:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74885,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "16509:10:115",
                            memberName: "quoteToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81776,
                            src: "16501:18:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74883,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "16495:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 74886,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "16495:25:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        expression: {
                          id: 74887,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74845,
                          src: "16522:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74888,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16530:9:115",
                        memberName: "callbacks",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81784,
                        src: "16522:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      ],
                      id: 74879,
                      name: "_sendPayment",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76410,
                      src: "16449:12:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_contract$_ERC20_$56264_$_t_contract$_ICallback_$82141_$returns$__$",
                        typeString: "function (address,uint256,contract ERC20,contract ICallback)"
                      }
                    },
                    id: 74889,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16449:91:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74890,
                  nodeType: "ExpressionStatement",
                  src: "16449:91:115"
                },
                {
                  assignments: [74892],
                  declarations: [
                    {
                      constant: false,
                      id: 74892,
                      mutability: "mutable",
                      name: "prefundingRefund",
                      nameLocation: "16966:16:115",
                      nodeType: "VariableDeclaration",
                      scope: 75008,
                      src: "16958:24:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 74891,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "16958:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 74893,
                  nodeType: "VariableDeclarationStatement",
                  src: "16958:24:115"
                },
                {
                  id: 74968,
                  nodeType: "Block",
                  src: "16992:1280:115",
                  statements: [
                    {
                      assignments: [74895],
                      declarations: [
                        {
                          constant: false,
                          id: 74895,
                          mutability: "mutable",
                          name: "curatorPayout",
                          nameLocation: "17091:13:115",
                          nodeType: "VariableDeclaration",
                          scope: 74968,
                          src: "17083:21:115",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          typeName: {
                            id: 74894,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "17083:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 74903,
                      initialValue: {
                        arguments: [
                          {
                            expression: {
                              id: 74897,
                              name: "feeData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74852,
                              src: "17144:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                typeString: "struct IAuctionHouse.FeeData storage pointer"
                              }
                            },
                            id: 74898,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "17152:7:115",
                            memberName: "curated",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81796,
                            src: "17144:15:115",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          {
                            expression: {
                              id: 74899,
                              name: "feeData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74852,
                              src: "17161:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                typeString: "struct IAuctionHouse.FeeData storage pointer"
                              }
                            },
                            id: 74900,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "17169:10:115",
                            memberName: "curatorFee",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81798,
                            src: "17161:18:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            }
                          },
                          {
                            id: 74901,
                            name: "totalOut",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74798,
                            src: "17181:8:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            },
                            {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 74896,
                          name: "_calculatePayoutFees",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 78318,
                          src: "17123:20:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_bool_$_t_uint48_$_t_uint256_$returns$_t_uint256_$",
                            typeString: "function (bool,uint48,uint256) pure returns (uint256)"
                          }
                        },
                        id: 74902,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "17123:67:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "17083:107:115"
                    },
                    {
                      condition: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 74906,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 74904,
                          name: "curatorPayout",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74895,
                          src: "17271:13:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: ">",
                        rightExpression: {
                          hexValue: "30",
                          id: 74905,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "17287:1:115",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        },
                        src: "17271:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      id: 74947,
                      nodeType: "IfStatement",
                      src: "17267:783:115",
                      trueBody: {
                        id: 74946,
                        nodeType: "Block",
                        src: "17290:760:115",
                        statements: [
                          {
                            condition: {
                              commonType: {
                                typeIdentifier: "t_bytes7",
                                typeString: "bytes7"
                              },
                              id: 74915,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                arguments: [
                                  {
                                    expression: {
                                      id: 74908,
                                      name: "routing",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74845,
                                      src: "17502:7:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                        typeString: "struct IAuctionHouse.Routing storage pointer"
                                      }
                                    },
                                    id: 74909,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "17510:19:115",
                                    memberName: "derivativeReference",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 81787,
                                    src: "17502:27:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                                      typeString: "Veecode"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                                      typeString: "Veecode"
                                    }
                                  ],
                                  id: 74907,
                                  name: "fromVeecode",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 88193,
                                  src: "17490:11:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_pure$_t_userDefinedValueType$_Veecode_$88084_$returns$_t_bytes7_$",
                                    typeString: "function (Veecode) pure returns (bytes7)"
                                  }
                                },
                                id: 74910,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "17490:40:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_bytes7",
                                  typeString: "bytes7"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "!=",
                              rightExpression: {
                                arguments: [
                                  {
                                    hexValue: "",
                                    id: 74913,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "string",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "17541:2:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                                      typeString: 'literal_string ""'
                                    },
                                    value: ""
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                                      typeString: 'literal_string ""'
                                    }
                                  ],
                                  id: 74912,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "17534:6:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_bytes7_$",
                                    typeString: "type(bytes7)"
                                  },
                                  typeName: {
                                    id: 74911,
                                    name: "bytes7",
                                    nodeType: "ElementaryTypeName",
                                    src: "17534:6:115",
                                    typeDescriptions: {}
                                  }
                                },
                                id: 74914,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "typeConversion",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "17534:10:115",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_bytes7",
                                  typeString: "bytes7"
                                }
                              },
                              src: "17490:54:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            falseBody: {
                              id: 74937,
                              nodeType: "Block",
                              src: "17718:170:115",
                              statements: [
                                {
                                  expression: {
                                    id: 74935,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      baseExpression: {
                                        baseExpression: {
                                          id: 74925,
                                          name: "rewards",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 78220,
                                          src: "17802:7:115",
                                          typeDescriptions: {
                                            typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_contract$_ERC20_$56264_$_t_uint256_$_$",
                                            typeString: "mapping(address => mapping(contract ERC20 => uint256))"
                                          }
                                        },
                                        id: 74932,
                                        indexExpression: {
                                          expression: {
                                            id: 74926,
                                            name: "feeData",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 74852,
                                            src: "17810:7:115",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                              typeString: "struct IAuctionHouse.FeeData storage pointer"
                                            }
                                          },
                                          id: 74927,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "17818:7:115",
                                          memberName: "curator",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 81794,
                                          src: "17810:15:115",
                                          typeDescriptions: {
                                            typeIdentifier: "t_address",
                                            typeString: "address"
                                          }
                                        },
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: "IndexAccess",
                                        src: "17802:24:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_mapping$_t_contract$_ERC20_$56264_$_t_uint256_$",
                                          typeString: "mapping(contract ERC20 => uint256)"
                                        }
                                      },
                                      id: 74933,
                                      indexExpression: {
                                        arguments: [
                                          {
                                            expression: {
                                              id: 74929,
                                              name: "routing",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 74845,
                                              src: "17833:7:115",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                                typeString: "struct IAuctionHouse.Routing storage pointer"
                                              }
                                            },
                                            id: 74930,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: false,
                                            memberLocation: "17841:9:115",
                                            memberName: "baseToken",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 81774,
                                            src: "17833:17:115",
                                            typeDescriptions: {
                                              typeIdentifier: "t_address",
                                              typeString: "address"
                                            }
                                          }
                                        ],
                                        expression: {
                                          argumentTypes: [
                                            {
                                              typeIdentifier: "t_address",
                                              typeString: "address"
                                            }
                                          ],
                                          id: 74928,
                                          name: "ERC20",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 56264,
                                          src: "17827:5:115",
                                          typeDescriptions: {
                                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                                            typeString: "type(contract ERC20)"
                                          }
                                        },
                                        id: 74931,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: "typeConversion",
                                        lValueRequested: false,
                                        nameLocations: [],
                                        names: [],
                                        nodeType: "FunctionCall",
                                        src: "17827:24:115",
                                        tryCall: false,
                                        typeDescriptions: {
                                          typeIdentifier: "t_contract$_ERC20_$56264",
                                          typeString: "contract ERC20"
                                        }
                                      },
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      nodeType: "IndexAccess",
                                      src: "17802:50:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "+=",
                                    rightHandSide: {
                                      id: 74934,
                                      name: "curatorPayout",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74895,
                                      src: "17856:13:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "17802:67:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  id: 74936,
                                  nodeType: "ExpressionStatement",
                                  src: "17802:67:115"
                                }
                              ]
                            },
                            id: 74938,
                            nodeType: "IfStatement",
                            src: "17486:402:115",
                            trueBody: {
                              id: 74924,
                              nodeType: "Block",
                              src: "17546:166:115",
                              statements: [
                                {
                                  expression: {
                                    arguments: [
                                      {
                                        expression: {
                                          id: 74917,
                                          name: "feeData",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 74852,
                                          src: "17638:7:115",
                                          typeDescriptions: {
                                            typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                            typeString: "struct IAuctionHouse.FeeData storage pointer"
                                          }
                                        },
                                        id: 74918,
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        memberLocation: "17646:7:115",
                                        memberName: "curator",
                                        nodeType: "MemberAccess",
                                        referencedDeclaration: 81794,
                                        src: "17638:15:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_address",
                                          typeString: "address"
                                        }
                                      },
                                      {
                                        id: 74919,
                                        name: "curatorPayout",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74895,
                                        src: "17655:13:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      },
                                      {
                                        id: 74920,
                                        name: "routing",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74845,
                                        src: "17670:7:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                          typeString: "struct IAuctionHouse.Routing storage pointer"
                                        }
                                      },
                                      {
                                        id: 74921,
                                        name: "auctionOutput",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 74802,
                                        src: "17679:13:115",
                                        typeDescriptions: {
                                          typeIdentifier: "t_bytes_memory_ptr",
                                          typeString: "bytes memory"
                                        }
                                      }
                                    ],
                                    expression: {
                                      argumentTypes: [
                                        {
                                          typeIdentifier: "t_address",
                                          typeString: "address"
                                        },
                                        {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        },
                                        {
                                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                          typeString: "struct IAuctionHouse.Routing storage pointer"
                                        },
                                        {
                                          typeIdentifier: "t_bytes_memory_ptr",
                                          typeString: "bytes memory"
                                        }
                                      ],
                                      id: 74916,
                                      name: "_sendPayout",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 76534,
                                      src: "17626:11:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_struct$_Routing_$81792_memory_ptr_$_t_bytes_memory_ptr_$returns$__$",
                                        typeString: "function (address,uint256,struct IAuctionHouse.Routing memory,bytes memory)"
                                      }
                                    },
                                    id: 74922,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    kind: "functionCall",
                                    lValueRequested: false,
                                    nameLocations: [],
                                    names: [],
                                    nodeType: "FunctionCall",
                                    src: "17626:67:115",
                                    tryCall: false,
                                    typeDescriptions: {
                                      typeIdentifier: "t_tuple$__$",
                                      typeString: "tuple()"
                                    }
                                  },
                                  id: 74923,
                                  nodeType: "ExpressionStatement",
                                  src: "17626:67:115"
                                }
                              ]
                            }
                          },
                          {
                            id: 74945,
                            nodeType: "UncheckedBlock",
                            src: "17953:83:115",
                            statements: [
                              {
                                expression: {
                                  id: 74943,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  leftHandSide: {
                                    expression: {
                                      id: 74939,
                                      name: "routing",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 74845,
                                      src: "17985:7:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                        typeString: "struct IAuctionHouse.Routing storage pointer"
                                      }
                                    },
                                    id: 74941,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: true,
                                    memberLocation: "17993:7:115",
                                    memberName: "funding",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 81781,
                                    src: "17985:15:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  nodeType: "Assignment",
                                  operator: "-=",
                                  rightHandSide: {
                                    id: 74942,
                                    name: "curatorPayout",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 74895,
                                    src: "18004:13:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  src: "17985:32:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                id: 74944,
                                nodeType: "ExpressionStatement",
                                src: "17985:32:115"
                              }
                            ]
                          }
                        ]
                      }
                    },
                    {
                      assignments: [74949],
                      declarations: [
                        {
                          constant: false,
                          id: 74949,
                          mutability: "mutable",
                          name: "maxCuratorPayout",
                          nameLocation: "18072:16:115",
                          nodeType: "VariableDeclaration",
                          scope: 74968,
                          src: "18064:24:115",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          typeName: {
                            id: 74948,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "18064:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 74957,
                      initialValue: {
                        arguments: [
                          {
                            expression: {
                              id: 74951,
                              name: "feeData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74852,
                              src: "18128:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                typeString: "struct IAuctionHouse.FeeData storage pointer"
                              }
                            },
                            id: 74952,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18136:7:115",
                            memberName: "curated",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81796,
                            src: "18128:15:115",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          {
                            expression: {
                              id: 74953,
                              name: "feeData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74852,
                              src: "18145:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_FeeData_$81803_storage_ptr",
                                typeString: "struct IAuctionHouse.FeeData storage pointer"
                              }
                            },
                            id: 74954,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18153:10:115",
                            memberName: "curatorFee",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81798,
                            src: "18145:18:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            }
                          },
                          {
                            id: 74955,
                            name: "capacity",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74809,
                            src: "18165:8:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            },
                            {
                              typeIdentifier: "t_uint48",
                              typeString: "uint48"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 74950,
                          name: "_calculatePayoutFees",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 78318,
                          src: "18107:20:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_bool_$_t_uint48_$_t_uint256_$returns$_t_uint256_$",
                            typeString: "function (bool,uint48,uint256) pure returns (uint256)"
                          }
                        },
                        id: 74956,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "18107:67:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "18064:110:115"
                    },
                    {
                      expression: {
                        id: 74966,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          id: 74958,
                          name: "prefundingRefund",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74892,
                          src: "18188:16:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "=",
                        rightHandSide: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 74965,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 74963,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 74961,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 74959,
                                name: "capacity",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74809,
                                src: "18207:8:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "-",
                              rightExpression: {
                                id: 74960,
                                name: "totalOut",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 74798,
                                src: "18218:8:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "18207:19:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "+",
                            rightExpression: {
                              id: 74962,
                              name: "maxCuratorPayout",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74949,
                              src: "18229:16:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "18207:38:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "-",
                          rightExpression: {
                            id: 74964,
                            name: "curatorPayout",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74895,
                            src: "18248:13:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "18207:54:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "18188:73:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 74967,
                      nodeType: "ExpressionStatement",
                      src: "18188:73:115"
                    }
                  ]
                },
                {
                  id: 74975,
                  nodeType: "UncheckedBlock",
                  src: "18281:70:115",
                  statements: [
                    {
                      expression: {
                        id: 74973,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          expression: {
                            id: 74969,
                            name: "routing",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 74845,
                            src: "18305:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                              typeString: "struct IAuctionHouse.Routing storage pointer"
                            }
                          },
                          id: 74971,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: true,
                          memberLocation: "18313:7:115",
                          memberName: "funding",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 81781,
                          src: "18305:15:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "-=",
                        rightHandSide: {
                          id: 74972,
                          name: "prefundingRefund",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74892,
                          src: "18324:16:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "18305:35:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 74974,
                      nodeType: "ExpressionStatement",
                      src: "18305:35:115"
                    }
                  ]
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74980,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74845,
                              src: "18397:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74981,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18405:9:115",
                            memberName: "baseToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81774,
                            src: "18397:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74979,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "18391:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 74982,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "18391:24:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              id: 74984,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74845,
                              src: "18467:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74985,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18475:9:115",
                            memberName: "callbacks",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81784,
                            src: "18467:17:115",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            }
                          },
                          {
                            expression: {
                              id: 74986,
                              name: "routing",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 74845,
                              src: "18486:7:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                                typeString: "struct IAuctionHouse.Routing storage pointer"
                              }
                            },
                            id: 74987,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18494:6:115",
                            memberName: "seller",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81772,
                            src: "18486:14:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 74983,
                          name: "_getAddressGivenCallbackBaseTokenFlag",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 76032,
                          src: "18429:37:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_address_$returns$_t_address_$",
                            typeString: "function (contract ICallback,address) pure returns (address)"
                          }
                        },
                        id: 74988,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "18429:72:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 74989,
                        name: "prefundingRefund",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74892,
                        src: "18515:16:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        hexValue: "66616c7365",
                        id: 74990,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "18545:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "false"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      expression: {
                        id: 74976,
                        name: "Transfer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86134,
                        src: "18360:8:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                          typeString: "type(library Transfer)"
                        }
                      },
                      id: 74978,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "18369:8:115",
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85890,
                      src: "18360:17:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                        typeString: "function (contract ERC20,address,uint256,bool)"
                      }
                    },
                    id: 74991,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18360:200:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 74992,
                  nodeType: "ExpressionStatement",
                  src: "18360:200:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 74996,
                          name: "routing",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 74845,
                          src: "18641:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                            typeString: "struct IAuctionHouse.Routing storage pointer"
                          }
                        },
                        id: 74997,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18649:9:115",
                        memberName: "callbacks",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 81784,
                        src: "18641:17:115",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        }
                      },
                      {
                        id: 74998,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74786,
                        src: "18660:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 74999,
                        name: "totalInLessFees",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74858,
                        src: "18668:15:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 75e3,
                        name: "prefundingRefund",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74892,
                        src: "18685:16:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 75001,
                        name: "callbackData_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74790,
                        src: "18703:13:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ICallback_$82141",
                          typeString: "contract ICallback"
                        },
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      ],
                      expression: {
                        id: 74993,
                        name: "Callbacks",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 84003,
                        src: "18609:9:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                          typeString: "type(library Callbacks)"
                        }
                      },
                      id: 74995,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "18619:8:115",
                      memberName: "onSettle",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83958,
                      src: "18609:18:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ICallback_$82141_$_t_uint96_$_t_uint256_$_t_uint256_$_t_bytes_calldata_ptr_$returns$__$",
                        typeString: "function (contract ICallback,uint96,uint256,uint256,bytes calldata)"
                      }
                    },
                    id: 75002,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18609:117:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 75003,
                  nodeType: "ExpressionStatement",
                  src: "18609:117:115"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 75005,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74786,
                        src: "18771:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 75004,
                      name: "Settle",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74163,
                      src: "18764:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint96_$returns$__$",
                        typeString: "function (uint96)"
                      }
                    },
                    id: 75006,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18764:14:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 75007,
                  nodeType: "EmitStatement",
                  src: "18759:19:115"
                }
              ]
            },
            baseFunctions: [81982],
            documentation: {
              id: 74784,
              nodeType: "StructuredDocumentation",
              src: "13914:555:115",
              text: "@inheritdoc IBatchAuctionHouse\n @dev        This function handles the following:\n             - Settles the auction on the auction module\n             - Sends proceeds and/or refund to the seller\n             - Executes the onSettle callback\n             - Allocates the curator fee to the curator\n             This function reverts if:\n             - The lot ID is invalid\n             - The auction module reverts when settling the auction\n             - Re-entrancy is detected"
            },
            functionSelector: "367b02fb",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 74794,
                kind: "modifierInvocation",
                modifierName: {
                  id: 74793,
                  name: "nonReentrant",
                  nameLocations: ["14621:12:115"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 56767,
                  src: "14621:12:115"
                },
                nodeType: "ModifierInvocation",
                src: "14621:12:115"
              }
            ],
            name: "settle",
            nameLocation: "14483:6:115",
            overrides: {
              id: 74792,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "14604:8:115"
            },
            parameters: {
              id: 74791,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74786,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "14506:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14499:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 74785,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "14499:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74788,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "14530:4:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14522:12:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 74787,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14522:7:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74790,
                  mutability: "mutable",
                  name: "callbackData_",
                  nameLocation: "14559:13:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14544:28:115",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_calldata_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 74789,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "14544:5:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14489:89:115"
            },
            returnParameters: {
              id: 74803,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 74796,
                  mutability: "mutable",
                  name: "totalIn",
                  nameLocation: "14659:7:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14651:15:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 74795,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14651:7:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74798,
                  mutability: "mutable",
                  name: "totalOut",
                  nameLocation: "14676:8:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14668:16:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 74797,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14668:7:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74800,
                  mutability: "mutable",
                  name: "finished",
                  nameLocation: "14691:8:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14686:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 74799,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "14686:4:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 74802,
                  mutability: "mutable",
                  name: "auctionOutput",
                  nameLocation: "14714:13:115",
                  nodeType: "VariableDeclaration",
                  scope: 75009,
                  src: "14701:26:115",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 74801,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "14701:5:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14650:78:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 75129,
            nodeType: "FunctionDefinition",
            src: "19497:1981:115",
            nodes: [],
            body: {
              id: 75128,
              nodeType: "Block",
              src: "19558:1920:115",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 75019,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75012,
                        src: "19602:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 75018,
                      name: "_isLotValid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 76047,
                      src: "19590:11:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 75020,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19590:19:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 75021,
                  nodeType: "ExpressionStatement",
                  src: "19590:19:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 75026,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75012,
                        src: "19739:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      expression: {
                        arguments: [
                          {
                            id: 75023,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 75012,
                            src: "19725:6:115",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          ],
                          id: 75022,
                          name: "getBatchModuleForId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 75147,
                          src: "19705:19:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$_t_uint96_$returns$_t_contract$_BatchAuctionModule_$89550_$",
                            typeString: "function (uint96) view returns (contract BatchAuctionModule)"
                          }
                        },
                        id: 75024,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "19705:27:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                          typeString: "contract BatchAuctionModule"
                        }
                      },
                      id: 75025,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19733:5:115",
                      memberName: "abort",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89450,
                      src: "19705:33:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_external_nonpayable$_t_uint96_$returns$__$",
                        typeString: "function (uint96) external"
                      }
                    },
                    id: 75027,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19705:41:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 75028,
                  nodeType: "ExpressionStatement",
                  src: "19705:41:115"
                },
                {
                  assignments: [75031],
                  declarations: [
                    {
                      constant: false,
                      id: 75031,
                      mutability: "mutable",
                      name: "routing",
                      nameLocation: "19854:7:115",
                      nodeType: "VariableDeclaration",
                      scope: 75128,
                      src: "19838:23:115",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing"
                      },
                      typeName: {
                        id: 75030,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 75029,
                          name: "Routing",
                          nameLocations: ["19838:7:115"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 81792,
                          src: "19838:7:115"
                        },
                        referencedDeclaration: 81792,
                        src: "19838:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 75035,
                  initialValue: {
                    baseExpression: {
                      id: 75032,
                      name: "lotRouting",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75365,
                      src: "19864:10:115",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                      }
                    },
                    id: 75034,
                    indexExpression: {
                      id: 75033,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75012,
                      src: "19875:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "19864:18:115",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                      typeString: "struct IAuctionHouse.Routing storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19838:44:115"
                },
                {
                  assignments: [75037],
                  declarations: [
                    {
                      constant: false,
                      id: 75037,
                      mutability: "mutable",
                      name: "refund",
                      nameLocation: "19900:6:115",
                      nodeType: "VariableDeclaration",
                      scope: 75128,
                      src: "19892:14:115",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 75036,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "19892:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 75040,
                  initialValue: {
                    expression: {
                      id: 75038,
                      name: "routing",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75031,
                      src: "19909:7:115",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                        typeString: "struct IAuctionHouse.Routing storage pointer"
                      }
                    },
                    id: 75039,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "19917:7:115",
                    memberName: "funding",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 81781,
                    src: "19909:15:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19892:32:115"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 75043,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 75041,
                      name: "refund",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 75037,
                      src: "19938:6:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 75042,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "19948:1:115",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "19938:11:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 75047,
                  nodeType: "IfStatement",
                  src: "19934:45:115",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 75044,
                        name: "InsufficientFunding",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 74133,
                        src: "19958:19:115",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 75045,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "19958:21:115",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 75046,
                    nodeType: "RevertStatement",
                    src: "19951:28:115"
                  }
                },
                {
                  expression: {
                    id: 75052,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 75048,
                        name: "routing",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75031,
                        src: "19989:7:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage_ptr",
                          typeString: "struct IAuctionHouse.Routing storage pointer"
                        }
                      },
                      id: 75050,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "19997:7:115",
                      memberName: "funding",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 81781,
                      src: "19989:15:115",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "30",
                      id: 75051,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "20007:1:115",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "19989:19:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 75053,
                  nodeType: "ExpressionStatement",
                  src: "19989:19:115"
                },
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              baseExpression: {
                                id: 75058,
                                name: "lotRouting",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75365,
                                src: "20130:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                  typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                }
                              },
                              id: 75060,
                              indexExpression: {
                                id: 75059,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75012,
                                src: "20141:6:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "20130:18:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage",
                                typeString: "struct IAuctionHouse.Routing storage ref"
                              }
                            },
                            id: 75061,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "20149:9:115",
                            memberName: "baseToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81774,
                            src: "20130:28:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 75057,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "20124:5:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 75062,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "20124:35:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        arguments: [
                          {
                            expression: {
                              baseExpression: {
                                id: 75064,
                                name: "lotRouting",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75365,
                                src: "20228:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                  typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                }
                              },
                              id: 75066,
                              indexExpression: {
                                id: 75065,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75012,
                                src: "20239:6:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "20228:18:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage",
                                typeString: "struct IAuctionHouse.Routing storage ref"
                              }
                            },
                            id: 75067,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "20247:9:115",
                            memberName: "callbacks",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81784,
                            src: "20228:28:115",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            }
                          },
                          {
                            expression: {
                              baseExpression: {
                                id: 75068,
                                name: "lotRouting",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75365,
                                src: "20258:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                  typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                }
                              },
                              id: 75070,
                              indexExpression: {
                                id: 75069,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75012,
                                src: "20269:6:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "20258:18:115",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Routing_$81792_storage",
                                typeString: "struct IAuctionHouse.Routing storage ref"
                              }
                            },
                            id: 75071,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "20277:6:115",
                            memberName: "seller",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 81772,
                            src: "20258:25:115",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_contract$_ICallback_$82141",
                              typeString: "contract ICallback"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 75063,
                          name: "_getAddressGivenCallbackBaseTokenFlag",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 76032,
                          src: "20173:37:115",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_address_$returns$_t_address_$",
                            typeString: "function (contract ICallback,address) pure returns (address)"
                          }
                        },
                        id: 75072,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "20173:124:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 75073,
                        name: "refund",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75037,
                        src: "20311:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        hexValue: "66616c7365",
                        id: 75074,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "bool",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "20331:5:115",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        value: "false"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      expression: {
                        id: 75054,
                        name: "Transfer",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 86134,
                        src: "20093:8:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_Transfer_$86134_$",
                          typeString: "type(library Transfer)"
                        }
                      },
                      id: 75056,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20102:8:115",
                      memberName: "transfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85890,
                      src: "20093:17:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_uint256_$_t_bool_$returns$__$",
                        typeString: "function (contract ERC20,address,uint256,bool)"
                      }
                    },
                    id: 75075,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "20093:253:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 75076,
                  nodeType: "ExpressionStatement",
                  src: "20093:253:115"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_contract$_ICallback_$82141",
                      typeString: "contract ICallback"
                    },
                    id: 75087,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 75077,
                          name: "lotRouting",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 75365,
                          src: "20724:10:115",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                            typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                          }
                        },
                        id: 75079,
                        indexExpression: {
                          id: 75078,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 75012,
                          src: "20735:6:115",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "20724:18:115",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Routing_$81792_storage",
                          typeString: "struct IAuctionHouse.Routing storage ref"
                        }
                      },
                      id: 75080,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20743:9:115",
                      memberName: "callbacks",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 81784,
                      src: "20724:28:115",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ICallback_$82141",
                        typeString: "contract ICallback"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      arguments: [
                        {
                          arguments: [
                            {
                              hexValue: "30",
                              id: 75084,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "20774:1:115",
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              },
                              value: "0"
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              }
                            ],
                            id: 75083,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "20766:7:115",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_address_$",
                              typeString: "type(address)"
                            },
                            typeName: {
                              id: 75082,
                              name: "address",
                              nodeType: "ElementaryTypeName",
                              src: "20766:7:115",
                              typeDescriptions: {}
                            }
                          },
                          id: 75085,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "20766:10:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        id: 75081,
                        name: "ICallback",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82141,
                        src: "20756:9:115",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_ICallback_$82141_$",
                          typeString: "type(contract ICallback)"
                        }
                      },
                      id: 75086,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "20756:21:115",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ICallback_$82141",
                        typeString: "contract ICallback"
                      }
                    },
                    src: "20724:53:115",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 75123,
                  nodeType: "IfStatement",
                  src: "20720:723:115",
                  trueBody: {
                    id: 75122,
                    nodeType: "Block",
                    src: "20779:664:115",
                    statements: [
                      {
                        assignments: [75089],
                        declarations: [
                          {
                            constant: false,
                            id: 75089,
                            mutability: "mutable",
                            name: "onCancelCalldata",
                            nameLocation: "20843:16:115",
                            nodeType: "VariableDeclaration",
                            scope: 75122,
                            src: "20830:29:115",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes"
                            },
                            typeName: {
                              id: 75088,
                              name: "bytes",
                              nodeType: "ElementaryTypeName",
                              src: "20830:5:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_storage_ptr",
                                typeString: "bytes"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 75110,
                        initialValue: {
                          arguments: [
                            {
                              expression: {
                                expression: {
                                  id: 75092,
                                  name: "ICallback",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 82141,
                                  src: "20902:9:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_contract$_ICallback_$82141_$",
                                    typeString: "type(contract ICallback)"
                                  }
                                },
                                id: 75093,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                memberLocation: "20912:8:115",
                                memberName: "onCancel",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 82078,
                                src: "20902:18:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_declaration_nonpayable$_t_uint96_$_t_uint256_$_t_bool_$_t_bytes_calldata_ptr_$returns$_t_bytes4_$",
                                  typeString: "function ICallback.onCancel(uint96,uint256,bool,bytes calldata) returns (bytes4)"
                                }
                              },
                              id: 75094,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              memberLocation: "20921:8:115",
                              memberName: "selector",
                              nodeType: "MemberAccess",
                              src: "20902:27:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes4",
                                typeString: "bytes4"
                              }
                            },
                            {
                              id: 75095,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 75012,
                              src: "20947:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              id: 75096,
                              name: "refund",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 75037,
                              src: "20971:6:115",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              arguments: [
                                {
                                  expression: {
                                    id: 75102,
                                    name: "Callbacks",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 84003,
                                    src: "21038:9:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_contract$_Callbacks_$84003_$",
                                      typeString: "type(library Callbacks)"
                                    }
                                  },
                                  id: 75103,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  memberLocation: "21048:21:115",
                                  memberName: "SEND_BASE_TOKENS_FLAG",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83497,
                                  src: "21038:31:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                expression: {
                                  expression: {
                                    baseExpression: {
                                      id: 75097,
                                      name: "lotRouting",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 75365,
                                      src: "20995:10:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                      }
                                    },
                                    id: 75099,
                                    indexExpression: {
                                      id: 75098,
                                      name: "lotId_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 75012,
                                      src: "21006:6:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "20995:18:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                                      typeString: "struct IAuctionHouse.Routing storage ref"
                                    }
                                  },
                                  id: 75100,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "21014:9:115",
                                  memberName: "callbacks",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 81784,
                                  src: "20995:28:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_ICallback_$82141",
                                    typeString: "contract ICallback"
                                  }
                                },
                                id: 75101,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "21024:13:115",
                                memberName: "hasPermission",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 83984,
                                src: "20995:42:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_internal_pure$_t_contract$_ICallback_$82141_$_t_uint256_$returns$_t_bool_$attached_to$_t_contract$_ICallback_$82141_$",
                                  typeString: "function (contract ICallback,uint256) pure returns (bool)"
                                }
                              },
                              id: 75104,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "20995:75:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            {
                              arguments: [
                                {
                                  hexValue: "",
                                  id: 75107,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  kind: "string",
                                  lValueRequested: false,
                                  nodeType: "Literal",
                                  src: "21099:2:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                                    typeString: 'literal_string ""'
                                  },
                                  value: ""
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_stringliteral_c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470",
                                    typeString: 'literal_string ""'
                                  }
                                ],
                                expression: {
                                  id: 75105,
                                  name: "abi",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -1,
                                  src: "21088:3:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_magic_abi",
                                    typeString: "abi"
                                  }
                                },
                                id: 75106,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                memberLocation: "21092:6:115",
                                memberName: "encode",
                                nodeType: "MemberAccess",
                                src: "21088:10:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                                  typeString: "function () pure returns (bytes memory)"
                                }
                              },
                              id: 75108,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "21088:14:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_bytes4",
                                typeString: "bytes4"
                              },
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            ],
                            expression: {
                              id: 75090,
                              name: "abi",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -1,
                              src: "20862:3:115",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_abi",
                                typeString: "abi"
                              }
                            },
                            id: 75091,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "20866:18:115",
                            memberName: "encodeWithSelector",
                            nodeType: "MemberAccess",
                            src: "20862:22:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_abiencodewithselector_pure$_t_bytes4_$returns$_t_bytes_memory_ptr_$",
                              typeString: "function (bytes4) pure returns (bytes memory)"
                            }
                          },
                          id: 75109,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "20862:254:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_bytes_memory_ptr",
                            typeString: "bytes memory"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "20830:286:115"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 75119,
                              name: "onCancelCalldata",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 75089,
                              src: "21415:16:115",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            ],
                            expression: {
                              arguments: [
                                {
                                  expression: {
                                    baseExpression: {
                                      id: 75113,
                                      name: "lotRouting",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 75365,
                                      src: "21380:10:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Routing_$81792_storage_$",
                                        typeString: "mapping(uint96 => struct IAuctionHouse.Routing storage ref)"
                                      }
                                    },
                                    id: 75115,
                                    indexExpression: {
                                      id: 75114,
                                      name: "lotId_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 75012,
                                      src: "21391:6:115",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "21380:18:115",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Routing_$81792_storage",
                                      typeString: "struct IAuctionHouse.Routing storage ref"
                                    }
                                  },
                                  id: 75116,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "21399:9:115",
                                  memberName: "callbacks",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 81784,
                                  src: "21380:28:115",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_ICallback_$82141",
                                    typeString: "contract ICallback"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_ICallback_$82141",
                                    typeString: "contract ICallback"
                                  }
                                ],
                                id: 75112,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "21372:7:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 75111,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "21372:7:115",
                                  typeDescriptions: {}
                                }
                              },
                              id: 75117,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "21372:37:115",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            id: 75118,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "21410:4:115",
                            memberName: "call",
                            nodeType: "MemberAccess",
                            src: "21372:42:115",
                            typeDescriptions: {
                              typeIdentifier: "t_function_barecall_payable$_t_bytes_memory_ptr_$returns$_t_bool_$_t_bytes_memory_ptr_$",
                              typeString: "function (bytes memory) payable returns (bool,bytes memory)"
                            }
                          },
                          id: 75120,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "21372:60:115",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_bool_$_t_bytes_memory_ptr_$",
                            typeString: "tuple(bool,bytes memory)"
                          }
                        },
                        id: 75121,
                        nodeType: "ExpressionStatement",
                        src: "21372:60:115"
                      }
                    ]
                  }
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 75125,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 75012,
                        src: "21464:6:115",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 75124,
                      name: "Abort",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 74167,
                      src: "21458:5:115",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint96_$returns$__$",
                        typeString: "function (uint96)"
                      }
                    },
                    id: 75126,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "21458:13:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 75127,
                  nodeType: "EmitStatement",
                  src: "21453:18:115"
                }
              ]
            },
            baseFunctions: [81988],
            documentation: {
              id: 75010,
              nodeType: "StructuredDocumentation",
              src: "18791:701:115",
              text: "@inheritdoc IBatchAuctionHouse\n @dev        This function handles the following:\n             - Validates the lot id\n             - Aborts the auction on the auction module\n             - Refunds prefunding (in base tokens) to the seller\n             - Calls the onCancel callback\n             This function reverts if:\n             - The lot ID is invalid\n             - The auction module reverts when aborting the auction\n             - The refund amount is zero\n             Note that this function will not revert if the `onCancel` callback reverts.\n @param      lotId_   The lot ID to abort"
            },
            functionSelector: "1ed75f1f",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 75016,
                kind: "modifierInvocation",
                modifierName: {
                  id: 75015,
                  name: "nonReentrant",
                  nameLocations: ["19545:12:115"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 56767,
                  src: "19545:12:115"
                },
                nodeType: "ModifierInvocation",
                src: "19545:12:115"
              }
            ],
            name: "abort",
            nameLocation: "19506:5:115",
            overrides: {
              id: 75014,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "19536:8:115"
            },
            parameters: {
              id: 75013,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 75012,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "19519:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 75129,
                  src: "19512:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 75011,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "19512:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19511:15:115"
            },
            returnParameters: {
              id: 75017,
              nodeType: "ParameterList",
              parameters: [],
              src: "19558:0:115"
            },
            scope: 75148,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 75147,
            nodeType: "FunctionDefinition",
            src: "21536:168:115",
            nodes: [],
            body: {
              id: 75146,
              nodeType: "Block",
              src: "21621:83:115",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                id: 75141,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 75131,
                                src: "21688:6:115",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              ],
                              id: 75140,
                              name: "_getAuctionModuleForId",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 75953,
                              src: "21665:22:115",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_view$_t_uint96_$returns$_t_contract$_AuctionModule_$88011_$",
                                typeString: "function (uint96) view returns (contract AuctionModule)"
                              }
                            },
                            id: 75142,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "21665:30:115",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_AuctionModule_$88011",
                              typeString: "contract AuctionModule"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_contract$_AuctionModule_$88011",
                              typeString: "contract AuctionModule"
                            }
                          ],
                          id: 75139,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "21657:7:115",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_address_$",
                            typeString: "type(address)"
                          },
                          typeName: {
                            id: 75138,
                            name: "address",
                            nodeType: "ElementaryTypeName",
                            src: "21657:7:115",
                            typeDescriptions: {}
                          }
                        },
                        id: 75143,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "21657:39:115",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 75137,
                      name: "BatchAuctionModule",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89550,
                      src: "21638:18:115",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_BatchAuctionModule_$89550_$",
                        typeString: "type(contract BatchAuctionModule)"
                      }
                    },
                    id: 75144,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "21638:59:115",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                      typeString: "contract BatchAuctionModule"
                    }
                  },
                  functionReturnParameters: 75136,
                  id: 75145,
                  nodeType: "Return",
                  src: "21631:66:115"
                }
              ]
            },
            functionSelector: "3ab3f98e",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBatchModuleForId",
            nameLocation: "21545:19:115",
            parameters: {
              id: 75132,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 75131,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "21572:6:115",
                  nodeType: "VariableDeclaration",
                  scope: 75147,
                  src: "21565:13:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 75130,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "21565:6:115",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21564:15:115"
            },
            returnParameters: {
              id: 75136,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 75135,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 75147,
                  src: "21601:18:115",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                    typeString: "contract BatchAuctionModule"
                  },
                  typeName: {
                    id: 75134,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 75133,
                      name: "BatchAuctionModule",
                      nameLocations: ["21601:18:115"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 89550,
                      src: "21601:18:115"
                    },
                    referencedDeclaration: 89550,
                    src: "21601:18:115",
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_BatchAuctionModule_$89550",
                      typeString: "contract BatchAuctionModule"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21600:20:115"
            },
            scope: 75148,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          }
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 74122,
              name: "IBatchAuctionHouse",
              nameLocations: ["1015:18:115"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 81989,
              src: "1015:18:115"
            },
            id: 74123,
            nodeType: "InheritanceSpecifier",
            src: "1015:18:115"
          },
          {
            baseName: {
              id: 74124,
              name: "AuctionHouse",
              nameLocations: ["1035:12:115"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 76603,
              src: "1035:12:115"
            },
            id: 74125,
            nodeType: "InheritanceSpecifier",
            src: "1035:12:115"
          }
        ],
        canonicalName: "BatchAuctionHouse",
        contractDependencies: [],
        contractKind: "contract",
        documentation: {
          id: 74121,
          nodeType: "StructuredDocumentation",
          src: "789:196:115",
          text: "@title      BatchAuctionHouse\n @notice     As its name implies, the BatchAuctionHouse is where batch auctions are created, bid on, and settled. The core protocol logic is implemented here."
        },
        fullyImplemented: true,
        linearizedBaseContracts: [
          75148,
          76603,
          78472,
          56768,
          82455,
          88885,
          55789,
          81989,
          81914
        ],
        name: "BatchAuctionHouse",
        nameLocation: "994:17:115",
        scope: 75149,
        usedErrors: [
          74131,
          74133,
          81708,
          81712,
          81714,
          81716,
          81721,
          82350,
          83522,
          83525,
          85808,
          85810,
          88089,
          88415,
          88422,
          88426,
          88431,
          88436,
          88440
        ]
      }
    ],
    license: "BSL-1.1"
  },
  id: 115
};

// src/abis/sources/EncryptedMarginalPrice.json
var EncryptedMarginalPrice_default = {
  abi: [
    {
      type: "constructor",
      inputs: [
        {
          name: "auctionHouse_",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "INIT",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "PARENT",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "TYPE",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint8",
          internalType: "enum Module.Type"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "VEECODE",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "abort",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "auction",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "params_",
          type: "tuple",
          internalType: "struct IAuction.AuctionParams",
          components: [
            {
              name: "start",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "duration",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "capacityInQuote",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "capacity",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "implParams",
              type: "bytes",
              internalType: "bytes"
            }
          ]
        },
        {
          name: "quoteTokenDecimals_",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "baseTokenDecimals_",
          type: "uint8",
          internalType: "uint8"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "auctionData",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "nextBidId",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "nextDecryptIndex",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "status",
          type: "uint8",
          internalType: "enum IEncryptedMarginalPrice.LotStatus"
        },
        {
          name: "marginalBidId",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "marginalPrice",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "minPrice",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "minFilled",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "minBidSize",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "publicKey",
          type: "tuple",
          internalType: "struct Point",
          components: [
            {
              name: "x",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "y",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        },
        {
          name: "privateKey",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "auctionType",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint8",
          internalType: "enum IAuction.AuctionType"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "bid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidder_",
          type: "address",
          internalType: "address"
        },
        {
          name: "referrer_",
          type: "address",
          internalType: "address"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "auctionData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "bids",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "bidder",
          type: "address",
          internalType: "address"
        },
        {
          name: "amount",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "minAmountOut",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "referrer",
          type: "address",
          internalType: "address"
        },
        {
          name: "status",
          type: "uint8",
          internalType: "enum IEncryptedMarginalPrice.BidStatus"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "cancelAuction",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "capacityInQuote",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "claimBids",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidIds_",
          type: "uint64[]",
          internalType: "uint64[]"
        }
      ],
      outputs: [
        {
          name: "bidClaims",
          type: "tuple[]",
          internalType: "struct IBatchAuction.BidClaim[]",
          components: [
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "paid",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "payout",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "refund",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        },
        {
          name: "auctionOutput",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "decryptAndSortBids",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "num_",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "sortHints_",
          type: "bytes32[]",
          internalType: "bytes32[]"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "decryptBid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "amountOut",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "decryptedBids",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "numBids",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "dedicatedSettlePeriod",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "encryptedBids",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "encryptedAmountOut",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "bidPubKey",
          type: "tuple",
          internalType: "struct Point",
          components: [
            {
              name: "x",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "y",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getAuctionData",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "auctionData_",
          type: "tuple",
          internalType: "struct IEncryptedMarginalPrice.AuctionData",
          components: [
            {
              name: "nextBidId",
              type: "uint64",
              internalType: "uint64"
            },
            {
              name: "nextDecryptIndex",
              type: "uint64",
              internalType: "uint64"
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IEncryptedMarginalPrice.LotStatus"
            },
            {
              name: "marginalBidId",
              type: "uint64",
              internalType: "uint64"
            },
            {
              name: "marginalPrice",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "minPrice",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "minFilled",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "minBidSize",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "publicKey",
              type: "tuple",
              internalType: "struct Point",
              components: [
                {
                  name: "x",
                  type: "uint256",
                  internalType: "uint256"
                },
                {
                  name: "y",
                  type: "uint256",
                  internalType: "uint256"
                }
              ]
            },
            {
              name: "privateKey",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "bidIds",
              type: "uint64[]",
              internalType: "uint64[]"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "bid",
          type: "tuple",
          internalType: "struct IEncryptedMarginalPrice.Bid",
          components: [
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "amount",
              type: "uint96",
              internalType: "uint96"
            },
            {
              name: "minAmountOut",
              type: "uint96",
              internalType: "uint96"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IEncryptedMarginalPrice.BidStatus"
            }
          ]
        },
        {
          name: "encryptedBid",
          type: "tuple",
          internalType: "struct IEncryptedMarginalPrice.EncryptedBid",
          components: [
            {
              name: "encryptedAmountOut",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "bidPubKey",
              type: "tuple",
              internalType: "struct Point",
              components: [
                {
                  name: "x",
                  type: "uint256",
                  internalType: "uint256"
                },
                {
                  name: "y",
                  type: "uint256",
                  internalType: "uint256"
                }
              ]
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBidClaim",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "bidClaim",
          type: "tuple",
          internalType: "struct IBatchAuction.BidClaim",
          components: [
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "paid",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "payout",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "refund",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBidIdAtIndex",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "index_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBidIds",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "startIndex_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "num_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint64[]",
          internalType: "uint64[]"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getLot",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "tuple",
          internalType: "struct IAuction.Lot",
          components: [
            {
              name: "start",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "conclusion",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "quoteTokenDecimals",
              type: "uint8",
              internalType: "uint8"
            },
            {
              name: "baseTokenDecimals",
              type: "uint8",
              internalType: "uint8"
            },
            {
              name: "capacityInQuote",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "capacity",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "sold",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "purchased",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getNextInQueue",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "key_",
          type: "bytes32",
          internalType: "bytes32"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bytes32",
          internalType: "bytes32"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getNumBids",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getNumBidsInQueue",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getPartialFill",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "hasPartialFill",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "partialFill",
          type: "tuple",
          internalType: "struct IEncryptedMarginalPrice.PartialFill",
          components: [
            {
              name: "bidId",
              type: "uint64",
              internalType: "uint64"
            },
            {
              name: "refund",
              type: "uint96",
              internalType: "uint96"
            },
            {
              name: "payout",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "hasEnded",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "isLive",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "isUpcoming",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotAuctionOutput",
      inputs: [
        {
          name: "",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotData",
      inputs: [
        {
          name: "id",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "start",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "conclusion",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "quoteTokenDecimals",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "baseTokenDecimals",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "capacityInQuote",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "capacity",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "sold",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "purchased",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "minAuctionDuration",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "refundBid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "index_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "caller_",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [
        {
          name: "refund",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "remainingCapacity",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "setDedicatedSettlePeriod",
      inputs: [
        {
          name: "period_",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "setMinAuctionDuration",
      inputs: [
        {
          name: "duration_",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "settle",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "num_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "totalIn",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "totalOut",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "capacity",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "finished",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "auctionOutput",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "submitPrivateKey",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "privateKey_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "num_",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "sortHints_",
          type: "bytes32[]",
          internalType: "bytes32[]"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "event",
      name: "BidDecrypted",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint64",
          indexed: true,
          internalType: "uint64"
        },
        {
          name: "amountIn",
          type: "uint96",
          indexed: false,
          internalType: "uint96"
        },
        {
          name: "amountOut",
          type: "uint96",
          indexed: false,
          internalType: "uint96"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "PrivateKeySubmitted",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          indexed: true,
          internalType: "uint96"
        }
      ],
      anonymous: false
    },
    {
      type: "error",
      name: "Auction_AmountLessThanMinimum",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_DedicatedSettlePeriod",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InsufficientCapacity",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_InvalidBidId",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InvalidDuration",
      inputs: [
        {
          name: "duration_",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "minimum_",
          type: "uint48",
          internalType: "uint48"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InvalidKey",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_InvalidLotId",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InvalidParams",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_InvalidStart",
      inputs: [
        {
          name: "start_",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "minimum_",
          type: "uint48",
          internalType: "uint48"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_LotActive",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_LotNotActive",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_LotNotConcluded",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_NotAuthorized",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_NotBidder",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_NotImplemented",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_OnlyLotOwner",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_WrongState",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Bid_WrongState",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ]
    },
    {
      type: "error",
      name: "Module_InvalidParent",
      inputs: [
        {
          name: "parent_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "Module_OnlyInternal",
      inputs: []
    },
    {
      type: "error",
      name: "Module_OnlyParent",
      inputs: [
        {
          name: "caller_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "NotPermitted",
      inputs: [
        {
          name: "caller",
          type: "address",
          internalType: "address"
        }
      ]
    }
  ],
  bytecode: {
    object: "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",
    sourceMap: "954:47746:177:-:0;;;4325:274;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;4374:13;;-1:-1:-1;;;;;11238:21:173;;11234:63;;11268:29;;-1:-1:-1;;;11268:29:173;;-1:-1:-1;;;;;473:32:264;;11268:29:173;;;455:51:264;428:18;;11268:29:173;;;;;;;11234:63;-1:-1:-1;;;;;11308:16:173;;;-1:-1:-1;;4462:18:177::1;:27:::0;;4483:6:::1;-1:-1:-1::0;;4462:27:177;;::::1;::::0;::::1;::::0;;;4562:21:::1;:30:::0;;;;::::1;::::0;;::::1;::::0;;954:47746;;14:290:264;84:6;137:2;125:9;116:7;112:23;108:32;105:52;;;153:1;150;143:12;105:52;179:16;;-1:-1:-1;;;;;224:31:264;;214:42;;204:70;;270:1;267;260:12;204:70;293:5;14:290;-1:-1:-1;;;14:290:264:o;309:203::-;954:47746:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;",
    linkReferences: {}
  },
  deployedBytecode: {
    object: "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",
    sourceMap: "954:47746:177:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;42164:1022;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;5523:191:169;;;;;;:::i;:::-;;:::i;:::-;;;1644:14:264;;1637:22;1619:41;;1607:2;1592:18;5523:191:169;1479:187:264;5217:271:169;;;;;;:::i;:::-;;:::i;5231:438:175:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;:::i;592:48::-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;25124:141:177:-;;;;;;:::i;:::-;;:::i;:::-;;;4673:25:264;;;4661:2;4646:18;25124:141:177;4527:177:264;3759:65:177;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;3759:65:177;;;;-1:-1:-1;;;;;;;;3759:65:177;;;;;;;;;-1:-1:-1;;;3759:65:177;;;;;;;;;;;;;;;;;;;;;;:::i;11114:31:173:-;;;;;;;;-1:-1:-1;;;;;6205:32:264;;;6187:51;;6175:2;6160:18;11114:31:173;6041:203:264;6456:116:169;;;;;;:::i;:::-;;:::i;:::-;;9712:345:175;;;;;;:::i;:::-;;:::i;18410:633:177:-;;;;;;:::i;:::-;;:::i;10499:243:175:-;;;;;;:::i;:::-;;:::i;5915:133:169:-;;;;;;:::i;:::-;-1:-1:-1;;;;;6010:15:169;5987:4;6010:15;;;:7;:15;;;;;:31;-1:-1:-1;;;6010:31:169;;;;;5915:133;6083:114;;;;;;:::i;:::-;;:::i;:::-;;;;;;7331:4:264;7373:3;7362:9;7358:19;7350:27;;7396:14;7456:2;7447:6;7441:13;7437:22;7426:9;7419:41;7528:2;7520:4;7512:6;7508:17;7502:24;7498:33;7491:4;7480:9;7476:20;7469:63;;7600:4;7592;7584:6;7580:17;7574:24;7570:35;7563:4;7552:9;7548:20;7541:65;7674:4;7666;7658:6;7654:17;7648:24;7644:35;7637:4;7626:9;7622:20;7615:65;7750:4;7742:6;7738:17;7732:24;7725:32;7718:40;7711:4;7700:9;7696:20;7689:70;7815:4;7807:6;7803:17;7797:24;7790:4;7779:9;7775:20;7768:54;7878:4;7870:6;7866:17;7860:24;7853:4;7842:9;7838:20;7831:54;7941:4;7933:6;7929:17;7923:24;7916:4;7905:9;7901:20;7894:54;7195:759;;;;;480:32:169;;;;;;;;;;;;8133:14:264;8121:27;;;8103:46;;8091:2;8076:18;480:32:169;7959:196:264;3944:83:177;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;548:44:169:-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;548:44:169;;;;;;;-1:-1:-1;;;548:44:169;;;;;-1:-1:-1;;;548:44:169;;;;;-1:-1:-1;;;548:44:169;;;;;;;;;;;;;;;;8964:14:264;9005:15;;;8987:34;;9057:15;;;;9052:2;9037:18;;9030:43;9121:4;9109:17;;;9089:18;;;9082:45;;;;9163:17;;;;9158:2;9143:18;;9136:45;9225:14;9218:22;9212:3;9197:19;;9190:51;9272:3;9257:19;;9250:35;9316:3;9301:19;;9294:35;9360:3;9345:19;;9338:35;8941:3;8926:19;548:44:169;8629:750:264;4914:268:169;;;;;;:::i;:::-;;:::i;16291:1105:177:-;;;;;;:::i;:::-;;:::i;45645:176::-;;;;;;:::i;:::-;;:::i;:::-;;;-1:-1:-1;;;;;10457:31:264;;;10439:50;;10427:2;10412:18;45645:176:177;10295:200:264;11256:668:177;;;;;;:::i;:::-;;:::i;1351:529:175:-;;;;;;:::i;:::-;;:::i;24921:153:177:-;;;;;;:::i;:::-;;:::i;46072:306::-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;676:109:175:-;761:17;676:109;;;;;;:::i;41362:371:177:-;;;;;;:::i;:::-;;:::i;:::-;;;;13171:14:264;;13164:22;13146:41;;13227:13;;-1:-1:-1;;;;;13223:38:264;13218:2;13203:18;;;13196:66;;;;13308:15;;13302:22;-1:-1:-1;;;;;13298:55:264;13278:18;;;13271:83;13396:15;13390:22;13385:2;13370:18;;13363:50;13133:3;13118:19;41362:371:177;12917:502:264;21130:1755:177;;;;;;:::i;:::-;;:::i;516:35:175:-;;;;;;;;;40419:301:177;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;:::i;5749:131:169:-;;;;;;:::i;:::-;-1:-1:-1;;;;;5849:15:169;5823:7;5849:15;;;:7;:15;;;;;;;;:24;;;5749:131;3790:445;;;;;;:::i;:::-;;:::i;1482:1209::-;;;;;;:::i;:::-;;:::i;736:88::-;782:4;736:88;;;;;;:::i;40860:221:177:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;6967:940:175:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;;;:::i;4632:101:177:-;;;-1:-1:-1;;;20066:58:264;;20054:2;20039:18;4632:101:177;19892:238:264;41863:171:177;;;;;;:::i;:::-;;:::i;4228:51::-;;;;;;:::i;:::-;;;;;;;;;;;;;;3133:55;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;3133:55:177;;;;-1:-1:-1;;;3133:55:177;;;;;;-1:-1:-1;;;3133:55:177;;;;-1:-1:-1;;;3133:55:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;13040:46:173:-;;;:::i;42164:1022:177:-;42295:15;42322:27;42342:6;42322:19;:27::i;:::-;-1:-1:-1;;;;;42386:19:177;;42360:23;42386:19;;;:11;:19;;;;;:26;;42436:13;;42518:18;;;42514:54;;42545:23;;-1:-1:-1;;;42545:23:177;;;;;;;;;;;42514:54;42836:17;42856;42862:11;42856:3;:17;:::i;:::-;42836:37;;42883:11;42904:9;42897:4;:16;:35;;42928:4;42897:35;;;42916:9;42897:35;42883:49;;42985:22;43023:3;-1:-1:-1;;;;;43010:17:177;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;43010:17:177;;42985:42;;43071:9;43066:90;43086:3;43082:1;:7;43066:90;;;43122:6;43129:15;43143:1;43129:11;:15;:::i;:::-;43122:23;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;43122:23:177;43110:6;43117:1;43110:9;;;;;;;;:::i;:::-;-1:-1:-1;;;;;43110:35:177;;;:9;;;;;;;;;;;:35;43091:3;;;;:::i;:::-;;;;43066:90;;;-1:-1:-1;43173:6:177;-1:-1:-1;;;;;42164:1022:177;;;;;;:::o;5523:191:169:-;-1:-1:-1;;;;;5648:15:169;;5586:4;5648:15;;;:7;:15;;;;;:26;;-1:-1:-1;;;5648:26:169;;;;;5628:15;5621:53;;;;;;:86;;-1:-1:-1;;;;;;5678:15:169;;;;;;:7;:15;;;;;;;;:24;;:29;5621:86;5602:105;5523:191;-1:-1:-1;;5523:191:169:o;5217:271::-;-1:-1:-1;;;;;5319:15:169;;5282:4;5319:15;;;:7;:15;;;;;;;:24;;:29;;;;:85;;-1:-1:-1;;;;;;5378:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;5378:26:169;;;;;5359:15;5352:52;;;;5319:85;:152;;;;-1:-1:-1;;;;;;;5450:15:169;;;;;:7;:15;;;;;:21;;;;;5431:15;5424:47;;;;;5217:271::o;5231:438:175:-;5402:27;;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;;;;;;;;11964:62;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;5504:27:175::1;5524:6;5504:19;:27::i;:::-;5541:30;5564:6;5541:22;:30::i;:::-;5635:27;5646:6;5654:7;;5635:10;:27::i;:::-;5628:34;;;;5231:438:::0;;;;;;:::o;592:48::-;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;25124:141:177:-;-1:-1:-1;;;;;25224:21:177;;25198:7;25224:21;;;:13;:21;;;;;5750:12:156;25224:34:177;5661:108:156;6456:116:169;11501:10:173;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;6187:51:264;6160:18;;11530:29:173;6041:203:264;11497:62:173;6535:18:169::1;:30:::0;;-1:-1:-1;;6535:30:169::1;;::::0;;;::::1;::::0;;;::::1;::::0;;6456:116::o;9712:345:175:-;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;6041:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;9822:27:175::1;9842:6;9822:19;:27::i;:::-;9859:35;9887:6;9859:27;:35::i;:::-;9904:38;9935:6;9904:30;:38::i;:::-;9952:27;9972:6;9952:19;:27::i;:::-;-1:-1:-1::0;;;;;39975:19:177;;;;;;:11;:19;;;;;:46;;-1:-1:-1;;;;39975:46:177;-1:-1:-1;;;39975:46:177;;;-1:-1:-1;;;40122:33:177;;;:53;9712:345:175;:::o;10036:14::-:1;9712:345:::0;:::o;18410:633:177:-;18592:27;18612:6;18592:19;:27::i;:::-;18629:31;18653:6;18629:23;:31::i;:::-;18670:26;18689:6;18670:18;:26::i;:::-;18824:17;-1:-1:-1;;;;;18794:19:177;;;;;;:11;:19;;;;;:26;-1:-1:-1;;;18794:26:177;;;;:47;;;;;;;;:::i;:::-;;;:86;;;-1:-1:-1;;;;;;18845:19:177;;;;;;:11;:19;;;;;:30;;;:35;18794:86;18790:158;;;18911:26;;-1:-1:-1;;;18911:26:177;;-1:-1:-1;;;;;22611:39:264;;18911:26:177;;;22593:58:264;22566:18;;18911:26:177;22449:208:264;18790:158:177;18991:45;19011:6;19019:4;19025:10;;18991:19;:45::i;:::-;18410:633;;;;:::o;10499:243:175:-;11501:10:173;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;6187:51:264;6160:18;;11530:29:173;6041:203:264;11497:62:173;10655:6:175::1;10645:7;:16;;;10641:52;;;10670:23;;-1:-1:-1::0;;;10670:23:175::1;;;;;;;;;;;10641:52;10704:21;:31:::0;;-1:-1:-1;;10704:31:175::1;;::::0;;;::::1;::::0;;;::::1;::::0;;10499:243::o;6083:114:169:-;6146:10;;:::i;:::-;-1:-1:-1;;;;;;6175:15:169;;;;;:7;:15;;;;;;;;;6168:22;;;;;;;;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6083:114::o;4914:268::-;-1:-1:-1;;;;;5012:15:169;;4975:4;5012:15;;;:7;:15;;;;;;;:24;;:29;;;;:85;;-1:-1:-1;;;;;;5071:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;5071:26:169;;;;;5052:15;5045:52;;;;5012:85;:153;;;;-1:-1:-1;;;;;;;5144:15:169;;;;;:7;:15;;;;;:21;;;;;5124:15;5117:48;;;;;;4914:268::o;16291:1105:177:-;16485:27;16505:6;16485:19;:27::i;:::-;16522:26;16541:6;16522:18;:26::i;:::-;16558:31;16582:6;16558:23;:31::i;:::-;16599:27;16619:6;16599:19;:27::i;:::-;-1:-1:-1;;;;;16712:19:177;;;;;;:11;:19;;;;;:30;;;:35;16708:74;;16756:26;;-1:-1:-1;;;16756:26:177;;-1:-1:-1;;;;;22611:39:264;;16756:26:177;;;22593:58:264;22566:18;;16756:26:177;22449:208:264;16708:74:177;16945:23;16971:42;16988:11;;;;;;;;16994:1;16988:11;;;;16997:1;16988:11;;;17001;16971:16;:42::i;:::-;-1:-1:-1;;;;;17045:19:177;;17023;17045;;;:11;:19;;;;;;;;;17023:51;;;;;;;;17045:29;;;17023:51;;;;;;;;;;;;;;;;17088:12;;16945:68;;-1:-1:-1;17023:51:177;;17088:24;;;:52;;;17132:6;:8;;;17116:10;:12;;;:24;;17088:52;17084:85;;;17149:20;;-1:-1:-1;;;17149:20:177;;;;;;;;;;;17084:85;-1:-1:-1;;;;;17213:19:177;;;;;;:11;:19;;;;;:30;;:44;;;17301:45;17225:6;17329:4;17335:10;;17301:19;:45::i;:::-;17362:27;;-1:-1:-1;;;;;17362:27:177;;;;;;;;16453:943;;16291:1105;;;;;:::o;45645:176::-;-1:-1:-1;;;;;45780:19:177;;45755:6;45780:19;;;:11;:19;;;;;:26;;:34;;45807:6;;45780:34;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;45780:34:177;45773:41;;45645:176;;;;:::o;11256:668::-;11416:14;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;6041:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;11473:27:177::1;11493:6;11473:19;:27::i;:::-;11510:31;11534:6;11510:23;:31::i;:::-;11551:35;11571:6;11579;11551:19;:35::i;:::-;11596:45;11617:6;11625;11633:7;11596:20;:45::i;:::-;11651:35;11671:6;11679;11651:19;:35::i;:::-;11696:38;11727:6;11696:30;:38::i;:::-;11744:29;11766:6;11744:21;:29::i;:::-;11783:27;11803:6;11783:19;:27::i;:::-;11874:43;11885:6;11893;11901;11909:7;11874:10;:43::i;:::-;11867:50:::0;11256:668;-1:-1:-1;;;;;11256:668:177:o;1351:529:175:-;1555:12;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;6041:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;1610:27:175::1;1630:6;1610:19;:27::i;:::-;1647:31;1671:6;1647:23;:31::i;:::-;1688:29;1710:6;1688:21;:29::i;:::-;1727:27;1747:6;1727:19;:27::i;:::-;1818:55;1823:6;1831:7;1840:9;1851:7;1860:12;;1818:4;:55::i;:::-;1811:62:::0;1351:529;-1:-1:-1;;;;;;;1351:529:175:o;24921:153:177:-;-1:-1:-1;;;;;25032:21:177;;25006:7;25032:21;;;:13;:21;;;;;;;;5575:17:156;;;:12;;:17;;;;;;25032:35:177;5476:123:156;46072:306:177;46177:24;;:::i;:::-;46213:27;46233:6;46213:19;:27::i;:::-;46250:30;46273:6;46250:22;:30::i;:::-;46290:35;46310:6;46318;46290:19;:35::i;:::-;46343:28;46356:6;46364;46343:12;:28::i;41362:371::-;-1:-1:-1;;;;;;;;41448:19:177;-1:-1:-1;;;;;;;;;;;;;;;41515:27:177;41535:6;41515:19;:27::i;:::-;41552:30;41575:6;41552:22;:30::i;:::-;-1:-1:-1;;;;;;;41607:23:177;;;;;;;:15;:23;;;;;;;;;41593:37;;;;;;;;;-1:-1:-1;;;;;41593:37:177;;;;;-1:-1:-1;;;41593:37:177;;;;;;;;;;;;;;;;;;;;;;;41657:22;;;;41362:371::o;21130:1755::-;-1:-1:-1;;;;;21314:19:177;;21232:17;21314:19;;;:11;:19;;;;;:30;;;21418:15;;;21414:54;;21442:26;;-1:-1:-1;;;21442:26:177;;-1:-1:-1;;;;;22611:39:264;;21442:26:177;;;22593:58:264;22566:18;;21442:26:177;22449:208:264;21414:54:177;-1:-1:-1;;;;;21720:12:177;;21698:19;21720:12;;;:4;:12;;;;;;;;-1:-1:-1;;;;;21720:20:177;;;;;;;;;;;21795:21;;;:13;:21;;;;;:29;;;;;;;;:48;;21768:252;;;;;;;21857:39;;;21768:252;;;;;;;;;;;;21977:14;;21952:56;;-1:-1:-1;;;;;;22857:3:264;22914:16;;;22910:25;;21952:56:177;;;22898:38:264;;;;-1:-1:-1;;;;;;22974:2:264;22970:15;;;;22952:12;;;22945:75;-1:-1:-1;;;21993:14:177;;;23054:16:264;;;;23036:12;;;23029:47;;;;21768:252:177;;21910:10;;23092:12:264;;21952:56:177;;;;;;;;;;;;21942:67;;;;;;21934:76;;21768:13;:252::i;:::-;22719:3;22708:14;;;22849:18;22841:27;;;;-1:-1:-1;;;;;;21130:1755:177:o;40419:301::-;40510:14;;:::i;:::-;40526:32;;:::i;:::-;40570:27;40590:6;40570:19;:27::i;:::-;40607:35;40627:6;40635;40607:19;:35::i;:::-;-1:-1:-1;;;;;40661:12:177;;;;;;;:4;:12;;;;;;;;-1:-1:-1;;;;;40661:20:177;;;;;;;;;;;40683:21;;;:13;:21;;;;;:29;;;;;;;;;40653:60;;;;;;;;;-1:-1:-1;;;;;40653:60:177;;;;;-1:-1:-1;;;40653:60:177;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;40653:60:177;;;;;;;;;;;;;40661:20;;40683:29;40661:20;;40653:60;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;-1:-1:-1;40653:60:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;40653:60:177;-1:-1:-1;;40419:301:177;;;;;;:::o;3790:445:169:-;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;6041:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;3899:27:169::1;3919:6;3899:19;:27::i;:::-;3936:29;3958:6;3936:21;:29::i;:::-;4063:22;4078:6;4063:14;:22::i;:::-;-1:-1:-1::0;;;;;4136:15:169::1;4118;4136::::0;;;:7:::1;:15;::::0;;;;;;4162:40;;-1:-1:-1;;4162:40:169::1;-1:-1:-1::0;;;4186:15:169::1;4162:40;;;;::::0;;4212:12:::1;:16:::0;3790:445::o;1482:1209::-;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;6041:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;1740:13:169;;:17:::1;;::::0;;;;:60:::1;;-1:-1:-1::0;1761:13:169;;:39:::1;1784:15;1761:39:::0;::::1;::::0;::::1;;1740:60;1736:158;;;1844:13:::0;;1823:60:::1;::::0;-1:-1:-1;;;1823:60:169;;23295:14:264;23336:15;;;1823:60:169::1;::::0;::::1;23318:34:264::0;1866:15:169::1;23388::264::0;;;23368:18;;;23361:43;23258:18;;1823:60:169::1;23115:295:264::0;1736:158:169::1;1977:18;::::0;1958:16:::1;::::0;::::1;::::0;1977:18:::1;::::0;;::::1;1958:37:::0;::::1;;1954:136;;;2042:16;::::0;::::1;::::0;2060:18:::1;::::0;2018:61:::1;::::0;-1:-1:-1;;;2018:61:169;;2060:18:::1;23336:15:264::0;;;2018:61:169::1;::::0;::::1;23318:34:264::0;2060:18:169;::::1;23368::264::0;;;23361:43;23258:18;;2018:61:169::1;23115:295:264::0;1954:136:169::1;2135:14;;:::i;:::-;2171:13:::0;;:18:::1;;::::0;:60:::1;;2218:13:::0;;2171:60:::1;;;2199:15;2171:60;2159:72;;::::0;;;2270:16:::1;::::0;::::1;::::0;2258:28:::1;::::0;::::1;:::i;:::-;2241:45;;:14;::::0;::::1;:45:::0;2296:44:::1;::::0;;::::1;:22;::::0;;::::1;:44:::0;;;;2350:42;;::::1;:21;::::0;;::::1;:42:::0;;;;2424:23;;::::1;::::0;2402:45:::1;;:19;::::0;;::::1;:45:::0;;;;2472:16;;::::1;::::0;2457:12:::1;::::0;::::1;:31:::0;2607:18;::::1;::::0;2585:41:::1;::::0;2594:6;;2241:3;;2585:8:::1;:41::i;:::-;-1:-1:-1::0;;;;;2663:15:169;;;::::1;;::::0;;;:7:::1;:15;::::0;;;;;;;;:21;;;;;;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;::::1;-1:-1:-1::0;;;;;;2663:21:169;;;;;;;-1:-1:-1;;;2663:21:169;;;::::1;::::0;;;::::1;::::0;;;::::1;-1:-1:-1::0;;;;2663:21:169;-1:-1:-1;;;2663:21:169::1;::::0;;::::1;;-1:-1:-1::0;;;;2663:21:169;;-1:-1:-1;;;2663:21:169;;;::::1;::::0;;;::::1;::::0;;;::::1;-1:-1:-1::0;;;;2663:21:169::1;-1:-1:-1::0;;;2663:21:169;::::1;;::::0;;;::::1;;::::0;;::::1;::::0;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;::::1;::::0;::::1;::::0;;::::1;::::0;;;;-1:-1:-1;;;1482:1209:169:o;40860:221:177:-;40963:31;;:::i;:::-;41010:27;41030:6;41010:19;:27::i;:::-;-1:-1:-1;;;;;41055:19:177;;;;;;:11;:19;;;;;;;;;41048:26;;;;;;;;;-1:-1:-1;;;;;41048:26:177;;;;;-1:-1:-1;;;41048:26:177;;;;;;;;;;;41055:19;;41048:26;;;;-1:-1:-1;;;41048:26:177;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;-1:-1:-1;;;41048:26:177;;-1:-1:-1;;;;;41048:26:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;41048:26:177;-1:-1:-1;;;;;41048:26:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;40860:221;;;:::o;6967:940:175:-;7135:15;;;;7251:26;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;6187:51:264;6160:18;;11997:29:173;6041:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;7333:27:175::1;7353:6;7333:19;:27::i;:::-;7370:31;7394:6;7370:23;:31::i;:::-;7411:26;7430:6;7411:18;:26::i;:::-;7447:27;7467:6;7447:19;:27::i;:::-;-1:-1:-1::0;;;;;7503:15:175;::::1;7485;7503::::0;;;:7:::1;:15;::::0;;;;7622:21:::1;7511:6:::0;7638:4;7622:7:::1;:21::i;:::-;-1:-1:-1::0;;;;;7698:15:175;::::1;;::::0;;;:7:::1;:15;::::0;;;;;;;:25:::1;::::0;;::::1;:35:::0;;;7743:20:::1;::::0;;::::1;:31:::0;;;7784:24;;;;;7575:68;;-1:-1:-1;7575:68:175;;-1:-1:-1;7575:68:175;-1:-1:-1;7575:68:175;-1:-1:-1;7784:40:175::1;7575:68:::0;7784:24;:40:::1;:::i;:::-;-1:-1:-1::0;7862:12:175::1;;::::0;;-1:-1:-1;6967:940:175;;;;;;;;:::o;41863:171:177:-;41930:7;41949:27;41969:6;41949:19;:27::i;:::-;-1:-1:-1;;;;;;41994:19:177;;;;;:11;:19;;;;;:26;;:33;;41863:171::o;13040:46:173:-;11501:10;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;6187:51:264;6160:18;;11530:29:173;6041:203:264;11497:62:173;13040:46::o;6862:150:169:-;-1:-1:-1;;;;;6942:15:169;;;;;;:7;:15;;;;;:21;;;:26;;6938:67;;6977:28;;-1:-1:-1;;;6977:28:169;;-1:-1:-1;;;;;22611:39:264;;6977:28:169;;;22593:58:264;22566:18;;6977:28:169;22449:208:264;47411:232:177;47560:17;-1:-1:-1;;;;;47530:19:177;;;;;;:11;:19;;;;;:26;-1:-1:-1;;;47530:26:177;;;;:47;;;;;;;;:::i;:::-;;47526:111;;47600:26;;-1:-1:-1;;;47600:26:177;;-1:-1:-1;;;;;22611:39:264;;47600:26:177;;;22593:58:264;22566:18;;47600:26:177;22449:208:264;15261:542:177;15372:27;;15454:7;;-1:-1:-1;;;;;15490:19:177;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;15478:31;;15524:9;15519:233;15539:3;15535:1;:7;15519:233;;;15587:39;15607:6;15615:7;;15623:1;15615:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;15587:19;:39::i;:::-;15640;15660:6;15668:7;;15676:1;15668:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;15640:19;:39::i;:::-;15712:29;15722:6;15730:7;;15738:1;15730:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;15712:9;:29::i;:::-;15694:47;15695:9;15705:1;15695:12;;;;;;;;:::i;:::-;;;;;;15694:47;;;;15544:3;;;;;:::i;:::-;;;;15519:233;;;;15762:34;15261:542;;;;;;:::o;7793:243:169:-;-1:-1:-1;;;;;7907:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;7907:26:169;;;;;7888:15;7881:52;;;;:84;;;;-1:-1:-1;;;;;;7937:15:169;;7964:1;7937:15;;;:7;:15;;;;;;;;:24;;:28;;7881:84;7877:153;;;7988:31;;-1:-1:-1;;;7988:31:169;;-1:-1:-1;;;;;22611:39:264;;7988:31:169;;;22593:58:264;22566:18;;7988:31:169;22449:208:264;12721:417:175;-1:-1:-1;;;;;12882:15:175;;12862:17;12882:15;;;:7;:15;;;;;:26;;-1:-1:-1;;;12882:26:175;;;;;;12942:15;12935:37;;-1:-1:-1;12935:37:175;;;:117;;-1:-1:-1;13031:21:175;;13018:34;;13031:21;;13018:10;:34;:::i;:::-;12992:60;;12999:15;12992:60;;;12935:117;12918:214;;;13084:37;;-1:-1:-1;;;13084:37:175;;-1:-1:-1;;;;;22611:39:264;;13084:37:175;;;22593:58:264;22566:18;;13084:37:175;22449:208:264;12918:214:175;12790:348;12721:417;:::o;47133:233:177:-;47283:17;-1:-1:-1;;;;;47253:19:177;;;;;;:11;:19;;;;;:26;-1:-1:-1;;;47253:26:177;;;;:47;;;;;;;;:::i;:::-;;47249:111;;47323:26;;-1:-1:-1;;;47323:26:177;;-1:-1:-1;;;;;22611:39:264;;47323:26:177;;;22593:58:264;22566:18;;47323:26:177;22449:208:264;7159:175:169;-1:-1:-1;;;;;7269:15:169;;;;;;:7;:15;;;;;:21;;;;;7250:15;7243:47;;;;7239:88;;;7299:28;;-1:-1:-1;;;7299:28:169;;-1:-1:-1;;;;;22611:39:264;;7299:28:169;;;22593:58:264;22566:18;;7299:28:169;22449:208:264;46462:315:177;46585:17;-1:-1:-1;;;;;46555:19:177;;;;;;:11;:19;;;;;:26;-1:-1:-1;;;46555:26:177;;;;:47;;;;;;;;:::i;:::-;;:107;;;;-1:-1:-1;;;;;;46622:15:177;;;;;;:7;:15;;;;;:21;46647:15;46622:21;;;;:40;;46555:107;:171;;;;-1:-1:-1;;;;;;46682:15:177;;;;;;:7;:15;;;;;:26;46711:15;-1:-1:-1;;;46682:26:177;;;;;:44;46555:171;46538:232;;;46744:26;;-1:-1:-1;;;46744:26:177;;-1:-1:-1;;;;;22611:39:264;;46744:26:177;;;22593:58:264;22566:18;;46744:26:177;22449:208:264;19049:1749:177;-1:-1:-1;;;;;19264:19:177;;19238:23;19264:19;;;:11;:19;;;;;:36;-1:-1:-1;;;;;;;;19264:36:177;;;;;;19378:25;;;;19374:61;;19412:23;;-1:-1:-1;;;19412:23:177;;;;;;;;;;;19374:61;-1:-1:-1;;;;;19636:19:177;;19610:23;19636:19;;;:11;:19;;;;;:26;;19683:13;;:32;;-1:-1:-1;;;;;19683:32:177;;;;:::i;:::-;19676:4;-1:-1:-1;;;;;19676:39:177;;19672:117;;;19745:13;;19738:40;;19762:16;;19738:40;:::i;:::-;19731:47;;19672:117;-1:-1:-1;;;;;19958:15:177;;19932:17;19958:15;;;:7;:15;;;;;:33;19952:39;;-1:-1:-1;;;19958:33:177;;;;19952:2;:39;:::i;:::-;19932:59;;20279:8;20274:205;20293:4;-1:-1:-1;;;;;20289:8:177;:1;-1:-1:-1;;;;;20289:8:177;;20274:205;;;20396:72;20405:6;20413;20420:20;20439:1;20420:16;:20;:::i;:::-;-1:-1:-1;;;;;20413:28:177;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;20413:28:177;20443:10;;20454:1;-1:-1:-1;;;;;20443:13:177;;;;;;;;:::i;:::-;;;;;;;20458:9;20396:8;:72::i;:::-;20299:3;;;;:::i;:::-;;;;20274:205;;;-1:-1:-1;;;;;;20529:19:177;;;;;;:11;:19;;;;;:44;;20569:4;;20529:19;:36;;:44;;20569:4;;-1:-1:-1;;;20529:44:177;;-1:-1:-1;;;;;20529:44:177;;:::i;:::-;;;;;;;;-1:-1:-1;;;;;20529:44:177;;;;;;;;;;;;;;;20704:13;;-1:-1:-1;;;;;20664:19:177;;-1:-1:-1;20664:19:177;;;:11;:19;;;;;:36;-1:-1:-1;;;20664:36:177;;;;;:53;;-1:-1:-1;20660:132:177;;-1:-1:-1;;;;;20733:19:177;;;;;;:11;:19;;;;;:48;;-1:-1:-1;;;;20733:48:177;-1:-1:-1;;;20733:48:177;;;20660:132;19176:1622;;;19049:1749;;;;:::o;6497:466:154:-;-1:-1:-1;;;;;;;;;;;;;;;;;6683:21:154;6693:10;6683:9;:21::i;:::-;6678:62;;6706:34;;-1:-1:-1;;;6706:34:154;;28155:2:264;6706:34:154;;;28137:21:264;28194:2;28174:18;;;28167:30;28233:26;28213:18;;;28206:54;28277:18;;6706:34:154;27953:348:264;6678:62:154;1747:102;6829:11;:26;;:46;;;-1:-1:-1;6859:16:154;;6829:46;6825:82;;;6877:30;;-1:-1:-1;;;6877:30:154;;28508:2:264;6877:30:154;;;28490:21:264;28547:2;28527:18;;;28520:30;-1:-1:-1;;;28566:18:264;;;28559:50;28626:18;;6877:30:154;28306:344:264;6825:82:154;6925:31;6932:10;6944:11;6925:6;:31::i;47688:383:177:-;-1:-1:-1;;;;;47853:19:177;;;;;;:11;:19;;;;;:29;-1:-1:-1;;;;;47853:29:177;;;47843:39;;;;47839:88;;47891:36;;-1:-1:-1;;;47891:36:177;;-1:-1:-1;;;;;28843:39:264;;47891:36:177;;;28825:58:264;-1:-1:-1;;;;;28919:31:264;;28899:18;;;28892:59;28798:18;;47891:36:177;28655:302:264;47839:88:177;-1:-1:-1;;;;;47978:12:177;;48017:1;47978:12;;;:4;:12;;;;;;;;-1:-1:-1;;;;;47978:20:177;;;;;;;;;:27;-1:-1:-1;;;;;47978:27:177;47974:90;;48028:36;;-1:-1:-1;;;48028:36:177;;-1:-1:-1;;;;;28843:39:264;;48028:36:177;;;28825:58:264;-1:-1:-1;;;;;28919:31:264;;28899:18;;;28892:59;28798:18;;48028:36:177;28655:302:264;48116:262:177;-1:-1:-1;;;;;48314:12:177;;;;;;:4;:12;;;;;;;;-1:-1:-1;;;;;48314:20:177;;;;;;;;;:27;-1:-1:-1;;;;;48303:38:177;;;48314:27;;48303:38;48299:72;;48350:21;;-1:-1:-1;;;48350:21:177;;-1:-1:-1;;;;;6205:32:264;;48350:21:177;;;6187:51:264;6160:18;;48350:21:177;6041:203:264;48299:72:177;48116:262;;;:::o;48423:275::-;-1:-1:-1;;;;;48580:12:177;;;;;;:4;:12;;;;;;;;-1:-1:-1;;;;;48580:20:177;;;;;;;;;48611:17;48580:27;;;;;;:48;;;;;;;;:::i;:::-;;48576:116;;48651:30;;-1:-1:-1;;;48651:30:177;;-1:-1:-1;;;;;28843:39:264;;48651:30:177;;;28825:58:264;-1:-1:-1;;;;;28919:31:264;;28899:18;;;28892:59;28798:18;;48651:30:177;28655:302:264;46857:231:177;-1:-1:-1;;;;;46987:19:177;;;;;;:11;:19;;;;;:30;;;:35;46983:99;;47045:26;;-1:-1:-1;;;47045:26:177;;-1:-1:-1;;;;;22611:39:264;;47045:26:177;;;22593:58:264;22566:18;;47045:26:177;22449:208:264;12662:904:177;-1:-1:-1;;;;;12865:12:177;;12802:14;12865:12;;;:4;:12;;;;;;;;-1:-1:-1;;;;;12865:20:177;;;;;;;;;12895:17;12865:27;;;:47;;-1:-1:-1;;12865:47:177;;;;;;13000:19;;;:11;:19;;;;;:26;;13050:13;;13130;;;13126:49;;13152:23;;-1:-1:-1;;;13152:23:177;;;;;;;;;;;13126:49;13263:12;13278:6;13285;13278:14;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13278:14:177;;;;-1:-1:-1;13306:15:177;;;;13302:51;;13330:23;;-1:-1:-1;;;13330:23:177;;;;;;;;;;;13302:51;13424:6;13431:7;13437:1;13431:3;:7;:::i;:::-;13424:15;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13424:15:177;13407:6;13414;13407:14;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;:32;;;;;-1:-1:-1;;;;;13407:32:177;;;;;-1:-1:-1;;;;;13407:32:177;;;;;;13449:6;:12;;;;;;;:::i;:::-;;;;;;;;;;-1:-1:-1;;13449:12:177;;;;;;;;;-1:-1:-1;;;;;13449:12:177;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;13531:12:177;;;;;:4;:12;;;;;;:20;;;;;;;;;;:27;-1:-1:-1;;;13531:27:177;;;;-1:-1:-1;;;;12662:904:177;;;;;;:::o;8183:368:169:-;-1:-1:-1;;;;;8330:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;8330:26:169;;;;;8310:15;8303:53;;;;8299:119;;8379:28;;-1:-1:-1;;;8379:28:169;;-1:-1:-1;;;;;22611:39:264;;8379:28:169;;;22593:58:264;22566:18;;8379:28:169;22449:208:264;8299:119:169;-1:-1:-1;;;;;8478:15:169;;;;;;:7;:15;;;;;;;:24;;:29;;8474:70;;8516:28;;-1:-1:-1;;;8516:28:169;;-1:-1:-1;;;;;22611:39:264;;8516:28:169;;;22593:58:264;22566:18;;8516:28:169;22449:208:264;8976:1381:177;9160:12;;;9282:42;;;;9293:12;9282:42;:::i;:::-;9215:109;;-1:-1:-1;9215:109:177;-1:-1:-1;;;;;;9436:26:177;;9432:62;;;9471:23;;-1:-1:-1;;;9471:23:177;;;;;;;;;;;9432:62;-1:-1:-1;;;;;9575:19:177;;;;;;:11;:19;;;;;;;;:30;;9565:40;;9561:84;;;9614:31;;-1:-1:-1;;;9614:31:177;;;;;;;;;;;9561:84;9746:24;9760:9;9746:13;:24::i;:::-;9741:58;;9779:20;;-1:-1:-1;;;9779:20:177;;;;;;;;;;;9741:58;-1:-1:-1;;;;;9844:19:177;;;;;;:11;:19;;;;;:31;;-1:-1:-1;;;;;9844:31:177;;;;;:::i;:::-;;;;;;;;-1:-1:-1;;;;;9844:31:177;;;;;;;;;;;;;;;-1:-1:-1;;;;;9907:12:177;;;-1:-1:-1;9907:12:177;;;:4;:12;;;;;;;;:19;;;;;;;;;;;-1:-1:-1;;;;;9936:24:177;;;-1:-1:-1;;;9970:32:177;;;;;;;-1:-1:-1;10012:16:177;;;:28;;;;;-1:-1:-1;;;10012:28:177;;;;;;;;;;;;;;10050:14;;;:36;;9907:19;;-1:-1:-1;9907:19:177;;10050:14;;-1:-1:-1;;10050:36:177;;;;-1:-1:-1;10050:36:177;;;;-1:-1:-1;;10185:43:177;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;10154:21:177;;;;-1:-1:-1;10154:21:177;;;:13;:21;;;;;;-1:-1:-1;;;;;10154:28:177;;;;;;;;;;;;:74;;;;;;;;;;;;;;;;;;;;;;;;;;;;10289:19;;;:11;:19;;;;;;:26;;:38;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;10154:28:177;;8976:1381;-1:-1:-1;;;;8976:1381:177:o;43544:2061::-;43641:24;;:::i;:::-;-1:-1:-1;;;;;43723:12:177;;;43702:18;43723:12;;;:4;:12;;;;;;;;-1:-1:-1;;;;;43723:20:177;;;;;;;;;43702:41;;;;;;;;;-1:-1:-1;;;;;43702:41:177;;;;;-1:-1:-1;;;43702:41:177;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;43702:41:177;;;;;;;;;;;;;;;:18;;:41;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;-1:-1:-1;43822:14:177;;-1:-1:-1;;;;;43804:32:177;;;;;43866:16;;;;43846:36;:17;;;;:36;;;;-1:-1:-1;;;;;43954:15:177;;-1:-1:-1;43954:15:177;;;:7;:15;;;-1:-1:-1;43954:15:177;;:33;43822:14;;-1:-1:-1;;43948:39:177;;-1:-1:-1;;;43954:33:177;;;;43948:2;:39;:::i;:::-;43928:59;;43997:13;44013:7;:20;;;-1:-1:-1;;;;;44013:25:177;44037:1;44013:25;:173;;44124:62;44138:7;:14;;;-1:-1:-1;;;;;44124:62:177;44154:9;44165:7;:20;;;-1:-1:-1;;;;;44124:62:177;:13;:62::i;:::-;44013:173;;;44053:1;44013:173;-1:-1:-1;;;;;44221:19:177;;44197:21;44221:19;;;:11;:19;;;;;;;;:33;;;44812:15;:23;;;;;;:29;43997:189;;-1:-1:-1;44221:33:177;-1:-1:-1;;;;;44812:39:177;;;:29;;:39;44808:765;;44883:14;;;;;-1:-1:-1;;;;;44867:30:177;;;:13;;;;:30;;;;44929:23;;;;;;;:15;:23;;;;;;:30;;;;44911:15;;;:48;44991:23;;;;;:30;;-1:-1:-1;;;44991:30:177;;;44973:15;;;:48;44808:765;;;45063:13;45055:5;:21;:112;;;;45106:13;45097:5;:22;:69;;;;-1:-1:-1;;;;;;45133:19:177;;;;;;:11;:19;;;;;:33;-1:-1:-1;;;;;;;;45133:33:177;;;;;45123:43;;;;;45097:69;45038:535;;;45284:14;;;;-1:-1:-1;;;;;45268:30:177;:13;;;:30;;;45330:52;;45357:9;45368:13;45330:11;:52::i;:::-;45312:15;;;:70;45038:535;;;45502:14;;;;;-1:-1:-1;;;;;45486:30:177;;;:13;;;:30;45548:14;;45530:32;:15;;;:32;45038:535;45583:15;;;;43544:2061;;;;:::o;3995:652:154:-;4162:16;4321:20;4344:51;4364:17;4383:11;4344:19;:51::i;:::-;2581:36;;;;;;;32974:19:264;;;;33009:12;;;33002:28;;;;2581:36:154;;;;;;;;;33046:12:264;;;;2581:36:154;;2571:47;;;;;;;;4614:26;;;;;;-1:-1:-1;;;;3995:652:154:o;7613:386:177:-;7839:26;7858:6;7839:18;:26::i;:::-;-1:-1:-1;;;;;7946:19:177;;;;;:11;:19;;;;;:46;;-1:-1:-1;;;;7946:46:177;-1:-1:-1;;;7946:46:177;;;7613:386::o;5706:1376::-;5846:35;5895:7;5884:40;;;;;;;;;;;;:::i;:::-;6004:19;;5846:78;;-1:-1:-1;6004:19:177;:24;6000:60;;6037:23;;-1:-1:-1;;;6037:23:177;;;;;;;;;;;6000:60;439:5:169;6136:48:177;;:10;:25;;;:48;;;6132:84;;;6193:23;;-1:-1:-1;;;6193:23:177;;;;;;;;;;;6132:84;6317:21;;;;-1:-1:-1;;;;;;6317:40:177;:70;;-1:-1:-1;6361:21:177;;;;:26;6317:70;6313:131;;;6410:23;;-1:-1:-1;;;6410:23:177;;;;;;;;;;;6313:131;6529:35;6543:10;:20;;;6529:13;:35::i;:::-;6524:72;;6573:23;;-1:-1:-1;;;6573:23:177;;;;;;;;;;;6524:72;-1:-1:-1;;;;;6662:19:177;;6635:24;6662:19;;;:11;:19;;;;;;;;6707;;6691:13;;;:35;6843:13;;;;6858:25;;;;6662:19;;6825:81;;;;439:5:169;6825:17:177;:81::i;:::-;6796:14;;;:110;6934:21;;;;;6916:15;;;:39;6982:20;;;;6965:37;;:14;;;:37;;;;;;;;;;7012:18;;-1:-1:-1;;7012:18:177;6965:37;7012:18;;;;;-1:-1:-1;;;;;7041:21:177;;-1:-1:-1;7041:21:177;;;:13;:21;;;;;-1:-1:-1;;;;;;;;;2521:25:156;;:12;;;:25;;;;-1:-1:-1;;;;;;2521:37:156;;5796:1286:177;;5706:1376;;;:::o;34654:4658::-;34773:16;;;34816:27;34960:19;-1:-1:-1;;;;;34930:19:177;;;;;;:11;:19;;;;;:26;-1:-1:-1;;;34930:26:177;;;;:49;;;;;;;;:::i;:::-;;34926:113;;35002:26;;-1:-1:-1;;;35002:26:177;;-1:-1:-1;;;;;22611:39:264;;35002:26:177;;;22593:58:264;22566:18;;35002:26:177;22449:208:264;34926:113:177;35249:33;35285:34;35306:6;35314:4;35285:20;:34::i;:::-;-1:-1:-1;;;;;35392:15:177;;35366:17;35392:15;;;:7;:15;;;;;:33;35249:70;;-1:-1:-1;35366:17:177;35386:39;;-1:-1:-1;;;35392:33:177;;;;35386:2;:39;:::i;:::-;35486:15;;;;35366:59;;-1:-1:-1;35486:24:177;;35505:5;35486:24;35482:675;;-1:-1:-1;35732:20:177;;;;-1:-1:-1;;;;;35682:29:177;;;;;;:21;:29;;;;;;;:70;;;35808:19;;;;35766:39;;;:61;35883:16;;;35841:39;;;;:58;;-1:-1:-1;;35841:58:177;-1:-1:-1;;;;;35841:58:177;;;;;;;;;36114:15;;;;-1:-1:-1;36085:61:177;;35482:675;-1:-1:-1;;;;;36354:15:177;;36335:16;36354:15;;;:7;:15;;;;;;;;:24;;;;36587:11;:19;;;;;:46;;-1:-1:-1;;;;36587:46:177;-1:-1:-1;;;36587:46:177;;;36843:29;;;36817:23;;;;:55;;:126;;-1:-1:-1;;;;;;36915:19:177;;;;;;:11;:19;;;;;:28;;;36892:20;;:51;36817:126;36800:574;;;-1:-1:-1;;;;;;;37152:19:177;;;;;;:11;:19;;;;;-1:-1:-1;;37152:33:177;;;;:53;37331:15;;;;-1:-1:-1;37302:61:177;;36800:574;37499:20;;-1:-1:-1;;;;;37463:19:177;;37499:20;37463:19;;;:11;:19;;;;;;;;:33;;;:56;;;;37565:20;;;37529:56;;-1:-1:-1;;;;;37529:56:177;;;-1:-1:-1;;;37529:56:177;-1:-1:-1;;;;37529:56:177;;;;;;37779:23;;;;:34;-1:-1:-1;37775:1293:177;;;-1:-1:-1;;;;;37892:12:177;;;37870:19;37892:12;;;:4;:12;;;;;;;;37905:20;;;;-1:-1:-1;;;;;37892:34:177;;;;;;;;38035:14;;38063:20;;37892:34;;38015:69;;-1:-1:-1;;;38035:14:177;;;;;38052:9;;38015:11;:69::i;:::-;37996:88;;38098:14;38141:8;38115:6;:23;;;:34;;;;:::i;:::-;38098:51;;38677:21;38701:203;;;;;;;;38738:6;:20;;;-1:-1:-1;;;;;38701:203:177;;;;;38791:54;38811:7;:14;;;;;;;;;;-1:-1:-1;;;;;38811:14:177;-1:-1:-1;;;;;38803:23:177;38828:6;38836:8;38791:11;:54::i;:::-;-1:-1:-1;;;;;38701:203:177;;;;;38872:17;38883:6;38872:8;:17;:::i;:::-;38701:203;;-1:-1:-1;;;;;38918:23:177;;;;;;;:15;:23;;;;;;;;;:28;;;;;;;;;;;-1:-1:-1;;;38918:28:177;;-1:-1:-1;;;;;;38918:28:177;;;-1:-1:-1;;;;;38918:28:177;;;;;;;;;;;;;;;;;;;;;;39024:20;;;:33;;38677:227;;-1:-1:-1;38918:28:177;;39024:33;;38918:28;;39024:33;:::i;:::-;;;-1:-1:-1;;;;;37775:1293:177;39120:6;:20;;;39109:31;;39188:8;39162:6;:23;;;:34;:71;;39210:6;:23;;;39162:71;;;39199:8;39162:71;39273:15;;;;;39150:83;;-1:-1:-1;39273:15:177;;-1:-1:-1;;;34654:4658:177;;;;;;;;:::o;14169:436::-;14258:24;;:::i;:::-;-1:-1:-1;;;;;14370:12:177;;14348:19;14370:12;;;:4;:12;;;;;;;;-1:-1:-1;;;;;14370:20:177;;;;;;;;;14459:17;14442:14;;;:34;;-1:-1:-1;;14442:34:177;;;;;;14284:27;;14526:28;14370:12;:20;14526:12;:28::i;:::-;14515:39;;14565:33;14169:436;;;;;:::o;22964:1907::-;-1:-1:-1;;;;;23161:12:177;;23139:19;23161:12;;;:4;:12;;;;;;;;-1:-1:-1;;;;;23161:20:177;;;;;;;;;;23211:26;23166:6;23174;23211:10;:26::i;:::-;23191:46;-1:-1:-1;23248:16:177;-1:-1:-1;;;;;23374:29:177;;23370:89;;-1:-1:-1;23438:9:177;23370:89;23508:14;;;:36;;-1:-1:-1;;23508:36:177;23525:19;23508:36;;;-1:-1:-1;;;;;23781:13:177;;;23777:995;;24148:14;;-1:-1:-1;;;;;24171:15:177;;;24093:13;24171:15;;;:7;:15;;;;;:33;24093:13;;24109:129;;-1:-1:-1;;;24148:14:177;;;;;24165:39;;-1:-1:-1;;;24171:33:177;;;;24165:2;:39;:::i;:::-;24214:9;-1:-1:-1;;;;;24206:18:177;24109:13;:129::i;:::-;24093:145;-1:-1:-1;;;;;;24256:24:177;;:74;;;;-1:-1:-1;;;;;;24301:19:177;;;;;;:11;:19;;;;;:28;;;24284:46;;;24256:74;24252:510;;;24518:14;;-1:-1:-1;;;;;24449:21:177;;;24518:14;24449:21;;;:13;:21;;;;;:124;;:21;;24499:9;;24510:6;;-1:-1:-1;;;24518:14:177;;;;24534:9;24545:10;24449:28;:124::i;:::-;24591:20;;;:32;;-1:-1:-1;;;;;;24591:32:177;-1:-1:-1;;;;;24591:32:177;;;;;24252:510;23796:976;23777:995;24838:14;;24809:55;;;-1:-1:-1;;;;;;;;24838:14:177;;;;;31163:34:264;;31233:15;;;31228:2;31213:18;;31206:43;-1:-1:-1;;;;;24809:55:177;;;;;;;;31091:18:264;24809:55:177;;;;;;;23098:1773;;;22964:1907;;;;:::o;7447:271:154:-;7682:3;;7505:4;;7662:49;;7672:35;;7687:19;7682:3;;7687:9;:19::i;:::-;7672:9;:35::i;:::-;7709:1;7662:9;:49::i;:::-;7649:3;;;;7639:19;;7649:3;7639:9;:19::i;:::-;:72;;7447:271;-1:-1:-1;;7447:271:154:o;6969:332::-;-1:-1:-1;;;;;;;;;;;;;;;;;7163:3:154;;7168;;;;;7152:28;;7067:12;;;;7124:4;;7146;;7152:28;;7163:3;7173:6;;7152:28;31462:25:264;;;31518:2;31503:18;;31496:34;;;;31561:2;31546:18;;31539:34;31450:2;31435:18;;31260:319;7152:28:154;;;;-1:-1:-1;;7152:28:154;;;;;;;;;;7116:65;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;7066:115;;;;7197:7;7196:8;:30;;;-1:-1:-1;7208:13:154;;:18;7196:30;7192:59;;;7228:23;;-1:-1:-1;;;7228:23:154;;32078:2:264;7228:23:154;;;32060:21:264;32117:2;32097:18;;;32090:30;-1:-1:-1;;;32136:18:264;;;32129:43;32189:18;;7228:23:154;31876:337:264;7192:59:154;7278:6;7267:27;;;;;;;;;;;;:::i;8064:214::-;8120:4;8143:12;8153:1;8143:9;:12::i;:::-;:39;;;;-1:-1:-1;8161:3:154;;8168:1;8161:8;:20;;;;;8173:1;:3;;;8180:1;8173:8;8161:20;8159:23;8143:39;:66;;;;-1:-1:-1;8188:3:154;;:8;:20;;;;-1:-1:-1;8200:3:154;;;;:8;8188:20;8186:23;8143:66;:103;;;;-1:-1:-1;8226:3:154;;-1:-1:-1;;;;;;;;;;;;8143:103:154;:128;;;;-1:-1:-1;;8251:3:154;;;-1:-1:-1;;;;;;;;;;;;8251:19:154;8064:214::o;17398:508:54:-;17472:9;17695:1;17691;17687:6;17683:14;17680:1;17677:21;17674:1;17670:29;17663:37;17660:1;17656:45;17646:169;;17734:10;17728:4;17721:24;17796:4;17790;17783:18;17646:169;-1:-1:-1;17876:9:54;;17851:17;;;17844:25;17837:33;17872:17;;;17833:57;;17398:508::o;16832:466::-;16904:9;17127:1;17123;17119:6;17115:14;17112:1;17109:21;17106:1;17102:29;17095:37;17092:1;17088:45;17078:169;;17166:10;17160:4;17153:24;17228:4;17222;17215:18;17078:169;-1:-1:-1;17269:9:54;;17265:17;;16832:466::o;2791:518:154:-;2918:7;2989:28;2999:17;2989:9;:28::i;:::-;2984:64;;3019:29;;-1:-1:-1;;;3019:29:154;;32671:2:264;3019:29:154;;;32653:21:264;32710:2;32690:18;;;32683:30;-1:-1:-1;;;32729:18:264;;;32722:49;32788:18;;3019:29:154;32469:343:264;2984:64:154;1747:102;3137:11;:26;;:46;;;-1:-1:-1;3167:16:154;;3137:46;3133:82;;;3185:30;;-1:-1:-1;;;3185:30:154;;28508:2:264;3185:30:154;;;28490:21:264;28547:2;28527:18;;;28520:30;-1:-1:-1;;;28566:18:264;;;28559:50;28626:18;;3185:30:154;28306:344:264;3133:82:154;3226:14;3243:38;3250:17;3269:11;3243:6;:38::i;:::-;3299:3;;2791:518;-1:-1:-1;;;;2791:518:154:o;16269:462:54:-;16347:14;16382:19;16393:1;16396;16399;16382:10;:19::i;:::-;16373:28;;16493:1;16490;16487;16480:15;16477:238;;;16536:1;16524:14;;16555:146;;16608:10;16602:4;16595:24;16678:4;16672;16665:18;26988:6816:177;27087:33;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;27087:33:177;-1:-1:-1;;;;;27264:15:177;;27245:16;27264:15;;;:7;:15;;;;;;;:24;;;;27324:33;;27264:24;;27245:16;27318:39;;-1:-1:-1;;;27324:33:177;;;;27318:2;:39;:::i;:::-;-1:-1:-1;;;;;27403:19:177;;27367:33;27403:19;;;:11;:19;;;;;;;;27367:55;;;;;;;;;-1:-1:-1;;;;;27367:55:177;;;;;-1:-1:-1;;;27367:55:177;;;;;;;;;;27298:59;;-1:-1:-1;27367:33:177;;:55;27403:19;27367:55;;;;-1:-1:-1;;;27367:55:177;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;-1:-1:-1;;;27367:55:177;;-1:-1:-1;;;;;27367:55:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;27367:55:177;-1:-1:-1;;;;;27367:55:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;27367:55:177;;;;-1:-1:-1;;;;;;;;27586:29:177;;27566:17;27586:29;;;:21;:29;;;;;:39;;;;27715:47;;27692:20;;;:70;27367:55;;-1:-1:-1;27802:14:177;;:139;;-1:-1:-1;;;;;27871:29:177;;;;;;:21;:29;;;;;:47;27855:86;;27920:9;27931;27855:15;:86::i;:::-;27802:139;;;27835:1;27802:139;27776:23;;;:165;-1:-1:-1;;;;;27978:21:177;;27956:19;27978:21;;;:13;:21;;;;;;;;28033;:29;;;;;:39;;;5750:12:156;;27978:21:177;;-1:-1:-1;;;;;28033:39:177;;;;5750:12:156;28140::177;;;28136:263;;-1:-1:-1;;28349:4:177;28331:15;;;:22;-1:-1:-1;28371:13:177;;-1:-1:-1;;;;28371:13:177;28136:263;28424:15;;;;;;28463:31;;28487:7;28463:31;;;28480:4;28463:31;28453:41;;28513:9;28508:5256;28532:7;28528:1;:11;28508:5256;;;28919:12;28933:16;28951:13;28968:29;28980:5;28987:9;28968:11;:29::i;:::-;28918:79;;;;;;29128:5;29109:6;:16;;:24;-1:-1:-1;;;;;29109:24:177;;;-1:-1:-1;;;;;29109:24:177;;;;;29173:5;29151:6;:19;;:27;;;;;29538:55;29554:6;:20;;;29576:9;29587:5;29538:15;:55::i;:::-;29512:23;;;:81;;;29615:35;-1:-1:-1;29611:1392:177;;29721:60;29739:6;:20;;;29761:9;29772:8;29721:17;:60::i;:::-;29674:107;;;30130:33;;30126:333;;-1:-1:-1;;;;;30191:32:177;;:20;;;:32;30126:333;;;30308:1;30278:20;;;:32;30126:333;30804:70;30820:6;:20;;;30842:9;30853:6;:20;;;30804:15;:70::i;:::-;30754:23;;;:120;-1:-1:-1;;30953:4:177;30935:15;;;:22;-1:-1:-1;30979:5:177;;29611:1392;31113:5;31101:17;;31148:5;31136:17;;31241:8;31217:6;:20;;:32;;;;;;;:::i;:::-;;;-1:-1:-1;31470:20:177;;;;31454:55;;31492:9;31503:5;31454:15;:55::i;:::-;31428:23;;;:81;;;31764:35;-1:-1:-1;31760:231:177;;31823:28;;-1:-1:-1;;;;;;31873:28:177;:20;;;:28;31941:4;31923:15;;;:22;31967:5;;31760:231;32157:11;32167:1;32157:7;:11;:::i;:::-;32152:1;:16;:24;;;;;32172:4;32152:24;32148:1602;;;32675:23;;;;:28;;:176;;;32843:8;32735:73;32751:6;:20;;;32773:9;32784:14;:23;;;32735:15;:73::i;:::-;:116;32675:176;32646:489;;;32951:60;32969:6;:20;;;32991:9;33002:8;32951:17;:60::i;:::-;32900:111;;32646:489;;;33089:23;;;;33066:46;;32646:489;33354:20;;33345:29;;33341:112;;-1:-1:-1;;;;;33402:28:177;;:20;;;:28;33341:112;33525:70;33541:6;:20;;;33563:9;33574:6;:20;;;33525:15;:70::i;:::-;33475:23;;;:120;33727:4;33709:15;;;:22;32148:1602;28546:5218;;;28541:3;;;;;:::i;:::-;;;;28508:5256;;;;27552:6222;;;;;33784:13;;;26988:6816;;;;:::o;2968:1557:156:-;3264:1;3248:13;-1:-1:-1;;;;;3248:17:156;;3240:50;;;;-1:-1:-1;;;3240:50:156;;33271:2:264;3240:50:156;;;33253:21:264;33310:2;33290:18;;;33283:30;-1:-1:-1;;;33329:18:264;;;33322:50;33389:18;;3240:50:156;33069:344:264;3240:50:156;3327:11;3341:52;3360:6;3368:9;3379:13;3341:18;:52::i;:::-;2689:4;2879:19;;;:12;;;:19;;;;;;3327:66;;-1:-1:-1;2879:33:156;3463:51;;;;-1:-1:-1;;;3463:51:156;;33620:2:264;3463:51:156;;;33602:21:264;33659:2;33639:18;;;33632:30;-1:-1:-1;;;33678:18:264;;;33671:48;33736:18;;3463:51:156;33418:342:264;3463:51:156;2689:4;2879:19;;;:12;;;:19;;;;;;3578:54;;;;-1:-1:-1;;;3578:54:156;;33967:2:264;3578:54:156;;;33949:21:264;34006:2;33986:18;;;33979:30;-1:-1:-1;;;34025:18:264;;;34018:50;34085:18;;3578:54:156;33765:344:264;3578:54:156;3742:43;:5;3769:3;3774:10;3742:26;:43::i;:::-;3734:79;;;;-1:-1:-1;;;3734:79:156;;34316:2:264;3734:79:156;;;34298:21:264;34355:2;34335:18;;;34328:30;34394:25;34374:18;;;34367:53;34437:18;;3734:79:156;34114:347:264;3734:79:156;4119:12;4134:19;;;:12;;;:19;;;;;;4163:127;4170:42;:4;4196:3;4201:10;4170:25;:42::i;:::-;4163:127;;;4261:18;;;;:12;;;:18;;;;;;4236:4;;-1:-1:-1;4163:127:156;;;4381:19;;;;:12;;;:19;;;;;;:25;;;4416:17;;;;;:24;;;4504:14;;;4381:4;;4504:14;;;:::i;:::-;;;;;;3157:1368;;2968:1557;;;;;;:::o;8284:155:154:-;8347:9;-1:-1:-1;;;;;;;;;;;8406:1:154;8403;8396:27;8391:32;8284:155;-1:-1:-1;;;8284:155:154:o;8445:::-;8508:9;-1:-1:-1;;;;;;;;;;;8567:1:154;8564;8557:27;8552:32;8445:155;-1:-1:-1;;;8445:155:154:o;12569:3418:54:-;12645:14;13181:9;;;-1:-1:-1;;13188:1:54;13185;13217:20;13341:10;;;13333:19;;13325:28;;;13438:274;;13484:1;13474:153;;13526:10;13520:4;13513:24;13600:4;13594;13587:18;13474:153;-1:-1:-1;13658:10:54;;;;-1:-1:-1;13689:5:54;;13438:274;13833:2;13830:1;13827:9;13817:149;;13873:10;13867:4;13860:24;13943:4;13937;13930:18;13817:149;14223:1;14220;14217;14210:15;14371:1;14367:9;;;14360:17;;14462:9;;;;;15753;;;15745:18;;;15773:9;;;;15769:17;;;15788:1;15765:25;15741:50;15797:10;;15793:18;15738:74;14841:1;14837:9;;14848:1;14833:17;;;15119:11;;;15112:19;;15103:29;15192:11;;;15185:19;;15176:29;15266:11;;;15259:19;;15250:29;15340:11;;;15333:19;;15324:29;15414:11;;;15407:19;;15398:29;15900:11;;;15893:19;;;15884:29;15496:439;;-1:-1:-1;12569:3418:54;;;;;:::o;25936:800:177:-;26039:12;26053:16;26071:13;26144:19;26207:15;:6;:13;:15::i;:::-;26173:49;;-1:-1:-1;;;;;;26173:49:177;;;;-1:-1:-1;26173:49:177;;-1:-1:-1;26418:17:177;;26434:1;26418:17;26414:155;;-1:-1:-1;26556:1:177;;-1:-1:-1;26531:27:177;;26414:155;26629:58;26643:8;26653:10;26673:12;-1:-1:-1;;;;;26665:21:177;26629:13;:58::i;:::-;26621:66;;26698:31;25936:800;;;;;;:::o;174:210:156:-;329:47;;;-1:-1:-1;;;;;;34683:3:264;34661:16;;;34657:51;329:47:156;;;34645:64:264;-1:-1:-1;;;;;;34732:3:264;34797:16;;;34793:25;;34780:11;;;34773:46;34853:16;;;34849:25;34835:12;;;34828:47;295:7:156;;34891:12:264;329:47:156;;;;;;;;;;;;321:56;;;:::i;:::-;314:63;174:210;-1:-1:-1;;;;174:210:156:o;689:614::-;820:4;515:3;507:11;;;;571:2;563:10;;;;507:11;;;;;;;563:10;;;507:11;820:4;1008:68;-1:-1:-1;;;;;1022:18:156;;;;1042:9;;1053:22;;1008:13;:68::i;:::-;991:85;;1086:14;1103:68;1125:9;-1:-1:-1;;;;;1117:18:156;1137:9;1156:13;-1:-1:-1;;;;;1148:22:156;1103:13;:68::i;:::-;1086:85;;1195:6;1185;:16;1181:116;;1230:3;-1:-1:-1;;;;;1224:9:156;:3;-1:-1:-1;;;;;1224:9:156;;1217:16;;;;;;;;;;;;1181:116;-1:-1:-1;1271:15:156;-1:-1:-1;1264:22:156;;-1:-1:-1;;;;;;1264:22:156;4637:513;-1:-1:-1;;;;;;;;;4691:6:156;4769:25;;;:12;;;:25;;;;;;4691:6;;;;-1:-1:-1;;;;;4812:19:156;;4804:46;;;;-1:-1:-1;;;4804:46:156;;35418:2:264;4804:46:156;;;35400:21:264;35457:2;35437:18;;;35430:30;-1:-1:-1;;;35476:18:264;;;35469:44;35530:18;;4804:46:156;35216:338:264;4804:46:156;4934:20;;;;:12;;;:20;;;;;;;;-1:-1:-1;;;;;;;;;4906:25:156;;;;;:48;;;;4971:20;;;4964:27;;;5055:14;;;4934:4;;5055:14;;;:::i;:::-;;;;-1:-1:-1;;515:3:156;507:11;;;;571:2;563:10;;;;-1:-1:-1;507:11:156;;-1:-1:-1;4637:513:156;-1:-1:-1;;4637:513:156:o;-1:-1:-1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;14:179:264:-;81:20;;-1:-1:-1;;;;;130:38:264;;120:49;;110:77;;183:1;180;173:12;110:77;14:179;;;:::o;198:320::-;274:6;282;290;343:2;331:9;322:7;318:23;314:32;311:52;;;359:1;356;349:12;311:52;382:28;400:9;382:28;:::i;:::-;372:38;457:2;442:18;;429:32;;-1:-1:-1;508:2:264;493:18;;;480:32;;198:320;-1:-1:-1;;;198:320:264:o;630:655::-;799:2;851:21;;;921:13;;824:18;;;943:22;;;770:4;;799:2;1022:15;;;;996:2;981:18;;;770:4;1065:194;1079:6;1076:1;1073:13;1065:194;;;1144:13;;-1:-1:-1;;;;;1140:38:264;1128:51;;1234:15;;;;1199:12;;;;1101:1;1094:9;1065:194;;;-1:-1:-1;1276:3:264;;630:655;-1:-1:-1;;;;;;630:655:264:o;1290:184::-;1348:6;1401:2;1389:9;1380:7;1376:23;1372:32;1369:52;;;1417:1;1414;1407:12;1369:52;1440:28;1458:9;1440:28;:::i;1671:366::-;1733:8;1743:6;1797:3;1790:4;1782:6;1778:17;1774:27;1764:55;;1815:1;1812;1805:12;1764:55;-1:-1:-1;1838:20:264;;-1:-1:-1;;;;;1870:30:264;;1867:50;;;1913:1;1910;1903:12;1867:50;1950:4;1942:6;1938:17;1926:29;;2010:3;2003:4;1993:6;1990:1;1986:14;1978:6;1974:27;1970:38;1967:47;1964:67;;;2027:1;2024;2017:12;2042:507;2135:6;2143;2151;2204:2;2192:9;2183:7;2179:23;2175:32;2172:52;;;2220:1;2217;2210:12;2172:52;2243:28;2261:9;2243:28;:::i;:::-;2233:38;;2322:2;2311:9;2307:18;2294:32;-1:-1:-1;;;;;2341:6:264;2338:30;2335:50;;;2381:1;2378;2371:12;2335:50;2420:69;2481:7;2472:6;2461:9;2457:22;2420:69;:::i;:::-;2042:507;;2508:8;;-1:-1:-1;2394:95:264;;-1:-1:-1;;;;2042:507:264:o;2554:373::-;2670:12;;-1:-1:-1;;;;;2666:21:264;;;2654:34;;2741:4;2730:16;;;2724:23;2720:32;;;2704:14;;;2697:56;2802:4;2791:16;;;2785:23;2769:14;;;2762:47;2858:4;2847:16;;;2841:23;2825:14;;;2818:47;2914:4;2903:16;;;2897:23;2881:14;;2874:47;2554:373::o;2932:250::-;3017:1;3027:113;3041:6;3038:1;3035:13;3027:113;;;3117:11;;;3111:18;3098:11;;;3091:39;3063:2;3056:10;3027:113;;;-1:-1:-1;;3174:1:264;3156:16;;3149:27;2932:250::o;3187:270::-;3228:3;3266:5;3260:12;3293:6;3288:3;3281:19;3309:76;3378:6;3371:4;3366:3;3362:14;3355:4;3348:5;3344:16;3309:76;:::i;:::-;3439:2;3418:15;-1:-1:-1;;3414:29:264;3405:39;;;;3446:4;3401:50;;3187:270;-1:-1:-1;;3187:270:264:o;3462:838::-;3752:2;3764:21;;;3834:13;;3737:18;;;3856:22;;;3704:4;;3931;;3909:2;3894:18;;;3958:15;;;3704:4;4001:191;4015:6;4012:1;4009:13;4001:191;;;4064:46;4106:3;4097:6;4091:13;4064:46;:::i;:::-;4139:4;4130:14;;;;;4167:15;;;;4037:1;4030:9;4001:191;;;4005:3;;;4237:9;4232:3;4228:19;4223:2;4212:9;4208:18;4201:47;4265:29;4290:3;4282:6;4265:29;:::i;:::-;4257:37;3462:838;-1:-1:-1;;;;;;3462:838:264:o;4305:217::-;4452:2;4441:9;4434:21;4415:4;4472:44;4512:2;4501:9;4497:18;4489:6;4472:44;:::i;4709:171::-;4776:20;;-1:-1:-1;;;;;4825:30:264;;4815:41;;4805:69;;4870:1;4867;4860:12;4885:256;4951:6;4959;5012:2;5000:9;4991:7;4987:23;4983:32;4980:52;;;5028:1;5025;5018:12;4980:52;5051:28;5069:9;5051:28;:::i;:::-;5041:38;;5098:37;5131:2;5120:9;5116:18;5098:37;:::i;:::-;5088:47;;4885:256;;;;;:::o;5146:127::-;5207:10;5202:3;5198:20;5195:1;5188:31;5238:4;5235:1;5228:15;5262:4;5259:1;5252:15;5278:114;5360:1;5353:5;5350:12;5340:46;;5366:18;;:::i;5397:639::-;-1:-1:-1;;;;;5721:15:264;;;5703:34;;-1:-1:-1;;;;;5818:15:264;;;5813:2;5798:18;;5791:43;5870:15;;5865:2;5850:18;;5843:43;5922:15;;5917:2;5902:18;;5895:43;5652:3;5637:19;;5947:39;5979:6;5947:39;:::i;:::-;6023:6;6017:3;6006:9;6002:19;5995:35;5397:639;;;;;;;;:::o;6249:167::-;6316:20;;6376:14;6365:26;;6355:37;;6345:65;;6406:1;6403;6396:12;6421:184;6479:6;6532:2;6520:9;6511:7;6507:23;6503:32;6500:52;;;6548:1;6545;6538:12;6500:52;6571:28;6589:9;6571:28;:::i;6610:580::-;6712:6;6720;6728;6736;6789:2;6777:9;6768:7;6764:23;6760:32;6757:52;;;6805:1;6802;6795:12;6757:52;6828:28;6846:9;6828:28;:::i;:::-;6818:38;;6875:37;6908:2;6897:9;6893:18;6875:37;:::i;:::-;6865:47;;6963:2;6952:9;6948:18;6935:32;-1:-1:-1;;;;;6982:6:264;6979:30;6976:50;;;7022:1;7019;7012:12;6976:50;7061:69;7122:7;7113:6;7102:9;7098:22;7061:69;:::i;:::-;6610:580;;;;-1:-1:-1;7149:8:264;-1:-1:-1;;;;6610:580:264:o;8311:313::-;8533:25;;;8521:2;8506:18;;8567:51;8614:2;8599:18;;8591:6;8231:12;;8219:25;;8293:4;8282:16;;;8276:23;8260:14;;8253:47;8160:146;9384:649;9495:6;9503;9511;9519;9527;9580:3;9568:9;9559:7;9555:23;9551:33;9548:53;;;9597:1;9594;9587:12;9548:53;9620:28;9638:9;9620:28;:::i;:::-;9610:38;;9695:2;9684:9;9680:18;9667:32;9657:42;;9718:37;9751:2;9740:9;9736:18;9718:37;:::i;:::-;9708:47;;9806:2;9795:9;9791:18;9778:32;-1:-1:-1;;;;;9825:6:264;9822:30;9819:50;;;9865:1;9862;9855:12;9819:50;9904:69;9965:7;9956:6;9945:9;9941:22;9904:69;:::i;:::-;9384:649;;;;-1:-1:-1;9384:649:264;;-1:-1:-1;9992:8:264;;9878:95;9384:649;-1:-1:-1;;;9384:649:264:o;10038:252::-;10105:6;10113;10166:2;10154:9;10145:7;10141:23;10137:32;10134:52;;;10182:1;10179;10172:12;10134:52;10205:28;10223:9;10205:28;:::i;:::-;10195:38;10280:2;10265:18;;;;10252:32;;-1:-1:-1;;;10038:252:264:o;10500:173::-;10568:20;;-1:-1:-1;;;;;10617:31:264;;10607:42;;10597:70;;10663:1;10660;10653:12;10678:399;10762:6;10770;10778;10786;10839:3;10827:9;10818:7;10814:23;10810:33;10807:53;;;10856:1;10853;10846:12;10807:53;10879:28;10897:9;10879:28;:::i;:::-;10869:38;;10926:37;10959:2;10948:9;10944:18;10926:37;:::i;:::-;10916:47;;11010:2;10999:9;10995:18;10982:32;10972:42;;11033:38;11067:2;11056:9;11052:18;11033:38;:::i;:::-;11023:48;;10678:399;;;;;;;:::o;11082:881::-;11187:6;11195;11203;11211;11219;11227;11280:3;11268:9;11259:7;11255:23;11251:33;11248:53;;;11297:1;11294;11287:12;11248:53;11320:28;11338:9;11320:28;:::i;:::-;11310:38;;11367;11401:2;11390:9;11386:18;11367:38;:::i;:::-;11357:48;;11424:38;11458:2;11447:9;11443:18;11424:38;:::i;:::-;11414:48;;11509:2;11498:9;11494:18;11481:32;11471:42;;11564:3;11553:9;11549:19;11536:33;-1:-1:-1;;;;;11629:2:264;11621:6;11618:14;11615:34;;;11645:1;11642;11635:12;11615:34;11683:6;11672:9;11668:22;11658:32;;11728:7;11721:4;11717:2;11713:13;11709:27;11699:55;;11750:1;11747;11740:12;11699:55;11790:2;11777:16;11816:2;11808:6;11805:14;11802:34;;;11832:1;11829;11822:12;11802:34;11877:7;11872:2;11863:6;11859:2;11855:15;11851:24;11848:37;11845:57;;;11898:1;11895;11888:12;11845:57;11929:2;11925;11921:11;11911:21;;11951:6;11941:16;;;;;11082:881;;;;;;;;:::o;12407:252::-;12595:3;12580:19;;12608:45;12584:9;12635:6;12608:45;:::i;12664:248::-;12813:2;12798:18;;12846:1;12835:13;;12825:47;;12852:18;;:::i;:::-;12881:25;;;12664:248;:::o;13424:1007::-;13650:4;13692:3;13681:9;13677:19;13669:27;;13732:1;13728;13723:3;13719:11;13715:19;13780:2;13771:6;13765:13;13761:22;13750:9;13743:41;13831:4;13823:6;13819:17;13813:24;-1:-1:-1;;;;;13938:2:264;13924:12;13920:21;13913:4;13902:9;13898:20;13891:51;14010:2;14002:4;13994:6;13990:17;13984:24;13980:33;13973:4;13962:9;13958:20;13951:63;;;14082:2;14074:4;14066:6;14062:17;14056:24;14052:33;14045:4;14034:9;14030:20;14023:63;;14135:4;14127:6;14123:17;14117:24;14150:47;14182:14;14150:47;:::i;:::-;14228:4;14213:20;;14206:44;14287:13;;14281:3;14266:19;;14259:42;14350:4;14338:17;;;14332:24;8231:12;;14420:3;14405:19;;8219:25;8282:16;;;8276:23;8260:14;;;;8253:47;13424:1007;;-1:-1:-1;13424:1007:264:o;14436:127::-;14497:10;14492:3;14488:20;14485:1;14478:31;14528:4;14525:1;14518:15;14552:4;14549:1;14542:15;14568:253;14640:2;14634:9;14682:4;14670:17;;-1:-1:-1;;;;;14702:34:264;;14738:22;;;14699:62;14696:88;;;14764:18;;:::i;:::-;14800:2;14793:22;14568:253;:::o;14826:257::-;14898:4;14892:11;;;14930:17;;-1:-1:-1;;;;;14962:34:264;;14998:22;;;14959:62;14956:88;;;15024:18;;:::i;15088:275::-;15159:2;15153:9;15224:2;15205:13;;-1:-1:-1;;15201:27:264;15189:40;;-1:-1:-1;;;;;15244:34:264;;15280:22;;;15241:62;15238:88;;;15306:18;;:::i;:::-;15342:2;15335:22;15088:275;;-1:-1:-1;15088:275:264:o;15368:118::-;15454:5;15447:13;15440:21;15433:5;15430:32;15420:60;;15476:1;15473;15466:12;15491:156;15557:20;;15617:4;15606:16;;15596:27;;15586:55;;15637:1;15634;15627:12;15652:1564;15765:6;15773;15781;15789;15842:3;15830:9;15821:7;15817:23;15813:33;15810:53;;;15859:1;15856;15849:12;15810:53;15882:28;15900:9;15882:28;:::i;:::-;15872:38;;15929:2;15982;15971:9;15967:18;15954:32;-1:-1:-1;;;;;16046:2:264;16038:6;16035:14;16032:34;;;16062:1;16059;16052:12;16032:34;16085:22;;;;16141:4;16123:16;;;16119:27;16116:47;;;16159:1;16156;16149:12;16116:47;16185:22;;:::i;:::-;16230:21;16248:2;16230:21;:::i;:::-;16223:5;16216:36;16284:30;16310:2;16306;16302:11;16284:30;:::i;:::-;16279:2;16272:5;16268:14;16261:54;16360:2;16356;16352:11;16339:25;16373:30;16395:7;16373:30;:::i;:::-;16430:2;16419:14;;16412:31;16496:2;16488:11;;;16475:25;16459:14;;;16452:49;16547:3;16539:12;;16526:26;16564:16;;;16561:36;;;16593:1;16590;16583:12;16561:36;16624:8;16620:2;16616:17;16606:27;;;16671:7;16664:4;16660:2;16656:13;16652:27;16642:55;;16693:1;16690;16683:12;16642:55;16729:2;16716:16;16751:2;16747;16744:10;16741:36;;;16757:18;;:::i;:::-;16799:53;16842:2;16823:13;;-1:-1:-1;;16819:27:264;16815:36;;16799:53;:::i;:::-;16786:66;;16875:2;16868:5;16861:17;16915:7;16910:2;16905;16901;16897:11;16893:20;16890:33;16887:53;;;16936:1;16933;16926:12;16887:53;16991:2;16986;16982;16978:11;16973:2;16966:5;16962:14;16949:45;17035:1;17014:14;;;17010:23;;;17003:34;;;;17064:3;17053:15;;17046:30;-1:-1:-1;17057:5:264;-1:-1:-1;17119:36:264;17151:2;17136:18;;17119:36;:::i;:::-;17109:46;;17174:36;17206:2;17195:9;17191:18;17174:36;:::i;17221:241::-;17363:2;17348:18;;17396:1;17385:13;;17375:47;;17402:18;;:::i;17467:132::-;17528:38;17560:5;17528:38;:::i;:::-;17575:18;;17467:132::o;17604:459::-;17656:3;17694:5;17688:12;17721:6;17716:3;17709:19;17747:4;17776:2;17771:3;17767:12;17760:19;;17813:2;17806:5;17802:14;17834:1;17844:194;17858:6;17855:1;17852:13;17844:194;;;17923:13;;-1:-1:-1;;;;;17919:38:264;17907:51;;17978:12;;;;18013:15;;;;17880:1;17873:9;17844:194;;;-1:-1:-1;18054:3:264;;17604:459;-1:-1:-1;;;;;17604:459:264:o;18068:1300::-;18257:2;18246:9;18239:21;18269:52;18317:2;18306:9;18302:18;18293:6;18287:13;-1:-1:-1;;;;;588:30:264;576:43;;523:102;18269:52;18220:4;18368:2;18360:6;18356:15;18350:22;18381:51;18428:2;18417:9;18413:18;18399:12;-1:-1:-1;;;;;588:30:264;576:43;;523:102;18381:51;;18481:2;18473:6;18469:15;18463:22;18494:61;18551:2;18540:9;18536:18;18520:14;18494:61;:::i;:::-;-1:-1:-1;18604:2:264;18592:15;;18586:22;-1:-1:-1;;;;;588:30:264;;18666:3;18651:19;;576:43;18617:54;18726:3;18718:6;18714:16;18708:23;18702:3;18691:9;18687:19;18680:52;18787:3;18779:6;18775:16;18769:23;18763:3;18752:9;18748:19;18741:52;18848:3;18840:6;18836:16;18830:23;18824:3;18813:9;18809:19;18802:52;18891:3;18883:6;18879:16;18873:23;18915:3;18954:2;18949;18938:9;18934:18;18927:30;19006:2;18998:6;18994:15;18988:22;18966:44;;;19029:3;19041:59;19096:2;19085:9;19081:18;19065:14;8231:12;;8219:25;;8293:4;8282:16;;;8276:23;8260:14;;8253:47;8160:146;19041:59;19143:15;;19137:22;19131:3;19116:19;;19109:51;-1:-1:-1;19209:6:264;19197:19;;19191:26;19236:6;19258:18;;;19251:30;19298:64;19357:3;19342:19;;19191:26;19298:64;:::i;19373:514::-;19626:6;19615:9;19608:25;19669:6;19664:2;19653:9;19649:18;19642:34;19712:6;19707:2;19696:9;19692:18;19685:34;19769:6;19762:14;19755:22;19750:2;19739:9;19735:18;19728:50;19815:3;19809;19798:9;19794:19;19787:32;19589:4;19836:45;19876:3;19865:9;19861:19;19853:6;19836:45;:::i;20135:1007::-;-1:-1:-1;;;;;20644:15:264;;;20626:34;;20696:15;;;20691:2;20676:18;;20669:43;20576:3;20561:19;;;20721:39;20753:6;20721:39;:::i;:::-;20796:6;20791:2;20780:9;20776:18;20769:34;20851:2;20843:6;20839:15;20834:2;20823:9;20819:18;20812:43;;20892:6;20886:3;20875:9;20871:19;20864:35;20936:6;20930:3;20919:9;20915:19;20908:35;20980:6;20974:3;20963:9;20959:19;20952:35;21024:6;21018:3;21007:9;21003:19;20996:35;21040:52;21087:3;21076:9;21072:19;21064:6;8231:12;;8219:25;;8293:4;8282:16;;;8276:23;8260:14;;8253:47;8160:146;21040:52;21129:6;21123:3;21112:9;21108:19;21101:35;20135:1007;;;;;;;;;;;;;:::o;21147:127::-;21208:10;21203:3;21199:20;21196:1;21189:31;21239:4;21236:1;21229:15;21263:4;21260:1;21253:15;21279:128;21346:9;;;21367:11;;;21364:37;;;21381:18;;:::i;21412:125::-;21477:9;;;21498:10;;;21495:36;;;21511:18;;:::i;21542:127::-;21603:10;21598:3;21594:20;21591:1;21584:31;21634:4;21631:1;21624:15;21658:4;21655:1;21648:15;21674:135;21713:3;21734:17;;;21731:43;;21754:18;;:::i;:::-;-1:-1:-1;21801:1:264;21790:13;;21674:135::o;21814:245::-;21881:6;21934:2;21922:9;21913:7;21909:23;21905:32;21902:52;;;21950:1;21947;21940:12;21902:52;21982:9;21976:16;22001:28;22023:5;22001:28;:::i;22064:380::-;22143:1;22139:12;;;;22186;;;22207:61;;22261:4;22253:6;22249:17;22239:27;;22207:61;22314:2;22306:6;22303:14;22283:18;22280:38;22277:161;;22360:10;22355:3;22351:20;22348:1;22341:31;22395:4;22392:1;22385:15;22423:4;22420:1;22413:15;22277:161;;22064:380;;;:::o;23415:176::-;23482:14;23516:10;;;23528;;;23512:27;;23551:11;;;23548:37;;;23565:18;;:::i;:::-;23548:37;23415:176;;;;:::o;23721:544::-;23822:2;23817:3;23814:11;23811:448;;;23858:1;23883:5;23879:2;23872:17;23928:4;23924:2;23914:19;23998:2;23986:10;23982:19;23979:1;23975:27;23969:4;23965:38;24034:4;24022:10;24019:20;24016:47;;;-1:-1:-1;24057:4:264;24016:47;24112:2;24107:3;24103:12;24100:1;24096:20;24090:4;24086:31;24076:41;;24167:82;24185:2;24178:5;24175:13;24167:82;;;24230:17;;;24211:1;24200:13;24167:82;;;24171:3;;;23721:544;;;:::o;24441:1348::-;24565:3;24559:10;-1:-1:-1;;;;;24584:6:264;24581:30;24578:56;;;24614:18;;:::i;:::-;24643:96;24732:6;24692:38;24724:4;24718:11;24692:38;:::i;:::-;24686:4;24643:96;:::i;:::-;24794:4;;24858:2;24847:14;;24875:1;24870:662;;;;25576:1;25593:6;25590:89;;;-1:-1:-1;25645:19:264;;;25639:26;25590:89;-1:-1:-1;;24398:1:264;24394:11;;;24390:24;24386:29;24376:40;24422:1;24418:11;;;24373:57;25692:81;;24840:943;;24870:662;23668:1;23661:14;;;23705:4;23692:18;;-1:-1:-1;;24906:20:264;;;25023:236;25037:7;25034:1;25031:14;25023:236;;;25126:19;;;25120:26;25105:42;;25218:27;;;;25186:1;25174:14;;;;25053:19;;25023:236;;;25027:3;25287:6;25278:7;25275:19;25272:201;;;25348:19;;;25342:26;-1:-1:-1;;25431:1:264;25427:14;;;25443:3;25423:24;25419:37;25415:42;25400:58;25385:74;;25272:201;-1:-1:-1;;;;;25519:1:264;25503:14;;;25499:22;25486:36;;-1:-1:-1;24441:1348:264:o;25794:184::-;25852:6;25905:2;25893:9;25884:7;25880:23;25876:32;25873:52;;;25921:1;25918;25911:12;25873:52;25944:28;25962:9;25944:28;:::i;25983:183::-;-1:-1:-1;;;;;26102:10:264;;;26090;;;26086:27;;26125:12;;;26122:38;;;26140:18;;:::i;26171:422::-;26260:1;26303:5;26260:1;26317:270;26338:7;26328:8;26325:21;26317:270;;;26397:4;26393:1;26389:6;26385:17;26379:4;26376:27;26373:53;;;26406:18;;:::i;:::-;26456:7;26446:8;26442:22;26439:55;;;26476:16;;;;26439:55;26555:22;;;;26515:15;;;;26317:270;;;26321:3;26171:422;;;;;:::o;26598:806::-;26647:5;26677:8;26667:80;;-1:-1:-1;26718:1:264;26732:5;;26667:80;26766:4;26756:76;;-1:-1:-1;26803:1:264;26817:5;;26756:76;26848:4;26866:1;26861:59;;;;26934:1;26929:130;;;;26841:218;;26861:59;26891:1;26882:10;;26905:5;;;26929:130;26966:3;26956:8;26953:17;26950:43;;;26973:18;;:::i;:::-;-1:-1:-1;;27029:1:264;27015:16;;27044:5;;26841:218;;27143:2;27133:8;27130:16;27124:3;27118:4;27115:13;27111:36;27105:2;27095:8;27092:16;27087:2;27081:4;27078:12;27074:35;27071:77;27068:159;;;-1:-1:-1;27180:19:264;;;27212:5;;27068:159;27259:34;27284:8;27278:4;27259:34;:::i;:::-;27329:6;27325:1;27321:6;27317:19;27308:7;27305:32;27302:58;;;27340:18;;:::i;:::-;27378:20;;26598:806;-1:-1:-1;;;26598:806:264:o;27409:140::-;27467:5;27496:47;27537:4;27527:8;27523:19;27517:4;27496:47;:::i;27554:180::-;-1:-1:-1;;;;;27659:10:264;;;27671;;;27655:27;;27694:11;;;27691:37;;;27708:18;;:::i;27739:209::-;27777:3;-1:-1:-1;;;;;27858:2:264;27851:5;27847:14;27885:2;27876:7;27873:15;27870:41;;27891:18;;:::i;:::-;27940:1;27927:15;;27739:209;-1:-1:-1;;;27739:209:264:o;29269:127::-;29330:10;29325:3;29321:20;29318:1;29311:31;29361:4;29358:1;29351:15;29385:4;29382:1;29375:15;29401:489;29493:6;29501;29545:9;29536:7;29532:23;29575:2;29571;29567:11;29564:31;;;29591:1;29588;29581:12;29564:31;29614:23;;;-1:-1:-1;29671:4:264;-1:-1:-1;;29653:16:264;;29649:27;29646:47;;;29689:1;29686;29679:12;29646:47;;29715:22;;:::i;:::-;29788:2;29777:9;29773:18;29760:32;29753:5;29746:47;29853:4;29842:9;29838:20;29825:34;29820:2;29813:5;29809:14;29802:58;29879:5;29869:15;;;29401:489;;;;;:::o;29895:277::-;29958:5;30006:4;29994:9;29989:3;29985:19;29981:30;29978:50;;;30024:1;30021;30014:12;29978:50;30046:22;;:::i;:::-;30037:31;;30097:9;30091:16;30084:5;30077:31;30161:2;30150:9;30146:18;30140:25;30135:2;30128:5;30124:14;30117:49;29895:277;;;;:::o;30177:766::-;30283:6;30336:3;30324:9;30315:7;30311:23;30307:33;30304:53;;;30353:1;30350;30343:12;30304:53;30386:2;30380:9;30428:4;30420:6;30416:17;30499:6;30487:10;30484:22;-1:-1:-1;;;;;30451:10:264;30448:34;30445:62;30442:88;;;30510:18;;:::i;:::-;30546:2;30539:22;30585:16;;30570:32;;30645:2;30630:18;;30624:25;30689:8;30678:20;;30668:31;;30658:59;;30713:1;30710;30703:12;30658:59;30745:2;30733:15;;30726:30;30810:2;30795:18;;;30789:25;30772:15;;;30765:50;30848:63;30903:7;30898:2;30883:18;;30848:63;:::i;:::-;30843:2;30831:15;;30824:88;30835:6;30177:766;-1:-1:-1;;;30177:766:264:o;31584:287::-;31713:3;31751:6;31745:13;31767:66;31826:6;31821:3;31814:4;31806:6;31802:17;31767:66;:::i;:::-;31849:16;;;;;31584:287;-1:-1:-1;;31584:287:264:o;32218:246::-;32312:6;32365:2;32353:9;32344:7;32340:23;32336:32;32333:52;;;32381:1;32378;32371:12;32333:52;32404:54;32450:7;32439:9;32404:54;:::i;34914:297::-;35032:12;;35079:4;35068:16;;;35062:23;;35032:12;35097:16;;35094:111;;;-1:-1:-1;;35171:4:264;35167:17;;;;35164:1;35160:25;35156:38;35145:50;;34914:297;-1:-1:-1;34914:297:264:o;35559:136::-;35598:3;35626:5;35616:39;;35635:18;;:::i;:::-;-1:-1:-1;;;35671:18:264;;35559:136::o",
    linkReferences: {},
    immutableReferences: {
      "88907": [
        {
          start: 907,
          length: 32
        },
        {
          start: 2856,
          length: 32
        },
        {
          start: 2927,
          length: 32
        },
        {
          start: 3321,
          length: 32
        },
        {
          start: 3428,
          length: 32
        },
        {
          start: 3494,
          length: 32
        },
        {
          start: 3933,
          length: 32
        },
        {
          start: 4830,
          length: 32
        },
        {
          start: 4896,
          length: 32
        },
        {
          start: 5164,
          length: 32
        },
        {
          start: 5230,
          length: 32
        },
        {
          start: 6269,
          length: 32
        },
        {
          start: 6335,
          length: 32
        },
        {
          start: 6595,
          length: 32
        },
        {
          start: 6661,
          length: 32
        },
        {
          start: 7729,
          length: 32
        },
        {
          start: 7795,
          length: 32
        },
        {
          start: 8161,
          length: 32
        }
      ]
    }
  },
  methodIdentifiers: {
    "INIT()": "ea643914",
    "PARENT()": "122b83f9",
    "TYPE()": "bb24fe8a",
    "VEECODE()": "d61735ca",
    "abort(uint96)": "1ed75f1f",
    "auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)": "bae96bdd",
    "auctionData(uint96)": "e2cfa6ea",
    "auctionType()": "994595e1",
    "bid(uint96,address,address,uint256,bytes)": "87698a31",
    "bids(uint96,uint64)": "0fb276fc",
    "cancelAuction(uint96)": "b04046df",
    "capacityInQuote(uint96)": "39792cdc",
    "claimBids(uint96,uint64[])": "0a35511b",
    "decryptAndSortBids(uint96,uint64,bytes32[])": "25e34a8e",
    "decryptBid(uint96,uint64)": "a1a61ec5",
    "decryptedBids(uint96)": "de1d3112",
    "dedicatedSettlePeriod()": "a85cebb6",
    "encryptedBids(uint96,uint64)": "54c87c01",
    "getAuctionData(uint96)": "cadb3383",
    "getBid(uint96,uint64)": "a8bf44e4",
    "getBidClaim(uint96,uint64)": "8f21c318",
    "getBidIdAtIndex(uint96,uint256)": "7d7b6853",
    "getBidIds(uint96,uint256,uint256)": "00b33217",
    "getLot(uint96)": "4e1f4258",
    "getNextInQueue(uint96,bytes32)": "8bde6109",
    "getNumBids(uint96)": "d899a337",
    "getNumBidsInQueue(uint96)": "0cf5538d",
    "getPartialFill(uint96)": "a16f7ef7",
    "hasEnded(uint96)": "03855921",
    "isLive(uint96)": "732efc03",
    "isUpcoming(uint96)": "0440ec53",
    "lotAuctionOutput(uint96)": "0cd0bcf2",
    "lotData(uint96)": "5806afc3",
    "minAuctionDuration()": "54134876",
    "refundBid(uint96,uint64,uint256,address)": "7d9234bc",
    "remainingCapacity(uint96)": "ace54da5",
    "setDedicatedSettlePeriod(uint48)": "29da5abd",
    "setMinAuctionDuration(uint48)": "12d6ef2d",
    "settle(uint96,uint256)": "cd280bdb",
    "submitPrivateKey(uint96,uint256,uint64,bytes32[])": "79fd0c1f"
  },
  rawMetadata: '{"compiler":{"version":"0.8.19+commit.7dd6d404"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"auctionHouse_","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"Auction_AmountLessThanMinimum","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_DedicatedSettlePeriod","type":"error"},{"inputs":[],"name":"Auction_InsufficientCapacity","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"uint96","name":"bidId","type":"uint96"}],"name":"Auction_InvalidBidId","type":"error"},{"inputs":[{"internalType":"uint48","name":"duration_","type":"uint48"},{"internalType":"uint48","name":"minimum_","type":"uint48"}],"name":"Auction_InvalidDuration","type":"error"},{"inputs":[],"name":"Auction_InvalidKey","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_InvalidLotId","type":"error"},{"inputs":[],"name":"Auction_InvalidParams","type":"error"},{"inputs":[{"internalType":"uint48","name":"start_","type":"uint48"},{"internalType":"uint48","name":"minimum_","type":"uint48"}],"name":"Auction_InvalidStart","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_LotActive","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_LotNotActive","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_LotNotConcluded","type":"error"},{"inputs":[],"name":"Auction_NotAuthorized","type":"error"},{"inputs":[],"name":"Auction_NotBidder","type":"error"},{"inputs":[],"name":"Auction_NotImplemented","type":"error"},{"inputs":[],"name":"Auction_OnlyLotOwner","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_WrongState","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"uint64","name":"bidId","type":"uint64"}],"name":"Bid_WrongState","type":"error"},{"inputs":[{"internalType":"address","name":"parent_","type":"address"}],"name":"Module_InvalidParent","type":"error"},{"inputs":[],"name":"Module_OnlyInternal","type":"error"},{"inputs":[{"internalType":"address","name":"caller_","type":"address"}],"name":"Module_OnlyParent","type":"error"},{"inputs":[{"internalType":"address","name":"caller","type":"address"}],"name":"NotPermitted","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"},{"indexed":true,"internalType":"uint64","name":"bidId","type":"uint64"},{"indexed":false,"internalType":"uint96","name":"amountIn","type":"uint96"},{"indexed":false,"internalType":"uint96","name":"amountOut","type":"uint96"}],"name":"BidDecrypted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"PrivateKeySubmitted","type":"event"},{"inputs":[],"name":"INIT","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"PARENT","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TYPE","outputs":[{"internalType":"enum Module.Type","name":"","type":"uint8"}],"stateMutability":"pure","type":"function"},{"inputs":[],"name":"VEECODE","outputs":[{"internalType":"Veecode","name":"","type":"bytes7"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"abort","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"components":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"duration","type":"uint48"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"bytes","name":"implParams","type":"bytes"}],"internalType":"struct IAuction.AuctionParams","name":"params_","type":"tuple"},{"internalType":"uint8","name":"quoteTokenDecimals_","type":"uint8"},{"internalType":"uint8","name":"baseTokenDecimals_","type":"uint8"}],"name":"auction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"auctionData","outputs":[{"internalType":"uint64","name":"nextBidId","type":"uint64"},{"internalType":"uint64","name":"nextDecryptIndex","type":"uint64"},{"internalType":"enum IEncryptedMarginalPrice.LotStatus","name":"status","type":"uint8"},{"internalType":"uint64","name":"marginalBidId","type":"uint64"},{"internalType":"uint256","name":"marginalPrice","type":"uint256"},{"internalType":"uint256","name":"minPrice","type":"uint256"},{"internalType":"uint256","name":"minFilled","type":"uint256"},{"internalType":"uint256","name":"minBidSize","type":"uint256"},{"components":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"internalType":"struct Point","name":"publicKey","type":"tuple"},{"internalType":"uint256","name":"privateKey","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"auctionType","outputs":[{"internalType":"enum IAuction.AuctionType","name":"","type":"uint8"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"address","name":"bidder_","type":"address"},{"internalType":"address","name":"referrer_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"},{"internalType":"bytes","name":"auctionData_","type":"bytes"}],"name":"bid","outputs":[{"internalType":"uint64","name":"bidId","type":"uint64"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"uint64","name":"bidId","type":"uint64"}],"name":"bids","outputs":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"uint96","name":"amount","type":"uint96"},{"internalType":"uint96","name":"minAmountOut","type":"uint96"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"enum IEncryptedMarginalPrice.BidStatus","name":"status","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"cancelAuction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"capacityInQuote","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64[]","name":"bidIds_","type":"uint64[]"}],"name":"claimBids","outputs":[{"components":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"uint256","name":"paid","type":"uint256"},{"internalType":"uint256","name":"payout","type":"uint256"},{"internalType":"uint256","name":"refund","type":"uint256"}],"internalType":"struct IBatchAuction.BidClaim[]","name":"bidClaims","type":"tuple[]"},{"internalType":"bytes","name":"auctionOutput","type":"bytes"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"num_","type":"uint64"},{"internalType":"bytes32[]","name":"sortHints_","type":"bytes32[]"}],"name":"decryptAndSortBids","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"}],"name":"decryptBid","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"decryptedBids","outputs":[{"internalType":"uint256","name":"numBids","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"dedicatedSettlePeriod","outputs":[{"internalType":"uint48","name":"","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"uint64","name":"bidId","type":"uint64"}],"name":"encryptedBids","outputs":[{"internalType":"uint256","name":"encryptedAmountOut","type":"uint256"},{"components":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"internalType":"struct Point","name":"bidPubKey","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getAuctionData","outputs":[{"components":[{"internalType":"uint64","name":"nextBidId","type":"uint64"},{"internalType":"uint64","name":"nextDecryptIndex","type":"uint64"},{"internalType":"enum IEncryptedMarginalPrice.LotStatus","name":"status","type":"uint8"},{"internalType":"uint64","name":"marginalBidId","type":"uint64"},{"internalType":"uint256","name":"marginalPrice","type":"uint256"},{"internalType":"uint256","name":"minPrice","type":"uint256"},{"internalType":"uint256","name":"minFilled","type":"uint256"},{"internalType":"uint256","name":"minBidSize","type":"uint256"},{"components":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"internalType":"struct Point","name":"publicKey","type":"tuple"},{"internalType":"uint256","name":"privateKey","type":"uint256"},{"internalType":"uint64[]","name":"bidIds","type":"uint64[]"}],"internalType":"struct IEncryptedMarginalPrice.AuctionData","name":"auctionData_","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"}],"name":"getBid","outputs":[{"components":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"uint96","name":"amount","type":"uint96"},{"internalType":"uint96","name":"minAmountOut","type":"uint96"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"enum IEncryptedMarginalPrice.BidStatus","name":"status","type":"uint8"}],"internalType":"struct IEncryptedMarginalPrice.Bid","name":"bid","type":"tuple"},{"components":[{"internalType":"uint256","name":"encryptedAmountOut","type":"uint256"},{"components":[{"internalType":"uint256","name":"x","type":"uint256"},{"internalType":"uint256","name":"y","type":"uint256"}],"internalType":"struct Point","name":"bidPubKey","type":"tuple"}],"internalType":"struct IEncryptedMarginalPrice.EncryptedBid","name":"encryptedBid","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"}],"name":"getBidClaim","outputs":[{"components":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"uint256","name":"paid","type":"uint256"},{"internalType":"uint256","name":"payout","type":"uint256"},{"internalType":"uint256","name":"refund","type":"uint256"}],"internalType":"struct IBatchAuction.BidClaim","name":"bidClaim","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint256","name":"index_","type":"uint256"}],"name":"getBidIdAtIndex","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint256","name":"startIndex_","type":"uint256"},{"internalType":"uint256","name":"num_","type":"uint256"}],"name":"getBidIds","outputs":[{"internalType":"uint64[]","name":"","type":"uint64[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getLot","outputs":[{"components":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"conclusion","type":"uint48"},{"internalType":"uint8","name":"quoteTokenDecimals","type":"uint8"},{"internalType":"uint8","name":"baseTokenDecimals","type":"uint8"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"uint256","name":"sold","type":"uint256"},{"internalType":"uint256","name":"purchased","type":"uint256"}],"internalType":"struct IAuction.Lot","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"bytes32","name":"key_","type":"bytes32"}],"name":"getNextInQueue","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getNumBids","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getNumBidsInQueue","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getPartialFill","outputs":[{"internalType":"bool","name":"hasPartialFill","type":"bool"},{"components":[{"internalType":"uint64","name":"bidId","type":"uint64"},{"internalType":"uint96","name":"refund","type":"uint96"},{"internalType":"uint256","name":"payout","type":"uint256"}],"internalType":"struct IEncryptedMarginalPrice.PartialFill","name":"partialFill","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"hasEnded","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"isLive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"isUpcoming","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"","type":"uint96"}],"name":"lotAuctionOutput","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"id","type":"uint96"}],"name":"lotData","outputs":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"conclusion","type":"uint48"},{"internalType":"uint8","name":"quoteTokenDecimals","type":"uint8"},{"internalType":"uint8","name":"baseTokenDecimals","type":"uint8"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"uint256","name":"sold","type":"uint256"},{"internalType":"uint256","name":"purchased","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"minAuctionDuration","outputs":[{"internalType":"uint48","name":"","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"},{"internalType":"uint256","name":"index_","type":"uint256"},{"internalType":"address","name":"caller_","type":"address"}],"name":"refundBid","outputs":[{"internalType":"uint256","name":"refund","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"remainingCapacity","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint48","name":"period_","type":"uint48"}],"name":"setDedicatedSettlePeriod","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint48","name":"duration_","type":"uint48"}],"name":"setMinAuctionDuration","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint256","name":"num_","type":"uint256"}],"name":"settle","outputs":[{"internalType":"uint256","name":"totalIn","type":"uint256"},{"internalType":"uint256","name":"totalOut","type":"uint256"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"bool","name":"finished","type":"bool"},{"internalType":"bytes","name":"auctionOutput","type":"bytes"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint256","name":"privateKey_","type":"uint256"},{"internalType":"uint64","name":"num_","type":"uint64"},{"internalType":"bytes32[]","name":"sortHints_","type":"bytes32[]"}],"name":"submitPrivateKey","outputs":[],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"details":"This batch auction module allows for bids to be encrypted off-chain, then stored, decrypted and settled on-chain.             Note that the maximum bid amount is bounded by uint96.","events":{"BidDecrypted(uint96,uint64,uint96,uint96)":{"params":{"amountIn":"The amount in","amountOut":"The amount out","bidId":"The bid ID","lotId":"The lot ID"}},"PrivateKeySubmitted(uint96)":{"params":{"lotId":"The lot ID"}}},"kind":"dev","methods":{"INIT()":{"details":"This function is called when the module is installed or upgraded by the module.MUST BE GATED BY onlyParent. Used to encompass any initialization or upgrade logic."},"TYPE()":{"details":"This enables the parent contract to check that the module Keycode specifiedis of the correct type"},"abort(uint96)":{"details":"Implements a basic abort function that:             - Validates the lot id and state             - Calls the implementation-specific function             The abort function allows anyone to abort the lot after the conclusion and settlement time has passed.             This can be useful if the lot is unable to be settled, or if the seller is unwilling to settle the lot.             This function reverts if:             - The lot id is invalid             - The lot has not concluded             - The lot is in the dedicated settle period             - The lot is settled (after which it cannot be aborted)","params":{"lotId_":"The lot id"}},"auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)":{"details":"If the start time is zero, the auction will have a start time of the current block timestamp.             This function handles the following:             - Validates the lot parameters             - Stores the auction lot             - Calls the implementation-specific function             This function reverts if:             - The caller is not the parent of the module             - The start time is in the past             - The duration is less than the minimum","params":{"baseTokenDecimals_":"The base token decimals","lotId_":"The lot id","params_":"The auction parameters","quoteTokenDecimals_":"The quote token decimals"}},"bid(uint96,address,address,uint256,bytes)":{"details":"Implements a basic bid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot has concluded             - The lot is already settled             - The caller is not an internal module","params":{"amount_":"The amount of quote tokens to bid","auctionData_":"The auction-specific data","bidder_":"The bidder of the purchased tokens","lotId_":"The lot id","referrer_":"The referrer of the bid"},"returns":{"bidId":"          The bid id"}},"cancelAuction(uint96)":{"details":"Assumptions:             - The parent will refund the seller the remaining capacity             - The parent will verify that the caller is the seller             This function handles the following:             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - the caller is not the parent of the module             - the lot id is invalid             - the lot has concluded","params":{"lotId_":"The lot id"}},"capacityInQuote(uint96)":{"details":"The implementing function should handle the following:             - Return true if the capacity is in quote tokens             - Return false if the capacity is in base tokens","params":{"lotId_":"The lot id"},"returns":{"_0":"bool    Whether or not the capacity is in quote tokens"}},"claimBids(uint96,uint64[])":{"details":"Implements a basic claimBids function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot is not settled             - The caller is not an internal module","params":{"bidIds_":"The bid ids","lotId_":"The lot id"},"returns":{"auctionOutput":"  The auction-specific output","bidClaims":"      The bid claim data"}},"decryptAndSortBids(uint96,uint64,bytes32[])":{"details":"This function handles the following:             - Performs state validation             - Iterates over the encrypted bids:                 - Decrypts the bid                 - Ignores if the bid is incorrectly encrypted                 - Does not add to the sorted bid queue if the decrypted amount out is less than the minimum bid size or overflows                 - Otherwise, adds to the sorted bid queue for use during settlement             - Determines the next decrypt index             - Sets the auction status to decrypted if all bids have been decrypted             This function reverts if:             - The lot ID is invalid             - The lot has not started             - The lot is active             - The private key has not been provided             - `num_` and `sortHints_` have different lengths","params":{"lotId_":"The lot ID","num_":"The number of bids to decrypt and sort","sortHints_":"The sort hints for the bids"}},"decryptBid(uint96,uint64)":{"details":"This function does not alter the state of the contract, but provides a way to peek at the decrypted bid             This function reverts if:             - The lot ID is invalid             - The private key has not been provided","params":{"bidId_":"The bid ID to decrypt","lotId_":"The lot ID of the auction to decrypt the bid for"},"returns":{"amountOut":"  The decrypted amount out"}},"getAuctionData(uint96)":{"details":"This function reverts if:             - The lot ID is invalid","params":{"lotId_":"The lot ID"},"returns":{"auctionData_":"   The `AuctionData`"}},"getBid(uint96,uint64)":{"details":"This function reverts if:             - The lot ID is invalid             - The bid ID is invalid","params":{"bidId_":"The bid ID","lotId_":"The lot ID"},"returns":{"bid":"            The `Bid` data","encryptedBid":"   The `EncryptedBid` data"}},"getBidClaim(uint96,uint64)":{"details":"This function reverts if:             - The lot ID is invalid             - The lot is not settled (since there would be no claim)             - The bid ID is invalid","params":{"bidId_":"The bid ID","lotId_":"The lot ID"},"returns":{"bidClaim":"   The bid claim data"}},"getBidIdAtIndex(uint96,uint256)":{"params":{"index_":"The index","lotId_":"The lot ID"},"returns":{"_0":"  The bid ID"}},"getBidIds(uint96,uint256,uint256)":{"details":"This function reverts if:             - The lot ID is invalid","params":{"count_":"The number of bids to retrieve","lotId_":"The lot ID","start_":"The index to start retrieving bid IDs from"},"returns":{"_0":" The bid IDs"}},"getLot(uint96)":{"params":{"lotId_":"The lot ID"}},"getNextInQueue(uint96,bytes32)":{"params":{"key_":"The key to search for","lotId_":"The lot ID"},"returns":{"_0":"The key of the next bid in the queue"}},"getNumBids(uint96)":{"details":"This function reverts if:             - The lot ID is invalid","params":{"lotId_":"The lot ID"},"returns":{"_0":"The number of bids"}},"getNumBidsInQueue(uint96)":{"params":{"lotId_":"The lot ID"},"returns":{"_0":"The number of decrypted bids remaining in the queue"}},"getPartialFill(uint96)":{"details":"For ease of use, this function determines if a partial fill exists.             This function reverts if:             - The lot ID is invalid             - The lot is not settled","params":{"lotId_":"The lot ID"},"returns":{"hasPartialFill":" True if a partial fill exists","partialFill":"    The `PartialFill` data"}},"hasEnded(uint96)":{"details":"The implementing function should handle the following:             - Return true if the lot is not accepting bids/purchases and will not at any point             - Return false if the lot hasn\'t started or is actively accepting bids/purchases","params":{"lotId_":"The lot id"},"returns":{"_0":"bool    Whether or not the lot is active"}},"isLive(uint96)":{"details":"A lot is active if:             - The lot has not concluded             - The lot has started             - The lot has not sold out or been cancelled (capacity > 0)","params":{"lotId_":"The lot ID"},"returns":{"_0":"bool    Whether or not the lot is active"}},"isUpcoming(uint96)":{"details":"The implementing function should handle the following:             - Return true if the lot has not started yet AND has not been cancelled             - Return false if the lot is active, has ended, or was cancelled","params":{"lotId_":"The lot id"},"returns":{"_0":"bool    Whether or not the lot is upcoming"}},"refundBid(uint96,uint64,uint256,address)":{"details":"Implements a basic refundBid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is decrypted or settled (but not concluded)             - The lot is within the dedicated settle period             - The bid id is invalid             - `caller_` is not the bid owner             - The bid is claimed or refunded             - The caller is not an internal module             This is a modified version of the refundBid function in the AuctionModule contract.             It does not revert if the lot is concluded.","params":{"bidId_":"The bid id","caller_":"The caller","index_":"The index of the bid ID in the auction\'s bid list","lotId_":"The lot id"},"returns":{"refund":"     The amount of quote tokens to refund"}},"remainingCapacity(uint96)":{"details":"The implementing function should handle the following:             - Return the remaining capacity of the lot","params":{"lotId_":"The lot id"},"returns":{"_0":"uint96 The remaining capacity of the lot"}},"setMinAuctionDuration(uint48)":{"details":"This function must be called by the parent AuctionHouse, and             can be called by governance using `execOnModule`."},"settle(uint96,uint256)":{"details":"Implements a basic settle function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is active             - The lot has already been settled             - The caller is not an internal module","params":{"lotId_":"The lot id","num_":"The number of winning bids to settle (capped at the remaining number if more is provided)"},"returns":{"auctionOutput":"  Custom data returned by the auction module","capacity":"       The original capacity of the lot","finished":"       Whether the settlement is finished","totalIn":"        Total amount of quote tokens from bids that were filled","totalOut":"       Total amount of base tokens paid out to winning bids"}},"submitPrivateKey(uint96,uint256,uint64,bytes32[])":{"details":"This function reverts if:             - The lot ID is invalid             - The lot is not active             - The lot has not concluded             - The private key has already been submitted             - The lot has been settled (cancelled, settled or aborted)             - The private key is invalid for the public key","params":{"lotId_":"The lot ID of the auction to submit the private key for","num_":"The number of bids to decrypt after submitting the private key (passed to `_decryptAndSortBids()`)","privateKey_":"The ECIES private key to decrypt the bids","sortHints_":"The sort hints for the bid decryption (passed to `_decryptAndSortBids()`)"}}},"stateVariables":{"_lotPartialFill":{"details":"Each EMPA can have at most one partial fill             Access via `getPartialFill()`"},"_lotPartialSettlement":{"details":"Only used internally, does not need a public accessor"},"auctionData":{"details":"Access via `getAuctionData()`"},"bids":{"details":"Access via `getBid()`"},"decryptedBids":{"details":"Access elements via `getNextInQueue()`"},"encryptedBids":{"details":"Access via `getBid()`"}},"version":1},"userdoc":{"errors":{"Module_InvalidParent(address)":[{"notice":"Error when the parent contract is invalid"}],"Module_OnlyInternal()":[{"notice":"Error when a module function is called by a non-internal contract"}],"Module_OnlyParent(address)":[{"notice":"Error when a module function is called by a non-parent contract"}]},"events":{"BidDecrypted(uint96,uint64,uint96,uint96)":{"notice":"Emitted when a bid is decrypted"},"PrivateKeySubmitted(uint96)":{"notice":"Emitted when the private key for an auction lot is submitted"}},"kind":"user","methods":{"INIT()":{"notice":"Initialization function for the module"},"PARENT()":{"notice":"The parent contract for this module."},"TYPE()":{"notice":"2 byte identifier for the module type"},"VEECODE()":{"notice":"7 byte, versioned identifier for the module. 2 characters from 0-9 that signify the version and 3-5 characters from A-Z."},"abort(uint96)":{"notice":"Abort a batch auction that cannot be settled, refunding the seller and allowing bidders to claim refunds"},"auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)":{"notice":"Create an auction lot"},"auctionData(uint96)":{"notice":"Auction-specific data for a lot"},"auctionType()":{"notice":"Get the auction type"},"bid(uint96,address,address,uint256,bytes)":{"notice":"Bid on an auction lot"},"bids(uint96,uint64)":{"notice":"General information about bids on a lot"},"cancelAuction(uint96)":{"notice":"Cancel an auction lot"},"capacityInQuote(uint96)":{"notice":"Get whether or not the capacity is in quote tokens"},"claimBids(uint96,uint64[])":{"notice":"Claim multiple bids"},"decryptAndSortBids(uint96,uint64,bytes32[])":{"notice":"Decrypts a batch of bids and sorts them by price in descending order"},"decryptBid(uint96,uint64)":{"notice":"Returns the decrypted amountOut of a single bid without altering contract state"},"decryptedBids(uint96)":{"notice":"Queue of decrypted bids for a lot (populated on decryption)"},"dedicatedSettlePeriod()":{"notice":"Time period after auction conclusion where bidders cannot refund bids"},"encryptedBids(uint96,uint64)":{"notice":"Data for encryption information for a specific bid"},"getAuctionData(uint96)":{"notice":"Returns the `AuctionData` data for an auction lot"},"getBid(uint96,uint64)":{"notice":"Returns the `Bid` and `EncryptedBid` data for a given lot and bid ID"},"getBidClaim(uint96,uint64)":{"notice":"Get the claim data for a bidThis provides information on the outcome of a bid, independent of the claim status"},"getBidIdAtIndex(uint96,uint256)":{"notice":"Get the bid ID at the given index"},"getBidIds(uint96,uint256,uint256)":{"notice":"Get the bid IDs from the given index"},"getLot(uint96)":{"notice":"Get the lot data for a given lot ID"},"getNextInQueue(uint96,bytes32)":{"notice":"Returns the bid after `key_` in the queue"},"getNumBids(uint96)":{"notice":"Get the number of bids for a lot"},"getNumBidsInQueue(uint96)":{"notice":"Returns the number of decrypted bids remaining in the queue"},"getPartialFill(uint96)":{"notice":"Returns the `PartialFill` data for an auction lot"},"hasEnded(uint96)":{"notice":"Returns whether the auction has ended"},"isLive(uint96)":{"notice":"Returns whether the auction is currently accepting bids or purchases"},"isUpcoming(uint96)":{"notice":"Returns whether the auction is upcoming"},"lotAuctionOutput(uint96)":{"notice":"Custom auction output for each lot"},"lotData(uint96)":{"notice":"General information pertaining to auction lots"},"minAuctionDuration()":{"notice":"Minimum auction duration in seconds"},"refundBid(uint96,uint64,uint256,address)":{"notice":"Refund a bid"},"remainingCapacity(uint96)":{"notice":"Get the remaining capacity of a lot"},"setMinAuctionDuration(uint48)":{"notice":"Set the minimum auction duration"},"settle(uint96,uint256)":{"notice":"Settle a batch auction lot with on-chain storage and settlement"},"submitPrivateKey(uint96,uint256,uint64,bytes32[])":{"notice":"Submits the private key for the auction lot and decrypts an initial number of bids         It does not require gating. If the seller wishes to limit who can call, they can simply not reveal the key to anyone else.         On the other hand, if a key management service is used, then anyone can call it once the key is revealed."}},"notice":"Encrypted Marginal Price","version":1}},"settings":{"compilationTarget":{"src/modules/auctions/batch/EMP.sol":"EncryptedMarginalPrice"},"evmVersion":"paris","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[":@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",":@prb/test/=lib/prb-math/node_modules/@prb/test/",":@uniswap/v3-core/=lib/uniswap-v3-core/",":ds-test/=lib/forge-std/lib/ds-test/src/",":erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",":forge-std/=lib/forge-std/src/",":g-uni-v1-core/=lib/g-uni-v1-core/contracts/",":openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/",":prb-math/=lib/prb-math/src/",":solady/=lib/solady/src/",":solmate/=lib/solmate/src/",":uniswap-v2-core/=lib/uniswap-v2-core/contracts/",":uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",":uniswap-v3-core/=lib/uniswap-v3-core/contracts/",":uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"]},"sources":{"lib/solady/src/utils/FixedPointMathLib.sol":{"keccak256":"0x8f90be29fd62817be94061136dd2dcc42cf2d5cc38005b1b606d2ee826598776","license":"MIT","urls":["bzz-raw://7d794cf6143263cba72409c99b5036626eeb08ed5fc71cf8beee4881c6fc58e4","dweb:/ipfs/QmePnCXajwV65z9p9rgDrjo2sgwkZodVdr6QJsWNvQvfcV"]},"lib/solmate/src/auth/Owned.sol":{"keccak256":"0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea","license":"AGPL-3.0-only","urls":["bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4","dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"]},"src/interfaces/modules/IAuction.sol":{"keccak256":"0x7039157d051a619b63ce7988be07a43b77a46043f61c5ab4e531084084bcca01","license":"AGPL-3.0-or-later","urls":["bzz-raw://32e0093e843d08deada85cf2649d61aa6b37be858e4fdb32b81bfd2c0cf2c304","dweb:/ipfs/QmPEt15nwpXoBzin32wAQKfSBqcvPdkcgLRxiu3eiN1VFg"]},"src/interfaces/modules/IBatchAuction.sol":{"keccak256":"0xbe814e420085ee1f321fef8d89ddd6b4c668e967bff5eccfbfcc2c994393a02b","license":"AGPL-3.0-or-later","urls":["bzz-raw://c1cf24444584582d87de6df951a80f28da9e611a8118a3796051fcc5087747cc","dweb:/ipfs/QmQss5Fo8wuYoAgjNZYRTUqSEwHeV4SXCVJTQazbEo1aCw"]},"src/interfaces/modules/auctions/IEncryptedMarginalPrice.sol":{"keccak256":"0x976fa11f91bc130e2195041af14e54b66ed38f94b7b543c6c05f8b50381dd106","license":"AGPL-3.0-or-later","urls":["bzz-raw://1d8f2b959b8f313a1bb167e84472043d7dd0524a44e2630d0b57219075a8cb3f","dweb:/ipfs/QmXrPcc9p1Kq3z1jgp4Fu4W6CMiyybzYAP4f7yjXFUa5ME"]},"src/lib/ECIES.sol":{"keccak256":"0xab32c6f4b6531463ce073a61cfa01a2d6682a4d732070fab3b46069ec9d1e945","license":"AGPL-3.0-or-later","urls":["bzz-raw://f5b4f77d5e9792972bcf0b14be1109ecd7db2baa796e06c25f388ce4f32b9a95","dweb:/ipfs/QmUYQ7pqwt4yagadGXqmpjcUN3GqNHVEnQR14NE5ttVjs5"]},"src/lib/MaxPriorityQueue.sol":{"keccak256":"0x2e765db64f0759bdd2be7b81e2e4b5d043a70bfe1dd577920bfaf0fdaa45ab5c","license":"BSL 1.1","urls":["bzz-raw://862ca08f288bd7cfdfe4a48d322a91a710ed050b0116a1e521e290797355ac3c","dweb:/ipfs/QmT5X2RwX5mSZFCmrAqSfYRMrVVWY53zB1TRqoYonnNcut"]},"src/modules/Auction.sol":{"keccak256":"0x4abc2212016836dbef38428b3a938d299b0f01e8b17b6d13ab86207439fdfd10","license":"BSL-1.1","urls":["bzz-raw://43debb1e08d7f9b4f0a8adfbd982cda068ad934eea123e0dad1a235d8a8c9ce3","dweb:/ipfs/QmZfe5VNfsa79pFt9TUogrbV2dAvpCpW4VWfpAhQiowGLC"]},"src/modules/Keycode.sol":{"keccak256":"0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e","license":"AGPL-3.0-or-later","urls":["bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd","dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"]},"src/modules/Modules.sol":{"keccak256":"0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689","license":"AGPL-3.0-or-later","urls":["bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee","dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"]},"src/modules/auctions/BatchAuctionModule.sol":{"keccak256":"0x7fd51c1ba66d2ee5988f96391983d7ac3ce14aa282b56affba69cc55de3f8907","license":"BSL-1.1","urls":["bzz-raw://cb7c98b9a308f6ba21be2cc56398fc719df9a5e0a731f56f49b66213a9476085","dweb:/ipfs/QmWU8pW8AKL3tvfL4EZTRxpkCtvGGwLNDpuFCYauCVjnXf"]},"src/modules/auctions/batch/EMP.sol":{"keccak256":"0x1b7efa3db969219c468ecf839f107f3c8f9ccb39beb0b5793137f2268b3a46b9","license":"BSL-1.1","urls":["bzz-raw://b6e709a4df86c988650688ee91f775fb817ec47cd25ab0695b4d9330c6715f52","dweb:/ipfs/QmXi4jFwbzep84S5bcSrX4JNyj3Myo4fwvg9aNeWinap6p"]}},"version":1}',
  metadata: {
    compiler: {
      version: "0.8.19+commit.7dd6d404"
    },
    language: "Solidity",
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "auctionHouse_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "constructor"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_AmountLessThanMinimum"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_DedicatedSettlePeriod"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_InsufficientCapacity"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            },
            {
              internalType: "uint96",
              name: "bidId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_InvalidBidId"
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "duration_",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "minimum_",
              type: "uint48"
            }
          ],
          type: "error",
          name: "Auction_InvalidDuration"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_InvalidKey"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_InvalidLotId"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_InvalidParams"
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "start_",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "minimum_",
              type: "uint48"
            }
          ],
          type: "error",
          name: "Auction_InvalidStart"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_LotActive"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_LotNotActive"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_LotNotConcluded"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_NotAuthorized"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_NotBidder"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_NotImplemented"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_OnlyLotOwner"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_WrongState"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ],
          type: "error",
          name: "Bid_WrongState"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "parent_",
              type: "address"
            }
          ],
          type: "error",
          name: "Module_InvalidParent"
        },
        {
          inputs: [],
          type: "error",
          name: "Module_OnlyInternal"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller_",
              type: "address"
            }
          ],
          type: "error",
          name: "Module_OnlyParent"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller",
              type: "address"
            }
          ],
          type: "error",
          name: "NotPermitted"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            },
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64",
              indexed: true
            },
            {
              internalType: "uint96",
              name: "amountIn",
              type: "uint96",
              indexed: false
            },
            {
              internalType: "uint96",
              name: "amountOut",
              type: "uint96",
              indexed: false
            }
          ],
          type: "event",
          name: "BidDecrypted",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96",
              indexed: true
            }
          ],
          type: "event",
          name: "PrivateKeySubmitted",
          anonymous: false
        },
        {
          inputs: [],
          stateMutability: "nonpayable",
          type: "function",
          name: "INIT"
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "PARENT",
          outputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "TYPE",
          outputs: [
            {
              internalType: "enum Module.Type",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "VEECODE",
          outputs: [
            {
              internalType: "Veecode",
              name: "",
              type: "bytes7"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "abort"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "struct IAuction.AuctionParams",
              name: "params_",
              type: "tuple",
              components: [
                {
                  internalType: "uint48",
                  name: "start",
                  type: "uint48"
                },
                {
                  internalType: "uint48",
                  name: "duration",
                  type: "uint48"
                },
                {
                  internalType: "bool",
                  name: "capacityInQuote",
                  type: "bool"
                },
                {
                  internalType: "uint256",
                  name: "capacity",
                  type: "uint256"
                },
                {
                  internalType: "bytes",
                  name: "implParams",
                  type: "bytes"
                }
              ]
            },
            {
              internalType: "uint8",
              name: "quoteTokenDecimals_",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "baseTokenDecimals_",
              type: "uint8"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "auction"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "auctionData",
          outputs: [
            {
              internalType: "uint64",
              name: "nextBidId",
              type: "uint64"
            },
            {
              internalType: "uint64",
              name: "nextDecryptIndex",
              type: "uint64"
            },
            {
              internalType: "enum IEncryptedMarginalPrice.LotStatus",
              name: "status",
              type: "uint8"
            },
            {
              internalType: "uint64",
              name: "marginalBidId",
              type: "uint64"
            },
            {
              internalType: "uint256",
              name: "marginalPrice",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "minPrice",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "minFilled",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "minBidSize",
              type: "uint256"
            },
            {
              internalType: "struct Point",
              name: "publicKey",
              type: "tuple",
              components: [
                {
                  internalType: "uint256",
                  name: "x",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "y",
                  type: "uint256"
                }
              ]
            },
            {
              internalType: "uint256",
              name: "privateKey",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "auctionType",
          outputs: [
            {
              internalType: "enum IAuction.AuctionType",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "address",
              name: "bidder_",
              type: "address"
            },
            {
              internalType: "address",
              name: "referrer_",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            },
            {
              internalType: "bytes",
              name: "auctionData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "bid",
          outputs: [
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "bids",
          outputs: [
            {
              internalType: "address",
              name: "bidder",
              type: "address"
            },
            {
              internalType: "uint96",
              name: "amount",
              type: "uint96"
            },
            {
              internalType: "uint96",
              name: "minAmountOut",
              type: "uint96"
            },
            {
              internalType: "address",
              name: "referrer",
              type: "address"
            },
            {
              internalType: "enum IEncryptedMarginalPrice.BidStatus",
              name: "status",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "cancelAuction"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "capacityInQuote",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64[]",
              name: "bidIds_",
              type: "uint64[]"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "claimBids",
          outputs: [
            {
              internalType: "struct IBatchAuction.BidClaim[]",
              name: "bidClaims",
              type: "tuple[]",
              components: [
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "uint256",
                  name: "paid",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "payout",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "refund",
                  type: "uint256"
                }
              ]
            },
            {
              internalType: "bytes",
              name: "auctionOutput",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "num_",
              type: "uint64"
            },
            {
              internalType: "bytes32[]",
              name: "sortHints_",
              type: "bytes32[]"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "decryptAndSortBids"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "decryptBid",
          outputs: [
            {
              internalType: "uint256",
              name: "amountOut",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "decryptedBids",
          outputs: [
            {
              internalType: "uint256",
              name: "numBids",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "dedicatedSettlePeriod",
          outputs: [
            {
              internalType: "uint48",
              name: "",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "encryptedBids",
          outputs: [
            {
              internalType: "uint256",
              name: "encryptedAmountOut",
              type: "uint256"
            },
            {
              internalType: "struct Point",
              name: "bidPubKey",
              type: "tuple",
              components: [
                {
                  internalType: "uint256",
                  name: "x",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "y",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getAuctionData",
          outputs: [
            {
              internalType: "struct IEncryptedMarginalPrice.AuctionData",
              name: "auctionData_",
              type: "tuple",
              components: [
                {
                  internalType: "uint64",
                  name: "nextBidId",
                  type: "uint64"
                },
                {
                  internalType: "uint64",
                  name: "nextDecryptIndex",
                  type: "uint64"
                },
                {
                  internalType: "enum IEncryptedMarginalPrice.LotStatus",
                  name: "status",
                  type: "uint8"
                },
                {
                  internalType: "uint64",
                  name: "marginalBidId",
                  type: "uint64"
                },
                {
                  internalType: "uint256",
                  name: "marginalPrice",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "minPrice",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "minFilled",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "minBidSize",
                  type: "uint256"
                },
                {
                  internalType: "struct Point",
                  name: "publicKey",
                  type: "tuple",
                  components: [
                    {
                      internalType: "uint256",
                      name: "x",
                      type: "uint256"
                    },
                    {
                      internalType: "uint256",
                      name: "y",
                      type: "uint256"
                    }
                  ]
                },
                {
                  internalType: "uint256",
                  name: "privateKey",
                  type: "uint256"
                },
                {
                  internalType: "uint64[]",
                  name: "bidIds",
                  type: "uint64[]"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBid",
          outputs: [
            {
              internalType: "struct IEncryptedMarginalPrice.Bid",
              name: "bid",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "uint96",
                  name: "amount",
                  type: "uint96"
                },
                {
                  internalType: "uint96",
                  name: "minAmountOut",
                  type: "uint96"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "enum IEncryptedMarginalPrice.BidStatus",
                  name: "status",
                  type: "uint8"
                }
              ]
            },
            {
              internalType: "struct IEncryptedMarginalPrice.EncryptedBid",
              name: "encryptedBid",
              type: "tuple",
              components: [
                {
                  internalType: "uint256",
                  name: "encryptedAmountOut",
                  type: "uint256"
                },
                {
                  internalType: "struct Point",
                  name: "bidPubKey",
                  type: "tuple",
                  components: [
                    {
                      internalType: "uint256",
                      name: "x",
                      type: "uint256"
                    },
                    {
                      internalType: "uint256",
                      name: "y",
                      type: "uint256"
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBidClaim",
          outputs: [
            {
              internalType: "struct IBatchAuction.BidClaim",
              name: "bidClaim",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "uint256",
                  name: "paid",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "payout",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "refund",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "index_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBidIdAtIndex",
          outputs: [
            {
              internalType: "uint64",
              name: "",
              type: "uint64"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "startIndex_",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "num_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBidIds",
          outputs: [
            {
              internalType: "uint64[]",
              name: "",
              type: "uint64[]"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getLot",
          outputs: [
            {
              internalType: "struct IAuction.Lot",
              name: "",
              type: "tuple",
              components: [
                {
                  internalType: "uint48",
                  name: "start",
                  type: "uint48"
                },
                {
                  internalType: "uint48",
                  name: "conclusion",
                  type: "uint48"
                },
                {
                  internalType: "uint8",
                  name: "quoteTokenDecimals",
                  type: "uint8"
                },
                {
                  internalType: "uint8",
                  name: "baseTokenDecimals",
                  type: "uint8"
                },
                {
                  internalType: "bool",
                  name: "capacityInQuote",
                  type: "bool"
                },
                {
                  internalType: "uint256",
                  name: "capacity",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "sold",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "purchased",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "bytes32",
              name: "key_",
              type: "bytes32"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getNextInQueue",
          outputs: [
            {
              internalType: "bytes32",
              name: "",
              type: "bytes32"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getNumBids",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getNumBidsInQueue",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getPartialFill",
          outputs: [
            {
              internalType: "bool",
              name: "hasPartialFill",
              type: "bool"
            },
            {
              internalType: "struct IEncryptedMarginalPrice.PartialFill",
              name: "partialFill",
              type: "tuple",
              components: [
                {
                  internalType: "uint64",
                  name: "bidId",
                  type: "uint64"
                },
                {
                  internalType: "uint96",
                  name: "refund",
                  type: "uint96"
                },
                {
                  internalType: "uint256",
                  name: "payout",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "hasEnded",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "isLive",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "isUpcoming",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "lotAuctionOutput",
          outputs: [
            {
              internalType: "bytes",
              name: "",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "id",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "lotData",
          outputs: [
            {
              internalType: "uint48",
              name: "start",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "conclusion",
              type: "uint48"
            },
            {
              internalType: "uint8",
              name: "quoteTokenDecimals",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "baseTokenDecimals",
              type: "uint8"
            },
            {
              internalType: "bool",
              name: "capacityInQuote",
              type: "bool"
            },
            {
              internalType: "uint256",
              name: "capacity",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "sold",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "purchased",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "minAuctionDuration",
          outputs: [
            {
              internalType: "uint48",
              name: "",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            },
            {
              internalType: "uint256",
              name: "index_",
              type: "uint256"
            },
            {
              internalType: "address",
              name: "caller_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "refundBid",
          outputs: [
            {
              internalType: "uint256",
              name: "refund",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "remainingCapacity",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "period_",
              type: "uint48"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setDedicatedSettlePeriod"
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "duration_",
              type: "uint48"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setMinAuctionDuration"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "num_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "settle",
          outputs: [
            {
              internalType: "uint256",
              name: "totalIn",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "totalOut",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "capacity",
              type: "uint256"
            },
            {
              internalType: "bool",
              name: "finished",
              type: "bool"
            },
            {
              internalType: "bytes",
              name: "auctionOutput",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "privateKey_",
              type: "uint256"
            },
            {
              internalType: "uint64",
              name: "num_",
              type: "uint64"
            },
            {
              internalType: "bytes32[]",
              name: "sortHints_",
              type: "bytes32[]"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "submitPrivateKey"
        }
      ],
      devdoc: {
        kind: "dev",
        methods: {
          "INIT()": {
            details: "This function is called when the module is installed or upgraded by the module.MUST BE GATED BY onlyParent. Used to encompass any initialization or upgrade logic."
          },
          "TYPE()": {
            details: "This enables the parent contract to check that the module Keycode specifiedis of the correct type"
          },
          "abort(uint96)": {
            details: "Implements a basic abort function that:             - Validates the lot id and state             - Calls the implementation-specific function             The abort function allows anyone to abort the lot after the conclusion and settlement time has passed.             This can be useful if the lot is unable to be settled, or if the seller is unwilling to settle the lot.             This function reverts if:             - The lot id is invalid             - The lot has not concluded             - The lot is in the dedicated settle period             - The lot is settled (after which it cannot be aborted)",
            params: {
              lotId_: "The lot id"
            }
          },
          "auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)": {
            details: "If the start time is zero, the auction will have a start time of the current block timestamp.             This function handles the following:             - Validates the lot parameters             - Stores the auction lot             - Calls the implementation-specific function             This function reverts if:             - The caller is not the parent of the module             - The start time is in the past             - The duration is less than the minimum",
            params: {
              baseTokenDecimals_: "The base token decimals",
              lotId_: "The lot id",
              params_: "The auction parameters",
              quoteTokenDecimals_: "The quote token decimals"
            }
          },
          "bid(uint96,address,address,uint256,bytes)": {
            details: "Implements a basic bid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot has concluded             - The lot is already settled             - The caller is not an internal module",
            params: {
              amount_: "The amount of quote tokens to bid",
              auctionData_: "The auction-specific data",
              bidder_: "The bidder of the purchased tokens",
              lotId_: "The lot id",
              referrer_: "The referrer of the bid"
            },
            returns: {
              bidId: "          The bid id"
            }
          },
          "cancelAuction(uint96)": {
            details: "Assumptions:             - The parent will refund the seller the remaining capacity             - The parent will verify that the caller is the seller             This function handles the following:             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - the caller is not the parent of the module             - the lot id is invalid             - the lot has concluded",
            params: {
              lotId_: "The lot id"
            }
          },
          "capacityInQuote(uint96)": {
            details: "The implementing function should handle the following:             - Return true if the capacity is in quote tokens             - Return false if the capacity is in base tokens",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "bool    Whether or not the capacity is in quote tokens"
            }
          },
          "claimBids(uint96,uint64[])": {
            details: "Implements a basic claimBids function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot is not settled             - The caller is not an internal module",
            params: {
              bidIds_: "The bid ids",
              lotId_: "The lot id"
            },
            returns: {
              auctionOutput: "  The auction-specific output",
              bidClaims: "      The bid claim data"
            }
          },
          "decryptAndSortBids(uint96,uint64,bytes32[])": {
            details: "This function handles the following:             - Performs state validation             - Iterates over the encrypted bids:                 - Decrypts the bid                 - Ignores if the bid is incorrectly encrypted                 - Does not add to the sorted bid queue if the decrypted amount out is less than the minimum bid size or overflows                 - Otherwise, adds to the sorted bid queue for use during settlement             - Determines the next decrypt index             - Sets the auction status to decrypted if all bids have been decrypted             This function reverts if:             - The lot ID is invalid             - The lot has not started             - The lot is active             - The private key has not been provided             - `num_` and `sortHints_` have different lengths",
            params: {
              lotId_: "The lot ID",
              num_: "The number of bids to decrypt and sort",
              sortHints_: "The sort hints for the bids"
            }
          },
          "decryptBid(uint96,uint64)": {
            details: "This function does not alter the state of the contract, but provides a way to peek at the decrypted bid             This function reverts if:             - The lot ID is invalid             - The private key has not been provided",
            params: {
              bidId_: "The bid ID to decrypt",
              lotId_: "The lot ID of the auction to decrypt the bid for"
            },
            returns: {
              amountOut: "  The decrypted amount out"
            }
          },
          "getAuctionData(uint96)": {
            details: "This function reverts if:             - The lot ID is invalid",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              auctionData_: "   The `AuctionData`"
            }
          },
          "getBid(uint96,uint64)": {
            details: "This function reverts if:             - The lot ID is invalid             - The bid ID is invalid",
            params: {
              bidId_: "The bid ID",
              lotId_: "The lot ID"
            },
            returns: {
              bid: "            The `Bid` data",
              encryptedBid: "   The `EncryptedBid` data"
            }
          },
          "getBidClaim(uint96,uint64)": {
            details: "This function reverts if:             - The lot ID is invalid             - The lot is not settled (since there would be no claim)             - The bid ID is invalid",
            params: {
              bidId_: "The bid ID",
              lotId_: "The lot ID"
            },
            returns: {
              bidClaim: "   The bid claim data"
            }
          },
          "getBidIdAtIndex(uint96,uint256)": {
            params: {
              index_: "The index",
              lotId_: "The lot ID"
            },
            returns: {
              _0: "  The bid ID"
            }
          },
          "getBidIds(uint96,uint256,uint256)": {
            details: "This function reverts if:             - The lot ID is invalid",
            params: {
              count_: "The number of bids to retrieve",
              lotId_: "The lot ID",
              start_: "The index to start retrieving bid IDs from"
            },
            returns: {
              _0: " The bid IDs"
            }
          },
          "getLot(uint96)": {
            params: {
              lotId_: "The lot ID"
            }
          },
          "getNextInQueue(uint96,bytes32)": {
            params: {
              key_: "The key to search for",
              lotId_: "The lot ID"
            },
            returns: {
              _0: "The key of the next bid in the queue"
            }
          },
          "getNumBids(uint96)": {
            details: "This function reverts if:             - The lot ID is invalid",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              _0: "The number of bids"
            }
          },
          "getNumBidsInQueue(uint96)": {
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              _0: "The number of decrypted bids remaining in the queue"
            }
          },
          "getPartialFill(uint96)": {
            details: "For ease of use, this function determines if a partial fill exists.             This function reverts if:             - The lot ID is invalid             - The lot is not settled",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              hasPartialFill: " True if a partial fill exists",
              partialFill: "    The `PartialFill` data"
            }
          },
          "hasEnded(uint96)": {
            details: "The implementing function should handle the following:             - Return true if the lot is not accepting bids/purchases and will not at any point             - Return false if the lot hasn't started or is actively accepting bids/purchases",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "bool    Whether or not the lot is active"
            }
          },
          "isLive(uint96)": {
            details: "A lot is active if:             - The lot has not concluded             - The lot has started             - The lot has not sold out or been cancelled (capacity > 0)",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              _0: "bool    Whether or not the lot is active"
            }
          },
          "isUpcoming(uint96)": {
            details: "The implementing function should handle the following:             - Return true if the lot has not started yet AND has not been cancelled             - Return false if the lot is active, has ended, or was cancelled",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "bool    Whether or not the lot is upcoming"
            }
          },
          "refundBid(uint96,uint64,uint256,address)": {
            details: "Implements a basic refundBid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is decrypted or settled (but not concluded)             - The lot is within the dedicated settle period             - The bid id is invalid             - `caller_` is not the bid owner             - The bid is claimed or refunded             - The caller is not an internal module             This is a modified version of the refundBid function in the AuctionModule contract.             It does not revert if the lot is concluded.",
            params: {
              bidId_: "The bid id",
              caller_: "The caller",
              index_: "The index of the bid ID in the auction's bid list",
              lotId_: "The lot id"
            },
            returns: {
              refund: "     The amount of quote tokens to refund"
            }
          },
          "remainingCapacity(uint96)": {
            details: "The implementing function should handle the following:             - Return the remaining capacity of the lot",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "uint96 The remaining capacity of the lot"
            }
          },
          "setMinAuctionDuration(uint48)": {
            details: "This function must be called by the parent AuctionHouse, and             can be called by governance using `execOnModule`."
          },
          "settle(uint96,uint256)": {
            details: "Implements a basic settle function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is active             - The lot has already been settled             - The caller is not an internal module",
            params: {
              lotId_: "The lot id",
              num_: "The number of winning bids to settle (capped at the remaining number if more is provided)"
            },
            returns: {
              auctionOutput: "  Custom data returned by the auction module",
              capacity: "       The original capacity of the lot",
              finished: "       Whether the settlement is finished",
              totalIn: "        Total amount of quote tokens from bids that were filled",
              totalOut: "       Total amount of base tokens paid out to winning bids"
            }
          },
          "submitPrivateKey(uint96,uint256,uint64,bytes32[])": {
            details: "This function reverts if:             - The lot ID is invalid             - The lot is not active             - The lot has not concluded             - The private key has already been submitted             - The lot has been settled (cancelled, settled or aborted)             - The private key is invalid for the public key",
            params: {
              lotId_: "The lot ID of the auction to submit the private key for",
              num_: "The number of bids to decrypt after submitting the private key (passed to `_decryptAndSortBids()`)",
              privateKey_: "The ECIES private key to decrypt the bids",
              sortHints_: "The sort hints for the bid decryption (passed to `_decryptAndSortBids()`)"
            }
          }
        },
        version: 1
      },
      userdoc: {
        kind: "user",
        methods: {
          "INIT()": {
            notice: "Initialization function for the module"
          },
          "PARENT()": {
            notice: "The parent contract for this module."
          },
          "TYPE()": {
            notice: "2 byte identifier for the module type"
          },
          "VEECODE()": {
            notice: "7 byte, versioned identifier for the module. 2 characters from 0-9 that signify the version and 3-5 characters from A-Z."
          },
          "abort(uint96)": {
            notice: "Abort a batch auction that cannot be settled, refunding the seller and allowing bidders to claim refunds"
          },
          "auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)": {
            notice: "Create an auction lot"
          },
          "auctionData(uint96)": {
            notice: "Auction-specific data for a lot"
          },
          "auctionType()": {
            notice: "Get the auction type"
          },
          "bid(uint96,address,address,uint256,bytes)": {
            notice: "Bid on an auction lot"
          },
          "bids(uint96,uint64)": {
            notice: "General information about bids on a lot"
          },
          "cancelAuction(uint96)": {
            notice: "Cancel an auction lot"
          },
          "capacityInQuote(uint96)": {
            notice: "Get whether or not the capacity is in quote tokens"
          },
          "claimBids(uint96,uint64[])": {
            notice: "Claim multiple bids"
          },
          "decryptAndSortBids(uint96,uint64,bytes32[])": {
            notice: "Decrypts a batch of bids and sorts them by price in descending order"
          },
          "decryptBid(uint96,uint64)": {
            notice: "Returns the decrypted amountOut of a single bid without altering contract state"
          },
          "decryptedBids(uint96)": {
            notice: "Queue of decrypted bids for a lot (populated on decryption)"
          },
          "dedicatedSettlePeriod()": {
            notice: "Time period after auction conclusion where bidders cannot refund bids"
          },
          "encryptedBids(uint96,uint64)": {
            notice: "Data for encryption information for a specific bid"
          },
          "getAuctionData(uint96)": {
            notice: "Returns the `AuctionData` data for an auction lot"
          },
          "getBid(uint96,uint64)": {
            notice: "Returns the `Bid` and `EncryptedBid` data for a given lot and bid ID"
          },
          "getBidClaim(uint96,uint64)": {
            notice: "Get the claim data for a bidThis provides information on the outcome of a bid, independent of the claim status"
          },
          "getBidIdAtIndex(uint96,uint256)": {
            notice: "Get the bid ID at the given index"
          },
          "getBidIds(uint96,uint256,uint256)": {
            notice: "Get the bid IDs from the given index"
          },
          "getLot(uint96)": {
            notice: "Get the lot data for a given lot ID"
          },
          "getNextInQueue(uint96,bytes32)": {
            notice: "Returns the bid after `key_` in the queue"
          },
          "getNumBids(uint96)": {
            notice: "Get the number of bids for a lot"
          },
          "getNumBidsInQueue(uint96)": {
            notice: "Returns the number of decrypted bids remaining in the queue"
          },
          "getPartialFill(uint96)": {
            notice: "Returns the `PartialFill` data for an auction lot"
          },
          "hasEnded(uint96)": {
            notice: "Returns whether the auction has ended"
          },
          "isLive(uint96)": {
            notice: "Returns whether the auction is currently accepting bids or purchases"
          },
          "isUpcoming(uint96)": {
            notice: "Returns whether the auction is upcoming"
          },
          "lotAuctionOutput(uint96)": {
            notice: "Custom auction output for each lot"
          },
          "lotData(uint96)": {
            notice: "General information pertaining to auction lots"
          },
          "minAuctionDuration()": {
            notice: "Minimum auction duration in seconds"
          },
          "refundBid(uint96,uint64,uint256,address)": {
            notice: "Refund a bid"
          },
          "remainingCapacity(uint96)": {
            notice: "Get the remaining capacity of a lot"
          },
          "setMinAuctionDuration(uint48)": {
            notice: "Set the minimum auction duration"
          },
          "settle(uint96,uint256)": {
            notice: "Settle a batch auction lot with on-chain storage and settlement"
          },
          "submitPrivateKey(uint96,uint256,uint64,bytes32[])": {
            notice: "Submits the private key for the auction lot and decrypts an initial number of bids         It does not require gating. If the seller wishes to limit who can call, they can simply not reveal the key to anyone else.         On the other hand, if a key management service is used, then anyone can call it once the key is revealed."
          }
        },
        version: 1
      }
    },
    settings: {
      remappings: [
        "@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",
        "@prb/test/=lib/prb-math/node_modules/@prb/test/",
        "@uniswap/v3-core/=lib/uniswap-v3-core/",
        "ds-test/=lib/forge-std/lib/ds-test/src/",
        "erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",
        "forge-std/=lib/forge-std/src/",
        "g-uni-v1-core/=lib/g-uni-v1-core/contracts/",
        "openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "openzeppelin-contracts/=lib/openzeppelin-contracts/",
        "openzeppelin/=lib/openzeppelin-contracts/contracts/",
        "prb-math/=lib/prb-math/src/",
        "solady/=lib/solady/src/",
        "solmate/=lib/solmate/src/",
        "uniswap-v2-core/=lib/uniswap-v2-core/contracts/",
        "uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",
        "uniswap-v3-core/=lib/uniswap-v3-core/contracts/",
        "uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"
      ],
      optimizer: {
        enabled: true,
        runs: 200
      },
      metadata: {
        bytecodeHash: "ipfs"
      },
      compilationTarget: {
        "src/modules/auctions/batch/EMP.sol": "EncryptedMarginalPrice"
      },
      evmVersion: "paris",
      libraries: {}
    },
    sources: {
      "lib/solady/src/utils/FixedPointMathLib.sol": {
        keccak256: "0x8f90be29fd62817be94061136dd2dcc42cf2d5cc38005b1b606d2ee826598776",
        urls: [
          "bzz-raw://7d794cf6143263cba72409c99b5036626eeb08ed5fc71cf8beee4881c6fc58e4",
          "dweb:/ipfs/QmePnCXajwV65z9p9rgDrjo2sgwkZodVdr6QJsWNvQvfcV"
        ],
        license: "MIT"
      },
      "lib/solmate/src/auth/Owned.sol": {
        keccak256: "0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea",
        urls: [
          "bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4",
          "dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"
        ],
        license: "AGPL-3.0-only"
      },
      "src/interfaces/modules/IAuction.sol": {
        keccak256: "0x7039157d051a619b63ce7988be07a43b77a46043f61c5ab4e531084084bcca01",
        urls: [
          "bzz-raw://32e0093e843d08deada85cf2649d61aa6b37be858e4fdb32b81bfd2c0cf2c304",
          "dweb:/ipfs/QmPEt15nwpXoBzin32wAQKfSBqcvPdkcgLRxiu3eiN1VFg"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/IBatchAuction.sol": {
        keccak256: "0xbe814e420085ee1f321fef8d89ddd6b4c668e967bff5eccfbfcc2c994393a02b",
        urls: [
          "bzz-raw://c1cf24444584582d87de6df951a80f28da9e611a8118a3796051fcc5087747cc",
          "dweb:/ipfs/QmQss5Fo8wuYoAgjNZYRTUqSEwHeV4SXCVJTQazbEo1aCw"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/auctions/IEncryptedMarginalPrice.sol": {
        keccak256: "0x976fa11f91bc130e2195041af14e54b66ed38f94b7b543c6c05f8b50381dd106",
        urls: [
          "bzz-raw://1d8f2b959b8f313a1bb167e84472043d7dd0524a44e2630d0b57219075a8cb3f",
          "dweb:/ipfs/QmXrPcc9p1Kq3z1jgp4Fu4W6CMiyybzYAP4f7yjXFUa5ME"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/lib/ECIES.sol": {
        keccak256: "0xab32c6f4b6531463ce073a61cfa01a2d6682a4d732070fab3b46069ec9d1e945",
        urls: [
          "bzz-raw://f5b4f77d5e9792972bcf0b14be1109ecd7db2baa796e06c25f388ce4f32b9a95",
          "dweb:/ipfs/QmUYQ7pqwt4yagadGXqmpjcUN3GqNHVEnQR14NE5ttVjs5"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/lib/MaxPriorityQueue.sol": {
        keccak256: "0x2e765db64f0759bdd2be7b81e2e4b5d043a70bfe1dd577920bfaf0fdaa45ab5c",
        urls: [
          "bzz-raw://862ca08f288bd7cfdfe4a48d322a91a710ed050b0116a1e521e290797355ac3c",
          "dweb:/ipfs/QmT5X2RwX5mSZFCmrAqSfYRMrVVWY53zB1TRqoYonnNcut"
        ],
        license: "BSL 1.1"
      },
      "src/modules/Auction.sol": {
        keccak256: "0x4abc2212016836dbef38428b3a938d299b0f01e8b17b6d13ab86207439fdfd10",
        urls: [
          "bzz-raw://43debb1e08d7f9b4f0a8adfbd982cda068ad934eea123e0dad1a235d8a8c9ce3",
          "dweb:/ipfs/QmZfe5VNfsa79pFt9TUogrbV2dAvpCpW4VWfpAhQiowGLC"
        ],
        license: "BSL-1.1"
      },
      "src/modules/Keycode.sol": {
        keccak256: "0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e",
        urls: [
          "bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd",
          "dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/Modules.sol": {
        keccak256: "0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689",
        urls: [
          "bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee",
          "dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/auctions/BatchAuctionModule.sol": {
        keccak256: "0x7fd51c1ba66d2ee5988f96391983d7ac3ce14aa282b56affba69cc55de3f8907",
        urls: [
          "bzz-raw://cb7c98b9a308f6ba21be2cc56398fc719df9a5e0a731f56f49b66213a9476085",
          "dweb:/ipfs/QmWU8pW8AKL3tvfL4EZTRxpkCtvGGwLNDpuFCYauCVjnXf"
        ],
        license: "BSL-1.1"
      },
      "src/modules/auctions/batch/EMP.sol": {
        keccak256: "0x1b7efa3db969219c468ecf839f107f3c8f9ccb39beb0b5793137f2268b3a46b9",
        urls: [
          "bzz-raw://b6e709a4df86c988650688ee91f775fb817ec47cd25ab0695b4d9330c6715f52",
          "dweb:/ipfs/QmXi4jFwbzep84S5bcSrX4JNyj3Myo4fwvg9aNeWinap6p"
        ],
        license: "BSL-1.1"
      }
    },
    version: 1
  },
  ast: {
    absolutePath: "src/modules/auctions/batch/EMP.sol",
    id: 92312,
    exportedSymbols: {
      AuctionModule: [88011],
      BatchAuctionModule: [89550],
      ECIES: [84365],
      EncryptedMarginalPrice: [92311],
      IBatchAuction: [82847],
      IEncryptedMarginalPrice: [83248],
      Math: [55729],
      MaxPriorityQueue: [84843],
      Module: [88991],
      Point: [84010],
      Queue: [84571],
      Veecode: [88084],
      toVeecode: [88179]
    },
    nodeType: "SourceUnit",
    src: "36:48665:177",
    nodes: [
      {
        id: 89871,
        nodeType: "PragmaDirective",
        src: "36:23:177",
        nodes: [],
        literals: ["solidity", "0.8", ".19"]
      },
      {
        id: 89873,
        nodeType: "ImportDirective",
        src: "75:71:177",
        nodes: [],
        absolutePath: "src/interfaces/modules/IBatchAuction.sol",
        file: "src/interfaces/modules/IBatchAuction.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 82848,
        symbolAliases: [
          {
            foreign: {
              id: 89872,
              name: "IBatchAuction",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 82847,
              src: "83:13:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89875,
        nodeType: "ImportDirective",
        src: "147:100:177",
        nodes: [],
        absolutePath: "src/interfaces/modules/auctions/IEncryptedMarginalPrice.sol",
        file: "src/interfaces/modules/auctions/IEncryptedMarginalPrice.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 83249,
        symbolAliases: [
          {
            foreign: {
              id: 89874,
              name: "IEncryptedMarginalPrice",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 83248,
              src: "155:23:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89878,
        nodeType: "ImportDirective",
        src: "271:47:177",
        nodes: [],
        absolutePath: "src/lib/ECIES.sol",
        file: "src/lib/ECIES.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 84366,
        symbolAliases: [
          {
            foreign: {
              id: 89876,
              name: "ECIES",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 84365,
              src: "279:5:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 89877,
              name: "Point",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 84010,
              src: "286:5:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89881,
        nodeType: "ImportDirective",
        src: "319:69:177",
        nodes: [],
        absolutePath: "src/lib/MaxPriorityQueue.sol",
        file: "src/lib/MaxPriorityQueue.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 84844,
        symbolAliases: [
          {
            foreign: {
              id: 89879,
              name: "MaxPriorityQueue",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 84843,
              src: "327:16:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 89880,
              name: "Queue",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 84571,
              src: "345:5:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89883,
        nodeType: "ImportDirective",
        src: "412:77:177",
        nodes: [],
        absolutePath: "lib/solady/src/utils/FixedPointMathLib.sol",
        file: "solady/utils/FixedPointMathLib.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 55730,
        symbolAliases: [
          {
            foreign: {
              id: 89882,
              name: "FixedPointMathLib",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 55729,
              src: "420:17:177",
              typeDescriptions: {}
            },
            local: "Math",
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89885,
        nodeType: "ImportDirective",
        src: "503:54:177",
        nodes: [],
        absolutePath: "src/modules/Auction.sol",
        file: "src/modules/Auction.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 88012,
        symbolAliases: [
          {
            foreign: {
              id: 89884,
              name: "AuctionModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88011,
              src: "511:13:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89887,
        nodeType: "ImportDirective",
        src: "558:79:177",
        nodes: [],
        absolutePath: "src/modules/auctions/BatchAuctionModule.sol",
        file: "src/modules/auctions/BatchAuctionModule.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 89551,
        symbolAliases: [
          {
            foreign: {
              id: 89886,
              name: "BatchAuctionModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 89550,
              src: "566:18:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 89891,
        nodeType: "ImportDirective",
        src: "639:67:177",
        nodes: [],
        absolutePath: "src/modules/Modules.sol",
        file: "src/modules/Modules.sol",
        nameLocation: "-1:-1:-1",
        scope: 92312,
        sourceUnit: 88992,
        symbolAliases: [
          {
            foreign: {
              id: 89888,
              name: "Module",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88991,
              src: "647:6:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 89889,
              name: "Veecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88084,
              src: "655:7:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 89890,
              name: "toVeecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88179,
              src: "664:9:177",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 92311,
        nodeType: "ContractDefinition",
        src: "954:47746:177",
        nodes: [
          {
            id: 89900,
            nodeType: "UsingForDirective",
            src: "1039:33:177",
            nodes: [],
            global: false,
            libraryName: {
              id: 89897,
              name: "MaxPriorityQueue",
              nameLocations: ["1045:16:177"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 84843,
              src: "1045:16:177"
            },
            typeName: {
              id: 89899,
              nodeType: "UserDefinedTypeName",
              pathNode: {
                id: 89898,
                name: "Queue",
                nameLocations: ["1066:5:177"],
                nodeType: "IdentifierPath",
                referencedDeclaration: 84571,
                src: "1066:5:177"
              },
              referencedDeclaration: 84571,
              src: "1066:5:177",
              typeDescriptions: {
                typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                typeString: "struct Queue"
              }
            }
          },
          {
            id: 89915,
            nodeType: "StructDefinition",
            src: "2266:239:177",
            nodes: [],
            canonicalName: "EncryptedMarginalPrice.MarginalPriceResult",
            members: [
              {
                constant: false,
                id: 89902,
                mutability: "mutable",
                name: "marginalPrice",
                nameLocation: "2311:13:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2303:21:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 89901,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2303:7:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89904,
                mutability: "mutable",
                name: "marginalBidId",
                nameLocation: "2341:13:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2334:20:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint64",
                  typeString: "uint64"
                },
                typeName: {
                  id: 89903,
                  name: "uint64",
                  nodeType: "ElementaryTypeName",
                  src: "2334:6:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89906,
                mutability: "mutable",
                name: "lastBidId",
                nameLocation: "2371:9:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2364:16:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint64",
                  typeString: "uint64"
                },
                typeName: {
                  id: 89905,
                  name: "uint64",
                  nodeType: "ElementaryTypeName",
                  src: "2364:6:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89908,
                mutability: "mutable",
                name: "lastBidPrice",
                nameLocation: "2398:12:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2390:20:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 89907,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2390:7:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89910,
                mutability: "mutable",
                name: "totalAmountIn",
                nameLocation: "2428:13:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2420:21:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 89909,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2420:7:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89912,
                mutability: "mutable",
                name: "capacityExpended",
                nameLocation: "2459:16:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2451:24:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 89911,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2451:7:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89914,
                mutability: "mutable",
                name: "finished",
                nameLocation: "2490:8:177",
                nodeType: "VariableDeclaration",
                scope: 89915,
                src: "2485:13:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_bool",
                  typeString: "bool"
                },
                typeName: {
                  id: 89913,
                  name: "bool",
                  nodeType: "ElementaryTypeName",
                  src: "2485:4:177",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  }
                },
                visibility: "internal"
              }
            ],
            name: "MarginalPriceResult",
            nameLocation: "2273:19:177",
            scope: 92311,
            visibility: "public"
          },
          {
            id: 89922,
            nodeType: "StructDefinition",
            src: "2856:120:177",
            nodes: [],
            canonicalName: "EncryptedMarginalPrice.PartialSettlement",
            members: [
              {
                constant: false,
                id: 89917,
                mutability: "mutable",
                name: "processedAmountIn",
                nameLocation: "2899:17:177",
                nodeType: "VariableDeclaration",
                scope: 89922,
                src: "2891:25:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 89916,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2891:7:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89919,
                mutability: "mutable",
                name: "lastPrice",
                nameLocation: "2934:9:177",
                nodeType: "VariableDeclaration",
                scope: 89922,
                src: "2926:17:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint256",
                  typeString: "uint256"
                },
                typeName: {
                  id: 89918,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2926:7:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                visibility: "internal"
              },
              {
                constant: false,
                id: 89921,
                mutability: "mutable",
                name: "lastBidId",
                nameLocation: "2960:9:177",
                nodeType: "VariableDeclaration",
                scope: 89922,
                src: "2953:16:177",
                stateVariable: false,
                storageLocation: "default",
                typeDescriptions: {
                  typeIdentifier: "t_uint64",
                  typeString: "uint64"
                },
                typeName: {
                  id: 89920,
                  name: "uint64",
                  nodeType: "ElementaryTypeName",
                  src: "2953:6:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  }
                },
                visibility: "internal"
              }
            ],
            name: "PartialSettlement",
            nameLocation: "2863:17:177",
            scope: 92311,
            visibility: "public"
          },
          {
            id: 89928,
            nodeType: "VariableDeclaration",
            src: "3133:55:177",
            nodes: [],
            constant: false,
            documentation: {
              id: 89923,
              nodeType: "StructuredDocumentation",
              src: "3031:97:177",
              text: "@notice     Auction-specific data for a lot\n @dev        Access via `getAuctionData()`"
            },
            functionSelector: "e2cfa6ea",
            mutability: "mutable",
            name: "auctionData",
            nameLocation: "3177:11:177",
            scope: 92311,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData)"
            },
            typeName: {
              id: 89927,
              keyName: "lotId",
              keyNameLocation: "3148:5:177",
              keyType: {
                id: 89924,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "3141:6:177",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "3133:36:177",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData)"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 89926,
                nodeType: "UserDefinedTypeName",
                pathNode: {
                  id: 89925,
                  name: "AuctionData",
                  nameLocations: ["3157:11:177"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 83136,
                  src: "3157:11:177"
                },
                referencedDeclaration: 83136,
                src: "3157:11:177",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                  typeString: "struct IEncryptedMarginalPrice.AuctionData"
                }
              }
            },
            visibility: "public"
          },
          {
            id: 89934,
            nodeType: "VariableDeclaration",
            src: "3357:61:177",
            nodes: [],
            constant: false,
            documentation: {
              id: 89929,
              nodeType: "StructuredDocumentation",
              src: "3195:157:177",
              text: "@notice     Partial fill data for a lot\n @dev        Each EMPA can have at most one partial fill\n             Access via `getPartialFill()`"
            },
            mutability: "mutable",
            name: "_lotPartialFill",
            nameLocation: "3403:15:177",
            scope: 92311,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill)"
            },
            typeName: {
              id: 89933,
              keyName: "lotId",
              keyNameLocation: "3372:5:177",
              keyType: {
                id: 89930,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "3365:6:177",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "3357:36:177",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
                typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill)"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 89932,
                nodeType: "UserDefinedTypeName",
                pathNode: {
                  id: 89931,
                  name: "PartialFill",
                  nameLocations: ["3381:11:177"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 83161,
                  src: "3381:11:177"
                },
                referencedDeclaration: 83161,
                src: "3381:11:177",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PartialFill_$83161_storage_ptr",
                  typeString: "struct IEncryptedMarginalPrice.PartialFill"
                }
              }
            },
            visibility: "internal"
          },
          {
            id: 89940,
            nodeType: "VariableDeclaration",
            src: "3577:73:177",
            nodes: [],
            constant: false,
            documentation: {
              id: 89935,
              nodeType: "StructuredDocumentation",
              src: "3425:147:177",
              text: "@notice     Partial settlement data stored between settlement batches\n @dev        Only used internally, does not need a public accessor"
            },
            mutability: "mutable",
            name: "_lotPartialSettlement",
            nameLocation: "3629:21:177",
            scope: 92311,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
              typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement)"
            },
            typeName: {
              id: 89939,
              keyName: "lotId",
              keyNameLocation: "3592:5:177",
              keyType: {
                id: 89936,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "3585:6:177",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "3577:42:177",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement)"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 89938,
                nodeType: "UserDefinedTypeName",
                pathNode: {
                  id: 89937,
                  name: "PartialSettlement",
                  nameLocations: ["3601:17:177"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 89922,
                  src: "3601:17:177"
                },
                referencedDeclaration: 89922,
                src: "3601:17:177",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PartialSettlement_$89922_storage_ptr",
                  typeString: "struct EncryptedMarginalPrice.PartialSettlement"
                }
              }
            },
            visibility: "internal"
          },
          {
            id: 89948,
            nodeType: "VariableDeclaration",
            src: "3759:65:177",
            nodes: [],
            constant: false,
            documentation: {
              id: 89941,
              nodeType: "StructuredDocumentation",
              src: "3657:97:177",
              text: "@notice     General information about bids on a lot\n @dev        Access via `getBid()`"
            },
            functionSelector: "0fb276fc",
            mutability: "mutable",
            name: "bids",
            nameLocation: "3820:4:177",
            scope: 92311,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid))"
            },
            typeName: {
              id: 89947,
              keyName: "lotId",
              keyNameLocation: "3774:5:177",
              keyType: {
                id: 89942,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "3767:6:177",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "3759:53:177",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid))"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 89946,
                keyName: "bidId",
                keyNameLocation: "3798:5:177",
                keyType: {
                  id: 89943,
                  name: "uint64",
                  nodeType: "ElementaryTypeName",
                  src: "3791:6:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  }
                },
                nodeType: "Mapping",
                src: "3783:28:177",
                typeDescriptions: {
                  typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                  typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid)"
                },
                valueName: "",
                valueNameLocation: "-1:-1:-1",
                valueType: {
                  id: 89945,
                  nodeType: "UserDefinedTypeName",
                  pathNode: {
                    id: 89944,
                    name: "Bid",
                    nameLocations: ["3807:3:177"],
                    nodeType: "IdentifierPath",
                    referencedDeclaration: 83148,
                    src: "3807:3:177"
                  },
                  referencedDeclaration: 83148,
                  src: "3807:3:177",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                    typeString: "struct IEncryptedMarginalPrice.Bid"
                  }
                }
              }
            },
            visibility: "public"
          },
          {
            id: 89956,
            nodeType: "VariableDeclaration",
            src: "3944:83:177",
            nodes: [],
            constant: false,
            documentation: {
              id: 89949,
              nodeType: "StructuredDocumentation",
              src: "3831:108:177",
              text: "@notice     Data for encryption information for a specific bid\n @dev        Access via `getBid()`"
            },
            functionSelector: "54c87c01",
            mutability: "mutable",
            name: "encryptedBids",
            nameLocation: "4014:13:177",
            scope: 92311,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$_$",
              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid))"
            },
            typeName: {
              id: 89955,
              keyName: "lotId",
              keyNameLocation: "3959:5:177",
              keyType: {
                id: 89950,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "3952:6:177",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "3944:62:177",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$_$",
                typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid))"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 89954,
                keyName: "bidId",
                keyNameLocation: "3983:5:177",
                keyType: {
                  id: 89951,
                  name: "uint64",
                  nodeType: "ElementaryTypeName",
                  src: "3976:6:177",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  }
                },
                nodeType: "Mapping",
                src: "3968:37:177",
                typeDescriptions: {
                  typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$",
                  typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid)"
                },
                valueName: "",
                valueNameLocation: "-1:-1:-1",
                valueType: {
                  id: 89953,
                  nodeType: "UserDefinedTypeName",
                  pathNode: {
                    id: 89952,
                    name: "EncryptedBid",
                    nameLocations: ["3992:12:177"],
                    nodeType: "IdentifierPath",
                    referencedDeclaration: 83154,
                    src: "3992:12:177"
                  },
                  referencedDeclaration: 83154,
                  src: "3992:12:177",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_EncryptedBid_$83154_storage_ptr",
                    typeString: "struct IEncryptedMarginalPrice.EncryptedBid"
                  }
                }
              }
            },
            visibility: "public"
          },
          {
            id: 89962,
            nodeType: "VariableDeclaration",
            src: "4228:51:177",
            nodes: [],
            constant: false,
            documentation: {
              id: 89957,
              nodeType: "StructuredDocumentation",
              src: "4089:134:177",
              text: "@notice     Queue of decrypted bids for a lot (populated on decryption)\n @dev        Access elements via `getNextInQueue()`"
            },
            functionSelector: "de1d3112",
            mutability: "mutable",
            name: "decryptedBids",
            nameLocation: "4266:13:177",
            scope: 92311,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
              typeString: "mapping(uint96 => struct Queue)"
            },
            typeName: {
              id: 89961,
              keyName: "lotId",
              keyNameLocation: "4243:5:177",
              keyType: {
                id: 89958,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "4236:6:177",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "4228:30:177",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
                typeString: "mapping(uint96 => struct Queue)"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 89960,
                nodeType: "UserDefinedTypeName",
                pathNode: {
                  id: 89959,
                  name: "Queue",
                  nameLocations: ["4252:5:177"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 84571,
                  src: "4252:5:177"
                },
                referencedDeclaration: 84571,
                src: "4252:5:177",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                  typeString: "struct Queue"
                }
              }
            },
            visibility: "public"
          },
          {
            id: 89979,
            nodeType: "FunctionDefinition",
            src: "4325:274:177",
            nodes: [],
            body: {
              id: 89978,
              nodeType: "Block",
              src: "4389:210:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 89972,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 89970,
                      name: "minAuctionDuration",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87474,
                      src: "4462:18:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "31",
                      id: 89971,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "4483:6:177",
                      subdenomination: "days",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_86400_by_1",
                        typeString: "int_const 86400"
                      },
                      value: "1"
                    },
                    src: "4462:27:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  id: 89973,
                  nodeType: "ExpressionStatement",
                  src: "4462:27:177"
                },
                {
                  expression: {
                    id: 89976,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 89974,
                      name: "dedicatedSettlePeriod",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89129,
                      src: "4562:21:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "31",
                      id: 89975,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "4586:6:177",
                      subdenomination: "days",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_86400_by_1",
                        typeString: "int_const 86400"
                      },
                      value: "1"
                    },
                    src: "4562:30:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  id: 89977,
                  nodeType: "ExpressionStatement",
                  src: "4562:30:177"
                }
              ]
            },
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    id: 89967,
                    name: "auctionHouse_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 89964,
                    src: "4374:13:177",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  }
                ],
                id: 89968,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 89966,
                  name: "AuctionModule",
                  nameLocations: ["4360:13:177"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 88011,
                  src: "4360:13:177"
                },
                nodeType: "ModifierInvocation",
                src: "4360:28:177"
              }
            ],
            name: "",
            nameLocation: "-1:-1:-1",
            parameters: {
              id: 89965,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 89964,
                  mutability: "mutable",
                  name: "auctionHouse_",
                  nameLocation: "4345:13:177",
                  nodeType: "VariableDeclaration",
                  scope: 89979,
                  src: "4337:21:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 89963,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "4337:7:177",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4336:23:177"
            },
            returnParameters: {
              id: 89969,
              nodeType: "ParameterList",
              parameters: [],
              src: "4389:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 89992,
            nodeType: "FunctionDefinition",
            src: "4632:101:177",
            nodes: [],
            body: {
              id: 89991,
              nodeType: "Block",
              src: "4690:43:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        hexValue: "3031454d5041",
                        id: 89988,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "4717:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_stringliteral_89fcf0bbd98c35e4ec157d02c414c75d2daab10bf961d2627857ec7152433b24",
                          typeString: 'literal_string "01EMPA"'
                        },
                        value: "01EMPA"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_stringliteral_89fcf0bbd98c35e4ec157d02c414c75d2daab10bf961d2627857ec7152433b24",
                          typeString: 'literal_string "01EMPA"'
                        }
                      ],
                      id: 89987,
                      name: "toVeecode",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88179,
                      src: "4707:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_bytes7_$returns$_t_userDefinedValueType$_Veecode_$88084_$",
                        typeString: "function (bytes7) pure returns (Veecode)"
                      }
                    },
                    id: 89989,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "4707:19:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                      typeString: "Veecode"
                    }
                  },
                  functionReturnParameters: 89986,
                  id: 89990,
                  nodeType: "Return",
                  src: "4700:26:177"
                }
              ]
            },
            baseFunctions: [88983],
            documentation: {
              id: 89980,
              nodeType: "StructuredDocumentation",
              src: "4605:22:177",
              text: "@inheritdoc Module"
            },
            functionSelector: "d61735ca",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "VEECODE",
            nameLocation: "4641:7:177",
            overrides: {
              id: 89982,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "4663:8:177"
            },
            parameters: {
              id: 89981,
              nodeType: "ParameterList",
              parameters: [],
              src: "4648:2:177"
            },
            returnParameters: {
              id: 89986,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 89985,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 89992,
                  src: "4681:7:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                    typeString: "Veecode"
                  },
                  typeName: {
                    id: 89984,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 89983,
                      name: "Veecode",
                      nameLocations: ["4681:7:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 88084,
                      src: "4681:7:177"
                    },
                    referencedDeclaration: 88084,
                    src: "4681:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                      typeString: "Veecode"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4680:9:177"
            },
            scope: 92311,
            stateMutability: "pure",
            virtual: false,
            visibility: "public"
          },
          {
            id: 90112,
            nodeType: "FunctionDefinition",
            src: "5706:1376:177",
            nodes: [],
            body: {
              id: 90111,
              nodeType: "Block",
              src: "5796:1286:177",
              nodes: [],
              statements: [
                {
                  assignments: [90006],
                  declarations: [
                    {
                      constant: false,
                      id: 90006,
                      mutability: "mutable",
                      name: "implParams",
                      nameLocation: "5871:10:177",
                      nodeType: "VariableDeclaration",
                      scope: 90111,
                      src: "5846:35:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                        typeString: "struct IEncryptedMarginalPrice.AuctionDataParams"
                      },
                      typeName: {
                        id: 90005,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90004,
                          name: "AuctionDataParams",
                          nameLocations: ["5846:17:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83096,
                          src: "5846:17:177"
                        },
                        referencedDeclaration: 83096,
                        src: "5846:17:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83096_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionDataParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90013,
                  initialValue: {
                    arguments: [
                      {
                        id: 90009,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 9e4,
                        src: "5895:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      },
                      {
                        components: [
                          {
                            id: 90010,
                            name: "AuctionDataParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83096,
                            src: "5905:17:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_AuctionDataParams_$83096_storage_ptr_$",
                              typeString: "type(struct IEncryptedMarginalPrice.AuctionDataParams storage pointer)"
                            }
                          }
                        ],
                        id: 90011,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "5904:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_AuctionDataParams_$83096_storage_ptr_$",
                          typeString: "type(struct IEncryptedMarginalPrice.AuctionDataParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_AuctionDataParams_$83096_storage_ptr_$",
                          typeString: "type(struct IEncryptedMarginalPrice.AuctionDataParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 90007,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "5884:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 90008,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "5888:6:177",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "5884:10:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 90012,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "5884:40:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                      typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "5846:78:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90017,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 90014,
                        name: "implParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90006,
                        src: "6004:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                        }
                      },
                      id: 90015,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "6015:8:177",
                      memberName: "minPrice",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83088,
                      src: "6004:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 90016,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "6027:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "6004:24:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90021,
                  nodeType: "IfStatement",
                  src: "6000:60:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90018,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "6037:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90019,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6037:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90020,
                    nodeType: "RevertStatement",
                    src: "6030:30:177"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    },
                    id: 90025,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 90022,
                        name: "implParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90006,
                        src: "6136:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                        }
                      },
                      id: 90023,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "6147:14:177",
                      memberName: "minFillPercent",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83090,
                      src: "6136:25:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint24",
                        typeString: "uint24"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 90024,
                      name: "_ONE_HUNDRED_PERCENT",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87471,
                      src: "6164:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "6136:48:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90029,
                  nodeType: "IfStatement",
                  src: "6132:84:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90026,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "6193:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90027,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6193:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90028,
                    nodeType: "RevertStatement",
                    src: "6186:30:177"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 90042,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 90037,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 90030,
                          name: "implParams",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90006,
                          src: "6317:10:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                            typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                          }
                        },
                        id: 90031,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "6328:10:177",
                        memberName: "minBidSize",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83092,
                        src: "6317:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        expression: {
                          arguments: [
                            {
                              id: 90034,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "6346:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint96_$",
                                typeString: "type(uint96)"
                              },
                              typeName: {
                                id: 90033,
                                name: "uint96",
                                nodeType: "ElementaryTypeName",
                                src: "6346:6:177",
                                typeDescriptions: {}
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_type$_t_uint96_$",
                                typeString: "type(uint96)"
                              }
                            ],
                            id: 90032,
                            name: "type",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -27,
                            src: "6341:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 90035,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6341:12:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_magic_meta_type_t_uint96",
                            typeString: "type(uint96)"
                          }
                        },
                        id: 90036,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        memberLocation: "6354:3:177",
                        memberName: "max",
                        nodeType: "MemberAccess",
                        src: "6341:16:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      src: "6317:40:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 90041,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 90038,
                          name: "implParams",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90006,
                          src: "6361:10:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                            typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                          }
                        },
                        id: 90039,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "6372:10:177",
                        memberName: "minBidSize",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83092,
                        src: "6361:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        hexValue: "30",
                        id: 90040,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6386:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "6361:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "6317:70:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90047,
                  nodeType: "IfStatement",
                  src: "6313:131:177",
                  trueBody: {
                    id: 90046,
                    nodeType: "Block",
                    src: "6389:55:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 90043,
                            name: "Auction_InvalidParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 82546,
                            src: "6410:21:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 90044,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6410:23:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 90045,
                        nodeType: "RevertStatement",
                        src: "6403:30:177"
                      }
                    ]
                  }
                },
                {
                  condition: {
                    id: 90053,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "UnaryOperation",
                    operator: "!",
                    prefix: true,
                    src: "6528:36:177",
                    subExpression: {
                      arguments: [
                        {
                          expression: {
                            id: 90050,
                            name: "implParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90006,
                            src: "6543:10:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                              typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                            }
                          },
                          id: 90051,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "6554:9:177",
                          memberName: "publicKey",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83095,
                          src: "6543:20:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        ],
                        expression: {
                          id: 90048,
                          name: "ECIES",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 84365,
                          src: "6529:5:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ECIES_$84365_$",
                            typeString: "type(library ECIES)"
                          }
                        },
                        id: 90049,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "6535:7:177",
                        memberName: "isValid",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84342,
                        src: "6529:13:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_struct$_Point_$84010_memory_ptr_$returns$_t_bool_$",
                          typeString: "function (struct Point memory) pure returns (bool)"
                        }
                      },
                      id: 90052,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6529:35:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90057,
                  nodeType: "IfStatement",
                  src: "6524:72:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90054,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "6573:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90055,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6573:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90056,
                    nodeType: "RevertStatement",
                    src: "6566:30:177"
                  }
                },
                {
                  assignments: [90060],
                  declarations: [
                    {
                      constant: false,
                      id: 90060,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "6655:4:177",
                      nodeType: "VariableDeclaration",
                      scope: 90111,
                      src: "6635:24:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData"
                      },
                      typeName: {
                        id: 90059,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90058,
                          name: "AuctionData",
                          nameLocations: ["6635:11:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83136,
                          src: "6635:11:177"
                        },
                        referencedDeclaration: 83136,
                        src: "6635:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90064,
                  initialValue: {
                    baseExpression: {
                      id: 90061,
                      name: "auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89928,
                      src: "6662:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                        typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                      }
                    },
                    id: 90063,
                    indexExpression: {
                      id: 90062,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89995,
                      src: "6674:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "6662:19:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                      typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6635:46:177"
                },
                {
                  expression: {
                    id: 90070,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90065,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90060,
                        src: "6691:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage pointer"
                        }
                      },
                      id: 90067,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6696:8:177",
                      memberName: "minPrice",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83123,
                      src: "6691:13:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90068,
                        name: "implParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90006,
                        src: "6707:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                        }
                      },
                      id: 90069,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "6718:8:177",
                      memberName: "minPrice",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83088,
                      src: "6707:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "6691:35:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 90071,
                  nodeType: "ExpressionStatement",
                  src: "6691:35:177"
                },
                {
                  expression: {
                    id: 90083,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90072,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90060,
                        src: "6796:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage pointer"
                        }
                      },
                      id: 90074,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6801:9:177",
                      memberName: "minFilled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83125,
                      src: "6796:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          expression: {
                            id: 90077,
                            name: "lot_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89998,
                            src: "6843:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Lot_$82587_memory_ptr",
                              typeString: "struct IAuction.Lot memory"
                            }
                          },
                          id: 90078,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "6848:8:177",
                          memberName: "capacity",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82582,
                          src: "6843:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          expression: {
                            id: 90079,
                            name: "implParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90006,
                            src: "6858:10:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                              typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                            }
                          },
                          id: 90080,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "6869:14:177",
                          memberName: "minFillPercent",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83090,
                          src: "6858:25:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint24",
                            typeString: "uint24"
                          }
                        },
                        {
                          id: 90081,
                          name: "_ONE_HUNDRED_PERCENT",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87471,
                          src: "6885:20:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_uint24",
                            typeString: "uint24"
                          },
                          {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        ],
                        expression: {
                          id: 90075,
                          name: "Math",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 55729,
                          src: "6825:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                            typeString: "type(library FixedPointMathLib)"
                          }
                        },
                        id: 90076,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "6830:12:177",
                        memberName: "fullMulDivUp",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 55070,
                        src: "6825:17:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 90082,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6825:81:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "6796:110:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 90084,
                  nodeType: "ExpressionStatement",
                  src: "6796:110:177"
                },
                {
                  expression: {
                    id: 90090,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90085,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90060,
                        src: "6916:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage pointer"
                        }
                      },
                      id: 90087,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6921:10:177",
                      memberName: "minBidSize",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83127,
                      src: "6916:15:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90088,
                        name: "implParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90006,
                        src: "6934:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                        }
                      },
                      id: 90089,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "6945:10:177",
                      memberName: "minBidSize",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83092,
                      src: "6934:21:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "6916:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 90091,
                  nodeType: "ExpressionStatement",
                  src: "6916:39:177"
                },
                {
                  expression: {
                    id: 90097,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90092,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90060,
                        src: "6965:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage pointer"
                        }
                      },
                      id: 90094,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6970:9:177",
                      memberName: "publicKey",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83130,
                      src: "6965:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Point_$84010_storage",
                        typeString: "struct Point storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90095,
                        name: "implParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90006,
                        src: "6982:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83096_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionDataParams memory"
                        }
                      },
                      id: 90096,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "6993:9:177",
                      memberName: "publicKey",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83095,
                      src: "6982:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                        typeString: "struct Point memory"
                      }
                    },
                    src: "6965:37:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Point_$84010_storage",
                      typeString: "struct Point storage ref"
                    }
                  },
                  id: 90098,
                  nodeType: "ExpressionStatement",
                  src: "6965:37:177"
                },
                {
                  expression: {
                    id: 90103,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90099,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90060,
                        src: "7012:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage pointer"
                        }
                      },
                      id: 90101,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "7017:9:177",
                      memberName: "nextBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83112,
                      src: "7012:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "31",
                      id: 90102,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "7029:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1"
                      },
                      value: "1"
                    },
                    src: "7012:18:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 90104,
                  nodeType: "ExpressionStatement",
                  src: "7012:18:177"
                },
                {
                  expression: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        baseExpression: {
                          id: 90105,
                          name: "decryptedBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89962,
                          src: "7041:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
                            typeString: "mapping(uint96 => struct Queue storage ref)"
                          }
                        },
                        id: 90107,
                        indexExpression: {
                          id: 90106,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89995,
                          src: "7055:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "7041:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Queue_$84571_storage",
                          typeString: "struct Queue storage ref"
                        }
                      },
                      id: 90108,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "7063:10:177",
                      memberName: "initialize",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 84596,
                      src: "7041:32:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_struct$_Queue_$84571_storage_ptr_$returns$__$attached_to$_t_struct$_Queue_$84571_storage_ptr_$",
                        typeString: "function (struct Queue storage pointer)"
                      }
                    },
                    id: 90109,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "7041:34:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90110,
                  nodeType: "ExpressionStatement",
                  src: "7041:34:177"
                }
              ]
            },
            baseFunctions: [87636],
            documentation: {
              id: 89993,
              nodeType: "StructuredDocumentation",
              src: "4780:921:177",
              text: "@inheritdoc AuctionModule\n @dev        This function assumes:\n             - The lot ID has been validated\n             - The start and duration of the lot have been validated\n             This function performs the following:\n             - Validates the auction parameters\n             - Stores the auction data\n             - Initializes the decrypted bids queue\n             This function reverts if:\n             - The parameters cannot be decoded into the correct format\n             - The minimum price is zero\n             - The minimum fill percent is greater than 100%\n             - The minimum bid size is zero or greater than the max uint96 value\n             - The public key is not valid\n @param      params_    ABI-encoded data of type `IEncryptedMarginalPrice.AuctionDataParams`"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_auction",
            nameLocation: "5715:8:177",
            overrides: {
              id: 90002,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "5787:8:177"
            },
            parameters: {
              id: 90001,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 89995,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "5731:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90112,
                  src: "5724:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 89994,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "5724:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 89998,
                  mutability: "mutable",
                  name: "lot_",
                  nameLocation: "5750:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 90112,
                  src: "5739:15:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Lot_$82587_memory_ptr",
                    typeString: "struct IAuction.Lot"
                  },
                  typeName: {
                    id: 89997,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 89996,
                      name: "Lot",
                      nameLocations: ["5739:3:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82587,
                      src: "5739:3:177"
                    },
                    referencedDeclaration: 82587,
                    src: "5739:3:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Lot_$82587_storage_ptr",
                      typeString: "struct IAuction.Lot"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 9e4,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "5769:7:177",
                  nodeType: "VariableDeclaration",
                  scope: 90112,
                  src: "5756:20:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 89999,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "5756:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5723:54:177"
            },
            returnParameters: {
              id: 90003,
              nodeType: "ParameterList",
              parameters: [],
              src: "5796:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90132,
            nodeType: "FunctionDefinition",
            src: "7613:386:177",
            nodes: [],
            body: {
              id: 90131,
              nodeType: "Block",
              src: "7670:329:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 90120,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90115,
                        src: "7858:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90119,
                      name: "_revertIfLotActive",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92159],
                      referencedDeclaration: 92159,
                      src: "7839:18:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90121,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "7839:26:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90122,
                  nodeType: "ExpressionStatement",
                  src: "7839:26:177"
                },
                {
                  expression: {
                    id: 90129,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 90123,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "7946:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 90125,
                        indexExpression: {
                          id: 90124,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90115,
                          src: "7958:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "7946:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 90126,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "7966:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83117,
                      src: "7946:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90127,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83106,
                        src: "7975:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                          typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                        }
                      },
                      id: 90128,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "7985:7:177",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83105,
                      src: "7975:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    src: "7946:46:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_LotStatus_$83106",
                      typeString: "enum IEncryptedMarginalPrice.LotStatus"
                    }
                  },
                  id: 90130,
                  nodeType: "ExpressionStatement",
                  src: "7946:46:177"
                }
              ]
            },
            baseFunctions: [87687],
            documentation: {
              id: 90113,
              nodeType: "StructuredDocumentation",
              src: "7088:520:177",
              text: "@inheritdoc AuctionModule\n @dev        This function assumes the following:\n             - The lot ID has been validated\n             - The caller has been authorized\n             - The auction has not concluded\n             This function performs the following:\n             - Sets the auction status to settled, and prevents claiming of proceeds\n             This function reverts if:\n             - The auction is active or has not concluded"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_cancelAuction",
            nameLocation: "7622:14:177",
            overrides: {
              id: 90117,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "7661:8:177"
            },
            parameters: {
              id: 90116,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90115,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "7644:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90132,
                  src: "7637:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90114,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "7637:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "7636:15:177"
            },
            returnParameters: {
              id: 90118,
              nodeType: "ParameterList",
              parameters: [],
              src: "7670:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90260,
            nodeType: "FunctionDefinition",
            src: "8976:1381:177",
            nodes: [],
            body: {
              id: 90259,
              nodeType: "Block",
              src: "9174:1183:177",
              nodes: [],
              statements: [
                {
                  assignments: [90150, 90153],
                  declarations: [
                    {
                      constant: false,
                      id: 90150,
                      mutability: "mutable",
                      name: "encryptedAmountOut",
                      nameLocation: "9224:18:177",
                      nodeType: "VariableDeclaration",
                      scope: 90259,
                      src: "9216:26:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90149,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "9216:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 90153,
                      mutability: "mutable",
                      name: "bidPubKey",
                      nameLocation: "9257:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 90259,
                      src: "9244:22:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                        typeString: "struct Point"
                      },
                      typeName: {
                        id: 90152,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90151,
                          name: "Point",
                          nameLocations: ["9244:5:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 84010,
                          src: "9244:5:177"
                        },
                        referencedDeclaration: 84010,
                        src: "9244:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Point_$84010_storage_ptr",
                          typeString: "struct Point"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90162,
                  initialValue: {
                    arguments: [
                      {
                        id: 90156,
                        name: "auctionData_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90143,
                        src: "9293:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        }
                      },
                      {
                        components: [
                          {
                            id: 90158,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "9308:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_uint256_$",
                              typeString: "type(uint256)"
                            },
                            typeName: {
                              id: 90157,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "9308:7:177",
                              typeDescriptions: {}
                            }
                          },
                          {
                            id: 90159,
                            name: "Point",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 84010,
                            src: "9317:5:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_Point_$84010_storage_ptr_$",
                              typeString: "type(struct Point storage pointer)"
                            }
                          }
                        ],
                        id: 90160,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "9307:16:177",
                        typeDescriptions: {
                          typeIdentifier: "t_tuple$_t_type$_t_uint256_$_$_t_type$_t_struct$_Point_$84010_storage_ptr_$_$",
                          typeString: "tuple(type(uint256),type(struct Point storage pointer))"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_calldata_ptr",
                          typeString: "bytes calldata"
                        },
                        {
                          typeIdentifier: "t_tuple$_t_type$_t_uint256_$_$_t_type$_t_struct$_Point_$84010_storage_ptr_$_$",
                          typeString: "tuple(type(uint256),type(struct Point storage pointer))"
                        }
                      ],
                      expression: {
                        id: 90154,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "9282:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 90155,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "9286:6:177",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "9282:10:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 90161,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9282:42:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_struct$_Point_$84010_memory_ptr_$",
                      typeString: "tuple(uint256,struct Point memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9215:109:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90169,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90163,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90141,
                      src: "9436:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      expression: {
                        arguments: [
                          {
                            id: 90166,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "9451:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_uint96_$",
                              typeString: "type(uint96)"
                            },
                            typeName: {
                              id: 90165,
                              name: "uint96",
                              nodeType: "ElementaryTypeName",
                              src: "9451:6:177",
                              typeDescriptions: {}
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_type$_t_uint96_$",
                              typeString: "type(uint96)"
                            }
                          ],
                          id: 90164,
                          name: "type",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -27,
                          src: "9446:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                            typeString: "function () pure"
                          }
                        },
                        id: 90167,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "9446:12:177",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_magic_meta_type_t_uint96",
                          typeString: "type(uint96)"
                        }
                      },
                      id: 90168,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "9459:3:177",
                      memberName: "max",
                      nodeType: "MemberAccess",
                      src: "9446:16:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    src: "9436:26:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90173,
                  nodeType: "IfStatement",
                  src: "9432:62:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90170,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "9471:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90171,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "9471:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90172,
                    nodeType: "RevertStatement",
                    src: "9464:30:177"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90179,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90174,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90141,
                      src: "9565:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 90175,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "9575:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 90177,
                        indexExpression: {
                          id: 90176,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90135,
                          src: "9587:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "9575:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 90178,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "9595:10:177",
                      memberName: "minBidSize",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83127,
                      src: "9575:30:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "9565:40:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90183,
                  nodeType: "IfStatement",
                  src: "9561:84:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90180,
                        name: "Auction_AmountLessThanMinimum",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82544,
                        src: "9614:29:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90181,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "9614:31:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90182,
                    nodeType: "RevertStatement",
                    src: "9607:38:177"
                  }
                },
                {
                  condition: {
                    id: 90188,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "UnaryOperation",
                    operator: "!",
                    prefix: true,
                    src: "9745:25:177",
                    subExpression: {
                      arguments: [
                        {
                          id: 90186,
                          name: "bidPubKey",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90153,
                          src: "9760:9:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        ],
                        expression: {
                          id: 90184,
                          name: "ECIES",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 84365,
                          src: "9746:5:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ECIES_$84365_$",
                            typeString: "type(library ECIES)"
                          }
                        },
                        id: 90185,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9752:7:177",
                        memberName: "isValid",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84342,
                        src: "9746:13:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_struct$_Point_$84010_memory_ptr_$returns$_t_bool_$",
                          typeString: "function (struct Point memory) pure returns (bool)"
                        }
                      },
                      id: 90187,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "9746:24:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90192,
                  nodeType: "IfStatement",
                  src: "9741:58:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90189,
                        name: "Auction_InvalidKey",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83056,
                        src: "9779:18:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90190,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "9779:20:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90191,
                    nodeType: "RevertStatement",
                    src: "9772:27:177"
                  }
                },
                {
                  expression: {
                    id: 90199,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 90193,
                      name: "bidId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90147,
                      src: "9836:5:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 90198,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "9844:31:177",
                      subExpression: {
                        expression: {
                          baseExpression: {
                            id: 90194,
                            name: "auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89928,
                            src: "9844:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                            }
                          },
                          id: 90196,
                          indexExpression: {
                            id: 90195,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90135,
                            src: "9856:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "9844:19:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                            typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                          }
                        },
                        id: 90197,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: true,
                        memberLocation: "9864:9:177",
                        memberName: "nextBidId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83112,
                        src: "9844:29:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "9836:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 90200,
                  nodeType: "ExpressionStatement",
                  src: "9836:39:177"
                },
                {
                  assignments: [90203],
                  declarations: [
                    {
                      constant: false,
                      id: 90203,
                      mutability: "mutable",
                      name: "userBid",
                      nameLocation: "9897:7:177",
                      nodeType: "VariableDeclaration",
                      scope: 90259,
                      src: "9885:19:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                        typeString: "struct IEncryptedMarginalPrice.Bid"
                      },
                      typeName: {
                        id: 90202,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90201,
                          name: "Bid",
                          nameLocations: ["9885:3:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83148,
                          src: "9885:3:177"
                        },
                        referencedDeclaration: 83148,
                        src: "9885:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90209,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 90204,
                        name: "bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89948,
                        src: "9907:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                        }
                      },
                      id: 90206,
                      indexExpression: {
                        id: 90205,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90135,
                        src: "9912:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "9907:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                        typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                      }
                    },
                    id: 90208,
                    indexExpression: {
                      id: 90207,
                      name: "bidId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90147,
                      src: "9920:5:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "9907:19:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83148_storage",
                      typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9885:41:177"
                },
                {
                  expression: {
                    id: 90214,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90210,
                        name: "userBid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90203,
                        src: "9936:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                        }
                      },
                      id: 90212,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "9944:6:177",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83138,
                      src: "9936:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 90213,
                      name: "bidder_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90137,
                      src: "9953:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "9936:24:177",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 90215,
                  nodeType: "ExpressionStatement",
                  src: "9936:24:177"
                },
                {
                  expression: {
                    id: 90223,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90216,
                        name: "userBid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90203,
                        src: "9970:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                        }
                      },
                      id: 90218,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "9978:6:177",
                      memberName: "amount",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83140,
                      src: "9970:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 90221,
                          name: "amount_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90141,
                          src: "9994:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 90220,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "9987:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_uint96_$",
                          typeString: "type(uint96)"
                        },
                        typeName: {
                          id: 90219,
                          name: "uint96",
                          nodeType: "ElementaryTypeName",
                          src: "9987:6:177",
                          typeDescriptions: {}
                        }
                      },
                      id: 90222,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "9987:15:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    src: "9970:32:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  id: 90224,
                  nodeType: "ExpressionStatement",
                  src: "9970:32:177"
                },
                {
                  expression: {
                    id: 90229,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90225,
                        name: "userBid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90203,
                        src: "10012:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                        }
                      },
                      id: 90227,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "10020:8:177",
                      memberName: "referrer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83144,
                      src: "10012:16:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 90228,
                      name: "referrer_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90139,
                      src: "10031:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "10012:28:177",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 90230,
                  nodeType: "ExpressionStatement",
                  src: "10012:28:177"
                },
                {
                  expression: {
                    id: 90236,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90231,
                        name: "userBid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90203,
                        src: "10050:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                        }
                      },
                      id: 90233,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "10058:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83147,
                      src: "10050:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90234,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83110,
                        src: "10067:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83110_$",
                          typeString: "type(enum IEncryptedMarginalPrice.BidStatus)"
                        }
                      },
                      id: 90235,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "10077:9:177",
                      memberName: "Submitted",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83107,
                      src: "10067:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    src: "10050:36:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_BidStatus_$83110",
                      typeString: "enum IEncryptedMarginalPrice.BidStatus"
                    }
                  },
                  id: 90237,
                  nodeType: "ExpressionStatement",
                  src: "10050:36:177"
                },
                {
                  expression: {
                    id: 90247,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        baseExpression: {
                          id: 90238,
                          name: "encryptedBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89956,
                          src: "10154:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$_$",
                            typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref))"
                          }
                        },
                        id: 90241,
                        indexExpression: {
                          id: 90239,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90135,
                          src: "10168:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "10154:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$",
                          typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref)"
                        }
                      },
                      id: 90242,
                      indexExpression: {
                        id: 90240,
                        name: "bidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90147,
                        src: "10176:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "10154:28:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_EncryptedBid_$83154_storage",
                        typeString: "struct IEncryptedMarginalPrice.EncryptedBid storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 90244,
                          name: "encryptedAmountOut",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90150,
                          src: "10198:18:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          id: 90245,
                          name: "bidPubKey",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90153,
                          src: "10218:9:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        ],
                        id: 90243,
                        name: "EncryptedBid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83154,
                        src: "10185:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_EncryptedBid_$83154_storage_ptr_$",
                          typeString: "type(struct IEncryptedMarginalPrice.EncryptedBid storage pointer)"
                        }
                      },
                      id: 90246,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "structConstructorCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "10185:43:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_EncryptedBid_$83154_memory_ptr",
                        typeString: "struct IEncryptedMarginalPrice.EncryptedBid memory"
                      }
                    },
                    src: "10154:74:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_EncryptedBid_$83154_storage",
                      typeString: "struct IEncryptedMarginalPrice.EncryptedBid storage ref"
                    }
                  },
                  id: 90248,
                  nodeType: "ExpressionStatement",
                  src: "10154:74:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90254,
                        name: "bidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90147,
                        src: "10321:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      expression: {
                        expression: {
                          baseExpression: {
                            id: 90249,
                            name: "auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89928,
                            src: "10289:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                            }
                          },
                          id: 90251,
                          indexExpression: {
                            id: 90250,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90135,
                            src: "10301:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "10289:19:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                            typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                          }
                        },
                        id: 90252,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "10309:6:177",
                        memberName: "bidIds",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83135,
                        src: "10289:26:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage",
                          typeString: "uint64[] storage ref"
                        }
                      },
                      id: 90253,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "10316:4:177",
                      memberName: "push",
                      nodeType: "MemberAccess",
                      src: "10289:31:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_arraypush_nonpayable$_t_array$_t_uint64_$dyn_storage_ptr_$_t_uint64_$returns$__$attached_to$_t_array$_t_uint64_$dyn_storage_ptr_$",
                        typeString: "function (uint64[] storage pointer,uint64)"
                      }
                    },
                    id: 90255,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "10289:38:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90256,
                  nodeType: "ExpressionStatement",
                  src: "10289:38:177"
                },
                {
                  expression: {
                    id: 90257,
                    name: "bidId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 90147,
                    src: "10345:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  functionReturnParameters: 90148,
                  id: 90258,
                  nodeType: "Return",
                  src: "10338:12:177"
                }
              ]
            },
            baseFunctions: [89206],
            documentation: {
              id: 90133,
              nodeType: "StructuredDocumentation",
              src: "8042:929:177",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates inputs\n             - Stores the encrypted bid\n             - Adds the bid ID to the list of bids to decrypt\n             - Returns the bid ID\n             This function assumes:\n             - The lot ID has been validated\n             - The caller has been authorized\n             - The auction is active\n             This function reverts if:\n             - The parameters cannot be decoded into the correct format\n             - The amount is greater than the max uint96 value\n             - The amount is less than the minimum bid size for the lot\n             - The bid public key is not valid\n @param      auctionData_    ABI-encoded data of type `IEncryptedMarginalPrice.BidParams`"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_bid",
            nameLocation: "8985:4:177",
            overrides: {
              id: 90145,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "9142:8:177"
            },
            parameters: {
              id: 90144,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90135,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "9006:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90260,
                  src: "8999:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90134,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "8999:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90137,
                  mutability: "mutable",
                  name: "bidder_",
                  nameLocation: "9030:7:177",
                  nodeType: "VariableDeclaration",
                  scope: 90260,
                  src: "9022:15:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 90136,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "9022:7:177",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90139,
                  mutability: "mutable",
                  name: "referrer_",
                  nameLocation: "9055:9:177",
                  nodeType: "VariableDeclaration",
                  scope: 90260,
                  src: "9047:17:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 90138,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "9047:7:177",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90141,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "9082:7:177",
                  nodeType: "VariableDeclaration",
                  scope: 90260,
                  src: "9074:15:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90140,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9074:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90143,
                  mutability: "mutable",
                  name: "auctionData_",
                  nameLocation: "9114:12:177",
                  nodeType: "VariableDeclaration",
                  scope: 90260,
                  src: "9099:27:177",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_calldata_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 90142,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "9099:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "8989:143:177"
            },
            returnParameters: {
              id: 90148,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90147,
                  mutability: "mutable",
                  name: "bidId",
                  nameLocation: "9167:5:177",
                  nodeType: "VariableDeclaration",
                  scope: 90260,
                  src: "9160:12:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90146,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "9160:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9159:14:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90321,
            nodeType: "FunctionDefinition",
            src: "11256:668:177",
            nodes: [],
            body: {
              id: 90320,
              nodeType: "Block",
              src: "11432:492:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 90278,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11493:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90277,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "11473:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90279,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11473:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90280,
                  nodeType: "ExpressionStatement",
                  src: "11473:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90282,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11534:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90281,
                      name: "_revertIfBeforeLotStart",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87893,
                      src: "11510:23:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90283,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11510:31:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90284,
                  nodeType: "ExpressionStatement",
                  src: "11510:31:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90286,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11571:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90287,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90265,
                        src: "11579:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 90285,
                      name: "_revertIfBidInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92259],
                      referencedDeclaration: 92259,
                      src: "11551:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                        typeString: "function (uint96,uint64) view"
                      }
                    },
                    id: 90288,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11551:35:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90289,
                  nodeType: "ExpressionStatement",
                  src: "11551:35:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90291,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11617:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90292,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90265,
                        src: "11625:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 90293,
                        name: "caller_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90269,
                        src: "11633:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 90290,
                      name: "_revertIfNotBidOwner",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92284],
                      referencedDeclaration: 92284,
                      src: "11596:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$_t_address_$returns$__$",
                        typeString: "function (uint96,uint64,address) view"
                      }
                    },
                    id: 90294,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11596:45:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90295,
                  nodeType: "ExpressionStatement",
                  src: "11596:45:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90297,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11671:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90298,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90265,
                        src: "11679:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 90296,
                      name: "_revertIfBidClaimed",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92310],
                      referencedDeclaration: 92310,
                      src: "11651:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                        typeString: "function (uint96,uint64) view"
                      }
                    },
                    id: 90299,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11651:35:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90300,
                  nodeType: "ExpressionStatement",
                  src: "11651:35:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90302,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11727:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90301,
                      name: "_revertIfDedicatedSettlePeriod",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89549,
                      src: "11696:30:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90303,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11696:38:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90304,
                  nodeType: "ExpressionStatement",
                  src: "11696:38:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90306,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11766:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90305,
                      name: "_revertIfKeySubmitted",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92178,
                      src: "11744:21:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90307,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11744:29:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90308,
                  nodeType: "ExpressionStatement",
                  src: "11744:29:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90310,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11803:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90309,
                      name: "_revertIfLotSettled",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92199],
                      referencedDeclaration: 92199,
                      src: "11783:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90311,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11783:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90312,
                  nodeType: "ExpressionStatement",
                  src: "11783:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90314,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90263,
                        src: "11885:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90315,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90265,
                        src: "11893:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 90316,
                        name: "index_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90267,
                        src: "11901:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 90317,
                        name: "caller_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90269,
                        src: "11909:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 90313,
                      name: "_refundBid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [90407],
                      referencedDeclaration: 90407,
                      src: "11874:10:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint96_$_t_uint64_$_t_uint256_$_t_address_$returns$_t_uint256_$",
                        typeString: "function (uint96,uint64,uint256,address) returns (uint256)"
                      }
                    },
                    id: 90318,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11874:43:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 90276,
                  id: 90319,
                  nodeType: "Return",
                  src: "11867:50:177"
                }
              ]
            },
            baseFunctions: [89259],
            documentation: {
              id: 90261,
              nodeType: "StructuredDocumentation",
              src: "10363:888:177",
              text: "@inheritdoc IBatchAuction\n @dev        Implements a basic refundBid function that:\n             - Validates the lot and bid parameters\n             - Calls the implementation-specific function\n             This function reverts if:\n             - The lot id is invalid\n             - The lot has not started\n             - The lot is decrypted or settled (but not concluded)\n             - The lot is within the dedicated settle period\n             - The bid id is invalid\n             - `caller_` is not the bid owner\n             - The bid is claimed or refunded\n             - The caller is not an internal module\n             This is a modified version of the refundBid function in the AuctionModule contract.\n             It does not revert if the lot is concluded."
            },
            functionSelector: "7d9234bc",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                id: 90273,
                kind: "modifierInvocation",
                modifierName: {
                  id: 90272,
                  name: "onlyInternal",
                  nameLocations: ["11394:12:177"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 88967,
                  src: "11394:12:177"
                },
                nodeType: "ModifierInvocation",
                src: "11394:12:177"
              }
            ],
            name: "refundBid",
            nameLocation: "11265:9:177",
            overrides: {
              id: 90271,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "11385:8:177"
            },
            parameters: {
              id: 90270,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90263,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "11291:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90321,
                  src: "11284:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90262,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "11284:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90265,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "11314:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90321,
                  src: "11307:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90264,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "11307:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90267,
                  mutability: "mutable",
                  name: "index_",
                  nameLocation: "11338:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90321,
                  src: "11330:14:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90266,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11330:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90269,
                  mutability: "mutable",
                  name: "caller_",
                  nameLocation: "11362:7:177",
                  nodeType: "VariableDeclaration",
                  scope: 90321,
                  src: "11354:15:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 90268,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "11354:7:177",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11274:101:177"
            },
            returnParameters: {
              id: 90276,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90275,
                  mutability: "mutable",
                  name: "refund",
                  nameLocation: "11424:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90321,
                  src: "11416:14:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90274,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11416:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11415:16:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 90407,
            nodeType: "FunctionDefinition",
            src: "12662:904:177",
            nodes: [],
            body: {
              id: 90406,
              nodeType: "Block",
              src: "12818:748:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 90344,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 90336,
                            name: "bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89948,
                            src: "12865:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                            }
                          },
                          id: 90339,
                          indexExpression: {
                            id: 90337,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90324,
                            src: "12870:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "12865:12:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                            typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                          }
                        },
                        id: 90340,
                        indexExpression: {
                          id: 90338,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90326,
                          src: "12878:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "12865:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                        }
                      },
                      id: 90341,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "12886:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83147,
                      src: "12865:27:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90342,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83110,
                        src: "12895:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83110_$",
                          typeString: "type(enum IEncryptedMarginalPrice.BidStatus)"
                        }
                      },
                      id: 90343,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "12905:7:177",
                      memberName: "Claimed",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83109,
                      src: "12895:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    src: "12865:47:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_BidStatus_$83110",
                      typeString: "enum IEncryptedMarginalPrice.BidStatus"
                    }
                  },
                  id: 90345,
                  nodeType: "ExpressionStatement",
                  src: "12865:47:177"
                },
                {
                  assignments: [90350],
                  declarations: [
                    {
                      constant: false,
                      id: 90350,
                      mutability: "mutable",
                      name: "bidIds",
                      nameLocation: "12991:6:177",
                      nodeType: "VariableDeclaration",
                      scope: 90406,
                      src: "12974:23:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                        typeString: "uint64[]"
                      },
                      typeName: {
                        baseType: {
                          id: 90348,
                          name: "uint64",
                          nodeType: "ElementaryTypeName",
                          src: "12974:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 90349,
                        nodeType: "ArrayTypeName",
                        src: "12974:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90355,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 90351,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "13000:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 90353,
                      indexExpression: {
                        id: 90352,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90324,
                        src: "13012:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "13000:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 90354,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "13020:6:177",
                    memberName: "bidIds",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83135,
                    src: "13000:26:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage",
                      typeString: "uint64[] storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12974:52:177"
                },
                {
                  assignments: [90357],
                  declarations: [
                    {
                      constant: false,
                      id: 90357,
                      mutability: "mutable",
                      name: "len",
                      nameLocation: "13044:3:177",
                      nodeType: "VariableDeclaration",
                      scope: 90406,
                      src: "13036:11:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90356,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13036:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90360,
                  initialValue: {
                    expression: {
                      id: 90358,
                      name: "bidIds",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90350,
                      src: "13050:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                        typeString: "uint64[] storage pointer"
                      }
                    },
                    id: 90359,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "13057:6:177",
                    memberName: "length",
                    nodeType: "MemberAccess",
                    src: "13050:13:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13036:27:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90363,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90361,
                      name: "index_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90328,
                      src: "13130:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">=",
                    rightExpression: {
                      id: 90362,
                      name: "len",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90357,
                      src: "13140:3:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "13130:13:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90367,
                  nodeType: "IfStatement",
                  src: "13126:49:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90364,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "13152:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90365,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "13152:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90366,
                    nodeType: "RevertStatement",
                    src: "13145:30:177"
                  }
                },
                {
                  assignments: [90369],
                  declarations: [
                    {
                      constant: false,
                      id: 90369,
                      mutability: "mutable",
                      name: "bidId",
                      nameLocation: "13270:5:177",
                      nodeType: "VariableDeclaration",
                      scope: 90406,
                      src: "13263:12:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      },
                      typeName: {
                        id: 90368,
                        name: "uint64",
                        nodeType: "ElementaryTypeName",
                        src: "13263:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90373,
                  initialValue: {
                    baseExpression: {
                      id: 90370,
                      name: "bidIds",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90350,
                      src: "13278:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                        typeString: "uint64[] storage pointer"
                      }
                    },
                    id: 90372,
                    indexExpression: {
                      id: 90371,
                      name: "index_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90328,
                      src: "13285:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "13278:14:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13263:29:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    },
                    id: 90376,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90374,
                      name: "bidId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90369,
                      src: "13306:5:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      id: 90375,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90326,
                      src: "13315:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "13306:15:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90380,
                  nodeType: "IfStatement",
                  src: "13302:51:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90377,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "13330:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90378,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "13330:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90379,
                    nodeType: "RevertStatement",
                    src: "13323:30:177"
                  }
                },
                {
                  expression: {
                    id: 90389,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        id: 90381,
                        name: "bidIds",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90350,
                        src: "13407:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[] storage pointer"
                        }
                      },
                      id: 90383,
                      indexExpression: {
                        id: 90382,
                        name: "index_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90328,
                        src: "13414:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "13407:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      baseExpression: {
                        id: 90384,
                        name: "bidIds",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90350,
                        src: "13424:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[] storage pointer"
                        }
                      },
                      id: 90388,
                      indexExpression: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 90387,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 90385,
                          name: "len",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90357,
                          src: "13431:3:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "-",
                        rightExpression: {
                          hexValue: "31",
                          id: 90386,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "13437:1:177",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_1_by_1",
                            typeString: "int_const 1"
                          },
                          value: "1"
                        },
                        src: "13431:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "13424:15:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "13407:32:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 90390,
                  nodeType: "ExpressionStatement",
                  src: "13407:32:177"
                },
                {
                  expression: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        id: 90391,
                        name: "bidIds",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90350,
                        src: "13449:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[] storage pointer"
                        }
                      },
                      id: 90393,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "13456:3:177",
                      memberName: "pop",
                      nodeType: "MemberAccess",
                      src: "13449:10:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_arraypop_nonpayable$_t_array$_t_uint64_$dyn_storage_ptr_$returns$__$attached_to$_t_array$_t_uint64_$dyn_storage_ptr_$",
                        typeString: "function (uint64[] storage pointer)"
                      }
                    },
                    id: 90394,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "13449:12:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90395,
                  nodeType: "ExpressionStatement",
                  src: "13449:12:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          baseExpression: {
                            baseExpression: {
                              id: 90398,
                              name: "bids",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89948,
                              src: "13531:4:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                                typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                              }
                            },
                            id: 90400,
                            indexExpression: {
                              id: 90399,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90324,
                              src: "13536:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "13531:12:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                              typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                            }
                          },
                          id: 90402,
                          indexExpression: {
                            id: 90401,
                            name: "bidId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90326,
                            src: "13544:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "13531:20:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Bid_$83148_storage",
                            typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                          }
                        },
                        id: 90403,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "13552:6:177",
                        memberName: "amount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83140,
                        src: "13531:27:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90397,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "13523:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint256_$",
                        typeString: "type(uint256)"
                      },
                      typeName: {
                        id: 90396,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13523:7:177",
                        typeDescriptions: {}
                      }
                    },
                    id: 90404,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "13523:36:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 90335,
                  id: 90405,
                  nodeType: "Return",
                  src: "13516:43:177"
                }
              ]
            },
            baseFunctions: [89273],
            documentation: {
              id: 90322,
              nodeType: "StructuredDocumentation",
              src: "11930:727:177",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates inputs\n             - Marks the bid as refunded\n             - Removes the bid from the list of bids to decrypt\n             - Returns the amount to be refunded\n             The encrypted bid is not deleted from storage, so that the details can be fetched later.\n             This function assumes:\n             - The lot ID has been validated\n             - The bid ID has been validated\n             - The caller has been authorized\n             - The auction is active\n             - The bid has not been refunded"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_refundBid",
            nameLocation: "12671:10:177",
            overrides: {
              id: 90332,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "12784:8:177"
            },
            parameters: {
              id: 90331,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90324,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "12698:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90407,
                  src: "12691:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90323,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "12691:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90326,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "12721:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90407,
                  src: "12714:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90325,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "12714:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90328,
                  mutability: "mutable",
                  name: "index_",
                  nameLocation: "12745:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90407,
                  src: "12737:14:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90327,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "12737:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90330,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 90407,
                  src: "12761:7:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 90329,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "12761:7:177",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "12681:93:177"
            },
            returnParameters: {
              id: 90335,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90334,
                  mutability: "mutable",
                  name: "refund",
                  nameLocation: "12810:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90407,
                  src: "12802:14:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90333,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "12802:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "12801:16:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90448,
            nodeType: "FunctionDefinition",
            src: "14169:436:177",
            nodes: [],
            body: {
              id: 90447,
              nodeType: "Block",
              src: "14313:292:177",
              nodes: [],
              statements: [
                {
                  assignments: [90422],
                  declarations: [
                    {
                      constant: false,
                      id: 90422,
                      mutability: "mutable",
                      name: "bidData",
                      nameLocation: "14360:7:177",
                      nodeType: "VariableDeclaration",
                      scope: 90447,
                      src: "14348:19:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                        typeString: "struct IEncryptedMarginalPrice.Bid"
                      },
                      typeName: {
                        id: 90421,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90420,
                          name: "Bid",
                          nameLocations: ["14348:3:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83148,
                          src: "14348:3:177"
                        },
                        referencedDeclaration: 83148,
                        src: "14348:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90428,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 90423,
                        name: "bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89948,
                        src: "14370:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                        }
                      },
                      id: 90425,
                      indexExpression: {
                        id: 90424,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90410,
                        src: "14375:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "14370:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                        typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                      }
                    },
                    id: 90427,
                    indexExpression: {
                      id: 90426,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90412,
                      src: "14383:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "14370:20:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83148_storage",
                      typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "14348:42:177"
                },
                {
                  expression: {
                    id: 90434,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90429,
                        name: "bidData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90422,
                        src: "14442:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                        }
                      },
                      id: 90431,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "14450:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83147,
                      src: "14442:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90432,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83110,
                        src: "14459:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83110_$",
                          typeString: "type(enum IEncryptedMarginalPrice.BidStatus)"
                        }
                      },
                      id: 90433,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "14469:7:177",
                      memberName: "Claimed",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83109,
                      src: "14459:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    src: "14442:34:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_BidStatus_$83110",
                      typeString: "enum IEncryptedMarginalPrice.BidStatus"
                    }
                  },
                  id: 90435,
                  nodeType: "ExpressionStatement",
                  src: "14442:34:177"
                },
                {
                  expression: {
                    id: 90441,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 90436,
                      name: "bidClaim",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90416,
                      src: "14515:8:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 90438,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90410,
                          src: "14539:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 90439,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90412,
                          src: "14547:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        ],
                        id: 90437,
                        name: "_getBidClaim",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92073,
                        src: "14526:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$_t_struct$_BidClaim_$82721_memory_ptr_$",
                          typeString: "function (uint96,uint64) view returns (struct IBatchAuction.BidClaim memory)"
                        }
                      },
                      id: 90440,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "14526:28:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory"
                      }
                    },
                    src: "14515:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory"
                    }
                  },
                  id: 90442,
                  nodeType: "ExpressionStatement",
                  src: "14515:39:177"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 90443,
                        name: "bidClaim",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90416,
                        src: "14573:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory"
                        }
                      },
                      {
                        id: 90444,
                        name: "auctionOutput_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90418,
                        src: "14583:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    id: 90445,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "14572:26:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_struct$_BidClaim_$82721_memory_ptr_$_t_bytes_memory_ptr_$",
                      typeString: "tuple(struct IBatchAuction.BidClaim memory,bytes memory)"
                    }
                  },
                  functionReturnParameters: 90419,
                  id: 90446,
                  nodeType: "Return",
                  src: "14565:33:177"
                }
              ]
            },
            documentation: {
              id: 90408,
              nodeType: "StructuredDocumentation",
              src: "13572:592:177",
              text: "@notice     Claims a bid and calculates the paid and payout amounts\n @dev        This function performs the following:\n             - Validates inputs\n             - Marks the bid as claimed\n             - Calculates the paid and payout amounts\n             This function assumes:\n             - The lot ID has been validated\n             - The bid ID has been validated\n             - The caller has been authorized\n             - The auction is not settled\n             - The bid has not already been claimed"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_claimBid",
            nameLocation: "14178:9:177",
            parameters: {
              id: 90413,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90410,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "14204:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90448,
                  src: "14197:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90409,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "14197:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90412,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "14227:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90448,
                  src: "14220:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90411,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "14220:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14187:52:177"
            },
            returnParameters: {
              id: 90419,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90416,
                  mutability: "mutable",
                  name: "bidClaim",
                  nameLocation: "14274:8:177",
                  nodeType: "VariableDeclaration",
                  scope: 90448,
                  src: "14258:24:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim"
                  },
                  typeName: {
                    id: 90415,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 90414,
                      name: "BidClaim",
                      nameLocations: ["14258:8:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82721,
                      src: "14258:8:177"
                    },
                    referencedDeclaration: 82721,
                    src: "14258:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90418,
                  mutability: "mutable",
                  name: "auctionOutput_",
                  nameLocation: "14297:14:177",
                  nodeType: "VariableDeclaration",
                  scope: 90448,
                  src: "14284:27:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 90417,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "14284:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14257:55:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90520,
            nodeType: "FunctionDefinition",
            src: "15261:542:177",
            nodes: [],
            body: {
              id: 90519,
              nodeType: "Block",
              src: "15430:373:177",
              nodes: [],
              statements: [
                {
                  assignments: [90465],
                  declarations: [
                    {
                      constant: false,
                      id: 90465,
                      mutability: "mutable",
                      name: "len",
                      nameLocation: "15448:3:177",
                      nodeType: "VariableDeclaration",
                      scope: 90519,
                      src: "15440:11:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90464,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "15440:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90468,
                  initialValue: {
                    expression: {
                      id: 90466,
                      name: "bidIds_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90454,
                      src: "15454:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                        typeString: "uint64[] calldata"
                      }
                    },
                    id: 90467,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "15462:6:177",
                    memberName: "length",
                    nodeType: "MemberAccess",
                    src: "15454:14:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "15440:28:177"
                },
                {
                  expression: {
                    id: 90476,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 90469,
                      name: "bidClaims",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90460,
                      src: "15478:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory[] memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 90474,
                          name: "len",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90465,
                          src: "15505:3:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 90473,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "NewExpression",
                        src: "15490:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr_$",
                          typeString: "function (uint256) pure returns (struct IBatchAuction.BidClaim memory[] memory)"
                        },
                        typeName: {
                          baseType: {
                            id: 90471,
                            nodeType: "UserDefinedTypeName",
                            pathNode: {
                              id: 90470,
                              name: "BidClaim",
                              nameLocations: ["15494:8:177"],
                              nodeType: "IdentifierPath",
                              referencedDeclaration: 82721,
                              src: "15494:8:177"
                            },
                            referencedDeclaration: 82721,
                            src: "15494:8:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                              typeString: "struct IBatchAuction.BidClaim"
                            }
                          },
                          id: 90472,
                          nodeType: "ArrayTypeName",
                          src: "15494:10:177",
                          typeDescriptions: {
                            typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_storage_$dyn_storage_ptr",
                            typeString: "struct IBatchAuction.BidClaim[]"
                          }
                        }
                      },
                      id: 90475,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "15490:19:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory[] memory"
                      }
                    },
                    src: "15478:31:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory[] memory"
                    }
                  },
                  id: 90477,
                  nodeType: "ExpressionStatement",
                  src: "15478:31:177"
                },
                {
                  body: {
                    id: 90513,
                    nodeType: "Block",
                    src: "15549:203:177",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 90488,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90451,
                              src: "15607:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              baseExpression: {
                                id: 90489,
                                name: "bidIds_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90454,
                                src: "15615:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                  typeString: "uint64[] calldata"
                                }
                              },
                              id: 90491,
                              indexExpression: {
                                id: 90490,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90479,
                                src: "15623:1:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "15615:10:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            ],
                            id: 90487,
                            name: "_revertIfBidInvalid",
                            nodeType: "Identifier",
                            overloadedDeclarations: [92259],
                            referencedDeclaration: 92259,
                            src: "15587:19:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                              typeString: "function (uint96,uint64) view"
                            }
                          },
                          id: 90492,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "15587:39:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 90493,
                        nodeType: "ExpressionStatement",
                        src: "15587:39:177"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 90495,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90451,
                              src: "15660:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              baseExpression: {
                                id: 90496,
                                name: "bidIds_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90454,
                                src: "15668:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                  typeString: "uint64[] calldata"
                                }
                              },
                              id: 90498,
                              indexExpression: {
                                id: 90497,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90479,
                                src: "15676:1:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "15668:10:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            ],
                            id: 90494,
                            name: "_revertIfBidClaimed",
                            nodeType: "Identifier",
                            overloadedDeclarations: [92310],
                            referencedDeclaration: 92310,
                            src: "15640:19:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                              typeString: "function (uint96,uint64) view"
                            }
                          },
                          id: 90499,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "15640:39:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 90500,
                        nodeType: "ExpressionStatement",
                        src: "15640:39:177"
                      },
                      {
                        expression: {
                          id: 90511,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            components: [
                              {
                                baseExpression: {
                                  id: 90501,
                                  name: "bidClaims",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90460,
                                  src: "15695:9:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                                    typeString: "struct IBatchAuction.BidClaim memory[] memory"
                                  }
                                },
                                id: 90503,
                                indexExpression: {
                                  id: 90502,
                                  name: "i",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90479,
                                  src: "15705:1:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                nodeType: "IndexAccess",
                                src: "15695:12:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                  typeString: "struct IBatchAuction.BidClaim memory"
                                }
                              },
                              null
                            ],
                            id: 90504,
                            isConstant: false,
                            isInlineArray: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "TupleExpression",
                            src: "15694:15:177",
                            typeDescriptions: {
                              typeIdentifier: "t_tuple$_t_struct$_BidClaim_$82721_memory_ptr_$__$",
                              typeString: "tuple(struct IBatchAuction.BidClaim memory,)"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 90506,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90451,
                                src: "15722:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              {
                                baseExpression: {
                                  id: 90507,
                                  name: "bidIds_",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90454,
                                  src: "15730:7:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                    typeString: "uint64[] calldata"
                                  }
                                },
                                id: 90509,
                                indexExpression: {
                                  id: 90508,
                                  name: "i",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90479,
                                  src: "15738:1:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                nodeType: "IndexAccess",
                                src: "15730:10:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                },
                                {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              ],
                              id: 90505,
                              name: "_claimBid",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90448,
                              src: "15712:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_nonpayable$_t_uint96_$_t_uint64_$returns$_t_struct$_BidClaim_$82721_memory_ptr_$_t_bytes_memory_ptr_$",
                                typeString: "function (uint96,uint64) returns (struct IBatchAuction.BidClaim memory,bytes memory)"
                              }
                            },
                            id: 90510,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "15712:29:177",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_tuple$_t_struct$_BidClaim_$82721_memory_ptr_$_t_bytes_memory_ptr_$",
                              typeString: "tuple(struct IBatchAuction.BidClaim memory,bytes memory)"
                            }
                          },
                          src: "15694:47:177",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 90512,
                        nodeType: "ExpressionStatement",
                        src: "15694:47:177"
                      }
                    ]
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90483,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90481,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90479,
                      src: "15535:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 90482,
                      name: "len",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90465,
                      src: "15539:3:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "15535:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90514,
                  initializationExpression: {
                    assignments: [90479],
                    declarations: [
                      {
                        constant: false,
                        id: 90479,
                        mutability: "mutable",
                        name: "i",
                        nameLocation: "15532:1:177",
                        nodeType: "VariableDeclaration",
                        scope: 90514,
                        src: "15524:9:177",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        typeName: {
                          id: 90478,
                          name: "uint256",
                          nodeType: "ElementaryTypeName",
                          src: "15524:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        visibility: "internal"
                      }
                    ],
                    id: 90480,
                    nodeType: "VariableDeclarationStatement",
                    src: "15524:9:177"
                  },
                  loopExpression: {
                    expression: {
                      id: 90485,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "15544:3:177",
                      subExpression: {
                        id: 90484,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90479,
                        src: "15544:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 90486,
                    nodeType: "ExpressionStatement",
                    src: "15544:3:177"
                  },
                  nodeType: "ForStatement",
                  src: "15519:233:177"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 90515,
                        name: "bidClaims",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90460,
                        src: "15770:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory[] memory"
                        }
                      },
                      {
                        id: 90516,
                        name: "auctionOutput_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90462,
                        src: "15781:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    id: 90517,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "15769:27:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr_$_t_bytes_memory_ptr_$",
                      typeString: "tuple(struct IBatchAuction.BidClaim memory[] memory,bytes memory)"
                    }
                  },
                  functionReturnParameters: 90463,
                  id: 90518,
                  nodeType: "Return",
                  src: "15762:34:177"
                }
              ]
            },
            baseFunctions: [89320],
            documentation: {
              id: 90449,
              nodeType: "StructuredDocumentation",
              src: "14611:645:177",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates inputs\n             - Marks the bid as claimed\n             - Calculates the paid and payout amounts\n             This function assumes:\n             - The lot ID has been validated\n             - The caller has been authorized\n             - The auction has concluded\n             - The auction is not settled\n             This function reverts if:\n             - The bid ID is invalid\n             - The bid has already been claimed"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_claimBids",
            nameLocation: "15270:10:177",
            overrides: {
              id: 90456,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "15354:8:177"
            },
            parameters: {
              id: 90455,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90451,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "15297:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90520,
                  src: "15290:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90450,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "15290:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90454,
                  mutability: "mutable",
                  name: "bidIds_",
                  nameLocation: "15331:7:177",
                  nodeType: "VariableDeclaration",
                  scope: 90520,
                  src: "15313:25:177",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                    typeString: "uint64[]"
                  },
                  typeName: {
                    baseType: {
                      id: 90452,
                      name: "uint64",
                      nodeType: "ElementaryTypeName",
                      src: "15313:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    id: 90453,
                    nodeType: "ArrayTypeName",
                    src: "15313:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                      typeString: "uint64[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15280:64:177"
            },
            returnParameters: {
              id: 90463,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90460,
                  mutability: "mutable",
                  name: "bidClaims",
                  nameLocation: "15390:9:177",
                  nodeType: "VariableDeclaration",
                  scope: 90520,
                  src: "15372:27:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim[]"
                  },
                  typeName: {
                    baseType: {
                      id: 90458,
                      nodeType: "UserDefinedTypeName",
                      pathNode: {
                        id: 90457,
                        name: "BidClaim",
                        nameLocations: ["15372:8:177"],
                        nodeType: "IdentifierPath",
                        referencedDeclaration: 82721,
                        src: "15372:8:177"
                      },
                      referencedDeclaration: 82721,
                      src: "15372:8:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                        typeString: "struct IBatchAuction.BidClaim"
                      }
                    },
                    id: 90459,
                    nodeType: "ArrayTypeName",
                    src: "15372:10:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_storage_$dyn_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim[]"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90462,
                  mutability: "mutable",
                  name: "auctionOutput_",
                  nameLocation: "15414:14:177",
                  nodeType: "VariableDeclaration",
                  scope: 90520,
                  src: "15401:27:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 90461,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "15401:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15371:58:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90614,
            nodeType: "FunctionDefinition",
            src: "16291:1105:177",
            nodes: [],
            body: {
              id: 90613,
              nodeType: "Block",
              src: "16453:943:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 90535,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "16505:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90534,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "16485:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90536,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16485:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90537,
                  nodeType: "ExpressionStatement",
                  src: "16485:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90539,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "16541:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90538,
                      name: "_revertIfLotActive",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92159],
                      referencedDeclaration: 92159,
                      src: "16522:18:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90540,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16522:26:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90541,
                  nodeType: "ExpressionStatement",
                  src: "16522:26:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90543,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "16582:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90542,
                      name: "_revertIfBeforeLotStart",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87893,
                      src: "16558:23:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90544,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16558:31:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90545,
                  nodeType: "ExpressionStatement",
                  src: "16558:31:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90547,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "16619:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90546,
                      name: "_revertIfLotSettled",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92199],
                      referencedDeclaration: 92199,
                      src: "16599:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90548,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16599:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90549,
                  nodeType: "ExpressionStatement",
                  src: "16599:27:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90555,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 90550,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "16712:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 90552,
                        indexExpression: {
                          id: 90551,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90523,
                          src: "16724:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "16712:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 90553,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "16732:10:177",
                      memberName: "privateKey",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83132,
                      src: "16712:30:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      hexValue: "30",
                      id: 90554,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "16746:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "16712:35:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90560,
                  nodeType: "IfStatement",
                  src: "16708:74:177",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 90557,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90523,
                          src: "16775:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        ],
                        id: 90556,
                        name: "Auction_WrongState",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83060,
                        src: "16756:18:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                          typeString: "function (uint96) pure"
                        }
                      },
                      id: 90558,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "16756:26:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90559,
                    nodeType: "RevertStatement",
                    src: "16749:33:177"
                  }
                },
                {
                  assignments: [90563],
                  declarations: [
                    {
                      constant: false,
                      id: 90563,
                      mutability: "mutable",
                      name: "calcPubKey",
                      nameLocation: "16958:10:177",
                      nodeType: "VariableDeclaration",
                      scope: 90613,
                      src: "16945:23:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                        typeString: "struct Point"
                      },
                      typeName: {
                        id: 90562,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90561,
                          name: "Point",
                          nameLocations: ["16945:5:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 84010,
                          src: "16945:5:177"
                        },
                        referencedDeclaration: 84010,
                        src: "16945:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Point_$84010_storage_ptr",
                          typeString: "struct Point"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90572,
                  initialValue: {
                    arguments: [
                      {
                        arguments: [
                          {
                            hexValue: "31",
                            id: 90567,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "16994:1:177",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_1_by_1",
                              typeString: "int_const 1"
                            },
                            value: "1"
                          },
                          {
                            hexValue: "32",
                            id: 90568,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "16997:1:177",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_2_by_1",
                              typeString: "int_const 2"
                            },
                            value: "2"
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_rational_1_by_1",
                              typeString: "int_const 1"
                            },
                            {
                              typeIdentifier: "t_rational_2_by_1",
                              typeString: "int_const 2"
                            }
                          ],
                          id: 90566,
                          name: "Point",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 84010,
                          src: "16988:5:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_struct$_Point_$84010_storage_ptr_$",
                            typeString: "type(struct Point storage pointer)"
                          }
                        },
                        id: 90569,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "structConstructorCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "16988:11:177",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                          typeString: "struct Point memory"
                        }
                      },
                      {
                        id: 90570,
                        name: "privateKey_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90525,
                        src: "17001:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                          typeString: "struct Point memory"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 90564,
                        name: "ECIES",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 84365,
                        src: "16971:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_ECIES_$84365_$",
                          typeString: "type(library ECIES)"
                        }
                      },
                      id: 90565,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "16977:10:177",
                      memberName: "calcPubKey",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 84207,
                      src: "16971:16:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_struct$_Point_$84010_memory_ptr_$_t_uint256_$returns$_t_struct$_Point_$84010_memory_ptr_$",
                        typeString: "function (struct Point memory,uint256) view returns (struct Point memory)"
                      }
                    },
                    id: 90571,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16971:42:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                      typeString: "struct Point memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "16945:68:177"
                },
                {
                  assignments: [90575],
                  declarations: [
                    {
                      constant: false,
                      id: 90575,
                      mutability: "mutable",
                      name: "pubKey",
                      nameLocation: "17036:6:177",
                      nodeType: "VariableDeclaration",
                      scope: 90613,
                      src: "17023:19:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                        typeString: "struct Point"
                      },
                      typeName: {
                        id: 90574,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90573,
                          name: "Point",
                          nameLocations: ["17023:5:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 84010,
                          src: "17023:5:177"
                        },
                        referencedDeclaration: 84010,
                        src: "17023:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Point_$84010_storage_ptr",
                          typeString: "struct Point"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90580,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 90576,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "17045:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 90578,
                      indexExpression: {
                        id: 90577,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "17057:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "17045:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 90579,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "17065:9:177",
                    memberName: "publicKey",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83130,
                    src: "17045:29:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Point_$84010_storage",
                      typeString: "struct Point storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "17023:51:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 90591,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 90585,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 90581,
                          name: "calcPubKey",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90563,
                          src: "17088:10:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        },
                        id: 90582,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17099:1:177",
                        memberName: "x",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84007,
                        src: "17088:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "!=",
                      rightExpression: {
                        expression: {
                          id: 90583,
                          name: "pubKey",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90575,
                          src: "17104:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        },
                        id: 90584,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17111:1:177",
                        memberName: "x",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84007,
                        src: "17104:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "17088:24:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 90590,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 90586,
                          name: "calcPubKey",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90563,
                          src: "17116:10:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        },
                        id: 90587,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17127:1:177",
                        memberName: "y",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84009,
                        src: "17116:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "!=",
                      rightExpression: {
                        expression: {
                          id: 90588,
                          name: "pubKey",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90575,
                          src: "17132:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Point_$84010_memory_ptr",
                            typeString: "struct Point memory"
                          }
                        },
                        id: 90589,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17139:1:177",
                        memberName: "y",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84009,
                        src: "17132:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "17116:24:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "17088:52:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90595,
                  nodeType: "IfStatement",
                  src: "17084:85:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90592,
                        name: "Auction_InvalidKey",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83056,
                        src: "17149:18:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90593,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "17149:20:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90594,
                    nodeType: "RevertStatement",
                    src: "17142:27:177"
                  }
                },
                {
                  expression: {
                    id: 90601,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 90596,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "17213:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 90598,
                        indexExpression: {
                          id: 90597,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90523,
                          src: "17225:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "17213:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 90599,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "17233:10:177",
                      memberName: "privateKey",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83132,
                      src: "17213:30:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 90600,
                      name: "privateKey_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90525,
                      src: "17246:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "17213:44:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 90602,
                  nodeType: "ExpressionStatement",
                  src: "17213:44:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90604,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "17321:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90605,
                        name: "num_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90527,
                        src: "17329:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 90606,
                        name: "sortHints_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90530,
                        src: "17335:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                          typeString: "bytes32[] calldata"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                          typeString: "bytes32[] calldata"
                        }
                      ],
                      id: 90603,
                      name: "_decryptAndSortBids",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90776,
                      src: "17301:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint96_$_t_uint64_$_t_array$_t_bytes32_$dyn_calldata_ptr_$returns$__$",
                        typeString: "function (uint96,uint64,bytes32[] calldata)"
                      }
                    },
                    id: 90607,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "17301:45:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90608,
                  nodeType: "ExpressionStatement",
                  src: "17301:45:177"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 90610,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90523,
                        src: "17382:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90609,
                      name: "PrivateKeySubmitted",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83086,
                      src: "17362:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint96_$returns$__$",
                        typeString: "function (uint96)"
                      }
                    },
                    id: 90611,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "17362:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90612,
                  nodeType: "EmitStatement",
                  src: "17357:32:177"
                }
              ]
            },
            baseFunctions: [83174],
            documentation: {
              id: 90521,
              nodeType: "StructuredDocumentation",
              src: "15853:433:177",
              text: "@inheritdoc IEncryptedMarginalPrice\n @dev        This function reverts if:\n             - The lot ID is invalid\n             - The lot is not active\n             - The lot has not concluded\n             - The private key has already been submitted\n             - The lot has been settled (cancelled, settled or aborted)\n             - The private key is invalid for the public key"
            },
            functionSelector: "79fd0c1f",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "submitPrivateKey",
            nameLocation: "16300:16:177",
            overrides: {
              id: 90532,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "16444:8:177"
            },
            parameters: {
              id: 90531,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90523,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "16333:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90614,
                  src: "16326:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90522,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "16326:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90525,
                  mutability: "mutable",
                  name: "privateKey_",
                  nameLocation: "16357:11:177",
                  nodeType: "VariableDeclaration",
                  scope: 90614,
                  src: "16349:19:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90524,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "16349:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90527,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "16385:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 90614,
                  src: "16378:11:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90526,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "16378:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90530,
                  mutability: "mutable",
                  name: "sortHints_",
                  nameLocation: "16418:10:177",
                  nodeType: "VariableDeclaration",
                  scope: 90614,
                  src: "16399:29:177",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                    typeString: "bytes32[]"
                  },
                  typeName: {
                    baseType: {
                      id: 90528,
                      name: "bytes32",
                      nodeType: "ElementaryTypeName",
                      src: "16399:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bytes32",
                        typeString: "bytes32"
                      }
                    },
                    id: 90529,
                    nodeType: "ArrayTypeName",
                    src: "16399:9:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_bytes32_$dyn_storage_ptr",
                      typeString: "bytes32[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "16316:118:177"
            },
            returnParameters: {
              id: 90533,
              nodeType: "ParameterList",
              parameters: [],
              src: "16453:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 90665,
            nodeType: "FunctionDefinition",
            src: "18410:633:177",
            nodes: [],
            body: {
              id: 90664,
              nodeType: "Block",
              src: "18545:498:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 90627,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90617,
                        src: "18612:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90626,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "18592:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90628,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18592:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90629,
                  nodeType: "ExpressionStatement",
                  src: "18592:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90631,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90617,
                        src: "18653:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90630,
                      name: "_revertIfBeforeLotStart",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87893,
                      src: "18629:23:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90632,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18629:31:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90633,
                  nodeType: "ExpressionStatement",
                  src: "18629:31:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90635,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90617,
                        src: "18689:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90634,
                      name: "_revertIfLotActive",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92159],
                      referencedDeclaration: 92159,
                      src: "18670:18:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 90636,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18670:26:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90637,
                  nodeType: "ExpressionStatement",
                  src: "18670:26:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 90651,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      },
                      id: 90644,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          baseExpression: {
                            id: 90638,
                            name: "auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89928,
                            src: "18794:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                            }
                          },
                          id: 90640,
                          indexExpression: {
                            id: 90639,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90617,
                            src: "18806:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "18794:19:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                            typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                          }
                        },
                        id: 90641,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18814:6:177",
                        memberName: "status",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83117,
                        src: "18794:26:177",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_LotStatus_$83106",
                          typeString: "enum IEncryptedMarginalPrice.LotStatus"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "!=",
                      rightExpression: {
                        expression: {
                          id: 90642,
                          name: "LotStatus",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 83106,
                          src: "18824:9:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                            typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                          }
                        },
                        id: 90643,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        memberLocation: "18834:7:177",
                        memberName: "Created",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83103,
                        src: "18824:17:177",
                        typeDescriptions: {
                          typeIdentifier: "t_enum$_LotStatus_$83106",
                          typeString: "enum IEncryptedMarginalPrice.LotStatus"
                        }
                      },
                      src: "18794:47:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 90650,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          baseExpression: {
                            id: 90645,
                            name: "auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89928,
                            src: "18845:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                            }
                          },
                          id: 90647,
                          indexExpression: {
                            id: 90646,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90617,
                            src: "18857:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "18845:19:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                            typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                          }
                        },
                        id: 90648,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18865:10:177",
                        memberName: "privateKey",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83132,
                        src: "18845:30:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        hexValue: "30",
                        id: 90649,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "18879:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "18845:35:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "18794:86:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90657,
                  nodeType: "IfStatement",
                  src: "18790:158:177",
                  trueBody: {
                    id: 90656,
                    nodeType: "Block",
                    src: "18890:58:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 90653,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90617,
                              src: "18930:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 90652,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83060,
                            src: "18911:18:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 90654,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "18911:26:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 90655,
                        nodeType: "RevertStatement",
                        src: "18904:33:177"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 90659,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90617,
                        src: "19011:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90660,
                        name: "num_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90619,
                        src: "19019:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 90661,
                        name: "sortHints_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90622,
                        src: "19025:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                          typeString: "bytes32[] calldata"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                          typeString: "bytes32[] calldata"
                        }
                      ],
                      id: 90658,
                      name: "_decryptAndSortBids",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90776,
                      src: "18991:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint96_$_t_uint64_$_t_array$_t_bytes32_$dyn_calldata_ptr_$returns$__$",
                        typeString: "function (uint96,uint64,bytes32[] calldata)"
                      }
                    },
                    id: 90662,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "18991:45:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90663,
                  nodeType: "ExpressionStatement",
                  src: "18991:45:177"
                }
              ]
            },
            baseFunctions: [83185],
            documentation: {
              id: 90615,
              nodeType: "StructuredDocumentation",
              src: "17402:1003:177",
              text: "@inheritdoc IEncryptedMarginalPrice\n @dev        This function handles the following:\n             - Performs state validation\n             - Iterates over the encrypted bids:\n                 - Decrypts the bid\n                 - Ignores if the bid is incorrectly encrypted\n                 - Does not add to the sorted bid queue if the decrypted amount out is less than the minimum bid size or overflows\n                 - Otherwise, adds to the sorted bid queue for use during settlement\n             - Determines the next decrypt index\n             - Sets the auction status to decrypted if all bids have been decrypted\n             This function reverts if:\n             - The lot ID is invalid\n             - The lot has not started\n             - The lot is active\n             - The private key has not been provided\n             - `num_` and `sortHints_` have different lengths"
            },
            functionSelector: "25e34a8e",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "decryptAndSortBids",
            nameLocation: "18419:18:177",
            overrides: {
              id: 90624,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "18536:8:177"
            },
            parameters: {
              id: 90623,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90617,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "18454:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90665,
                  src: "18447:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90616,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "18447:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90619,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "18477:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 90665,
                  src: "18470:11:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90618,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "18470:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90622,
                  mutability: "mutable",
                  name: "sortHints_",
                  nameLocation: "18510:10:177",
                  nodeType: "VariableDeclaration",
                  scope: 90665,
                  src: "18491:29:177",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                    typeString: "bytes32[]"
                  },
                  typeName: {
                    baseType: {
                      id: 90620,
                      name: "bytes32",
                      nodeType: "ElementaryTypeName",
                      src: "18491:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bytes32",
                        typeString: "bytes32"
                      }
                    },
                    id: 90621,
                    nodeType: "ArrayTypeName",
                    src: "18491:9:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_bytes32_$dyn_storage_ptr",
                      typeString: "bytes32[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18437:89:177"
            },
            returnParameters: {
              id: 90625,
              nodeType: "ParameterList",
              parameters: [],
              src: "18545:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 90776,
            nodeType: "FunctionDefinition",
            src: "19049:1749:177",
            nodes: [],
            body: {
              id: 90775,
              nodeType: "Block",
              src: "19176:1622:177",
              nodes: [],
              statements: [
                {
                  assignments: [90676],
                  declarations: [
                    {
                      constant: false,
                      id: 90676,
                      mutability: "mutable",
                      name: "nextDecryptIndex",
                      nameLocation: "19245:16:177",
                      nodeType: "VariableDeclaration",
                      scope: 90775,
                      src: "19238:23:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      },
                      typeName: {
                        id: 90675,
                        name: "uint64",
                        nodeType: "ElementaryTypeName",
                        src: "19238:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90681,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 90677,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "19264:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 90679,
                      indexExpression: {
                        id: 90678,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90667,
                        src: "19276:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "19264:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 90680,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "19284:16:177",
                    memberName: "nextDecryptIndex",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83114,
                    src: "19264:36:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19238:62:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90685,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 90682,
                        name: "sortHints_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90672,
                        src: "19378:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                          typeString: "bytes32[] calldata"
                        }
                      },
                      id: 90683,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19389:6:177",
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "19378:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      id: 90684,
                      name: "num_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90669,
                      src: "19399:4:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "19378:25:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90689,
                  nodeType: "IfStatement",
                  src: "19374:61:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 90686,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "19412:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 90687,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "19412:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90688,
                    nodeType: "RevertStatement",
                    src: "19405:30:177"
                  }
                },
                {
                  assignments: [90694],
                  declarations: [
                    {
                      constant: false,
                      id: 90694,
                      mutability: "mutable",
                      name: "bidIds",
                      nameLocation: "19627:6:177",
                      nodeType: "VariableDeclaration",
                      scope: 90775,
                      src: "19610:23:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                        typeString: "uint64[]"
                      },
                      typeName: {
                        baseType: {
                          id: 90692,
                          name: "uint64",
                          nodeType: "ElementaryTypeName",
                          src: "19610:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 90693,
                        nodeType: "ArrayTypeName",
                        src: "19610:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90699,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 90695,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "19636:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 90697,
                      indexExpression: {
                        id: 90696,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90667,
                        src: "19648:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "19636:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 90698,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "19656:6:177",
                    memberName: "bidIds",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83135,
                    src: "19636:26:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage",
                      typeString: "uint64[] storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19610:52:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90705,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90700,
                      name: "num_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90669,
                      src: "19676:4:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 90704,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 90701,
                          name: "bidIds",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90694,
                          src: "19683:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                            typeString: "uint64[] storage pointer"
                          }
                        },
                        id: 90702,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "19690:6:177",
                        memberName: "length",
                        nodeType: "MemberAccess",
                        src: "19683:13:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "-",
                      rightExpression: {
                        id: 90703,
                        name: "nextDecryptIndex",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90676,
                        src: "19699:16:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      src: "19683:32:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "19676:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90717,
                  nodeType: "IfStatement",
                  src: "19672:117:177",
                  trueBody: {
                    id: 90716,
                    nodeType: "Block",
                    src: "19717:72:177",
                    statements: [
                      {
                        expression: {
                          id: 90714,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 90706,
                            name: "num_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90669,
                            src: "19731:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            commonType: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            },
                            id: 90713,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              arguments: [
                                {
                                  expression: {
                                    id: 90709,
                                    name: "bidIds",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90694,
                                    src: "19745:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                                      typeString: "uint64[] storage pointer"
                                    }
                                  },
                                  id: 90710,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "19752:6:177",
                                  memberName: "length",
                                  nodeType: "MemberAccess",
                                  src: "19745:13:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                id: 90708,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "19738:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint64_$",
                                  typeString: "type(uint64)"
                                },
                                typeName: {
                                  id: 90707,
                                  name: "uint64",
                                  nodeType: "ElementaryTypeName",
                                  src: "19738:6:177",
                                  typeDescriptions: {}
                                }
                              },
                              id: 90711,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "19738:21:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "-",
                            rightExpression: {
                              id: 90712,
                              name: "nextDecryptIndex",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90676,
                              src: "19762:16:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            src: "19738:40:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          src: "19731:47:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 90715,
                        nodeType: "ExpressionStatement",
                        src: "19731:47:177"
                      }
                    ]
                  }
                },
                {
                  assignments: [90719],
                  declarations: [
                    {
                      constant: false,
                      id: 90719,
                      mutability: "mutable",
                      name: "baseScale",
                      nameLocation: "19940:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 90775,
                      src: "19932:17:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90718,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "19932:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90726,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90725,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      hexValue: "3130",
                      id: 90720,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "19952:2:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_10_by_1",
                        typeString: "int_const 10"
                      },
                      value: "10"
                    },
                    nodeType: "BinaryOperation",
                    operator: "**",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 90721,
                          name: "lotData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87480,
                          src: "19958:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                            typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                          }
                        },
                        id: 90723,
                        indexExpression: {
                          id: 90722,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90667,
                          src: "19966:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "19958:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Lot_$82587_storage",
                          typeString: "struct IAuction.Lot storage ref"
                        }
                      },
                      id: 90724,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19974:17:177",
                      memberName: "baseTokenDecimals",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82578,
                      src: "19958:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint8",
                        typeString: "uint8"
                      }
                    },
                    src: "19952:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19932:59:177"
                },
                {
                  body: {
                    id: 90749,
                    nodeType: "Block",
                    src: "20304:175:177",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 90737,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90667,
                              src: "20405:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              baseExpression: {
                                id: 90738,
                                name: "bidIds",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90694,
                                src: "20413:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                                  typeString: "uint64[] storage pointer"
                                }
                              },
                              id: 90742,
                              indexExpression: {
                                commonType: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                },
                                id: 90741,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftExpression: {
                                  id: 90739,
                                  name: "nextDecryptIndex",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90676,
                                  src: "20420:16:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint64",
                                    typeString: "uint64"
                                  }
                                },
                                nodeType: "BinaryOperation",
                                operator: "+",
                                rightExpression: {
                                  id: 90740,
                                  name: "i",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90728,
                                  src: "20439:1:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint64",
                                    typeString: "uint64"
                                  }
                                },
                                src: "20420:20:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "20413:28:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            {
                              baseExpression: {
                                id: 90743,
                                name: "sortHints_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90672,
                                src: "20443:10:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                                  typeString: "bytes32[] calldata"
                                }
                              },
                              id: 90745,
                              indexExpression: {
                                id: 90744,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90728,
                                src: "20454:1:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "20443:13:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes32",
                                typeString: "bytes32"
                              }
                            },
                            {
                              id: 90746,
                              name: "baseScale",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90719,
                              src: "20458:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              },
                              {
                                typeIdentifier: "t_bytes32",
                                typeString: "bytes32"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            id: 90736,
                            name: "_decrypt",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90996,
                            src: "20396:8:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_uint96_$_t_uint64_$_t_bytes32_$_t_uint256_$returns$__$",
                              typeString: "function (uint96,uint64,bytes32,uint256)"
                            }
                          },
                          id: 90747,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "20396:72:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 90748,
                        nodeType: "ExpressionStatement",
                        src: "20396:72:177"
                      }
                    ]
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    },
                    id: 90732,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90730,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90728,
                      src: "20289:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 90731,
                      name: "num_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90669,
                      src: "20293:4:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "20289:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90750,
                  initializationExpression: {
                    assignments: [90728],
                    declarations: [
                      {
                        constant: false,
                        id: 90728,
                        mutability: "mutable",
                        name: "i",
                        nameLocation: "20286:1:177",
                        nodeType: "VariableDeclaration",
                        scope: 90750,
                        src: "20279:8:177",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        typeName: {
                          id: 90727,
                          name: "uint64",
                          nodeType: "ElementaryTypeName",
                          src: "20279:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        visibility: "internal"
                      }
                    ],
                    id: 90729,
                    nodeType: "VariableDeclarationStatement",
                    src: "20279:8:177"
                  },
                  loopExpression: {
                    expression: {
                      id: 90734,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "20299:3:177",
                      subExpression: {
                        id: 90733,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90728,
                        src: "20299:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    id: 90735,
                    nodeType: "ExpressionStatement",
                    src: "20299:3:177"
                  },
                  nodeType: "ForStatement",
                  src: "20274:205:177"
                },
                {
                  expression: {
                    id: 90756,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 90751,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "20529:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 90753,
                        indexExpression: {
                          id: 90752,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90667,
                          src: "20541:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "20529:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 90754,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "20549:16:177",
                      memberName: "nextDecryptIndex",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83114,
                      src: "20529:36:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "+=",
                    rightHandSide: {
                      id: 90755,
                      name: "num_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90669,
                      src: "20569:4:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "20529:44:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 90757,
                  nodeType: "ExpressionStatement",
                  src: "20529:44:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90764,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 90758,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "20664:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 90760,
                        indexExpression: {
                          id: 90759,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90667,
                          src: "20676:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "20664:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 90761,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20684:16:177",
                      memberName: "nextDecryptIndex",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83114,
                      src: "20664:36:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      expression: {
                        id: 90762,
                        name: "bidIds",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90694,
                        src: "20704:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[] storage pointer"
                        }
                      },
                      id: 90763,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20711:6:177",
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "20704:13:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "20664:53:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90774,
                  nodeType: "IfStatement",
                  src: "20660:132:177",
                  trueBody: {
                    id: 90773,
                    nodeType: "Block",
                    src: "20719:73:177",
                    statements: [
                      {
                        expression: {
                          id: 90771,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              baseExpression: {
                                id: 90765,
                                name: "auctionData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89928,
                                src: "20733:11:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                                  typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                                }
                              },
                              id: 90767,
                              indexExpression: {
                                id: 90766,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90667,
                                src: "20745:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "20733:19:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                                typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                              }
                            },
                            id: 90768,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "20753:6:177",
                            memberName: "status",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83117,
                            src: "20733:26:177",
                            typeDescriptions: {
                              typeIdentifier: "t_enum$_LotStatus_$83106",
                              typeString: "enum IEncryptedMarginalPrice.LotStatus"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 90769,
                              name: "LotStatus",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 83106,
                              src: "20762:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                                typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                              }
                            },
                            id: 90770,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "20772:9:177",
                            memberName: "Decrypted",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83104,
                            src: "20762:19:177",
                            typeDescriptions: {
                              typeIdentifier: "t_enum$_LotStatus_$83106",
                              typeString: "enum IEncryptedMarginalPrice.LotStatus"
                            }
                          },
                          src: "20733:48:177",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_LotStatus_$83106",
                            typeString: "enum IEncryptedMarginalPrice.LotStatus"
                          }
                        },
                        id: 90772,
                        nodeType: "ExpressionStatement",
                        src: "20733:48:177"
                      }
                    ]
                  }
                }
              ]
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_decryptAndSortBids",
            nameLocation: "19058:19:177",
            parameters: {
              id: 90673,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90667,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "19094:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90776,
                  src: "19087:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90666,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "19087:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90669,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "19117:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 90776,
                  src: "19110:11:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90668,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "19110:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90672,
                  mutability: "mutable",
                  name: "sortHints_",
                  nameLocation: "19150:10:177",
                  nodeType: "VariableDeclaration",
                  scope: 90776,
                  src: "19131:29:177",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_bytes32_$dyn_calldata_ptr",
                    typeString: "bytes32[]"
                  },
                  typeName: {
                    baseType: {
                      id: 90670,
                      name: "bytes32",
                      nodeType: "ElementaryTypeName",
                      src: "19131:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bytes32",
                        typeString: "bytes32"
                      }
                    },
                    id: 90671,
                    nodeType: "ArrayTypeName",
                    src: "19131:9:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_bytes32_$dyn_storage_ptr",
                      typeString: "bytes32[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19077:89:177"
            },
            returnParameters: {
              id: 90674,
              nodeType: "ParameterList",
              parameters: [],
              src: "19176:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 90870,
            nodeType: "FunctionDefinition",
            src: "21130:1755:177",
            nodes: [],
            body: {
              id: 90869,
              nodeType: "Block",
              src: "21251:1634:177",
              nodes: [],
              statements: [
                {
                  assignments: [90788],
                  declarations: [
                    {
                      constant: false,
                      id: 90788,
                      mutability: "mutable",
                      name: "privateKey",
                      nameLocation: "21301:10:177",
                      nodeType: "VariableDeclaration",
                      scope: 90869,
                      src: "21293:18:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90787,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "21293:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90793,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 90789,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "21314:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 90791,
                      indexExpression: {
                        id: 90790,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90779,
                        src: "21326:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "21314:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 90792,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "21334:10:177",
                    memberName: "privateKey",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83132,
                    src: "21314:30:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "21293:51:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90796,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90794,
                      name: "privateKey",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90788,
                      src: "21418:10:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 90795,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "21432:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "21418:15:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90801,
                  nodeType: "IfStatement",
                  src: "21414:54:177",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 90798,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90779,
                          src: "21461:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        ],
                        id: 90797,
                        name: "Auction_WrongState",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83060,
                        src: "21442:18:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                          typeString: "function (uint96) pure"
                        }
                      },
                      id: 90799,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "21442:26:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 90800,
                    nodeType: "RevertStatement",
                    src: "21435:33:177"
                  }
                },
                {
                  assignments: [90804],
                  declarations: [
                    {
                      constant: false,
                      id: 90804,
                      mutability: "mutable",
                      name: "bidData",
                      nameLocation: "21710:7:177",
                      nodeType: "VariableDeclaration",
                      scope: 90869,
                      src: "21698:19:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                        typeString: "struct IEncryptedMarginalPrice.Bid"
                      },
                      typeName: {
                        id: 90803,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90802,
                          name: "Bid",
                          nameLocations: ["21698:3:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83148,
                          src: "21698:3:177"
                        },
                        referencedDeclaration: 83148,
                        src: "21698:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90810,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 90805,
                        name: "bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89948,
                        src: "21720:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                        }
                      },
                      id: 90807,
                      indexExpression: {
                        id: 90806,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90779,
                        src: "21725:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "21720:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                        typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                      }
                    },
                    id: 90809,
                    indexExpression: {
                      id: 90808,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90781,
                      src: "21733:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "21720:20:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83148_storage",
                      typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "21698:42:177"
                },
                {
                  assignments: [90812],
                  declarations: [
                    {
                      constant: false,
                      id: 90812,
                      mutability: "mutable",
                      name: "message",
                      nameLocation: "21758:7:177",
                      nodeType: "VariableDeclaration",
                      scope: 90869,
                      src: "21750:15:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90811,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "21750:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90842,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          baseExpression: {
                            baseExpression: {
                              id: 90815,
                              name: "encryptedBids",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89956,
                              src: "21795:13:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$_$",
                                typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref))"
                              }
                            },
                            id: 90817,
                            indexExpression: {
                              id: 90816,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90779,
                              src: "21809:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "21795:21:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$",
                              typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref)"
                            }
                          },
                          id: 90819,
                          indexExpression: {
                            id: 90818,
                            name: "bidId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90781,
                            src: "21817:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "21795:29:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_EncryptedBid_$83154_storage",
                            typeString: "struct IEncryptedMarginalPrice.EncryptedBid storage ref"
                          }
                        },
                        id: 90820,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "21825:18:177",
                        memberName: "encryptedAmountOut",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83150,
                        src: "21795:48:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          baseExpression: {
                            baseExpression: {
                              id: 90821,
                              name: "encryptedBids",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89956,
                              src: "21857:13:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$_$",
                                typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref))"
                              }
                            },
                            id: 90823,
                            indexExpression: {
                              id: 90822,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90779,
                              src: "21871:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "21857:21:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$",
                              typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref)"
                            }
                          },
                          id: 90825,
                          indexExpression: {
                            id: 90824,
                            name: "bidId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90781,
                            src: "21879:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "21857:29:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_EncryptedBid_$83154_storage",
                            typeString: "struct IEncryptedMarginalPrice.EncryptedBid storage ref"
                          }
                        },
                        id: 90826,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "21887:9:177",
                        memberName: "bidPubKey",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83153,
                        src: "21857:39:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Point_$84010_storage",
                          typeString: "struct Point storage ref"
                        }
                      },
                      {
                        id: 90827,
                        name: "privateKey",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90788,
                        src: "21910:10:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    id: 90833,
                                    name: "lotId_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90779,
                                    src: "21969:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 90834,
                                      name: "bidData",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 90804,
                                      src: "21977:7:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                        typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                      }
                                    },
                                    id: 90835,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "21985:6:177",
                                    memberName: "bidder",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 83138,
                                    src: "21977:14:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 90836,
                                      name: "bidData",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 90804,
                                      src: "21993:7:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                        typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                      }
                                    },
                                    id: 90837,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "22001:6:177",
                                    memberName: "amount",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 83140,
                                    src: "21993:14:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    },
                                    {
                                      typeIdentifier: "t_address",
                                      typeString: "address"
                                    },
                                    {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  ],
                                  expression: {
                                    id: 90831,
                                    name: "abi",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: -1,
                                    src: "21952:3:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_magic_abi",
                                      typeString: "abi"
                                    }
                                  },
                                  id: 90832,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  memberLocation: "21956:12:177",
                                  memberName: "encodePacked",
                                  nodeType: "MemberAccess",
                                  src: "21952:16:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
                                    typeString: "function () pure returns (bytes memory)"
                                  }
                                },
                                id: 90838,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "21952:56:177",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_bytes_memory_ptr",
                                  typeString: "bytes memory"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_bytes_memory_ptr",
                                  typeString: "bytes memory"
                                }
                              ],
                              id: 90830,
                              name: "keccak256",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -8,
                              src: "21942:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
                                typeString: "function (bytes memory) pure returns (bytes32)"
                              }
                            },
                            id: 90839,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "21942:67:177",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_bytes32",
                              typeString: "bytes32"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bytes32",
                              typeString: "bytes32"
                            }
                          ],
                          id: 90829,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "21934:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_uint256_$",
                            typeString: "type(uint256)"
                          },
                          typeName: {
                            id: 90828,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "21934:7:177",
                            typeDescriptions: {}
                          }
                        },
                        id: 90840,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "21934:76:177",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_struct$_Point_$84010_storage",
                          typeString: "struct Point storage ref"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 90813,
                        name: "ECIES",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 84365,
                        src: "21768:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_ECIES_$84365_$",
                          typeString: "type(library ECIES)"
                        }
                      },
                      id: 90814,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "21774:7:177",
                      memberName: "decrypt",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 84119,
                      src: "21768:13:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint256_$_t_struct$_Point_$84010_memory_ptr_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                        typeString: "function (uint256,struct Point memory,uint256,uint256) view returns (uint256)"
                      }
                    },
                    id: 90841,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "21768:252:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "21750:270:177"
                },
                {
                  assignments: [90844],
                  declarations: [
                    {
                      constant: false,
                      id: 90844,
                      mutability: "mutable",
                      name: "maskedValue",
                      nameLocation: "22645:11:177",
                      nodeType: "VariableDeclaration",
                      scope: 90869,
                      src: "22637:19:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint128",
                        typeString: "uint128"
                      },
                      typeName: {
                        id: 90843,
                        name: "uint128",
                        nodeType: "ElementaryTypeName",
                        src: "22637:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint128",
                          typeString: "uint128"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90849,
                  initialValue: {
                    arguments: [
                      {
                        id: 90847,
                        name: "message",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90812,
                        src: "22667:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 90846,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "22659:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint128_$",
                        typeString: "type(uint128)"
                      },
                      typeName: {
                        id: 90845,
                        name: "uint128",
                        nodeType: "ElementaryTypeName",
                        src: "22659:7:177",
                        typeDescriptions: {}
                      }
                    },
                    id: 90848,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "22659:16:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint128",
                      typeString: "uint128"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "22637:38:177"
                },
                {
                  assignments: [90851],
                  declarations: [
                    {
                      constant: false,
                      id: 90851,
                      mutability: "mutable",
                      name: "seed",
                      nameLocation: "22693:4:177",
                      nodeType: "VariableDeclaration",
                      scope: 90869,
                      src: "22685:12:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint128",
                        typeString: "uint128"
                      },
                      typeName: {
                        id: 90850,
                        name: "uint128",
                        nodeType: "ElementaryTypeName",
                        src: "22685:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint128",
                          typeString: "uint128"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90858,
                  initialValue: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 90856,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 90854,
                          name: "message",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90812,
                          src: "22708:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: ">>",
                        rightExpression: {
                          hexValue: "313238",
                          id: 90855,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "22719:3:177",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_128_by_1",
                            typeString: "int_const 128"
                          },
                          value: "128"
                        },
                        src: "22708:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 90853,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "22700:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint128_$",
                        typeString: "type(uint128)"
                      },
                      typeName: {
                        id: 90852,
                        name: "uint128",
                        nodeType: "ElementaryTypeName",
                        src: "22700:7:177",
                        typeDescriptions: {}
                      }
                    },
                    id: 90857,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "22700:23:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint128",
                      typeString: "uint128"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "22685:38:177"
                },
                {
                  id: 90868,
                  nodeType: "UncheckedBlock",
                  src: "22805:74:177",
                  statements: [
                    {
                      expression: {
                        id: 90866,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          id: 90859,
                          name: "amountOut",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90785,
                          src: "22829:9:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "=",
                        rightHandSide: {
                          arguments: [
                            {
                              commonType: {
                                typeIdentifier: "t_uint128",
                                typeString: "uint128"
                              },
                              id: 90864,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 90862,
                                name: "maskedValue",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90844,
                                src: "22849:11:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint128",
                                  typeString: "uint128"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "+",
                              rightExpression: {
                                id: 90863,
                                name: "seed",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90851,
                                src: "22863:4:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint128",
                                  typeString: "uint128"
                                }
                              },
                              src: "22849:18:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint128",
                                typeString: "uint128"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint128",
                                typeString: "uint128"
                              }
                            ],
                            id: 90861,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "22841:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_uint256_$",
                              typeString: "type(uint256)"
                            },
                            typeName: {
                              id: 90860,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "22841:7:177",
                              typeDescriptions: {}
                            }
                          },
                          id: 90865,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "22841:27:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "22829:39:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 90867,
                      nodeType: "ExpressionStatement",
                      src: "22829:39:177"
                    }
                  ]
                }
              ]
            },
            baseFunctions: [83195],
            documentation: {
              id: 90777,
              nodeType: "StructuredDocumentation",
              src: "20804:321:177",
              text: "@inheritdoc IEncryptedMarginalPrice\n @dev        This function does not alter the state of the contract, but provides a way to peek at the decrypted bid\n             This function reverts if:\n             - The lot ID is invalid\n             - The private key has not been provided"
            },
            functionSelector: "a1a61ec5",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "decryptBid",
            nameLocation: "21139:10:177",
            overrides: {
              id: 90783,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "21214:8:177"
            },
            parameters: {
              id: 90782,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90779,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "21166:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90870,
                  src: "21159:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90778,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "21159:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90781,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "21189:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90870,
                  src: "21182:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90780,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "21182:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21149:52:177"
            },
            returnParameters: {
              id: 90786,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90785,
                  mutability: "mutable",
                  name: "amountOut",
                  nameLocation: "21240:9:177",
                  nodeType: "VariableDeclaration",
                  scope: 90870,
                  src: "21232:17:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90784,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "21232:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21231:19:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          },
          {
            id: 90996,
            nodeType: "FunctionDefinition",
            src: "22964:1907:177",
            nodes: [],
            body: {
              id: 90995,
              nodeType: "Block",
              src: "23098:1773:177",
              nodes: [],
              statements: [
                {
                  assignments: [90884],
                  declarations: [
                    {
                      constant: false,
                      id: 90884,
                      mutability: "mutable",
                      name: "bidData",
                      nameLocation: "23151:7:177",
                      nodeType: "VariableDeclaration",
                      scope: 90995,
                      src: "23139:19:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                        typeString: "struct IEncryptedMarginalPrice.Bid"
                      },
                      typeName: {
                        id: 90883,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 90882,
                          name: "Bid",
                          nameLocations: ["23139:3:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83148,
                          src: "23139:3:177"
                        },
                        referencedDeclaration: 83148,
                        src: "23139:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90890,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 90885,
                        name: "bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89948,
                        src: "23161:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                        }
                      },
                      id: 90887,
                      indexExpression: {
                        id: 90886,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90873,
                        src: "23166:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "23161:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                        typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                      }
                    },
                    id: 90889,
                    indexExpression: {
                      id: 90888,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90875,
                      src: "23174:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "23161:20:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83148_storage",
                      typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "23139:42:177"
                },
                {
                  assignments: [90892],
                  declarations: [
                    {
                      constant: false,
                      id: 90892,
                      mutability: "mutable",
                      name: "plaintext",
                      nameLocation: "23199:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 90995,
                      src: "23191:17:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 90891,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "23191:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90897,
                  initialValue: {
                    arguments: [
                      {
                        id: 90894,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90873,
                        src: "23222:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90895,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90875,
                        src: "23230:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 90893,
                      name: "decryptBid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90870,
                      src: "23211:10:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$_t_uint256_$",
                        typeString: "function (uint96,uint64) view returns (uint256)"
                      }
                    },
                    id: 90896,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "23211:26:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "23191:46:177"
                },
                {
                  assignments: [90899],
                  declarations: [
                    {
                      constant: false,
                      id: 90899,
                      mutability: "mutable",
                      name: "amountOut",
                      nameLocation: "23255:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 90995,
                      src: "23248:16:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      },
                      typeName: {
                        id: 90898,
                        name: "uint96",
                        nodeType: "ElementaryTypeName",
                        src: "23248:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 90900,
                  nodeType: "VariableDeclarationStatement",
                  src: "23248:16:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 90907,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90901,
                      name: "plaintext",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90892,
                      src: "23374:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<=",
                    rightExpression: {
                      expression: {
                        arguments: [
                          {
                            id: 90904,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "23392:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_uint96_$",
                              typeString: "type(uint96)"
                            },
                            typeName: {
                              id: 90903,
                              name: "uint96",
                              nodeType: "ElementaryTypeName",
                              src: "23392:6:177",
                              typeDescriptions: {}
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_type$_t_uint96_$",
                              typeString: "type(uint96)"
                            }
                          ],
                          id: 90902,
                          name: "type",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -27,
                          src: "23387:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                            typeString: "function () pure"
                          }
                        },
                        id: 90905,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "23387:12:177",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_magic_meta_type_t_uint96",
                          typeString: "type(uint96)"
                        }
                      },
                      id: 90906,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "23400:3:177",
                      memberName: "max",
                      nodeType: "MemberAccess",
                      src: "23387:16:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    src: "23374:29:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90916,
                  nodeType: "IfStatement",
                  src: "23370:89:177",
                  trueBody: {
                    id: 90915,
                    nodeType: "Block",
                    src: "23405:54:177",
                    statements: [
                      {
                        expression: {
                          id: 90913,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 90908,
                            name: "amountOut",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 90899,
                            src: "23419:9:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 90911,
                                name: "plaintext",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 90892,
                                src: "23438:9:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              id: 90910,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "23431:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint96_$",
                                typeString: "type(uint96)"
                              },
                              typeName: {
                                id: 90909,
                                name: "uint96",
                                nodeType: "ElementaryTypeName",
                                src: "23431:6:177",
                                typeDescriptions: {}
                              }
                            },
                            id: 90912,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "23431:17:177",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "23419:29:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        id: 90914,
                        nodeType: "ExpressionStatement",
                        src: "23419:29:177"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 90922,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 90917,
                        name: "bidData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90884,
                        src: "23508:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                        }
                      },
                      id: 90919,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "23516:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83147,
                      src: "23508:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 90920,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83110,
                        src: "23525:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83110_$",
                          typeString: "type(enum IEncryptedMarginalPrice.BidStatus)"
                        }
                      },
                      id: 90921,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "23535:9:177",
                      memberName: "Decrypted",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83108,
                      src: "23525:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    src: "23508:36:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_BidStatus_$83110",
                      typeString: "enum IEncryptedMarginalPrice.BidStatus"
                    }
                  },
                  id: 90923,
                  nodeType: "ExpressionStatement",
                  src: "23508:36:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    },
                    id: 90926,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 90924,
                      name: "amountOut",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 90899,
                      src: "23781:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      hexValue: "30",
                      id: 90925,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "23793:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "23781:13:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 90986,
                  nodeType: "IfStatement",
                  src: "23777:995:177",
                  trueBody: {
                    id: 90985,
                    nodeType: "Block",
                    src: "23796:976:177",
                    statements: [
                      {
                        assignments: [90928],
                        declarations: [
                          {
                            constant: false,
                            id: 90928,
                            mutability: "mutable",
                            name: "price",
                            nameLocation: "24101:5:177",
                            nodeType: "VariableDeclaration",
                            scope: 90985,
                            src: "24093:13:177",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 90927,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "24093:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 90947,
                        initialValue: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  expression: {
                                    id: 90933,
                                    name: "bidData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90884,
                                    src: "24148:7:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                      typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                    }
                                  },
                                  id: 90934,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "24156:6:177",
                                  memberName: "amount",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83140,
                                  src: "24148:14:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                ],
                                id: 90932,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "24140:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint256_$",
                                  typeString: "type(uint256)"
                                },
                                typeName: {
                                  id: 90931,
                                  name: "uint256",
                                  nodeType: "ElementaryTypeName",
                                  src: "24140:7:177",
                                  typeDescriptions: {}
                                }
                              },
                              id: 90935,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "24140:23:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 90941,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                hexValue: "3130",
                                id: 90936,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "24165:2:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_rational_10_by_1",
                                  typeString: "int_const 10"
                                },
                                value: "10"
                              },
                              nodeType: "BinaryOperation",
                              operator: "**",
                              rightExpression: {
                                expression: {
                                  baseExpression: {
                                    id: 90937,
                                    name: "lotData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 87480,
                                    src: "24171:7:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                                      typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                                    }
                                  },
                                  id: 90939,
                                  indexExpression: {
                                    id: 90938,
                                    name: "lotId_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90873,
                                    src: "24179:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  },
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  nodeType: "IndexAccess",
                                  src: "24171:15:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_Lot_$82587_storage",
                                    typeString: "struct IAuction.Lot storage ref"
                                  }
                                },
                                id: 90940,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "24187:17:177",
                                memberName: "baseTokenDecimals",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 82578,
                                src: "24171:33:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint8",
                                  typeString: "uint8"
                                }
                              },
                              src: "24165:39:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              arguments: [
                                {
                                  id: 90944,
                                  name: "amountOut",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90899,
                                  src: "24214:9:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                ],
                                id: 90943,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "24206:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint256_$",
                                  typeString: "type(uint256)"
                                },
                                typeName: {
                                  id: 90942,
                                  name: "uint256",
                                  nodeType: "ElementaryTypeName",
                                  src: "24206:7:177",
                                  typeDescriptions: {}
                                }
                              },
                              id: 90945,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "24206:18:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              id: 90929,
                              name: "Math",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 55729,
                              src: "24109:4:177",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                typeString: "type(library FixedPointMathLib)"
                              }
                            },
                            id: 90930,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "24114:8:177",
                            memberName: "mulDivUp",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 55098,
                            src: "24109:13:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                              typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                            }
                          },
                          id: 90946,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "24109:129:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "24093:145:177"
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          },
                          id: 90964,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 90954,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 90948,
                              name: "price",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90928,
                              src: "24256:5:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "<",
                            rightExpression: {
                              expression: {
                                arguments: [
                                  {
                                    id: 90951,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "24269:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_uint96_$",
                                      typeString: "type(uint96)"
                                    },
                                    typeName: {
                                      id: 90950,
                                      name: "uint96",
                                      nodeType: "ElementaryTypeName",
                                      src: "24269:6:177",
                                      typeDescriptions: {}
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_type$_t_uint96_$",
                                      typeString: "type(uint96)"
                                    }
                                  ],
                                  id: 90949,
                                  name: "type",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -27,
                                  src: "24264:4:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                                    typeString: "function () pure"
                                  }
                                },
                                id: 90952,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "24264:12:177",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_meta_type_t_uint96",
                                  typeString: "type(uint96)"
                                }
                              },
                              id: 90953,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              memberLocation: "24277:3:177",
                              memberName: "max",
                              nodeType: "MemberAccess",
                              src: "24264:16:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            src: "24256:24:177",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "&&",
                          rightExpression: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 90963,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 90955,
                              name: "price",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 90928,
                              src: "24284:5:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: ">=",
                            rightExpression: {
                              arguments: [
                                {
                                  expression: {
                                    baseExpression: {
                                      id: 90958,
                                      name: "auctionData",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 89928,
                                      src: "24301:11:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                                        typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                                      }
                                    },
                                    id: 90960,
                                    indexExpression: {
                                      id: 90959,
                                      name: "lotId_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 90873,
                                      src: "24313:6:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "24301:19:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                                      typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                                    }
                                  },
                                  id: 90961,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "24321:8:177",
                                  memberName: "minPrice",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83123,
                                  src: "24301:28:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                id: 90957,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "24293:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint256_$",
                                  typeString: "type(uint256)"
                                },
                                typeName: {
                                  id: 90956,
                                  name: "uint256",
                                  nodeType: "ElementaryTypeName",
                                  src: "24293:7:177",
                                  typeDescriptions: {}
                                }
                              },
                              id: 90962,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "24293:37:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "24284:46:177",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          src: "24256:74:177",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 90984,
                        nodeType: "IfStatement",
                        src: "24252:510:177",
                        trueBody: {
                          id: 90983,
                          nodeType: "Block",
                          src: "24332:430:177",
                          statements: [
                            {
                              expression: {
                                arguments: [
                                  {
                                    id: 90969,
                                    name: "sortHint_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90877,
                                    src: "24499:9:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bytes32",
                                      typeString: "bytes32"
                                    }
                                  },
                                  {
                                    id: 90970,
                                    name: "bidId_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90875,
                                    src: "24510:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint64",
                                      typeString: "uint64"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 90971,
                                      name: "bidData",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 90884,
                                      src: "24518:7:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                        typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                      }
                                    },
                                    id: 90972,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "24526:6:177",
                                    memberName: "amount",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 83140,
                                    src: "24518:14:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  },
                                  {
                                    id: 90973,
                                    name: "amountOut",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90899,
                                    src: "24534:9:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  },
                                  {
                                    id: 90974,
                                    name: "baseScale_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90879,
                                    src: "24545:10:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_bytes32",
                                      typeString: "bytes32"
                                    },
                                    {
                                      typeIdentifier: "t_uint64",
                                      typeString: "uint64"
                                    },
                                    {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    },
                                    {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  ],
                                  expression: {
                                    baseExpression: {
                                      id: 90965,
                                      name: "decryptedBids",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 89962,
                                      src: "24449:13:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
                                        typeString: "mapping(uint96 => struct Queue storage ref)"
                                      }
                                    },
                                    id: 90967,
                                    indexExpression: {
                                      id: 90966,
                                      name: "lotId_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 90873,
                                      src: "24463:6:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "24449:21:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Queue_$84571_storage",
                                      typeString: "struct Queue storage ref"
                                    }
                                  },
                                  id: 90968,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "24471:6:177",
                                  memberName: "insert",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 84722,
                                  src: "24449:28:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_nonpayable$_t_struct$_Queue_$84571_storage_ptr_$_t_bytes32_$_t_uint64_$_t_uint96_$_t_uint96_$_t_uint256_$returns$__$attached_to$_t_struct$_Queue_$84571_storage_ptr_$",
                                    typeString: "function (struct Queue storage pointer,bytes32,uint64,uint96,uint96,uint256)"
                                  }
                                },
                                id: 90975,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "24449:124:177",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_tuple$__$",
                                  typeString: "tuple()"
                                }
                              },
                              id: 90976,
                              nodeType: "ExpressionStatement",
                              src: "24449:124:177"
                            },
                            {
                              expression: {
                                id: 90981,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 90977,
                                    name: "bidData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 90884,
                                    src: "24591:7:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                      typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                    }
                                  },
                                  id: 90979,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "24599:12:177",
                                  memberName: "minAmountOut",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83142,
                                  src: "24591:20:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  id: 90980,
                                  name: "amountOut",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 90899,
                                  src: "24614:9:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                },
                                src: "24591:32:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              id: 90982,
                              nodeType: "ExpressionStatement",
                              src: "24591:32:177"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 90988,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90873,
                        src: "24822:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90989,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90875,
                        src: "24830:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        expression: {
                          id: 90990,
                          name: "bidData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90884,
                          src: "24838:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                            typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                          }
                        },
                        id: 90991,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "24846:6:177",
                        memberName: "amount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83140,
                        src: "24838:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 90992,
                        name: "amountOut",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 90899,
                        src: "24854:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        },
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 90987,
                      name: "BidDecrypted",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83081,
                      src: "24809:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint96_$_t_uint64_$_t_uint96_$_t_uint96_$returns$__$",
                        typeString: "function (uint96,uint64,uint96,uint96)"
                      }
                    },
                    id: 90993,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "24809:55:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 90994,
                  nodeType: "EmitStatement",
                  src: "24804:60:177"
                }
              ]
            },
            documentation: {
              id: 90871,
              nodeType: "StructuredDocumentation",
              src: "22891:68:177",
              text: "@notice     Decrypts a bid and stores it in the sorted bid queue"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_decrypt",
            nameLocation: "22973:8:177",
            parameters: {
              id: 90880,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90873,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "22998:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90996,
                  src: "22991:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90872,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "22991:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90875,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "23021:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 90996,
                  src: "23014:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 90874,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "23014:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90877,
                  mutability: "mutable",
                  name: "sortHint_",
                  nameLocation: "23045:9:177",
                  nodeType: "VariableDeclaration",
                  scope: 90996,
                  src: "23037:17:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes32",
                    typeString: "bytes32"
                  },
                  typeName: {
                    id: 90876,
                    name: "bytes32",
                    nodeType: "ElementaryTypeName",
                    src: "23037:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes32",
                      typeString: "bytes32"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 90879,
                  mutability: "mutable",
                  name: "baseScale_",
                  nameLocation: "23072:10:177",
                  nodeType: "VariableDeclaration",
                  scope: 90996,
                  src: "23064:18:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 90878,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "23064:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "22981:107:177"
            },
            returnParameters: {
              id: 90881,
              nodeType: "ParameterList",
              parameters: [],
              src: "23098:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 91015,
            nodeType: "FunctionDefinition",
            src: "24921:153:177",
            nodes: [],
            body: {
              id: 91014,
              nodeType: "Block",
              src: "25015:59:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 91011,
                        name: "key_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91001,
                        src: "25062:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes32",
                          typeString: "bytes32"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes32",
                          typeString: "bytes32"
                        }
                      ],
                      expression: {
                        baseExpression: {
                          id: 91007,
                          name: "decryptedBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89962,
                          src: "25032:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
                            typeString: "mapping(uint96 => struct Queue storage ref)"
                          }
                        },
                        id: 91009,
                        indexExpression: {
                          id: 91008,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 90999,
                          src: "25046:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "25032:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Queue_$84571_storage",
                          typeString: "struct Queue storage ref"
                        }
                      },
                      id: 91010,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "25054:7:177",
                      memberName: "getNext",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 84814,
                      src: "25032:29:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_struct$_Queue_$84571_storage_ptr_$_t_bytes32_$returns$_t_bytes32_$attached_to$_t_struct$_Queue_$84571_storage_ptr_$",
                        typeString: "function (struct Queue storage pointer,bytes32) view returns (bytes32)"
                      }
                    },
                    id: 91012,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "25032:35:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_bytes32",
                      typeString: "bytes32"
                    }
                  },
                  functionReturnParameters: 91006,
                  id: 91013,
                  nodeType: "Return",
                  src: "25025:42:177"
                }
              ]
            },
            baseFunctions: [83205],
            documentation: {
              id: 90997,
              nodeType: "StructuredDocumentation",
              src: "24877:39:177",
              text: "@inheritdoc IEncryptedMarginalPrice"
            },
            functionSelector: "8bde6109",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getNextInQueue",
            nameLocation: "24930:14:177",
            overrides: {
              id: 91003,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "24988:8:177"
            },
            parameters: {
              id: 91002,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 90999,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "24952:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91015,
                  src: "24945:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 90998,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "24945:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91001,
                  mutability: "mutable",
                  name: "key_",
                  nameLocation: "24968:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 91015,
                  src: "24960:12:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes32",
                    typeString: "bytes32"
                  },
                  typeName: {
                    id: 91e3,
                    name: "bytes32",
                    nodeType: "ElementaryTypeName",
                    src: "24960:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes32",
                      typeString: "bytes32"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "24944:29:177"
            },
            returnParameters: {
              id: 91006,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91005,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 91015,
                  src: "25006:7:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes32",
                    typeString: "bytes32"
                  },
                  typeName: {
                    id: 91004,
                    name: "bytes32",
                    nodeType: "ElementaryTypeName",
                    src: "25006:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes32",
                      typeString: "bytes32"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "25005:9:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 91031,
            nodeType: "FunctionDefinition",
            src: "25124:141:177",
            nodes: [],
            body: {
              id: 91030,
              nodeType: "Block",
              src: "25207:58:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        baseExpression: {
                          id: 91024,
                          name: "decryptedBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89962,
                          src: "25224:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
                            typeString: "mapping(uint96 => struct Queue storage ref)"
                          }
                        },
                        id: 91026,
                        indexExpression: {
                          id: 91025,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91018,
                          src: "25238:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "25224:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Queue_$84571_storage",
                          typeString: "struct Queue storage ref"
                        }
                      },
                      id: 91027,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "25246:10:177",
                      memberName: "getNumBids",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 84827,
                      src: "25224:32:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_struct$_Queue_$84571_storage_ptr_$returns$_t_uint256_$attached_to$_t_struct$_Queue_$84571_storage_ptr_$",
                        typeString: "function (struct Queue storage pointer) view returns (uint256)"
                      }
                    },
                    id: 91028,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "25224:34:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 91023,
                  id: 91029,
                  nodeType: "Return",
                  src: "25217:41:177"
                }
              ]
            },
            baseFunctions: [83213],
            documentation: {
              id: 91016,
              nodeType: "StructuredDocumentation",
              src: "25080:39:177",
              text: "@inheritdoc IEncryptedMarginalPrice"
            },
            functionSelector: "0cf5538d",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getNumBidsInQueue",
            nameLocation: "25133:17:177",
            overrides: {
              id: 91020,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "25180:8:177"
            },
            parameters: {
              id: 91019,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91018,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "25158:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91031,
                  src: "25151:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91017,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "25151:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "25150:15:177"
            },
            returnParameters: {
              id: 91023,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91022,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 91031,
                  src: "25198:7:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91021,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "25198:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "25197:9:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 91086,
            nodeType: "FunctionDefinition",
            src: "25936:800:177",
            nodes: [],
            body: {
              id: 91085,
              nodeType: "Block",
              src: "26086:650:177",
              nodes: [],
              statements: [
                {
                  assignments: [91047],
                  declarations: [
                    {
                      constant: false,
                      id: 91047,
                      mutability: "mutable",
                      name: "minAmountOut",
                      nameLocation: "26151:12:177",
                      nodeType: "VariableDeclaration",
                      scope: 91085,
                      src: "26144:19:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      },
                      typeName: {
                        id: 91046,
                        name: "uint96",
                        nodeType: "ElementaryTypeName",
                        src: "26144:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91048,
                  nodeType: "VariableDeclarationStatement",
                  src: "26144:19:177"
                },
                {
                  expression: {
                    id: 91056,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      components: [
                        {
                          id: 91049,
                          name: "bidId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91040,
                          src: "26174:5:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        {
                          id: 91050,
                          name: "amountIn",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91042,
                          src: "26181:8:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          id: 91051,
                          name: "minAmountOut",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91047,
                          src: "26191:12:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        }
                      ],
                      id: 91052,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "TupleExpression",
                      src: "26173:31:177",
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_uint64_$_t_uint256_$_t_uint96_$",
                        typeString: "tuple(uint64,uint256,uint96)"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        expression: {
                          id: 91053,
                          name: "queue_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91035,
                          src: "26207:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                            typeString: "struct Queue storage pointer"
                          }
                        },
                        id: 91054,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "26214:6:177",
                        memberName: "delMax",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 84776,
                        src: "26207:13:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_nonpayable$_t_struct$_Queue_$84571_storage_ptr_$returns$_t_uint64_$_t_uint96_$_t_uint96_$attached_to$_t_struct$_Queue_$84571_storage_ptr_$",
                          typeString: "function (struct Queue storage pointer) returns (uint64,uint96,uint96)"
                        }
                      },
                      id: 91055,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "26207:15:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_uint64_$_t_uint96_$_t_uint96_$",
                        typeString: "tuple(uint64,uint96,uint96)"
                      }
                    },
                    src: "26173:49:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91057,
                  nodeType: "ExpressionStatement",
                  src: "26173:49:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    },
                    id: 91060,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 91058,
                      name: "minAmountOut",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91047,
                      src: "26418:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 91059,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "26434:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "26418:17:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91067,
                  nodeType: "IfStatement",
                  src: "26414:155:177",
                  trueBody: {
                    id: 91066,
                    nodeType: "Block",
                    src: "26437:132:177",
                    statements: [
                      {
                        expression: {
                          components: [
                            {
                              id: 91061,
                              name: "bidId",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91040,
                              src: "26539:5:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            {
                              id: 91062,
                              name: "amountIn",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91042,
                              src: "26546:8:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "30",
                              id: 91063,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "26556:1:177",
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              },
                              value: "0"
                            }
                          ],
                          id: 91064,
                          isConstant: false,
                          isInlineArray: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "TupleExpression",
                          src: "26538:20:177",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_uint64_$_t_uint256_$_t_rational_0_by_1_$",
                            typeString: "tuple(uint64,uint256,int_const 0)"
                          }
                        },
                        functionReturnParameters: 91045,
                        id: 91065,
                        nodeType: "Return",
                        src: "26531:27:177"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 91078,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 91068,
                      name: "price",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91044,
                      src: "26621:5:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 91071,
                          name: "amountIn",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91042,
                          src: "26643:8:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          id: 91072,
                          name: "baseScale_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91037,
                          src: "26653:10:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          arguments: [
                            {
                              id: 91075,
                              name: "minAmountOut",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91047,
                              src: "26673:12:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 91074,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "26665:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_uint256_$",
                              typeString: "type(uint256)"
                            },
                            typeName: {
                              id: 91073,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "26665:7:177",
                              typeDescriptions: {}
                            }
                          },
                          id: 91076,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "26665:21:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        expression: {
                          id: 91069,
                          name: "Math",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 55729,
                          src: "26629:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                            typeString: "type(library FixedPointMathLib)"
                          }
                        },
                        id: 91070,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "26634:8:177",
                        memberName: "mulDivUp",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 55098,
                        src: "26629:13:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 91077,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "26629:58:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "26621:66:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 91079,
                  nodeType: "ExpressionStatement",
                  src: "26621:66:177"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 91080,
                        name: "bidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91040,
                        src: "26706:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      {
                        id: 91081,
                        name: "amountIn",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91042,
                        src: "26713:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 91082,
                        name: "price",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91044,
                        src: "26723:5:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    id: 91083,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "26705:24:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint64_$_t_uint256_$_t_uint256_$",
                      typeString: "tuple(uint64,uint256,uint256)"
                    }
                  },
                  functionReturnParameters: 91045,
                  id: 91084,
                  nodeType: "Return",
                  src: "26698:31:177"
                }
              ]
            },
            documentation: {
              id: 91032,
              nodeType: "StructuredDocumentation",
              src: "25315:616:177",
              text: "@notice         Helper function to get the next bid from the queue and calculate the price\n @dev            This is split into a different function to avoid stack too deep errors\n @param          queue_          The queue to get the next bid from\n @param          baseScale_      The scaling factor for the base token\n @return         bidId           The ID of the bid\n @return         amountIn        The amount in of the bid (in quote token units)\n @return         price           The price of the bid (in quote token units), or 0 if it could not be determined"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_getNextBid",
            nameLocation: "25945:11:177",
            parameters: {
              id: 91038,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91035,
                  mutability: "mutable",
                  name: "queue_",
                  nameLocation: "25980:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91086,
                  src: "25966:20:177",
                  stateVariable: false,
                  storageLocation: "storage",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                    typeString: "struct Queue"
                  },
                  typeName: {
                    id: 91034,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91033,
                      name: "Queue",
                      nameLocations: ["25966:5:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 84571,
                      src: "25966:5:177"
                    },
                    referencedDeclaration: 84571,
                    src: "25966:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                      typeString: "struct Queue"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91037,
                  mutability: "mutable",
                  name: "baseScale_",
                  nameLocation: "26004:10:177",
                  nodeType: "VariableDeclaration",
                  scope: 91086,
                  src: "25996:18:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91036,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "25996:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "25956:64:177"
            },
            returnParameters: {
              id: 91045,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91040,
                  mutability: "mutable",
                  name: "bidId",
                  nameLocation: "26046:5:177",
                  nodeType: "VariableDeclaration",
                  scope: 91086,
                  src: "26039:12:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 91039,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "26039:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91042,
                  mutability: "mutable",
                  name: "amountIn",
                  nameLocation: "26061:8:177",
                  nodeType: "VariableDeclaration",
                  scope: 91086,
                  src: "26053:16:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91041,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "26053:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91044,
                  mutability: "mutable",
                  name: "price",
                  nameLocation: "26079:5:177",
                  nodeType: "VariableDeclaration",
                  scope: 91086,
                  src: "26071:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91043,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "26071:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "26038:47:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 91442,
            nodeType: "FunctionDefinition",
            src: "26988:6816:177",
            nodes: [],
            body: {
              id: 91441,
              nodeType: "Block",
              src: "27122:6682:177",
              nodes: [],
              statements: [
                {
                  assignments: [91098],
                  declarations: [
                    {
                      constant: false,
                      id: 91098,
                      mutability: "mutable",
                      name: "capacity",
                      nameLocation: "27253:8:177",
                      nodeType: "VariableDeclaration",
                      scope: 91441,
                      src: "27245:16:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91097,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "27245:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91103,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 91099,
                        name: "lotData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 87480,
                        src: "27264:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                          typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                        }
                      },
                      id: 91101,
                      indexExpression: {
                        id: 91100,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91089,
                        src: "27272:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "27264:15:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Lot_$82587_storage",
                        typeString: "struct IAuction.Lot storage ref"
                      }
                    },
                    id: 91102,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "27280:8:177",
                    memberName: "capacity",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 82582,
                    src: "27264:24:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27245:43:177"
                },
                {
                  assignments: [91105],
                  declarations: [
                    {
                      constant: false,
                      id: 91105,
                      mutability: "mutable",
                      name: "baseScale",
                      nameLocation: "27306:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 91441,
                      src: "27298:17:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91104,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "27298:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91112,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91111,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      hexValue: "3130",
                      id: 91106,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "27318:2:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_10_by_1",
                        typeString: "int_const 10"
                      },
                      value: "10"
                    },
                    nodeType: "BinaryOperation",
                    operator: "**",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 91107,
                          name: "lotData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87480,
                          src: "27324:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                            typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                          }
                        },
                        id: 91109,
                        indexExpression: {
                          id: 91108,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91089,
                          src: "27332:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "27324:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Lot_$82587_storage",
                          typeString: "struct IAuction.Lot storage ref"
                        }
                      },
                      id: 91110,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "27340:17:177",
                      memberName: "baseTokenDecimals",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82578,
                      src: "27324:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint8",
                        typeString: "uint8"
                      }
                    },
                    src: "27318:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27298:59:177"
                },
                {
                  assignments: [91115],
                  declarations: [
                    {
                      constant: false,
                      id: 91115,
                      mutability: "mutable",
                      name: "lotAuctionData",
                      nameLocation: "27386:14:177",
                      nodeType: "VariableDeclaration",
                      scope: 91441,
                      src: "27367:33:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_memory_ptr",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData"
                      },
                      typeName: {
                        id: 91114,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 91113,
                          name: "AuctionData",
                          nameLocations: ["27367:11:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83136,
                          src: "27367:11:177"
                        },
                        referencedDeclaration: 83136,
                        src: "27367:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91119,
                  initialValue: {
                    baseExpression: {
                      id: 91116,
                      name: "auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89928,
                      src: "27403:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                        typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                      }
                    },
                    id: 91118,
                    indexExpression: {
                      id: 91117,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91089,
                      src: "27415:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "27403:19:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                      typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27367:55:177"
                },
                {
                  id: 91438,
                  nodeType: "Block",
                  src: "27552:6222:177",
                  statements: [
                    {
                      assignments: [91121],
                      declarations: [
                        {
                          constant: false,
                          id: 91121,
                          mutability: "mutable",
                          name: "lastPrice",
                          nameLocation: "27574:9:177",
                          nodeType: "VariableDeclaration",
                          scope: 91438,
                          src: "27566:17:177",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          typeName: {
                            id: 91120,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "27566:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 91126,
                      initialValue: {
                        expression: {
                          baseExpression: {
                            id: 91122,
                            name: "_lotPartialSettlement",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89940,
                            src: "27586:21:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                              typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                            }
                          },
                          id: 91124,
                          indexExpression: {
                            id: 91123,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91089,
                            src: "27608:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "27586:29:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                            typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                          }
                        },
                        id: 91125,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "27616:9:177",
                        memberName: "lastPrice",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89919,
                        src: "27586:39:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "27566:59:177"
                    },
                    {
                      expression: {
                        id: 91134,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          expression: {
                            id: 91127,
                            name: "result",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91095,
                            src: "27692:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                            }
                          },
                          id: 91129,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: true,
                          memberLocation: "27699:13:177",
                          memberName: "totalAmountIn",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 89910,
                          src: "27692:20:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "=",
                        rightHandSide: {
                          expression: {
                            baseExpression: {
                              id: 91130,
                              name: "_lotPartialSettlement",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89940,
                              src: "27715:21:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                                typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                              }
                            },
                            id: 91132,
                            indexExpression: {
                              id: 91131,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91089,
                              src: "27737:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "27715:29:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                              typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                            }
                          },
                          id: 91133,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "27745:17:177",
                          memberName: "processedAmountIn",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 89917,
                          src: "27715:47:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "27692:70:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 91135,
                      nodeType: "ExpressionStatement",
                      src: "27692:70:177"
                    },
                    {
                      expression: {
                        id: 91153,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          expression: {
                            id: 91136,
                            name: "result",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91095,
                            src: "27776:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                            }
                          },
                          id: 91138,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: true,
                          memberLocation: "27783:16:177",
                          memberName: "capacityExpended",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 89912,
                          src: "27776:23:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "=",
                        rightHandSide: {
                          condition: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 91141,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 91139,
                              name: "lastPrice",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91121,
                              src: "27802:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "==",
                            rightExpression: {
                              hexValue: "30",
                              id: 91140,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "number",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "27815:1:177",
                              typeDescriptions: {
                                typeIdentifier: "t_rational_0_by_1",
                                typeString: "int_const 0"
                              },
                              value: "0"
                            },
                            src: "27802:14:177",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          falseExpression: {
                            arguments: [
                              {
                                expression: {
                                  baseExpression: {
                                    id: 91145,
                                    name: "_lotPartialSettlement",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 89940,
                                    src: "27871:21:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                                      typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                                    }
                                  },
                                  id: 91147,
                                  indexExpression: {
                                    id: 91146,
                                    name: "lotId_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91089,
                                    src: "27893:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  },
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  nodeType: "IndexAccess",
                                  src: "27871:29:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                                    typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                                  }
                                },
                                id: 91148,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "27901:17:177",
                                memberName: "processedAmountIn",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89917,
                                src: "27871:47:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              {
                                id: 91149,
                                name: "baseScale",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91105,
                                src: "27920:9:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              {
                                id: 91150,
                                name: "lastPrice",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91121,
                                src: "27931:9:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              expression: {
                                id: 91143,
                                name: "Math",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 55729,
                                src: "27855:4:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                  typeString: "type(library FixedPointMathLib)"
                                }
                              },
                              id: 91144,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "27860:10:177",
                              memberName: "fullMulDiv",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 55048,
                              src: "27855:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 91151,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "27855:86:177",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 91152,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "Conditional",
                          src: "27802:139:177",
                          trueExpression: {
                            hexValue: "30",
                            id: 91142,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "27835:1:177",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "27776:165:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 91154,
                      nodeType: "ExpressionStatement",
                      src: "27776:165:177"
                    },
                    {
                      assignments: [91157],
                      declarations: [
                        {
                          constant: false,
                          id: 91157,
                          mutability: "mutable",
                          name: "queue",
                          nameLocation: "27970:5:177",
                          nodeType: "VariableDeclaration",
                          scope: 91438,
                          src: "27956:19:177",
                          stateVariable: false,
                          storageLocation: "storage",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                            typeString: "struct Queue"
                          },
                          typeName: {
                            id: 91156,
                            nodeType: "UserDefinedTypeName",
                            pathNode: {
                              id: 91155,
                              name: "Queue",
                              nameLocations: ["27956:5:177"],
                              nodeType: "IdentifierPath",
                              referencedDeclaration: 84571,
                              src: "27956:5:177"
                            },
                            referencedDeclaration: 84571,
                            src: "27956:5:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                              typeString: "struct Queue"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 91161,
                      initialValue: {
                        baseExpression: {
                          id: 91158,
                          name: "decryptedBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89962,
                          src: "27978:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Queue_$84571_storage_$",
                            typeString: "mapping(uint96 => struct Queue storage ref)"
                          }
                        },
                        id: 91160,
                        indexExpression: {
                          id: 91159,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91089,
                          src: "27992:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "27978:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Queue_$84571_storage",
                          typeString: "struct Queue storage ref"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "27956:43:177"
                    },
                    {
                      assignments: [91163],
                      declarations: [
                        {
                          constant: false,
                          id: 91163,
                          mutability: "mutable",
                          name: "lastBidId",
                          nameLocation: "28021:9:177",
                          nodeType: "VariableDeclaration",
                          scope: 91438,
                          src: "28014:16:177",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          },
                          typeName: {
                            id: 91162,
                            name: "uint64",
                            nodeType: "ElementaryTypeName",
                            src: "28014:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 91168,
                      initialValue: {
                        expression: {
                          baseExpression: {
                            id: 91164,
                            name: "_lotPartialSettlement",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89940,
                            src: "28033:21:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                              typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                            }
                          },
                          id: 91166,
                          indexExpression: {
                            id: 91165,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91089,
                            src: "28055:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "28033:29:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                            typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                          }
                        },
                        id: 91167,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "28063:9:177",
                        memberName: "lastBidId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89921,
                        src: "28033:39:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "28014:58:177"
                    },
                    {
                      assignments: [91170],
                      declarations: [
                        {
                          constant: false,
                          id: 91170,
                          mutability: "mutable",
                          name: "numBids",
                          nameLocation: "28094:7:177",
                          nodeType: "VariableDeclaration",
                          scope: 91438,
                          src: "28086:15:177",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          typeName: {
                            id: 91169,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "28086:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 91174,
                      initialValue: {
                        arguments: [],
                        expression: {
                          argumentTypes: [],
                          expression: {
                            id: 91171,
                            name: "queue",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91157,
                            src: "28104:5:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                              typeString: "struct Queue storage pointer"
                            }
                          },
                          id: 91172,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "28110:10:177",
                          memberName: "getNumBids",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 84827,
                          src: "28104:16:177",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$_t_struct$_Queue_$84571_storage_ptr_$returns$_t_uint256_$attached_to$_t_struct$_Queue_$84571_storage_ptr_$",
                            typeString: "function (struct Queue storage pointer) view returns (uint256)"
                          }
                        },
                        id: 91173,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "28104:18:177",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "28086:36:177"
                    },
                    {
                      condition: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 91177,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 91175,
                          name: "numBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91170,
                          src: "28140:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          hexValue: "30",
                          id: 91176,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "28151:1:177",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        },
                        src: "28140:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      id: 91187,
                      nodeType: "IfStatement",
                      src: "28136:263:177",
                      trueBody: {
                        id: 91186,
                        nodeType: "Block",
                        src: "28154:245:177",
                        statements: [
                          {
                            expression: {
                              id: 91182,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 91178,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "28331:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91180,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "28338:8:177",
                                memberName: "finished",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89914,
                                src: "28331:15:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_bool",
                                  typeString: "bool"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                hexValue: "74727565",
                                id: 91181,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "bool",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "28349:4:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_bool",
                                  typeString: "bool"
                                },
                                value: "true"
                              },
                              src: "28331:22:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            id: 91183,
                            nodeType: "ExpressionStatement",
                            src: "28331:22:177"
                          },
                          {
                            expression: {
                              id: 91184,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91095,
                              src: "28378:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            functionReturnParameters: 91096,
                            id: 91185,
                            nodeType: "Return",
                            src: "28371:13:177"
                          }
                        ]
                      }
                    },
                    {
                      assignments: [91189],
                      declarations: [
                        {
                          constant: false,
                          id: 91189,
                          mutability: "mutable",
                          name: "last",
                          nameLocation: "28417:4:177",
                          nodeType: "VariableDeclaration",
                          scope: 91438,
                          src: "28412:9:177",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          },
                          typeName: {
                            id: 91188,
                            name: "bool",
                            nodeType: "ElementaryTypeName",
                            src: "28412:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 91193,
                      initialValue: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 91192,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 91190,
                          name: "numBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91170,
                          src: "28424:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "<=",
                        rightExpression: {
                          id: 91191,
                          name: "num_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91091,
                          src: "28435:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "28424:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "28412:27:177"
                    },
                    {
                      expression: {
                        id: 91201,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          id: 91194,
                          name: "numBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91170,
                          src: "28453:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "=",
                        rightHandSide: {
                          condition: {
                            commonType: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            id: 91197,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              id: 91195,
                              name: "numBids",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91170,
                              src: "28463:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: ">",
                            rightExpression: {
                              id: 91196,
                              name: "num_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91091,
                              src: "28473:4:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "28463:14:177",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          falseExpression: {
                            id: 91199,
                            name: "numBids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91170,
                            src: "28487:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 91200,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "Conditional",
                          src: "28463:31:177",
                          trueExpression: {
                            id: 91198,
                            name: "num_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91091,
                            src: "28480:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "28453:41:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 91202,
                      nodeType: "ExpressionStatement",
                      src: "28453:41:177"
                    },
                    {
                      body: {
                        id: 91436,
                        nodeType: "Block",
                        src: "28546:5218:177",
                        statements: [
                          {
                            assignments: [91214, 91216, 91218],
                            declarations: [
                              {
                                constant: false,
                                id: 91214,
                                mutability: "mutable",
                                name: "bidId",
                                nameLocation: "28926:5:177",
                                nodeType: "VariableDeclaration",
                                scope: 91436,
                                src: "28919:12:177",
                                stateVariable: false,
                                storageLocation: "default",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                },
                                typeName: {
                                  id: 91213,
                                  name: "uint64",
                                  nodeType: "ElementaryTypeName",
                                  src: "28919:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint64",
                                    typeString: "uint64"
                                  }
                                },
                                visibility: "internal"
                              },
                              {
                                constant: false,
                                id: 91216,
                                mutability: "mutable",
                                name: "amountIn",
                                nameLocation: "28941:8:177",
                                nodeType: "VariableDeclaration",
                                scope: 91436,
                                src: "28933:16:177",
                                stateVariable: false,
                                storageLocation: "default",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                typeName: {
                                  id: 91215,
                                  name: "uint256",
                                  nodeType: "ElementaryTypeName",
                                  src: "28933:7:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                visibility: "internal"
                              },
                              {
                                constant: false,
                                id: 91218,
                                mutability: "mutable",
                                name: "price",
                                nameLocation: "28959:5:177",
                                nodeType: "VariableDeclaration",
                                scope: 91436,
                                src: "28951:13:177",
                                stateVariable: false,
                                storageLocation: "default",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                typeName: {
                                  id: 91217,
                                  name: "uint256",
                                  nodeType: "ElementaryTypeName",
                                  src: "28951:7:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                visibility: "internal"
                              }
                            ],
                            id: 91223,
                            initialValue: {
                              arguments: [
                                {
                                  id: 91220,
                                  name: "queue",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91157,
                                  src: "28980:5:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                                    typeString: "struct Queue storage pointer"
                                  }
                                },
                                {
                                  id: 91221,
                                  name: "baseScale",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91105,
                                  src: "28987:9:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_struct$_Queue_$84571_storage_ptr",
                                    typeString: "struct Queue storage pointer"
                                  },
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                id: 91219,
                                name: "_getNextBid",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91086,
                                src: "28968:11:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_internal_nonpayable$_t_struct$_Queue_$84571_storage_ptr_$_t_uint256_$returns$_t_uint64_$_t_uint256_$_t_uint256_$",
                                  typeString: "function (struct Queue storage pointer,uint256) returns (uint64,uint256,uint256)"
                                }
                              },
                              id: 91222,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "28968:29:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_tuple$_t_uint64_$_t_uint256_$_t_uint256_$",
                                typeString: "tuple(uint64,uint256,uint256)"
                              }
                            },
                            nodeType: "VariableDeclarationStatement",
                            src: "28918:79:177"
                          },
                          {
                            expression: {
                              id: 91228,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 91224,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "29109:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91226,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "29116:9:177",
                                memberName: "lastBidId",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89906,
                                src: "29109:16:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                id: 91227,
                                name: "bidId",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91214,
                                src: "29128:5:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              src: "29109:24:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            id: 91229,
                            nodeType: "ExpressionStatement",
                            src: "29109:24:177"
                          },
                          {
                            expression: {
                              id: 91234,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 91230,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "29151:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91232,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "29158:12:177",
                                memberName: "lastBidPrice",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89908,
                                src: "29151:19:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                id: 91233,
                                name: "price",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91218,
                                src: "29173:5:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "29151:27:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 91235,
                            nodeType: "ExpressionStatement",
                            src: "29151:27:177"
                          },
                          {
                            expression: {
                              id: 91246,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 91236,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "29512:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91238,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "29519:16:177",
                                memberName: "capacityExpended",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89912,
                                src: "29512:23:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                arguments: [
                                  {
                                    expression: {
                                      id: 91241,
                                      name: "result",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91095,
                                      src: "29554:6:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                        typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                      }
                                    },
                                    id: 91242,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "29561:13:177",
                                    memberName: "totalAmountIn",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 89910,
                                    src: "29554:20:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  {
                                    id: 91243,
                                    name: "baseScale",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91105,
                                    src: "29576:9:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  {
                                    id: 91244,
                                    name: "price",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91218,
                                    src: "29587:5:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  ],
                                  expression: {
                                    id: 91239,
                                    name: "Math",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 55729,
                                    src: "29538:4:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                      typeString: "type(library FixedPointMathLib)"
                                    }
                                  },
                                  id: 91240,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "29543:10:177",
                                  memberName: "fullMulDiv",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 55048,
                                  src: "29538:15:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                    typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                  }
                                },
                                id: 91245,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "29538:55:177",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "29512:81:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 91247,
                            nodeType: "ExpressionStatement",
                            src: "29512:81:177"
                          },
                          {
                            condition: {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 91251,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                expression: {
                                  id: 91248,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "29615:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91249,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "29622:16:177",
                                memberName: "capacityExpended",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89912,
                                src: "29615:23:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: ">=",
                              rightExpression: {
                                id: 91250,
                                name: "capacity",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91098,
                                src: "29642:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "29615:35:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            id: 91307,
                            nodeType: "IfStatement",
                            src: "29611:1392:177",
                            trueBody: {
                              id: 91306,
                              nodeType: "Block",
                              src: "29652:1351:177",
                              statements: [
                                {
                                  expression: {
                                    id: 91262,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91252,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "29674:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91254,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "29681:13:177",
                                      memberName: "marginalPrice",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89902,
                                      src: "29674:20:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      arguments: [
                                        {
                                          expression: {
                                            id: 91257,
                                            name: "result",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91095,
                                            src: "29739:6:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                            }
                                          },
                                          id: 91258,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "29746:13:177",
                                          memberName: "totalAmountIn",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 89910,
                                          src: "29739:20:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        {
                                          id: 91259,
                                          name: "baseScale",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 91105,
                                          src: "29761:9:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        {
                                          id: 91260,
                                          name: "capacity",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 91098,
                                          src: "29772:8:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        }
                                      ],
                                      expression: {
                                        argumentTypes: [
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          },
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          },
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        ],
                                        expression: {
                                          id: 91255,
                                          name: "Math",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 55729,
                                          src: "29721:4:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                            typeString: "type(library FixedPointMathLib)"
                                          }
                                        },
                                        id: 91256,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        memberLocation: "29726:12:177",
                                        memberName: "fullMulDivUp",
                                        nodeType: "MemberAccess",
                                        referencedDeclaration: 55070,
                                        src: "29721:17:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                        }
                                      },
                                      id: 91261,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      kind: "functionCall",
                                      lValueRequested: false,
                                      nameLocations: [],
                                      names: [],
                                      nodeType: "FunctionCall",
                                      src: "29721:60:177",
                                      tryCall: false,
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "29674:107:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  id: 91263,
                                  nodeType: "ExpressionStatement",
                                  src: "29674:107:177"
                                },
                                {
                                  condition: {
                                    commonType: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    id: 91267,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftExpression: {
                                      id: 91264,
                                      name: "lastPrice",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91121,
                                      src: "30130:9:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "BinaryOperation",
                                    operator: "==",
                                    rightExpression: {
                                      expression: {
                                        id: 91265,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "30143:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91266,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "30150:13:177",
                                      memberName: "marginalPrice",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89902,
                                      src: "30143:20:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "30130:33:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  },
                                  falseBody: {
                                    id: 91284,
                                    nodeType: "Block",
                                    src: "30252:207:177",
                                    statements: [
                                      {
                                        expression: {
                                          id: 91282,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: false,
                                          lValueRequested: false,
                                          leftHandSide: {
                                            expression: {
                                              id: 91275,
                                              name: "result",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91095,
                                              src: "30278:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                              }
                                            },
                                            id: 91277,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            memberLocation: "30285:13:177",
                                            memberName: "marginalBidId",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 89904,
                                            src: "30278:20:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint64",
                                              typeString: "uint64"
                                            }
                                          },
                                          nodeType: "Assignment",
                                          operator: "=",
                                          rightHandSide: {
                                            arguments: [
                                              {
                                                hexValue: "30",
                                                id: 91280,
                                                isConstant: false,
                                                isLValue: false,
                                                isPure: true,
                                                kind: "number",
                                                lValueRequested: false,
                                                nodeType: "Literal",
                                                src: "30308:1:177",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_rational_0_by_1",
                                                  typeString: "int_const 0"
                                                },
                                                value: "0"
                                              }
                                            ],
                                            expression: {
                                              argumentTypes: [
                                                {
                                                  typeIdentifier: "t_rational_0_by_1",
                                                  typeString: "int_const 0"
                                                }
                                              ],
                                              id: 91279,
                                              isConstant: false,
                                              isLValue: false,
                                              isPure: true,
                                              lValueRequested: false,
                                              nodeType: "ElementaryTypeNameExpression",
                                              src: "30301:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_type$_t_uint64_$",
                                                typeString: "type(uint64)"
                                              },
                                              typeName: {
                                                id: 91278,
                                                name: "uint64",
                                                nodeType: "ElementaryTypeName",
                                                src: "30301:6:177",
                                                typeDescriptions: {}
                                              }
                                            },
                                            id: 91281,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: true,
                                            kind: "typeConversion",
                                            lValueRequested: false,
                                            nameLocations: [],
                                            names: [],
                                            nodeType: "FunctionCall",
                                            src: "30301:9:177",
                                            tryCall: false,
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint64",
                                              typeString: "uint64"
                                            }
                                          },
                                          src: "30278:32:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint64",
                                            typeString: "uint64"
                                          }
                                        },
                                        id: 91283,
                                        nodeType: "ExpressionStatement",
                                        src: "30278:32:177"
                                      }
                                    ]
                                  },
                                  id: 91285,
                                  nodeType: "IfStatement",
                                  src: "30126:333:177",
                                  trueBody: {
                                    id: 91274,
                                    nodeType: "Block",
                                    src: "30165:81:177",
                                    statements: [
                                      {
                                        expression: {
                                          id: 91272,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: false,
                                          lValueRequested: false,
                                          leftHandSide: {
                                            expression: {
                                              id: 91268,
                                              name: "result",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91095,
                                              src: "30191:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                              }
                                            },
                                            id: 91270,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            memberLocation: "30198:13:177",
                                            memberName: "marginalBidId",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 89904,
                                            src: "30191:20:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint64",
                                              typeString: "uint64"
                                            }
                                          },
                                          nodeType: "Assignment",
                                          operator: "=",
                                          rightHandSide: {
                                            id: 91271,
                                            name: "lastBidId",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91163,
                                            src: "30214:9:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint64",
                                              typeString: "uint64"
                                            }
                                          },
                                          src: "30191:32:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint64",
                                            typeString: "uint64"
                                          }
                                        },
                                        id: 91273,
                                        nodeType: "ExpressionStatement",
                                        src: "30191:32:177"
                                      }
                                    ]
                                  }
                                },
                                {
                                  expression: {
                                    id: 91297,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91286,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "30754:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91288,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "30761:16:177",
                                      memberName: "capacityExpended",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89912,
                                      src: "30754:23:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      arguments: [
                                        {
                                          expression: {
                                            id: 91291,
                                            name: "result",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91095,
                                            src: "30820:6:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                            }
                                          },
                                          id: 91292,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "30827:13:177",
                                          memberName: "totalAmountIn",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 89910,
                                          src: "30820:20:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        {
                                          id: 91293,
                                          name: "baseScale",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 91105,
                                          src: "30842:9:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        {
                                          expression: {
                                            id: 91294,
                                            name: "result",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91095,
                                            src: "30853:6:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                            }
                                          },
                                          id: 91295,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "30860:13:177",
                                          memberName: "marginalPrice",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 89902,
                                          src: "30853:20:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        }
                                      ],
                                      expression: {
                                        argumentTypes: [
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          },
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          },
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        ],
                                        expression: {
                                          id: 91289,
                                          name: "Math",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 55729,
                                          src: "30804:4:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                            typeString: "type(library FixedPointMathLib)"
                                          }
                                        },
                                        id: 91290,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        memberLocation: "30809:10:177",
                                        memberName: "fullMulDiv",
                                        nodeType: "MemberAccess",
                                        referencedDeclaration: 55048,
                                        src: "30804:15:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                        }
                                      },
                                      id: 91296,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      kind: "functionCall",
                                      lValueRequested: false,
                                      nameLocations: [],
                                      names: [],
                                      nodeType: "FunctionCall",
                                      src: "30804:70:177",
                                      tryCall: false,
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "30754:120:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  id: 91298,
                                  nodeType: "ExpressionStatement",
                                  src: "30754:120:177"
                                },
                                {
                                  expression: {
                                    id: 91303,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91299,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "30935:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91301,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "30942:8:177",
                                      memberName: "finished",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89914,
                                      src: "30935:15:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      hexValue: "74727565",
                                      id: 91302,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: true,
                                      kind: "bool",
                                      lValueRequested: false,
                                      nodeType: "Literal",
                                      src: "30953:4:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      },
                                      value: "true"
                                    },
                                    src: "30935:22:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  },
                                  id: 91304,
                                  nodeType: "ExpressionStatement",
                                  src: "30935:22:177"
                                },
                                {
                                  id: 91305,
                                  nodeType: "Break",
                                  src: "30979:5:177"
                                }
                              ]
                            }
                          },
                          {
                            expression: {
                              id: 91310,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                id: 91308,
                                name: "lastPrice",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91121,
                                src: "31101:9:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                id: 91309,
                                name: "price",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91218,
                                src: "31113:5:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "31101:17:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 91311,
                            nodeType: "ExpressionStatement",
                            src: "31101:17:177"
                          },
                          {
                            expression: {
                              id: 91314,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                id: 91312,
                                name: "lastBidId",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91163,
                                src: "31136:9:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                id: 91313,
                                name: "bidId",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91214,
                                src: "31148:5:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              src: "31136:17:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            id: 91315,
                            nodeType: "ExpressionStatement",
                            src: "31136:17:177"
                          },
                          {
                            expression: {
                              id: 91320,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 91316,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "31217:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91318,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "31224:13:177",
                                memberName: "totalAmountIn",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89910,
                                src: "31217:20:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "+=",
                              rightHandSide: {
                                id: 91319,
                                name: "amountIn",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91216,
                                src: "31241:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "31217:32:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 91321,
                            nodeType: "ExpressionStatement",
                            src: "31217:32:177"
                          },
                          {
                            expression: {
                              id: 91332,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 91322,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "31428:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91324,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "31435:16:177",
                                memberName: "capacityExpended",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89912,
                                src: "31428:23:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "=",
                              rightHandSide: {
                                arguments: [
                                  {
                                    expression: {
                                      id: 91327,
                                      name: "result",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91095,
                                      src: "31470:6:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                        typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                      }
                                    },
                                    id: 91328,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "31477:13:177",
                                    memberName: "totalAmountIn",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 89910,
                                    src: "31470:20:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  {
                                    id: 91329,
                                    name: "baseScale",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91105,
                                    src: "31492:9:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  {
                                    id: 91330,
                                    name: "price",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91218,
                                    src: "31503:5:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  ],
                                  expression: {
                                    id: 91325,
                                    name: "Math",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 55729,
                                    src: "31454:4:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                      typeString: "type(library FixedPointMathLib)"
                                    }
                                  },
                                  id: 91326,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "31459:10:177",
                                  memberName: "fullMulDiv",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 55048,
                                  src: "31454:15:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                    typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                  }
                                },
                                id: 91331,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "31454:55:177",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "31428:81:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 91333,
                            nodeType: "ExpressionStatement",
                            src: "31428:81:177"
                          },
                          {
                            condition: {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 91337,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                expression: {
                                  id: 91334,
                                  name: "result",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91095,
                                  src: "31764:6:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                  }
                                },
                                id: 91335,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "31771:16:177",
                                memberName: "capacityExpended",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 89912,
                                src: "31764:23:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: ">=",
                              rightExpression: {
                                id: 91336,
                                name: "capacity",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91098,
                                src: "31791:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "31764:35:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            id: 91358,
                            nodeType: "IfStatement",
                            src: "31760:231:177",
                            trueBody: {
                              id: 91357,
                              nodeType: "Block",
                              src: "31801:190:177",
                              statements: [
                                {
                                  expression: {
                                    id: 91342,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91338,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "31823:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91340,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "31830:13:177",
                                      memberName: "marginalPrice",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89902,
                                      src: "31823:20:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      id: 91341,
                                      name: "price",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91218,
                                      src: "31846:5:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "31823:28:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  id: 91343,
                                  nodeType: "ExpressionStatement",
                                  src: "31823:28:177"
                                },
                                {
                                  expression: {
                                    id: 91348,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91344,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "31873:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91346,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "31880:13:177",
                                      memberName: "marginalBidId",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89904,
                                      src: "31873:20:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint64",
                                        typeString: "uint64"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      id: 91347,
                                      name: "bidId",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91214,
                                      src: "31896:5:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint64",
                                        typeString: "uint64"
                                      }
                                    },
                                    src: "31873:28:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint64",
                                      typeString: "uint64"
                                    }
                                  },
                                  id: 91349,
                                  nodeType: "ExpressionStatement",
                                  src: "31873:28:177"
                                },
                                {
                                  expression: {
                                    id: 91354,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91350,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "31923:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91352,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "31930:8:177",
                                      memberName: "finished",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89914,
                                      src: "31923:15:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      hexValue: "74727565",
                                      id: 91353,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: true,
                                      kind: "bool",
                                      lValueRequested: false,
                                      nodeType: "Literal",
                                      src: "31941:4:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      },
                                      value: "true"
                                    },
                                    src: "31923:22:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  },
                                  id: 91355,
                                  nodeType: "ExpressionStatement",
                                  src: "31923:22:177"
                                },
                                {
                                  id: 91356,
                                  nodeType: "Break",
                                  src: "31967:5:177"
                                }
                              ]
                            }
                          },
                          {
                            condition: {
                              commonType: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              id: 91365,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                commonType: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                id: 91363,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftExpression: {
                                  id: 91359,
                                  name: "i",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91204,
                                  src: "32152:1:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "BinaryOperation",
                                operator: "==",
                                rightExpression: {
                                  commonType: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  },
                                  id: 91362,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  leftExpression: {
                                    id: 91360,
                                    name: "numBids",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91170,
                                    src: "32157:7:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  nodeType: "BinaryOperation",
                                  operator: "-",
                                  rightExpression: {
                                    hexValue: "31",
                                    id: 91361,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "number",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "32167:1:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_rational_1_by_1",
                                      typeString: "int_const 1"
                                    },
                                    value: "1"
                                  },
                                  src: "32157:11:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                src: "32152:16:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_bool",
                                  typeString: "bool"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "&&",
                              rightExpression: {
                                id: 91364,
                                name: "last",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91189,
                                src: "32172:4:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_bool",
                                  typeString: "bool"
                                }
                              },
                              src: "32152:24:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            id: 91435,
                            nodeType: "IfStatement",
                            src: "32148:1602:177",
                            trueBody: {
                              id: 91434,
                              nodeType: "Block",
                              src: "32178:1572:177",
                              statements: [
                                {
                                  condition: {
                                    commonType: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    },
                                    id: 91380,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftExpression: {
                                      commonType: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      },
                                      id: 91369,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      leftExpression: {
                                        expression: {
                                          id: 91366,
                                          name: "lotAuctionData",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 91115,
                                          src: "32675:14:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_struct$_AuctionData_$83136_memory_ptr",
                                            typeString: "struct IEncryptedMarginalPrice.AuctionData memory"
                                          }
                                        },
                                        id: 91367,
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        memberLocation: "32690:8:177",
                                        memberName: "minPrice",
                                        nodeType: "MemberAccess",
                                        referencedDeclaration: 83123,
                                        src: "32675:23:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      },
                                      nodeType: "BinaryOperation",
                                      operator: "==",
                                      rightExpression: {
                                        hexValue: "30",
                                        id: 91368,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: "number",
                                        lValueRequested: false,
                                        nodeType: "Literal",
                                        src: "32702:1:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_rational_0_by_1",
                                          typeString: "int_const 0"
                                        },
                                        value: "0"
                                      },
                                      src: "32675:28:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      }
                                    },
                                    nodeType: "BinaryOperation",
                                    operator: "||",
                                    rightExpression: {
                                      commonType: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      },
                                      id: 91379,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      leftExpression: {
                                        arguments: [
                                          {
                                            expression: {
                                              id: 91372,
                                              name: "result",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91095,
                                              src: "32751:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                              }
                                            },
                                            id: 91373,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: false,
                                            memberLocation: "32758:13:177",
                                            memberName: "totalAmountIn",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 89910,
                                            src: "32751:20:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          },
                                          {
                                            id: 91374,
                                            name: "baseScale",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91105,
                                            src: "32773:9:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          },
                                          {
                                            expression: {
                                              id: 91375,
                                              name: "lotAuctionData",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91115,
                                              src: "32784:14:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_AuctionData_$83136_memory_ptr",
                                                typeString: "struct IEncryptedMarginalPrice.AuctionData memory"
                                              }
                                            },
                                            id: 91376,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: false,
                                            memberLocation: "32799:8:177",
                                            memberName: "minPrice",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 83123,
                                            src: "32784:23:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          }
                                        ],
                                        expression: {
                                          argumentTypes: [
                                            {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            },
                                            {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            },
                                            {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          ],
                                          expression: {
                                            id: 91370,
                                            name: "Math",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 55729,
                                            src: "32735:4:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                              typeString: "type(library FixedPointMathLib)"
                                            }
                                          },
                                          id: 91371,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "32740:10:177",
                                          memberName: "fullMulDiv",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 55048,
                                          src: "32735:15:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                            typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                          }
                                        },
                                        id: 91377,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: "functionCall",
                                        lValueRequested: false,
                                        nameLocations: [],
                                        names: [],
                                        nodeType: "FunctionCall",
                                        src: "32735:73:177",
                                        tryCall: false,
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      },
                                      nodeType: "BinaryOperation",
                                      operator: ">",
                                      rightExpression: {
                                        id: 91378,
                                        name: "capacity",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91098,
                                        src: "32843:8:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      },
                                      src: "32735:116:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      }
                                    },
                                    src: "32675:176:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  },
                                  falseBody: {
                                    id: 91401,
                                    nodeType: "Block",
                                    src: "33040:95:177",
                                    statements: [
                                      {
                                        expression: {
                                          id: 91399,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: false,
                                          lValueRequested: false,
                                          leftHandSide: {
                                            expression: {
                                              id: 91394,
                                              name: "result",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91095,
                                              src: "33066:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                              }
                                            },
                                            id: 91396,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            memberLocation: "33073:13:177",
                                            memberName: "marginalPrice",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 89902,
                                            src: "33066:20:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          },
                                          nodeType: "Assignment",
                                          operator: "=",
                                          rightHandSide: {
                                            expression: {
                                              id: 91397,
                                              name: "lotAuctionData",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91115,
                                              src: "33089:14:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_AuctionData_$83136_memory_ptr",
                                                typeString: "struct IEncryptedMarginalPrice.AuctionData memory"
                                              }
                                            },
                                            id: 91398,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: false,
                                            memberLocation: "33104:8:177",
                                            memberName: "minPrice",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 83123,
                                            src: "33089:23:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          },
                                          src: "33066:46:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        id: 91400,
                                        nodeType: "ExpressionStatement",
                                        src: "33066:46:177"
                                      }
                                    ]
                                  },
                                  id: 91402,
                                  nodeType: "IfStatement",
                                  src: "32646:489:177",
                                  trueBody: {
                                    id: 91393,
                                    nodeType: "Block",
                                    src: "32874:160:177",
                                    statements: [
                                      {
                                        expression: {
                                          id: 91391,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: false,
                                          lValueRequested: false,
                                          leftHandSide: {
                                            expression: {
                                              id: 91381,
                                              name: "result",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91095,
                                              src: "32900:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                              }
                                            },
                                            id: 91383,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            memberLocation: "32907:13:177",
                                            memberName: "marginalPrice",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 89902,
                                            src: "32900:20:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          },
                                          nodeType: "Assignment",
                                          operator: "=",
                                          rightHandSide: {
                                            arguments: [
                                              {
                                                expression: {
                                                  id: 91386,
                                                  name: "result",
                                                  nodeType: "Identifier",
                                                  overloadedDeclarations: [],
                                                  referencedDeclaration: 91095,
                                                  src: "32969:6:177",
                                                  typeDescriptions: {
                                                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                                  }
                                                },
                                                id: 91387,
                                                isConstant: false,
                                                isLValue: true,
                                                isPure: false,
                                                lValueRequested: false,
                                                memberLocation: "32976:13:177",
                                                memberName: "totalAmountIn",
                                                nodeType: "MemberAccess",
                                                referencedDeclaration: 89910,
                                                src: "32969:20:177",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                }
                                              },
                                              {
                                                id: 91388,
                                                name: "baseScale",
                                                nodeType: "Identifier",
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 91105,
                                                src: "32991:9:177",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                }
                                              },
                                              {
                                                id: 91389,
                                                name: "capacity",
                                                nodeType: "Identifier",
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 91098,
                                                src: "33002:8:177",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                }
                                              }
                                            ],
                                            expression: {
                                              argumentTypes: [
                                                {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                },
                                                {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                },
                                                {
                                                  typeIdentifier: "t_uint256",
                                                  typeString: "uint256"
                                                }
                                              ],
                                              expression: {
                                                id: 91384,
                                                name: "Math",
                                                nodeType: "Identifier",
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 55729,
                                                src: "32951:4:177",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                                  typeString: "type(library FixedPointMathLib)"
                                                }
                                              },
                                              id: 91385,
                                              isConstant: false,
                                              isLValue: false,
                                              isPure: false,
                                              lValueRequested: false,
                                              memberLocation: "32956:12:177",
                                              memberName: "fullMulDivUp",
                                              nodeType: "MemberAccess",
                                              referencedDeclaration: 55070,
                                              src: "32951:17:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                                typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                              }
                                            },
                                            id: 91390,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: "functionCall",
                                            lValueRequested: false,
                                            nameLocations: [],
                                            names: [],
                                            nodeType: "FunctionCall",
                                            src: "32951:60:177",
                                            tryCall: false,
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint256",
                                              typeString: "uint256"
                                            }
                                          },
                                          src: "32900:111:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        id: 91392,
                                        nodeType: "ExpressionStatement",
                                        src: "32900:111:177"
                                      }
                                    ]
                                  }
                                },
                                {
                                  condition: {
                                    commonType: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    },
                                    id: 91406,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftExpression: {
                                      id: 91403,
                                      name: "price",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91218,
                                      src: "33345:5:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "BinaryOperation",
                                    operator: "==",
                                    rightExpression: {
                                      expression: {
                                        id: 91404,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "33354:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91405,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "33361:13:177",
                                      memberName: "marginalPrice",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89902,
                                      src: "33354:20:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "33345:29:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  },
                                  id: 91414,
                                  nodeType: "IfStatement",
                                  src: "33341:112:177",
                                  trueBody: {
                                    id: 91413,
                                    nodeType: "Block",
                                    src: "33376:77:177",
                                    statements: [
                                      {
                                        expression: {
                                          id: 91411,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: false,
                                          lValueRequested: false,
                                          leftHandSide: {
                                            expression: {
                                              id: 91407,
                                              name: "result",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 91095,
                                              src: "33402:6:177",
                                              typeDescriptions: {
                                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                              }
                                            },
                                            id: 91409,
                                            isConstant: false,
                                            isLValue: true,
                                            isPure: false,
                                            lValueRequested: true,
                                            memberLocation: "33409:13:177",
                                            memberName: "marginalBidId",
                                            nodeType: "MemberAccess",
                                            referencedDeclaration: 89904,
                                            src: "33402:20:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint64",
                                              typeString: "uint64"
                                            }
                                          },
                                          nodeType: "Assignment",
                                          operator: "=",
                                          rightHandSide: {
                                            id: 91410,
                                            name: "bidId",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91214,
                                            src: "33425:5:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint64",
                                              typeString: "uint64"
                                            }
                                          },
                                          src: "33402:28:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint64",
                                            typeString: "uint64"
                                          }
                                        },
                                        id: 91412,
                                        nodeType: "ExpressionStatement",
                                        src: "33402:28:177"
                                      }
                                    ]
                                  }
                                },
                                {
                                  expression: {
                                    id: 91426,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91415,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "33475:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91417,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "33482:16:177",
                                      memberName: "capacityExpended",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89912,
                                      src: "33475:23:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      arguments: [
                                        {
                                          expression: {
                                            id: 91420,
                                            name: "result",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91095,
                                            src: "33541:6:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                            }
                                          },
                                          id: 91421,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "33548:13:177",
                                          memberName: "totalAmountIn",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 89910,
                                          src: "33541:20:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        {
                                          id: 91422,
                                          name: "baseScale",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 91105,
                                          src: "33563:9:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        },
                                        {
                                          expression: {
                                            id: 91423,
                                            name: "result",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91095,
                                            src: "33574:6:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                            }
                                          },
                                          id: 91424,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "33581:13:177",
                                          memberName: "marginalPrice",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 89902,
                                          src: "33574:20:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        }
                                      ],
                                      expression: {
                                        argumentTypes: [
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          },
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          },
                                          {
                                            typeIdentifier: "t_uint256",
                                            typeString: "uint256"
                                          }
                                        ],
                                        expression: {
                                          id: 91418,
                                          name: "Math",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 55729,
                                          src: "33525:4:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                            typeString: "type(library FixedPointMathLib)"
                                          }
                                        },
                                        id: 91419,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        lValueRequested: false,
                                        memberLocation: "33530:10:177",
                                        memberName: "fullMulDiv",
                                        nodeType: "MemberAccess",
                                        referencedDeclaration: 55048,
                                        src: "33525:15:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                        }
                                      },
                                      id: 91425,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      kind: "functionCall",
                                      lValueRequested: false,
                                      nameLocations: [],
                                      names: [],
                                      nodeType: "FunctionCall",
                                      src: "33525:70:177",
                                      tryCall: false,
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    src: "33475:120:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  },
                                  id: 91427,
                                  nodeType: "ExpressionStatement",
                                  src: "33475:120:177"
                                },
                                {
                                  expression: {
                                    id: 91432,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    leftHandSide: {
                                      expression: {
                                        id: 91428,
                                        name: "result",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 91095,
                                        src: "33709:6:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                        }
                                      },
                                      id: 91430,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: true,
                                      memberLocation: "33716:8:177",
                                      memberName: "finished",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 89914,
                                      src: "33709:15:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      }
                                    },
                                    nodeType: "Assignment",
                                    operator: "=",
                                    rightHandSide: {
                                      hexValue: "74727565",
                                      id: 91431,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: true,
                                      kind: "bool",
                                      lValueRequested: false,
                                      nodeType: "Literal",
                                      src: "33727:4:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_bool",
                                        typeString: "bool"
                                      },
                                      value: "true"
                                    },
                                    src: "33709:22:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_bool",
                                      typeString: "bool"
                                    }
                                  },
                                  id: 91433,
                                  nodeType: "ExpressionStatement",
                                  src: "33709:22:177"
                                }
                              ]
                            }
                          }
                        ]
                      },
                      condition: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 91209,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 91207,
                          name: "i",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91204,
                          src: "28528:1:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "<",
                        rightExpression: {
                          id: 91208,
                          name: "numBids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91170,
                          src: "28532:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "28528:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      id: 91437,
                      initializationExpression: {
                        assignments: [91204],
                        declarations: [
                          {
                            constant: false,
                            id: 91204,
                            mutability: "mutable",
                            name: "i",
                            nameLocation: "28521:1:177",
                            nodeType: "VariableDeclaration",
                            scope: 91437,
                            src: "28513:9:177",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 91203,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "28513:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 91206,
                        initialValue: {
                          hexValue: "30",
                          id: 91205,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "28525:1:177",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "28513:13:177"
                      },
                      loopExpression: {
                        expression: {
                          id: 91211,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "UnaryOperation",
                          operator: "++",
                          prefix: false,
                          src: "28541:3:177",
                          subExpression: {
                            id: 91210,
                            name: "i",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91204,
                            src: "28541:1:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 91212,
                        nodeType: "ExpressionStatement",
                        src: "28541:3:177"
                      },
                      nodeType: "ForStatement",
                      src: "28508:5256:177"
                    }
                  ]
                },
                {
                  expression: {
                    id: 91439,
                    name: "result",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 91095,
                    src: "33791:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                      typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                    }
                  },
                  functionReturnParameters: 91096,
                  id: 91440,
                  nodeType: "Return",
                  src: "33784:13:177"
                }
              ]
            },
            documentation: {
              id: 91087,
              nodeType: "StructuredDocumentation",
              src: "26742:241:177",
              text: "@notice     Calculates the marginal price of a lot\n @param      lotId_          The lot ID of the auction to calculate the marginal price for\n @return     result          The result of the marginal price calculation"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_getLotMarginalPrice",
            nameLocation: "26997:20:177",
            parameters: {
              id: 91092,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91089,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "27034:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91442,
                  src: "27027:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91088,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "27027:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91091,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "27058:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 91442,
                  src: "27050:12:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91090,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "27050:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "27017:51:177"
            },
            returnParameters: {
              id: 91096,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91095,
                  mutability: "mutable",
                  name: "result",
                  nameLocation: "27114:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91442,
                  src: "27087:33:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                    typeString: "struct EncryptedMarginalPrice.MarginalPriceResult"
                  },
                  typeName: {
                    id: 91094,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91093,
                      name: "MarginalPriceResult",
                      nameLocations: ["27087:19:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 89915,
                      src: "27087:19:177"
                    },
                    referencedDeclaration: 89915,
                    src: "27087:19:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_MarginalPriceResult_$89915_storage_ptr",
                      typeString: "struct EncryptedMarginalPrice.MarginalPriceResult"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "27086:35:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 91690,
            nodeType: "FunctionDefinition",
            src: "34654:4658:177",
            nodes: [],
            body: {
              id: 91689,
              nodeType: "Block",
              src: "34849:4463:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_LotStatus_$83106",
                      typeString: "enum IEncryptedMarginalPrice.LotStatus"
                    },
                    id: 91465,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 91459,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "34930:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91461,
                        indexExpression: {
                          id: 91460,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91445,
                          src: "34942:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "34930:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91462,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "34950:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83117,
                      src: "34930:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      expression: {
                        id: 91463,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83106,
                        src: "34960:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                          typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                        }
                      },
                      id: 91464,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "34970:9:177",
                      memberName: "Decrypted",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83104,
                      src: "34960:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    src: "34930:49:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91471,
                  nodeType: "IfStatement",
                  src: "34926:113:177",
                  trueBody: {
                    id: 91470,
                    nodeType: "Block",
                    src: "34981:58:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 91467,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91445,
                              src: "35021:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 91466,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83060,
                            src: "35002:18:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 91468,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "35002:26:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 91469,
                        nodeType: "RevertStatement",
                        src: "34995:33:177"
                      }
                    ]
                  }
                },
                {
                  assignments: [91474],
                  declarations: [
                    {
                      constant: false,
                      id: 91474,
                      mutability: "mutable",
                      name: "result",
                      nameLocation: "35276:6:177",
                      nodeType: "VariableDeclaration",
                      scope: 91689,
                      src: "35249:33:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                        typeString: "struct EncryptedMarginalPrice.MarginalPriceResult"
                      },
                      typeName: {
                        id: 91473,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 91472,
                          name: "MarginalPriceResult",
                          nameLocations: ["35249:19:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 89915,
                          src: "35249:19:177"
                        },
                        referencedDeclaration: 89915,
                        src: "35249:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_storage_ptr",
                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91479,
                  initialValue: {
                    arguments: [
                      {
                        id: 91476,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91445,
                        src: "35306:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 91477,
                        name: "num_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91447,
                        src: "35314:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 91475,
                      name: "_getLotMarginalPrice",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91442,
                      src: "35285:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint96_$_t_uint256_$returns$_t_struct$_MarginalPriceResult_$89915_memory_ptr_$",
                        typeString: "function (uint96,uint256) returns (struct EncryptedMarginalPrice.MarginalPriceResult memory)"
                      }
                    },
                    id: 91478,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "35285:34:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                      typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "35249:70:177"
                },
                {
                  assignments: [91481],
                  declarations: [
                    {
                      constant: false,
                      id: 91481,
                      mutability: "mutable",
                      name: "baseScale",
                      nameLocation: "35374:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 91689,
                      src: "35366:17:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91480,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "35366:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91488,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91487,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      hexValue: "3130",
                      id: 91482,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "35386:2:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_10_by_1",
                        typeString: "int_const 10"
                      },
                      value: "10"
                    },
                    nodeType: "BinaryOperation",
                    operator: "**",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 91483,
                          name: "lotData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87480,
                          src: "35392:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                            typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                          }
                        },
                        id: 91485,
                        indexExpression: {
                          id: 91484,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91445,
                          src: "35400:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "35392:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Lot_$82587_storage",
                          typeString: "struct IAuction.Lot storage ref"
                        }
                      },
                      id: 91486,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "35408:17:177",
                      memberName: "baseTokenDecimals",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82578,
                      src: "35392:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint8",
                        typeString: "uint8"
                      }
                    },
                    src: "35386:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "35366:59:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 91492,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 91489,
                        name: "result",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91474,
                        src: "35486:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                        }
                      },
                      id: 91490,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "35493:8:177",
                      memberName: "finished",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89914,
                      src: "35486:15:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "66616c7365",
                      id: 91491,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "35505:5:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    src: "35486:24:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91525,
                  nodeType: "IfStatement",
                  src: "35482:675:177",
                  trueBody: {
                    id: 91524,
                    nodeType: "Block",
                    src: "35512:645:177",
                    statements: [
                      {
                        expression: {
                          id: 91499,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              baseExpression: {
                                id: 91493,
                                name: "_lotPartialSettlement",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89940,
                                src: "35682:21:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                                  typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                                }
                              },
                              id: 91495,
                              indexExpression: {
                                id: 91494,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91445,
                                src: "35704:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "35682:29:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                                typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                              }
                            },
                            id: 91496,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "35712:17:177",
                            memberName: "processedAmountIn",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89917,
                            src: "35682:47:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 91497,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91474,
                              src: "35732:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            id: 91498,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "35739:13:177",
                            memberName: "totalAmountIn",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89910,
                            src: "35732:20:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "35682:70:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 91500,
                        nodeType: "ExpressionStatement",
                        src: "35682:70:177"
                      },
                      {
                        expression: {
                          id: 91507,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              baseExpression: {
                                id: 91501,
                                name: "_lotPartialSettlement",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89940,
                                src: "35766:21:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                                  typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                                }
                              },
                              id: 91503,
                              indexExpression: {
                                id: 91502,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91445,
                                src: "35788:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "35766:29:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                                typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                              }
                            },
                            id: 91504,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "35796:9:177",
                            memberName: "lastPrice",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89919,
                            src: "35766:39:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 91505,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91474,
                              src: "35808:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            id: 91506,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "35815:12:177",
                            memberName: "lastBidPrice",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89908,
                            src: "35808:19:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "35766:61:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 91508,
                        nodeType: "ExpressionStatement",
                        src: "35766:61:177"
                      },
                      {
                        expression: {
                          id: 91515,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              baseExpression: {
                                id: 91509,
                                name: "_lotPartialSettlement",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89940,
                                src: "35841:21:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialSettlement_$89922_storage_$",
                                  typeString: "mapping(uint96 => struct EncryptedMarginalPrice.PartialSettlement storage ref)"
                                }
                              },
                              id: 91511,
                              indexExpression: {
                                id: 91510,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91445,
                                src: "35863:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "35841:29:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialSettlement_$89922_storage",
                                typeString: "struct EncryptedMarginalPrice.PartialSettlement storage ref"
                              }
                            },
                            id: 91512,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "35871:9:177",
                            memberName: "lastBidId",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89921,
                            src: "35841:39:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 91513,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91474,
                              src: "35883:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            id: 91514,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "35890:9:177",
                            memberName: "lastBidId",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89906,
                            src: "35883:16:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          src: "35841:58:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 91516,
                        nodeType: "ExpressionStatement",
                        src: "35841:58:177"
                      },
                      {
                        expression: {
                          components: [
                            {
                              id: 91517,
                              name: "totalIn_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91451,
                              src: "36093:8:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 91518,
                              name: "totalOut_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91453,
                              src: "36103:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              expression: {
                                id: 91519,
                                name: "result",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91474,
                                src: "36114:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                  typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                }
                              },
                              id: 91520,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "36121:8:177",
                              memberName: "finished",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 89914,
                              src: "36114:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            {
                              id: 91521,
                              name: "auctionOutput_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91457,
                              src: "36131:14:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            }
                          ],
                          id: 91522,
                          isConstant: false,
                          isInlineArray: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "TupleExpression",
                          src: "36092:54:177",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                            typeString: "tuple(uint256,uint256,bool,bytes memory)"
                          }
                        },
                        functionReturnParameters: 91458,
                        id: 91523,
                        nodeType: "Return",
                        src: "36085:61:177"
                      }
                    ]
                  }
                },
                {
                  assignments: [91527],
                  declarations: [
                    {
                      constant: false,
                      id: 91527,
                      mutability: "mutable",
                      name: "capacity",
                      nameLocation: "36343:8:177",
                      nodeType: "VariableDeclaration",
                      scope: 91689,
                      src: "36335:16:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91526,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "36335:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91532,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 91528,
                        name: "lotData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 87480,
                        src: "36354:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                          typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                        }
                      },
                      id: 91530,
                      indexExpression: {
                        id: 91529,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91445,
                        src: "36362:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "36354:15:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Lot_$82587_storage",
                        typeString: "struct IAuction.Lot storage ref"
                      }
                    },
                    id: 91531,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "36370:8:177",
                    memberName: "capacity",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 82582,
                    src: "36354:24:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "36335:43:177"
                },
                {
                  expression: {
                    id: 91539,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 91533,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "36587:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91535,
                        indexExpression: {
                          id: 91534,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91445,
                          src: "36599:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "36587:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91536,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "36607:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83117,
                      src: "36587:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91537,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83106,
                        src: "36616:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                          typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                        }
                      },
                      id: 91538,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "36626:7:177",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83105,
                      src: "36616:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    src: "36587:46:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_LotStatus_$83106",
                      typeString: "enum IEncryptedMarginalPrice.LotStatus"
                    }
                  },
                  id: 91540,
                  nodeType: "ExpressionStatement",
                  src: "36587:46:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 91555,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 91547,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 91541,
                          name: "result",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91474,
                          src: "36817:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                            typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                          }
                        },
                        id: 91542,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "36824:16:177",
                        memberName: "capacityExpended",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89912,
                        src: "36817:23:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "<",
                      rightExpression: {
                        expression: {
                          baseExpression: {
                            id: 91543,
                            name: "auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89928,
                            src: "36843:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                            }
                          },
                          id: 91545,
                          indexExpression: {
                            id: 91544,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91445,
                            src: "36855:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "36843:19:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                            typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                          }
                        },
                        id: 91546,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "36863:9:177",
                        memberName: "minFilled",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83125,
                        src: "36843:29:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "36817:55:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 91554,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 91548,
                          name: "result",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91474,
                          src: "36892:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                            typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                          }
                        },
                        id: 91549,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "36899:13:177",
                        memberName: "marginalPrice",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89902,
                        src: "36892:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "<",
                      rightExpression: {
                        expression: {
                          baseExpression: {
                            id: 91550,
                            name: "auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89928,
                            src: "36915:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                              typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                            }
                          },
                          id: 91552,
                          indexExpression: {
                            id: 91551,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91445,
                            src: "36927:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "36915:19:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                            typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                          }
                        },
                        id: 91553,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "36935:8:177",
                        memberName: "minPrice",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83123,
                        src: "36915:28:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "36892:51:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "36817:126:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91575,
                  nodeType: "IfStatement",
                  src: "36800:574:177",
                  trueBody: {
                    id: 91574,
                    nodeType: "Block",
                    src: "36954:420:177",
                    statements: [
                      {
                        expression: {
                          id: 91565,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              baseExpression: {
                                id: 91556,
                                name: "auctionData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89928,
                                src: "37152:11:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                                  typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                                }
                              },
                              id: 91558,
                              indexExpression: {
                                id: 91557,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91445,
                                src: "37164:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "37152:19:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                                typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                              }
                            },
                            id: 91559,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "37172:13:177",
                            memberName: "marginalPrice",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83121,
                            src: "37152:33:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              arguments: [
                                {
                                  id: 91562,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "37193:7:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_uint256_$",
                                    typeString: "type(uint256)"
                                  },
                                  typeName: {
                                    id: 91561,
                                    name: "uint256",
                                    nodeType: "ElementaryTypeName",
                                    src: "37193:7:177",
                                    typeDescriptions: {}
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_type$_t_uint256_$",
                                    typeString: "type(uint256)"
                                  }
                                ],
                                id: 91560,
                                name: "type",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -27,
                                src: "37188:4:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                                  typeString: "function () pure"
                                }
                              },
                              id: 91563,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "37188:13:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_magic_meta_type_t_uint256",
                                typeString: "type(uint256)"
                              }
                            },
                            id: 91564,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "37202:3:177",
                            memberName: "max",
                            nodeType: "MemberAccess",
                            src: "37188:17:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "37152:53:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 91566,
                        nodeType: "ExpressionStatement",
                        src: "37152:53:177"
                      },
                      {
                        expression: {
                          components: [
                            {
                              id: 91567,
                              name: "totalIn_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91451,
                              src: "37310:8:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 91568,
                              name: "totalOut_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91453,
                              src: "37320:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              expression: {
                                id: 91569,
                                name: "result",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91474,
                                src: "37331:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                  typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                }
                              },
                              id: 91570,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "37338:8:177",
                              memberName: "finished",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 89914,
                              src: "37331:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            {
                              id: 91571,
                              name: "auctionOutput_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91457,
                              src: "37348:14:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            }
                          ],
                          id: 91572,
                          isConstant: false,
                          isInlineArray: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "TupleExpression",
                          src: "37309:54:177",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                            typeString: "tuple(uint256,uint256,bool,bytes memory)"
                          }
                        },
                        functionReturnParameters: 91458,
                        id: 91573,
                        nodeType: "Return",
                        src: "37302:61:177"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 91582,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 91576,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "37463:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91578,
                        indexExpression: {
                          id: 91577,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91445,
                          src: "37475:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "37463:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91579,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "37483:13:177",
                      memberName: "marginalPrice",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83121,
                      src: "37463:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91580,
                        name: "result",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91474,
                        src: "37499:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                        }
                      },
                      id: 91581,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "37506:13:177",
                      memberName: "marginalPrice",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89902,
                      src: "37499:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "37463:56:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 91583,
                  nodeType: "ExpressionStatement",
                  src: "37463:56:177"
                },
                {
                  expression: {
                    id: 91590,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 91584,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "37529:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91586,
                        indexExpression: {
                          id: 91585,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91445,
                          src: "37541:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "37529:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91587,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "37549:13:177",
                      memberName: "marginalBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83119,
                      src: "37529:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91588,
                        name: "result",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91474,
                        src: "37565:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                        }
                      },
                      id: 91589,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "37572:13:177",
                      memberName: "marginalBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89904,
                      src: "37565:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "37529:56:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 91591,
                  nodeType: "ExpressionStatement",
                  src: "37529:56:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91595,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 91592,
                        name: "result",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91474,
                        src: "37779:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                        }
                      },
                      id: 91593,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "37786:16:177",
                      memberName: "capacityExpended",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89912,
                      src: "37779:23:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 91594,
                      name: "capacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91527,
                      src: "37805:8:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "37779:34:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91665,
                  nodeType: "IfStatement",
                  src: "37775:1293:177",
                  trueBody: {
                    id: 91664,
                    nodeType: "Block",
                    src: "37815:1253:177",
                    statements: [
                      {
                        assignments: [91598],
                        declarations: [
                          {
                            constant: false,
                            id: 91598,
                            mutability: "mutable",
                            name: "bidData",
                            nameLocation: "37882:7:177",
                            nodeType: "VariableDeclaration",
                            scope: 91664,
                            src: "37870:19:177",
                            stateVariable: false,
                            storageLocation: "storage",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                              typeString: "struct IEncryptedMarginalPrice.Bid"
                            },
                            typeName: {
                              id: 91597,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 91596,
                                name: "Bid",
                                nameLocations: ["37870:3:177"],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 83148,
                                src: "37870:3:177"
                              },
                              referencedDeclaration: 83148,
                              src: "37870:3:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                typeString: "struct IEncryptedMarginalPrice.Bid"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 91605,
                        initialValue: {
                          baseExpression: {
                            baseExpression: {
                              id: 91599,
                              name: "bids",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89948,
                              src: "37892:4:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                                typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                              }
                            },
                            id: 91601,
                            indexExpression: {
                              id: 91600,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91445,
                              src: "37897:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "37892:12:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                              typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                            }
                          },
                          id: 91604,
                          indexExpression: {
                            expression: {
                              id: 91602,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91474,
                              src: "37905:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            id: 91603,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "37912:13:177",
                            memberName: "marginalBidId",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89904,
                            src: "37905:20:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "37892:34:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Bid_$83148_storage",
                            typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "37870:56:177"
                      },
                      {
                        assignments: [91607],
                        declarations: [
                          {
                            constant: false,
                            id: 91607,
                            mutability: "mutable",
                            name: "fullFill",
                            nameLocation: "38004:8:177",
                            nodeType: "VariableDeclaration",
                            scope: 91664,
                            src: "37996:16:177",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 91606,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "37996:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 91619,
                        initialValue: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  expression: {
                                    id: 91612,
                                    name: "bidData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91598,
                                    src: "38035:7:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                      typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                    }
                                  },
                                  id: 91613,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "38043:6:177",
                                  memberName: "amount",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83140,
                                  src: "38035:14:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                ],
                                id: 91611,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "38027:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint256_$",
                                  typeString: "type(uint256)"
                                },
                                typeName: {
                                  id: 91610,
                                  name: "uint256",
                                  nodeType: "ElementaryTypeName",
                                  src: "38027:7:177",
                                  typeDescriptions: {}
                                }
                              },
                              id: 91614,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "38027:23:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 91615,
                              name: "baseScale",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91481,
                              src: "38052:9:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              expression: {
                                id: 91616,
                                name: "result",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91474,
                                src: "38063:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                  typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                }
                              },
                              id: 91617,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "38070:13:177",
                              memberName: "marginalPrice",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 89902,
                              src: "38063:20:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              id: 91608,
                              name: "Math",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 55729,
                              src: "38015:4:177",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                typeString: "type(library FixedPointMathLib)"
                              }
                            },
                            id: 91609,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "38020:6:177",
                            memberName: "mulDiv",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 55084,
                            src: "38015:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                              typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                            }
                          },
                          id: 91618,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "38015:69:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "37996:88:177"
                      },
                      {
                        assignments: [91621],
                        declarations: [
                          {
                            constant: false,
                            id: 91621,
                            mutability: "mutable",
                            name: "excess",
                            nameLocation: "38106:6:177",
                            nodeType: "VariableDeclaration",
                            scope: 91664,
                            src: "38098:14:177",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 91620,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "38098:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 91626,
                        initialValue: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 91625,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              id: 91622,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91474,
                              src: "38115:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            id: 91623,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "38122:16:177",
                            memberName: "capacityExpended",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89912,
                            src: "38115:23:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "-",
                          rightExpression: {
                            id: 91624,
                            name: "capacity",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91527,
                            src: "38141:8:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "38115:34:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "38098:51:177"
                      },
                      {
                        assignments: [91629],
                        declarations: [
                          {
                            constant: false,
                            id: 91629,
                            mutability: "mutable",
                            name: "pf",
                            nameLocation: "38696:2:177",
                            nodeType: "VariableDeclaration",
                            scope: 91664,
                            src: "38677:21:177",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                              typeString: "struct IEncryptedMarginalPrice.PartialFill"
                            },
                            typeName: {
                              id: 91628,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 91627,
                                name: "PartialFill",
                                nameLocations: ["38677:11:177"],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 83161,
                                src: "38677:11:177"
                              },
                              referencedDeclaration: 83161,
                              src: "38677:11:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialFill_$83161_storage_ptr",
                                typeString: "struct IEncryptedMarginalPrice.PartialFill"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 91650,
                        initialValue: {
                          arguments: [
                            {
                              expression: {
                                id: 91631,
                                name: "result",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91474,
                                src: "38738:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                  typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                                }
                              },
                              id: 91632,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "38745:13:177",
                              memberName: "marginalBidId",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 89904,
                              src: "38738:20:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            {
                              arguments: [
                                {
                                  arguments: [
                                    {
                                      arguments: [
                                        {
                                          expression: {
                                            id: 91639,
                                            name: "bidData",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 91598,
                                            src: "38811:7:177",
                                            typeDescriptions: {
                                              typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                                              typeString: "struct IEncryptedMarginalPrice.Bid storage pointer"
                                            }
                                          },
                                          id: 91640,
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          memberLocation: "38819:6:177",
                                          memberName: "amount",
                                          nodeType: "MemberAccess",
                                          referencedDeclaration: 83140,
                                          src: "38811:14:177",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint96",
                                            typeString: "uint96"
                                          }
                                        }
                                      ],
                                      expression: {
                                        argumentTypes: [
                                          {
                                            typeIdentifier: "t_uint96",
                                            typeString: "uint96"
                                          }
                                        ],
                                        id: 91638,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        lValueRequested: false,
                                        nodeType: "ElementaryTypeNameExpression",
                                        src: "38803:7:177",
                                        typeDescriptions: {
                                          typeIdentifier: "t_type$_t_uint256_$",
                                          typeString: "type(uint256)"
                                        },
                                        typeName: {
                                          id: 91637,
                                          name: "uint256",
                                          nodeType: "ElementaryTypeName",
                                          src: "38803:7:177",
                                          typeDescriptions: {}
                                        }
                                      },
                                      id: 91641,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      kind: "typeConversion",
                                      lValueRequested: false,
                                      nameLocations: [],
                                      names: [],
                                      nodeType: "FunctionCall",
                                      src: "38803:23:177",
                                      tryCall: false,
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    {
                                      id: 91642,
                                      name: "excess",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91621,
                                      src: "38828:6:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    {
                                      id: 91643,
                                      name: "fullFill",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 91607,
                                      src: "38836:8:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    }
                                  ],
                                  expression: {
                                    argumentTypes: [
                                      {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      },
                                      {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      },
                                      {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    ],
                                    expression: {
                                      id: 91635,
                                      name: "Math",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 55729,
                                      src: "38791:4:177",
                                      typeDescriptions: {
                                        typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                        typeString: "type(library FixedPointMathLib)"
                                      }
                                    },
                                    id: 91636,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "38796:6:177",
                                    memberName: "mulDiv",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 55084,
                                    src: "38791:11:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                      typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                    }
                                  },
                                  id: 91644,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "functionCall",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "38791:54:177",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                id: 91634,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "38784:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint96_$",
                                  typeString: "type(uint96)"
                                },
                                typeName: {
                                  id: 91633,
                                  name: "uint96",
                                  nodeType: "ElementaryTypeName",
                                  src: "38784:6:177",
                                  typeDescriptions: {}
                                }
                              },
                              id: 91645,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "38784:62:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 91648,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 91646,
                                name: "fullFill",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91607,
                                src: "38872:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "-",
                              rightExpression: {
                                id: 91647,
                                name: "excess",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91621,
                                src: "38883:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "38872:17:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              },
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            id: 91630,
                            name: "PartialFill",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83161,
                            src: "38701:11:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_PartialFill_$83161_storage_ptr_$",
                              typeString: "type(struct IEncryptedMarginalPrice.PartialFill storage pointer)"
                            }
                          },
                          id: 91649,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "structConstructorCall",
                          lValueRequested: false,
                          nameLocations: [
                            "38731:5:177",
                            "38776:6:177",
                            "38864:6:177"
                          ],
                          names: ["bidId", "refund", "payout"],
                          nodeType: "FunctionCall",
                          src: "38701:203:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                            typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "38677:227:177"
                      },
                      {
                        expression: {
                          id: 91655,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 91651,
                              name: "_lotPartialFill",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89934,
                              src: "38918:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
                                typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill storage ref)"
                              }
                            },
                            id: 91653,
                            indexExpression: {
                              id: 91652,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91445,
                              src: "38934:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "38918:23:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PartialFill_$83161_storage",
                              typeString: "struct IEncryptedMarginalPrice.PartialFill storage ref"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            id: 91654,
                            name: "pf",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91629,
                            src: "38944:2:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                              typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                            }
                          },
                          src: "38918:28:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialFill_$83161_storage",
                            typeString: "struct IEncryptedMarginalPrice.PartialFill storage ref"
                          }
                        },
                        id: 91656,
                        nodeType: "ExpressionStatement",
                        src: "38918:28:177"
                      },
                      {
                        expression: {
                          id: 91662,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 91657,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91474,
                              src: "39024:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                                typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                              }
                            },
                            id: 91659,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "39031:13:177",
                            memberName: "totalAmountIn",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 89910,
                            src: "39024:20:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "-=",
                          rightHandSide: {
                            expression: {
                              id: 91660,
                              name: "pf",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91629,
                              src: "39048:2:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                                typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                              }
                            },
                            id: 91661,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "39051:6:177",
                            memberName: "refund",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83158,
                            src: "39048:9:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "39024:33:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 91663,
                        nodeType: "ExpressionStatement",
                        src: "39024:33:177"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 91669,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 91666,
                      name: "totalIn_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91451,
                      src: "39109:8:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91667,
                        name: "result",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91474,
                        src: "39120:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                          typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                        }
                      },
                      id: 91668,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "39127:13:177",
                      memberName: "totalAmountIn",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 89910,
                      src: "39120:20:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "39109:31:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 91670,
                  nodeType: "ExpressionStatement",
                  src: "39109:31:177"
                },
                {
                  expression: {
                    id: 91680,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 91671,
                      name: "totalOut_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91453,
                      src: "39150:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      condition: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 91675,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            id: 91672,
                            name: "result",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91474,
                            src: "39162:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                              typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                            }
                          },
                          id: 91673,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "39169:16:177",
                          memberName: "capacityExpended",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 89912,
                          src: "39162:23:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: ">",
                        rightExpression: {
                          id: 91674,
                          name: "capacity",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91527,
                          src: "39188:8:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "39162:34:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      falseExpression: {
                        expression: {
                          id: 91677,
                          name: "result",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91474,
                          src: "39210:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                            typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                          }
                        },
                        id: 91678,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "39217:16:177",
                        memberName: "capacityExpended",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89912,
                        src: "39210:23:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 91679,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "Conditional",
                      src: "39162:71:177",
                      trueExpression: {
                        id: 91676,
                        name: "capacity",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91527,
                        src: "39199:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "39150:83:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 91681,
                  nodeType: "ExpressionStatement",
                  src: "39150:83:177"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 91682,
                        name: "totalIn_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91451,
                        src: "39252:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 91683,
                        name: "totalOut_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91453,
                        src: "39262:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 91684,
                          name: "result",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91474,
                          src: "39273:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_MarginalPriceResult_$89915_memory_ptr",
                            typeString: "struct EncryptedMarginalPrice.MarginalPriceResult memory"
                          }
                        },
                        id: 91685,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "39280:8:177",
                        memberName: "finished",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 89914,
                        src: "39273:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        id: 91686,
                        name: "auctionOutput_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91457,
                        src: "39290:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    id: 91687,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "39251:54:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                      typeString: "tuple(uint256,uint256,bool,bytes memory)"
                    }
                  },
                  functionReturnParameters: 91458,
                  id: 91688,
                  nodeType: "Return",
                  src: "39244:61:177"
                }
              ]
            },
            baseFunctions: [89420],
            documentation: {
              id: 91443,
              nodeType: "StructuredDocumentation",
              src: "33810:839:177",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates inputs\n             - Iterates over the decrypted bids to calculate the marginal price and number of winning bids\n             - If applicable, calculates the payout and refund for a partially filled bid\n             - Sets the auction status to settled\n             This function assumes:\n             - The lot ID has been validated\n             - The auction has concluded\n             - The auction is not settled\n             This function reverts if:\n             - The auction has not been decrypted\n             The function has been written to avoid any reverts that would cause the settlement process to brick."
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_settle",
            nameLocation: "34663:7:177",
            overrides: {
              id: 91449,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "34747:8:177"
            },
            parameters: {
              id: 91448,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91445,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "34687:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91690,
                  src: "34680:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91444,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "34680:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91447,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "34711:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 91690,
                  src: "34703:12:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91446,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "34703:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "34670:51:177"
            },
            returnParameters: {
              id: 91458,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91451,
                  mutability: "mutable",
                  name: "totalIn_",
                  nameLocation: "34781:8:177",
                  nodeType: "VariableDeclaration",
                  scope: 91690,
                  src: "34773:16:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91450,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "34773:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91453,
                  mutability: "mutable",
                  name: "totalOut_",
                  nameLocation: "34799:9:177",
                  nodeType: "VariableDeclaration",
                  scope: 91690,
                  src: "34791:17:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91452,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "34791:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91455,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 91690,
                  src: "34810:4:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 91454,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "34810:4:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91457,
                  mutability: "mutable",
                  name: "auctionOutput_",
                  nameLocation: "34829:14:177",
                  nodeType: "VariableDeclaration",
                  scope: 91690,
                  src: "34816:27:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 91456,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "34816:5:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "34772:72:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 91717,
            nodeType: "FunctionDefinition",
            src: "39871:311:177",
            nodes: [],
            body: {
              id: 91716,
              nodeType: "Block",
              src: "39920:262:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 91703,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 91697,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "39975:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91699,
                        indexExpression: {
                          id: 91698,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91693,
                          src: "39987:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "39975:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91700,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "39995:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83117,
                      src: "39975:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91701,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83106,
                        src: "40004:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                          typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                        }
                      },
                      id: 91702,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "40014:7:177",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83105,
                      src: "40004:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    src: "39975:46:177",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_LotStatus_$83106",
                      typeString: "enum IEncryptedMarginalPrice.LotStatus"
                    }
                  },
                  id: 91704,
                  nodeType: "ExpressionStatement",
                  src: "39975:46:177"
                },
                {
                  expression: {
                    id: 91714,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 91705,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "40122:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91707,
                        indexExpression: {
                          id: 91706,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91693,
                          src: "40134:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "40122:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91708,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "40142:13:177",
                      memberName: "marginalPrice",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83121,
                      src: "40122:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        arguments: [
                          {
                            id: 91711,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            nodeType: "ElementaryTypeNameExpression",
                            src: "40163:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_uint256_$",
                              typeString: "type(uint256)"
                            },
                            typeName: {
                              id: 91710,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "40163:7:177",
                              typeDescriptions: {}
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_type$_t_uint256_$",
                              typeString: "type(uint256)"
                            }
                          ],
                          id: 91709,
                          name: "type",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -27,
                          src: "40158:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                            typeString: "function () pure"
                          }
                        },
                        id: 91712,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "40158:13:177",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_magic_meta_type_t_uint256",
                          typeString: "type(uint256)"
                        }
                      },
                      id: 91713,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "40172:3:177",
                      memberName: "max",
                      nodeType: "MemberAccess",
                      src: "40158:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "40122:53:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 91715,
                  nodeType: "ExpressionStatement",
                  src: "40122:53:177"
                }
              ]
            },
            baseFunctions: [89456],
            documentation: {
              id: 91691,
              nodeType: "StructuredDocumentation",
              src: "39318:548:177",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates state\n             - Sets the lot status to Settled\n             - Sets the marginal price to the maximum value\n             This function assumes:\n             - The lot ID has been validated\n             - The auction is not settled\n             - The dedicated settle period has not passed\n             This function reverts if:\n             - None"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_abort",
            nameLocation: "39880:6:177",
            overrides: {
              id: 91695,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "39911:8:177"
            },
            parameters: {
              id: 91694,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91693,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "39894:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91717,
                  src: "39887:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91692,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "39887:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "39886:15:177"
            },
            returnParameters: {
              id: 91696,
              nodeType: "ParameterList",
              parameters: [],
              src: "39920:0:177"
            },
            scope: 92311,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 91753,
            nodeType: "FunctionDefinition",
            src: "40419:301:177",
            nodes: [],
            body: {
              id: 91752,
              nodeType: "Block",
              src: "40560:160:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 91732,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91720,
                        src: "40590:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 91731,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "40570:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 91733,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "40570:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91734,
                  nodeType: "ExpressionStatement",
                  src: "40570:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 91736,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91720,
                        src: "40627:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 91737,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91722,
                        src: "40635:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 91735,
                      name: "_revertIfBidInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92259],
                      referencedDeclaration: 92259,
                      src: "40607:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                        typeString: "function (uint96,uint64) view"
                      }
                    },
                    id: 91738,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "40607:35:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91739,
                  nodeType: "ExpressionStatement",
                  src: "40607:35:177"
                },
                {
                  expression: {
                    components: [
                      {
                        baseExpression: {
                          baseExpression: {
                            id: 91740,
                            name: "bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89948,
                            src: "40661:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                            }
                          },
                          id: 91742,
                          indexExpression: {
                            id: 91741,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91720,
                            src: "40666:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "40661:12:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                            typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                          }
                        },
                        id: 91744,
                        indexExpression: {
                          id: 91743,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91722,
                          src: "40674:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "40661:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                        }
                      },
                      {
                        baseExpression: {
                          baseExpression: {
                            id: 91745,
                            name: "encryptedBids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89956,
                            src: "40683:13:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref))"
                            }
                          },
                          id: 91747,
                          indexExpression: {
                            id: 91746,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91720,
                            src: "40697:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "40683:21:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_EncryptedBid_$83154_storage_$",
                            typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.EncryptedBid storage ref)"
                          }
                        },
                        id: 91749,
                        indexExpression: {
                          id: 91748,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91722,
                          src: "40705:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "40683:29:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_EncryptedBid_$83154_storage",
                          typeString: "struct IEncryptedMarginalPrice.EncryptedBid storage ref"
                        }
                      }
                    ],
                    id: 91750,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "40660:53:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_struct$_Bid_$83148_storage_$_t_struct$_EncryptedBid_$83154_storage_$",
                      typeString: "tuple(struct IEncryptedMarginalPrice.Bid storage ref,struct IEncryptedMarginalPrice.EncryptedBid storage ref)"
                    }
                  },
                  functionReturnParameters: 91730,
                  id: 91751,
                  nodeType: "Return",
                  src: "40653:60:177"
                }
              ]
            },
            baseFunctions: [83227],
            documentation: {
              id: 91718,
              nodeType: "StructuredDocumentation",
              src: "40241:173:177",
              text: "@inheritdoc IEncryptedMarginalPrice\n @dev        This function reverts if:\n             - The lot ID is invalid\n             - The bid ID is invalid"
            },
            functionSelector: "a8bf44e4",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBid",
            nameLocation: "40428:6:177",
            parameters: {
              id: 91723,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91720,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "40451:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91753,
                  src: "40444:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91719,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "40444:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91722,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "40474:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91753,
                  src: "40467:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 91721,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "40467:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "40434:52:177"
            },
            returnParameters: {
              id: 91730,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91726,
                  mutability: "mutable",
                  name: "bid",
                  nameLocation: "40521:3:177",
                  nodeType: "VariableDeclaration",
                  scope: 91753,
                  src: "40510:14:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                    typeString: "struct IEncryptedMarginalPrice.Bid"
                  },
                  typeName: {
                    id: 91725,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91724,
                      name: "Bid",
                      nameLocations: ["40510:3:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83148,
                      src: "40510:3:177"
                    },
                    referencedDeclaration: 83148,
                    src: "40510:3:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                      typeString: "struct IEncryptedMarginalPrice.Bid"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91729,
                  mutability: "mutable",
                  name: "encryptedBid",
                  nameLocation: "40546:12:177",
                  nodeType: "VariableDeclaration",
                  scope: 91753,
                  src: "40526:32:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_EncryptedBid_$83154_memory_ptr",
                    typeString: "struct IEncryptedMarginalPrice.EncryptedBid"
                  },
                  typeName: {
                    id: 91728,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91727,
                      name: "EncryptedBid",
                      nameLocations: ["40526:12:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83154,
                      src: "40526:12:177"
                    },
                    referencedDeclaration: 83154,
                    src: "40526:12:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_EncryptedBid_$83154_storage_ptr",
                      typeString: "struct IEncryptedMarginalPrice.EncryptedBid"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "40509:50:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 91772,
            nodeType: "FunctionDefinition",
            src: "40860:221:177",
            nodes: [],
            body: {
              id: 91771,
              nodeType: "Block",
              src: "41000:81:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 91764,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91756,
                        src: "41030:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 91763,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "41010:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 91765,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "41010:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91766,
                  nodeType: "ExpressionStatement",
                  src: "41010:27:177"
                },
                {
                  expression: {
                    baseExpression: {
                      id: 91767,
                      name: "auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89928,
                      src: "41055:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                        typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                      }
                    },
                    id: 91769,
                    indexExpression: {
                      id: 91768,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91756,
                      src: "41067:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "41055:19:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                      typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                    }
                  },
                  functionReturnParameters: 91762,
                  id: 91770,
                  nodeType: "Return",
                  src: "41048:26:177"
                }
              ]
            },
            baseFunctions: [83236],
            documentation: {
              id: 91754,
              nodeType: "StructuredDocumentation",
              src: "40726:129:177",
              text: "@inheritdoc IEncryptedMarginalPrice\n @dev        This function reverts if:\n             - The lot ID is invalid"
            },
            functionSelector: "cadb3383",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getAuctionData",
            nameLocation: "40869:14:177",
            overrides: {
              id: 91758,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "40937:8:177"
            },
            parameters: {
              id: 91757,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91756,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "40891:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91772,
                  src: "40884:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91755,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "40884:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "40883:15:177"
            },
            returnParameters: {
              id: 91762,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91761,
                  mutability: "mutable",
                  name: "auctionData_",
                  nameLocation: "40982:12:177",
                  nodeType: "VariableDeclaration",
                  scope: 91772,
                  src: "40963:31:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_AuctionData_$83136_memory_ptr",
                    typeString: "struct IEncryptedMarginalPrice.AuctionData"
                  },
                  typeName: {
                    id: 91760,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91759,
                      name: "AuctionData",
                      nameLocations: ["40963:11:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83136,
                      src: "40963:11:177"
                    },
                    referencedDeclaration: 83136,
                    src: "40963:11:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83136_storage_ptr",
                      typeString: "struct IEncryptedMarginalPrice.AuctionData"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "40962:33:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 91809,
            nodeType: "FunctionDefinition",
            src: "41362:371:177",
            nodes: [],
            body: {
              id: 91808,
              nodeType: "Block",
              src: "41505:228:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 91784,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91775,
                        src: "41535:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 91783,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "41515:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 91785,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "41515:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91786,
                  nodeType: "ExpressionStatement",
                  src: "41515:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 91788,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91775,
                        src: "41575:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 91787,
                      name: "_revertIfLotNotSettled",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92220],
                      referencedDeclaration: 92220,
                      src: "41552:22:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 91789,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "41552:30:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91790,
                  nodeType: "ExpressionStatement",
                  src: "41552:30:177"
                },
                {
                  expression: {
                    id: 91795,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 91791,
                      name: "partialFill",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91781,
                      src: "41593:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                        typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      baseExpression: {
                        id: 91792,
                        name: "_lotPartialFill",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89934,
                        src: "41607:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill storage ref)"
                        }
                      },
                      id: 91794,
                      indexExpression: {
                        id: 91793,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91775,
                        src: "41623:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "41607:23:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PartialFill_$83161_storage",
                        typeString: "struct IEncryptedMarginalPrice.PartialFill storage ref"
                      }
                    },
                    src: "41593:37:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                      typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                    }
                  },
                  id: 91796,
                  nodeType: "ExpressionStatement",
                  src: "41593:37:177"
                },
                {
                  expression: {
                    id: 91802,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 91797,
                      name: "hasPartialFill",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91778,
                      src: "41640:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      commonType: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      },
                      id: 91801,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 91798,
                          name: "partialFill",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91781,
                          src: "41657:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                            typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                          }
                        },
                        id: 91799,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "41669:5:177",
                        memberName: "bidId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83156,
                        src: "41657:17:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "!=",
                      rightExpression: {
                        hexValue: "30",
                        id: 91800,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "41678:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "41657:22:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "41640:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91803,
                  nodeType: "ExpressionStatement",
                  src: "41640:39:177"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 91804,
                        name: "hasPartialFill",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91778,
                        src: "41698:14:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        id: 91805,
                        name: "partialFill",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91781,
                        src: "41714:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.PartialFill memory"
                        }
                      }
                    ],
                    id: 91806,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "41697:29:177",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_bool_$_t_struct$_PartialFill_$83161_memory_ptr_$",
                      typeString: "tuple(bool,struct IEncryptedMarginalPrice.PartialFill memory)"
                    }
                  },
                  functionReturnParameters: 91782,
                  id: 91807,
                  nodeType: "Return",
                  src: "41690:36:177"
                }
              ]
            },
            baseFunctions: [83247],
            documentation: {
              id: 91773,
              nodeType: "StructuredDocumentation",
              src: "41087:270:177",
              text: "@inheritdoc IEncryptedMarginalPrice\n @dev        For ease of use, this function determines if a partial fill exists.\n             This function reverts if:\n             - The lot ID is invalid\n             - The lot is not settled"
            },
            functionSelector: "a16f7ef7",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getPartialFill",
            nameLocation: "41371:14:177",
            parameters: {
              id: 91776,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91775,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "41393:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91809,
                  src: "41386:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91774,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "41386:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "41385:15:177"
            },
            returnParameters: {
              id: 91782,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91778,
                  mutability: "mutable",
                  name: "hasPartialFill",
                  nameLocation: "41453:14:177",
                  nodeType: "VariableDeclaration",
                  scope: 91809,
                  src: "41448:19:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 91777,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "41448:4:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91781,
                  mutability: "mutable",
                  name: "partialFill",
                  nameLocation: "41488:11:177",
                  nodeType: "VariableDeclaration",
                  scope: 91809,
                  src: "41469:30:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PartialFill_$83161_memory_ptr",
                    typeString: "struct IEncryptedMarginalPrice.PartialFill"
                  },
                  typeName: {
                    id: 91780,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91779,
                      name: "PartialFill",
                      nameLocations: ["41469:11:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83161,
                      src: "41469:11:177"
                    },
                    referencedDeclaration: 83161,
                    src: "41469:11:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PartialFill_$83161_storage_ptr",
                      typeString: "struct IEncryptedMarginalPrice.PartialFill"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "41447:53:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 91829,
            nodeType: "FunctionDefinition",
            src: "41863:171:177",
            nodes: [],
            body: {
              id: 91828,
              nodeType: "Block",
              src: "41939:95:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 91819,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91812,
                        src: "41969:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 91818,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "41949:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 91820,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "41949:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91821,
                  nodeType: "ExpressionStatement",
                  src: "41949:27:177"
                },
                {
                  expression: {
                    expression: {
                      expression: {
                        baseExpression: {
                          id: 91822,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "41994:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 91824,
                        indexExpression: {
                          id: 91823,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91812,
                          src: "42006:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "41994:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 91825,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "42014:6:177",
                      memberName: "bidIds",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83135,
                      src: "41994:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage",
                        typeString: "uint64[] storage ref"
                      }
                    },
                    id: 91826,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "42021:6:177",
                    memberName: "length",
                    nodeType: "MemberAccess",
                    src: "41994:33:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 91817,
                  id: 91827,
                  nodeType: "Return",
                  src: "41987:40:177"
                }
              ]
            },
            baseFunctions: [82812],
            documentation: {
              id: 91810,
              nodeType: "StructuredDocumentation",
              src: "41739:119:177",
              text: "@inheritdoc IBatchAuction\n @dev        This function reverts if:\n             - The lot ID is invalid"
            },
            functionSelector: "d899a337",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getNumBids",
            nameLocation: "41872:10:177",
            overrides: {
              id: 91814,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "41912:8:177"
            },
            parameters: {
              id: 91813,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91812,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "41890:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91829,
                  src: "41883:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91811,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "41883:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "41882:15:177"
            },
            returnParameters: {
              id: 91817,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91816,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 91829,
                  src: "41930:7:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91815,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "41930:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "41929:9:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 91919,
            nodeType: "FunctionDefinition",
            src: "42164:1022:177",
            nodes: [],
            body: {
              id: 91918,
              nodeType: "Block",
              src: "42312:874:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 91844,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91832,
                        src: "42342:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 91843,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "42322:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 91845,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "42322:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 91846,
                  nodeType: "ExpressionStatement",
                  src: "42322:27:177"
                },
                {
                  assignments: [91851],
                  declarations: [
                    {
                      constant: false,
                      id: 91851,
                      mutability: "mutable",
                      name: "bidIds",
                      nameLocation: "42377:6:177",
                      nodeType: "VariableDeclaration",
                      scope: 91918,
                      src: "42360:23:177",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                        typeString: "uint64[]"
                      },
                      typeName: {
                        baseType: {
                          id: 91849,
                          name: "uint64",
                          nodeType: "ElementaryTypeName",
                          src: "42360:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 91850,
                        nodeType: "ArrayTypeName",
                        src: "42360:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91856,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 91852,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "42386:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 91854,
                      indexExpression: {
                        id: 91853,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91832,
                        src: "42398:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "42386:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 91855,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "42406:6:177",
                    memberName: "bidIds",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83135,
                    src: "42386:26:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage",
                      typeString: "uint64[] storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "42360:52:177"
                },
                {
                  assignments: [91858],
                  declarations: [
                    {
                      constant: false,
                      id: 91858,
                      mutability: "mutable",
                      name: "len",
                      nameLocation: "42430:3:177",
                      nodeType: "VariableDeclaration",
                      scope: 91918,
                      src: "42422:11:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91857,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "42422:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91861,
                  initialValue: {
                    expression: {
                      id: 91859,
                      name: "bidIds",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91851,
                      src: "42436:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                        typeString: "uint64[] storage pointer"
                      }
                    },
                    id: 91860,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "42443:6:177",
                    memberName: "length",
                    nodeType: "MemberAccess",
                    src: "42436:13:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "42422:27:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91864,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 91862,
                      name: "startIndex_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91834,
                      src: "42518:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">=",
                    rightExpression: {
                      id: 91863,
                      name: "len",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91858,
                      src: "42533:3:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "42518:18:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91868,
                  nodeType: "IfStatement",
                  src: "42514:54:177",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 91865,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "42545:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 91866,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "42545:23:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 91867,
                    nodeType: "RevertStatement",
                    src: "42538:30:177"
                  }
                },
                {
                  assignments: [91870],
                  declarations: [
                    {
                      constant: false,
                      id: 91870,
                      mutability: "mutable",
                      name: "remaining",
                      nameLocation: "42844:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 91918,
                      src: "42836:17:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91869,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "42836:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91874,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91873,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 91871,
                      name: "len",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91858,
                      src: "42856:3:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      id: 91872,
                      name: "startIndex_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91834,
                      src: "42862:11:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "42856:17:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "42836:37:177"
                },
                {
                  assignments: [91876],
                  declarations: [
                    {
                      constant: false,
                      id: 91876,
                      mutability: "mutable",
                      name: "num",
                      nameLocation: "42891:3:177",
                      nodeType: "VariableDeclaration",
                      scope: 91918,
                      src: "42883:11:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91875,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "42883:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91883,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 91879,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 91877,
                        name: "num_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91836,
                        src: "42897:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        id: 91878,
                        name: "remaining",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91870,
                        src: "42904:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "42897:16:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      id: 91881,
                      name: "num_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91836,
                      src: "42928:4:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 91882,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "42897:35:177",
                    trueExpression: {
                      id: 91880,
                      name: "remaining",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91870,
                      src: "42916:9:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "42883:49:177"
                },
                {
                  assignments: [91888],
                  declarations: [
                    {
                      constant: false,
                      id: 91888,
                      mutability: "mutable",
                      name: "result",
                      nameLocation: "43001:6:177",
                      nodeType: "VariableDeclaration",
                      scope: 91918,
                      src: "42985:22:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_memory_ptr",
                        typeString: "uint64[]"
                      },
                      typeName: {
                        baseType: {
                          id: 91886,
                          name: "uint64",
                          nodeType: "ElementaryTypeName",
                          src: "42985:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 91887,
                        nodeType: "ArrayTypeName",
                        src: "42985:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[]"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91894,
                  initialValue: {
                    arguments: [
                      {
                        id: 91892,
                        name: "num",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91876,
                        src: "43023:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 91891,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "NewExpression",
                      src: "43010:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_uint64_$dyn_memory_ptr_$",
                        typeString: "function (uint256) pure returns (uint64[] memory)"
                      },
                      typeName: {
                        baseType: {
                          id: 91889,
                          name: "uint64",
                          nodeType: "ElementaryTypeName",
                          src: "43014:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 91890,
                        nodeType: "ArrayTypeName",
                        src: "43014:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                          typeString: "uint64[]"
                        }
                      }
                    },
                    id: 91893,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "43010:17:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_memory_ptr",
                      typeString: "uint64[] memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "42985:42:177"
                },
                {
                  body: {
                    id: 91914,
                    nodeType: "Block",
                    src: "43096:60:177",
                    statements: [
                      {
                        expression: {
                          id: 91912,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 91904,
                              name: "result",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91888,
                              src: "43110:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_uint64_$dyn_memory_ptr",
                                typeString: "uint64[] memory"
                              }
                            },
                            id: 91906,
                            indexExpression: {
                              id: 91905,
                              name: "i",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91896,
                              src: "43117:1:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "43110:9:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            baseExpression: {
                              id: 91907,
                              name: "bidIds",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91851,
                              src: "43122:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                                typeString: "uint64[] storage pointer"
                              }
                            },
                            id: 91911,
                            indexExpression: {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 91910,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 91908,
                                name: "startIndex_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91834,
                                src: "43129:11:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "+",
                              rightExpression: {
                                id: 91909,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91896,
                                src: "43143:1:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "43129:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "43122:23:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          src: "43110:35:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        id: 91913,
                        nodeType: "ExpressionStatement",
                        src: "43110:35:177"
                      }
                    ]
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91900,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 91898,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91896,
                      src: "43082:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 91899,
                      name: "num",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91876,
                      src: "43086:3:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "43082:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 91915,
                  initializationExpression: {
                    assignments: [91896],
                    declarations: [
                      {
                        constant: false,
                        id: 91896,
                        mutability: "mutable",
                        name: "i",
                        nameLocation: "43079:1:177",
                        nodeType: "VariableDeclaration",
                        scope: 91915,
                        src: "43071:9:177",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        typeName: {
                          id: 91895,
                          name: "uint256",
                          nodeType: "ElementaryTypeName",
                          src: "43071:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        visibility: "internal"
                      }
                    ],
                    id: 91897,
                    nodeType: "VariableDeclarationStatement",
                    src: "43071:9:177"
                  },
                  loopExpression: {
                    expression: {
                      id: 91902,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "43091:3:177",
                      subExpression: {
                        id: 91901,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91896,
                        src: "43091:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 91903,
                    nodeType: "ExpressionStatement",
                    src: "43091:3:177"
                  },
                  nodeType: "ForStatement",
                  src: "43066:90:177"
                },
                {
                  expression: {
                    id: 91916,
                    name: "result",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 91888,
                    src: "43173:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_memory_ptr",
                      typeString: "uint64[] memory"
                    }
                  },
                  functionReturnParameters: 91842,
                  id: 91917,
                  nodeType: "Return",
                  src: "43166:13:177"
                }
              ]
            },
            baseFunctions: [82825],
            documentation: {
              id: 91830,
              nodeType: "StructuredDocumentation",
              src: "42040:119:177",
              text: "@inheritdoc IBatchAuction\n @dev        This function reverts if:\n             - The lot ID is invalid"
            },
            functionSelector: "00b33217",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBidIds",
            nameLocation: "42173:9:177",
            overrides: {
              id: 91838,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "42277:8:177"
            },
            parameters: {
              id: 91837,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91832,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "42199:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 91919,
                  src: "42192:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91831,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "42192:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91834,
                  mutability: "mutable",
                  name: "startIndex_",
                  nameLocation: "42223:11:177",
                  nodeType: "VariableDeclaration",
                  scope: 91919,
                  src: "42215:19:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91833,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "42215:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91836,
                  mutability: "mutable",
                  name: "num_",
                  nameLocation: "42252:4:177",
                  nodeType: "VariableDeclaration",
                  scope: 91919,
                  src: "42244:12:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 91835,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "42244:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "42182:80:177"
            },
            returnParameters: {
              id: 91842,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91841,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 91919,
                  src: "42295:15:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_uint64_$dyn_memory_ptr",
                    typeString: "uint64[]"
                  },
                  typeName: {
                    baseType: {
                      id: 91839,
                      name: "uint64",
                      nodeType: "ElementaryTypeName",
                      src: "42295:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    id: 91840,
                    nodeType: "ArrayTypeName",
                    src: "42295:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                      typeString: "uint64[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "42294:17:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 92073,
            nodeType: "FunctionDefinition",
            src: "43544:2061:177",
            nodes: [],
            body: {
              id: 92072,
              nodeType: "Block",
              src: "43667:1938:177",
              nodes: [],
              statements: [
                {
                  assignments: [91932],
                  declarations: [
                    {
                      constant: false,
                      id: 91932,
                      mutability: "mutable",
                      name: "bidData",
                      nameLocation: "43713:7:177",
                      nodeType: "VariableDeclaration",
                      scope: 92072,
                      src: "43702:18:177",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                        typeString: "struct IEncryptedMarginalPrice.Bid"
                      },
                      typeName: {
                        id: 91931,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 91930,
                          name: "Bid",
                          nameLocations: ["43702:3:177"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83148,
                          src: "43702:3:177"
                        },
                        referencedDeclaration: 83148,
                        src: "43702:3:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91938,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 91933,
                        name: "bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89948,
                        src: "43723:4:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                        }
                      },
                      id: 91935,
                      indexExpression: {
                        id: 91934,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91922,
                        src: "43728:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "43723:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                        typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                      }
                    },
                    id: 91937,
                    indexExpression: {
                      id: 91936,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91924,
                      src: "43736:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "43723:20:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83148_storage",
                      typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "43702:41:177"
                },
                {
                  expression: {
                    id: 91944,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 91939,
                        name: "bidClaim",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91928,
                        src: "43804:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory"
                        }
                      },
                      id: 91941,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "43813:6:177",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82712,
                      src: "43804:15:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91942,
                        name: "bidData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91932,
                        src: "43822:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid memory"
                        }
                      },
                      id: 91943,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "43830:6:177",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83138,
                      src: "43822:14:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "43804:32:177",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 91945,
                  nodeType: "ExpressionStatement",
                  src: "43804:32:177"
                },
                {
                  expression: {
                    id: 91951,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 91946,
                        name: "bidClaim",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91928,
                        src: "43846:8:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory"
                        }
                      },
                      id: 91948,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "43855:8:177",
                      memberName: "referrer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82714,
                      src: "43846:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 91949,
                        name: "bidData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91932,
                        src: "43866:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                          typeString: "struct IEncryptedMarginalPrice.Bid memory"
                        }
                      },
                      id: 91950,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "43874:8:177",
                      memberName: "referrer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83144,
                      src: "43866:16:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "43846:36:177",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 91952,
                  nodeType: "ExpressionStatement",
                  src: "43846:36:177"
                },
                {
                  assignments: [91954],
                  declarations: [
                    {
                      constant: false,
                      id: 91954,
                      mutability: "mutable",
                      name: "baseScale",
                      nameLocation: "43936:9:177",
                      nodeType: "VariableDeclaration",
                      scope: 92072,
                      src: "43928:17:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91953,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "43928:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91961,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 91960,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      hexValue: "3130",
                      id: 91955,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "43948:2:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_10_by_1",
                        typeString: "int_const 10"
                      },
                      value: "10"
                    },
                    nodeType: "BinaryOperation",
                    operator: "**",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 91956,
                          name: "lotData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87480,
                          src: "43954:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                            typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                          }
                        },
                        id: 91958,
                        indexExpression: {
                          id: 91957,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91922,
                          src: "43962:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "43954:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Lot_$82587_storage",
                          typeString: "struct IAuction.Lot storage ref"
                        }
                      },
                      id: 91959,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "43970:17:177",
                      memberName: "baseTokenDecimals",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82578,
                      src: "43954:33:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint8",
                        typeString: "uint8"
                      }
                    },
                    src: "43948:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "43928:59:177"
                },
                {
                  assignments: [91963],
                  declarations: [
                    {
                      constant: false,
                      id: 91963,
                      mutability: "mutable",
                      name: "price",
                      nameLocation: "44005:5:177",
                      nodeType: "VariableDeclaration",
                      scope: 92072,
                      src: "43997:13:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91962,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "43997:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91978,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      },
                      id: 91967,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 91964,
                          name: "bidData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91932,
                          src: "44013:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                            typeString: "struct IEncryptedMarginalPrice.Bid memory"
                          }
                        },
                        id: 91965,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "44021:12:177",
                        memberName: "minAmountOut",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83142,
                        src: "44013:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        hexValue: "30",
                        id: 91966,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "44037:1:177",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "44013:25:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      arguments: [
                        {
                          expression: {
                            id: 91971,
                            name: "bidData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91932,
                            src: "44138:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                              typeString: "struct IEncryptedMarginalPrice.Bid memory"
                            }
                          },
                          id: 91972,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "44146:6:177",
                          memberName: "amount",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83140,
                          src: "44138:14:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 91973,
                          name: "baseScale",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91954,
                          src: "44154:9:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          expression: {
                            id: 91974,
                            name: "bidData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 91932,
                            src: "44165:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                              typeString: "struct IEncryptedMarginalPrice.Bid memory"
                            }
                          },
                          id: 91975,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "44173:12:177",
                          memberName: "minAmountOut",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83142,
                          src: "44165:20:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        ],
                        expression: {
                          id: 91969,
                          name: "Math",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 55729,
                          src: "44124:4:177",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                            typeString: "type(library FixedPointMathLib)"
                          }
                        },
                        id: 91970,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "44129:8:177",
                        memberName: "mulDivUp",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 55098,
                        src: "44124:13:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 91976,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "44124:62:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 91977,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "44013:173:177",
                    trueExpression: {
                      hexValue: "30",
                      id: 91968,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "44053:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "43997:189:177"
                },
                {
                  assignments: [91980],
                  declarations: [
                    {
                      constant: false,
                      id: 91980,
                      mutability: "mutable",
                      name: "marginalPrice",
                      nameLocation: "44205:13:177",
                      nodeType: "VariableDeclaration",
                      scope: 92072,
                      src: "44197:21:177",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 91979,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "44197:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 91985,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 91981,
                        name: "auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 89928,
                        src: "44221:11:177",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                          typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                        }
                      },
                      id: 91983,
                      indexExpression: {
                        id: 91982,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 91922,
                        src: "44233:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "44221:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                        typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                      }
                    },
                    id: 91984,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "44241:13:177",
                    memberName: "marginalPrice",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83121,
                    src: "44221:33:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "44197:57:177"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    },
                    id: 91991,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 91986,
                          name: "_lotPartialFill",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89934,
                          src: "44812:15:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill storage ref)"
                          }
                        },
                        id: 91988,
                        indexExpression: {
                          id: 91987,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91922,
                          src: "44828:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "44812:23:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PartialFill_$83161_storage",
                          typeString: "struct IEncryptedMarginalPrice.PartialFill storage ref"
                        }
                      },
                      id: 91989,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "44836:5:177",
                      memberName: "bidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83156,
                      src: "44812:29:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      id: 91990,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 91924,
                      src: "44845:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "44812:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      id: 92032,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 92020,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          id: 92018,
                          name: "price",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91963,
                          src: "45055:5:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: ">",
                        rightExpression: {
                          id: 92019,
                          name: "marginalPrice",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 91980,
                          src: "45063:13:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "45055:21:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "||",
                      rightExpression: {
                        components: [
                          {
                            commonType: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            },
                            id: 92030,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftExpression: {
                              commonType: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              id: 92023,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 92021,
                                name: "price",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91963,
                                src: "45097:5:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "==",
                              rightExpression: {
                                id: 92022,
                                name: "marginalPrice",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91980,
                                src: "45106:13:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "45097:22:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            nodeType: "BinaryOperation",
                            operator: "&&",
                            rightExpression: {
                              commonType: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              },
                              id: 92029,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftExpression: {
                                id: 92024,
                                name: "bidId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91924,
                                src: "45123:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              nodeType: "BinaryOperation",
                              operator: "<=",
                              rightExpression: {
                                expression: {
                                  baseExpression: {
                                    id: 92025,
                                    name: "auctionData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 89928,
                                    src: "45133:11:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                                      typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                                    }
                                  },
                                  id: 92027,
                                  indexExpression: {
                                    id: 92026,
                                    name: "lotId_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91922,
                                    src: "45145:6:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint96",
                                      typeString: "uint96"
                                    }
                                  },
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  nodeType: "IndexAccess",
                                  src: "45133:19:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                                    typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                                  }
                                },
                                id: 92028,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "45153:13:177",
                                memberName: "marginalBidId",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 83119,
                                src: "45133:33:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              src: "45123:43:177",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              }
                            },
                            src: "45097:69:177",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          }
                        ],
                        id: 92031,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "45096:71:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      src: "45055:112:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseBody: {
                      id: 92067,
                      nodeType: "Block",
                      src: "45399:174:177",
                      statements: [
                        {
                          expression: {
                            id: 92058,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftHandSide: {
                              expression: {
                                id: 92053,
                                name: "bidClaim",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91928,
                                src: "45486:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                  typeString: "struct IBatchAuction.BidClaim memory"
                                }
                              },
                              id: 92055,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: true,
                              memberLocation: "45495:4:177",
                              memberName: "paid",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82716,
                              src: "45486:13:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "Assignment",
                            operator: "=",
                            rightHandSide: {
                              expression: {
                                id: 92056,
                                name: "bidData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91932,
                                src: "45502:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                                  typeString: "struct IEncryptedMarginalPrice.Bid memory"
                                }
                              },
                              id: 92057,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "45510:6:177",
                              memberName: "amount",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83140,
                              src: "45502:14:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            src: "45486:30:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 92059,
                          nodeType: "ExpressionStatement",
                          src: "45486:30:177"
                        },
                        {
                          expression: {
                            id: 92065,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftHandSide: {
                              expression: {
                                id: 92060,
                                name: "bidClaim",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91928,
                                src: "45530:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                  typeString: "struct IBatchAuction.BidClaim memory"
                                }
                              },
                              id: 92062,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: true,
                              memberLocation: "45539:6:177",
                              memberName: "refund",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82720,
                              src: "45530:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "Assignment",
                            operator: "=",
                            rightHandSide: {
                              expression: {
                                id: 92063,
                                name: "bidData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91932,
                                src: "45548:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                                  typeString: "struct IEncryptedMarginalPrice.Bid memory"
                                }
                              },
                              id: 92064,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "45556:6:177",
                              memberName: "amount",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83140,
                              src: "45548:14:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            src: "45530:32:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 92066,
                          nodeType: "ExpressionStatement",
                          src: "45530:32:177"
                        }
                      ]
                    },
                    id: 92068,
                    nodeType: "IfStatement",
                    src: "45038:535:177",
                    trueBody: {
                      id: 92052,
                      nodeType: "Block",
                      src: "45178:215:177",
                      statements: [
                        {
                          expression: {
                            id: 92038,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftHandSide: {
                              expression: {
                                id: 92033,
                                name: "bidClaim",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91928,
                                src: "45268:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                  typeString: "struct IBatchAuction.BidClaim memory"
                                }
                              },
                              id: 92035,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: true,
                              memberLocation: "45277:4:177",
                              memberName: "paid",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82716,
                              src: "45268:13:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "Assignment",
                            operator: "=",
                            rightHandSide: {
                              expression: {
                                id: 92036,
                                name: "bidData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91932,
                                src: "45284:7:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                                  typeString: "struct IEncryptedMarginalPrice.Bid memory"
                                }
                              },
                              id: 92037,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "45292:6:177",
                              memberName: "amount",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83140,
                              src: "45284:14:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            src: "45268:30:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 92039,
                          nodeType: "ExpressionStatement",
                          src: "45268:30:177"
                        },
                        {
                          expression: {
                            id: 92050,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftHandSide: {
                              expression: {
                                id: 92040,
                                name: "bidClaim",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91928,
                                src: "45312:8:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                  typeString: "struct IBatchAuction.BidClaim memory"
                                }
                              },
                              id: 92042,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: true,
                              memberLocation: "45321:6:177",
                              memberName: "payout",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82718,
                              src: "45312:15:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "Assignment",
                            operator: "=",
                            rightHandSide: {
                              arguments: [
                                {
                                  expression: {
                                    id: 92045,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 91928,
                                    src: "45342:8:177",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 92046,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "45351:4:177",
                                  memberName: "paid",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82716,
                                  src: "45342:13:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                {
                                  id: 92047,
                                  name: "baseScale",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91954,
                                  src: "45357:9:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                {
                                  id: 92048,
                                  name: "marginalPrice",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 91980,
                                  src: "45368:13:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  },
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  },
                                  {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                ],
                                expression: {
                                  id: 92043,
                                  name: "Math",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 55729,
                                  src: "45330:4:177",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                    typeString: "type(library FixedPointMathLib)"
                                  }
                                },
                                id: 92044,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "45335:6:177",
                                memberName: "mulDiv",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 55084,
                                src: "45330:11:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                  typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                }
                              },
                              id: 92049,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "45330:52:177",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "45312:70:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 92051,
                          nodeType: "ExpressionStatement",
                          src: "45312:70:177"
                        }
                      ]
                    }
                  },
                  id: 92069,
                  nodeType: "IfStatement",
                  src: "44808:765:177",
                  trueBody: {
                    id: 92017,
                    nodeType: "Block",
                    src: "44853:179:177",
                    statements: [
                      {
                        expression: {
                          id: 91997,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 91992,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91928,
                              src: "44867:8:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 91994,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "44876:4:177",
                            memberName: "paid",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82716,
                            src: "44867:13:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 91995,
                              name: "bidData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91932,
                              src: "44883:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Bid_$83148_memory_ptr",
                                typeString: "struct IEncryptedMarginalPrice.Bid memory"
                              }
                            },
                            id: 91996,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "44891:6:177",
                            memberName: "amount",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83140,
                            src: "44883:14:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "44867:30:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 91998,
                        nodeType: "ExpressionStatement",
                        src: "44867:30:177"
                      },
                      {
                        expression: {
                          id: 92006,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 91999,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91928,
                              src: "44911:8:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 92001,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "44920:6:177",
                            memberName: "payout",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82718,
                            src: "44911:15:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              baseExpression: {
                                id: 92002,
                                name: "_lotPartialFill",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89934,
                                src: "44929:15:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
                                  typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill storage ref)"
                                }
                              },
                              id: 92004,
                              indexExpression: {
                                id: 92003,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91922,
                                src: "44945:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "44929:23:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialFill_$83161_storage",
                                typeString: "struct IEncryptedMarginalPrice.PartialFill storage ref"
                              }
                            },
                            id: 92005,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "44953:6:177",
                            memberName: "payout",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83160,
                            src: "44929:30:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "44911:48:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 92007,
                        nodeType: "ExpressionStatement",
                        src: "44911:48:177"
                      },
                      {
                        expression: {
                          id: 92015,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 92008,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 91928,
                              src: "44973:8:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 92010,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "44982:6:177",
                            memberName: "refund",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82720,
                            src: "44973:15:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              baseExpression: {
                                id: 92011,
                                name: "_lotPartialFill",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 89934,
                                src: "44991:15:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83161_storage_$",
                                  typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.PartialFill storage ref)"
                                }
                              },
                              id: 92013,
                              indexExpression: {
                                id: 92012,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 91922,
                                src: "45007:6:177",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "44991:23:177",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialFill_$83161_storage",
                                typeString: "struct IEncryptedMarginalPrice.PartialFill storage ref"
                              }
                            },
                            id: 92014,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "45015:6:177",
                            memberName: "refund",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83158,
                            src: "44991:30:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "44973:48:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 92016,
                        nodeType: "ExpressionStatement",
                        src: "44973:48:177"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 92070,
                    name: "bidClaim",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 91928,
                    src: "45590:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory"
                    }
                  },
                  functionReturnParameters: 91929,
                  id: 92071,
                  nodeType: "Return",
                  src: "45583:15:177"
                }
              ]
            },
            documentation: {
              id: 91920,
              nodeType: "StructuredDocumentation",
              src: "43192:347:177",
              text: "@notice Returns the `BidClaim` data for a given lot and bid ID\n @dev    This function assumes:\n         - The lot ID has been validated\n         - The bid ID has been validated\n @param  lotId_          The lot ID\n @param  bidId_          The bid ID\n @return bidClaim        The `BidClaim` data"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_getBidClaim",
            nameLocation: "43553:12:177",
            parameters: {
              id: 91925,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91922,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "43582:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92073,
                  src: "43575:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 91921,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "43575:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 91924,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "43605:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92073,
                  src: "43598:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 91923,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "43598:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "43565:52:177"
            },
            returnParameters: {
              id: 91929,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 91928,
                  mutability: "mutable",
                  name: "bidClaim",
                  nameLocation: "43657:8:177",
                  nodeType: "VariableDeclaration",
                  scope: 92073,
                  src: "43641:24:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim"
                  },
                  typeName: {
                    id: 91927,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 91926,
                      name: "BidClaim",
                      nameLocations: ["43641:8:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82721,
                      src: "43641:8:177"
                    },
                    referencedDeclaration: 82721,
                    src: "43641:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "43640:26:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92092,
            nodeType: "FunctionDefinition",
            src: "45645:176:177",
            nodes: [],
            body: {
              id: 92091,
              nodeType: "Block",
              src: "45763:58:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    baseExpression: {
                      expression: {
                        baseExpression: {
                          id: 92084,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "45780:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 92086,
                        indexExpression: {
                          id: 92085,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92076,
                          src: "45792:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "45780:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 92087,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "45800:6:177",
                      memberName: "bidIds",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83135,
                      src: "45780:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_storage",
                        typeString: "uint64[] storage ref"
                      }
                    },
                    id: 92089,
                    indexExpression: {
                      id: 92088,
                      name: "index_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92078,
                      src: "45807:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "45780:34:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  functionReturnParameters: 92083,
                  id: 92090,
                  nodeType: "Return",
                  src: "45773:41:177"
                }
              ]
            },
            baseFunctions: [82835],
            documentation: {
              id: 92074,
              nodeType: "StructuredDocumentation",
              src: "45611:29:177",
              text: "@inheritdoc IBatchAuction"
            },
            functionSelector: "7d7b6853",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBidIdAtIndex",
            nameLocation: "45654:15:177",
            overrides: {
              id: 92080,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "45737:8:177"
            },
            parameters: {
              id: 92079,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92076,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "45686:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92092,
                  src: "45679:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92075,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "45679:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92078,
                  mutability: "mutable",
                  name: "index_",
                  nameLocation: "45710:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92092,
                  src: "45702:14:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92077,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "45702:7:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "45669:53:177"
            },
            returnParameters: {
              id: 92083,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92082,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92092,
                  src: "45755:6:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92081,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "45755:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "45754:8:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 92123,
            nodeType: "FunctionDefinition",
            src: "46072:306:177",
            nodes: [],
            body: {
              id: 92122,
              nodeType: "Block",
              src: "46203:175:177",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 92105,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92095,
                        src: "46233:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92104,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "46213:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92106,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "46213:27:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92107,
                  nodeType: "ExpressionStatement",
                  src: "46213:27:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 92109,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92095,
                        src: "46273:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92108,
                      name: "_revertIfLotNotSettled",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92220],
                      referencedDeclaration: 92220,
                      src: "46250:22:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92110,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "46250:30:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92111,
                  nodeType: "ExpressionStatement",
                  src: "46250:30:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 92113,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92095,
                        src: "46310:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 92114,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92097,
                        src: "46318:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 92112,
                      name: "_revertIfBidInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [92259],
                      referencedDeclaration: 92259,
                      src: "46290:19:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                        typeString: "function (uint96,uint64) view"
                      }
                    },
                    id: 92115,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "46290:35:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92116,
                  nodeType: "ExpressionStatement",
                  src: "46290:35:177"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 92118,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92095,
                        src: "46356:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 92119,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92097,
                        src: "46364:6:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 92117,
                      name: "_getBidClaim",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92073,
                      src: "46343:12:177",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$_t_struct$_BidClaim_$82721_memory_ptr_$",
                        typeString: "function (uint96,uint64) view returns (struct IBatchAuction.BidClaim memory)"
                      }
                    },
                    id: 92120,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "46343:28:177",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory"
                    }
                  },
                  functionReturnParameters: 92103,
                  id: 92121,
                  nodeType: "Return",
                  src: "46336:35:177"
                }
              ]
            },
            baseFunctions: [82846],
            documentation: {
              id: 92093,
              nodeType: "StructuredDocumentation",
              src: "45827:240:177",
              text: "@inheritdoc IBatchAuction\n @dev        This function reverts if:\n             - The lot ID is invalid\n             - The lot is not settled (since there would be no claim)\n             - The bid ID is invalid"
            },
            functionSelector: "8f21c318",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBidClaim",
            nameLocation: "46081:11:177",
            overrides: {
              id: 92099,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "46159:8:177"
            },
            parameters: {
              id: 92098,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92095,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "46109:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92123,
                  src: "46102:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92094,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "46102:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92097,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "46132:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92123,
                  src: "46125:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92096,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "46125:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "46092:52:177"
            },
            returnParameters: {
              id: 92103,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92102,
                  mutability: "mutable",
                  name: "bidClaim",
                  nameLocation: "46193:8:177",
                  nodeType: "VariableDeclaration",
                  scope: 92123,
                  src: "46177:24:177",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim"
                  },
                  typeName: {
                    id: 92101,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92100,
                      name: "BidClaim",
                      nameLocations: ["46177:8:177"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82721,
                      src: "46177:8:177"
                    },
                    referencedDeclaration: 82721,
                    src: "46177:8:177",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "46176:26:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 92159,
            nodeType: "FunctionDefinition",
            src: "46462:315:177",
            nodes: [],
            body: {
              id: 92158,
              nodeType: "Block",
              src: "46528:249:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 92152,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      id: 92144,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        commonType: {
                          typeIdentifier: "t_enum$_LotStatus_$83106",
                          typeString: "enum IEncryptedMarginalPrice.LotStatus"
                        },
                        id: 92136,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 92130,
                              name: "auctionData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 89928,
                              src: "46555:11:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                                typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                              }
                            },
                            id: 92132,
                            indexExpression: {
                              id: 92131,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92126,
                              src: "46567:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "46555:19:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                              typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                            }
                          },
                          id: 92133,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "46575:6:177",
                          memberName: "status",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83117,
                          src: "46555:26:177",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_LotStatus_$83106",
                            typeString: "enum IEncryptedMarginalPrice.LotStatus"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          expression: {
                            id: 92134,
                            name: "LotStatus",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83106,
                            src: "46585:9:177",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                              typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                            }
                          },
                          id: 92135,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          memberLocation: "46595:7:177",
                          memberName: "Created",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83103,
                          src: "46585:17:177",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_LotStatus_$83106",
                            typeString: "enum IEncryptedMarginalPrice.LotStatus"
                          }
                        },
                        src: "46555:47:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "&&",
                      rightExpression: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 92143,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 92137,
                              name: "lotData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 87480,
                              src: "46622:7:177",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                                typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                              }
                            },
                            id: 92139,
                            indexExpression: {
                              id: 92138,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92126,
                              src: "46630:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "46622:15:177",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Lot_$82587_storage",
                              typeString: "struct IAuction.Lot storage ref"
                            }
                          },
                          id: 92140,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "46638:5:177",
                          memberName: "start",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82572,
                          src: "46622:21:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "<=",
                        rightExpression: {
                          expression: {
                            id: 92141,
                            name: "block",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -4,
                            src: "46647:5:177",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_block",
                              typeString: "block"
                            }
                          },
                          id: 92142,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "46653:9:177",
                          memberName: "timestamp",
                          nodeType: "MemberAccess",
                          src: "46647:15:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "46622:40:177",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      src: "46555:107:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "&&",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 92151,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          baseExpression: {
                            id: 92145,
                            name: "lotData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 87480,
                            src: "46682:7:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                              typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                            }
                          },
                          id: 92147,
                          indexExpression: {
                            id: 92146,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92126,
                            src: "46690:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "46682:15:177",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Lot_$82587_storage",
                            typeString: "struct IAuction.Lot storage ref"
                          }
                        },
                        id: 92148,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "46698:10:177",
                        memberName: "conclusion",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82574,
                        src: "46682:26:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        expression: {
                          id: 92149,
                          name: "block",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -4,
                          src: "46711:5:177",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_block",
                            typeString: "block"
                          }
                        },
                        id: 92150,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "46717:9:177",
                        memberName: "timestamp",
                        nodeType: "MemberAccess",
                        src: "46711:15:177",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "46682:44:177",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "46555:171:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92157,
                  nodeType: "IfStatement",
                  src: "46538:232:177",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 92154,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92126,
                          src: "46763:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        ],
                        id: 92153,
                        name: "Auction_WrongState",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83060,
                        src: "46744:18:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                          typeString: "function (uint96) pure"
                        }
                      },
                      id: 92155,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "46744:26:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92156,
                    nodeType: "RevertStatement",
                    src: "46737:33:177"
                  }
                }
              ]
            },
            baseFunctions: [88010],
            documentation: {
              id: 92124,
              nodeType: "StructuredDocumentation",
              src: "46428:29:177",
              text: "@inheritdoc AuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfLotActive",
            nameLocation: "46471:18:177",
            overrides: {
              id: 92128,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "46519:8:177"
            },
            parameters: {
              id: 92127,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92126,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "46497:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92159,
                  src: "46490:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92125,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "46490:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "46489:15:177"
            },
            returnParameters: {
              id: 92129,
              nodeType: "ParameterList",
              parameters: [],
              src: "46528:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92178,
            nodeType: "FunctionDefinition",
            src: "46857:231:177",
            nodes: [],
            body: {
              id: 92177,
              nodeType: "Block",
              src: "46917:171:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92170,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 92165,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "46987:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 92167,
                        indexExpression: {
                          id: 92166,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92162,
                          src: "46999:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "46987:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 92168,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "47007:10:177",
                      memberName: "privateKey",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83132,
                      src: "46987:30:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      hexValue: "30",
                      id: 92169,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "47021:1:177",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "46987:35:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92176,
                  nodeType: "IfStatement",
                  src: "46983:99:177",
                  trueBody: {
                    id: 92175,
                    nodeType: "Block",
                    src: "47024:58:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 92172,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92162,
                              src: "47064:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 92171,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83060,
                            src: "47045:18:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 92173,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "47045:26:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 92174,
                        nodeType: "RevertStatement",
                        src: "47038:33:177"
                      }
                    ]
                  }
                }
              ]
            },
            documentation: {
              id: 92160,
              nodeType: "StructuredDocumentation",
              src: "46783:69:177",
              text: "@notice Reverts if the private key has been submitted for the lot"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfKeySubmitted",
            nameLocation: "46866:21:177",
            parameters: {
              id: 92163,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92162,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "46895:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92178,
                  src: "46888:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92161,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "46888:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "46887:15:177"
            },
            returnParameters: {
              id: 92164,
              nodeType: "ParameterList",
              parameters: [],
              src: "46917:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92199,
            nodeType: "FunctionDefinition",
            src: "47133:233:177",
            nodes: [],
            body: {
              id: 92198,
              nodeType: "Block",
              src: "47200:166:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_LotStatus_$83106",
                      typeString: "enum IEncryptedMarginalPrice.LotStatus"
                    },
                    id: 92191,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 92185,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "47253:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 92187,
                        indexExpression: {
                          id: 92186,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92181,
                          src: "47265:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "47253:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 92188,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "47273:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83117,
                      src: "47253:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      expression: {
                        id: 92189,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83106,
                        src: "47283:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                          typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                        }
                      },
                      id: 92190,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "47293:7:177",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83105,
                      src: "47283:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    src: "47253:47:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92197,
                  nodeType: "IfStatement",
                  src: "47249:111:177",
                  trueBody: {
                    id: 92196,
                    nodeType: "Block",
                    src: "47302:58:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 92193,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92181,
                              src: "47342:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 92192,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83060,
                            src: "47323:18:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 92194,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "47323:26:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 92195,
                        nodeType: "RevertStatement",
                        src: "47316:33:177"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [89481],
            documentation: {
              id: 92179,
              nodeType: "StructuredDocumentation",
              src: "47094:34:177",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfLotSettled",
            nameLocation: "47142:19:177",
            overrides: {
              id: 92183,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "47191:8:177"
            },
            parameters: {
              id: 92182,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92181,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "47169:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92199,
                  src: "47162:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92180,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "47162:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "47161:15:177"
            },
            returnParameters: {
              id: 92184,
              nodeType: "ParameterList",
              parameters: [],
              src: "47200:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92220,
            nodeType: "FunctionDefinition",
            src: "47411:232:177",
            nodes: [],
            body: {
              id: 92219,
              nodeType: "Block",
              src: "47481:162:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_LotStatus_$83106",
                      typeString: "enum IEncryptedMarginalPrice.LotStatus"
                    },
                    id: 92212,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 92206,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "47530:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 92208,
                        indexExpression: {
                          id: 92207,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92202,
                          src: "47542:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "47530:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 92209,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "47550:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83117,
                      src: "47530:26:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      expression: {
                        id: 92210,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83106,
                        src: "47560:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83106_$",
                          typeString: "type(enum IEncryptedMarginalPrice.LotStatus)"
                        }
                      },
                      id: 92211,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "47570:7:177",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83105,
                      src: "47560:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83106",
                        typeString: "enum IEncryptedMarginalPrice.LotStatus"
                      }
                    },
                    src: "47530:47:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92218,
                  nodeType: "IfStatement",
                  src: "47526:111:177",
                  trueBody: {
                    id: 92217,
                    nodeType: "Block",
                    src: "47579:58:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 92214,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92202,
                              src: "47619:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 92213,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83060,
                            src: "47600:18:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 92215,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "47600:26:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 92216,
                        nodeType: "RevertStatement",
                        src: "47593:33:177"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [89487],
            documentation: {
              id: 92200,
              nodeType: "StructuredDocumentation",
              src: "47372:34:177",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfLotNotSettled",
            nameLocation: "47420:22:177",
            overrides: {
              id: 92204,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "47472:8:177"
            },
            parameters: {
              id: 92203,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92202,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "47450:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92220,
                  src: "47443:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92201,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "47443:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "47442:15:177"
            },
            returnParameters: {
              id: 92205,
              nodeType: "ParameterList",
              parameters: [],
              src: "47481:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92259,
            nodeType: "FunctionDefinition",
            src: "47688:383:177",
            nodes: [],
            body: {
              id: 92258,
              nodeType: "Block",
              src: "47770:301:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    },
                    id: 92234,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92229,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92225,
                      src: "47843:6:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">=",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 92230,
                          name: "auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 89928,
                          src: "47853:11:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83136_storage_$",
                            typeString: "mapping(uint96 => struct IEncryptedMarginalPrice.AuctionData storage ref)"
                          }
                        },
                        id: 92232,
                        indexExpression: {
                          id: 92231,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92223,
                          src: "47865:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "47853:19:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83136_storage",
                          typeString: "struct IEncryptedMarginalPrice.AuctionData storage ref"
                        }
                      },
                      id: 92233,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "47873:9:177",
                      memberName: "nextBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83112,
                      src: "47853:29:177",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "47843:39:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92240,
                  nodeType: "IfStatement",
                  src: "47839:88:177",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 92236,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92223,
                          src: "47912:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 92237,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92225,
                          src: "47920:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        ],
                        id: 92235,
                        name: "Auction_InvalidBidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82708,
                        src: "47891:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$_t_uint96_$returns$__$",
                          typeString: "function (uint96,uint96) pure"
                        }
                      },
                      id: 92238,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "47891:36:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92239,
                    nodeType: "RevertStatement",
                    src: "47884:43:177"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 92251,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 92241,
                            name: "bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89948,
                            src: "47978:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                            }
                          },
                          id: 92243,
                          indexExpression: {
                            id: 92242,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92223,
                            src: "47983:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "47978:12:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                            typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                          }
                        },
                        id: 92245,
                        indexExpression: {
                          id: 92244,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92225,
                          src: "47991:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "47978:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                        }
                      },
                      id: 92246,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "47999:6:177",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83138,
                      src: "47978:27:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 92249,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "48017:1:177",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 92248,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "48009:7:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 92247,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "48009:7:177",
                          typeDescriptions: {}
                        }
                      },
                      id: 92250,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "48009:10:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "47978:41:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92257,
                  nodeType: "IfStatement",
                  src: "47974:90:177",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 92253,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92223,
                          src: "48049:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 92254,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92225,
                          src: "48057:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        ],
                        id: 92252,
                        name: "Auction_InvalidBidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82708,
                        src: "48028:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$_t_uint96_$returns$__$",
                          typeString: "function (uint96,uint96) pure"
                        }
                      },
                      id: 92255,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "48028:36:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92256,
                    nodeType: "RevertStatement",
                    src: "48021:43:177"
                  }
                }
              ]
            },
            baseFunctions: [89495],
            documentation: {
              id: 92221,
              nodeType: "StructuredDocumentation",
              src: "47649:34:177",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfBidInvalid",
            nameLocation: "47697:19:177",
            overrides: {
              id: 92227,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "47761:8:177"
            },
            parameters: {
              id: 92226,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92223,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "47724:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92259,
                  src: "47717:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92222,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "47717:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92225,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "47739:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92259,
                  src: "47732:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92224,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "47732:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "47716:30:177"
            },
            returnParameters: {
              id: 92228,
              nodeType: "ParameterList",
              parameters: [],
              src: "47770:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92284,
            nodeType: "FunctionDefinition",
            src: "48116:262:177",
            nodes: [],
            body: {
              id: 92283,
              nodeType: "Block",
              src: "48246:132:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 92277,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92270,
                      name: "caller_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92266,
                      src: "48303:7:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 92271,
                            name: "bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89948,
                            src: "48314:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                            }
                          },
                          id: 92273,
                          indexExpression: {
                            id: 92272,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92262,
                            src: "48319:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "48314:12:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                            typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                          }
                        },
                        id: 92275,
                        indexExpression: {
                          id: 92274,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92264,
                          src: "48327:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "48314:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                        }
                      },
                      id: 92276,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "48335:6:177",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83138,
                      src: "48314:27:177",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "48303:38:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92282,
                  nodeType: "IfStatement",
                  src: "48299:72:177",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 92279,
                          name: "caller_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92266,
                          src: "48363:7:177",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        id: 92278,
                        name: "NotPermitted",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83070,
                        src: "48350:12:177",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_address_$returns$__$",
                          typeString: "function (address) pure"
                        }
                      },
                      id: 92280,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "48350:21:177",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92281,
                    nodeType: "RevertStatement",
                    src: "48343:28:177"
                  }
                }
              ]
            },
            baseFunctions: [89505],
            documentation: {
              id: 92260,
              nodeType: "StructuredDocumentation",
              src: "48077:34:177",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfNotBidOwner",
            nameLocation: "48125:20:177",
            overrides: {
              id: 92268,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "48237:8:177"
            },
            parameters: {
              id: 92267,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92262,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "48162:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92284,
                  src: "48155:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92261,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "48155:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92264,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "48185:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92284,
                  src: "48178:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92263,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "48178:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92266,
                  mutability: "mutable",
                  name: "caller_",
                  nameLocation: "48209:7:177",
                  nodeType: "VariableDeclaration",
                  scope: 92284,
                  src: "48201:15:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 92265,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "48201:7:177",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "48145:77:177"
            },
            returnParameters: {
              id: 92269,
              nodeType: "ParameterList",
              parameters: [],
              src: "48246:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92310,
            nodeType: "FunctionDefinition",
            src: "48423:275:177",
            nodes: [],
            body: {
              id: 92309,
              nodeType: "Block",
              src: "48505:193:177",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_BidStatus_$83110",
                      typeString: "enum IEncryptedMarginalPrice.BidStatus"
                    },
                    id: 92301,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 92293,
                            name: "bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 89948,
                            src: "48580:4:177",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref))"
                            }
                          },
                          id: 92295,
                          indexExpression: {
                            id: 92294,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92287,
                            src: "48585:6:177",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "48580:12:177",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83148_storage_$",
                            typeString: "mapping(uint64 => struct IEncryptedMarginalPrice.Bid storage ref)"
                          }
                        },
                        id: 92297,
                        indexExpression: {
                          id: 92296,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92289,
                          src: "48593:6:177",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "48580:20:177",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83148_storage",
                          typeString: "struct IEncryptedMarginalPrice.Bid storage ref"
                        }
                      },
                      id: 92298,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "48601:6:177",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83147,
                      src: "48580:27:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      expression: {
                        id: 92299,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83110,
                        src: "48611:9:177",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83110_$",
                          typeString: "type(enum IEncryptedMarginalPrice.BidStatus)"
                        }
                      },
                      id: 92300,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "48621:7:177",
                      memberName: "Claimed",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83109,
                      src: "48611:17:177",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83110",
                        typeString: "enum IEncryptedMarginalPrice.BidStatus"
                      }
                    },
                    src: "48580:48:177",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92308,
                  nodeType: "IfStatement",
                  src: "48576:116:177",
                  trueBody: {
                    id: 92307,
                    nodeType: "Block",
                    src: "48630:62:177",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 92303,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92287,
                              src: "48666:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              id: 92304,
                              name: "bidId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92289,
                              src: "48674:6:177",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            ],
                            id: 92302,
                            name: "Bid_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83066,
                            src: "48651:14:177",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$_t_uint64_$returns$__$",
                              typeString: "function (uint96,uint64) pure"
                            }
                          },
                          id: 92305,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "48651:30:177",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 92306,
                        nodeType: "RevertStatement",
                        src: "48644:37:177"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [89513],
            documentation: {
              id: 92285,
              nodeType: "StructuredDocumentation",
              src: "48384:34:177",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfBidClaimed",
            nameLocation: "48432:19:177",
            overrides: {
              id: 92291,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "48496:8:177"
            },
            parameters: {
              id: 92290,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92287,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "48459:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92310,
                  src: "48452:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92286,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "48452:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92289,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "48474:6:177",
                  nodeType: "VariableDeclaration",
                  scope: 92310,
                  src: "48467:13:177",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92288,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "48467:6:177",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "48451:30:177"
            },
            returnParameters: {
              id: 92292,
              nodeType: "ParameterList",
              parameters: [],
              src: "48505:0:177"
            },
            scope: 92311,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          }
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 89893,
              name: "BatchAuctionModule",
              nameLocations: ["989:18:177"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 89550,
              src: "989:18:177"
            },
            id: 89894,
            nodeType: "InheritanceSpecifier",
            src: "989:18:177"
          },
          {
            baseName: {
              id: 89895,
              name: "IEncryptedMarginalPrice",
              nameLocations: ["1009:23:177"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 83248,
              src: "1009:23:177"
            },
            id: 89896,
            nodeType: "InheritanceSpecifier",
            src: "1009:23:177"
          }
        ],
        canonicalName: "EncryptedMarginalPrice",
        contractDependencies: [],
        contractKind: "contract",
        documentation: {
          id: 89892,
          nodeType: "StructuredDocumentation",
          src: "708:246:177",
          text: "@notice     Encrypted Marginal Price\n @dev        This batch auction module allows for bids to be encrypted off-chain, then stored, decrypted and settled on-chain.\n             Note that the maximum bid amount is bounded by uint96."
        },
        fullyImplemented: true,
        linearizedBaseContracts: [
          92311,
          83248,
          89550,
          88011,
          88991,
          82847,
          82691
        ],
        name: "EncryptedMarginalPrice",
        nameLocation: "963:22:177",
        scope: 92312,
        usedErrors: [
          82520,
          82524,
          82530,
          82536,
          82540,
          82542,
          82544,
          82546,
          82548,
          82550,
          82552,
          82556,
          82702,
          82708,
          82710,
          83056,
          83060,
          83066,
          83070,
          88891,
          88894,
          88899
        ]
      }
    ],
    license: "BSL-1.1"
  },
  id: 177
};

// src/abis/sources/FixedPriceBatch.json
var FixedPriceBatch_default = {
  abi: [
    {
      type: "constructor",
      inputs: [
        {
          name: "auctionHouse_",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "INIT",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "PARENT",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "TYPE",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint8",
          internalType: "enum Module.Type"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "VEECODE",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "abort",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "auction",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "params_",
          type: "tuple",
          internalType: "struct IAuction.AuctionParams",
          components: [
            {
              name: "start",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "duration",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "capacityInQuote",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "capacity",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "implParams",
              type: "bytes",
              internalType: "bytes"
            }
          ]
        },
        {
          name: "quoteTokenDecimals_",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "baseTokenDecimals_",
          type: "uint8",
          internalType: "uint8"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "auctionType",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint8",
          internalType: "enum IAuction.AuctionType"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "bid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidder_",
          type: "address",
          internalType: "address"
        },
        {
          name: "referrer_",
          type: "address",
          internalType: "address"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "auctionData_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "cancelAuction",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "capacityInQuote",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "claimBids",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidIds_",
          type: "uint64[]",
          internalType: "uint64[]"
        }
      ],
      outputs: [
        {
          name: "bidClaims",
          type: "tuple[]",
          internalType: "struct IBatchAuction.BidClaim[]",
          components: [
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "paid",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "payout",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "refund",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        },
        {
          name: "auctionOutput",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "dedicatedSettlePeriod",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getAuctionData",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "auctionData_",
          type: "tuple",
          internalType: "struct IFixedPriceBatch.AuctionData",
          components: [
            {
              name: "price",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IFixedPriceBatch.LotStatus"
            },
            {
              name: "nextBidId",
              type: "uint64",
              internalType: "uint64"
            },
            {
              name: "settlementCleared",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "totalBidAmount",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "minFilled",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "bid",
          type: "tuple",
          internalType: "struct IFixedPriceBatch.Bid",
          components: [
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "amount",
              type: "uint96",
              internalType: "uint96"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "status",
              type: "uint8",
              internalType: "enum IFixedPriceBatch.BidStatus"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBidClaim",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      outputs: [
        {
          name: "bidClaim",
          type: "tuple",
          internalType: "struct IBatchAuction.BidClaim",
          components: [
            {
              name: "bidder",
              type: "address",
              internalType: "address"
            },
            {
              name: "referrer",
              type: "address",
              internalType: "address"
            },
            {
              name: "paid",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "payout",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "refund",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBidIdAtIndex",
      inputs: [
        {
          name: "",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint64",
          internalType: "uint64"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getBidIds",
      inputs: [
        {
          name: "",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint64[]",
          internalType: "uint64[]"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getLot",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "tuple",
          internalType: "struct IAuction.Lot",
          components: [
            {
              name: "start",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "conclusion",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "quoteTokenDecimals",
              type: "uint8",
              internalType: "uint8"
            },
            {
              name: "baseTokenDecimals",
              type: "uint8",
              internalType: "uint8"
            },
            {
              name: "capacityInQuote",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "capacity",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "sold",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "purchased",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getNumBids",
      inputs: [
        {
          name: "",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getPartialFill",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "hasPartialFill",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "partialFill",
          type: "tuple",
          internalType: "struct IFixedPriceBatch.PartialFill",
          components: [
            {
              name: "bidId",
              type: "uint64",
              internalType: "uint64"
            },
            {
              name: "refund",
              type: "uint96",
              internalType: "uint96"
            },
            {
              name: "payout",
              type: "uint256",
              internalType: "uint256"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "hasEnded",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "isLive",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "isUpcoming",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotAuctionOutput",
      inputs: [
        {
          name: "",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "lotData",
      inputs: [
        {
          name: "id",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "start",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "conclusion",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "quoteTokenDecimals",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "baseTokenDecimals",
          type: "uint8",
          internalType: "uint8"
        },
        {
          name: "capacityInQuote",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "capacity",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "sold",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "purchased",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "minAuctionDuration",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "refundBid",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId_",
          type: "uint64",
          internalType: "uint64"
        },
        {
          name: "index_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "caller_",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [
        {
          name: "refund",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "remainingCapacity",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "setDedicatedSettlePeriod",
      inputs: [
        {
          name: "period_",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "setMinAuctionDuration",
      inputs: [
        {
          name: "duration_",
          type: "uint48",
          internalType: "uint48"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "settle",
      inputs: [
        {
          name: "lotId_",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "num_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "totalIn",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "totalOut",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "capacity",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "finished",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "auctionOutput",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "error",
      name: "Auction_AmountLessThanMinimum",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_DedicatedSettlePeriod",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InsufficientCapacity",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_InvalidBidId",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InvalidDuration",
      inputs: [
        {
          name: "duration_",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "minimum_",
          type: "uint48",
          internalType: "uint48"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InvalidLotId",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_InvalidParams",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_InvalidStart",
      inputs: [
        {
          name: "start_",
          type: "uint48",
          internalType: "uint48"
        },
        {
          name: "minimum_",
          type: "uint48",
          internalType: "uint48"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_LotActive",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_LotNotActive",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_LotNotConcluded",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Auction_NotAuthorized",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_NotBidder",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_NotImplemented",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_OnlyLotOwner",
      inputs: []
    },
    {
      type: "error",
      name: "Auction_WrongState",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        }
      ]
    },
    {
      type: "error",
      name: "Bid_WrongState",
      inputs: [
        {
          name: "lotId",
          type: "uint96",
          internalType: "uint96"
        },
        {
          name: "bidId",
          type: "uint64",
          internalType: "uint64"
        }
      ]
    },
    {
      type: "error",
      name: "Module_InvalidParent",
      inputs: [
        {
          name: "parent_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "Module_OnlyInternal",
      inputs: []
    },
    {
      type: "error",
      name: "Module_OnlyParent",
      inputs: [
        {
          name: "caller_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "NotPermitted",
      inputs: [
        {
          name: "caller",
          type: "address",
          internalType: "address"
        }
      ]
    }
  ],
  bytecode: {
    object: "0x60a06040523480156200001157600080fd5b50604051620033fd380380620033fd8339810160408190526200003491620000a5565b80806001600160a01b0381166200006d57604051631462ddc360e21b81526001600160a01b038216600482015260240160405180910390fd5b6001600160a01b03166080525050600080546201518065ffffffffffff199182168117909255600280549091169091179055620000d7565b600060208284031215620000b857600080fd5b81516001600160a01b0381168114620000d057600080fd5b9392505050565b6080516132936200016a6000396000818161029201528181610794015281816107db01528181610947015281816109b2015281816109f401528181610acd01528181610c8b01528181610ccd01528181610dc701528181610e0901528181611089015281816110cb015281816111cf0152818161121101528181611594015281816115d6015261171a01526132936000f3fe608060405234801561001057600080fd5b50600436106101e45760003560e01c80637d9234bc1161010f578063b04046df116100a2578063cd280bdb11610071578063cd280bdb1461064d578063d61735ca14610671578063d899a33714610688578063ea6439141461069c57600080fd5b8063b04046df146105f8578063bae96bdd1461060b578063bb24fe8a1461061e578063cadb33831461062d57600080fd5b8063a16f7ef7116100de578063a16f7ef71461054a578063a85cebb614610599578063a8bf44e4146105ab578063ace54da5146105cb57600080fd5b80637d9234bc146104e757806387698a31146105085780638f21c3181461051b578063994595e11461053b57600080fd5b80631ed75f1f11610187578063541348761161015657806354134876146103c25780635806afc3146103eb578063732efc03146104a65780637d7b6853146104b957600080fd5b80631ed75f1f146102e157806329da5abd146102f457806339792cdc146103075780634e1f42581461033a57600080fd5b80630a35511b116101c35780630a35511b1461024c5780630cd0bcf21461026d578063122b83f91461028d57806312d6ef2d146102cc57600080fd5b8062b33217146101e957806303855921146102165780630440ec5314610239575b600080fd5b6102006101f736600461283d565b60609392505050565b60405161020d9190612870565b60405180910390f35b6102296102243660046128bd565b6106a4565b604051901515815260200161020d565b6102296102473660046128bd565b6106ff565b61025f61025a3660046128d8565b610786565b60405161020d9291906129de565b61028061027b3660046128bd565b6108a2565b60405161020d9190612a35565b6102b47f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b03909116815260200161020d565b6102df6102da366004612a5e565b61093c565b005b6102df6102ef3660046128bd565b6109a7565b6102df610302366004612a5e565b610ac2565b6102296103153660046128bd565b6001600160601b0316600090815260016020526040902054600160701b900460ff1690565b61034d6103483660046128bd565b610b59565b60405161020d919060006101008201905065ffffffffffff8084511683528060208501511660208401525060ff604084015116604083015260ff606084015116606083015260808301511515608083015260a083015160a083015260c083015160c083015260e083015160e083015292915050565b6000546103d49065ffffffffffff1681565b60405165ffffffffffff909116815260200161020d565b6104596103f93660046128bd565b6001602081905260009182526040909120805491810154600282015460039092015465ffffffffffff80851694600160301b81049091169360ff600160601b8304811694600160681b8404821694600160701b9094049091169290919088565b6040805165ffffffffffff998a16815298909716602089015260ff958616968801969096529390921660608601521515608085015260a084015260c083015260e08201526101000161020d565b6102296104b43660046128bd565b610bf6565b6104cf6104c7366004612a79565b600092915050565b6040516001600160401b03909116815260200161020d565b6104fa6104f5366004612ad1565b610c7e565b60405190815260200161020d565b6104cf610516366004612b1e565b610dba565b61052e610529366004612bca565b610ee6565b60405161020d9190612bfd565b600160405161020d9190612c31565b61055d6105583660046128bd565b610f1b565b60408051921515835281516001600160401b03166020808501919091528201516001600160601b0316838201520151606082015260800161020d565b6002546103d49065ffffffffffff1681565b6105be6105b9366004612bca565b610fa2565b60405161020d9190612c44565b6104fa6105d93660046128bd565b6001600160601b03166000908152600160208190526040909120015490565b6102df6106063660046128bd565b61107e565b6102df610619366004612d20565b6111c4565b600060405161020d9190612e46565b61064061063b3660046128bd565b6114a8565b60405161020d9190612e5a565b61066061065b366004612a79565b611582565b60405161020d959493929190612eb1565b6040516530314650424160d01b815260200161020d565b6104fa6106963660046128bd565b50600090565b6102df61170f565b6001600160601b03811660009081526001602052604081205465ffffffffffff600160301b9091048116429091161015806106f957506001600160601b03821660009081526001602081905260409091200154155b92915050565b6001600160601b0381166000908152600160208190526040822001541580159061075457506001600160601b03821660009081526001602052604090205465ffffffffffff600160301b909104811642909116105b80156106f95750506001600160601b031660009081526001602052604090205465ffffffffffff908116429091161090565b606080336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146107d9576040516366e069e160e01b81523360048201526024015b60405180910390fd5b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa158015610837573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061085b9190612ede565b156108795760405163115250c560e21b815260040160405180910390fd5b6108828561175c565b61088b856117a7565b610896858585611801565b91509150935093915050565b600360205260009081526040902080546108bb90612efb565b80601f01602080910402602001604051908101604052809291908181526020018280546108e790612efb565b80156109345780601f1061090957610100808354040283529160200191610934565b820191906000526020600020905b81548152906001019060200180831161091757829003601f168201915b505050505081565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610987576040516366e069e160e01b81523360048201526024016107d0565b6000805465ffffffffffff191665ffffffffffff92909216919091179055565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146109f2576040516366e069e160e01b81523360048201526024016107d0565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa158015610a50573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610a749190612ede565b15610a925760405163115250c560e21b815260040160405180910390fd5b610a9b8161175c565b610aa4816119b9565b610aad81611a38565b610ab681611ac4565b610abf81611b1e565b50565b336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610b0d576040516366e069e160e01b81523360048201526024016107d0565b62093a808165ffffffffffff161115610b3957604051633350f82560e11b815260040160405180910390fd5b6002805465ffffffffffff191665ffffffffffff92909216919091179055565b610b6161279c565b506001600160601b0316600090815260016020818152604092839020835161010081018552815465ffffffffffff8082168352600160301b8204169382019390935260ff600160601b8404811695820195909552600160681b830485166060820152600160701b909204909316151560808201529082015460a0820152600282015460c082015260039091015460e082015290565b6001600160601b03811660009081526001602081905260408220015415801590610c4b57506001600160601b03821660009081526001602052604090205465ffffffffffff600160301b909104811642909116105b80156106f95750506001600160601b031660009081526001602052604090205465ffffffffffff90811642909116101590565b6000336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610ccb576040516366e069e160e01b81523360048201526024016107d0565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa158015610d29573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d4d9190612ede565b15610d6b5760405163115250c560e21b815260040160405180910390fd5b610d748561175c565b610d7d85611b47565b610d878585611b98565b610d92858584611c6c565b610d9c8585611cd4565b610da585611d5a565b610db185858585611df7565b95945050505050565b6000336001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610e07576040516366e069e160e01b81523360048201526024016107d0565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa158015610e65573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e899190612ede565b15610ea75760405163115250c560e21b815260040160405180910390fd5b610eb08761175c565b610eb987611b47565b610ec287611d5a565b610ecb87611ac4565b610ed9878787878787611e8b565b90505b9695505050505050565b610eee6127e0565b610ef78361175c565b610f00836117a7565b610f0a8383611b98565b610f148383612198565b9392505050565b60408051606081018252600080825260208201819052918101829052610f408361175c565b610f49836117a7565b50506001600160601b03908116600090815260066020908152604091829020825160608101845281546001600160401b038116808352600160401b90910490951692810192909252600101549181019190915290151591565b610fca6040805160808101825260008082526020820181905291810182905290606082015290565b610fd38361175c565b610fdd8383611b98565b6001600160601b0383811660009081526005602090815260408083206001600160401b0387168452825291829020825160808101845281546001600160a01b038082168352600160a01b918290049096169382019390935260018083015495861694820194909452939092606085019290910460ff169081111561106357611063612c0b565b600181111561107457611074612c0b565b9052509392505050565b336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146110c9576040516366e069e160e01b81523360048201526024016107d0565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa158015611127573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061114b9190612ede565b156111695760405163115250c560e21b815260040160405180910390fd5b6111728161175c565b61117b81611d5a565b611184816123a6565b6001600160601b03166000908152600160208190526040822080546bffffffffffff0000000000001916600160301b4265ffffffffffff16021781550155565b336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161461120f576040516366e069e160e01b81523360048201526024016107d0565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa15801561126d573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906112919190612ede565b156112af5760405163115250c560e21b815260040160405180910390fd5b825165ffffffffffff16158015906112d25750825165ffffffffffff4281169116105b15611306578251604051639421aa8960e01b815265ffffffffffff91821660048201524290911660248201526044016107d0565b600054602084015165ffffffffffff918216911610156113535760208301516000546040516302c1012760e21b815265ffffffffffff9283166004820152911660248201526044016107d0565b61135b61279c565b835165ffffffffffff1615611371578351611373565b425b65ffffffffffff16808252602085015161138c91612f4b565b65ffffffffffff16602082015260ff8084166040808401919091529083166060808401919091529085015115156080808401919091529085015160a08301528401516113db90869083906123af565b6001600160601b039490941660009081526001602081815260409283902087518154928901519489015160608a015160808b015165ffffffffffff9384166bffffffffffffffffffffffff1990961695909517600160301b93909716929092029590951761ffff60601b1916600160601b60ff9687160260ff60681b191617600160681b95909116949094029390931760ff60701b1916600160701b9115159190910217825560a08601519082015560c0850151600282015560e090940151600390940193909355505050565b6040805160c081018252600080825260208201819052918101829052606081018290526080810182905260a08101919091526114e38261175c565b6001600160601b038216600090815260046020908152604091829020825160c0810190935280548352600180820154919284019160ff169081111561152a5761152a612c0b565b600181111561153b5761153b612c0b565b8152600182015461010081046001600160401b03166020830152600160481b900460ff16151560408201526002820154606082015260039091015460809091015292915050565b60008080806060336001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016146115d4576040516366e069e160e01b81523360048201526024016107d0565b7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316635c774ed76040518163ffffffff1660e01b8152600401602060405180830381865afa158015611632573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116569190612ede565b156116745760405163115250c560e21b815260040160405180910390fd5b61167d8761175c565b61168687611b47565b61168f8761247d565b61169887611ac4565b6001600160601b03871660009081526001602052604090206116ba8888612539565b6001600160601b038c166000908152600160209081526040808320600380820189905560029091018790559091529020939950919750945092506116fe8382612fb8565b506001015492509295509295909350565b336001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000161461175a576040516366e069e160e01b81523360048201526024016107d0565b565b6001600160601b03811660009081526001602052604081205465ffffffffffff169003610abf57604051638c54233f60e01b81526001600160601b03821660048201526024016107d0565b6001600160601b038116600090815260046020526040902060019081015460ff16818111156117d8576117d8612c0b565b14610abf57604051636985f4c960e11b81526001600160601b03821660048201526024016107d0565b60608082806001600160401b0381111561181d5761181d612c93565b60405190808252806020026020018201604052801561185657816020015b6118436127e0565b81526020019060019003908161183b5790505b50925060005b818110156119af576118948787878481811061187a5761187a613077565b905060200201602081019061188f919061308d565b611b98565b6118c4878787848181106118aa576118aa613077565b90506020020160208101906118bf919061308d565b611cd4565b6001600160601b03871660009081526005602052604081206001918888858181106118f1576118f1613077565b9050602002016020810190611906919061308d565b6001600160401b03166001600160401b0316815260200190815260200160002060010160146101000a81548160ff0219169083600181111561194a5761194a612c0b565b021790555061197f8787878481811061196557611965613077565b905060200201602081019061197a919061308d565b612198565b84828151811061199157611991613077565b602002602001018190525080806119a7906130a8565b91505061185c565b5050935093915050565b6001600160601b03811660009081526001602052604090205465ffffffffffff600160301b909104811642909116108015611a0f57506001600160601b0381166000908152600160208190526040909120015415155b15610abf5760405163f7babce560e01b81526001600160601b03821660048201526024016107d0565b6001600160601b03811660009081526001602052604090205465ffffffffffff600160301b90910481169042168111801590611a975750600254611a849065ffffffffffff1682612f4b565b65ffffffffffff164265ffffffffffff16105b15611ac057604051630340ca2960e11b81526001600160601b03831660048201526024016107d0565b5050565b6001600160601b038116600090815260046020526040902060019081015460ff1681811115611af557611af5612c0b565b03610abf57604051636985f4c960e11b81526001600160601b03821660048201526024016107d0565b6001600160601b031660009081526004602052604090206001908101805460ff19169091179055565b6001600160601b03811660009081526001602052604090205465ffffffffffff908116429091161015610abf576040516306f6ec2760e31b81526001600160601b03821660048201526024016107d0565b6001600160601b0382166000908152600460205260409020600101546001600160401b03610100909104811690821610611bff576040516322a16ebf60e01b81526001600160601b03831660048201526001600160401b03821660248201526044016107d0565b6001600160601b03821660009081526005602090815260408083206001600160401b03851684529091529020546001600160a01b0316611ac0576040516322a16ebf60e01b81526001600160601b03831660048201526001600160401b03821660248201526044016107d0565b6001600160601b03831660009081526005602090815260408083206001600160401b03861684529091529020546001600160a01b03828116911614611ccf576040516319b1d90760e31b81526001600160a01b03821660048201526024016107d0565b505050565b60016001600160601b03831660009081526005602090815260408083206001600160401b03861684529091529020600190810154600160a01b900460ff1690811115611d2257611d22612c0b565b03611ac057604051631359755560e11b81526001600160601b03831660048201526001600160401b03821660248201526044016107d0565b6001600160601b03811660009081526001602052604090205465ffffffffffff600160301b90910481164290911610611db1576040516306f6ec2760e31b81526001600160601b03821660048201526024016107d0565b6001600160601b0381166000908152600160208190526040822001549003610abf576040516306f6ec2760e31b81526001600160601b03821660048201526024016107d0565b6001600160601b0384166000908152600460209081526040808320600583528184206001600160401b038816855290925282206001808201805460ff60a01b1916600160a01b8302179055508054600283018054600160a01b9092046001600160601b031691600090611e6b9084906130c1565b909155505054600160a01b90046001600160601b03169695505050505050565b6000831580611ea057506001600160601b0384115b15611ebe57604051633350f82560e11b815260040160405180910390fd5b6001600160601b038716600090815260016020818152604080842083015460049092528320808301805492949193919261010090046001600160401b031691611f06836130d4565b91906101000a8154816001600160401b0302191690836001600160401b031602179055509050600087905060405180608001604052808b6001600160a01b03168152602001826001600160601b031681526020018a6001600160a01b0316815260200160006001811115611f7c57611f7c612c0b565b90526001600160601b03808d1660009081526005602090815260408083206001600160401b0388168452825291829020845191850151909316600160a01b9081026001600160a01b039283161784559184015160018085018054929093166001600160a01b03198316811784556060870151946001600160a81b0319909316179190849081111561200f5761200f612c0b565b02179055509050508783600201600082825461202b91906130fa565b90915550506001600160601b038b1660009081526001602052604081205461205e90600160681b900460ff16600a6131f1565b90506000612075856002015483876000015461262a565b90508581101561208d57839650505050505050610edc565b8581111561214b576120a784878386868a600001546126d1565b6001600160601b038e8116600090815260066020908152604080832085518154938701516001600160401b039091166001600160a01b031990941693909317600160401b93861684021780825595909101516001909101556002890180549190940490921692916121199084906130c1565b90915550506002850154855460009161213391859061262a565b9050856003015481101561214957600386018190555b505b5050506001600160601b0399909916600090815260016020526040902080546bffffffffffff0000000000001916600160301b4265ffffffffffff16021790555096979650505050505050565b6121a06127e0565b6001600160601b0383811660009081526005602090815260408083206001600160401b03871684528252808320815160808101835281546001600160a01b038082168352600160a01b918290049097169482019490945260018083015496871693820193909352939490926060850192910460ff169081111561222557612225612c0b565b600181111561223657612236612c0b565b90525080516001600160a01b0390811684526040808301519091166020808601919091526001600160601b038716600090815260049091522060010154909150600160481b900460ff1615612379576001600160601b0384166000908152600660205260409020546001600160401b038085169116036122fd576020808201516001600160601b03908116604080860191909152868216600081815260068086529281206001810154606089015291905292529054600160401b900416608083015261239f565b602081810180516001600160601b03908116604086810191909152915187821660009081526001909452919092205461236892919091169061234a90600160681b900460ff16600a6131f1565b6001600160601b03871660009081526004602052604090205461262a565b60608301526000608083015261239f565b6020810180516001600160601b0390811660408501526000606085015290511660808301525b5092915050565b611b1e8161247d565b6000818060200190518101906123c59190613200565b80519091506000036123ea57604051633350f82560e11b815260040160405180910390fd5b61271065ffffffffffff16816020015162ffffff16111561241e57604051633350f82560e11b815260040160405180910390fd5b6001600160601b03841660009081526004602090815260409091208251815560018101805468ffffffffffffffff00191661010017905560a08501519183015190916124719162ffffff1661271061276e565b60039091015550505050565b6001600160601b038116600090815260046020526040812060019081015460ff16908111156124ae576124ae612c0b565b1480156124dd57506001600160601b0381166000908152600160205260409020544265ffffffffffff90911611155b801561251057506001600160601b03811660009081526001602052604090205442600160301b90910465ffffffffffff16115b15610abf57604051636985f4c960e11b81526001600160601b03821660048201526024016107d0565b6001600160601b03821660009081526004602090815260408083206001808201805460ff19168217905560029091015492528220548291829160609183916125af919061259190600160681b900460ff16600a6131f1565b6001600160601b038a1660009081526004602052604090205461262a565b6001600160601b0388166000908152600460205260409020600301549091508110156125df575060019150612621565b6001600160601b03871660009081526004602052604090206001818101805469ff0000000000000000001916600160481b179055600290910154955090935091505b92959194509250565b6000838302600019848609818110820190038061265f57836126545763ae47f7026000526004601cfd5b508290049050610f14565b8084116126745763ae47f7026000526004601cfd5b83858709600085810386169586900495848311909303908390038390046001010292030417600383026002908118808502820302808502820302808502820302808502820302808502820302808502909103020290509392505050565b60408051606081018252600080825260208201819052918101829052906127026001600160601b038616858561262a565b9050600061271088886130c1565b90506000612728876001600160601b0316838561262a565b9050600061273683856130c1565b604080516060810182526001600160401b038e1681526001600160601b03909416602085015283015250925050509695505050505050565b600061277b84848461262a565b90508183850915610f145760010180610f145763ae47f7026000526004601cfd5b6040805161010081018252600080825260208201819052918101829052606081018290526080810182905260a0810182905260c0810182905260e081019190915290565b6040518060a0016040528060006001600160a01b0316815260200160006001600160a01b031681526020016000815260200160008152602001600081525090565b80356001600160601b038116811461283857600080fd5b919050565b60008060006060848603121561285257600080fd5b61285b84612821565b95602085013595506040909401359392505050565b6020808252825182820181905260009190848201906040850190845b818110156128b15783516001600160401b03168352928401929184019160010161288c565b50909695505050505050565b6000602082840312156128cf57600080fd5b610f1482612821565b6000806000604084860312156128ed57600080fd5b6128f684612821565b925060208401356001600160401b038082111561291257600080fd5b818601915086601f83011261292657600080fd5b81358181111561293557600080fd5b8760208260051b850101111561294a57600080fd5b6020830194508093505050509250925092565b80516001600160a01b039081168352602080830151909116908301526040808201519083015260608082015190830152608090810151910152565b6000815180845260005b818110156129be576020818501810151868301820152016129a2565b506000602082860101526020601f19601f83011685010191505092915050565b604080825283519082018190526000906020906060840190828701845b82811015612a2157612a0e84835161295d565b60a09390930192908401906001016129fb565b50505083810382850152610edc8186612998565b602081526000610f146020830184612998565b803565ffffffffffff8116811461283857600080fd5b600060208284031215612a7057600080fd5b610f1482612a48565b60008060408385031215612a8c57600080fd5b612a9583612821565b946020939093013593505050565b80356001600160401b038116811461283857600080fd5b80356001600160a01b038116811461283857600080fd5b60008060008060808587031215612ae757600080fd5b612af085612821565b9350612afe60208601612aa3565b925060408501359150612b1360608601612aba565b905092959194509250565b60008060008060008060a08789031215612b3757600080fd5b612b4087612821565b9550612b4e60208801612aba565b9450612b5c60408801612aba565b93506060870135925060808701356001600160401b0380821115612b7f57600080fd5b818901915089601f830112612b9357600080fd5b813581811115612ba257600080fd5b8a6020828501011115612bb457600080fd5b6020830194508093505050509295509295509295565b60008060408385031215612bdd57600080fd5b612be683612821565b9150612bf460208401612aa3565b90509250929050565b60a081016106f9828461295d565b634e487b7160e01b600052602160045260246000fd5b60028110610abf57610abf612c0b565b60208101612c3e83612c21565b91905290565b81516001600160a01b0390811682526020808401516001600160601b0316908301526040808401519091169082015260608201516080820190612c8681612c21565b8060608401525092915050565b634e487b7160e01b600052604160045260246000fd5b60405160a081016001600160401b0381118282101715612ccb57612ccb612c93565b60405290565b604051601f8201601f191681016001600160401b0381118282101715612cf957612cf9612c93565b604052919050565b8015158114610abf57600080fd5b803560ff8116811461283857600080fd5b60008060008060808587031215612d3657600080fd5b612d3f85612821565b93506020808601356001600160401b0380821115612d5c57600080fd5b9087019060a0828a031215612d7057600080fd5b612d78612ca9565b612d8183612a48565b8152612d8e848401612a48565b848201526040830135612da081612d01565b604082015260608381013590820152608083013582811115612dc157600080fd5b80840193505089601f840112612dd657600080fd5b823582811115612de857612de8612c93565b612dfa601f8201601f19168601612cd1565b92508083528a85828601011115612e1057600080fd5b80858501868501376000908301909401939093526080830152509250612e3860408601612d0f565b9150612b1360608601612d0f565b6020810160048310612c3e57612c3e612c0b565b81518152602082015160c0820190612e7181612c21565b806020840152506001600160401b0360408401511660408301526060830151151560608301526080830151608083015260a083015160a083015292915050565b858152846020820152836040820152821515606082015260a060808201526000610ed960a0830184612998565b600060208284031215612ef057600080fd5b8151610f1481612d01565b600181811c90821680612f0f57607f821691505b602082108103612f2f57634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fd5b65ffffffffffff81811683821601908082111561239f5761239f612f35565b601f821115611ccf57600081815260208120601f850160051c81016020861015612f915750805b601f850160051c820191505b81811015612fb057828155600101612f9d565b505050505050565b81516001600160401b03811115612fd157612fd1612c93565b612fe581612fdf8454612efb565b84612f6a565b602080601f83116001811461301a57600084156130025750858301515b600019600386901b1c1916600185901b178555612fb0565b600085815260208120601f198616915b828110156130495788860151825594840194600190910190840161302a565b50858210156130675787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b634e487b7160e01b600052603260045260246000fd5b60006020828403121561309f57600080fd5b610f1482612aa3565b6000600182016130ba576130ba612f35565b5060010190565b818103818111156106f9576106f9612f35565b60006001600160401b038083168181036130f0576130f0612f35565b6001019392505050565b808201808211156106f9576106f9612f35565b600181815b8085111561314857816000190482111561312e5761312e612f35565b8085161561313b57918102915b93841c9390800290613112565b509250929050565b60008261315f575060016106f9565b8161316c575060006106f9565b8160018114613182576002811461318c576131a8565b60019150506106f9565b60ff84111561319d5761319d612f35565b50506001821b6106f9565b5060208310610133831016604e8410600b84101617156131cb575081810a6106f9565b6131d5838361310d565b80600019048211156131e9576131e9612f35565b029392505050565b6000610f1460ff841683613150565b60006040828403121561321257600080fd5b604051604081018181106001600160401b038211171561323457613234612c93565b60405282518152602083015162ffffff8116811461325157600080fd5b6020820152939250505056fea264697066735822122012f36555fad138600b3f145ef0624382ac8560a1fb24bd9d160be7722f910e5f64736f6c63430008130033",
    sourceMap: "642:19793:178:-:0;;;1380:274;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1429:13;;-1:-1:-1;;;;;11238:21:173;;11234:63;;11268:29;;-1:-1:-1;;;11268:29:173;;-1:-1:-1;;;;;473:32:264;;11268:29:173;;;455:51:264;428:18;;11268:29:173;;;;;;;11234:63;-1:-1:-1;;;;;11308:16:173;;;-1:-1:-1;;1517:18:178::1;:27:::0;;1538:6:::1;-1:-1:-1::0;;1517:27:178;;::::1;::::0;::::1;::::0;;;1617:21:::1;:30:::0;;;;::::1;::::0;;::::1;::::0;;642:19793;;14:290:264;84:6;137:2;125:9;116:7;112:23;108:32;105:52;;;153:1;150;143:12;105:52;179:16;;-1:-1:-1;;;;;224:31:264;;214:42;;204:70;;270:1;267;260:12;204:70;293:5;14:290;-1:-1:-1;;;14:290:264:o;309:203::-;642:19793:178;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;",
    linkReferences: {}
  },
  deployedBytecode: {
    object: "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",
    sourceMap: "642:19793:178:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;15775:96;;;;;;:::i;:::-;15852:15;15775:96;;;;;;;;;;;;;:::i;:::-;;;;;;;;5523:191:169;;;;;;:::i;:::-;;:::i;:::-;;;1537:14:264;;1530:22;1512:41;;1500:2;1485:18;5523:191:169;1372:187:264;5217:271:169;;;;;;:::i;:::-;;:::i;5231:438:175:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;:::i;592:48::-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;11114:31:173:-;;;;;;;;-1:-1:-1;;;;;4289:32:264;;;4271:51;;4259:2;4244:18;11114:31:173;4125:203:264;6456:116:169;;;;;;:::i;:::-;;:::i;:::-;;9712:345:175;;;;;;:::i;:::-;;:::i;10499:243::-;;;;;;:::i;:::-;;:::i;5915:133:169:-;;;;;;:::i;:::-;-1:-1:-1;;;;;6010:15:169;5987:4;6010:15;;;:7;:15;;;;;:31;-1:-1:-1;;;6010:31:169;;;;;5915:133;6083:114;;;;;;:::i;:::-;;:::i;:::-;;;;;;4830:4:264;4872:3;4861:9;4857:19;4849:27;;4895:14;4955:2;4946:6;4940:13;4936:22;4925:9;4918:41;5027:2;5019:4;5011:6;5007:17;5001:24;4997:33;4990:4;4979:9;4975:20;4968:63;;5099:4;5091;5083:6;5079:17;5073:24;5069:35;5062:4;5051:9;5047:20;5040:65;5173:4;5165;5157:6;5153:17;5147:24;5143:35;5136:4;5125:9;5121:20;5114:65;5249:4;5241:6;5237:17;5231:24;5224:32;5217:40;5210:4;5199:9;5195:20;5188:70;5314:4;5306:6;5302:17;5296:24;5289:4;5278:9;5274:20;5267:54;5377:4;5369:6;5365:17;5359:24;5352:4;5341:9;5337:20;5330:54;5440:4;5432:6;5428:17;5422:24;5415:4;5404:9;5400:20;5393:54;4694:759;;;;;480:32:169;;;;;;;;;;;;5632:14:264;5620:27;;;5602:46;;5590:2;5575:18;480:32:169;5458:196:264;548:44:169;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;548:44:169;;;;;;;-1:-1:-1;;;548:44:169;;;;;-1:-1:-1;;;548:44:169;;;;;-1:-1:-1;;;548:44:169;;;;;;;;;;;;;;;;5994:14:264;6035:15;;;6017:34;;6087:15;;;;6082:2;6067:18;;6060:43;6151:4;6139:17;;;6119:18;;;6112:45;;;;6193:17;;;;6188:2;6173:18;;6166:45;6255:14;6248:22;6242:3;6227:19;;6220:51;6302:3;6287:19;;6280:35;6346:3;6331:19;;6324:35;6390:3;6375:19;;6368:35;5971:3;5956:19;548:44:169;5659:750:264;4914:268:169;;;;;;:::i;:::-;;:::i;16026:84:178:-;;;;;;:::i;:::-;16100:6;16026:84;;;;;;;;-1:-1:-1;;;;;6833:31:264;;;6815:50;;6803:2;6788:18;16026:84:178;6671:200:264;3471:591:175;;;;;;:::i;:::-;;:::i;:::-;;;7780:25:264;;;7768:2;7753:18;3471:591:175;7634:177:264;1351:529:175;;;;;;:::i;:::-;;:::i;16361:306:178:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;676:109:175:-;761:17;676:109;;;;;;:::i;14890:371:178:-;;;;;;:::i;:::-;;:::i;:::-;;;;9974:14:264;;9967:22;9949:41;;10030:13;;-1:-1:-1;;;;;10026:38:264;10021:2;10006:18;;;9999:66;;;;10111:15;;10105:22;-1:-1:-1;;;;;10101:55:264;10081:18;;;10074:83;10199:15;10193:22;10188:2;10173:18;;10166:50;9936:3;9921:19;14890:371:178;9720:502:264;516:35:175;;;;;;;;;14048:213:178;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;5749:131:169:-;;;;;;:::i;:::-;-1:-1:-1;;;;;5849:15:169;5823:7;5849:15;;;:7;:15;;;;;;;;:24;;;5749:131;3790:445;;;;;;:::i;:::-;;:::i;1482:1209::-;;;;;;:::i;:::-;;:::i;736:88::-;782:4;736:88;;;;;;:::i;14394:222:178:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;6967:940:175:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;;;:::i;1687:101:178:-;;;-1:-1:-1;;;15001:58:264;;14989:2;14974:18;1687:101:178;14827:238:264;15549:71:178;;;;;;:::i;:::-;-1:-1:-1;15609:7:178;;15549:71;13040:46:173;;;:::i;5523:191:169:-;-1:-1:-1;;;;;5648:15:169;;5586:4;5648:15;;;:7;:15;;;;;:26;;-1:-1:-1;;;5648:26:169;;;;;5628:15;5621:53;;;;;;:86;;-1:-1:-1;;;;;;5678:15:169;;;;;;:7;:15;;;;;;;;:24;;:29;5621:86;5602:105;5523:191;-1:-1:-1;;5523:191:169:o;5217:271::-;-1:-1:-1;;;;;5319:15:169;;5282:4;5319:15;;;:7;:15;;;;;;;:24;;:29;;;;:85;;-1:-1:-1;;;;;;5378:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;5378:26:169;;;;;5359:15;5352:52;;;;5319:85;:152;;;;-1:-1:-1;;;;;;;5450:15:169;;;;;:7;:15;;;;;:21;;;;;5431:15;5424:47;;;;;5217:271::o;5231:438:175:-;5402:27;;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;;;;;;;;11964:62;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;5504:27:175::1;5524:6;5504:19;:27::i;:::-;5541:30;5564:6;5541:22;:30::i;:::-;5635:27;5646:6;5654:7;;5635:10;:27::i;:::-;5628:34;;;;5231:438:::0;;;;;;:::o;592:48::-;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;6456:116:169:-;11501:10:173;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;4271:51:264;4244:18;;11530:29:173;4125:203:264;11497:62:173;6535:18:169::1;:30:::0;;-1:-1:-1;;6535:30:169::1;;::::0;;;::::1;::::0;;;::::1;::::0;;6456:116::o;9712:345:175:-;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;4125:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;9822:27:175::1;9842:6;9822:19;:27::i;:::-;9859:35;9887:6;9859:27;:35::i;:::-;9904:38;9935:6;9904:30;:38::i;:::-;9952:27;9972:6;9952:19;:27::i;:::-;10036:14;10043:6;10036;:14::i;:::-;9712:345:::0;:::o;10499:243::-;11501:10:173;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;4271:51:264;4244:18;;11530:29:173;4125:203:264;11497:62:173;10655:6:175::1;10645:7;:16;;;10641:52;;;10670:23;;-1:-1:-1::0;;;10670:23:175::1;;;;;;;;;;;10641:52;10704:21;:31:::0;;-1:-1:-1;;10704:31:175::1;;::::0;;;::::1;::::0;;;::::1;::::0;;10499:243::o;6083:114:169:-;6146:10;;:::i;:::-;-1:-1:-1;;;;;;6175:15:169;;;;;:7;:15;;;;;;;;;6168:22;;;;;;;;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;-1:-1:-1;;;6168:22:169;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6083:114::o;4914:268::-;-1:-1:-1;;;;;5012:15:169;;4975:4;5012:15;;;:7;:15;;;;;;;:24;;:29;;;;:85;;-1:-1:-1;;;;;;5071:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;5071:26:169;;;;;5052:15;5045:52;;;;5012:85;:153;;;;-1:-1:-1;;;;;;;5144:15:169;;;;;:7;:15;;;;;:21;;;;;5124:15;5117:48;;;;;;4914:268::o;3471:591:175:-;3639:14;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;4125:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;3696:27:175::1;3716:6;3696:19;:27::i;:::-;3733:31;3757:6;3733:23;:31::i;:::-;3774:35;3794:6;3802;3774:19;:35::i;:::-;3819:45;3840:6;3848;3856:7;3819:20;:45::i;:::-;3874:35;3894:6;3902;3874:19;:35::i;:::-;3919:29;3941:6;3919:21;:29::i;:::-;4012:43;4023:6;4031;4039;4047:7;4012:10;:43::i;:::-;4005:50:::0;3471:591;-1:-1:-1;;;;;3471:591:175:o;1351:529::-;1555:12;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;4125:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;1610:27:175::1;1630:6;1610:19;:27::i;:::-;1647:31;1671:6;1647:23;:31::i;:::-;1688:29;1710:6;1688:21;:29::i;:::-;1727:27;1747:6;1727:19;:27::i;:::-;1818:55;1823:6;1831:7;1840:9;1851:7;1860:12;;1818:4;:55::i;:::-;1811:62;;12117:1:173;1351:529:175::0;;;;;;;;:::o;16361:306:178:-;16466:24;;:::i;:::-;16502:27;16522:6;16502:19;:27::i;:::-;16539:30;16562:6;16539:22;:30::i;:::-;16579:35;16599:6;16607;16579:19;:35::i;:::-;16632:28;16645:6;16653;16632:12;:28::i;:::-;16625:35;16361:306;-1:-1:-1;;;16361:306:178:o;14890:371::-;-1:-1:-1;;;;;;;;14976:19:178;-1:-1:-1;;;;;;;;;;;;;;;15043:27:178;15063:6;15043:19;:27::i;:::-;15080:30;15103:6;15080:22;:30::i;:::-;-1:-1:-1;;;;;;;15135:23:178;;;;;;;:15;:23;;;;;;;;;15121:37;;;;;;;;;-1:-1:-1;;;;;15121:37:178;;;;;-1:-1:-1;;;15121:37:178;;;;;;;;;;;;;;;;;;;;;;;15185:22;;;;14890:371::o;14048:213::-;14117:14;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14117:14:178;14143:27;14163:6;14143:19;:27::i;:::-;14180:35;14200:6;14208;14180:19;:35::i;:::-;-1:-1:-1;;;;;14233:13:178;;;;;;;:5;:13;;;;;;;;-1:-1:-1;;;;;14233:21:178;;;;;;;;;;14226:28;;;;;;;;;-1:-1:-1;;;;;14226:28:178;;;;;-1:-1:-1;;;14226:28:178;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14233:21;;14226:28;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;-1:-1:-1;14226:28:178;14048:213;-1:-1:-1;;;14048:213:178:o;3790:445:169:-;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;4125:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;3899:27:169::1;3919:6;3899:19;:27::i;:::-;3936:29;3958:6;3936:21;:29::i;:::-;4063:22;4078:6;4063:14;:22::i;:::-;-1:-1:-1::0;;;;;4136:15:169::1;4118;4136::::0;;;:7:::1;:15;::::0;;;;;;4162:40;;-1:-1:-1;;4162:40:169::1;-1:-1:-1::0;;;4186:15:169::1;4162:40;;;;::::0;;4212:12:::1;:16:::0;3790:445::o;1482:1209::-;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;4125:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;1740:13:169;;:17:::1;;::::0;;;;:60:::1;;-1:-1:-1::0;1761:13:169;;:39:::1;1784:15;1761:39:::0;::::1;::::0;::::1;;1740:60;1736:158;;;1844:13:::0;;1823:60:::1;::::0;-1:-1:-1;;;1823:60:169;;15885:14:264;15926:15;;;1823:60:169::1;::::0;::::1;15908:34:264::0;1866:15:169::1;15978::264::0;;;15958:18;;;15951:43;15848:18;;1823:60:169::1;15705:295:264::0;1736:158:169::1;1977:18;::::0;1958:16:::1;::::0;::::1;::::0;1977:18:::1;::::0;;::::1;1958:37:::0;::::1;;1954:136;;;2042:16;::::0;::::1;::::0;2060:18:::1;::::0;2018:61:::1;::::0;-1:-1:-1;;;2018:61:169;;2060:18:::1;15926:15:264::0;;;2018:61:169::1;::::0;::::1;15908:34:264::0;2060:18:169;::::1;15958::264::0;;;15951:43;15848:18;;2018:61:169::1;15705:295:264::0;1954:136:169::1;2135:14;;:::i;:::-;2171:13:::0;;:18:::1;;::::0;:60:::1;;2218:13:::0;;2171:60:::1;;;2199:15;2171:60;2159:72;;::::0;;;2270:16:::1;::::0;::::1;::::0;2258:28:::1;::::0;::::1;:::i;:::-;2241:45;;:14;::::0;::::1;:45:::0;2296:44:::1;::::0;;::::1;:22;::::0;;::::1;:44:::0;;;;2350:42;;::::1;:21;::::0;;::::1;:42:::0;;;;2424:23;;::::1;::::0;2402:45:::1;;:19;::::0;;::::1;:45:::0;;;;2472:16;;::::1;::::0;2457:12:::1;::::0;::::1;:31:::0;2607:18;::::1;::::0;2585:41:::1;::::0;2594:6;;2241:3;;2585:8:::1;:41::i;:::-;-1:-1:-1::0;;;;;2663:15:169;;;::::1;;::::0;;;:7:::1;:15;::::0;;;;;;;;:21;;;;;;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;::::1;-1:-1:-1::0;;2663:21:169;;;;;;;-1:-1:-1;;;2663:21:169;;;::::1;::::0;;;::::1;::::0;;;::::1;-1:-1:-1::0;;;;2663:21:169;-1:-1:-1;;;2663:21:169::1;::::0;;::::1;;-1:-1:-1::0;;;;2663:21:169;;-1:-1:-1;;;2663:21:169;;;::::1;::::0;;;::::1;::::0;;;::::1;-1:-1:-1::0;;;;2663:21:169::1;-1:-1:-1::0;;;2663:21:169;::::1;;::::0;;;::::1;;::::0;;::::1;::::0;::::1;::::0;;;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;::::1;::::0;;::::1;::::0;::::1;::::0;;::::1;::::0;;;;-1:-1:-1;;;1482:1209:169:o;14394:222:178:-;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;14544:27:178;14564:6;14544:19;:27::i;:::-;-1:-1:-1;;;;;14589:20:178;;;;;;:12;:20;;;;;;;;;14582:27;;;;;;;;;;;;;;;;;14589:20;;14582:27;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;;;;;;;;-1:-1:-1;;;;;14582:27:178;;;;;-1:-1:-1;;;14582:27:178;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;14394:222:178:o;6967:940:175:-;7135:15;;;;7251:26;11968:10:173;-1:-1:-1;;;;;11982:6:173;11968:20;;11964:62;;11997:29;;-1:-1:-1;;;11997:29:173;;12015:10;11997:29;;;4271:51:264;4244:18;;11997:29:173;4125:203:264;11964:62:173;12053:6;-1:-1:-1;;;;;12041:34:173;;:36;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;12037:70;;;12086:21;;-1:-1:-1;;;12086:21:173;;;;;;;;;;;12037:70;7333:27:175::1;7353:6;7333:19;:27::i;:::-;7370:31;7394:6;7370:23;:31::i;:::-;7411:26;7430:6;7411:18;:26::i;:::-;7447:27;7467:6;7447:19;:27::i;:::-;-1:-1:-1::0;;;;;7503:15:175;::::1;7485;7503::::0;;;:7:::1;:15;::::0;;;;7622:21:::1;7511:6:::0;7638:4;7622:7:::1;:21::i;:::-;-1:-1:-1::0;;;;;7698:15:175;::::1;;::::0;;;:7:::1;:15;::::0;;;;;;;:25:::1;::::0;;::::1;:35:::0;;;7743:20:::1;::::0;;::::1;:31:::0;;;7784:24;;;;;7575:68;;-1:-1:-1;7575:68:175;;-1:-1:-1;7575:68:175;-1:-1:-1;7575:68:175;-1:-1:-1;7784:40:175::1;7575:68:::0;7784:24;:40:::1;:::i;:::-;-1:-1:-1::0;7862:12:175::1;;::::0;;-1:-1:-1;6967:940:175;;;;;;;;:::o;13040:46:173:-;11501:10;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;4271:51:264;4244:18;;11530:29:173;4125:203:264;11497:62:173;13040:46::o;6862:150:169:-;-1:-1:-1;;;;;6942:15:169;;;;;;:7;:15;;;;;:21;;;:26;;6938:67;;6977:28;;-1:-1:-1;;;6977:28:169;;-1:-1:-1;;;;;18678:39:264;;6977:28:169;;;18660:58:264;18633:18;;6977:28:169;18516:208:264;19141:233:178;-1:-1:-1;;;;;19260:20:178;;;;;;:12;:20;;;;;19291:17;19260:27;;;;;;:48;;;;;;;;:::i;:::-;;19256:112;;19331:26;;-1:-1:-1;;;19331:26:178;;-1:-1:-1;;;;;18678:39:264;;19331:26:178;;;18660:58:264;18633:18;;19331:26:178;18516:208:264;10315:691:178;10426:27;;10507:7;;-1:-1:-1;;;;;10543:19:178;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;10531:31;;10577:9;10572:384;10592:3;10588:1;:7;10572:384;;;10640:39;10660:6;10668:7;;10676:1;10668:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;10640:19;:39::i;:::-;10693;10713:6;10721:7;;10729:1;10721:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;10693:19;:39::i;:::-;-1:-1:-1;;;;;10792:13:178;;;;;;:5;:13;;;;;10827:17;;10806:7;;10814:1;10806:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;-1:-1:-1;;;;;10792:25:178;-1:-1:-1;;;;;10792:25:178;;;;;;;;;;;;:32;;;:52;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;10913:32;10926:6;10934:7;;10942:1;10934:10;;;;;;;:::i;:::-;;;;;;;;;;;;;;:::i;:::-;10913:12;:32::i;:::-;10898:9;10908:1;10898:12;;;;;;;;:::i;:::-;;;;;;:47;;;;10597:3;;;;;:::i;:::-;;;;10572:384;;;;10966:33;10315:691;;;;;;:::o;7793:243:169:-;-1:-1:-1;;;;;7907:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;7907:26:169;;;;;7888:15;7881:52;;;;:84;;;;-1:-1:-1;;;;;;7937:15:169;;7964:1;7937:15;;;:7;:15;;;;;;;;:24;;:28;;7881:84;7877:153;;;7988:31;;-1:-1:-1;;;7988:31:169;;-1:-1:-1;;;;;18678:39:264;;7988:31:169;;;18660:58:264;18633:18;;7988:31:169;18516:208:264;12721:417:175;-1:-1:-1;;;;;12882:15:175;;12862:17;12882:15;;;:7;:15;;;;;:26;;-1:-1:-1;;;12882:26:175;;;;;;12942:15;12935:37;;-1:-1:-1;12935:37:175;;;:117;;-1:-1:-1;13031:21:175;;13018:34;;13031:21;;13018:10;:34;:::i;:::-;12992:60;;12999:15;12992:60;;;12935:117;12918:214;;;13084:37;;-1:-1:-1;;;13084:37:175;;-1:-1:-1;;;;;18678:39:264;;13084:37:175;;;18660:58:264;18633:18;;13084:37:175;18516:208:264;12918:214:175;12790:348;12721:417;:::o;18862:234:178:-;-1:-1:-1;;;;;18982:20:178;;;;;;:12;:20;;;;;19013:17;18982:27;;;;;;:48;;;;;;;;:::i;:::-;;18978:112;;19053:26;;-1:-1:-1;;;19053:26:178;;-1:-1:-1;;;;;18678:39:264;;19053:26:178;;;18660:58:264;18633:18;;19053:26:178;18516:208:264;13583:235:178;-1:-1:-1;;;;;13687:20:178;;;;;:12;:20;;;;;13717:17;13687:27;;;:47;;-1:-1:-1;;13687:47:178;;;;;;13583:235::o;7159:175:169:-;-1:-1:-1;;;;;7269:15:169;;;;;;:7;:15;;;;;:21;;;;;7250:15;7243:47;;;;7239:88;;;7299:28;;-1:-1:-1;;;7299:28:169;;-1:-1:-1;;;;;18678:39:264;;7299:28:169;;;18660:58:264;18633:18;;7299:28:169;18516:208:264;19419:385:178;-1:-1:-1;;;;;19584:20:178;;;;;;:12;:20;;;;;:30;;;-1:-1:-1;;;;;19584:30:178;;;;;;19574:40;;;;19570:89;;19623:36;;-1:-1:-1;;;19623:36:178;;-1:-1:-1;;;;;19378:39:264;;19623:36:178;;;19360:58:264;-1:-1:-1;;;;;19454:31:264;;19434:18;;;19427:59;19333:18;;19623:36:178;19190:302:264;19570:89:178;-1:-1:-1;;;;;19710:13:178;;19750:1;19710:13;;;:5;:13;;;;;;;;-1:-1:-1;;;;;19710:21:178;;;;;;;;;:28;-1:-1:-1;;;;;19710:28:178;19706:91;;19761:36;;-1:-1:-1;;;19761:36:178;;-1:-1:-1;;;;;19378:39:264;;19761:36:178;;;19360:58:264;-1:-1:-1;;;;;19454:31:264;;19434:18;;;19427:59;19333:18;;19761:36:178;19190:302:264;19849:263:178;-1:-1:-1;;;;;20047:13:178;;;;;;:5;:13;;;;;;;;-1:-1:-1;;;;;20047:21:178;;;;;;;;;:28;-1:-1:-1;;;;;20036:39:178;;;20047:28;;20036:39;20032:73;;20084:21;;-1:-1:-1;;;20084:21:178;;-1:-1:-1;;;;;4289:32:264;;20084:21:178;;;4271:51:264;4244:18;;20084:21:178;4125:203:264;20032:73:178;19849:263;;;:::o;20157:276::-;20346:17;-1:-1:-1;;;;;20314:13:178;;;;;;:5;:13;;;;;;;;-1:-1:-1;;;;;20314:21:178;;;;;;;;;:28;;;;;-1:-1:-1;;;20314:28:178;;;;;:49;;;;;;;:::i;:::-;;20310:117;;20386:30;;-1:-1:-1;;;20386:30:178;;-1:-1:-1;;;;;19378:39:264;;20386:30:178;;;19360:58:264;-1:-1:-1;;;;;19454:31:264;;19434:18;;;19427:59;19333:18;;20386:30:178;19190:302:264;8183:368:169;-1:-1:-1;;;;;8330:15:169;;;;;;:7;:15;;;;;:26;;-1:-1:-1;;;8330:26:169;;;;;8310:15;8303:53;;;;8299:119;;8379:28;;-1:-1:-1;;;8379:28:169;;-1:-1:-1;;;;;18678:39:264;;8379:28:169;;;18660:58:264;18633:18;;8379:28:169;18516:208:264;8299:119:169;-1:-1:-1;;;;;8478:15:169;;;;;;:7;:15;;;;;;;:24;;:29;;8474:70;;8516:28;;-1:-1:-1;;;8516:28:169;;-1:-1:-1;;;;;18678:39:264;;8516:28:169;;;18660:58:264;18633:18;;8516:28:169;18516:208:264;9142:522:178;-1:-1:-1;;;;;9365:20:178;;9275:14;9365:20;;;:12;:20;;;;;;;;9413:5;:13;;;;;-1:-1:-1;;;;;9413:21:178;;;;;;;;;9491:17;9478:10;;;:30;;-1:-1:-1;;;;9478:30:178;-1:-1:-1;;;9491:17:178;9478:30;;;;-1:-1:-1;9581:10:178;;9558:19;;;:33;;-1:-1:-1;;;9581:10:178;;;-1:-1:-1;;;;;9581:10:178;;;;9558:33;;9581:10;;9558:33;:::i;:::-;;;;-1:-1:-1;;9647:10:178;-1:-1:-1;;;9647:10:178;;-1:-1:-1;;;;;9647:10:178;;;-1:-1:-1;;;;;;9142:522:178:o;5797:2835::-;5968:6;6058:12;;;:42;;-1:-1:-1;;;;;;6074:26:178;;6058:42;6054:78;;;6109:23;;-1:-1:-1;;;6109:23:178;;;;;;;;;;;6054:78;-1:-1:-1;;;;;6206:15:178;;6184:19;6206:15;;;:7;:15;;;;;;;;:24;;;6267:12;:20;;;;;6369:14;;;:16;;6206:24;;6267:20;;6184:19;;6369:16;;;-1:-1:-1;;;;;6369:16:178;;;;;:::i;:::-;;;;;;;;-1:-1:-1;;;;;6369:16:178;;;;;-1:-1:-1;;;;;6369:16:178;;;;;;6354:31;;6448:15;6473:7;6448:33;;6540:148;;;;;;;;6566:7;-1:-1:-1;;;;;6540:148:178;;;;;6595:8;-1:-1:-1;;;;;6540:148:178;;;;;6627:9;-1:-1:-1;;;;;6540:148:178;;;;;6658:19;6540:148;;;;;;;;:::i;:::-;;;-1:-1:-1;;;;;6517:13:178;;;;;;;:5;:13;;;;;;;;-1:-1:-1;;;;;6517:20:178;;;;;;;;;;:171;;;;;;;;;-1:-1:-1;;;6517:171:178;;;-1:-1:-1;;;;;6517:171:178;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;6517:171:178;;;;;;;;;;;-1:-1:-1;;;;;;6517:171:178;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;6764:7;6741:4;:19;;;:30;;;;;;;:::i;:::-;;;;-1:-1:-1;;;;;;;7114:15:178;;7088:17;7114:15;;;:7;:15;;;;;:33;7108:39;;-1:-1:-1;;;7114:33:178;;;;7108:2;:39;:::i;:::-;7088:59;;7157:25;7185:59;7201:4;:19;;;7222:9;7233:4;:10;;;7185:15;:59::i;:::-;7157:87;;7370:11;7350:17;:31;7346:74;;;7404:5;7397:12;;;;;;;;;;7346:74;7519:11;7499:17;:31;7495:907;;;7610:123;7649:5;7656:11;7669:17;7688:8;7698:9;7709:4;:10;;;7610:21;:123::i;:::-;-1:-1:-1;;;;;7584:23:178;;;;;;;:15;:23;;;;;;;;:149;;;;;;;;-1:-1:-1;;;;;7584:149:178;;;-1:-1:-1;;;;;;7584:149:178;;;;;;;-1:-1:-1;;;7584:149:178;;;;;;;;;;;;;;-1:-1:-1;7584:149:178;;;;7808:19;;;:53;;7831:30;;;;;;;;7808:19;:53;;7831:30;;7808:53;:::i;:::-;;;;-1:-1:-1;;7970:19:178;;;;8002:10;;7929:22;;7954:59;;7991:9;;7954:15;:59::i;:::-;7929:84;;8344:4;:14;;;8327;:31;8323:68;;;8360:14;;;:31;;;8323:68;7532:870;7495:907;-1:-1:-1;;;;;;;;8550:15:178;;;;;;;;:7;:15;;;;;:52;;-1:-1:-1;;8550:52:178;-1:-1:-1;;;8586:15:178;8550:52;;;;;;-1:-1:-1;8620:5:178;;5797:2835;-1:-1:-1;;;;;;;5797:2835:178:o;17025:1392::-;17122:24;;:::i;:::-;-1:-1:-1;;;;;17204:13:178;;;17183:18;17204:13;;;:5;:13;;;;;;;;-1:-1:-1;;;;;17204:21:178;;;;;;;;;17183:42;;;;;;;;;-1:-1:-1;;;;;17183:42:178;;;;;-1:-1:-1;;;17183:42:178;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:18;;17204:21;;17183:42;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;:::i;:::-;;;-1:-1:-1;17304:14:178;;-1:-1:-1;;;;;17286:32:178;;;;;17348:16;;;;;17328:36;;;:17;;;;:36;;;;-1:-1:-1;;;;;17379:20:178;;-1:-1:-1;17379:20:178;;;:12;:20;;;;:38;;;17304:14;;-1:-1:-1;;;;17379:38:178;;;;17375:1010;;;-1:-1:-1;;;;;17494:23:178;;;;;;:15;:23;;;;;:29;-1:-1:-1;;;;;17494:39:178;;;:29;;:39;17490:685;;17622:14;;;;;-1:-1:-1;;;;;17606:30:178;;;:13;;;;:30;;;;17672:23;;;;;;;:15;:23;;;;;;:30;;;;17654:15;;;:48;17738:23;;;;;:30;;-1:-1:-1;;;17738:30:178;;;17720:15;;;:48;17375:1010;;17490:685;17895:14;;;;;;-1:-1:-1;;;;;17879:30:178;;;:13;;;;:30;;;;17982:14;;18024:15;;;;;;;:7;:15;;;;;;;:33;17945:178;;;;;;;18018:39;;-1:-1:-1;;;18024:33:178;;;;18018:2;:39;:::i;:::-;-1:-1:-1;;;;;18079:20:178;;;;;;:12;:20;;;;;:26;17945:15;:178::i;:::-;17927:15;;;:196;18159:1;18141:15;;;:19;17375:1010;;;18281:14;;;;;-1:-1:-1;;;;;18265:30:178;;;:13;;;:30;18327:1;18309:15;;;:19;18360:14;;18342:32;:15;;;:32;17375:1010;18395:15;17025:1392;;;;:::o;3815:450::-;4041:26;4060:6;4041:18;:26::i;2363:921::-;2500:31;2545:7;2534:40;;;;;;;;;;;;:::i;:::-;2631:12;;2500:74;;-1:-1:-1;2631:12:178;:17;2627:53;;2657:23;;-1:-1:-1;;;2657:23:178;;;;;;;;;;;2627:53;439:5:169;2756:44:178;;:6;:21;;;:44;;;2752:80;;;2809:23;;-1:-1:-1;;;2809:23:178;;;;;;;;;;;2752:80;-1:-1:-1;;;;;2902:20:178;;2875:24;2902:20;;;:12;:20;;;;;;;;2945:12;;2932:25;;2984:1;2967:14;;:18;;-1:-1:-1;;2967:18:178;;;;;3218:13;;;;3233:21;;;;2902:20;;3200:77;;;;439:5:169;3200:17:178;:77::i;:::-;3171:14;;;;:106;-1:-1:-1;;;;2363:921:178:o;18501:316::-;-1:-1:-1;;;;;18594:20:178;;18625:17;18594:20;;;:12;:20;;;;;:27;;;;;;;;:48;;;;;;;:::i;:::-;;:108;;;;-1:-1:-1;;;;;;18662:15:178;;;;;;:7;:15;;;;;:21;18687:15;18662:21;;;;:40;;18594:108;:172;;;;-1:-1:-1;;;;;;18722:15:178;;;;;;:7;:15;;;;;:26;18751:15;-1:-1:-1;;;18722:26:178;;;;;:44;18594:172;18577:233;;;18784:26;;-1:-1:-1;;;18784:26:178;;-1:-1:-1;;;;;18678:39:264;;18784:26:178;;;18660:58:264;18633:18;;18784:26:178;18516:208:264;11870:1255:178;-1:-1:-1;;;;;12125:20:178;;11984:16;12125:20;;;:12;:20;;;;;;;;12155:17;12125:27;;;:47;;-1:-1:-1;;12125:47:178;;;;;12278:35;;;;;12333:15;;;;:33;11984:16;;;;12037:27;;11984:16;;12249:167;;12278:35;12327:39;;-1:-1:-1;;;12333:33:178;;;;12327:2;:39;:::i;:::-;-1:-1:-1;;;;;12380:20:178;;;;;;:12;:20;;;;;:26;12249:15;:167::i;:::-;-1:-1:-1;;;;;12551:20:178;;;;;;:12;:20;;;;;:30;;;12224:192;;-1:-1:-1;12534:47:178;;12530:299;;;-1:-1:-1;12797:4:178;;-1:-1:-1;12768:50:178;;12530:299;-1:-1:-1;;;;;12921:20:178;;;;;;:12;:20;;;;;12962:4;12921:38;;;:45;;-1:-1:-1;;12921:45:178;-1:-1:-1;;;12921:45:178;;;13021:35;;;;;;-1:-1:-1;13078:14:178;;-1:-1:-1;12962:4:178;-1:-1:-1;11870:1255:178;;;;;;;;:::o;12569:3418:54:-;12645:14;13181:9;;;-1:-1:-1;;13188:1:54;13185;13217:20;13341:10;;;13333:19;;13325:28;;;13438:274;;13484:1;13474:153;;13526:10;13520:4;13513:24;13600:4;13594;13587:18;13474:153;-1:-1:-1;13658:10:54;;;;-1:-1:-1;13689:5:54;;13438:274;13833:2;13830:1;13827:9;13817:149;;13873:10;13867:4;13860:24;13943:4;13937;13930:18;13817:149;14223:1;14220;14217;14210:15;14371:1;14367:9;;;14360:17;;14462:9;;;;;15753;;;15745:18;;;15773:9;;;;15769:17;;;15788:1;15765:25;15741:50;15797:10;;15793:18;15738:74;14841:1;14837:9;;14848:1;14833:17;;;15119:11;;;15112:19;;15103:29;15192:11;;;15185:19;;15176:29;15266:11;;;15259:19;;15250:29;15340:11;;;15333:19;;15324:29;15414:11;;;15407:19;;15398:29;15900:11;;;15893:19;;;15884:29;15496:439;;-1:-1:-1;12569:3418:54;;;;;:::o;4308:810:178:-;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;4641:47:178;-1:-1:-1;;;;;4641:47:178;;4669:10;4681:6;4641:15;:47::i;:::-;4622:66;-1:-1:-1;4698:14:178;4715:29;4735:9;4715:17;:29;:::i;:::-;4698:46;;4918:13;4941:45;4957:10;-1:-1:-1;;;;;4941:45:178;4969:6;4977:8;4941:15;:45::i;:::-;4918:69;-1:-1:-1;4997:14:178;5014:17;5025:6;5014:8;:17;:::i;:::-;5050:60;;;;;;;;-1:-1:-1;;;;;5050:60:178;;;;-1:-1:-1;;;;;5050:60:178;;;;;;;;;;-1:-1:-1;5050:60:178;-1:-1:-1;;;4308:810:178;;;;;;;;:::o;16269:462:54:-;16347:14;16382:19;16393:1;16396;16399;16382:10;:19::i;:::-;16373:28;;16493:1;16490;16487;16480:15;16477:238;;;16536:1;16524:14;;16555:146;;16608:10;16602:4;16595:24;16678:4;16672;16665:18;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;14:179:264:-;81:20;;-1:-1:-1;;;;;130:38:264;;120:49;;110:77;;183:1;180;173:12;110:77;14:179;;;:::o;198:320::-;274:6;282;290;343:2;331:9;322:7;318:23;314:32;311:52;;;359:1;356;349:12;311:52;382:28;400:9;382:28;:::i;:::-;372:38;457:2;442:18;;429:32;;-1:-1:-1;508:2:264;493:18;;;480:32;;198:320;-1:-1:-1;;;198:320:264:o;523:655::-;692:2;744:21;;;814:13;;717:18;;;836:22;;;663:4;;692:2;915:15;;;;889:2;874:18;;;663:4;958:194;972:6;969:1;966:13;958:194;;;1037:13;;-1:-1:-1;;;;;1033:38:264;1021:51;;1127:15;;;;1092:12;;;;994:1;987:9;958:194;;;-1:-1:-1;1169:3:264;;523:655;-1:-1:-1;;;;;;523:655:264:o;1183:184::-;1241:6;1294:2;1282:9;1273:7;1269:23;1265:32;1262:52;;;1310:1;1307;1300:12;1262:52;1333:28;1351:9;1333:28;:::i;1564:686::-;1657:6;1665;1673;1726:2;1714:9;1705:7;1701:23;1697:32;1694:52;;;1742:1;1739;1732:12;1694:52;1765:28;1783:9;1765:28;:::i;:::-;1755:38;;1844:2;1833:9;1829:18;1816:32;-1:-1:-1;;;;;1908:2:264;1900:6;1897:14;1894:34;;;1924:1;1921;1914:12;1894:34;1962:6;1951:9;1947:22;1937:32;;2007:7;2000:4;1996:2;1992:13;1988:27;1978:55;;2029:1;2026;2019:12;1978:55;2069:2;2056:16;2095:2;2087:6;2084:14;2081:34;;;2111:1;2108;2101:12;2081:34;2164:7;2159:2;2149:6;2146:1;2142:14;2138:2;2134:23;2130:32;2127:45;2124:65;;;2185:1;2182;2175:12;2124:65;2216:2;2212;2208:11;2198:21;;2238:6;2228:16;;;;;1564:686;;;;;:::o;2255:373::-;2371:12;;-1:-1:-1;;;;;2367:21:264;;;2355:34;;2442:4;2431:16;;;2425:23;2421:32;;;2405:14;;;2398:56;2503:4;2492:16;;;2486:23;2470:14;;;2463:47;2559:4;2548:16;;;2542:23;2526:14;;;2519:47;2615:4;2604:16;;;2598:23;2582:14;;2575:47;2255:373::o;2633:422::-;2674:3;2712:5;2706:12;2739:6;2734:3;2727:19;2764:1;2774:162;2788:6;2785:1;2782:13;2774:162;;;2850:4;2906:13;;;2902:22;;2896:29;2878:11;;;2874:20;;2867:59;2803:12;2774:162;;;2778:3;2981:1;2974:4;2965:6;2960:3;2956:16;2952:27;2945:38;3044:4;3037:2;3033:7;3028:2;3020:6;3016:15;3012:29;3007:3;3003:39;2999:50;2992:57;;;2633:422;;;;:::o;3060:838::-;3350:2;3362:21;;;3432:13;;3335:18;;;3454:22;;;3302:4;;3529;;3507:2;3492:18;;;3556:15;;;3302:4;3599:191;3613:6;3610:1;3607:13;3599:191;;;3662:46;3704:3;3695:6;3689:13;3662:46;:::i;:::-;3737:4;3728:14;;;;;3765:15;;;;3635:1;3628:9;3599:191;;;3603:3;;;3835:9;3830:3;3826:19;3821:2;3810:9;3806:18;3799:47;3863:29;3888:3;3880:6;3863:29;:::i;3903:217::-;4050:2;4039:9;4032:21;4013:4;4070:44;4110:2;4099:9;4095:18;4087:6;4070:44;:::i;4333:167::-;4400:20;;4460:14;4449:26;;4439:37;;4429:65;;4490:1;4487;4480:12;4505:184;4563:6;4616:2;4604:9;4595:7;4591:23;4587:32;4584:52;;;4632:1;4629;4622:12;4584:52;4655:28;4673:9;4655:28;:::i;6414:252::-;6481:6;6489;6542:2;6530:9;6521:7;6517:23;6513:32;6510:52;;;6558:1;6555;6548:12;6510:52;6581:28;6599:9;6581:28;:::i;:::-;6571:38;6656:2;6641:18;;;;6628:32;;-1:-1:-1;;;6414:252:264:o;6876:171::-;6943:20;;-1:-1:-1;;;;;6992:30:264;;6982:41;;6972:69;;7037:1;7034;7027:12;7052:173;7120:20;;-1:-1:-1;;;;;7169:31:264;;7159:42;;7149:70;;7215:1;7212;7205:12;7230:399;7314:6;7322;7330;7338;7391:3;7379:9;7370:7;7366:23;7362:33;7359:53;;;7408:1;7405;7398:12;7359:53;7431:28;7449:9;7431:28;:::i;:::-;7421:38;;7478:37;7511:2;7500:9;7496:18;7478:37;:::i;:::-;7468:47;;7562:2;7551:9;7547:18;7534:32;7524:42;;7585:38;7619:2;7608:9;7604:18;7585:38;:::i;:::-;7575:48;;7230:399;;;;;;;:::o;7816:881::-;7921:6;7929;7937;7945;7953;7961;8014:3;8002:9;7993:7;7989:23;7985:33;7982:53;;;8031:1;8028;8021:12;7982:53;8054:28;8072:9;8054:28;:::i;:::-;8044:38;;8101;8135:2;8124:9;8120:18;8101:38;:::i;:::-;8091:48;;8158:38;8192:2;8181:9;8177:18;8158:38;:::i;:::-;8148:48;;8243:2;8232:9;8228:18;8215:32;8205:42;;8298:3;8287:9;8283:19;8270:33;-1:-1:-1;;;;;8363:2:264;8355:6;8352:14;8349:34;;;8379:1;8376;8369:12;8349:34;8417:6;8406:9;8402:22;8392:32;;8462:7;8455:4;8451:2;8447:13;8443:27;8433:55;;8484:1;8481;8474:12;8433:55;8524:2;8511:16;8550:2;8542:6;8539:14;8536:34;;;8566:1;8563;8556:12;8536:34;8611:7;8606:2;8597:6;8593:2;8589:15;8585:24;8582:37;8579:57;;;8632:1;8629;8622:12;8579:57;8663:2;8659;8655:11;8645:21;;8685:6;8675:16;;;;;7816:881;;;;;;;;:::o;8702:256::-;8768:6;8776;8829:2;8817:9;8808:7;8804:23;8800:32;8797:52;;;8845:1;8842;8835:12;8797:52;8868:28;8886:9;8868:28;:::i;:::-;8858:38;;8915:37;8948:2;8937:9;8933:18;8915:37;:::i;:::-;8905:47;;8702:256;;;;;:::o;8963:252::-;9151:3;9136:19;;9164:45;9140:9;9191:6;9164:45;:::i;9220:127::-;9281:10;9276:3;9272:20;9269:1;9262:31;9312:4;9309:1;9302:15;9336:4;9333:1;9326:15;9352:116;9436:1;9429:5;9426:12;9416:46;;9442:18;;:::i;9473:242::-;9622:2;9607:18;;9634:41;9668:6;9634:41;:::i;:::-;9684:25;;;9473:242;:::o;10227:604::-;10478:13;;-1:-1:-1;;;;;10474:22:264;;;10456:41;;10557:4;10545:17;;;10539:24;-1:-1:-1;;;;;10535:57:264;10513:20;;;10506:87;10653:4;10641:17;;;10635:24;10631:33;;;10609:20;;;10602:63;10712:4;10700:17;;10694:24;10405:3;10390:19;;;10727:47;10694:24;10727:47;:::i;:::-;10812:12;10805:4;10794:9;10790:20;10783:42;;10227:604;;;;:::o;10836:127::-;10897:10;10892:3;10888:20;10885:1;10878:31;10928:4;10925:1;10918:15;10952:4;10949:1;10942:15;10968:253;11040:2;11034:9;11082:4;11070:17;;-1:-1:-1;;;;;11102:34:264;;11138:22;;;11099:62;11096:88;;;11164:18;;:::i;:::-;11200:2;11193:22;10968:253;:::o;11226:275::-;11297:2;11291:9;11362:2;11343:13;;-1:-1:-1;;11339:27:264;11327:40;;-1:-1:-1;;;;;11382:34:264;;11418:22;;;11379:62;11376:88;;;11444:18;;:::i;:::-;11480:2;11473:22;11226:275;;-1:-1:-1;11226:275:264:o;11506:118::-;11592:5;11585:13;11578:21;11571:5;11568:32;11558:60;;11614:1;11611;11604:12;11629:156;11695:20;;11755:4;11744:16;;11734:27;;11724:55;;11775:1;11772;11765:12;11790:1564;11903:6;11911;11919;11927;11980:3;11968:9;11959:7;11955:23;11951:33;11948:53;;;11997:1;11994;11987:12;11948:53;12020:28;12038:9;12020:28;:::i;:::-;12010:38;;12067:2;12120;12109:9;12105:18;12092:32;-1:-1:-1;;;;;12184:2:264;12176:6;12173:14;12170:34;;;12200:1;12197;12190:12;12170:34;12223:22;;;;12279:4;12261:16;;;12257:27;12254:47;;;12297:1;12294;12287:12;12254:47;12323:22;;:::i;:::-;12368:21;12386:2;12368:21;:::i;:::-;12361:5;12354:36;12422:30;12448:2;12444;12440:11;12422:30;:::i;:::-;12417:2;12410:5;12406:14;12399:54;12498:2;12494;12490:11;12477:25;12511:30;12533:7;12511:30;:::i;:::-;12568:2;12557:14;;12550:31;12634:2;12626:11;;;12613:25;12597:14;;;12590:49;12685:3;12677:12;;12664:26;12702:16;;;12699:36;;;12731:1;12728;12721:12;12699:36;12762:8;12758:2;12754:17;12744:27;;;12809:7;12802:4;12798:2;12794:13;12790:27;12780:55;;12831:1;12828;12821:12;12780:55;12867:2;12854:16;12889:2;12885;12882:10;12879:36;;;12895:18;;:::i;:::-;12937:53;12980:2;12961:13;;-1:-1:-1;;12957:27:264;12953:36;;12937:53;:::i;:::-;12924:66;;13013:2;13006:5;12999:17;13053:7;13048:2;13043;13039;13035:11;13031:20;13028:33;13025:53;;;13074:1;13071;13064:12;13025:53;13129:2;13124;13120;13116:11;13111:2;13104:5;13100:14;13087:45;13173:1;13152:14;;;13148:23;;;13141:34;;;;13202:3;13191:15;;13184:30;-1:-1:-1;13195:5:264;-1:-1:-1;13257:36:264;13289:2;13274:18;;13257:36;:::i;:::-;13247:46;;13312:36;13344:2;13333:9;13329:18;13312:36;:::i;13359:241::-;13501:2;13486:18;;13534:1;13523:13;;13513:47;;13540:18;;:::i;13605:698::-;13830:13;;13812:32;;13891:4;13879:17;;13873:24;13799:3;13784:19;;;13906:47;13873:24;13906:47;:::i;:::-;13991:12;13984:4;13973:9;13969:20;13962:42;;-1:-1:-1;;;;;14064:4:264;14056:6;14052:17;14046:24;14042:49;14035:4;14024:9;14020:20;14013:79;14162:4;14154:6;14150:17;14144:24;14137:32;14130:40;14123:4;14112:9;14108:20;14101:70;14227:4;14219:6;14215:17;14209:24;14202:4;14191:9;14187:20;14180:54;14290:4;14282:6;14278:17;14272:24;14265:4;14254:9;14250:20;14243:54;13605:698;;;;:::o;14308:514::-;14561:6;14550:9;14543:25;14604:6;14599:2;14588:9;14584:18;14577:34;14647:6;14642:2;14631:9;14627:18;14620:34;14704:6;14697:14;14690:22;14685:2;14674:9;14670:18;14663:50;14750:3;14744;14733:9;14729:19;14722:32;14524:4;14771:45;14811:3;14800:9;14796:19;14788:6;14771:45;:::i;15070:245::-;15137:6;15190:2;15178:9;15169:7;15165:23;15161:32;15158:52;;;15206:1;15203;15196:12;15158:52;15238:9;15232:16;15257:28;15279:5;15257:28;:::i;15320:380::-;15399:1;15395:12;;;;15442;;;15463:61;;15517:4;15509:6;15505:17;15495:27;;15463:61;15570:2;15562:6;15559:14;15539:18;15536:38;15533:161;;15616:10;15611:3;15607:20;15604:1;15597:31;15651:4;15648:1;15641:15;15679:4;15676:1;15669:15;15533:161;;15320:380;;;:::o;16005:127::-;16066:10;16061:3;16057:20;16054:1;16047:31;16097:4;16094:1;16087:15;16121:4;16118:1;16111:15;16137:176;16204:14;16238:10;;;16250;;;16234:27;;16273:11;;;16270:37;;;16287:18;;:::i;16443:544::-;16544:2;16539:3;16536:11;16533:448;;;16580:1;16605:5;16601:2;16594:17;16650:4;16646:2;16636:19;16720:2;16708:10;16704:19;16701:1;16697:27;16691:4;16687:38;16756:4;16744:10;16741:20;16738:47;;;-1:-1:-1;16779:4:264;16738:47;16834:2;16829:3;16825:12;16822:1;16818:20;16812:4;16808:31;16798:41;;16889:82;16907:2;16900:5;16897:13;16889:82;;;16952:17;;;16933:1;16922:13;16889:82;;;16893:3;;;16443:544;;;:::o;17163:1348::-;17287:3;17281:10;-1:-1:-1;;;;;17306:6:264;17303:30;17300:56;;;17336:18;;:::i;:::-;17365:96;17454:6;17414:38;17446:4;17440:11;17414:38;:::i;:::-;17408:4;17365:96;:::i;:::-;17516:4;;17580:2;17569:14;;17597:1;17592:662;;;;18298:1;18315:6;18312:89;;;-1:-1:-1;18367:19:264;;;18361:26;18312:89;-1:-1:-1;;17120:1:264;17116:11;;;17112:24;17108:29;17098:40;17144:1;17140:11;;;17095:57;18414:81;;17562:943;;17592:662;16390:1;16383:14;;;16427:4;16414:18;;-1:-1:-1;;17628:20:264;;;17745:236;17759:7;17756:1;17753:14;17745:236;;;17848:19;;;17842:26;17827:42;;17940:27;;;;17908:1;17896:14;;;;17775:19;;17745:236;;;17749:3;18009:6;18000:7;17997:19;17994:201;;;18070:19;;;18064:26;-1:-1:-1;;18153:1:264;18149:14;;;18165:3;18145:24;18141:37;18137:42;18122:58;18107:74;;17994:201;-1:-1:-1;;;;;18241:1:264;18225:14;;;18221:22;18208:36;;-1:-1:-1;17163:1348:264:o;18729:127::-;18790:10;18785:3;18781:20;18778:1;18771:31;18821:4;18818:1;18811:15;18845:4;18842:1;18835:15;18861:184;18919:6;18972:2;18960:9;18951:7;18947:23;18943:32;18940:52;;;18988:1;18985;18978:12;18940:52;19011:28;19029:9;19011:28;:::i;19050:135::-;19089:3;19110:17;;;19107:43;;19130:18;;:::i;:::-;-1:-1:-1;19177:1:264;19166:13;;19050:135::o;19804:128::-;19871:9;;;19892:11;;;19889:37;;;19906:18;;:::i;19937:209::-;19975:3;-1:-1:-1;;;;;20056:2:264;20049:5;20045:14;20083:2;20074:7;20071:15;20068:41;;20089:18;;:::i;:::-;20138:1;20125:15;;19937:209;-1:-1:-1;;;19937:209:264:o;20151:125::-;20216:9;;;20237:10;;;20234:36;;;20250:18;;:::i;20281:422::-;20370:1;20413:5;20370:1;20427:270;20448:7;20438:8;20435:21;20427:270;;;20507:4;20503:1;20499:6;20495:17;20489:4;20486:27;20483:53;;;20516:18;;:::i;:::-;20566:7;20556:8;20552:22;20549:55;;;20586:16;;;;20549:55;20665:22;;;;20625:15;;;;20427:270;;;20431:3;20281:422;;;;;:::o;20708:806::-;20757:5;20787:8;20777:80;;-1:-1:-1;20828:1:264;20842:5;;20777:80;20876:4;20866:76;;-1:-1:-1;20913:1:264;20927:5;;20866:76;20958:4;20976:1;20971:59;;;;21044:1;21039:130;;;;20951:218;;20971:59;21001:1;20992:10;;21015:5;;;21039:130;21076:3;21066:8;21063:17;21060:43;;;21083:18;;:::i;:::-;-1:-1:-1;;21139:1:264;21125:16;;21154:5;;20951:218;;21253:2;21243:8;21240:16;21234:3;21228:4;21225:13;21221:36;21215:2;21205:8;21202:16;21197:2;21191:4;21188:12;21184:35;21181:77;21178:159;;;-1:-1:-1;21290:19:264;;;21322:5;;21178:159;21369:34;21394:8;21388:4;21369:34;:::i;:::-;21439:6;21435:1;21431:6;21427:19;21418:7;21415:32;21412:58;;;21450:18;;:::i;:::-;21488:20;;20708:806;-1:-1:-1;;;20708:806:264:o;21519:140::-;21577:5;21606:47;21647:4;21637:8;21633:19;21627:4;21606:47;:::i;21664:607::-;21770:6;21823:2;21811:9;21802:7;21798:23;21794:32;21791:52;;;21839:1;21836;21829:12;21791:52;21872:2;21866:9;21914:2;21906:6;21902:15;21983:6;21971:10;21968:22;-1:-1:-1;;;;;21935:10:264;21932:34;21929:62;21926:88;;;21994:18;;:::i;:::-;22030:2;22023:22;22069:16;;22054:32;;22129:2;22114:18;;22108:25;22173:8;22162:20;;22152:31;;22142:59;;22197:1;22194;22187:12;22142:59;22229:2;22217:15;;22210:30;22221:6;21664:607;-1:-1:-1;;;21664:607:264:o",
    linkReferences: {},
    immutableReferences: {
      "88907": [
        {
          start: 658,
          length: 32
        },
        {
          start: 1940,
          length: 32
        },
        {
          start: 2011,
          length: 32
        },
        {
          start: 2375,
          length: 32
        },
        {
          start: 2482,
          length: 32
        },
        {
          start: 2548,
          length: 32
        },
        {
          start: 2765,
          length: 32
        },
        {
          start: 3211,
          length: 32
        },
        {
          start: 3277,
          length: 32
        },
        {
          start: 3527,
          length: 32
        },
        {
          start: 3593,
          length: 32
        },
        {
          start: 4233,
          length: 32
        },
        {
          start: 4299,
          length: 32
        },
        {
          start: 4559,
          length: 32
        },
        {
          start: 4625,
          length: 32
        },
        {
          start: 5524,
          length: 32
        },
        {
          start: 5590,
          length: 32
        },
        {
          start: 5914,
          length: 32
        }
      ]
    }
  },
  methodIdentifiers: {
    "INIT()": "ea643914",
    "PARENT()": "122b83f9",
    "TYPE()": "bb24fe8a",
    "VEECODE()": "d61735ca",
    "abort(uint96)": "1ed75f1f",
    "auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)": "bae96bdd",
    "auctionType()": "994595e1",
    "bid(uint96,address,address,uint256,bytes)": "87698a31",
    "cancelAuction(uint96)": "b04046df",
    "capacityInQuote(uint96)": "39792cdc",
    "claimBids(uint96,uint64[])": "0a35511b",
    "dedicatedSettlePeriod()": "a85cebb6",
    "getAuctionData(uint96)": "cadb3383",
    "getBid(uint96,uint64)": "a8bf44e4",
    "getBidClaim(uint96,uint64)": "8f21c318",
    "getBidIdAtIndex(uint96,uint256)": "7d7b6853",
    "getBidIds(uint96,uint256,uint256)": "00b33217",
    "getLot(uint96)": "4e1f4258",
    "getNumBids(uint96)": "d899a337",
    "getPartialFill(uint96)": "a16f7ef7",
    "hasEnded(uint96)": "03855921",
    "isLive(uint96)": "732efc03",
    "isUpcoming(uint96)": "0440ec53",
    "lotAuctionOutput(uint96)": "0cd0bcf2",
    "lotData(uint96)": "5806afc3",
    "minAuctionDuration()": "54134876",
    "refundBid(uint96,uint64,uint256,address)": "7d9234bc",
    "remainingCapacity(uint96)": "ace54da5",
    "setDedicatedSettlePeriod(uint48)": "29da5abd",
    "setMinAuctionDuration(uint48)": "12d6ef2d",
    "settle(uint96,uint256)": "cd280bdb"
  },
  rawMetadata: '{"compiler":{"version":"0.8.19+commit.7dd6d404"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"auctionHouse_","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"Auction_AmountLessThanMinimum","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_DedicatedSettlePeriod","type":"error"},{"inputs":[],"name":"Auction_InsufficientCapacity","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"uint96","name":"bidId","type":"uint96"}],"name":"Auction_InvalidBidId","type":"error"},{"inputs":[{"internalType":"uint48","name":"duration_","type":"uint48"},{"internalType":"uint48","name":"minimum_","type":"uint48"}],"name":"Auction_InvalidDuration","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_InvalidLotId","type":"error"},{"inputs":[],"name":"Auction_InvalidParams","type":"error"},{"inputs":[{"internalType":"uint48","name":"start_","type":"uint48"},{"internalType":"uint48","name":"minimum_","type":"uint48"}],"name":"Auction_InvalidStart","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_LotActive","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_LotNotActive","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_LotNotConcluded","type":"error"},{"inputs":[],"name":"Auction_NotAuthorized","type":"error"},{"inputs":[],"name":"Auction_NotBidder","type":"error"},{"inputs":[],"name":"Auction_NotImplemented","type":"error"},{"inputs":[],"name":"Auction_OnlyLotOwner","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"}],"name":"Auction_WrongState","type":"error"},{"inputs":[{"internalType":"uint96","name":"lotId","type":"uint96"},{"internalType":"uint64","name":"bidId","type":"uint64"}],"name":"Bid_WrongState","type":"error"},{"inputs":[{"internalType":"address","name":"parent_","type":"address"}],"name":"Module_InvalidParent","type":"error"},{"inputs":[],"name":"Module_OnlyInternal","type":"error"},{"inputs":[{"internalType":"address","name":"caller_","type":"address"}],"name":"Module_OnlyParent","type":"error"},{"inputs":[{"internalType":"address","name":"caller","type":"address"}],"name":"NotPermitted","type":"error"},{"inputs":[],"name":"INIT","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"PARENT","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TYPE","outputs":[{"internalType":"enum Module.Type","name":"","type":"uint8"}],"stateMutability":"pure","type":"function"},{"inputs":[],"name":"VEECODE","outputs":[{"internalType":"Veecode","name":"","type":"bytes7"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"abort","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"components":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"duration","type":"uint48"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"bytes","name":"implParams","type":"bytes"}],"internalType":"struct IAuction.AuctionParams","name":"params_","type":"tuple"},{"internalType":"uint8","name":"quoteTokenDecimals_","type":"uint8"},{"internalType":"uint8","name":"baseTokenDecimals_","type":"uint8"}],"name":"auction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"auctionType","outputs":[{"internalType":"enum IAuction.AuctionType","name":"","type":"uint8"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"address","name":"bidder_","type":"address"},{"internalType":"address","name":"referrer_","type":"address"},{"internalType":"uint256","name":"amount_","type":"uint256"},{"internalType":"bytes","name":"auctionData_","type":"bytes"}],"name":"bid","outputs":[{"internalType":"uint64","name":"bidId","type":"uint64"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"cancelAuction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"capacityInQuote","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64[]","name":"bidIds_","type":"uint64[]"}],"name":"claimBids","outputs":[{"components":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"uint256","name":"paid","type":"uint256"},{"internalType":"uint256","name":"payout","type":"uint256"},{"internalType":"uint256","name":"refund","type":"uint256"}],"internalType":"struct IBatchAuction.BidClaim[]","name":"bidClaims","type":"tuple[]"},{"internalType":"bytes","name":"auctionOutput","type":"bytes"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"dedicatedSettlePeriod","outputs":[{"internalType":"uint48","name":"","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getAuctionData","outputs":[{"components":[{"internalType":"uint256","name":"price","type":"uint256"},{"internalType":"enum IFixedPriceBatch.LotStatus","name":"status","type":"uint8"},{"internalType":"uint64","name":"nextBidId","type":"uint64"},{"internalType":"bool","name":"settlementCleared","type":"bool"},{"internalType":"uint256","name":"totalBidAmount","type":"uint256"},{"internalType":"uint256","name":"minFilled","type":"uint256"}],"internalType":"struct IFixedPriceBatch.AuctionData","name":"auctionData_","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"}],"name":"getBid","outputs":[{"components":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"uint96","name":"amount","type":"uint96"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"enum IFixedPriceBatch.BidStatus","name":"status","type":"uint8"}],"internalType":"struct IFixedPriceBatch.Bid","name":"bid","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"}],"name":"getBidClaim","outputs":[{"components":[{"internalType":"address","name":"bidder","type":"address"},{"internalType":"address","name":"referrer","type":"address"},{"internalType":"uint256","name":"paid","type":"uint256"},{"internalType":"uint256","name":"payout","type":"uint256"},{"internalType":"uint256","name":"refund","type":"uint256"}],"internalType":"struct IBatchAuction.BidClaim","name":"bidClaim","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"","type":"uint96"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"getBidIdAtIndex","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"","type":"uint96"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"getBidIds","outputs":[{"internalType":"uint64[]","name":"","type":"uint64[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getLot","outputs":[{"components":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"conclusion","type":"uint48"},{"internalType":"uint8","name":"quoteTokenDecimals","type":"uint8"},{"internalType":"uint8","name":"baseTokenDecimals","type":"uint8"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"uint256","name":"sold","type":"uint256"},{"internalType":"uint256","name":"purchased","type":"uint256"}],"internalType":"struct IAuction.Lot","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"","type":"uint96"}],"name":"getNumBids","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"getPartialFill","outputs":[{"internalType":"bool","name":"hasPartialFill","type":"bool"},{"components":[{"internalType":"uint64","name":"bidId","type":"uint64"},{"internalType":"uint96","name":"refund","type":"uint96"},{"internalType":"uint256","name":"payout","type":"uint256"}],"internalType":"struct IFixedPriceBatch.PartialFill","name":"partialFill","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"hasEnded","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"isLive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"isUpcoming","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"","type":"uint96"}],"name":"lotAuctionOutput","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"id","type":"uint96"}],"name":"lotData","outputs":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"conclusion","type":"uint48"},{"internalType":"uint8","name":"quoteTokenDecimals","type":"uint8"},{"internalType":"uint8","name":"baseTokenDecimals","type":"uint8"},{"internalType":"bool","name":"capacityInQuote","type":"bool"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"uint256","name":"sold","type":"uint256"},{"internalType":"uint256","name":"purchased","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"minAuctionDuration","outputs":[{"internalType":"uint48","name":"","type":"uint48"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint64","name":"bidId_","type":"uint64"},{"internalType":"uint256","name":"index_","type":"uint256"},{"internalType":"address","name":"caller_","type":"address"}],"name":"refundBid","outputs":[{"internalType":"uint256","name":"refund","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"}],"name":"remainingCapacity","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint48","name":"period_","type":"uint48"}],"name":"setDedicatedSettlePeriod","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint48","name":"duration_","type":"uint48"}],"name":"setMinAuctionDuration","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint96","name":"lotId_","type":"uint96"},{"internalType":"uint256","name":"num_","type":"uint256"}],"name":"settle","outputs":[{"internalType":"uint256","name":"totalIn","type":"uint256"},{"internalType":"uint256","name":"totalOut","type":"uint256"},{"internalType":"uint256","name":"capacity","type":"uint256"},{"internalType":"bool","name":"finished","type":"bool"},{"internalType":"bytes","name":"auctionOutput","type":"bytes"}],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"kind":"dev","methods":{"INIT()":{"details":"This function is called when the module is installed or upgraded by the module.MUST BE GATED BY onlyParent. Used to encompass any initialization or upgrade logic."},"TYPE()":{"details":"This enables the parent contract to check that the module Keycode specifiedis of the correct type"},"abort(uint96)":{"details":"Implements a basic abort function that:             - Validates the lot id and state             - Calls the implementation-specific function             The abort function allows anyone to abort the lot after the conclusion and settlement time has passed.             This can be useful if the lot is unable to be settled, or if the seller is unwilling to settle the lot.             This function reverts if:             - The lot id is invalid             - The lot has not concluded             - The lot is in the dedicated settle period             - The lot is settled (after which it cannot be aborted)","params":{"lotId_":"The lot id"}},"auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)":{"details":"If the start time is zero, the auction will have a start time of the current block timestamp.             This function handles the following:             - Validates the lot parameters             - Stores the auction lot             - Calls the implementation-specific function             This function reverts if:             - The caller is not the parent of the module             - The start time is in the past             - The duration is less than the minimum","params":{"baseTokenDecimals_":"The base token decimals","lotId_":"The lot id","params_":"The auction parameters","quoteTokenDecimals_":"The quote token decimals"}},"bid(uint96,address,address,uint256,bytes)":{"details":"Implements a basic bid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot has concluded             - The lot is already settled             - The caller is not an internal module","params":{"amount_":"The amount of quote tokens to bid","auctionData_":"The auction-specific data","bidder_":"The bidder of the purchased tokens","lotId_":"The lot id","referrer_":"The referrer of the bid"},"returns":{"bidId":"          The bid id"}},"cancelAuction(uint96)":{"details":"Assumptions:             - The parent will refund the seller the remaining capacity             - The parent will verify that the caller is the seller             This function handles the following:             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - the caller is not the parent of the module             - the lot id is invalid             - the lot has concluded","params":{"lotId_":"The lot id"}},"capacityInQuote(uint96)":{"details":"The implementing function should handle the following:             - Return true if the capacity is in quote tokens             - Return false if the capacity is in base tokens","params":{"lotId_":"The lot id"},"returns":{"_0":"bool    Whether or not the capacity is in quote tokens"}},"claimBids(uint96,uint64[])":{"details":"Implements a basic claimBids function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot is not settled             - The caller is not an internal module","params":{"bidIds_":"The bid ids","lotId_":"The lot id"},"returns":{"auctionOutput":"  The auction-specific output","bidClaims":"      The bid claim data"}},"getAuctionData(uint96)":{"details":"This function reverts if:             - The lot ID is invalid","params":{"lotId_":"The lot ID"},"returns":{"auctionData_":"   The `AuctionData`"}},"getBid(uint96,uint64)":{"details":"This function reverts if:             - The lot ID is invalid             - The bid ID is invalid","params":{"bidId_":"The bid ID","lotId_":"The lot ID"},"returns":{"bid":"            The `Bid` data"}},"getBidClaim(uint96,uint64)":{"details":"This function reverts if:             - The lot ID is invalid             - The lot is not settled (since there would be no claim)             - The bid ID is invalid","params":{"bidId_":"The bid ID","lotId_":"The lot ID"},"returns":{"bidClaim":"   The bid claim data"}},"getBidIdAtIndex(uint96,uint256)":{"details":"This function is not implemented in fixed price batch since bid IDs are not stored in an array","params":{"index_":"The index","lotId_":"The lot ID"},"returns":{"_0":"  The bid ID"}},"getBidIds(uint96,uint256,uint256)":{"details":"This function is not implemented in fixed price batch since bid IDs are not stored in an array","params":{"count_":"The number of bids to retrieve","lotId_":"The lot ID","start_":"The index to start retrieving bid IDs from"},"returns":{"_0":" The bid IDs"}},"getLot(uint96)":{"params":{"lotId_":"The lot ID"}},"getNumBids(uint96)":{"details":"This function is not implemented in fixed price batch since bid IDs are not stored in an array             A proxy is using the nextBidId to determine how many bids have been submitted, but this doesn\'t consider refunds","params":{"lotId_":"The lot ID"},"returns":{"_0":"The number of bids"}},"getPartialFill(uint96)":{"details":"For ease of use, this function determines if a partial fill exists.             This function reverts if:             - The lot ID is invalid             - The lot is not settled","params":{"lotId_":"The lot ID"},"returns":{"hasPartialFill":" True if a partial fill exists","partialFill":"    The `PartialFill` data"}},"hasEnded(uint96)":{"details":"The implementing function should handle the following:             - Return true if the lot is not accepting bids/purchases and will not at any point             - Return false if the lot hasn\'t started or is actively accepting bids/purchases","params":{"lotId_":"The lot id"},"returns":{"_0":"bool    Whether or not the lot is active"}},"isLive(uint96)":{"details":"A lot is active if:             - The lot has not concluded             - The lot has started             - The lot has not sold out or been cancelled (capacity > 0)","params":{"lotId_":"The lot ID"},"returns":{"_0":"bool    Whether or not the lot is active"}},"isUpcoming(uint96)":{"details":"The implementing function should handle the following:             - Return true if the lot has not started yet AND has not been cancelled             - Return false if the lot is active, has ended, or was cancelled","params":{"lotId_":"The lot id"},"returns":{"_0":"bool    Whether or not the lot is upcoming"}},"refundBid(uint96,uint64,uint256,address)":{"details":"Implements a basic refundBid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is concluded, decrypted or settled             - The bid id is invalid             - `caller_` is not the bid owner             - The bid is claimed or refunded             - The caller is not an internal module","params":{"bidId_":"The bid id","caller_":"The caller","index_":"The index of the bid ID in the auction\'s bid list","lotId_":"The lot id"},"returns":{"refund":"     The amount of quote tokens to refund"}},"remainingCapacity(uint96)":{"details":"The implementing function should handle the following:             - Return the remaining capacity of the lot","params":{"lotId_":"The lot id"},"returns":{"_0":"uint96 The remaining capacity of the lot"}},"setMinAuctionDuration(uint48)":{"details":"This function must be called by the parent AuctionHouse, and             can be called by governance using `execOnModule`."},"settle(uint96,uint256)":{"details":"Implements a basic settle function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is active             - The lot has already been settled             - The caller is not an internal module","params":{"lotId_":"The lot id","num_":"The number of winning bids to settle (capped at the remaining number if more is provided)"},"returns":{"auctionOutput":"  Custom data returned by the auction module","capacity":"       The original capacity of the lot","finished":"       Whether the settlement is finished","totalIn":"        Total amount of quote tokens from bids that were filled","totalOut":"       Total amount of base tokens paid out to winning bids"}}},"stateVariables":{"_auctionData":{"details":"Access via `getAuctionData()`"},"_bids":{"details":"Access via `getBid()`"},"_lotPartialFill":{"details":"Each FPBA can have at most one partial fill             Access via `getPartialFill()`"}},"title":"FixedPriceBatch","version":1},"userdoc":{"errors":{"Module_InvalidParent(address)":[{"notice":"Error when the parent contract is invalid"}],"Module_OnlyInternal()":[{"notice":"Error when a module function is called by a non-internal contract"}],"Module_OnlyParent(address)":[{"notice":"Error when a module function is called by a non-parent contract"}]},"kind":"user","methods":{"INIT()":{"notice":"Initialization function for the module"},"PARENT()":{"notice":"The parent contract for this module."},"TYPE()":{"notice":"2 byte identifier for the module type"},"VEECODE()":{"notice":"7 byte, versioned identifier for the module. 2 characters from 0-9 that signify the version and 3-5 characters from A-Z."},"abort(uint96)":{"notice":"Abort a batch auction that cannot be settled, refunding the seller and allowing bidders to claim refunds"},"auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)":{"notice":"Create an auction lot"},"auctionType()":{"notice":"Get the auction type"},"bid(uint96,address,address,uint256,bytes)":{"notice":"Bid on an auction lot"},"cancelAuction(uint96)":{"notice":"Cancel an auction lot"},"capacityInQuote(uint96)":{"notice":"Get whether or not the capacity is in quote tokens"},"claimBids(uint96,uint64[])":{"notice":"Claim multiple bids"},"dedicatedSettlePeriod()":{"notice":"Time period after auction conclusion where bidders cannot refund bids"},"getAuctionData(uint96)":{"notice":"Returns the `AuctionData` data for an auction lot"},"getBid(uint96,uint64)":{"notice":"Returns the `Bid` and `EncryptedBid` data for a given lot and bid ID"},"getBidClaim(uint96,uint64)":{"notice":"Get the claim data for a bidThis provides information on the outcome of a bid, independent of the claim status"},"getBidIdAtIndex(uint96,uint256)":{"notice":"Get the bid ID at the given index"},"getBidIds(uint96,uint256,uint256)":{"notice":"Get the bid IDs from the given index"},"getLot(uint96)":{"notice":"Get the lot data for a given lot ID"},"getNumBids(uint96)":{"notice":"Get the number of bids for a lot"},"getPartialFill(uint96)":{"notice":"Returns the `PartialFill` data for an auction lot"},"hasEnded(uint96)":{"notice":"Returns whether the auction has ended"},"isLive(uint96)":{"notice":"Returns whether the auction is currently accepting bids or purchases"},"isUpcoming(uint96)":{"notice":"Returns whether the auction is upcoming"},"lotAuctionOutput(uint96)":{"notice":"Custom auction output for each lot"},"lotData(uint96)":{"notice":"General information pertaining to auction lots"},"minAuctionDuration()":{"notice":"Minimum auction duration in seconds"},"refundBid(uint96,uint64,uint256,address)":{"notice":"Refund a bid"},"remainingCapacity(uint96)":{"notice":"Get the remaining capacity of a lot"},"setMinAuctionDuration(uint48)":{"notice":"Set the minimum auction duration"},"settle(uint96,uint256)":{"notice":"Settle a batch auction lot with on-chain storage and settlement"}},"notice":"A module for creating fixed price batch auctions","version":1}},"settings":{"compilationTarget":{"src/modules/auctions/batch/FPB.sol":"FixedPriceBatch"},"evmVersion":"paris","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[":@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",":@prb/test/=lib/prb-math/node_modules/@prb/test/",":@uniswap/v3-core/=lib/uniswap-v3-core/",":ds-test/=lib/forge-std/lib/ds-test/src/",":erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",":forge-std/=lib/forge-std/src/",":g-uni-v1-core/=lib/g-uni-v1-core/contracts/",":openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/",":prb-math/=lib/prb-math/src/",":solady/=lib/solady/src/",":solmate/=lib/solmate/src/",":uniswap-v2-core/=lib/uniswap-v2-core/contracts/",":uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",":uniswap-v3-core/=lib/uniswap-v3-core/contracts/",":uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"]},"sources":{"lib/solady/src/utils/FixedPointMathLib.sol":{"keccak256":"0x8f90be29fd62817be94061136dd2dcc42cf2d5cc38005b1b606d2ee826598776","license":"MIT","urls":["bzz-raw://7d794cf6143263cba72409c99b5036626eeb08ed5fc71cf8beee4881c6fc58e4","dweb:/ipfs/QmePnCXajwV65z9p9rgDrjo2sgwkZodVdr6QJsWNvQvfcV"]},"lib/solmate/src/auth/Owned.sol":{"keccak256":"0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea","license":"AGPL-3.0-only","urls":["bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4","dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"]},"src/interfaces/modules/IAuction.sol":{"keccak256":"0x7039157d051a619b63ce7988be07a43b77a46043f61c5ab4e531084084bcca01","license":"AGPL-3.0-or-later","urls":["bzz-raw://32e0093e843d08deada85cf2649d61aa6b37be858e4fdb32b81bfd2c0cf2c304","dweb:/ipfs/QmPEt15nwpXoBzin32wAQKfSBqcvPdkcgLRxiu3eiN1VFg"]},"src/interfaces/modules/IBatchAuction.sol":{"keccak256":"0xbe814e420085ee1f321fef8d89ddd6b4c668e967bff5eccfbfcc2c994393a02b","license":"AGPL-3.0-or-later","urls":["bzz-raw://c1cf24444584582d87de6df951a80f28da9e611a8118a3796051fcc5087747cc","dweb:/ipfs/QmQss5Fo8wuYoAgjNZYRTUqSEwHeV4SXCVJTQazbEo1aCw"]},"src/interfaces/modules/auctions/IFixedPriceBatch.sol":{"keccak256":"0x9220e5c2980c6a5ed8755bdaf265f8b7195a71e0d20f4a6435112c3acbf9f9df","license":"AGPL-3.0-or-later","urls":["bzz-raw://2315b35e2659050d0a644f8d72254cafa57add9f5c44477dde5476e7ff409af8","dweb:/ipfs/QmXJwUXm95RcVGaSEoX6QuB719vs4iqEu88sMHpturPC25"]},"src/modules/Auction.sol":{"keccak256":"0x4abc2212016836dbef38428b3a938d299b0f01e8b17b6d13ab86207439fdfd10","license":"BSL-1.1","urls":["bzz-raw://43debb1e08d7f9b4f0a8adfbd982cda068ad934eea123e0dad1a235d8a8c9ce3","dweb:/ipfs/QmZfe5VNfsa79pFt9TUogrbV2dAvpCpW4VWfpAhQiowGLC"]},"src/modules/Keycode.sol":{"keccak256":"0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e","license":"AGPL-3.0-or-later","urls":["bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd","dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"]},"src/modules/Modules.sol":{"keccak256":"0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689","license":"AGPL-3.0-or-later","urls":["bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee","dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"]},"src/modules/auctions/BatchAuctionModule.sol":{"keccak256":"0x7fd51c1ba66d2ee5988f96391983d7ac3ce14aa282b56affba69cc55de3f8907","license":"BSL-1.1","urls":["bzz-raw://cb7c98b9a308f6ba21be2cc56398fc719df9a5e0a731f56f49b66213a9476085","dweb:/ipfs/QmWU8pW8AKL3tvfL4EZTRxpkCtvGGwLNDpuFCYauCVjnXf"]},"src/modules/auctions/batch/FPB.sol":{"keccak256":"0xe33883b525100f8293d200a6f9d1b2ed6b2515e8800521b1befe88eeeeef7f48","license":"BSL-1.1","urls":["bzz-raw://85969657fc002bf7b3e2799b53250edd047ac65f8c108b12fe684ac2ee187212","dweb:/ipfs/QmdjtkEru7vzVEVuErk7YQfgJTrKpC211dNFKYMNv1tb7W"]}},"version":1}',
  metadata: {
    compiler: {
      version: "0.8.19+commit.7dd6d404"
    },
    language: "Solidity",
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "auctionHouse_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "constructor"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_AmountLessThanMinimum"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_DedicatedSettlePeriod"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_InsufficientCapacity"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            },
            {
              internalType: "uint96",
              name: "bidId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_InvalidBidId"
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "duration_",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "minimum_",
              type: "uint48"
            }
          ],
          type: "error",
          name: "Auction_InvalidDuration"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_InvalidLotId"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_InvalidParams"
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "start_",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "minimum_",
              type: "uint48"
            }
          ],
          type: "error",
          name: "Auction_InvalidStart"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_LotActive"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_LotNotActive"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_LotNotConcluded"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_NotAuthorized"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_NotBidder"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_NotImplemented"
        },
        {
          inputs: [],
          type: "error",
          name: "Auction_OnlyLotOwner"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            }
          ],
          type: "error",
          name: "Auction_WrongState"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ],
          type: "error",
          name: "Bid_WrongState"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "parent_",
              type: "address"
            }
          ],
          type: "error",
          name: "Module_InvalidParent"
        },
        {
          inputs: [],
          type: "error",
          name: "Module_OnlyInternal"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller_",
              type: "address"
            }
          ],
          type: "error",
          name: "Module_OnlyParent"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller",
              type: "address"
            }
          ],
          type: "error",
          name: "NotPermitted"
        },
        {
          inputs: [],
          stateMutability: "nonpayable",
          type: "function",
          name: "INIT"
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "PARENT",
          outputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "TYPE",
          outputs: [
            {
              internalType: "enum Module.Type",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "VEECODE",
          outputs: [
            {
              internalType: "Veecode",
              name: "",
              type: "bytes7"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "abort"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "struct IAuction.AuctionParams",
              name: "params_",
              type: "tuple",
              components: [
                {
                  internalType: "uint48",
                  name: "start",
                  type: "uint48"
                },
                {
                  internalType: "uint48",
                  name: "duration",
                  type: "uint48"
                },
                {
                  internalType: "bool",
                  name: "capacityInQuote",
                  type: "bool"
                },
                {
                  internalType: "uint256",
                  name: "capacity",
                  type: "uint256"
                },
                {
                  internalType: "bytes",
                  name: "implParams",
                  type: "bytes"
                }
              ]
            },
            {
              internalType: "uint8",
              name: "quoteTokenDecimals_",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "baseTokenDecimals_",
              type: "uint8"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "auction"
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "auctionType",
          outputs: [
            {
              internalType: "enum IAuction.AuctionType",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "address",
              name: "bidder_",
              type: "address"
            },
            {
              internalType: "address",
              name: "referrer_",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            },
            {
              internalType: "bytes",
              name: "auctionData_",
              type: "bytes"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "bid",
          outputs: [
            {
              internalType: "uint64",
              name: "bidId",
              type: "uint64"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "cancelAuction"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "capacityInQuote",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64[]",
              name: "bidIds_",
              type: "uint64[]"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "claimBids",
          outputs: [
            {
              internalType: "struct IBatchAuction.BidClaim[]",
              name: "bidClaims",
              type: "tuple[]",
              components: [
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "uint256",
                  name: "paid",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "payout",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "refund",
                  type: "uint256"
                }
              ]
            },
            {
              internalType: "bytes",
              name: "auctionOutput",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "dedicatedSettlePeriod",
          outputs: [
            {
              internalType: "uint48",
              name: "",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getAuctionData",
          outputs: [
            {
              internalType: "struct IFixedPriceBatch.AuctionData",
              name: "auctionData_",
              type: "tuple",
              components: [
                {
                  internalType: "uint256",
                  name: "price",
                  type: "uint256"
                },
                {
                  internalType: "enum IFixedPriceBatch.LotStatus",
                  name: "status",
                  type: "uint8"
                },
                {
                  internalType: "uint64",
                  name: "nextBidId",
                  type: "uint64"
                },
                {
                  internalType: "bool",
                  name: "settlementCleared",
                  type: "bool"
                },
                {
                  internalType: "uint256",
                  name: "totalBidAmount",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "minFilled",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBid",
          outputs: [
            {
              internalType: "struct IFixedPriceBatch.Bid",
              name: "bid",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "uint96",
                  name: "amount",
                  type: "uint96"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "enum IFixedPriceBatch.BidStatus",
                  name: "status",
                  type: "uint8"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBidClaim",
          outputs: [
            {
              internalType: "struct IBatchAuction.BidClaim",
              name: "bidClaim",
              type: "tuple",
              components: [
                {
                  internalType: "address",
                  name: "bidder",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "referrer",
                  type: "address"
                },
                {
                  internalType: "uint256",
                  name: "paid",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "payout",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "refund",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBidIdAtIndex",
          outputs: [
            {
              internalType: "uint64",
              name: "",
              type: "uint64"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getBidIds",
          outputs: [
            {
              internalType: "uint64[]",
              name: "",
              type: "uint64[]"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getLot",
          outputs: [
            {
              internalType: "struct IAuction.Lot",
              name: "",
              type: "tuple",
              components: [
                {
                  internalType: "uint48",
                  name: "start",
                  type: "uint48"
                },
                {
                  internalType: "uint48",
                  name: "conclusion",
                  type: "uint48"
                },
                {
                  internalType: "uint8",
                  name: "quoteTokenDecimals",
                  type: "uint8"
                },
                {
                  internalType: "uint8",
                  name: "baseTokenDecimals",
                  type: "uint8"
                },
                {
                  internalType: "bool",
                  name: "capacityInQuote",
                  type: "bool"
                },
                {
                  internalType: "uint256",
                  name: "capacity",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "sold",
                  type: "uint256"
                },
                {
                  internalType: "uint256",
                  name: "purchased",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getNumBids",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getPartialFill",
          outputs: [
            {
              internalType: "bool",
              name: "hasPartialFill",
              type: "bool"
            },
            {
              internalType: "struct IFixedPriceBatch.PartialFill",
              name: "partialFill",
              type: "tuple",
              components: [
                {
                  internalType: "uint64",
                  name: "bidId",
                  type: "uint64"
                },
                {
                  internalType: "uint96",
                  name: "refund",
                  type: "uint96"
                },
                {
                  internalType: "uint256",
                  name: "payout",
                  type: "uint256"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "hasEnded",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "isLive",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "isUpcoming",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "lotAuctionOutput",
          outputs: [
            {
              internalType: "bytes",
              name: "",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "id",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "lotData",
          outputs: [
            {
              internalType: "uint48",
              name: "start",
              type: "uint48"
            },
            {
              internalType: "uint48",
              name: "conclusion",
              type: "uint48"
            },
            {
              internalType: "uint8",
              name: "quoteTokenDecimals",
              type: "uint8"
            },
            {
              internalType: "uint8",
              name: "baseTokenDecimals",
              type: "uint8"
            },
            {
              internalType: "bool",
              name: "capacityInQuote",
              type: "bool"
            },
            {
              internalType: "uint256",
              name: "capacity",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "sold",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "purchased",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "minAuctionDuration",
          outputs: [
            {
              internalType: "uint48",
              name: "",
              type: "uint48"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint64",
              name: "bidId_",
              type: "uint64"
            },
            {
              internalType: "uint256",
              name: "index_",
              type: "uint256"
            },
            {
              internalType: "address",
              name: "caller_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "refundBid",
          outputs: [
            {
              internalType: "uint256",
              name: "refund",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "remainingCapacity",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "period_",
              type: "uint48"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setDedicatedSettlePeriod"
        },
        {
          inputs: [
            {
              internalType: "uint48",
              name: "duration_",
              type: "uint48"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setMinAuctionDuration"
        },
        {
          inputs: [
            {
              internalType: "uint96",
              name: "lotId_",
              type: "uint96"
            },
            {
              internalType: "uint256",
              name: "num_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "settle",
          outputs: [
            {
              internalType: "uint256",
              name: "totalIn",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "totalOut",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "capacity",
              type: "uint256"
            },
            {
              internalType: "bool",
              name: "finished",
              type: "bool"
            },
            {
              internalType: "bytes",
              name: "auctionOutput",
              type: "bytes"
            }
          ]
        }
      ],
      devdoc: {
        kind: "dev",
        methods: {
          "INIT()": {
            details: "This function is called when the module is installed or upgraded by the module.MUST BE GATED BY onlyParent. Used to encompass any initialization or upgrade logic."
          },
          "TYPE()": {
            details: "This enables the parent contract to check that the module Keycode specifiedis of the correct type"
          },
          "abort(uint96)": {
            details: "Implements a basic abort function that:             - Validates the lot id and state             - Calls the implementation-specific function             The abort function allows anyone to abort the lot after the conclusion and settlement time has passed.             This can be useful if the lot is unable to be settled, or if the seller is unwilling to settle the lot.             This function reverts if:             - The lot id is invalid             - The lot has not concluded             - The lot is in the dedicated settle period             - The lot is settled (after which it cannot be aborted)",
            params: {
              lotId_: "The lot id"
            }
          },
          "auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)": {
            details: "If the start time is zero, the auction will have a start time of the current block timestamp.             This function handles the following:             - Validates the lot parameters             - Stores the auction lot             - Calls the implementation-specific function             This function reverts if:             - The caller is not the parent of the module             - The start time is in the past             - The duration is less than the minimum",
            params: {
              baseTokenDecimals_: "The base token decimals",
              lotId_: "The lot id",
              params_: "The auction parameters",
              quoteTokenDecimals_: "The quote token decimals"
            }
          },
          "bid(uint96,address,address,uint256,bytes)": {
            details: "Implements a basic bid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot has concluded             - The lot is already settled             - The caller is not an internal module",
            params: {
              amount_: "The amount of quote tokens to bid",
              auctionData_: "The auction-specific data",
              bidder_: "The bidder of the purchased tokens",
              lotId_: "The lot id",
              referrer_: "The referrer of the bid"
            },
            returns: {
              bidId: "          The bid id"
            }
          },
          "cancelAuction(uint96)": {
            details: "Assumptions:             - The parent will refund the seller the remaining capacity             - The parent will verify that the caller is the seller             This function handles the following:             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - the caller is not the parent of the module             - the lot id is invalid             - the lot has concluded",
            params: {
              lotId_: "The lot id"
            }
          },
          "capacityInQuote(uint96)": {
            details: "The implementing function should handle the following:             - Return true if the capacity is in quote tokens             - Return false if the capacity is in base tokens",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "bool    Whether or not the capacity is in quote tokens"
            }
          },
          "claimBids(uint96,uint64[])": {
            details: "Implements a basic claimBids function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot is not settled             - The caller is not an internal module",
            params: {
              bidIds_: "The bid ids",
              lotId_: "The lot id"
            },
            returns: {
              auctionOutput: "  The auction-specific output",
              bidClaims: "      The bid claim data"
            }
          },
          "getAuctionData(uint96)": {
            details: "This function reverts if:             - The lot ID is invalid",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              auctionData_: "   The `AuctionData`"
            }
          },
          "getBid(uint96,uint64)": {
            details: "This function reverts if:             - The lot ID is invalid             - The bid ID is invalid",
            params: {
              bidId_: "The bid ID",
              lotId_: "The lot ID"
            },
            returns: {
              bid: "            The `Bid` data"
            }
          },
          "getBidClaim(uint96,uint64)": {
            details: "This function reverts if:             - The lot ID is invalid             - The lot is not settled (since there would be no claim)             - The bid ID is invalid",
            params: {
              bidId_: "The bid ID",
              lotId_: "The lot ID"
            },
            returns: {
              bidClaim: "   The bid claim data"
            }
          },
          "getBidIdAtIndex(uint96,uint256)": {
            details: "This function is not implemented in fixed price batch since bid IDs are not stored in an array",
            params: {
              index_: "The index",
              lotId_: "The lot ID"
            },
            returns: {
              _0: "  The bid ID"
            }
          },
          "getBidIds(uint96,uint256,uint256)": {
            details: "This function is not implemented in fixed price batch since bid IDs are not stored in an array",
            params: {
              count_: "The number of bids to retrieve",
              lotId_: "The lot ID",
              start_: "The index to start retrieving bid IDs from"
            },
            returns: {
              _0: " The bid IDs"
            }
          },
          "getLot(uint96)": {
            params: {
              lotId_: "The lot ID"
            }
          },
          "getNumBids(uint96)": {
            details: "This function is not implemented in fixed price batch since bid IDs are not stored in an array             A proxy is using the nextBidId to determine how many bids have been submitted, but this doesn't consider refunds",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              _0: "The number of bids"
            }
          },
          "getPartialFill(uint96)": {
            details: "For ease of use, this function determines if a partial fill exists.             This function reverts if:             - The lot ID is invalid             - The lot is not settled",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              hasPartialFill: " True if a partial fill exists",
              partialFill: "    The `PartialFill` data"
            }
          },
          "hasEnded(uint96)": {
            details: "The implementing function should handle the following:             - Return true if the lot is not accepting bids/purchases and will not at any point             - Return false if the lot hasn't started or is actively accepting bids/purchases",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "bool    Whether or not the lot is active"
            }
          },
          "isLive(uint96)": {
            details: "A lot is active if:             - The lot has not concluded             - The lot has started             - The lot has not sold out or been cancelled (capacity > 0)",
            params: {
              lotId_: "The lot ID"
            },
            returns: {
              _0: "bool    Whether or not the lot is active"
            }
          },
          "isUpcoming(uint96)": {
            details: "The implementing function should handle the following:             - Return true if the lot has not started yet AND has not been cancelled             - Return false if the lot is active, has ended, or was cancelled",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "bool    Whether or not the lot is upcoming"
            }
          },
          "refundBid(uint96,uint64,uint256,address)": {
            details: "Implements a basic refundBid function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is concluded, decrypted or settled             - The bid id is invalid             - `caller_` is not the bid owner             - The bid is claimed or refunded             - The caller is not an internal module",
            params: {
              bidId_: "The bid id",
              caller_: "The caller",
              index_: "The index of the bid ID in the auction's bid list",
              lotId_: "The lot id"
            },
            returns: {
              refund: "     The amount of quote tokens to refund"
            }
          },
          "remainingCapacity(uint96)": {
            details: "The implementing function should handle the following:             - Return the remaining capacity of the lot",
            params: {
              lotId_: "The lot id"
            },
            returns: {
              _0: "uint96 The remaining capacity of the lot"
            }
          },
          "setMinAuctionDuration(uint48)": {
            details: "This function must be called by the parent AuctionHouse, and             can be called by governance using `execOnModule`."
          },
          "settle(uint96,uint256)": {
            details: "Implements a basic settle function that:             - Validates the lot and bid parameters             - Calls the implementation-specific function             - Updates the lot data             This function reverts if:             - The lot id is invalid             - The lot has not started             - The lot is active             - The lot has already been settled             - The caller is not an internal module",
            params: {
              lotId_: "The lot id",
              num_: "The number of winning bids to settle (capped at the remaining number if more is provided)"
            },
            returns: {
              auctionOutput: "  Custom data returned by the auction module",
              capacity: "       The original capacity of the lot",
              finished: "       Whether the settlement is finished",
              totalIn: "        Total amount of quote tokens from bids that were filled",
              totalOut: "       Total amount of base tokens paid out to winning bids"
            }
          }
        },
        version: 1
      },
      userdoc: {
        kind: "user",
        methods: {
          "INIT()": {
            notice: "Initialization function for the module"
          },
          "PARENT()": {
            notice: "The parent contract for this module."
          },
          "TYPE()": {
            notice: "2 byte identifier for the module type"
          },
          "VEECODE()": {
            notice: "7 byte, versioned identifier for the module. 2 characters from 0-9 that signify the version and 3-5 characters from A-Z."
          },
          "abort(uint96)": {
            notice: "Abort a batch auction that cannot be settled, refunding the seller and allowing bidders to claim refunds"
          },
          "auction(uint96,(uint48,uint48,bool,uint256,bytes),uint8,uint8)": {
            notice: "Create an auction lot"
          },
          "auctionType()": {
            notice: "Get the auction type"
          },
          "bid(uint96,address,address,uint256,bytes)": {
            notice: "Bid on an auction lot"
          },
          "cancelAuction(uint96)": {
            notice: "Cancel an auction lot"
          },
          "capacityInQuote(uint96)": {
            notice: "Get whether or not the capacity is in quote tokens"
          },
          "claimBids(uint96,uint64[])": {
            notice: "Claim multiple bids"
          },
          "dedicatedSettlePeriod()": {
            notice: "Time period after auction conclusion where bidders cannot refund bids"
          },
          "getAuctionData(uint96)": {
            notice: "Returns the `AuctionData` data for an auction lot"
          },
          "getBid(uint96,uint64)": {
            notice: "Returns the `Bid` and `EncryptedBid` data for a given lot and bid ID"
          },
          "getBidClaim(uint96,uint64)": {
            notice: "Get the claim data for a bidThis provides information on the outcome of a bid, independent of the claim status"
          },
          "getBidIdAtIndex(uint96,uint256)": {
            notice: "Get the bid ID at the given index"
          },
          "getBidIds(uint96,uint256,uint256)": {
            notice: "Get the bid IDs from the given index"
          },
          "getLot(uint96)": {
            notice: "Get the lot data for a given lot ID"
          },
          "getNumBids(uint96)": {
            notice: "Get the number of bids for a lot"
          },
          "getPartialFill(uint96)": {
            notice: "Returns the `PartialFill` data for an auction lot"
          },
          "hasEnded(uint96)": {
            notice: "Returns whether the auction has ended"
          },
          "isLive(uint96)": {
            notice: "Returns whether the auction is currently accepting bids or purchases"
          },
          "isUpcoming(uint96)": {
            notice: "Returns whether the auction is upcoming"
          },
          "lotAuctionOutput(uint96)": {
            notice: "Custom auction output for each lot"
          },
          "lotData(uint96)": {
            notice: "General information pertaining to auction lots"
          },
          "minAuctionDuration()": {
            notice: "Minimum auction duration in seconds"
          },
          "refundBid(uint96,uint64,uint256,address)": {
            notice: "Refund a bid"
          },
          "remainingCapacity(uint96)": {
            notice: "Get the remaining capacity of a lot"
          },
          "setMinAuctionDuration(uint48)": {
            notice: "Set the minimum auction duration"
          },
          "settle(uint96,uint256)": {
            notice: "Settle a batch auction lot with on-chain storage and settlement"
          }
        },
        version: 1
      }
    },
    settings: {
      remappings: [
        "@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",
        "@prb/test/=lib/prb-math/node_modules/@prb/test/",
        "@uniswap/v3-core/=lib/uniswap-v3-core/",
        "ds-test/=lib/forge-std/lib/ds-test/src/",
        "erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",
        "forge-std/=lib/forge-std/src/",
        "g-uni-v1-core/=lib/g-uni-v1-core/contracts/",
        "openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "openzeppelin-contracts/=lib/openzeppelin-contracts/",
        "openzeppelin/=lib/openzeppelin-contracts/contracts/",
        "prb-math/=lib/prb-math/src/",
        "solady/=lib/solady/src/",
        "solmate/=lib/solmate/src/",
        "uniswap-v2-core/=lib/uniswap-v2-core/contracts/",
        "uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",
        "uniswap-v3-core/=lib/uniswap-v3-core/contracts/",
        "uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"
      ],
      optimizer: {
        enabled: true,
        runs: 200
      },
      metadata: {
        bytecodeHash: "ipfs"
      },
      compilationTarget: {
        "src/modules/auctions/batch/FPB.sol": "FixedPriceBatch"
      },
      evmVersion: "paris",
      libraries: {}
    },
    sources: {
      "lib/solady/src/utils/FixedPointMathLib.sol": {
        keccak256: "0x8f90be29fd62817be94061136dd2dcc42cf2d5cc38005b1b606d2ee826598776",
        urls: [
          "bzz-raw://7d794cf6143263cba72409c99b5036626eeb08ed5fc71cf8beee4881c6fc58e4",
          "dweb:/ipfs/QmePnCXajwV65z9p9rgDrjo2sgwkZodVdr6QJsWNvQvfcV"
        ],
        license: "MIT"
      },
      "lib/solmate/src/auth/Owned.sol": {
        keccak256: "0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea",
        urls: [
          "bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4",
          "dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"
        ],
        license: "AGPL-3.0-only"
      },
      "src/interfaces/modules/IAuction.sol": {
        keccak256: "0x7039157d051a619b63ce7988be07a43b77a46043f61c5ab4e531084084bcca01",
        urls: [
          "bzz-raw://32e0093e843d08deada85cf2649d61aa6b37be858e4fdb32b81bfd2c0cf2c304",
          "dweb:/ipfs/QmPEt15nwpXoBzin32wAQKfSBqcvPdkcgLRxiu3eiN1VFg"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/IBatchAuction.sol": {
        keccak256: "0xbe814e420085ee1f321fef8d89ddd6b4c668e967bff5eccfbfcc2c994393a02b",
        urls: [
          "bzz-raw://c1cf24444584582d87de6df951a80f28da9e611a8118a3796051fcc5087747cc",
          "dweb:/ipfs/QmQss5Fo8wuYoAgjNZYRTUqSEwHeV4SXCVJTQazbEo1aCw"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/auctions/IFixedPriceBatch.sol": {
        keccak256: "0x9220e5c2980c6a5ed8755bdaf265f8b7195a71e0d20f4a6435112c3acbf9f9df",
        urls: [
          "bzz-raw://2315b35e2659050d0a644f8d72254cafa57add9f5c44477dde5476e7ff409af8",
          "dweb:/ipfs/QmXJwUXm95RcVGaSEoX6QuB719vs4iqEu88sMHpturPC25"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/Auction.sol": {
        keccak256: "0x4abc2212016836dbef38428b3a938d299b0f01e8b17b6d13ab86207439fdfd10",
        urls: [
          "bzz-raw://43debb1e08d7f9b4f0a8adfbd982cda068ad934eea123e0dad1a235d8a8c9ce3",
          "dweb:/ipfs/QmZfe5VNfsa79pFt9TUogrbV2dAvpCpW4VWfpAhQiowGLC"
        ],
        license: "BSL-1.1"
      },
      "src/modules/Keycode.sol": {
        keccak256: "0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e",
        urls: [
          "bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd",
          "dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/Modules.sol": {
        keccak256: "0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689",
        urls: [
          "bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee",
          "dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/auctions/BatchAuctionModule.sol": {
        keccak256: "0x7fd51c1ba66d2ee5988f96391983d7ac3ce14aa282b56affba69cc55de3f8907",
        urls: [
          "bzz-raw://cb7c98b9a308f6ba21be2cc56398fc719df9a5e0a731f56f49b66213a9476085",
          "dweb:/ipfs/QmWU8pW8AKL3tvfL4EZTRxpkCtvGGwLNDpuFCYauCVjnXf"
        ],
        license: "BSL-1.1"
      },
      "src/modules/auctions/batch/FPB.sol": {
        keccak256: "0xe33883b525100f8293d200a6f9d1b2ed6b2515e8800521b1befe88eeeeef7f48",
        urls: [
          "bzz-raw://85969657fc002bf7b3e2799b53250edd047ac65f8c108b12fe684ac2ee187212",
          "dweb:/ipfs/QmdjtkEru7vzVEVuErk7YQfgJTrKpC211dNFKYMNv1tb7W"
        ],
        license: "BSL-1.1"
      }
    },
    version: 1
  },
  ast: {
    absolutePath: "src/modules/auctions/batch/FPB.sol",
    id: 93387,
    exportedSymbols: {
      AuctionModule: [88011],
      BatchAuctionModule: [89550],
      FixedPriceBatch: [93386],
      IBatchAuction: [82847],
      IFixedPriceBatch: [83343],
      Math: [55729],
      Module: [88991],
      Veecode: [88084],
      toVeecode: [88179]
    },
    nodeType: "SourceUnit",
    src: "36:20400:178",
    nodes: [
      {
        id: 92313,
        nodeType: "PragmaDirective",
        src: "36:23:178",
        nodes: [],
        literals: ["solidity", "0.8", ".19"]
      },
      {
        id: 92315,
        nodeType: "ImportDirective",
        src: "75:71:178",
        nodes: [],
        absolutePath: "src/interfaces/modules/IBatchAuction.sol",
        file: "src/interfaces/modules/IBatchAuction.sol",
        nameLocation: "-1:-1:-1",
        scope: 93387,
        sourceUnit: 82848,
        symbolAliases: [
          {
            foreign: {
              id: 92314,
              name: "IBatchAuction",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 82847,
              src: "83:13:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 92317,
        nodeType: "ImportDirective",
        src: "147:86:178",
        nodes: [],
        absolutePath: "src/interfaces/modules/auctions/IFixedPriceBatch.sol",
        file: "src/interfaces/modules/auctions/IFixedPriceBatch.sol",
        nameLocation: "-1:-1:-1",
        scope: 93387,
        sourceUnit: 83344,
        symbolAliases: [
          {
            foreign: {
              id: 92316,
              name: "IFixedPriceBatch",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 83343,
              src: "155:16:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 92319,
        nodeType: "ImportDirective",
        src: "257:77:178",
        nodes: [],
        absolutePath: "lib/solady/src/utils/FixedPointMathLib.sol",
        file: "solady/utils/FixedPointMathLib.sol",
        nameLocation: "-1:-1:-1",
        scope: 93387,
        sourceUnit: 55730,
        symbolAliases: [
          {
            foreign: {
              id: 92318,
              name: "FixedPointMathLib",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 55729,
              src: "265:17:178",
              typeDescriptions: {}
            },
            local: "Math",
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 92321,
        nodeType: "ImportDirective",
        src: "348:54:178",
        nodes: [],
        absolutePath: "src/modules/Auction.sol",
        file: "src/modules/Auction.sol",
        nameLocation: "-1:-1:-1",
        scope: 93387,
        sourceUnit: 88012,
        symbolAliases: [
          {
            foreign: {
              id: 92320,
              name: "AuctionModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88011,
              src: "356:13:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 92323,
        nodeType: "ImportDirective",
        src: "403:79:178",
        nodes: [],
        absolutePath: "src/modules/auctions/BatchAuctionModule.sol",
        file: "src/modules/auctions/BatchAuctionModule.sol",
        nameLocation: "-1:-1:-1",
        scope: 93387,
        sourceUnit: 89551,
        symbolAliases: [
          {
            foreign: {
              id: 92322,
              name: "BatchAuctionModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 89550,
              src: "411:18:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 92327,
        nodeType: "ImportDirective",
        src: "484:67:178",
        nodes: [],
        absolutePath: "src/modules/Modules.sol",
        file: "src/modules/Modules.sol",
        nameLocation: "-1:-1:-1",
        scope: 93387,
        sourceUnit: 88992,
        symbolAliases: [
          {
            foreign: {
              id: 92324,
              name: "Module",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88991,
              src: "492:6:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 92325,
              name: "Veecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88084,
              src: "500:7:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 92326,
              name: "toVeecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88179,
              src: "509:9:178",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93386,
        nodeType: "ContractDefinition",
        src: "642:19793:178",
        nodes: [
          {
            id: 92338,
            nodeType: "VariableDeclaration",
            src: "869:58:178",
            nodes: [],
            constant: false,
            documentation: {
              id: 92333,
              nodeType: "StructuredDocumentation",
              src: "762:102:178",
              text: "@notice     FPBA-specific auction data for a lot\n @dev        Access via `getAuctionData()`"
            },
            mutability: "mutable",
            name: "_auctionData",
            nameLocation: "915:12:178",
            scope: 93386,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
              typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData)"
            },
            typeName: {
              id: 92337,
              keyName: "lotId",
              keyNameLocation: "884:5:178",
              keyType: {
                id: 92334,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "877:6:178",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "869:36:178",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData)"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 92336,
                nodeType: "UserDefinedTypeName",
                pathNode: {
                  id: 92335,
                  name: "AuctionData",
                  nameLocations: ["893:11:178"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 83294,
                  src: "893:11:178"
                },
                referencedDeclaration: 83294,
                src: "893:11:178",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                  typeString: "struct IFixedPriceBatch.AuctionData"
                }
              }
            },
            visibility: "internal"
          },
          {
            id: 92346,
            nodeType: "VariableDeclaration",
            src: "1036:68:178",
            nodes: [],
            constant: false,
            documentation: {
              id: 92339,
              nodeType: "StructuredDocumentation",
              src: "934:97:178",
              text: "@notice     General information about bids on a lot\n @dev        Access via `getBid()`"
            },
            mutability: "mutable",
            name: "_bids",
            nameLocation: "1099:5:178",
            scope: 93386,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
              typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid))"
            },
            typeName: {
              id: 92345,
              keyName: "lotId",
              keyNameLocation: "1051:5:178",
              keyType: {
                id: 92340,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "1044:6:178",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "1036:53:178",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid))"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 92344,
                keyName: "bidId",
                keyNameLocation: "1075:5:178",
                keyType: {
                  id: 92341,
                  name: "uint64",
                  nodeType: "ElementaryTypeName",
                  src: "1068:6:178",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  }
                },
                nodeType: "Mapping",
                src: "1060:28:178",
                typeDescriptions: {
                  typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                  typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid)"
                },
                valueName: "",
                valueNameLocation: "-1:-1:-1",
                valueType: {
                  id: 92343,
                  nodeType: "UserDefinedTypeName",
                  pathNode: {
                    id: 92342,
                    name: "Bid",
                    nameLocations: ["1084:3:178"],
                    nodeType: "IdentifierPath",
                    referencedDeclaration: 83304,
                    src: "1084:3:178"
                  },
                  referencedDeclaration: 83304,
                  src: "1084:3:178",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                    typeString: "struct IFixedPriceBatch.Bid"
                  }
                }
              }
            },
            visibility: "internal"
          },
          {
            id: 92352,
            nodeType: "VariableDeclaration",
            src: "1273:61:178",
            nodes: [],
            constant: false,
            documentation: {
              id: 92347,
              nodeType: "StructuredDocumentation",
              src: "1111:157:178",
              text: "@notice     Partial fill data for a lot\n @dev        Each FPBA can have at most one partial fill\n             Access via `getPartialFill()`"
            },
            mutability: "mutable",
            name: "_lotPartialFill",
            nameLocation: "1319:15:178",
            scope: 93386,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
              typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill)"
            },
            typeName: {
              id: 92351,
              keyName: "lotId",
              keyNameLocation: "1288:5:178",
              keyType: {
                id: 92348,
                name: "uint96",
                nodeType: "ElementaryTypeName",
                src: "1281:6:178",
                typeDescriptions: {
                  typeIdentifier: "t_uint96",
                  typeString: "uint96"
                }
              },
              nodeType: "Mapping",
              src: "1273:36:178",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill)"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 92350,
                nodeType: "UserDefinedTypeName",
                pathNode: {
                  id: 92349,
                  name: "PartialFill",
                  nameLocations: ["1297:11:178"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 83311,
                  src: "1297:11:178"
                },
                referencedDeclaration: 83311,
                src: "1297:11:178",
                typeDescriptions: {
                  typeIdentifier: "t_struct$_PartialFill_$83311_storage_ptr",
                  typeString: "struct IFixedPriceBatch.PartialFill"
                }
              }
            },
            visibility: "internal"
          },
          {
            id: 92369,
            nodeType: "FunctionDefinition",
            src: "1380:274:178",
            nodes: [],
            body: {
              id: 92368,
              nodeType: "Block",
              src: "1444:210:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 92362,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92360,
                      name: "minAuctionDuration",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87474,
                      src: "1517:18:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "31",
                      id: 92361,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1538:6:178",
                      subdenomination: "days",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_86400_by_1",
                        typeString: "int_const 86400"
                      },
                      value: "1"
                    },
                    src: "1517:27:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  id: 92363,
                  nodeType: "ExpressionStatement",
                  src: "1517:27:178"
                },
                {
                  expression: {
                    id: 92366,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92364,
                      name: "dedicatedSettlePeriod",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 89129,
                      src: "1617:21:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "31",
                      id: 92365,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "1641:6:178",
                      subdenomination: "days",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_86400_by_1",
                        typeString: "int_const 86400"
                      },
                      value: "1"
                    },
                    src: "1617:30:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  id: 92367,
                  nodeType: "ExpressionStatement",
                  src: "1617:30:178"
                }
              ]
            },
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    id: 92357,
                    name: "auctionHouse_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 92354,
                    src: "1429:13:178",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  }
                ],
                id: 92358,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 92356,
                  name: "AuctionModule",
                  nameLocations: ["1415:13:178"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 88011,
                  src: "1415:13:178"
                },
                nodeType: "ModifierInvocation",
                src: "1415:28:178"
              }
            ],
            name: "",
            nameLocation: "-1:-1:-1",
            parameters: {
              id: 92355,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92354,
                  mutability: "mutable",
                  name: "auctionHouse_",
                  nameLocation: "1400:13:178",
                  nodeType: "VariableDeclaration",
                  scope: 92369,
                  src: "1392:21:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 92353,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "1392:7:178",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1391:23:178"
            },
            returnParameters: {
              id: 92359,
              nodeType: "ParameterList",
              parameters: [],
              src: "1444:0:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 92382,
            nodeType: "FunctionDefinition",
            src: "1687:101:178",
            nodes: [],
            body: {
              id: 92381,
              nodeType: "Block",
              src: "1745:43:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        hexValue: "303146504241",
                        id: 92378,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "1772:8:178",
                        typeDescriptions: {
                          typeIdentifier: "t_stringliteral_44d1fc4e9d67c2fc0c9fc52d742e07299e7710f1061672cda2efd6a1d16238b7",
                          typeString: 'literal_string "01FPBA"'
                        },
                        value: "01FPBA"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_stringliteral_44d1fc4e9d67c2fc0c9fc52d742e07299e7710f1061672cda2efd6a1d16238b7",
                          typeString: 'literal_string "01FPBA"'
                        }
                      ],
                      id: 92377,
                      name: "toVeecode",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88179,
                      src: "1762:9:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_bytes7_$returns$_t_userDefinedValueType$_Veecode_$88084_$",
                        typeString: "function (bytes7) pure returns (Veecode)"
                      }
                    },
                    id: 92379,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "1762:19:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                      typeString: "Veecode"
                    }
                  },
                  functionReturnParameters: 92376,
                  id: 92380,
                  nodeType: "Return",
                  src: "1755:26:178"
                }
              ]
            },
            baseFunctions: [88983],
            documentation: {
              id: 92370,
              nodeType: "StructuredDocumentation",
              src: "1660:22:178",
              text: "@inheritdoc Module"
            },
            functionSelector: "d61735ca",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "VEECODE",
            nameLocation: "1696:7:178",
            overrides: {
              id: 92372,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "1718:8:178"
            },
            parameters: {
              id: 92371,
              nodeType: "ParameterList",
              parameters: [],
              src: "1703:2:178"
            },
            returnParameters: {
              id: 92376,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92375,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92382,
                  src: "1736:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                    typeString: "Veecode"
                  },
                  typeName: {
                    id: 92374,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92373,
                      name: "Veecode",
                      nameLocations: ["1736:7:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 88084,
                      src: "1736:7:178"
                    },
                    referencedDeclaration: 88084,
                    src: "1736:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                      typeString: "Veecode"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "1735:9:178"
            },
            scope: 93386,
            stateMutability: "pure",
            virtual: false,
            visibility: "public"
          },
          {
            id: 92454,
            nodeType: "FunctionDefinition",
            src: "2363:921:178",
            nodes: [],
            body: {
              id: 92453,
              nodeType: "Block",
              src: "2453:831:178",
              nodes: [],
              statements: [
                {
                  assignments: [92396],
                  declarations: [
                    {
                      constant: false,
                      id: 92396,
                      mutability: "mutable",
                      name: "params",
                      nameLocation: "2525:6:178",
                      nodeType: "VariableDeclaration",
                      scope: 92453,
                      src: "2500:31:178",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionDataParams_$83280_memory_ptr",
                        typeString: "struct IFixedPriceBatch.AuctionDataParams"
                      },
                      typeName: {
                        id: 92395,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 92394,
                          name: "AuctionDataParams",
                          nameLocations: ["2500:17:178"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83280,
                          src: "2500:17:178"
                        },
                        referencedDeclaration: 83280,
                        src: "2500:17:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83280_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionDataParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92403,
                  initialValue: {
                    arguments: [
                      {
                        id: 92399,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92390,
                        src: "2545:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      },
                      {
                        components: [
                          {
                            id: 92400,
                            name: "AuctionDataParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83280,
                            src: "2555:17:178",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_AuctionDataParams_$83280_storage_ptr_$",
                              typeString: "type(struct IFixedPriceBatch.AuctionDataParams storage pointer)"
                            }
                          }
                        ],
                        id: 92401,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "2554:19:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_AuctionDataParams_$83280_storage_ptr_$",
                          typeString: "type(struct IFixedPriceBatch.AuctionDataParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_AuctionDataParams_$83280_storage_ptr_$",
                          typeString: "type(struct IFixedPriceBatch.AuctionDataParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 92397,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "2534:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 92398,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "2538:6:178",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "2534:10:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 92402,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2534:40:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionDataParams_$83280_memory_ptr",
                      typeString: "struct IFixedPriceBatch.AuctionDataParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2500:74:178"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92407,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 92404,
                        name: "params",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92396,
                        src: "2631:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83280_memory_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionDataParams memory"
                        }
                      },
                      id: 92405,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "2638:5:178",
                      memberName: "price",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83277,
                      src: "2631:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 92406,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2647:1:178",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "2631:17:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92411,
                  nodeType: "IfStatement",
                  src: "2627:53:178",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 92408,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "2657:21:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 92409,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2657:23:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92410,
                    nodeType: "RevertStatement",
                    src: "2650:30:178"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    },
                    id: 92415,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 92412,
                        name: "params",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92396,
                        src: "2756:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83280_memory_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionDataParams memory"
                        }
                      },
                      id: 92413,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "2763:14:178",
                      memberName: "minFillPercent",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83279,
                      src: "2756:21:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint24",
                        typeString: "uint24"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 92414,
                      name: "_ONE_HUNDRED_PERCENT",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87471,
                      src: "2780:20:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "2756:44:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92419,
                  nodeType: "IfStatement",
                  src: "2752:80:178",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 92416,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "2809:21:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 92417,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2809:23:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92418,
                    nodeType: "RevertStatement",
                    src: "2802:30:178"
                  }
                },
                {
                  assignments: [92422],
                  declarations: [
                    {
                      constant: false,
                      id: 92422,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "2895:4:178",
                      nodeType: "VariableDeclaration",
                      scope: 92453,
                      src: "2875:24:178",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                        typeString: "struct IFixedPriceBatch.AuctionData"
                      },
                      typeName: {
                        id: 92421,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 92420,
                          name: "AuctionData",
                          nameLocations: ["2875:11:178"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83294,
                          src: "2875:11:178"
                        },
                        referencedDeclaration: 83294,
                        src: "2875:11:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92426,
                  initialValue: {
                    baseExpression: {
                      id: 92423,
                      name: "_auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92338,
                      src: "2902:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                        typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                      }
                    },
                    id: 92425,
                    indexExpression: {
                      id: 92424,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92385,
                      src: "2915:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "2902:20:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                      typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "2875:47:178"
                },
                {
                  expression: {
                    id: 92432,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 92427,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92422,
                        src: "2932:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                        }
                      },
                      id: 92429,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "2937:5:178",
                      memberName: "price",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83282,
                      src: "2932:10:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 92430,
                        name: "params",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92396,
                        src: "2945:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionDataParams_$83280_memory_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionDataParams memory"
                        }
                      },
                      id: 92431,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "2952:5:178",
                      memberName: "price",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83277,
                      src: "2945:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "2932:25:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92433,
                  nodeType: "ExpressionStatement",
                  src: "2932:25:178"
                },
                {
                  expression: {
                    id: 92438,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 92434,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92422,
                        src: "2967:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                        }
                      },
                      id: 92436,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "2972:9:178",
                      memberName: "nextBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83287,
                      src: "2967:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "31",
                      id: 92437,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2984:1:178",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_1_by_1",
                        typeString: "int_const 1"
                      },
                      value: "1"
                    },
                    src: "2967:18:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  id: 92439,
                  nodeType: "ExpressionStatement",
                  src: "2967:18:178"
                },
                {
                  expression: {
                    id: 92451,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 92440,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92422,
                        src: "3171:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                        }
                      },
                      id: 92442,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "3176:9:178",
                      memberName: "minFilled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83293,
                      src: "3171:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          expression: {
                            id: 92445,
                            name: "lot_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92388,
                            src: "3218:4:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Lot_$82587_memory_ptr",
                              typeString: "struct IAuction.Lot memory"
                            }
                          },
                          id: 92446,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "3223:8:178",
                          memberName: "capacity",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82582,
                          src: "3218:13:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        {
                          expression: {
                            id: 92447,
                            name: "params",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92396,
                            src: "3233:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_AuctionDataParams_$83280_memory_ptr",
                              typeString: "struct IFixedPriceBatch.AuctionDataParams memory"
                            }
                          },
                          id: 92448,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "3240:14:178",
                          memberName: "minFillPercent",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83279,
                          src: "3233:21:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint24",
                            typeString: "uint24"
                          }
                        },
                        {
                          id: 92449,
                          name: "_ONE_HUNDRED_PERCENT",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87471,
                          src: "3256:20:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          {
                            typeIdentifier: "t_uint24",
                            typeString: "uint24"
                          },
                          {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        ],
                        expression: {
                          id: 92443,
                          name: "Math",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 55729,
                          src: "3200:4:178",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                            typeString: "type(library FixedPointMathLib)"
                          }
                        },
                        id: 92444,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "3205:12:178",
                        memberName: "fullMulDivUp",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 55070,
                        src: "3200:17:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                          typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                        }
                      },
                      id: 92450,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "3200:77:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "3171:106:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92452,
                  nodeType: "ExpressionStatement",
                  src: "3171:106:178"
                }
              ]
            },
            baseFunctions: [87636],
            documentation: {
              id: 92383,
              nodeType: "StructuredDocumentation",
              src: "1835:523:178",
              text: "@inheritdoc AuctionModule\n @dev        This function assumes:\n             - The lot ID has been validated\n             - The start and duration of the lot have been validated\n             This function reverts if:\n             - The parameters cannot be decoded into the correct format\n             - The price is zero\n             - The minimum fill percentage is greater than\n @param      params_    ABI-encoded data of type `AuctionDataParams`"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_auction",
            nameLocation: "2372:8:178",
            overrides: {
              id: 92392,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "2444:8:178"
            },
            parameters: {
              id: 92391,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92385,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "2388:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92454,
                  src: "2381:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92384,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "2381:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92388,
                  mutability: "mutable",
                  name: "lot_",
                  nameLocation: "2407:4:178",
                  nodeType: "VariableDeclaration",
                  scope: 92454,
                  src: "2396:15:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Lot_$82587_memory_ptr",
                    typeString: "struct IAuction.Lot"
                  },
                  typeName: {
                    id: 92387,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92386,
                      name: "Lot",
                      nameLocations: ["2396:3:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82587,
                      src: "2396:3:178"
                    },
                    referencedDeclaration: 82587,
                    src: "2396:3:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Lot_$82587_storage_ptr",
                      typeString: "struct IAuction.Lot"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92390,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "2426:7:178",
                  nodeType: "VariableDeclaration",
                  scope: 92454,
                  src: "2413:20:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 92389,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "2413:5:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2380:54:178"
            },
            returnParameters: {
              id: 92393,
              nodeType: "ParameterList",
              parameters: [],
              src: "2453:0:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92474,
            nodeType: "FunctionDefinition",
            src: "3815:450:178",
            nodes: [],
            body: {
              id: 92473,
              nodeType: "Block",
              src: "3872:393:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 92462,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92457,
                        src: "4060:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92461,
                      name: "_revertIfLotActive",
                      nodeType: "Identifier",
                      overloadedDeclarations: [93253],
                      referencedDeclaration: 93253,
                      src: "4041:18:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92463,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "4041:26:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92464,
                  nodeType: "ExpressionStatement",
                  src: "4041:26:178"
                },
                {
                  expression: {
                    id: 92471,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 92465,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "4211:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 92467,
                        indexExpression: {
                          id: 92466,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92457,
                          src: "4224:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "4211:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 92468,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "4232:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83285,
                      src: "4211:27:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 92469,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83272,
                        src: "4241:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83272_$",
                          typeString: "type(enum IFixedPriceBatch.LotStatus)"
                        }
                      },
                      id: 92470,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "4251:7:178",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83271,
                      src: "4241:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    src: "4211:47:178",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_LotStatus_$83272",
                      typeString: "enum IFixedPriceBatch.LotStatus"
                    }
                  },
                  id: 92472,
                  nodeType: "ExpressionStatement",
                  src: "4211:47:178"
                }
              ]
            },
            baseFunctions: [87687],
            documentation: {
              id: 92455,
              nodeType: "StructuredDocumentation",
              src: "3290:520:178",
              text: "@inheritdoc AuctionModule\n @dev        This function assumes the following:\n             - The lot ID has been validated\n             - The caller has been authorized\n             - The auction has not concluded\n             This function performs the following:\n             - Sets the auction status to settled, and prevents claiming of proceeds\n             This function reverts if:\n             - The auction is active or has not concluded"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_cancelAuction",
            nameLocation: "3824:14:178",
            overrides: {
              id: 92459,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "3863:8:178"
            },
            parameters: {
              id: 92458,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92457,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "3846:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92474,
                  src: "3839:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92456,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "3839:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3838:15:178"
            },
            returnParameters: {
              id: 92460,
              nodeType: "ParameterList",
              parameters: [],
              src: "3872:0:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92533,
            nodeType: "FunctionDefinition",
            src: "4308:810:178",
            nodes: [],
            body: {
              id: 92532,
              nodeType: "Block",
              src: "4552:566:178",
              nodes: [],
              statements: [
                {
                  assignments: [92493],
                  declarations: [
                    {
                      constant: false,
                      id: 92493,
                      mutability: "mutable",
                      name: "fullFill",
                      nameLocation: "4630:8:178",
                      nodeType: "VariableDeclaration",
                      scope: 92532,
                      src: "4622:16:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92492,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "4622:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92500,
                  initialValue: {
                    arguments: [
                      {
                        id: 92496,
                        name: "bidAmount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92482,
                        src: "4657:10:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 92497,
                        name: "baseScale_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92484,
                        src: "4669:10:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 92498,
                        name: "price_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92486,
                        src: "4681:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 92494,
                        name: "Math",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 55729,
                        src: "4641:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                          typeString: "type(library FixedPointMathLib)"
                        }
                      },
                      id: 92495,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "4646:10:178",
                      memberName: "fullMulDiv",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 55048,
                      src: "4641:15:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                        typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                      }
                    },
                    id: 92499,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "4641:47:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4622:66:178"
                },
                {
                  assignments: [92502],
                  declarations: [
                    {
                      constant: false,
                      id: 92502,
                      mutability: "mutable",
                      name: "excess",
                      nameLocation: "4706:6:178",
                      nodeType: "VariableDeclaration",
                      scope: 92532,
                      src: "4698:14:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92501,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "4698:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92506,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92505,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92503,
                      name: "capacityExpended_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92480,
                      src: "4715:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      id: 92504,
                      name: "capacity_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92478,
                      src: "4735:9:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "4715:29:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4698:46:178"
                },
                {
                  assignments: [92508],
                  declarations: [
                    {
                      constant: false,
                      id: 92508,
                      mutability: "mutable",
                      name: "refund",
                      nameLocation: "4925:6:178",
                      nodeType: "VariableDeclaration",
                      scope: 92532,
                      src: "4918:13:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      },
                      typeName: {
                        id: 92507,
                        name: "uint96",
                        nodeType: "ElementaryTypeName",
                        src: "4918:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92518,
                  initialValue: {
                    arguments: [
                      {
                        arguments: [
                          {
                            id: 92513,
                            name: "bidAmount_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92482,
                            src: "4957:10:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          {
                            id: 92514,
                            name: "excess",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92502,
                            src: "4969:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          {
                            id: 92515,
                            name: "fullFill",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92493,
                            src: "4977:8:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          expression: {
                            id: 92511,
                            name: "Math",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 55729,
                            src: "4941:4:178",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                              typeString: "type(library FixedPointMathLib)"
                            }
                          },
                          id: 92512,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "4946:10:178",
                          memberName: "fullMulDiv",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 55048,
                          src: "4941:15:178",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                            typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                          }
                        },
                        id: 92516,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "4941:45:178",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 92510,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "4934:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint96_$",
                        typeString: "type(uint96)"
                      },
                      typeName: {
                        id: 92509,
                        name: "uint96",
                        nodeType: "ElementaryTypeName",
                        src: "4934:6:178",
                        typeDescriptions: {}
                      }
                    },
                    id: 92517,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "4934:53:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4918:69:178"
                },
                {
                  assignments: [92520],
                  declarations: [
                    {
                      constant: false,
                      id: 92520,
                      mutability: "mutable",
                      name: "payout",
                      nameLocation: "5005:6:178",
                      nodeType: "VariableDeclaration",
                      scope: 92532,
                      src: "4997:14:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92519,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "4997:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92524,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92523,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92521,
                      name: "fullFill",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92493,
                      src: "5014:8:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      id: 92522,
                      name: "excess",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92502,
                      src: "5025:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "5014:17:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4997:34:178"
                },
                {
                  expression: {
                    components: [
                      {
                        arguments: [
                          {
                            id: 92526,
                            name: "bidId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92476,
                            src: "5070:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          {
                            id: 92527,
                            name: "refund",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92508,
                            src: "5086:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          {
                            id: 92528,
                            name: "payout",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92520,
                            src: "5102:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            },
                            {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 92525,
                          name: "PartialFill",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 83311,
                          src: "5050:11:178",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_struct$_PartialFill_$83311_storage_ptr_$",
                            typeString: "type(struct IFixedPriceBatch.PartialFill storage pointer)"
                          }
                        },
                        id: 92529,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "structConstructorCall",
                        lValueRequested: false,
                        nameLocations: [
                          "5063:5:178",
                          "5078:6:178",
                          "5094:6:178"
                        ],
                        names: ["bidId", "refund", "payout"],
                        nodeType: "FunctionCall",
                        src: "5050:60:178",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                          typeString: "struct IFixedPriceBatch.PartialFill memory"
                        }
                      }
                    ],
                    id: 92530,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "5049:62:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                      typeString: "struct IFixedPriceBatch.PartialFill memory"
                    }
                  },
                  functionReturnParameters: 92491,
                  id: 92531,
                  nodeType: "Return",
                  src: "5042:69:178"
                }
              ]
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_calculatePartialFill",
            nameLocation: "4317:21:178",
            parameters: {
              id: 92487,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92476,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "4355:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4348:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92475,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "4348:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92478,
                  mutability: "mutable",
                  name: "capacity_",
                  nameLocation: "4379:9:178",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4371:17:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92477,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4371:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92480,
                  mutability: "mutable",
                  name: "capacityExpended_",
                  nameLocation: "4406:17:178",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4398:25:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92479,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4398:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92482,
                  mutability: "mutable",
                  name: "bidAmount_",
                  nameLocation: "4440:10:178",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4433:17:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92481,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "4433:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92484,
                  mutability: "mutable",
                  name: "baseScale_",
                  nameLocation: "4468:10:178",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4460:18:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92483,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4460:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92486,
                  mutability: "mutable",
                  name: "price_",
                  nameLocation: "4496:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4488:14:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92485,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4488:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4338:170:178"
            },
            returnParameters: {
              id: 92491,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92490,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92533,
                  src: "4532:18:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                    typeString: "struct IFixedPriceBatch.PartialFill"
                  },
                  typeName: {
                    id: 92489,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92488,
                      name: "PartialFill",
                      nameLocations: ["4532:11:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83311,
                      src: "4532:11:178"
                    },
                    referencedDeclaration: 83311,
                    src: "4532:11:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PartialFill_$83311_storage_ptr",
                      typeString: "struct IFixedPriceBatch.PartialFill"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4531:20:178"
            },
            scope: 93386,
            stateMutability: "pure",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92703,
            nodeType: "FunctionDefinition",
            src: "5797:2835:178",
            nodes: [],
            body: {
              id: 92702,
              nodeType: "Block",
              src: "5976:2656:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 92560,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 92552,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 92550,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92542,
                        src: "6058:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        hexValue: "30",
                        id: 92551,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "6069:1:178",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "6058:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 92559,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 92553,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92542,
                        src: "6074:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        expression: {
                          arguments: [
                            {
                              id: 92556,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "6089:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_uint96_$",
                                typeString: "type(uint96)"
                              },
                              typeName: {
                                id: 92555,
                                name: "uint96",
                                nodeType: "ElementaryTypeName",
                                src: "6089:6:178",
                                typeDescriptions: {}
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_type$_t_uint96_$",
                                typeString: "type(uint96)"
                              }
                            ],
                            id: 92554,
                            name: "type",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -27,
                            src: "6084:4:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_metatype_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 92557,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6084:12:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_magic_meta_type_t_uint96",
                            typeString: "type(uint96)"
                          }
                        },
                        id: 92558,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        memberLocation: "6097:3:178",
                        memberName: "max",
                        nodeType: "MemberAccess",
                        src: "6084:16:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      src: "6074:26:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "6058:42:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92564,
                  nodeType: "IfStatement",
                  src: "6054:78:178",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 92561,
                        name: "Auction_InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82546,
                        src: "6109:21:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 92562,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "6109:23:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 92563,
                    nodeType: "RevertStatement",
                    src: "6102:30:178"
                  }
                },
                {
                  assignments: [92566],
                  declarations: [
                    {
                      constant: false,
                      id: 92566,
                      mutability: "mutable",
                      name: "lotCapacity",
                      nameLocation: "6192:11:178",
                      nodeType: "VariableDeclaration",
                      scope: 92702,
                      src: "6184:19:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92565,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "6184:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92571,
                  initialValue: {
                    expression: {
                      baseExpression: {
                        id: 92567,
                        name: "lotData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 87480,
                        src: "6206:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                          typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                        }
                      },
                      id: 92569,
                      indexExpression: {
                        id: 92568,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92536,
                        src: "6214:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "6206:15:178",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Lot_$82587_storage",
                        typeString: "struct IAuction.Lot storage ref"
                      }
                    },
                    id: 92570,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "6222:8:178",
                    memberName: "capacity",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 82582,
                    src: "6206:24:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6184:46:178"
                },
                {
                  assignments: [92574],
                  declarations: [
                    {
                      constant: false,
                      id: 92574,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "6260:4:178",
                      nodeType: "VariableDeclaration",
                      scope: 92702,
                      src: "6240:24:178",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                        typeString: "struct IFixedPriceBatch.AuctionData"
                      },
                      typeName: {
                        id: 92573,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 92572,
                          name: "AuctionData",
                          nameLocations: ["6240:11:178"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83294,
                          src: "6240:11:178"
                        },
                        referencedDeclaration: 83294,
                        src: "6240:11:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92578,
                  initialValue: {
                    baseExpression: {
                      id: 92575,
                      name: "_auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92338,
                      src: "6267:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                        typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                      }
                    },
                    id: 92577,
                    indexExpression: {
                      id: 92576,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92536,
                      src: "6280:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "6267:20:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                      typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6240:47:178"
                },
                {
                  assignments: [92580],
                  declarations: [
                    {
                      constant: false,
                      id: 92580,
                      mutability: "mutable",
                      name: "bidId",
                      nameLocation: "6361:5:178",
                      nodeType: "VariableDeclaration",
                      scope: 92702,
                      src: "6354:12:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      },
                      typeName: {
                        id: 92579,
                        name: "uint64",
                        nodeType: "ElementaryTypeName",
                        src: "6354:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92584,
                  initialValue: {
                    id: 92583,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "UnaryOperation",
                    operator: "++",
                    prefix: false,
                    src: "6369:16:178",
                    subExpression: {
                      expression: {
                        id: 92581,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92574,
                        src: "6369:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                        }
                      },
                      id: 92582,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6374:9:178",
                      memberName: "nextBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83287,
                      src: "6369:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6354:31:178"
                },
                {
                  assignments: [92586],
                  declarations: [
                    {
                      constant: false,
                      id: 92586,
                      mutability: "mutable",
                      name: "amount96",
                      nameLocation: "6455:8:178",
                      nodeType: "VariableDeclaration",
                      scope: 92702,
                      src: "6448:15:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      },
                      typeName: {
                        id: 92585,
                        name: "uint96",
                        nodeType: "ElementaryTypeName",
                        src: "6448:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92591,
                  initialValue: {
                    arguments: [
                      {
                        id: 92589,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92542,
                        src: "6473:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 92588,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "6466:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint96_$",
                        typeString: "type(uint96)"
                      },
                      typeName: {
                        id: 92587,
                        name: "uint96",
                        nodeType: "ElementaryTypeName",
                        src: "6466:6:178",
                        typeDescriptions: {}
                      }
                    },
                    id: 92590,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "6466:15:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "6448:33:178"
                },
                {
                  expression: {
                    id: 92604,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        baseExpression: {
                          id: 92592,
                          name: "_bids",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92346,
                          src: "6517:5:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                            typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                          }
                        },
                        id: 92595,
                        indexExpression: {
                          id: 92593,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92536,
                          src: "6523:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "6517:13:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                          typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                        }
                      },
                      id: 92596,
                      indexExpression: {
                        id: 92594,
                        name: "bidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92580,
                        src: "6531:5:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "6517:20:178",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83304_storage",
                        typeString: "struct IFixedPriceBatch.Bid storage ref"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 92598,
                          name: "bidder_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92538,
                          src: "6566:7:178",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 92599,
                          name: "amount96",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92586,
                          src: "6595:8:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 92600,
                          name: "referrer_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92540,
                          src: "6627:9:178",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          expression: {
                            id: 92601,
                            name: "BidStatus",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83275,
                            src: "6658:9:178",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_enum$_BidStatus_$83275_$",
                              typeString: "type(enum IFixedPriceBatch.BidStatus)"
                            }
                          },
                          id: 92602,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          memberLocation: "6668:9:178",
                          memberName: "Submitted",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83273,
                          src: "6658:19:178",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_BidStatus_$83275",
                            typeString: "enum IFixedPriceBatch.BidStatus"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_enum$_BidStatus_$83275",
                            typeString: "enum IFixedPriceBatch.BidStatus"
                          }
                        ],
                        id: 92597,
                        name: "Bid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83304,
                        src: "6540:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_Bid_$83304_storage_ptr_$",
                          typeString: "type(struct IFixedPriceBatch.Bid storage pointer)"
                        }
                      },
                      id: 92603,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "structConstructorCall",
                      lValueRequested: false,
                      nameLocations: [
                        "6558:6:178",
                        "6587:6:178",
                        "6617:8:178",
                        "6650:6:178"
                      ],
                      names: ["bidder", "amount", "referrer", "status"],
                      nodeType: "FunctionCall",
                      src: "6540:148:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                        typeString: "struct IFixedPriceBatch.Bid memory"
                      }
                    },
                    src: "6517:171:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83304_storage",
                      typeString: "struct IFixedPriceBatch.Bid storage ref"
                    }
                  },
                  id: 92605,
                  nodeType: "ExpressionStatement",
                  src: "6517:171:178"
                },
                {
                  expression: {
                    id: 92610,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 92606,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92574,
                        src: "6741:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                        }
                      },
                      id: 92608,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "6746:14:178",
                      memberName: "totalBidAmount",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83291,
                      src: "6741:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "+=",
                    rightHandSide: {
                      id: 92609,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92542,
                      src: "6764:7:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "6741:30:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92611,
                  nodeType: "ExpressionStatement",
                  src: "6741:30:178"
                },
                {
                  assignments: [92613],
                  declarations: [
                    {
                      constant: false,
                      id: 92613,
                      mutability: "mutable",
                      name: "baseScale",
                      nameLocation: "7096:9:178",
                      nodeType: "VariableDeclaration",
                      scope: 92702,
                      src: "7088:17:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92612,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "7088:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92620,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92619,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      hexValue: "3130",
                      id: 92614,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "7108:2:178",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_10_by_1",
                        typeString: "int_const 10"
                      },
                      value: "10"
                    },
                    nodeType: "BinaryOperation",
                    operator: "**",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 92615,
                          name: "lotData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87480,
                          src: "7114:7:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                            typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                          }
                        },
                        id: 92617,
                        indexExpression: {
                          id: 92616,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92536,
                          src: "7122:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "7114:15:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Lot_$82587_storage",
                          typeString: "struct IAuction.Lot storage ref"
                        }
                      },
                      id: 92618,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "7130:17:178",
                      memberName: "baseTokenDecimals",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82578,
                      src: "7114:33:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint8",
                        typeString: "uint8"
                      }
                    },
                    src: "7108:39:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "7088:59:178"
                },
                {
                  assignments: [92622],
                  declarations: [
                    {
                      constant: false,
                      id: 92622,
                      mutability: "mutable",
                      name: "newFilledCapacity",
                      nameLocation: "7165:17:178",
                      nodeType: "VariableDeclaration",
                      scope: 92702,
                      src: "7157:25:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92621,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "7157:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92631,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 92625,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92574,
                          src: "7201:4:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                            typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                          }
                        },
                        id: 92626,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "7206:14:178",
                        memberName: "totalBidAmount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83291,
                        src: "7201:19:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 92627,
                        name: "baseScale",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92613,
                        src: "7222:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 92628,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92574,
                          src: "7233:4:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                            typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                          }
                        },
                        id: 92629,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "7238:5:178",
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83282,
                        src: "7233:10:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 92623,
                        name: "Math",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 55729,
                        src: "7185:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                          typeString: "type(library FixedPointMathLib)"
                        }
                      },
                      id: 92624,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "7190:10:178",
                      memberName: "fullMulDiv",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 55048,
                      src: "7185:15:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                        typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                      }
                    },
                    id: 92630,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "7185:59:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "7157:87:178"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92634,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92632,
                      name: "newFilledCapacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92622,
                      src: "7350:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 92633,
                      name: "lotCapacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92566,
                      src: "7370:11:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "7350:31:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92638,
                  nodeType: "IfStatement",
                  src: "7346:74:178",
                  trueBody: {
                    id: 92637,
                    nodeType: "Block",
                    src: "7383:37:178",
                    statements: [
                      {
                        expression: {
                          id: 92635,
                          name: "bidId",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92580,
                          src: "7404:5:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        functionReturnParameters: 92549,
                        id: 92636,
                        nodeType: "Return",
                        src: "7397:12:178"
                      }
                    ]
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92641,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92639,
                      name: "newFilledCapacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92622,
                      src: "7499:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 92640,
                      name: "lotCapacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92566,
                      src: "7519:11:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "7499:31:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92688,
                  nodeType: "IfStatement",
                  src: "7495:907:178",
                  trueBody: {
                    id: 92687,
                    nodeType: "Block",
                    src: "7532:870:178",
                    statements: [
                      {
                        expression: {
                          id: 92654,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 92642,
                              name: "_lotPartialFill",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92352,
                              src: "7584:15:178",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                                typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill storage ref)"
                              }
                            },
                            id: 92644,
                            indexExpression: {
                              id: 92643,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92536,
                              src: "7600:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "7584:23:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                              typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 92646,
                                name: "bidId",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92580,
                                src: "7649:5:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              {
                                id: 92647,
                                name: "lotCapacity",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92566,
                                src: "7656:11:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              {
                                id: 92648,
                                name: "newFilledCapacity",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92622,
                                src: "7669:17:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              {
                                id: 92649,
                                name: "amount96",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92586,
                                src: "7688:8:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              {
                                id: 92650,
                                name: "baseScale",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92613,
                                src: "7698:9:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              {
                                expression: {
                                  id: 92651,
                                  name: "data",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92574,
                                  src: "7709:4:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                                    typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                                  }
                                },
                                id: 92652,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                memberLocation: "7714:5:178",
                                memberName: "price",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 83282,
                                src: "7709:10:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                },
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                },
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              ],
                              id: 92645,
                              name: "_calculatePartialFill",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92533,
                              src: "7610:21:178",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_pure$_t_uint64_$_t_uint256_$_t_uint256_$_t_uint96_$_t_uint256_$_t_uint256_$returns$_t_struct$_PartialFill_$83311_memory_ptr_$",
                                typeString: "function (uint64,uint256,uint256,uint96,uint256,uint256) pure returns (struct IFixedPriceBatch.PartialFill memory)"
                              }
                            },
                            id: 92653,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "7610:123:178",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                              typeString: "struct IFixedPriceBatch.PartialFill memory"
                            }
                          },
                          src: "7584:149:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                            typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                          }
                        },
                        id: 92655,
                        nodeType: "ExpressionStatement",
                        src: "7584:149:178"
                      },
                      {
                        expression: {
                          id: 92663,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 92656,
                              name: "data",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92574,
                              src: "7808:4:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                                typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                              }
                            },
                            id: 92658,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "7813:14:178",
                            memberName: "totalBidAmount",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83291,
                            src: "7808:19:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "-=",
                          rightHandSide: {
                            expression: {
                              baseExpression: {
                                id: 92659,
                                name: "_lotPartialFill",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92352,
                                src: "7831:15:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                                  typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill storage ref)"
                                }
                              },
                              id: 92661,
                              indexExpression: {
                                id: 92660,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92536,
                                src: "7847:6:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "7831:23:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                                typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                              }
                            },
                            id: 92662,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "7855:6:178",
                            memberName: "refund",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83308,
                            src: "7831:30:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "7808:53:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 92664,
                        nodeType: "ExpressionStatement",
                        src: "7808:53:178"
                      },
                      {
                        assignments: [92666],
                        declarations: [
                          {
                            constant: false,
                            id: 92666,
                            mutability: "mutable",
                            name: "filledCapacity",
                            nameLocation: "7937:14:178",
                            nodeType: "VariableDeclaration",
                            scope: 92687,
                            src: "7929:22:178",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            },
                            typeName: {
                              id: 92665,
                              name: "uint256",
                              nodeType: "ElementaryTypeName",
                              src: "7929:7:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 92675,
                        initialValue: {
                          arguments: [
                            {
                              expression: {
                                id: 92669,
                                name: "data",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92574,
                                src: "7970:4:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                                  typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                                }
                              },
                              id: 92670,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "7975:14:178",
                              memberName: "totalBidAmount",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83291,
                              src: "7970:19:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 92671,
                              name: "baseScale",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92613,
                              src: "7991:9:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              expression: {
                                id: 92672,
                                name: "data",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92574,
                                src: "8002:4:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                                  typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                                }
                              },
                              id: 92673,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "8007:5:178",
                              memberName: "price",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83282,
                              src: "8002:10:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              id: 92667,
                              name: "Math",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 55729,
                              src: "7954:4:178",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                typeString: "type(library FixedPointMathLib)"
                              }
                            },
                            id: 92668,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "7959:10:178",
                            memberName: "fullMulDiv",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 55048,
                            src: "7954:15:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                              typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                            }
                          },
                          id: 92674,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "7954:59:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "7929:84:178"
                      },
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 92679,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            id: 92676,
                            name: "filledCapacity",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92666,
                            src: "8327:14:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "<",
                          rightExpression: {
                            expression: {
                              id: 92677,
                              name: "data",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92574,
                              src: "8344:4:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                                typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                              }
                            },
                            id: 92678,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "8349:9:178",
                            memberName: "minFilled",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83293,
                            src: "8344:14:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "8327:31:178",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 92686,
                        nodeType: "IfStatement",
                        src: "8323:68:178",
                        trueBody: {
                          expression: {
                            id: 92684,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            leftHandSide: {
                              expression: {
                                id: 92680,
                                name: "data",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92574,
                                src: "8360:4:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                                  typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                                }
                              },
                              id: 92682,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: true,
                              memberLocation: "8365:9:178",
                              memberName: "minFilled",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83293,
                              src: "8360:14:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            nodeType: "Assignment",
                            operator: "=",
                            rightHandSide: {
                              id: 92683,
                              name: "filledCapacity",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92666,
                              src: "8377:14:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            src: "8360:31:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          id: 92685,
                          nodeType: "ExpressionStatement",
                          src: "8360:31:178"
                        }
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 92698,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 92689,
                          name: "lotData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 87480,
                          src: "8550:7:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                            typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                          }
                        },
                        id: 92691,
                        indexExpression: {
                          id: 92690,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92536,
                          src: "8558:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "8550:15:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Lot_$82587_storage",
                          typeString: "struct IAuction.Lot storage ref"
                        }
                      },
                      id: 92692,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "8566:10:178",
                      memberName: "conclusion",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82574,
                      src: "8550:26:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          expression: {
                            id: 92695,
                            name: "block",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -4,
                            src: "8586:5:178",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_block",
                              typeString: "block"
                            }
                          },
                          id: 92696,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "8592:9:178",
                          memberName: "timestamp",
                          nodeType: "MemberAccess",
                          src: "8586:15:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 92694,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "8579:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_uint48_$",
                          typeString: "type(uint48)"
                        },
                        typeName: {
                          id: 92693,
                          name: "uint48",
                          nodeType: "ElementaryTypeName",
                          src: "8579:6:178",
                          typeDescriptions: {}
                        }
                      },
                      id: 92697,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "8579:23:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "8550:52:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  id: 92699,
                  nodeType: "ExpressionStatement",
                  src: "8550:52:178"
                },
                {
                  expression: {
                    id: 92700,
                    name: "bidId",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 92580,
                    src: "8620:5:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  functionReturnParameters: 92549,
                  id: 92701,
                  nodeType: "Return",
                  src: "8613:12:178"
                }
              ]
            },
            baseFunctions: [89206],
            documentation: {
              id: 92534,
              nodeType: "StructuredDocumentation",
              src: "5124:668:178",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates inputs\n             - Stores the bid\n             - Conditionally ends the auction if the bid fills the lot (bid may be partial fill)\n             - Returns the bid ID\n             This function assumes:\n             - The lot ID has been validated\n             - The caller has been authorized\n             - The auction is active\n             This function reverts if:\n             - Amount is zero\n             - Amount is greater than the maximum uint96"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_bid",
            nameLocation: "5806:4:178",
            overrides: {
              id: 92546,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "5950:8:178"
            },
            parameters: {
              id: 92545,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92536,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "5827:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92703,
                  src: "5820:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92535,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "5820:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92538,
                  mutability: "mutable",
                  name: "bidder_",
                  nameLocation: "5851:7:178",
                  nodeType: "VariableDeclaration",
                  scope: 92703,
                  src: "5843:15:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 92537,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5843:7:178",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92540,
                  mutability: "mutable",
                  name: "referrer_",
                  nameLocation: "5876:9:178",
                  nodeType: "VariableDeclaration",
                  scope: 92703,
                  src: "5868:17:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 92539,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5868:7:178",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92542,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "5903:7:178",
                  nodeType: "VariableDeclaration",
                  scope: 92703,
                  src: "5895:15:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92541,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5895:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92544,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92703,
                  src: "5920:14:178",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_calldata_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 92543,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "5920:5:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5810:130:178"
            },
            returnParameters: {
              id: 92549,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92548,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92703,
                  src: "5968:6:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92547,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "5968:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5967:8:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92754,
            nodeType: "FunctionDefinition",
            src: "9142:522:178",
            nodes: [],
            body: {
              id: 92753,
              nodeType: "Block",
              src: "9291:373:178",
              nodes: [],
              statements: [
                {
                  assignments: [92720],
                  declarations: [
                    {
                      constant: false,
                      id: 92720,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "9358:4:178",
                      nodeType: "VariableDeclaration",
                      scope: 92753,
                      src: "9338:24:178",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                        typeString: "struct IFixedPriceBatch.AuctionData"
                      },
                      typeName: {
                        id: 92719,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 92718,
                          name: "AuctionData",
                          nameLocations: ["9338:11:178"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83294,
                          src: "9338:11:178"
                        },
                        referencedDeclaration: 83294,
                        src: "9338:11:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92724,
                  initialValue: {
                    baseExpression: {
                      id: 92721,
                      name: "_auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92338,
                      src: "9365:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                        typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                      }
                    },
                    id: 92723,
                    indexExpression: {
                      id: 92722,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92706,
                      src: "9378:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "9365:20:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                      typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9338:47:178"
                },
                {
                  assignments: [92727],
                  declarations: [
                    {
                      constant: false,
                      id: 92727,
                      mutability: "mutable",
                      name: "bid",
                      nameLocation: "9407:3:178",
                      nodeType: "VariableDeclaration",
                      scope: 92753,
                      src: "9395:15:178",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                        typeString: "struct IFixedPriceBatch.Bid"
                      },
                      typeName: {
                        id: 92726,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 92725,
                          name: "Bid",
                          nameLocations: ["9395:3:178"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83304,
                          src: "9395:3:178"
                        },
                        referencedDeclaration: 83304,
                        src: "9395:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                          typeString: "struct IFixedPriceBatch.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92733,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 92728,
                        name: "_bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92346,
                        src: "9413:5:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                        }
                      },
                      id: 92730,
                      indexExpression: {
                        id: 92729,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92706,
                        src: "9419:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "9413:13:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                        typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                      }
                    },
                    id: 92732,
                    indexExpression: {
                      id: 92731,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92708,
                      src: "9427:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "9413:21:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83304_storage",
                      typeString: "struct IFixedPriceBatch.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9395:39:178"
                },
                {
                  expression: {
                    id: 92739,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 92734,
                        name: "bid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92727,
                        src: "9478:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                          typeString: "struct IFixedPriceBatch.Bid storage pointer"
                        }
                      },
                      id: 92736,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "9482:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83303,
                      src: "9478:10:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83275",
                        typeString: "enum IFixedPriceBatch.BidStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 92737,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83275,
                        src: "9491:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83275_$",
                          typeString: "type(enum IFixedPriceBatch.BidStatus)"
                        }
                      },
                      id: 92738,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "9501:7:178",
                      memberName: "Claimed",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83274,
                      src: "9491:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83275",
                        typeString: "enum IFixedPriceBatch.BidStatus"
                      }
                    },
                    src: "9478:30:178",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_BidStatus_$83275",
                      typeString: "enum IFixedPriceBatch.BidStatus"
                    }
                  },
                  id: 92740,
                  nodeType: "ExpressionStatement",
                  src: "9478:30:178"
                },
                {
                  expression: {
                    id: 92746,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 92741,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92720,
                        src: "9558:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                          typeString: "struct IFixedPriceBatch.AuctionData storage pointer"
                        }
                      },
                      id: 92743,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "9563:14:178",
                      memberName: "totalBidAmount",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83291,
                      src: "9558:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "-=",
                    rightHandSide: {
                      expression: {
                        id: 92744,
                        name: "bid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92727,
                        src: "9581:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                          typeString: "struct IFixedPriceBatch.Bid storage pointer"
                        }
                      },
                      id: 92745,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "9585:6:178",
                      memberName: "amount",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83298,
                      src: "9581:10:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    src: "9558:33:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92747,
                  nodeType: "ExpressionStatement",
                  src: "9558:33:178"
                },
                {
                  expression: {
                    id: 92751,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92748,
                      name: "refund",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92716,
                      src: "9638:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 92749,
                        name: "bid",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92727,
                        src: "9647:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                          typeString: "struct IFixedPriceBatch.Bid storage pointer"
                        }
                      },
                      id: 92750,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "9651:6:178",
                      memberName: "amount",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83298,
                      src: "9647:10:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    src: "9638:19:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92752,
                  nodeType: "ExpressionStatement",
                  src: "9638:19:178"
                }
              ]
            },
            baseFunctions: [89273],
            documentation: {
              id: 92704,
              nodeType: "StructuredDocumentation",
              src: "8638:499:178",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Marks the bid as claimed\n             - Returns the amount to be refunded\n             This function assumes:\n             - The lot ID has been validated\n             - The bid ID has been validated\n             - The caller has been authorized\n             - The auction is active\n             - The bid has not been refunded"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_refundBid",
            nameLocation: "9151:10:178",
            overrides: {
              id: 92714,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "9257:8:178"
            },
            parameters: {
              id: 92713,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92706,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "9178:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92754,
                  src: "9171:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92705,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "9171:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92708,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "9201:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92754,
                  src: "9194:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92707,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "9194:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92710,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92754,
                  src: "9217:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92709,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9217:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92712,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92754,
                  src: "9234:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 92711,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "9234:7:178",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9161:86:178"
            },
            returnParameters: {
              id: 92717,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92716,
                  mutability: "mutable",
                  name: "refund",
                  nameLocation: "9283:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92754,
                  src: "9275:14:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92715,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9275:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9274:16:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92837,
            nodeType: "FunctionDefinition",
            src: "10315:691:178",
            nodes: [],
            body: {
              id: 92836,
              nodeType: "Block",
              src: "10483:523:178",
              nodes: [],
              statements: [
                {
                  assignments: [92771],
                  declarations: [
                    {
                      constant: false,
                      id: 92771,
                      mutability: "mutable",
                      name: "len",
                      nameLocation: "10501:3:178",
                      nodeType: "VariableDeclaration",
                      scope: 92836,
                      src: "10493:11:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92770,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "10493:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92774,
                  initialValue: {
                    expression: {
                      id: 92772,
                      name: "bidIds_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92760,
                      src: "10507:7:178",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                        typeString: "uint64[] calldata"
                      }
                    },
                    id: 92773,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "10515:6:178",
                    memberName: "length",
                    nodeType: "MemberAccess",
                    src: "10507:14:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "10493:28:178"
                },
                {
                  expression: {
                    id: 92782,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92775,
                      name: "bidClaims",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92766,
                      src: "10531:9:178",
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory[] memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 92780,
                          name: "len",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92771,
                          src: "10558:3:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        ],
                        id: 92779,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "NewExpression",
                        src: "10543:14:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr_$",
                          typeString: "function (uint256) pure returns (struct IBatchAuction.BidClaim memory[] memory)"
                        },
                        typeName: {
                          baseType: {
                            id: 92777,
                            nodeType: "UserDefinedTypeName",
                            pathNode: {
                              id: 92776,
                              name: "BidClaim",
                              nameLocations: ["10547:8:178"],
                              nodeType: "IdentifierPath",
                              referencedDeclaration: 82721,
                              src: "10547:8:178"
                            },
                            referencedDeclaration: 82721,
                            src: "10547:8:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                              typeString: "struct IBatchAuction.BidClaim"
                            }
                          },
                          id: 92778,
                          nodeType: "ArrayTypeName",
                          src: "10547:10:178",
                          typeDescriptions: {
                            typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_storage_$dyn_storage_ptr",
                            typeString: "struct IBatchAuction.BidClaim[]"
                          }
                        }
                      },
                      id: 92781,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "10543:19:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                        typeString: "struct IBatchAuction.BidClaim memory[] memory"
                      }
                    },
                    src: "10531:31:178",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory[] memory"
                    }
                  },
                  id: 92783,
                  nodeType: "ExpressionStatement",
                  src: "10531:31:178"
                },
                {
                  body: {
                    id: 92830,
                    nodeType: "Block",
                    src: "10602:354:178",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 92794,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92757,
                              src: "10660:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              baseExpression: {
                                id: 92795,
                                name: "bidIds_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92760,
                                src: "10668:7:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                  typeString: "uint64[] calldata"
                                }
                              },
                              id: 92797,
                              indexExpression: {
                                id: 92796,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92785,
                                src: "10676:1:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "10668:10:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            ],
                            id: 92793,
                            name: "_revertIfBidInvalid",
                            nodeType: "Identifier",
                            overloadedDeclarations: [93334],
                            referencedDeclaration: 93334,
                            src: "10640:19:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                              typeString: "function (uint96,uint64) view"
                            }
                          },
                          id: 92798,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "10640:39:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 92799,
                        nodeType: "ExpressionStatement",
                        src: "10640:39:178"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 92801,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92757,
                              src: "10713:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              baseExpression: {
                                id: 92802,
                                name: "bidIds_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92760,
                                src: "10721:7:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                  typeString: "uint64[] calldata"
                                }
                              },
                              id: 92804,
                              indexExpression: {
                                id: 92803,
                                name: "i",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92785,
                                src: "10729:1:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "10721:10:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            ],
                            id: 92800,
                            name: "_revertIfBidClaimed",
                            nodeType: "Identifier",
                            overloadedDeclarations: [93385],
                            referencedDeclaration: 93385,
                            src: "10693:19:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                              typeString: "function (uint96,uint64) view"
                            }
                          },
                          id: 92805,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "10693:39:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 92806,
                        nodeType: "ExpressionStatement",
                        src: "10693:39:178"
                      },
                      {
                        expression: {
                          id: 92817,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              baseExpression: {
                                baseExpression: {
                                  id: 92807,
                                  name: "_bids",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92346,
                                  src: "10792:5:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                                    typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                                  }
                                },
                                id: 92812,
                                indexExpression: {
                                  id: 92808,
                                  name: "lotId_",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92757,
                                  src: "10798:6:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                },
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: false,
                                nodeType: "IndexAccess",
                                src: "10792:13:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                                  typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                                }
                              },
                              id: 92813,
                              indexExpression: {
                                baseExpression: {
                                  id: 92809,
                                  name: "bidIds_",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92760,
                                  src: "10806:7:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                    typeString: "uint64[] calldata"
                                  }
                                },
                                id: 92811,
                                indexExpression: {
                                  id: 92810,
                                  name: "i",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92785,
                                  src: "10814:1:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                nodeType: "IndexAccess",
                                src: "10806:10:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "10792:25:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Bid_$83304_storage",
                                typeString: "struct IFixedPriceBatch.Bid storage ref"
                              }
                            },
                            id: 92814,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "10818:6:178",
                            memberName: "status",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83303,
                            src: "10792:32:178",
                            typeDescriptions: {
                              typeIdentifier: "t_enum$_BidStatus_$83275",
                              typeString: "enum IFixedPriceBatch.BidStatus"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 92815,
                              name: "BidStatus",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 83275,
                              src: "10827:9:178",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_enum$_BidStatus_$83275_$",
                                typeString: "type(enum IFixedPriceBatch.BidStatus)"
                              }
                            },
                            id: 92816,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "10837:7:178",
                            memberName: "Claimed",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83274,
                            src: "10827:17:178",
                            typeDescriptions: {
                              typeIdentifier: "t_enum$_BidStatus_$83275",
                              typeString: "enum IFixedPriceBatch.BidStatus"
                            }
                          },
                          src: "10792:52:178",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_BidStatus_$83275",
                            typeString: "enum IFixedPriceBatch.BidStatus"
                          }
                        },
                        id: 92818,
                        nodeType: "ExpressionStatement",
                        src: "10792:52:178"
                      },
                      {
                        expression: {
                          id: 92828,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 92819,
                              name: "bidClaims",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92766,
                              src: "10898:9:178",
                              typeDescriptions: {
                                typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory[] memory"
                              }
                            },
                            id: 92821,
                            indexExpression: {
                              id: 92820,
                              name: "i",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92785,
                              src: "10908:1:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "10898:12:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                              typeString: "struct IBatchAuction.BidClaim memory"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 92823,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92757,
                                src: "10926:6:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              {
                                baseExpression: {
                                  id: 92824,
                                  name: "bidIds_",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92760,
                                  src: "10934:7:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                                    typeString: "uint64[] calldata"
                                  }
                                },
                                id: 92826,
                                indexExpression: {
                                  id: 92825,
                                  name: "i",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 92785,
                                  src: "10942:1:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                nodeType: "IndexAccess",
                                src: "10934:10:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                },
                                {
                                  typeIdentifier: "t_uint64",
                                  typeString: "uint64"
                                }
                              ],
                              id: 92822,
                              name: "_getBidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93217,
                              src: "10913:12:178",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$_t_struct$_BidClaim_$82721_memory_ptr_$",
                                typeString: "function (uint96,uint64) view returns (struct IBatchAuction.BidClaim memory)"
                              }
                            },
                            id: 92827,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "10913:32:178",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                              typeString: "struct IBatchAuction.BidClaim memory"
                            }
                          },
                          src: "10898:47:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                            typeString: "struct IBatchAuction.BidClaim memory"
                          }
                        },
                        id: 92829,
                        nodeType: "ExpressionStatement",
                        src: "10898:47:178"
                      }
                    ]
                  },
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92789,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92787,
                      name: "i",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92785,
                      src: "10588:1:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 92788,
                      name: "len",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92771,
                      src: "10592:3:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "10588:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92831,
                  initializationExpression: {
                    assignments: [92785],
                    declarations: [
                      {
                        constant: false,
                        id: 92785,
                        mutability: "mutable",
                        name: "i",
                        nameLocation: "10585:1:178",
                        nodeType: "VariableDeclaration",
                        scope: 92831,
                        src: "10577:9:178",
                        stateVariable: false,
                        storageLocation: "default",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        typeName: {
                          id: 92784,
                          name: "uint256",
                          nodeType: "ElementaryTypeName",
                          src: "10577:7:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        visibility: "internal"
                      }
                    ],
                    id: 92786,
                    nodeType: "VariableDeclarationStatement",
                    src: "10577:9:178"
                  },
                  loopExpression: {
                    expression: {
                      id: 92791,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "UnaryOperation",
                      operator: "++",
                      prefix: false,
                      src: "10597:3:178",
                      subExpression: {
                        id: 92790,
                        name: "i",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92785,
                        src: "10597:1:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 92792,
                    nodeType: "ExpressionStatement",
                    src: "10597:3:178"
                  },
                  nodeType: "ForStatement",
                  src: "10572:384:178"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 92832,
                        name: "bidClaims",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92766,
                        src: "10974:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory[] memory"
                        }
                      },
                      {
                        id: 92833,
                        name: "auctionOutput",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92768,
                        src: "10985:13:178",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    id: 92834,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "10973:26:178",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr_$_t_bytes_memory_ptr_$",
                      typeString: "tuple(struct IBatchAuction.BidClaim memory[] memory,bytes memory)"
                    }
                  },
                  functionReturnParameters: 92769,
                  id: 92835,
                  nodeType: "Return",
                  src: "10966:33:178"
                }
              ]
            },
            baseFunctions: [89320],
            documentation: {
              id: 92755,
              nodeType: "StructuredDocumentation",
              src: "9670:640:178",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Validates the bid\n             - Marks the bid as claimed\n             - Calculates the payout and refund\n             This function assumes:\n             - The lot ID has been validated\n             - The caller has been authorized\n             - The auction has concluded\n             - The auction is not settled\n             This function reverts if:\n             - The bid ID is invalid\n             - The bid has already been claimed"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_claimBids",
            nameLocation: "10324:10:178",
            overrides: {
              id: 92762,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "10408:8:178"
            },
            parameters: {
              id: 92761,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92757,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "10351:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92837,
                  src: "10344:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92756,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "10344:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92760,
                  mutability: "mutable",
                  name: "bidIds_",
                  nameLocation: "10385:7:178",
                  nodeType: "VariableDeclaration",
                  scope: 92837,
                  src: "10367:25:178",
                  stateVariable: false,
                  storageLocation: "calldata",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_uint64_$dyn_calldata_ptr",
                    typeString: "uint64[]"
                  },
                  typeName: {
                    baseType: {
                      id: 92758,
                      name: "uint64",
                      nodeType: "ElementaryTypeName",
                      src: "10367:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    id: 92759,
                    nodeType: "ArrayTypeName",
                    src: "10367:8:178",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                      typeString: "uint64[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "10334:64:178"
            },
            returnParameters: {
              id: 92769,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92766,
                  mutability: "mutable",
                  name: "bidClaims",
                  nameLocation: "10444:9:178",
                  nodeType: "VariableDeclaration",
                  scope: 92837,
                  src: "10426:27:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_memory_ptr_$dyn_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim[]"
                  },
                  typeName: {
                    baseType: {
                      id: 92764,
                      nodeType: "UserDefinedTypeName",
                      pathNode: {
                        id: 92763,
                        name: "BidClaim",
                        nameLocations: ["10426:8:178"],
                        nodeType: "IdentifierPath",
                        referencedDeclaration: 82721,
                        src: "10426:8:178"
                      },
                      referencedDeclaration: 82721,
                      src: "10426:8:178",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                        typeString: "struct IBatchAuction.BidClaim"
                      }
                    },
                    id: 92765,
                    nodeType: "ArrayTypeName",
                    src: "10426:10:178",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_struct$_BidClaim_$82721_storage_$dyn_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim[]"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92768,
                  mutability: "mutable",
                  name: "auctionOutput",
                  nameLocation: "10468:13:178",
                  nodeType: "VariableDeclaration",
                  scope: 92837,
                  src: "10455:26:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 92767,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "10455:5:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "10425:57:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92919,
            nodeType: "FunctionDefinition",
            src: "11870:1255:178",
            nodes: [],
            body: {
              id: 92918,
              nodeType: "Block",
              src: "12070:1055:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 92860,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 92854,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "12125:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 92856,
                        indexExpression: {
                          id: 92855,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92840,
                          src: "12138:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "12125:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 92857,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "12146:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83285,
                      src: "12125:27:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 92858,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83272,
                        src: "12155:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83272_$",
                          typeString: "type(enum IFixedPriceBatch.LotStatus)"
                        }
                      },
                      id: 92859,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "12165:7:178",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83271,
                      src: "12155:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    src: "12125:47:178",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_LotStatus_$83272",
                      typeString: "enum IFixedPriceBatch.LotStatus"
                    }
                  },
                  id: 92861,
                  nodeType: "ExpressionStatement",
                  src: "12125:47:178"
                },
                {
                  assignments: [92863],
                  declarations: [
                    {
                      constant: false,
                      id: 92863,
                      mutability: "mutable",
                      name: "filledCapacity",
                      nameLocation: "12232:14:178",
                      nodeType: "VariableDeclaration",
                      scope: 92918,
                      src: "12224:22:178",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 92862,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "12224:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 92881,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          baseExpression: {
                            id: 92866,
                            name: "_auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92338,
                            src: "12278:12:178",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                              typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                            }
                          },
                          id: 92868,
                          indexExpression: {
                            id: 92867,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92840,
                            src: "12291:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "12278:20:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                            typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                          }
                        },
                        id: 92869,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "12299:14:178",
                        memberName: "totalBidAmount",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83291,
                        src: "12278:35:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 92875,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          hexValue: "3130",
                          id: 92870,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "12327:2:178",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_10_by_1",
                            typeString: "int_const 10"
                          },
                          value: "10"
                        },
                        nodeType: "BinaryOperation",
                        operator: "**",
                        rightExpression: {
                          expression: {
                            baseExpression: {
                              id: 92871,
                              name: "lotData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 87480,
                              src: "12333:7:178",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                                typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                              }
                            },
                            id: 92873,
                            indexExpression: {
                              id: 92872,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92840,
                              src: "12341:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "12333:15:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Lot_$82587_storage",
                              typeString: "struct IAuction.Lot storage ref"
                            }
                          },
                          id: 92874,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "12349:17:178",
                          memberName: "baseTokenDecimals",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82578,
                          src: "12333:33:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint8",
                            typeString: "uint8"
                          }
                        },
                        src: "12327:39:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          baseExpression: {
                            id: 92876,
                            name: "_auctionData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92338,
                            src: "12380:12:178",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                              typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                            }
                          },
                          id: 92878,
                          indexExpression: {
                            id: 92877,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92840,
                            src: "12393:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "12380:20:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                            typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                          }
                        },
                        id: 92879,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "12401:5:178",
                        memberName: "price",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83282,
                        src: "12380:26:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 92864,
                        name: "Math",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 55729,
                        src: "12249:4:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                          typeString: "type(library FixedPointMathLib)"
                        }
                      },
                      id: 92865,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "12254:10:178",
                      memberName: "fullMulDiv",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 55048,
                      src: "12249:15:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                        typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                      }
                    },
                    id: 92880,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "12249:167:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12224:192:178"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 92887,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 92882,
                      name: "filledCapacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92863,
                      src: "12534:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 92883,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "12551:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 92885,
                        indexExpression: {
                          id: 92884,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92840,
                          src: "12564:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "12551:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 92886,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "12572:9:178",
                      memberName: "minFilled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83293,
                      src: "12551:30:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "12534:47:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92895,
                  nodeType: "IfStatement",
                  src: "12530:299:178",
                  trueBody: {
                    id: 92894,
                    nodeType: "Block",
                    src: "12583:246:178",
                    statements: [
                      {
                        expression: {
                          components: [
                            {
                              id: 92888,
                              name: "totalIn_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92846,
                              src: "12776:8:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 92889,
                              name: "totalOut_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92848,
                              src: "12786:9:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              hexValue: "74727565",
                              id: 92890,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              kind: "bool",
                              lValueRequested: false,
                              nodeType: "Literal",
                              src: "12797:4:178",
                              typeDescriptions: {
                                typeIdentifier: "t_bool",
                                typeString: "bool"
                              },
                              value: "true"
                            },
                            {
                              id: 92891,
                              name: "auctionOutput_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92852,
                              src: "12803:14:178",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_memory_ptr",
                                typeString: "bytes memory"
                              }
                            }
                          ],
                          id: 92892,
                          isConstant: false,
                          isInlineArray: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "TupleExpression",
                          src: "12775:43:178",
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$_t_bool_$_t_bytes_memory_ptr_$",
                            typeString: "tuple(uint256,uint256,bool,bytes memory)"
                          }
                        },
                        functionReturnParameters: 92853,
                        id: 92893,
                        nodeType: "Return",
                        src: "12768:50:178"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 92901,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 92896,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "12921:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 92898,
                        indexExpression: {
                          id: 92897,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92840,
                          src: "12934:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "12921:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 92899,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "12942:17:178",
                      memberName: "settlementCleared",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83289,
                      src: "12921:38:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 92900,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "12962:4:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "true"
                    },
                    src: "12921:45:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92902,
                  nodeType: "ExpressionStatement",
                  src: "12921:45:178"
                },
                {
                  expression: {
                    id: 92908,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92903,
                      name: "totalIn_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92846,
                      src: "13010:8:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        baseExpression: {
                          id: 92904,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "13021:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 92906,
                        indexExpression: {
                          id: 92905,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92840,
                          src: "13034:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "13021:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 92907,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "13042:14:178",
                      memberName: "totalBidAmount",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83291,
                      src: "13021:35:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "13010:46:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92909,
                  nodeType: "ExpressionStatement",
                  src: "13010:46:178"
                },
                {
                  expression: {
                    id: 92912,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92910,
                      name: "totalOut_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92848,
                      src: "13066:9:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      id: 92911,
                      name: "filledCapacity",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92863,
                      src: "13078:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "13066:26:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 92913,
                  nodeType: "ExpressionStatement",
                  src: "13066:26:178"
                },
                {
                  expression: {
                    id: 92916,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 92914,
                      name: "finished_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92850,
                      src: "13102:9:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      hexValue: "74727565",
                      id: 92915,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "13114:4:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "true"
                    },
                    src: "13102:16:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 92917,
                  nodeType: "ExpressionStatement",
                  src: "13102:16:178"
                }
              ]
            },
            baseFunctions: [89420],
            documentation: {
              id: 92838,
              nodeType: "StructuredDocumentation",
              src: "11056:809:178",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Sets the auction status to settled\n             - Calculates the filled capacity\n             - If the filled capacity is less than the minimum filled capacity, the auction does not clear\n             - If the filled capacity is greater than or equal to the minimum filled capacity, the auction clears\n             - Returns the total in, total out, and whether the auction is finished\n             This function assumes:\n             - The lot ID has been validated\n             - The auction has concluded\n             - The auction is not settled\n             This function reverts if:\n             - None"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_settle",
            nameLocation: "11879:7:178",
            overrides: {
              id: 92844,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "11958:8:178"
            },
            parameters: {
              id: 92843,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92840,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "11903:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92919,
                  src: "11896:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92839,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "11896:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92842,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 92919,
                  src: "11919:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92841,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11919:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11886:46:178"
            },
            returnParameters: {
              id: 92853,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92846,
                  mutability: "mutable",
                  name: "totalIn_",
                  nameLocation: "11992:8:178",
                  nodeType: "VariableDeclaration",
                  scope: 92919,
                  src: "11984:16:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92845,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11984:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92848,
                  mutability: "mutable",
                  name: "totalOut_",
                  nameLocation: "12010:9:178",
                  nodeType: "VariableDeclaration",
                  scope: 92919,
                  src: "12002:17:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 92847,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "12002:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92850,
                  mutability: "mutable",
                  name: "finished_",
                  nameLocation: "12026:9:178",
                  nodeType: "VariableDeclaration",
                  scope: 92919,
                  src: "12021:14:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 92849,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "12021:4:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92852,
                  mutability: "mutable",
                  name: "auctionOutput_",
                  nameLocation: "12050:14:178",
                  nodeType: "VariableDeclaration",
                  scope: 92919,
                  src: "12037:27:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 92851,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "12037:5:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11983:82:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92935,
            nodeType: "FunctionDefinition",
            src: "13583:235:178",
            nodes: [],
            body: {
              id: 92934,
              nodeType: "Block",
              src: "13632:186:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 92932,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        baseExpression: {
                          id: 92926,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "13687:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 92928,
                        indexExpression: {
                          id: 92927,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92922,
                          src: "13700:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "13687:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 92929,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "13708:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83285,
                      src: "13687:27:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 92930,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83272,
                        src: "13717:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83272_$",
                          typeString: "type(enum IFixedPriceBatch.LotStatus)"
                        }
                      },
                      id: 92931,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "13727:7:178",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83271,
                      src: "13717:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    src: "13687:47:178",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_LotStatus_$83272",
                      typeString: "enum IFixedPriceBatch.LotStatus"
                    }
                  },
                  id: 92933,
                  nodeType: "ExpressionStatement",
                  src: "13687:47:178"
                }
              ]
            },
            baseFunctions: [89456],
            documentation: {
              id: 92920,
              nodeType: "StructuredDocumentation",
              src: "13131:447:178",
              text: "@inheritdoc BatchAuctionModule\n @dev        This function performs the following:\n             - Sets the auction status to Settled\n             This function assumes:\n             - The lot ID has been validated\n             - The auction is not settled\n             - The dedicated settle period has not passed\n             This function reverts if:\n             - None"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_abort",
            nameLocation: "13592:6:178",
            overrides: {
              id: 92924,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "13623:8:178"
            },
            parameters: {
              id: 92923,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92922,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "13606:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92935,
                  src: "13599:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92921,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "13599:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "13598:15:178"
            },
            returnParameters: {
              id: 92925,
              nodeType: "ParameterList",
              parameters: [],
              src: "13632:0:178"
            },
            scope: 93386,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 92962,
            nodeType: "FunctionDefinition",
            src: "14048:213:178",
            nodes: [],
            body: {
              id: 92961,
              nodeType: "Block",
              src: "14133:128:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 92947,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92938,
                        src: "14163:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92946,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "14143:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92948,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14143:27:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92949,
                  nodeType: "ExpressionStatement",
                  src: "14143:27:178"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 92951,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92938,
                        src: "14200:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 92952,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92940,
                        src: "14208:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 92950,
                      name: "_revertIfBidInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [93334],
                      referencedDeclaration: 93334,
                      src: "14180:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                        typeString: "function (uint96,uint64) view"
                      }
                    },
                    id: 92953,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14180:35:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92954,
                  nodeType: "ExpressionStatement",
                  src: "14180:35:178"
                },
                {
                  expression: {
                    baseExpression: {
                      baseExpression: {
                        id: 92955,
                        name: "_bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92346,
                        src: "14233:5:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                        }
                      },
                      id: 92957,
                      indexExpression: {
                        id: 92956,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92938,
                        src: "14239:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "14233:13:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                        typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                      }
                    },
                    id: 92959,
                    indexExpression: {
                      id: 92958,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92940,
                      src: "14247:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "14233:21:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83304_storage",
                      typeString: "struct IFixedPriceBatch.Bid storage ref"
                    }
                  },
                  functionReturnParameters: 92945,
                  id: 92960,
                  nodeType: "Return",
                  src: "14226:28:178"
                }
              ]
            },
            baseFunctions: [83322],
            documentation: {
              id: 92936,
              nodeType: "StructuredDocumentation",
              src: "13877:166:178",
              text: "@inheritdoc IFixedPriceBatch\n @dev        This function reverts if:\n             - The lot ID is invalid\n             - The bid ID is invalid"
            },
            functionSelector: "a8bf44e4",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBid",
            nameLocation: "14057:6:178",
            parameters: {
              id: 92941,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92938,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "14071:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92962,
                  src: "14064:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92937,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "14064:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92940,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "14086:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92962,
                  src: "14079:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 92939,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "14079:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14063:30:178"
            },
            returnParameters: {
              id: 92945,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92944,
                  mutability: "mutable",
                  name: "bid",
                  nameLocation: "14128:3:178",
                  nodeType: "VariableDeclaration",
                  scope: 92962,
                  src: "14117:14:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                    typeString: "struct IFixedPriceBatch.Bid"
                  },
                  typeName: {
                    id: 92943,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92942,
                      name: "Bid",
                      nameLocations: ["14117:3:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83304,
                      src: "14117:3:178"
                    },
                    referencedDeclaration: 83304,
                    src: "14117:3:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                      typeString: "struct IFixedPriceBatch.Bid"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14116:16:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 92981,
            nodeType: "FunctionDefinition",
            src: "14394:222:178",
            nodes: [],
            body: {
              id: 92980,
              nodeType: "Block",
              src: "14534:82:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 92973,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92965,
                        src: "14564:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92972,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "14544:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92974,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14544:27:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92975,
                  nodeType: "ExpressionStatement",
                  src: "14544:27:178"
                },
                {
                  expression: {
                    baseExpression: {
                      id: 92976,
                      name: "_auctionData",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92338,
                      src: "14589:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                        typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                      }
                    },
                    id: 92978,
                    indexExpression: {
                      id: 92977,
                      name: "lotId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92965,
                      src: "14602:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint96",
                        typeString: "uint96"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "14589:20:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                      typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                    }
                  },
                  functionReturnParameters: 92971,
                  id: 92979,
                  nodeType: "Return",
                  src: "14582:27:178"
                }
              ]
            },
            baseFunctions: [83331],
            documentation: {
              id: 92963,
              nodeType: "StructuredDocumentation",
              src: "14267:122:178",
              text: "@inheritdoc IFixedPriceBatch\n @dev        This function reverts if:\n             - The lot ID is invalid"
            },
            functionSelector: "cadb3383",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getAuctionData",
            nameLocation: "14403:14:178",
            overrides: {
              id: 92967,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "14471:8:178"
            },
            parameters: {
              id: 92966,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92965,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "14425:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 92981,
                  src: "14418:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92964,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "14418:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14417:15:178"
            },
            returnParameters: {
              id: 92971,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92970,
                  mutability: "mutable",
                  name: "auctionData_",
                  nameLocation: "14516:12:178",
                  nodeType: "VariableDeclaration",
                  scope: 92981,
                  src: "14497:31:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_AuctionData_$83294_memory_ptr",
                    typeString: "struct IFixedPriceBatch.AuctionData"
                  },
                  typeName: {
                    id: 92969,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92968,
                      name: "AuctionData",
                      nameLocations: ["14497:11:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83294,
                      src: "14497:11:178"
                    },
                    referencedDeclaration: 83294,
                    src: "14497:11:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_AuctionData_$83294_storage_ptr",
                      typeString: "struct IFixedPriceBatch.AuctionData"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14496:33:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 93018,
            nodeType: "FunctionDefinition",
            src: "14890:371:178",
            nodes: [],
            body: {
              id: 93017,
              nodeType: "Block",
              src: "15033:228:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 92993,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92984,
                        src: "15063:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92992,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "15043:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92994,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "15043:27:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92995,
                  nodeType: "ExpressionStatement",
                  src: "15043:27:178"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 92997,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92984,
                        src: "15103:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 92996,
                      name: "_revertIfLotNotSettled",
                      nodeType: "Identifier",
                      overloadedDeclarations: [93295],
                      referencedDeclaration: 93295,
                      src: "15080:22:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 92998,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "15080:30:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 92999,
                  nodeType: "ExpressionStatement",
                  src: "15080:30:178"
                },
                {
                  expression: {
                    id: 93004,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 93e3,
                      name: "partialFill",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92990,
                      src: "15121:11:178",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                        typeString: "struct IFixedPriceBatch.PartialFill memory"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      baseExpression: {
                        id: 93001,
                        name: "_lotPartialFill",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92352,
                        src: "15135:15:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                          typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill storage ref)"
                        }
                      },
                      id: 93003,
                      indexExpression: {
                        id: 93002,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92984,
                        src: "15151:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "15135:23:178",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                        typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                      }
                    },
                    src: "15121:37:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                      typeString: "struct IFixedPriceBatch.PartialFill memory"
                    }
                  },
                  id: 93005,
                  nodeType: "ExpressionStatement",
                  src: "15121:37:178"
                },
                {
                  expression: {
                    id: 93011,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 93006,
                      name: "hasPartialFill",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 92987,
                      src: "15168:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      commonType: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      },
                      id: 93010,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 93007,
                          name: "partialFill",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92990,
                          src: "15185:11:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                            typeString: "struct IFixedPriceBatch.PartialFill memory"
                          }
                        },
                        id: 93008,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "15197:5:178",
                        memberName: "bidId",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83306,
                        src: "15185:17:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "!=",
                      rightExpression: {
                        hexValue: "30",
                        id: 93009,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "15206:1:178",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "15185:22:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "15168:39:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93012,
                  nodeType: "ExpressionStatement",
                  src: "15168:39:178"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 93013,
                        name: "hasPartialFill",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92987,
                        src: "15226:14:178",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        id: 93014,
                        name: "partialFill",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92990,
                        src: "15242:11:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                          typeString: "struct IFixedPriceBatch.PartialFill memory"
                        }
                      }
                    ],
                    id: 93015,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "15225:29:178",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_bool_$_t_struct$_PartialFill_$83311_memory_ptr_$",
                      typeString: "tuple(bool,struct IFixedPriceBatch.PartialFill memory)"
                    }
                  },
                  functionReturnParameters: 92991,
                  id: 93016,
                  nodeType: "Return",
                  src: "15218:36:178"
                }
              ]
            },
            baseFunctions: [83342],
            documentation: {
              id: 92982,
              nodeType: "StructuredDocumentation",
              src: "14622:263:178",
              text: "@inheritdoc IFixedPriceBatch\n @dev        For ease of use, this function determines if a partial fill exists.\n             This function reverts if:\n             - The lot ID is invalid\n             - The lot is not settled"
            },
            functionSelector: "a16f7ef7",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getPartialFill",
            nameLocation: "14899:14:178",
            parameters: {
              id: 92985,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92984,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "14921:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93018,
                  src: "14914:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 92983,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "14914:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14913:15:178"
            },
            returnParameters: {
              id: 92991,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 92987,
                  mutability: "mutable",
                  name: "hasPartialFill",
                  nameLocation: "14981:14:178",
                  nodeType: "VariableDeclaration",
                  scope: 93018,
                  src: "14976:19:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 92986,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "14976:4:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 92990,
                  mutability: "mutable",
                  name: "partialFill",
                  nameLocation: "15016:11:178",
                  nodeType: "VariableDeclaration",
                  scope: 93018,
                  src: "14997:30:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_PartialFill_$83311_memory_ptr",
                    typeString: "struct IFixedPriceBatch.PartialFill"
                  },
                  typeName: {
                    id: 92989,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 92988,
                      name: "PartialFill",
                      nameLocations: ["14997:11:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83311,
                      src: "14997:11:178"
                    },
                    referencedDeclaration: 83311,
                    src: "14997:11:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_PartialFill_$83311_storage_ptr",
                      typeString: "struct IFixedPriceBatch.PartialFill"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14975:53:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 93028,
            nodeType: "FunctionDefinition",
            src: "15549:71:178",
            nodes: [],
            body: {
              id: 93027,
              nodeType: "Block",
              src: "15618:2:178",
              nodes: [],
              statements: []
            },
            baseFunctions: [82812],
            documentation: {
              id: 93019,
              nodeType: "StructuredDocumentation",
              src: "15267:277:178",
              text: "@inheritdoc IBatchAuction\n @dev        This function is not implemented in fixed price batch since bid IDs are not stored in an array\n             A proxy is using the nextBidId to determine how many bids have been submitted, but this doesn't consider refunds"
            },
            functionSelector: "d899a337",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getNumBids",
            nameLocation: "15558:10:178",
            overrides: {
              id: 93023,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "15591:8:178"
            },
            parameters: {
              id: 93022,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93021,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93028,
                  src: "15569:6:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93020,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "15569:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15568:8:178"
            },
            returnParameters: {
              id: 93026,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93025,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93028,
                  src: "15609:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93024,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15609:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15608:9:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 93043,
            nodeType: "FunctionDefinition",
            src: "15775:96:178",
            nodes: [],
            body: {
              id: 93042,
              nodeType: "Block",
              src: "15869:2:178",
              nodes: [],
              statements: []
            },
            baseFunctions: [82825],
            documentation: {
              id: 93029,
              nodeType: "StructuredDocumentation",
              src: "15626:144:178",
              text: "@inheritdoc IBatchAuction\n @dev        This function is not implemented in fixed price batch since bid IDs are not stored in an array"
            },
            functionSelector: "00b33217",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBidIds",
            nameLocation: "15784:9:178",
            overrides: {
              id: 93037,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "15834:8:178"
            },
            parameters: {
              id: 93036,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93031,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93043,
                  src: "15794:6:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93030,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "15794:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93033,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93043,
                  src: "15802:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93032,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15802:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93035,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93043,
                  src: "15811:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93034,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15811:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15793:26:178"
            },
            returnParameters: {
              id: 93041,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93040,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93043,
                  src: "15852:15:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_array$_t_uint64_$dyn_memory_ptr",
                    typeString: "uint64[]"
                  },
                  typeName: {
                    baseType: {
                      id: 93038,
                      name: "uint64",
                      nodeType: "ElementaryTypeName",
                      src: "15852:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    id: 93039,
                    nodeType: "ArrayTypeName",
                    src: "15852:8:178",
                    typeDescriptions: {
                      typeIdentifier: "t_array$_t_uint64_$dyn_storage_ptr",
                      typeString: "uint64[]"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15851:17:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 93055,
            nodeType: "FunctionDefinition",
            src: "16026:84:178",
            nodes: [],
            body: {
              id: 93054,
              nodeType: "Block",
              src: "16108:2:178",
              nodes: [],
              statements: []
            },
            baseFunctions: [82835],
            documentation: {
              id: 93044,
              nodeType: "StructuredDocumentation",
              src: "15877:144:178",
              text: "@inheritdoc IBatchAuction\n @dev        This function is not implemented in fixed price batch since bid IDs are not stored in an array"
            },
            functionSelector: "7d7b6853",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBidIdAtIndex",
            nameLocation: "16035:15:178",
            overrides: {
              id: 93050,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "16082:8:178"
            },
            parameters: {
              id: 93049,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93046,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93055,
                  src: "16051:6:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93045,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "16051:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93048,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93055,
                  src: "16059:7:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93047,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "16059:7:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "16050:17:178"
            },
            returnParameters: {
              id: 93053,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93052,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93055,
                  src: "16100:6:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 93051,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "16100:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "16099:8:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 93086,
            nodeType: "FunctionDefinition",
            src: "16361:306:178",
            nodes: [],
            body: {
              id: 93085,
              nodeType: "Block",
              src: "16492:175:178",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 93068,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93058,
                        src: "16522:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 93067,
                      name: "_revertIfLotInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 87871,
                      src: "16502:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 93069,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16502:27:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93070,
                  nodeType: "ExpressionStatement",
                  src: "16502:27:178"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 93072,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93058,
                        src: "16562:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      ],
                      id: 93071,
                      name: "_revertIfLotNotSettled",
                      nodeType: "Identifier",
                      overloadedDeclarations: [93295],
                      referencedDeclaration: 93295,
                      src: "16539:22:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$returns$__$",
                        typeString: "function (uint96) view"
                      }
                    },
                    id: 93073,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16539:30:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93074,
                  nodeType: "ExpressionStatement",
                  src: "16539:30:178"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 93076,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93058,
                        src: "16599:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 93077,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93060,
                        src: "16607:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 93075,
                      name: "_revertIfBidInvalid",
                      nodeType: "Identifier",
                      overloadedDeclarations: [93334],
                      referencedDeclaration: 93334,
                      src: "16579:19:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$__$",
                        typeString: "function (uint96,uint64) view"
                      }
                    },
                    id: 93078,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16579:35:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93079,
                  nodeType: "ExpressionStatement",
                  src: "16579:35:178"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 93081,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93058,
                        src: "16645:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      {
                        id: 93082,
                        name: "bidId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93060,
                        src: "16653:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        },
                        {
                          typeIdentifier: "t_uint64",
                          typeString: "uint64"
                        }
                      ],
                      id: 93080,
                      name: "_getBidClaim",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93217,
                      src: "16632:12:178",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_uint96_$_t_uint64_$returns$_t_struct$_BidClaim_$82721_memory_ptr_$",
                        typeString: "function (uint96,uint64) view returns (struct IBatchAuction.BidClaim memory)"
                      }
                    },
                    id: 93083,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16632:28:178",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory"
                    }
                  },
                  functionReturnParameters: 93066,
                  id: 93084,
                  nodeType: "Return",
                  src: "16625:35:178"
                }
              ]
            },
            baseFunctions: [82846],
            documentation: {
              id: 93056,
              nodeType: "StructuredDocumentation",
              src: "16116:240:178",
              text: "@inheritdoc IBatchAuction\n @dev        This function reverts if:\n             - The lot ID is invalid\n             - The lot is not settled (since there would be no claim)\n             - The bid ID is invalid"
            },
            functionSelector: "8f21c318",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "getBidClaim",
            nameLocation: "16370:11:178",
            overrides: {
              id: 93062,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "16448:8:178"
            },
            parameters: {
              id: 93061,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93058,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "16398:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93086,
                  src: "16391:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93057,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "16391:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93060,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "16421:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93086,
                  src: "16414:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 93059,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "16414:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "16381:52:178"
            },
            returnParameters: {
              id: 93066,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93065,
                  mutability: "mutable",
                  name: "bidClaim",
                  nameLocation: "16482:8:178",
                  nodeType: "VariableDeclaration",
                  scope: 93086,
                  src: "16466:24:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim"
                  },
                  typeName: {
                    id: 93064,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 93063,
                      name: "BidClaim",
                      nameLocations: ["16466:8:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82721,
                      src: "16466:8:178"
                    },
                    referencedDeclaration: 82721,
                    src: "16466:8:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "16465:26:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 93217,
            nodeType: "FunctionDefinition",
            src: "17025:1392:178",
            nodes: [],
            body: {
              id: 93216,
              nodeType: "Block",
              src: "17148:1269:178",
              nodes: [],
              statements: [
                {
                  assignments: [93099],
                  declarations: [
                    {
                      constant: false,
                      id: 93099,
                      mutability: "mutable",
                      name: "bidData",
                      nameLocation: "17194:7:178",
                      nodeType: "VariableDeclaration",
                      scope: 93216,
                      src: "17183:18:178",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                        typeString: "struct IFixedPriceBatch.Bid"
                      },
                      typeName: {
                        id: 93098,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 93097,
                          name: "Bid",
                          nameLocations: ["17183:3:178"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83304,
                          src: "17183:3:178"
                        },
                        referencedDeclaration: 83304,
                        src: "17183:3:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage_ptr",
                          typeString: "struct IFixedPriceBatch.Bid"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93105,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 93100,
                        name: "_bids",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92346,
                        src: "17204:5:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                          typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                        }
                      },
                      id: 93102,
                      indexExpression: {
                        id: 93101,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93089,
                        src: "17210:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "17204:13:178",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                        typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                      }
                    },
                    id: 93104,
                    indexExpression: {
                      id: 93103,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93091,
                      src: "17218:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "17204:21:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Bid_$83304_storage",
                      typeString: "struct IFixedPriceBatch.Bid storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "17183:42:178"
                },
                {
                  expression: {
                    id: 93111,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 93106,
                        name: "bidClaim",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93095,
                        src: "17286:8:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory"
                        }
                      },
                      id: 93108,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "17295:6:178",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82712,
                      src: "17286:15:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 93109,
                        name: "bidData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93099,
                        src: "17304:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                          typeString: "struct IFixedPriceBatch.Bid memory"
                        }
                      },
                      id: 93110,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "17312:6:178",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83296,
                      src: "17304:14:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "17286:32:178",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 93112,
                  nodeType: "ExpressionStatement",
                  src: "17286:32:178"
                },
                {
                  expression: {
                    id: 93118,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      expression: {
                        id: 93113,
                        name: "bidClaim",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93095,
                        src: "17328:8:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                          typeString: "struct IBatchAuction.BidClaim memory"
                        }
                      },
                      id: 93115,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      memberLocation: "17337:8:178",
                      memberName: "referrer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82714,
                      src: "17328:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      expression: {
                        id: 93116,
                        name: "bidData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93099,
                        src: "17348:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                          typeString: "struct IFixedPriceBatch.Bid memory"
                        }
                      },
                      id: 93117,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "17356:8:178",
                      memberName: "referrer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83300,
                      src: "17348:16:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "17328:36:178",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 93119,
                  nodeType: "ExpressionStatement",
                  src: "17328:36:178"
                },
                {
                  condition: {
                    expression: {
                      baseExpression: {
                        id: 93120,
                        name: "_auctionData",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 92338,
                        src: "17379:12:178",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                          typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                        }
                      },
                      id: 93122,
                      indexExpression: {
                        id: 93121,
                        name: "lotId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93089,
                        src: "17392:6:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint96",
                          typeString: "uint96"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "17379:20:178",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                        typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                      }
                    },
                    id: 93123,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "17400:17:178",
                    memberName: "settlementCleared",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 83289,
                    src: "17379:38:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 93212,
                    nodeType: "Block",
                    src: "18191:194:178",
                    statements: [
                      {
                        expression: {
                          id: 93197,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 93192,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93095,
                              src: "18265:8:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 93194,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "18274:4:178",
                            memberName: "paid",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82716,
                            src: "18265:13:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 93195,
                              name: "bidData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93099,
                              src: "18281:7:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                                typeString: "struct IFixedPriceBatch.Bid memory"
                              }
                            },
                            id: 93196,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18289:6:178",
                            memberName: "amount",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83298,
                            src: "18281:14:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "18265:30:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 93198,
                        nodeType: "ExpressionStatement",
                        src: "18265:30:178"
                      },
                      {
                        expression: {
                          id: 93203,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 93199,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93095,
                              src: "18309:8:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 93201,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "18318:6:178",
                            memberName: "payout",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82718,
                            src: "18309:15:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            hexValue: "30",
                            id: 93202,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "18327:1:178",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          },
                          src: "18309:19:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 93204,
                        nodeType: "ExpressionStatement",
                        src: "18309:19:178"
                      },
                      {
                        expression: {
                          id: 93210,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 93205,
                              name: "bidClaim",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93095,
                              src: "18342:8:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                typeString: "struct IBatchAuction.BidClaim memory"
                              }
                            },
                            id: 93207,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "18351:6:178",
                            memberName: "refund",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82720,
                            src: "18342:15:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            expression: {
                              id: 93208,
                              name: "bidData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93099,
                              src: "18360:7:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                                typeString: "struct IFixedPriceBatch.Bid memory"
                              }
                            },
                            id: 93209,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "18368:6:178",
                            memberName: "amount",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83298,
                            src: "18360:14:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          src: "18342:32:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 93211,
                        nodeType: "ExpressionStatement",
                        src: "18342:32:178"
                      }
                    ]
                  },
                  id: 93213,
                  nodeType: "IfStatement",
                  src: "17375:1010:178",
                  trueBody: {
                    id: 93191,
                    nodeType: "Block",
                    src: "17419:766:178",
                    statements: [
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          },
                          id: 93129,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              baseExpression: {
                                id: 93124,
                                name: "_lotPartialFill",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 92352,
                                src: "17494:15:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                                  typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill storage ref)"
                                }
                              },
                              id: 93126,
                              indexExpression: {
                                id: 93125,
                                name: "lotId_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 93089,
                                src: "17510:6:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint96",
                                  typeString: "uint96"
                                }
                              },
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              nodeType: "IndexAccess",
                              src: "17494:23:178",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                                typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                              }
                            },
                            id: 93127,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "17518:5:178",
                            memberName: "bidId",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 83306,
                            src: "17494:29:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            id: 93128,
                            name: "bidId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93091,
                            src: "17527:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint64",
                              typeString: "uint64"
                            }
                          },
                          src: "17494:39:178",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        falseBody: {
                          id: 93189,
                          nodeType: "Block",
                          src: "17789:386:178",
                          statements: [
                            {
                              expression: {
                                id: 93161,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 93156,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93095,
                                    src: "17879:8:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 93158,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "17888:4:178",
                                  memberName: "paid",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82716,
                                  src: "17879:13:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  expression: {
                                    id: 93159,
                                    name: "bidData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93099,
                                    src: "17895:7:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                                      typeString: "struct IFixedPriceBatch.Bid memory"
                                    }
                                  },
                                  id: 93160,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "17903:6:178",
                                  memberName: "amount",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83298,
                                  src: "17895:14:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                },
                                src: "17879:30:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 93162,
                              nodeType: "ExpressionStatement",
                              src: "17879:30:178"
                            },
                            {
                              expression: {
                                id: 93181,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 93163,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93095,
                                    src: "17927:8:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 93165,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "17936:6:178",
                                  memberName: "payout",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82718,
                                  src: "17927:15:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  arguments: [
                                    {
                                      expression: {
                                        id: 93168,
                                        name: "bidData",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 93099,
                                        src: "17982:7:178",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                                          typeString: "struct IFixedPriceBatch.Bid memory"
                                        }
                                      },
                                      id: 93169,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "17990:6:178",
                                      memberName: "amount",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 83298,
                                      src: "17982:14:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    {
                                      commonType: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      },
                                      id: 93175,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      leftExpression: {
                                        hexValue: "3130",
                                        id: 93170,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: true,
                                        kind: "number",
                                        lValueRequested: false,
                                        nodeType: "Literal",
                                        src: "18018:2:178",
                                        typeDescriptions: {
                                          typeIdentifier: "t_rational_10_by_1",
                                          typeString: "int_const 10"
                                        },
                                        value: "10"
                                      },
                                      nodeType: "BinaryOperation",
                                      operator: "**",
                                      rightExpression: {
                                        expression: {
                                          baseExpression: {
                                            id: 93171,
                                            name: "lotData",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 87480,
                                            src: "18024:7:178",
                                            typeDescriptions: {
                                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                                              typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                                            }
                                          },
                                          id: 93173,
                                          indexExpression: {
                                            id: 93172,
                                            name: "lotId_",
                                            nodeType: "Identifier",
                                            overloadedDeclarations: [],
                                            referencedDeclaration: 93089,
                                            src: "18032:6:178",
                                            typeDescriptions: {
                                              typeIdentifier: "t_uint96",
                                              typeString: "uint96"
                                            }
                                          },
                                          isConstant: false,
                                          isLValue: true,
                                          isPure: false,
                                          lValueRequested: false,
                                          nodeType: "IndexAccess",
                                          src: "18024:15:178",
                                          typeDescriptions: {
                                            typeIdentifier: "t_struct$_Lot_$82587_storage",
                                            typeString: "struct IAuction.Lot storage ref"
                                          }
                                        },
                                        id: 93174,
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        memberLocation: "18040:17:178",
                                        memberName: "baseTokenDecimals",
                                        nodeType: "MemberAccess",
                                        referencedDeclaration: 82578,
                                        src: "18024:33:178",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint8",
                                          typeString: "uint8"
                                        }
                                      },
                                      src: "18018:39:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    },
                                    {
                                      expression: {
                                        baseExpression: {
                                          id: 93176,
                                          name: "_auctionData",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 92338,
                                          src: "18079:12:178",
                                          typeDescriptions: {
                                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                                          }
                                        },
                                        id: 93178,
                                        indexExpression: {
                                          id: 93177,
                                          name: "lotId_",
                                          nodeType: "Identifier",
                                          overloadedDeclarations: [],
                                          referencedDeclaration: 93089,
                                          src: "18092:6:178",
                                          typeDescriptions: {
                                            typeIdentifier: "t_uint96",
                                            typeString: "uint96"
                                          }
                                        },
                                        isConstant: false,
                                        isLValue: true,
                                        isPure: false,
                                        lValueRequested: false,
                                        nodeType: "IndexAccess",
                                        src: "18079:20:178",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                                        }
                                      },
                                      id: 93179,
                                      isConstant: false,
                                      isLValue: true,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "18100:5:178",
                                      memberName: "price",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 83282,
                                      src: "18079:26:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    }
                                  ],
                                  expression: {
                                    argumentTypes: [
                                      {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      },
                                      {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      },
                                      {
                                        typeIdentifier: "t_uint256",
                                        typeString: "uint256"
                                      }
                                    ],
                                    expression: {
                                      id: 93166,
                                      name: "Math",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 55729,
                                      src: "17945:4:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_type$_t_contract$_FixedPointMathLib_$55729_$",
                                        typeString: "type(library FixedPointMathLib)"
                                      }
                                    },
                                    id: 93167,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "17950:10:178",
                                    memberName: "fullMulDiv",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 55048,
                                    src: "17945:15:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
                                      typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                                    }
                                  },
                                  id: 93180,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "functionCall",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "17945:178:178",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                src: "17927:196:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 93182,
                              nodeType: "ExpressionStatement",
                              src: "17927:196:178"
                            },
                            {
                              expression: {
                                id: 93187,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 93183,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93095,
                                    src: "18141:8:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 93185,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "18150:6:178",
                                  memberName: "refund",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82720,
                                  src: "18141:15:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  hexValue: "30",
                                  id: 93186,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  kind: "number",
                                  lValueRequested: false,
                                  nodeType: "Literal",
                                  src: "18159:1:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_rational_0_by_1",
                                    typeString: "int_const 0"
                                  },
                                  value: "0"
                                },
                                src: "18141:19:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 93188,
                              nodeType: "ExpressionStatement",
                              src: "18141:19:178"
                            }
                          ]
                        },
                        id: 93190,
                        nodeType: "IfStatement",
                        src: "17490:685:178",
                        trueBody: {
                          id: 93155,
                          nodeType: "Block",
                          src: "17535:248:178",
                          statements: [
                            {
                              expression: {
                                id: 93135,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 93130,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93095,
                                    src: "17606:8:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 93132,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "17615:4:178",
                                  memberName: "paid",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82716,
                                  src: "17606:13:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  expression: {
                                    id: 93133,
                                    name: "bidData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93099,
                                    src: "17622:7:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Bid_$83304_memory_ptr",
                                      typeString: "struct IFixedPriceBatch.Bid memory"
                                    }
                                  },
                                  id: 93134,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "17630:6:178",
                                  memberName: "amount",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83298,
                                  src: "17622:14:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                },
                                src: "17606:30:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 93136,
                              nodeType: "ExpressionStatement",
                              src: "17606:30:178"
                            },
                            {
                              expression: {
                                id: 93144,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 93137,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93095,
                                    src: "17654:8:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 93139,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "17663:6:178",
                                  memberName: "payout",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82718,
                                  src: "17654:15:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  expression: {
                                    baseExpression: {
                                      id: 93140,
                                      name: "_lotPartialFill",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 92352,
                                      src: "17672:15:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                                        typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill storage ref)"
                                      }
                                    },
                                    id: 93142,
                                    indexExpression: {
                                      id: 93141,
                                      name: "lotId_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 93089,
                                      src: "17688:6:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "17672:23:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                                      typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                                    }
                                  },
                                  id: 93143,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "17696:6:178",
                                  memberName: "payout",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83310,
                                  src: "17672:30:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                src: "17654:48:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 93145,
                              nodeType: "ExpressionStatement",
                              src: "17654:48:178"
                            },
                            {
                              expression: {
                                id: 93153,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftHandSide: {
                                  expression: {
                                    id: 93146,
                                    name: "bidClaim",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93095,
                                    src: "17720:8:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                                      typeString: "struct IBatchAuction.BidClaim memory"
                                    }
                                  },
                                  id: 93148,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: true,
                                  memberLocation: "17729:6:178",
                                  memberName: "refund",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82720,
                                  src: "17720:15:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "Assignment",
                                operator: "=",
                                rightHandSide: {
                                  expression: {
                                    baseExpression: {
                                      id: 93149,
                                      name: "_lotPartialFill",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 92352,
                                      src: "17738:15:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_PartialFill_$83311_storage_$",
                                        typeString: "mapping(uint96 => struct IFixedPriceBatch.PartialFill storage ref)"
                                      }
                                    },
                                    id: 93151,
                                    indexExpression: {
                                      id: 93150,
                                      name: "lotId_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 93089,
                                      src: "17754:6:178",
                                      typeDescriptions: {
                                        typeIdentifier: "t_uint96",
                                        typeString: "uint96"
                                      }
                                    },
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    nodeType: "IndexAccess",
                                    src: "17738:23:178",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_PartialFill_$83311_storage",
                                      typeString: "struct IFixedPriceBatch.PartialFill storage ref"
                                    }
                                  },
                                  id: 93152,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "17762:6:178",
                                  memberName: "refund",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83308,
                                  src: "17738:30:178",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint96",
                                    typeString: "uint96"
                                  }
                                },
                                src: "17720:48:178",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 93154,
                              nodeType: "ExpressionStatement",
                              src: "17720:48:178"
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 93214,
                    name: "bidClaim",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 93095,
                    src: "18402:8:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                      typeString: "struct IBatchAuction.BidClaim memory"
                    }
                  },
                  functionReturnParameters: 93096,
                  id: 93215,
                  nodeType: "Return",
                  src: "18395:15:178"
                }
              ]
            },
            documentation: {
              id: 93087,
              nodeType: "StructuredDocumentation",
              src: "16673:347:178",
              text: "@notice Returns the `BidClaim` data for a given lot and bid ID\n @dev    This function assumes:\n         - The lot ID has been validated\n         - The bid ID has been validated\n @param  lotId_          The lot ID\n @param  bidId_          The bid ID\n @return bidClaim        The `BidClaim` data"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_getBidClaim",
            nameLocation: "17034:12:178",
            parameters: {
              id: 93092,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93089,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "17063:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93217,
                  src: "17056:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93088,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "17056:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93091,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "17086:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93217,
                  src: "17079:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 93090,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "17079:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "17046:52:178"
            },
            returnParameters: {
              id: 93096,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93095,
                  mutability: "mutable",
                  name: "bidClaim",
                  nameLocation: "17138:8:178",
                  nodeType: "VariableDeclaration",
                  scope: 93217,
                  src: "17122:24:178",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_BidClaim_$82721_memory_ptr",
                    typeString: "struct IBatchAuction.BidClaim"
                  },
                  typeName: {
                    id: 93094,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 93093,
                      name: "BidClaim",
                      nameLocations: ["17122:8:178"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82721,
                      src: "17122:8:178"
                    },
                    referencedDeclaration: 82721,
                    src: "17122:8:178",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_BidClaim_$82721_storage_ptr",
                      typeString: "struct IBatchAuction.BidClaim"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "17121:26:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93253,
            nodeType: "FunctionDefinition",
            src: "18501:316:178",
            nodes: [],
            body: {
              id: 93252,
              nodeType: "Block",
              src: "18567:250:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 93246,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      id: 93238,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        commonType: {
                          typeIdentifier: "t_enum$_LotStatus_$83272",
                          typeString: "enum IFixedPriceBatch.LotStatus"
                        },
                        id: 93230,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 93224,
                              name: "_auctionData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 92338,
                              src: "18594:12:178",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                                typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                              }
                            },
                            id: 93226,
                            indexExpression: {
                              id: 93225,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93220,
                              src: "18607:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "18594:20:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                              typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                            }
                          },
                          id: 93227,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "18615:6:178",
                          memberName: "status",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83285,
                          src: "18594:27:178",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_LotStatus_$83272",
                            typeString: "enum IFixedPriceBatch.LotStatus"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "==",
                        rightExpression: {
                          expression: {
                            id: 93228,
                            name: "LotStatus",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83272,
                            src: "18625:9:178",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_enum$_LotStatus_$83272_$",
                              typeString: "type(enum IFixedPriceBatch.LotStatus)"
                            }
                          },
                          id: 93229,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          memberLocation: "18635:7:178",
                          memberName: "Created",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83270,
                          src: "18625:17:178",
                          typeDescriptions: {
                            typeIdentifier: "t_enum$_LotStatus_$83272",
                            typeString: "enum IFixedPriceBatch.LotStatus"
                          }
                        },
                        src: "18594:48:178",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "&&",
                      rightExpression: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 93237,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          expression: {
                            baseExpression: {
                              id: 93231,
                              name: "lotData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 87480,
                              src: "18662:7:178",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                                typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                              }
                            },
                            id: 93233,
                            indexExpression: {
                              id: 93232,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93220,
                              src: "18670:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "18662:15:178",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Lot_$82587_storage",
                              typeString: "struct IAuction.Lot storage ref"
                            }
                          },
                          id: 93234,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "18678:5:178",
                          memberName: "start",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82572,
                          src: "18662:21:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "<=",
                        rightExpression: {
                          expression: {
                            id: 93235,
                            name: "block",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -4,
                            src: "18687:5:178",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_block",
                              typeString: "block"
                            }
                          },
                          id: 93236,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "18693:9:178",
                          memberName: "timestamp",
                          nodeType: "MemberAccess",
                          src: "18687:15:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "18662:40:178",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      src: "18594:108:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "&&",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 93245,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          baseExpression: {
                            id: 93239,
                            name: "lotData",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 87480,
                            src: "18722:7:178",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_Lot_$82587_storage_$",
                              typeString: "mapping(uint96 => struct IAuction.Lot storage ref)"
                            }
                          },
                          id: 93241,
                          indexExpression: {
                            id: 93240,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93220,
                            src: "18730:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "18722:15:178",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Lot_$82587_storage",
                            typeString: "struct IAuction.Lot storage ref"
                          }
                        },
                        id: 93242,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18738:10:178",
                        memberName: "conclusion",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82574,
                        src: "18722:26:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        expression: {
                          id: 93243,
                          name: "block",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -4,
                          src: "18751:5:178",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_block",
                            typeString: "block"
                          }
                        },
                        id: 93244,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18757:9:178",
                        memberName: "timestamp",
                        nodeType: "MemberAccess",
                        src: "18751:15:178",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "18722:44:178",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "18594:172:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93251,
                  nodeType: "IfStatement",
                  src: "18577:233:178",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 93248,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93220,
                          src: "18803:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        ],
                        id: 93247,
                        name: "Auction_WrongState",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83259,
                        src: "18784:18:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                          typeString: "function (uint96) pure"
                        }
                      },
                      id: 93249,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "18784:26:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93250,
                    nodeType: "RevertStatement",
                    src: "18777:33:178"
                  }
                }
              ]
            },
            baseFunctions: [88010],
            documentation: {
              id: 93218,
              nodeType: "StructuredDocumentation",
              src: "18467:29:178",
              text: "@inheritdoc AuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfLotActive",
            nameLocation: "18510:18:178",
            overrides: {
              id: 93222,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "18558:8:178"
            },
            parameters: {
              id: 93221,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93220,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "18536:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93253,
                  src: "18529:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93219,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "18529:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18528:15:178"
            },
            returnParameters: {
              id: 93223,
              nodeType: "ParameterList",
              parameters: [],
              src: "18567:0:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93274,
            nodeType: "FunctionDefinition",
            src: "18862:234:178",
            nodes: [],
            body: {
              id: 93273,
              nodeType: "Block",
              src: "18929:167:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_LotStatus_$83272",
                      typeString: "enum IFixedPriceBatch.LotStatus"
                    },
                    id: 93266,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 93260,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "18982:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 93262,
                        indexExpression: {
                          id: 93261,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93256,
                          src: "18995:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "18982:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 93263,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19003:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83285,
                      src: "18982:27:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      expression: {
                        id: 93264,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83272,
                        src: "19013:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83272_$",
                          typeString: "type(enum IFixedPriceBatch.LotStatus)"
                        }
                      },
                      id: 93265,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "19023:7:178",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83271,
                      src: "19013:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    src: "18982:48:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93272,
                  nodeType: "IfStatement",
                  src: "18978:112:178",
                  trueBody: {
                    id: 93271,
                    nodeType: "Block",
                    src: "19032:58:178",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 93268,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93256,
                              src: "19072:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 93267,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83259,
                            src: "19053:18:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 93269,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "19053:26:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93270,
                        nodeType: "RevertStatement",
                        src: "19046:33:178"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [89481],
            documentation: {
              id: 93254,
              nodeType: "StructuredDocumentation",
              src: "18823:34:178",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfLotSettled",
            nameLocation: "18871:19:178",
            overrides: {
              id: 93258,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "18920:8:178"
            },
            parameters: {
              id: 93257,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93256,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "18898:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93274,
                  src: "18891:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93255,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "18891:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18890:15:178"
            },
            returnParameters: {
              id: 93259,
              nodeType: "ParameterList",
              parameters: [],
              src: "18929:0:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93295,
            nodeType: "FunctionDefinition",
            src: "19141:233:178",
            nodes: [],
            body: {
              id: 93294,
              nodeType: "Block",
              src: "19211:163:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_LotStatus_$83272",
                      typeString: "enum IFixedPriceBatch.LotStatus"
                    },
                    id: 93287,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 93281,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "19260:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 93283,
                        indexExpression: {
                          id: 93282,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93277,
                          src: "19273:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "19260:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 93284,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19281:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83285,
                      src: "19260:27:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      expression: {
                        id: 93285,
                        name: "LotStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83272,
                        src: "19291:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_LotStatus_$83272_$",
                          typeString: "type(enum IFixedPriceBatch.LotStatus)"
                        }
                      },
                      id: 93286,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "19301:7:178",
                      memberName: "Settled",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83271,
                      src: "19291:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_LotStatus_$83272",
                        typeString: "enum IFixedPriceBatch.LotStatus"
                      }
                    },
                    src: "19260:48:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93293,
                  nodeType: "IfStatement",
                  src: "19256:112:178",
                  trueBody: {
                    id: 93292,
                    nodeType: "Block",
                    src: "19310:58:178",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 93289,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93277,
                              src: "19350:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            ],
                            id: 93288,
                            name: "Auction_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83259,
                            src: "19331:18:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$returns$__$",
                              typeString: "function (uint96) pure"
                            }
                          },
                          id: 93290,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "19331:26:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93291,
                        nodeType: "RevertStatement",
                        src: "19324:33:178"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [89487],
            documentation: {
              id: 93275,
              nodeType: "StructuredDocumentation",
              src: "19102:34:178",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfLotNotSettled",
            nameLocation: "19150:22:178",
            overrides: {
              id: 93279,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "19202:8:178"
            },
            parameters: {
              id: 93278,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93277,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "19180:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93295,
                  src: "19173:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93276,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "19173:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19172:15:178"
            },
            returnParameters: {
              id: 93280,
              nodeType: "ParameterList",
              parameters: [],
              src: "19211:0:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93334,
            nodeType: "FunctionDefinition",
            src: "19419:385:178",
            nodes: [],
            body: {
              id: 93333,
              nodeType: "Block",
              src: "19501:303:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    },
                    id: 93309,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93304,
                      name: "bidId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93300,
                      src: "19574:6:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">=",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          id: 93305,
                          name: "_auctionData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 92338,
                          src: "19584:12:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint96_$_t_struct$_AuctionData_$83294_storage_$",
                            typeString: "mapping(uint96 => struct IFixedPriceBatch.AuctionData storage ref)"
                          }
                        },
                        id: 93307,
                        indexExpression: {
                          id: 93306,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93298,
                          src: "19597:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "19584:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_AuctionData_$83294_storage",
                          typeString: "struct IFixedPriceBatch.AuctionData storage ref"
                        }
                      },
                      id: 93308,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19605:9:178",
                      memberName: "nextBidId",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83287,
                      src: "19584:30:178",
                      typeDescriptions: {
                        typeIdentifier: "t_uint64",
                        typeString: "uint64"
                      }
                    },
                    src: "19574:40:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93315,
                  nodeType: "IfStatement",
                  src: "19570:89:178",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 93311,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93298,
                          src: "19644:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 93312,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93300,
                          src: "19652:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        ],
                        id: 93310,
                        name: "Auction_InvalidBidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82708,
                        src: "19623:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$_t_uint96_$returns$__$",
                          typeString: "function (uint96,uint96) pure"
                        }
                      },
                      id: 93313,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "19623:36:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93314,
                    nodeType: "RevertStatement",
                    src: "19616:43:178"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 93326,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 93316,
                            name: "_bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92346,
                            src: "19710:5:178",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                            }
                          },
                          id: 93318,
                          indexExpression: {
                            id: 93317,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93298,
                            src: "19716:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "19710:13:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                            typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                          }
                        },
                        id: 93320,
                        indexExpression: {
                          id: 93319,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93300,
                          src: "19724:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "19710:21:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage",
                          typeString: "struct IFixedPriceBatch.Bid storage ref"
                        }
                      },
                      id: 93321,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "19732:6:178",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83296,
                      src: "19710:28:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 93324,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "19750:1:178",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 93323,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "19742:7:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 93322,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "19742:7:178",
                          typeDescriptions: {}
                        }
                      },
                      id: 93325,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "19742:10:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "19710:42:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93332,
                  nodeType: "IfStatement",
                  src: "19706:91:178",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 93328,
                          name: "lotId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93298,
                          src: "19782:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          }
                        },
                        {
                          id: 93329,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93300,
                          src: "19790:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_uint96",
                            typeString: "uint96"
                          },
                          {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        ],
                        id: 93327,
                        name: "Auction_InvalidBidId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 82708,
                        src: "19761:20:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_uint96_$_t_uint96_$returns$__$",
                          typeString: "function (uint96,uint96) pure"
                        }
                      },
                      id: 93330,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "19761:36:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93331,
                    nodeType: "RevertStatement",
                    src: "19754:43:178"
                  }
                }
              ]
            },
            baseFunctions: [89495],
            documentation: {
              id: 93296,
              nodeType: "StructuredDocumentation",
              src: "19380:34:178",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfBidInvalid",
            nameLocation: "19428:19:178",
            overrides: {
              id: 93302,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "19492:8:178"
            },
            parameters: {
              id: 93301,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93298,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "19455:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93334,
                  src: "19448:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93297,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "19448:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93300,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "19470:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93334,
                  src: "19463:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 93299,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "19463:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19447:30:178"
            },
            returnParameters: {
              id: 93303,
              nodeType: "ParameterList",
              parameters: [],
              src: "19501:0:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93359,
            nodeType: "FunctionDefinition",
            src: "19849:263:178",
            nodes: [],
            body: {
              id: 93358,
              nodeType: "Block",
              src: "19979:133:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 93352,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93345,
                      name: "caller_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93341,
                      src: "20036:7:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 93346,
                            name: "_bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92346,
                            src: "20047:5:178",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                            }
                          },
                          id: 93348,
                          indexExpression: {
                            id: 93347,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93337,
                            src: "20053:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "20047:13:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                            typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                          }
                        },
                        id: 93350,
                        indexExpression: {
                          id: 93349,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93339,
                          src: "20061:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "20047:21:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage",
                          typeString: "struct IFixedPriceBatch.Bid storage ref"
                        }
                      },
                      id: 93351,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20069:6:178",
                      memberName: "bidder",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83296,
                      src: "20047:28:178",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "20036:39:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93357,
                  nodeType: "IfStatement",
                  src: "20032:73:178",
                  trueBody: {
                    errorCall: {
                      arguments: [
                        {
                          id: 93354,
                          name: "caller_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93341,
                          src: "20097:7:178",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        id: 93353,
                        name: "NotPermitted",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83269,
                        src: "20084:12:178",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$_t_address_$returns$__$",
                          typeString: "function (address) pure"
                        }
                      },
                      id: 93355,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "20084:21:178",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93356,
                    nodeType: "RevertStatement",
                    src: "20077:28:178"
                  }
                }
              ]
            },
            baseFunctions: [89505],
            documentation: {
              id: 93335,
              nodeType: "StructuredDocumentation",
              src: "19810:34:178",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfNotBidOwner",
            nameLocation: "19858:20:178",
            overrides: {
              id: 93343,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "19970:8:178"
            },
            parameters: {
              id: 93342,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93337,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "19895:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93359,
                  src: "19888:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93336,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "19888:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93339,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "19918:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93359,
                  src: "19911:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 93338,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "19911:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93341,
                  mutability: "mutable",
                  name: "caller_",
                  nameLocation: "19942:7:178",
                  nodeType: "VariableDeclaration",
                  scope: 93359,
                  src: "19934:15:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93340,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "19934:7:178",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19878:77:178"
            },
            returnParameters: {
              id: 93344,
              nodeType: "ParameterList",
              parameters: [],
              src: "19979:0:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93385,
            nodeType: "FunctionDefinition",
            src: "20157:276:178",
            nodes: [],
            body: {
              id: 93384,
              nodeType: "Block",
              src: "20239:194:178",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_enum$_BidStatus_$83275",
                      typeString: "enum IFixedPriceBatch.BidStatus"
                    },
                    id: 93376,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          baseExpression: {
                            id: 93368,
                            name: "_bids",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 92346,
                            src: "20314:5:178",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint96_$_t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$_$",
                              typeString: "mapping(uint96 => mapping(uint64 => struct IFixedPriceBatch.Bid storage ref))"
                            }
                          },
                          id: 93370,
                          indexExpression: {
                            id: 93369,
                            name: "lotId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93362,
                            src: "20320:6:178",
                            typeDescriptions: {
                              typeIdentifier: "t_uint96",
                              typeString: "uint96"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "20314:13:178",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint64_$_t_struct$_Bid_$83304_storage_$",
                            typeString: "mapping(uint64 => struct IFixedPriceBatch.Bid storage ref)"
                          }
                        },
                        id: 93372,
                        indexExpression: {
                          id: 93371,
                          name: "bidId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93364,
                          src: "20328:6:178",
                          typeDescriptions: {
                            typeIdentifier: "t_uint64",
                            typeString: "uint64"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "20314:21:178",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Bid_$83304_storage",
                          typeString: "struct IFixedPriceBatch.Bid storage ref"
                        }
                      },
                      id: 93373,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20336:6:178",
                      memberName: "status",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83303,
                      src: "20314:28:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83275",
                        typeString: "enum IFixedPriceBatch.BidStatus"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      expression: {
                        id: 93374,
                        name: "BidStatus",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83275,
                        src: "20346:9:178",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_enum$_BidStatus_$83275_$",
                          typeString: "type(enum IFixedPriceBatch.BidStatus)"
                        }
                      },
                      id: 93375,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "20356:7:178",
                      memberName: "Claimed",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83274,
                      src: "20346:17:178",
                      typeDescriptions: {
                        typeIdentifier: "t_enum$_BidStatus_$83275",
                        typeString: "enum IFixedPriceBatch.BidStatus"
                      }
                    },
                    src: "20314:49:178",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93383,
                  nodeType: "IfStatement",
                  src: "20310:117:178",
                  trueBody: {
                    id: 93382,
                    nodeType: "Block",
                    src: "20365:62:178",
                    statements: [
                      {
                        errorCall: {
                          arguments: [
                            {
                              id: 93378,
                              name: "lotId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93362,
                              src: "20401:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              }
                            },
                            {
                              id: 93379,
                              name: "bidId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93364,
                              src: "20409:6:178",
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint96",
                                typeString: "uint96"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            ],
                            id: 93377,
                            name: "Bid_WrongState",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83265,
                            src: "20386:14:178",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$_t_uint96_$_t_uint64_$returns$__$",
                              typeString: "function (uint96,uint64) pure"
                            }
                          },
                          id: 93380,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "20386:30:178",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93381,
                        nodeType: "RevertStatement",
                        src: "20379:37:178"
                      }
                    ]
                  }
                }
              ]
            },
            baseFunctions: [89513],
            documentation: {
              id: 93360,
              nodeType: "StructuredDocumentation",
              src: "20118:34:178",
              text: "@inheritdoc BatchAuctionModule"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_revertIfBidClaimed",
            nameLocation: "20166:19:178",
            overrides: {
              id: 93366,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "20230:8:178"
            },
            parameters: {
              id: 93365,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93362,
                  mutability: "mutable",
                  name: "lotId_",
                  nameLocation: "20193:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93385,
                  src: "20186:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint96",
                    typeString: "uint96"
                  },
                  typeName: {
                    id: 93361,
                    name: "uint96",
                    nodeType: "ElementaryTypeName",
                    src: "20186:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint96",
                      typeString: "uint96"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93364,
                  mutability: "mutable",
                  name: "bidId_",
                  nameLocation: "20208:6:178",
                  nodeType: "VariableDeclaration",
                  scope: 93385,
                  src: "20201:13:178",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint64",
                    typeString: "uint64"
                  },
                  typeName: {
                    id: 93363,
                    name: "uint64",
                    nodeType: "ElementaryTypeName",
                    src: "20201:6:178",
                    typeDescriptions: {
                      typeIdentifier: "t_uint64",
                      typeString: "uint64"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "20185:30:178"
            },
            returnParameters: {
              id: 93367,
              nodeType: "ParameterList",
              parameters: [],
              src: "20239:0:178"
            },
            scope: 93386,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          }
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 92329,
              name: "BatchAuctionModule",
              nameLocations: ["670:18:178"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 89550,
              src: "670:18:178"
            },
            id: 92330,
            nodeType: "InheritanceSpecifier",
            src: "670:18:178"
          },
          {
            baseName: {
              id: 92331,
              name: "IFixedPriceBatch",
              nameLocations: ["690:16:178"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 83343,
              src: "690:16:178"
            },
            id: 92332,
            nodeType: "InheritanceSpecifier",
            src: "690:16:178"
          }
        ],
        canonicalName: "FixedPriceBatch",
        contractDependencies: [],
        contractKind: "contract",
        documentation: {
          id: 92328,
          nodeType: "StructuredDocumentation",
          src: "553:89:178",
          text: "@title  FixedPriceBatch\n @notice A module for creating fixed price batch auctions"
        },
        fullyImplemented: true,
        linearizedBaseContracts: [
          93386,
          83343,
          89550,
          88011,
          88991,
          82847,
          82691
        ],
        name: "FixedPriceBatch",
        nameLocation: "651:15:178",
        scope: 93387,
        usedErrors: [
          82520,
          82524,
          82530,
          82536,
          82540,
          82542,
          82544,
          82546,
          82548,
          82550,
          82552,
          82556,
          82702,
          82708,
          82710,
          83259,
          83265,
          83269,
          88891,
          88894,
          88899
        ]
      }
    ],
    license: "BSL-1.1"
  },
  id: 178
};

// src/abis/sources/LinearVesting.json
var LinearVesting_default = {
  abi: [
    {
      type: "constructor",
      inputs: [
        {
          name: "parent_",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "INIT",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "PARENT",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "TYPE",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "uint8",
          internalType: "enum Module.Type"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "VEECODE",
      inputs: [],
      outputs: [
        {
          name: "",
          type: "bytes7",
          internalType: "Veecode"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "allowance",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "approve",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "balanceOf",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "computeId",
      inputs: [
        {
          name: "underlyingToken_",
          type: "address",
          internalType: "address"
        },
        {
          name: "params_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "decimals",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint8",
          internalType: "uint8"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "deploy",
      inputs: [
        {
          name: "underlyingToken_",
          type: "address",
          internalType: "address"
        },
        {
          name: "params_",
          type: "bytes",
          internalType: "bytes"
        },
        {
          name: "wrapped_",
          type: "bool",
          internalType: "bool"
        }
      ],
      outputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "wrappedAddress_",
          type: "address",
          internalType: "address"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "exercise",
      inputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "exerciseCost",
      inputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getTokenMetadata",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "tuple",
          internalType: "struct IDerivative.Token",
          components: [
            {
              name: "exists",
              type: "bool",
              internalType: "bool"
            },
            {
              name: "wrapped",
              type: "address",
              internalType: "address"
            },
            {
              name: "underlyingToken",
              type: "address",
              internalType: "address"
            },
            {
              name: "supply",
              type: "uint256",
              internalType: "uint256"
            },
            {
              name: "data",
              type: "bytes",
              internalType: "bytes"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "getTokenVestingParams",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "tuple",
          internalType: "struct ILinearVesting.VestingParams",
          components: [
            {
              name: "start",
              type: "uint48",
              internalType: "uint48"
            },
            {
              name: "expiry",
              type: "uint48",
              internalType: "uint48"
            }
          ]
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "isOperator",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "address",
          internalType: "address"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "mint",
      inputs: [
        {
          name: "to_",
          type: "address",
          internalType: "address"
        },
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "wrapped_",
          type: "bool",
          internalType: "bool"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "mint",
      inputs: [
        {
          name: "to_",
          type: "address",
          internalType: "address"
        },
        {
          name: "underlyingToken_",
          type: "address",
          internalType: "address"
        },
        {
          name: "params_",
          type: "bytes",
          internalType: "bytes"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "wrapped_",
          type: "bool",
          internalType: "bool"
        }
      ],
      outputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "wrappedAddress_",
          type: "address",
          internalType: "address"
        },
        {
          name: "amountCreated_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "name",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "string",
          internalType: "string"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "reclaim",
      inputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "redeem",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "redeemMax",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "redeemable",
      inputs: [
        {
          name: "owner_",
          type: "address",
          internalType: "address"
        },
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "setOperator",
      inputs: [
        {
          name: "operator",
          type: "address",
          internalType: "address"
        },
        {
          name: "approved",
          type: "bool",
          internalType: "bool"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "supportsInterface",
      inputs: [
        {
          name: "interfaceId",
          type: "bytes4",
          internalType: "bytes4"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "symbol",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "string",
          internalType: "string"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "tokenMetadata",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "exists",
          type: "bool",
          internalType: "bool"
        },
        {
          name: "wrapped",
          type: "address",
          internalType: "address"
        },
        {
          name: "underlyingToken",
          type: "address",
          internalType: "address"
        },
        {
          name: "supply",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "data",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "tokenURI",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "string",
          internalType: "string"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "totalSupply",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "transfer",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "transferFrom",
      inputs: [
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "transform",
      inputs: [
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "",
          type: "address",
          internalType: "address"
        },
        {
          name: "",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "unwrap",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "userClaimed",
      inputs: [
        {
          name: "owner_",
          type: "address",
          internalType: "address"
        },
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [
        {
          name: "claimed_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      stateMutability: "view"
    },
    {
      type: "function",
      name: "validate",
      inputs: [
        {
          name: "underlyingToken_",
          type: "address",
          internalType: "address"
        },
        {
          name: "params_",
          type: "bytes",
          internalType: "bytes"
        }
      ],
      outputs: [
        {
          name: "",
          type: "bool",
          internalType: "bool"
        }
      ],
      stateMutability: "pure"
    },
    {
      type: "function",
      name: "wrap",
      inputs: [
        {
          name: "tokenId_",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "amount_",
          type: "uint256",
          internalType: "uint256"
        }
      ],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "event",
      name: "Approval",
      inputs: [
        {
          name: "owner",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "spender",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "id",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "DerivativeCreated",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "start",
          type: "uint48",
          indexed: false,
          internalType: "uint48"
        },
        {
          name: "expiry",
          type: "uint48",
          indexed: false,
          internalType: "uint48"
        },
        {
          name: "baseToken",
          type: "address",
          indexed: false,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "OperatorSet",
      inputs: [
        {
          name: "owner",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "operator",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "approved",
          type: "bool",
          indexed: false,
          internalType: "bool"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Redeemed",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "owner",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Transfer",
      inputs: [
        {
          name: "caller",
          type: "address",
          indexed: false,
          internalType: "address"
        },
        {
          name: "from",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "to",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "id",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Unwrapped",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "owner",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256"
        },
        {
          name: "wrappedToken",
          type: "address",
          indexed: false,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "Wrapped",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "owner",
          type: "address",
          indexed: true,
          internalType: "address"
        },
        {
          name: "amount",
          type: "uint256",
          indexed: false,
          internalType: "uint256"
        },
        {
          name: "wrappedToken",
          type: "address",
          indexed: false,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "event",
      name: "WrappedDerivativeCreated",
      inputs: [
        {
          name: "tokenId",
          type: "uint256",
          indexed: true,
          internalType: "uint256"
        },
        {
          name: "wrappedToken",
          type: "address",
          indexed: false,
          internalType: "address"
        }
      ],
      anonymous: false
    },
    {
      type: "error",
      name: "BrokenInvariant",
      inputs: []
    },
    {
      type: "error",
      name: "Derivative_NotImplemented",
      inputs: []
    },
    {
      type: "error",
      name: "InsufficientBalance",
      inputs: []
    },
    {
      type: "error",
      name: "InvalidParams",
      inputs: []
    },
    {
      type: "error",
      name: "Module_InvalidParent",
      inputs: [
        {
          name: "parent_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "Module_OnlyInternal",
      inputs: []
    },
    {
      type: "error",
      name: "Module_OnlyParent",
      inputs: [
        {
          name: "caller_",
          type: "address",
          internalType: "address"
        }
      ]
    },
    {
      type: "error",
      name: "NotPermitted",
      inputs: []
    },
    {
      type: "error",
      name: "StringsInsufficientHexLength",
      inputs: [
        {
          name: "value",
          type: "uint256",
          internalType: "uint256"
        },
        {
          name: "length",
          type: "uint256",
          internalType: "uint256"
        }
      ]
    },
    {
      type: "error",
      name: "UnsupportedToken",
      inputs: [
        {
          name: "token_",
          type: "address",
          internalType: "address"
        }
      ]
    }
  ],
  bytecode: {
    object: "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",
    sourceMap: "1574:27312:179:-:0;;;;;1865:51;;2265:177;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;2301:7;-1:-1:-1;;;;;11238:21:173;;11234:63;;11268:29;;-1:-1:-1;;;11268:29:173;;-1:-1:-1;;;;;473:32:264;;11268:29:173;;;455:51:264;428:18;;11268:29:173;;;;;;;;11234:63;-1:-1:-1;;;;;11308:16:173;;;1322:34:180;1350:4;1322:19;:34::i;:::-;1308:11;;:48;;:11;:48;:::i;:::-;;2409:25:179::2;;;;;:::i;:::-;;;;;;;;;;;;;;;;;::::0;::::2;;;;;-1:-1:-1::0;;;;;;2383:52:179::2;;::::0;-1:-1:-1;1574:27312:179;;2677:149:48;2735:13;2767:52;-1:-1:-1;;;;;2779:22:48;;374:2;2767:11;:52::i;:::-;2760:59;2677:149;-1:-1:-1;;2677:149:48:o;2002:523::-;2077:13;2123:5;2102:18;2170:10;2174:6;2170:1;:10;:::i;:::-;:14;;2183:1;2170:14;:::i;:::-;-1:-1:-1;;;;;2160:25:48;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;2160:25:48;;2138:47;;-1:-1:-1;;;2195:6:48;2202:1;2195:9;;;;;;;;:::i;:::-;;;;:15;-1:-1:-1;;;;;2195:15:48;;;;;;;;;-1:-1:-1;;;2220:6:48;2227:1;2220:9;;;;;;;;:::i;:::-;;;;:15;-1:-1:-1;;;;;2220:15:48;;;;;;;;-1:-1:-1;2250:9:48;2262:10;2266:6;2262:1;:10;:::i;:::-;:14;;2275:1;2262:14;:::i;:::-;2250:26;;2245:138;2282:1;2278;:5;2245:138;;;-1:-1:-1;;;2325:10:48;2338:3;2325:16;2316:26;;;;;;;:::i;:::-;;;;2304:6;2311:1;2304:9;;;;;;;;:::i;:::-;;;;:38;-1:-1:-1;;;;;2304:38:48;;;;;;;;-1:-1:-1;2371:1:48;2356:16;;;;;2285:3;;;:::i;:::-;;;2245:138;;;-1:-1:-1;2396:15:48;;2392:96;;2434:43;;-1:-1:-1;;;2434:43:48;;;;;4120:25:264;;;4161:18;;;4154:34;;;4093:18;;2434:43:48;3946:248:264;2392:96:48;2511:6;2002:523;-1:-1:-1;;;;2002:523:48:o;1574:27312:179:-;;;;;;;;:::o;14:290:264:-;84:6;137:2;125:9;116:7;112:23;108:32;105:52;;;153:1;150;143:12;105:52;179:16;;-1:-1:-1;;;;;224:31:264;;214:42;;204:70;;270:1;267;260:12;204:70;293:5;14:290;-1:-1:-1;;;14:290:264:o;517:127::-;578:10;573:3;569:20;566:1;559:31;609:4;606:1;599:15;633:4;630:1;623:15;649:380;728:1;724:12;;;;771;;;792:61;;846:4;838:6;834:17;824:27;;792:61;899:2;891:6;888:14;868:18;865:38;862:161;;945:10;940:3;936:20;933:1;926:31;980:4;977:1;970:15;1008:4;1005:1;998:15;862:161;;649:380;;;:::o;1160:545::-;1262:2;1257:3;1254:11;1251:448;;;1298:1;1323:5;1319:2;1312:17;1368:4;1364:2;1354:19;1438:2;1426:10;1422:19;1419:1;1415:27;1409:4;1405:38;1474:4;1462:10;1459:20;1456:47;;;-1:-1:-1;1497:4:264;1456:47;1552:2;1547:3;1543:12;1540:1;1536:20;1530:4;1526:31;1516:41;;1607:82;1625:2;1618:5;1615:13;1607:82;;;1670:17;;;1651:1;1640:13;1607:82;;;1611:3;;;1251:448;1160:545;;;:::o;1881:1352::-;2001:10;;-1:-1:-1;;;;;2023:30:264;;2020:56;;;2056:18;;:::i;:::-;2085:97;2175:6;2135:38;2167:4;2161:11;2135:38;:::i;:::-;2129:4;2085:97;:::i;:::-;2237:4;;2301:2;2290:14;;2318:1;2313:663;;;;3020:1;3037:6;3034:89;;;-1:-1:-1;3089:19:264;;;3083:26;3034:89;-1:-1:-1;;1838:1:264;1834:11;;;1830:24;1826:29;1816:40;1862:1;1858:11;;;1813:57;3136:81;;2283:944;;2313:663;1107:1;1100:14;;;1144:4;1131:18;;-1:-1:-1;;2349:20:264;;;2467:236;2481:7;2478:1;2475:14;2467:236;;;2570:19;;;2564:26;2549:42;;2662:27;;;;2630:1;2618:14;;;;2497:19;;2467:236;;;2471:3;2731:6;2722:7;2719:19;2716:201;;;2792:19;;;2786:26;-1:-1:-1;;2875:1:264;2871:14;;;2887:3;2867:24;2863:37;2859:42;2844:58;2829:74;;2716:201;-1:-1:-1;;;;;2963:1:264;2947:14;;;2943:22;2930:36;;-1:-1:-1;1881:1352:264:o;3238:127::-;3299:10;3294:3;3290:20;3287:1;3280:31;3330:4;3327:1;3320:15;3354:4;3351:1;3344:15;3370:168;3443:9;;;3474;;3491:15;;;3485:22;;3471:37;3461:71;;3512:18;;:::i;3543:125::-;3608:9;;;3629:10;;;3626:36;;;3642:18;;:::i;3673:127::-;3734:10;3729:3;3725:20;3722:1;3715:31;3765:4;3762:1;3755:15;3789:4;3786:1;3779:15;3805:136;3844:3;3872:5;3862:39;;3881:18;;:::i;:::-;-1:-1:-1;;;3917:18:264;;3805:136::o;3946:248::-;1574:27312:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;",
    linkReferences: {}
  },
  deployedBytecode: {
    object: "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",
    sourceMap: "1574:27312:179:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;25808:409;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1002:64:59;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;1560:25:264;;;1548:2;1533:18;1002:64:59;1414:177:264;2930:253:59;;;;;;:::i;:::-;;:::i;:::-;;;2052:14:264;;2045:22;2027:41;;2015:2;2000:18;2930:253:59;1887:187:264;3221:122:179;;;;;;:::i;:::-;;:::i;11114:31:173:-;;;;;;;;-1:-1:-1;;;;;2570:32:264;;;2552:51;;2540:2;2525:18;11114:31:173;2406:203:264;4284:642:179;;;;;;:::i;:::-;;:::i;:::-;;;;4490:25:264;;;-1:-1:-1;;;;;4551:32:264;;;4546:2;4531:18;;4524:60;4463:18;4284:642:179;4316:274:264;15327:819:179;;;;;;:::i;:::-;;:::i;:::-;;14797:115;;;;;;:::i;:::-;;:::i;26909:263::-;;;;;;:::i;:::-;;:::i;:::-;;;5020:4:264;5008:17;;;4990:36;;4978:2;4963:18;26909:263:179;4848:184:264;26355:416:179;;;;;;:::i;:::-;;:::i;2517:225:59:-;;;;;;:::i;:::-;;:::i;1073:84::-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;895:134:171;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;12792:1518:179:-;;;;;;:::i;:::-;;:::i;737:63:171:-;;;;;;:::i;:::-;;:::i;:::-;;;;;;;;;;;:::i;14583:140:179:-;;;;;;:::i;:::-;;:::i;16432:791::-;;;;;;:::i;:::-;;:::i;11798:517::-;;;;;;:::i;:::-;;:::i;14384:125::-;;;;;;:::i;19252:238::-;;;;;;:::i;:::-;;:::i;:::-;;;;7192:13:264;;7147:14;7188:22;;;7170:41;;7271:4;7259:17;;;7253:24;7249:33;7227:20;;;7220:63;;;;7110:18;19252:238:179;6927:362:264;933:62:59;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;2475:91:179;2544:15;2475:91;;;;;;:::i;1135:138:171:-;;;;;;:::i;:::-;1211:7;1237:22;;;:13;:22;;;;;:29;;;;1135:138;27369:1515:179;;;;;;:::i;:::-;;:::i;18881:282::-;;;;;;:::i;:::-;;:::i;2599:114::-;;;:::i;:::-;;;-1:-1:-1;;;;;;8493:39:264;;;8475:58;;8463:2;8448:18;2599:114:179;8301:238:264;19625:398:179;;;;;;:::i;:::-;;:::i;8863:458::-;;;;;;:::i;:::-;;:::i;:::-;;;;9142:25:264;;;-1:-1:-1;;;;;9203:32:264;;;9198:2;9183:18;;9176:60;9252:18;;;9245:34;9130:2;9115:18;8863:458:179;8940:345:264;7458:946:179;;;;;;:::i;:::-;;:::i;13040:46:173:-;;;:::i;14986:135:179:-;;;;;;:::i;11118:411::-;;;;;;:::i;:::-;;:::i;2121:91::-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;3443:173;;;;;;:::i;25808:409::-;2820:23;;;;:13;:23;;;;;:30;25937:13;;25910:8;;2820:30;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;25966:19:::1;25988:23:::0;;;:13:::1;:23;::::0;;;;;;26060:10;;::::1;26049:39:::0;;25988:23;;25966:19;26049:39:::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;26152:21;::::0;::::1;::::0;26176:11:::1;::::0;::::1;::::0;26021:67;;-1:-1:-1;26100:19:179::1;::::0;26124:64:::1;::::0;-1:-1:-1;;;;;26152:21:179::1;::::0;26124::::1;:64::i;:::-;-1:-1:-1::0;26099:89:179;-1:-1:-1;;;;2893:1:179::1;25808:409:::0;;;;:::o;2930:253:59:-;3006:4;-1:-1:-1;;;;;;;;;3041:25:59;;;;:100;;-1:-1:-1;;;;;;;;;;3116:25:59;;;3041:100;3022:119;2930:253;-1:-1:-1;;2930:253:59:o;3221:122:179:-;3299:4;3322:14;;-1:-1:-1;;;3322:14:179;;;;;;;;;;;4284:642;4428:16;4446:23;4510:27;4540:29;4561:7;4540:20;:29::i;:::-;4510:59;;4615:35;4625:16;4643:6;4615:9;:35::i;:::-;:44;;4654:5;4615:44;4611:97;;4682:15;;-1:-1:-1;;;4682:15:179;;;;;;;;;;;4611:97;4770:15;4787:22;4825:51;4841:16;4859:6;4867:8;4825:15;:51::i;:::-;4769:107;;;;-1:-1:-1;4284:642:179;-1:-1:-1;;;;;;;4284:642:179:o;15327:819::-;2820:23;;;;:13;:23;;;;;:30;15411:8;;2820:30;;;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;15435:7:::1;15446:1;15435:12:::0;15431:40:::1;;15456:15;;-1:-1:-1::0;;;15456:15:179::1;;;;;;;;;;;15431:40;15496:10;15486:21;::::0;;;:9:::1;:21;::::0;;;;;;;:31;;;;;;;;;:41;-1:-1:-1;15482:75:179::1;;;15536:21;;-1:-1:-1::0;;;15536:21:179::1;;;;;;;;;;;15482:75;15670:23;::::0;;;:13:::1;:23;::::0;;;;:30:::1;;:41:::0;;;;::::1;::::0;;15769:36:::1;15775:10;15684:8:::0;15704:7;15769:5:::1;:36::i;:::-;15869:19;15891:23:::0;;;:13:::1;:23;::::0;;;;15924:36:::1;15905:8:::0;15891:23;15924:19:::1;:36::i;:::-;-1:-1:-1::0;16030:13:179;;16010:60:::1;::::0;-1:-1:-1;;;16010:60:179;;16050:10:::1;16010:60;::::0;::::1;11924:51:264::0;11991:18;;;11984:34;;;16030:13:179::1;::::0;;::::1;-1:-1:-1::0;;;;;16030:13:179::1;::::0;16010:39:::1;::::0;11897:18:264;;16010:60:179::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;-1:-1:-1::0;;16125:13:179;;16086:53:::1;::::0;;4490:25:264;;;16125:13:179::1;::::0;;::::1;-1:-1:-1::0;;;;;16125:13:179::1;4546:2:264::0;4531:18;;4524:60;16104:10:179::1;::::0;-1:-1:-1;16094:8:179;;-1:-1:-1;16086:53:179::1;::::0;4463:18:264;16086:53:179::1;;;;;;;15421:725;15327:819:::0;;;:::o;14797:115::-;14866:39;;-1:-1:-1;;;14866:39:179;;;;;;;;;;;26909:263;27042:5;2820:23;;;:13;:23;;;;;:30;27015:8;;2820:30;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;27063:19:::1;27085:23:::0;;;:13:::1;:23;::::0;;;;;;;;27132:21:::1;::::0;::::1;::::0;27126:39;;-1:-1:-1;;;27126:39:179;;;;27085:23;;-1:-1:-1;;;;;27132:21:179;;::::1;::::0;27126:37:::1;::::0;:39:::1;::::0;;::::1;::::0;;;;;;27132:21;27126:39:::1;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;27119:46:::0;26909:263;-1:-1:-1;;;;26909:263:179:o;26355:416::-;2820:23;;;;:13;:23;;;;;:30;26486:13;;26459:8;;2820:30;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;26515:19:::1;26537:23:::0;;;:13:::1;:23;::::0;;;;;;26609:10;;::::1;26598:39:::0;;26537:23;;26515:19;26598:39:::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;26704:21;::::0;::::1;::::0;26728:11:::1;::::0;::::1;::::0;26570:67;;-1:-1:-1;26651:21:179::1;::::0;26676:64:::1;::::0;-1:-1:-1;;;;;26704:21:179::1;::::0;26676::::1;:64::i;:::-;26648:92:::0;26355:416;-1:-1:-1;;;;;;;26355:416:179:o;2517:225:59:-;2622:10;2595:4;2611:22;;;;;;;;;;;-1:-1:-1;;;;;2611:32:59;;;;;;;;;;;:43;;-1:-1:-1;;2611:43:59;;;;;;;;;;2670;;2027:41:264;;;2595:4:59;;2622:10;2670:43;;2000:18:264;2670:43:59;;;;;;;-1:-1:-1;2731:4:59;2517:225;;;;:::o;895:134:171:-;969:12;-1:-1:-1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;969:12:171;1000:22;;;;:13;:22;;;;;;;;;993:29;;;;;;;;;;;;;;;;-1:-1:-1;;;;;993:29:171;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1000:22;993:29;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;895:134;;;:::o;12792:1518:179:-;12933:7;2820:23;;;:13;:23;;;;;:30;12914:8;;2820:30;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;12984:19:::1;13006:23:::0;;;:13:::1;:23;::::0;;;;;;13078:10;;::::1;13067:39:::0;;13006:23;;12984:19;13067:39:::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;13179:10:::0;;13039:67;;-1:-1:-1;13160:29:179::1;;:15;:29;13156:43;;13198:1;13191:8;;;;;;13156:43;-1:-1:-1::0;;;;;13262:17:179;;::::1;13234:25;13262:17:::0;;;:9:::1;:17;::::0;;;;;;;:27;;;;;;;;;13336:13;;13262:27;;13336:13:::1;::::0;;::::1;;:27:::0;:86:::1;;13390:13:::0;;13370:52:::1;::::0;-1:-1:-1;;;13370:52:179;;-1:-1:-1;;;;;2570:32:264;;;13370:52:179::1;::::0;::::1;2552:51:264::0;13390:13:179::1;::::0;;::::1;::::0;;::::1;::::0;13370:44:::1;::::0;2525:18:264;;13370:52:179::1;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;13336:86;;;13366:1;13336:86;-1:-1:-1::0;;;;;13457:19:179;::::1;13432:22;13457:19:::0;;;:11:::1;:19;::::0;;;;;;;:29;;;;;;;;;13299:123;;-1:-1:-1;13457:29:179;13518:34:::1;13299:123:::0;13518:17;:34:::1;:::i;:::-;:51;;;;:::i;:::-;13496:73;;13685:14;13795:4;:11;;;13776:30;;:15;:30;13772:279;;-1:-1:-1::0;13831:11:179;13772:279:::1;;;14003:10:::0;;13962:78:::1;::::0;13985:28:::1;::::0;::::1;;:15;:28;:::i;:::-;14029:10:::0;;14015:11:::1;::::0;::::1;::::0;:24:::1;::::0;14029:10;14015:24:::1;:::i;:::-;13962:11:::0;;:78;::::1;;:22;:78::i;:::-;13953:87;;13772:279;14139:14;14130:6;:23;14126:78;;;14176:17;;-1:-1:-1::0;;;14176:17:179::1;;;;;;;;;;;14126:78;14255:24;14265:14:::0;14255:24;::::1;:::i;:::-;::::0;-1:-1:-1;;;;;;;;2893:1:179::1;12792:1518:::0;;;;;:::o;737:63:171:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;737:63:171;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;14583:140:179:-;14663:7;14689:27;;-1:-1:-1;;;14689:27:179;;;;;;;;;;;16432:791;2820:23;;;;:13;:23;;;;;:30;16540:8;;2820:30;;;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;3011:1:::1;2968:23:::0;;;:13:::1;:23;::::0;;;;:31;16570:8;;2968:31:::1;::::0;::::1;-1:-1:-1::0;;;;;2968:31:179::1;2964:98;;3036:15;;-1:-1:-1::0;;;3036:15:179::1;;;;;;;;;;;2964:98;16594:7:::2;16605:1;16594:12:::0;16590:40:::2;;16615:15;;-1:-1:-1::0;;;16615:15:179::2;;;;;;;;;;;16590:40;16641:19;16663:23:::0;;;:13:::2;:23;::::0;;;;;;16751:13;;16780:34;;-1:-1:-1;;;16780:34:179;;16803:10:::2;16780:34;::::0;::::2;2552:51:264::0;16663:23:179;;16751:13:::2;::::0;::::2;-1:-1:-1::0;;;;;16751:13:179::2;::::0;16817:7;;16751:13;;16780:22:::2;::::0;2525:18:264;;16780:34:179::2;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:44;16776:78;;;16833:21;;-1:-1:-1::0;;;16833:21:179::2;;;;;;;;;;;16776:78;16934:12;::::0;::::2;:23:::0;;;::::2;::::0;;17023:38:::2;::::0;-1:-1:-1;;;17023:38:179;;17041:10:::2;17023:38;::::0;::::2;11924:51:264::0;11991:18;;;11984:34;;;-1:-1:-1;;;;;17023:17:179;::::2;::::0;::::2;::::0;11897:18:264;;17023:38:179::2;;;;;;;;;;;;;;;;;::::0;::::2;;;;;;;;;;;;::::0;::::2;;;;;;;;;17109:36;17115:10;17127:8;17137:7;17109:5;:36::i;:::-;17202:13:::0;;17161:55:::2;::::0;;4490:25:264;;;17202:13:179::2;::::0;;::::2;-1:-1:-1::0;;;;;17202:13:179::2;4546:2:264::0;4531:18;;4524:60;17181:10:179::2;::::0;17171:8;;17161:55:::2;::::0;4463:18:264;17161:55:179::2;;;;;;;16580:643;;2893:1:::1;16432:791:::0;;;:::o;11798:517::-;2820:23;;;;:13;:23;;;;;:30;11914:8;;2820:30;;;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;11938:7:::1;11949:1;11938:12:::0;11934:40:::1;;11959:15;;-1:-1:-1::0;;;11959:15:179::1;;;;;;;;;;;11934:40;12022:24;12049:32;12060:10;12072:8;12049:10;:32::i;:::-;12022:59;;12193:7;12174:16;:26;12170:60;;;12209:21;;-1:-1:-1::0;;;12209:21:179::1;;;;;;;;;;;12170:60;12270:38;12278:8;12288:10;12300:7;12270;:38::i;:::-;11924:391;11798:517:::0;;;:::o;19252:238::-;-1:-1:-1;;;;;;;;;;;;;;;;;2820:23:179;;;;:13;:23;;;;;:30;19356:8;;2820:30;;;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;19437:23:::1;::::0;;;:13:::1;:23;::::0;;;;;;;:28:::1;19426:57:::0;;::::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;19419:64:::0;19252:238;-1:-1:-1;;;19252:238:179:o;27369:1515::-;2820:23;;;;:13;:23;;;;;:30;27502:13;;27475:8;;2820:30;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;27531:19:::1;27553:23:::0;;;:13:::1;:23;::::0;;;;;;27625:10;;::::1;27614:39:::0;;27553:23;;27531:19;27614:39:::1;::::0;::::1;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;27586:67;;27707:21;27737:5;:21;;;;;;;;;;-1:-1:-1::0;;;;;27737:21:179::1;-1:-1:-1::0;;;;;27731:35:179::1;;:37;;;;;;;;;;;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;;;;;;::::0;;::::1;-1:-1:-1::0;;27731:37:179::1;::::0;::::1;;::::0;::::1;::::0;;;::::1;::::0;::::1;:::i;:::-;27852:238;::::0;;::::1;::::0;::::1;::::0;;;;;27913:21:::1;::::0;::::1;::::0;-1:-1:-1;;;;;27913:21:179::1;27852:238;::::0;;::::1;::::0;;;;;;;;;;27993:10;;27852:238:::1;::::0;;::::1;::::0;;;;28025:11;;::::1;::::0;27852:238:::1;::::0;;;;-1:-1:-1;1237:22:171;;;:13;:22;;;;;;;:29;;;27852:238:179;;;;;;-1:-1:-1;28246:588:179::1;28381:14;27852:238:::0;28381:4:::1;:14::i;:::-;28468:7;28606:17;28618:4;28606:11;:17::i;:::-;28715:35;28735:13;28743:4;28735:7;:13::i;:::-;28715;:35::i;:::-;28304:498;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;28246:13;:588::i;:::-;28174:670;;;;;;;;:::i;:::-;;;;;;;;;;;;;28167:677;;;;;;27369:1515:::0;;;;:::o;18881:282::-;18999:4;19048:25;19076:29;19097:7;19076:20;:29::i;:::-;19048:57;;19123:33;19133:16;19151:4;19123:9;:33::i;2599:114::-;2648:7;2674:32;-1:-1:-1;;;2704:1:179;2674:11;:32::i;:::-;2667:39;;2599:114;:::o;19625:398::-;19754:7;19806:25;19834:29;19855:7;19834:20;:29::i;:::-;19992:10;;20004:11;;;;19806:57;;-1:-1:-1;19903:16:179;;19964:52;;19903:16;;19964:10;:52::i;:::-;19957:59;19625:398;-1:-1:-1;;;;;19625:398:179:o;8863:458::-;9040:7;2820:23;;;:13;:23;;;;;:30;9040:7;;;;9021:8;;2820:30;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;9105:7:::1;9116:1;9105:12:::0;9101:40:::1;;9126:15;;-1:-1:-1::0;;;9126:15:179::1;;;;;;;;;;;9101:40;9152:19;9174:23:::0;;;:13:::1;:23;::::0;;;;9208:54:::1;9222:3:::0;9188:8;9237:7;9174:23;9253:8;9208:13:::1;:54::i;:::-;9291:13:::0;9281:8;;9291:13:::1;::::0;;::::1;-1:-1:-1::0;;;;;9291:13:179::1;::::0;-1:-1:-1;9306:7:179;;8863:458;-1:-1:-1;;;;;8863:458:179:o;7458:946::-;7678:16;7696:23;7721:22;7787:7;7798:1;7787:12;7783:40;;7808:15;;-1:-1:-1;;;7808:15:179;;;;;;;;;;;7783:40;7863:27;7893:29;7914:7;7893:20;:29::i;:::-;7863:59;;7968:35;7978:16;7996:6;7968:9;:35::i;:::-;:44;;8007:5;7968:44;7964:97;;8035:15;;-1:-1:-1;;;8035:15:179;;;;;;;;;;;7964:97;8136:51;8152:16;8170:6;8178:8;8136:15;:51::i;:::-;-1:-1:-1;8235:19:179;8257:23;;;:13;:23;;;;;8122:65;;-1:-1:-1;8291:54:179;8305:3;8122:65;8320:7;8257:23;8336:8;8291:13;:54::i;:::-;8374:13;7458:946;;8374:13;;;;-1:-1:-1;;;;;8374:13:179;;-1:-1:-1;8389:7:179;;-1:-1:-1;7458:946:179;;-1:-1:-1;;;;;7458:946:179:o;13040:46:173:-;11501:10;-1:-1:-1;;;;;11515:6:173;11501:20;;11497:62;;11530:29;;-1:-1:-1;;;11530:29:173;;11548:10;11530:29;;;2552:51:264;2525:18;;11530:29:173;;;;;;;;11497:62;13040:46::o;11118:411:179:-;2820:23;;;;:13;:23;;;;;:30;11198:8;;2820:30;;;;:39;;;;2816:67;;2868:15;;-1:-1:-1;;;2868:15:179;;;;;;;;;;;2816:67;11261:24:::1;11288:32;11299:10;11311:8;11288:10;:32::i;:::-;11261:59;;11384:16;11404:1;11384:21:::0;11380:55:::1;;11414:21;;-1:-1:-1::0;;;11414:21:179::1;;;;;;;;;;;11380:55;11475:47;11483:8;11493:10;11505:16;11475:7;:47::i;:::-;11208:321;11118:411:::0;;:::o;21615:474::-;21720:13;21735;21796:18;21816:19;21837:17;21858:24;:7;:22;;;:24::i;:::-;21795:87;;;;;;21938:5;-1:-1:-1;;;;;21938:10:179;;:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;21938:12:179;;;;;;;;;;;;:::i;:::-;21957:4;21968:5;21980:3;21921:63;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;22023:5;-1:-1:-1;;;;;22023:12:179;;:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;22023:14:179;;;;;;;;;;;;:::i;:::-;22044:4;22055:5;22067:3;22006:65;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;21893:189;;;;;;;21615:474;;;;;:::o;20262:261::-;-1:-1:-1;;;;;;;;;;;;;;;;;20419:19:179;20401:7;:14;:37;20397:65;;20447:15;;-1:-1:-1;;;20447:15:179;;;;;;;;;;;20397:65;20491:7;20480:36;;;;;;;;;;;;:::i;18098:648::-;18285:11;;18216:4;;18285:16;;;;:37;;-1:-1:-1;18305:12:179;;;;:17;;;18285:37;18281:55;;;-1:-1:-1;18331:5:179;18324:12;;18281:55;18461:5;:12;;;18446:27;;:5;:11;;;:27;;;18442:45;;-1:-1:-1;18482:5:179;18475:12;;18442:45;18580:5;:12;;;18565:27;;:5;:11;;;:27;;;18561:45;;-1:-1:-1;18601:5:179;18594:12;;18561:45;-1:-1:-1;;;;;18673:30:179;;18669:48;;-1:-1:-1;18712:5:179;18705:12;;18669:48;-1:-1:-1;18735:4:179;18098:648;;;;:::o;22723:1141::-;22867:16;22885:23;22952:21;22982:16;22952:47;;23020:58;23031:15;23048:7;:13;;;23063:7;:14;;;23020:10;:58::i;:::-;23137:19;23159:23;;;:13;:23;;;;;23196:12;;23009:69;;-1:-1:-1;23159:23:179;23196:12;;:21;;;;23192:488;;23270:19;;23285:4;-1:-1:-1;;23270:19:179;;;;;;;23303:21;;:40;;-1:-1:-1;;;;;;23303:40:179;-1:-1:-1;;;;;23303:40:179;;;;;23381:61;;;;;;;;23403:13;;23381:61;;;;;;;;23426:14;;;;23381:61;;;;;;;;23370:73;;;;;7170:41:264;;;;7253:24;;7249:33;7227:20;;;7220:63;23370:73:179;;;;;;;;;7110:18:264;;;;23370:73:179;;;23357:10;;;;:86;;:10;:86;:::i;:::-;-1:-1:-1;23516:23:179;;;;:13;:23;;;;;;;;:31;;;;;;;;;;-1:-1:-1;;23516:31:179;;;;;;;;-1:-1:-1;;;;;23516:31:179;;;;;;;;;;-1:-1:-1;;;;;;23516:31:179;;;-1:-1:-1;;;;;;23516:31:179;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;;23516:31:179;;;;;;;;;;;;;;;;;23542:5;;23516:31;;;;;;;;;;:::i;:::-;-1:-1:-1;;23621:13:179;;23636:14;;;;;23593:76;;;21527:14:264;21568:15;;;21550:34;;21620:15;;;;21600:18;;;21593:43;;;;-1:-1:-1;;;;;21672:32:264;;21652:18;;;21645:60;23593:76:179;23611:8;;-1:-1:-1;23593:76:179;;;;;21505:2:264;23593:76:179;;;23192:488;23744:8;23740:75;;;23768:36;23788:8;23798:5;23768:19;:36::i;:::-;;23740:75;23843:13;-1:-1:-1;;;;;23843:13:179;;;;;;-1:-1:-1;;22723:1141:179;;;;;;:::o;3611:222:59:-;-1:-1:-1;;;;;3727:17:59;;;;;;:9;:17;;;;;;;;:21;;;;;;;;:31;;3752:6;;3727:17;:31;;3752:6;;3727:31;:::i;:::-;;;;-1:-1:-1;;3774:52:59;;;3783:10;11924:51:264;;12006:2;11991:18;;11984:34;;;3815:2:59;;3811:1;;-1:-1:-1;;;;;3774:52:59;;;;;11897:18:264;3774:52:59;;;;;;;;3611:222;;;:::o;24285:1335:179:-;24482:14;;24394:22;;24482:14;;;-1:-1:-1;;;;;24482:14:179;24478:1104;;24600:15;-1:-1:-1;;;;;24600:29:179;24596:57;;24638:15;;-1:-1:-1;;;24638:15:179;;;;;;;;;;;24596:57;24702:25;24741:6;:11;;24730:40;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;24808:22;;;;24991:11;;;;24702:68;;-1:-1:-1;;;;;;24808:22:179;;24784:15;;;;24958:45;;24808:22;;24958:21;:45::i;:::-;24895:108;;;;25017:29;25097:5;25083:21;;;:::i;:::-;25130:23;25144:7;25130:23;:::i;:::-;25187:9;-1:-1:-1;;;;;25187:18:179;;:20;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;25245:11;;;;;25335:22;;;;25049:336;;;;;;;25238:19;;;;;25303:4;;-1:-1:-1;;;;;25335:22:179;;25049:336;22281:19:264;;;22325:2;22316:12;;22309:28;;;;22393:3;22371:16;;;;-1:-1:-1;;;;;;22367:36:264;22362:2;22353:12;;22346:58;22460:3;22438:16;-1:-1:-1;;;;;;22434:51:264;22429:2;22420:12;;22413:73;22574:2;22570:15;;;-1:-1:-1;;22566:24:264;;;22561:2;22552:12;;22545:46;22625:15;;;22621:24;22616:2;22607:12;;22600:46;22671:3;22662:13;;22018:663;25049:336:179;;;;-1:-1:-1;;25049:336:179;;;;;;;;;;-1:-1:-1;25416:59:179;-1:-1:-1;;;;;25416:15:179;:22;25049:336;25465:8;25416:22;:59::i;:::-;25399:76;;-1:-1:-1;;;;;;25399:76:179;;-1:-1:-1;;;;;25399:76:179;;;;;;;;;;;;25521:50;;25556:14;;;;;;2552:51:264;;25546:8:179;;25521:50;;2540:2:264;2525:18;25521:50:179;;;;;;;24512:1070;;;;;24478:1104;-1:-1:-1;25599:14:179;;;;-1:-1:-1;;;;;25599:14:179;;24285:1335;-1:-1:-1;24285:1335:179:o;1564:526:60:-;1680:9;1928:1;-1:-1:-1;;1911:19:60;1908:1;1905:26;1902:1;1898:34;1891:42;1878:11;1874:60;1864:116;;1964:1;1961;1954:12;1864:116;-1:-1:-1;2051:9:60;;2047:27;;1564:526::o;3377:228:59:-;-1:-1:-1;;;;;3495:19:59;;;;;;:9;:19;;;;;;;;:23;;;;;;;;:33;;3522:6;;3495:19;:33;;3522:6;;3495:33;:::i;:::-;;;;-1:-1:-1;;3544:54:59;;;3553:10;11924:51:264;;12006:2;11991:18;;11984:34;;;3587:2:59;;-1:-1:-1;;;;;3544:54:59;;;3573:1;;3544:54;;11897:18:264;3544:54:59;11750:274:264;9720:1360:179;9806:23;9832;;;:13;:23;;;;;;;;-1:-1:-1;;;;;9936:16:179;;;;;:9;:16;;;;;:26;;;;;;;;;;9997:17;;9832:23;;9936:26;;9806:23;;9997:17;;;;:31;:117;;10079:17;;10059:55;;-1:-1:-1;;;10059:55:179;;-1:-1:-1;;;;;2570:32:264;;;10059:55:179;;;2552:51:264;10079:17:179;;;;;;;;10059:48;;2525:18:264;;10059:55:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;9997:117;;;10043:1;9997:117;9972:142;;10125:24;10162:17;10152:7;:27;:57;;10202:7;10152:57;;;10182:17;10152:57;10125:84;-1:-1:-1;10219:21:179;10243:26;10125:84;10243:7;:26;:::i;:::-;10219:50;;10299:14;10283:13;:30;10279:89;;;10336:21;;-1:-1:-1;;;10336:21:179;;;;;;;;;;;10279:89;-1:-1:-1;;;;;10422:18:179;;;;;;:11;:18;;;;;;;;:28;;;;;;;;:39;;10454:7;;10422:18;:39;;10454:7;;10422:39;:::i;:::-;;;;-1:-1:-1;;10513:20:179;;10509:183;;10577:16;;;:36;;;;;;;10641:40;10647:5;10654:8;10597:16;10641:5;:40::i;:::-;10767:17;;10763:113;;10820:17;;10800:65;;-1:-1:-1;;;10800:65:179;;-1:-1:-1;;;;;11942:32:264;;;10800:65:179;;;11924:51:264;11991:18;;;11984:34;;;10820:17:179;;;;;;;;10800:43;;11897:18:264;;10800:65:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10763:113;10946:25;;;;10940:61;;-1:-1:-1;;;;;10946:25:179;10986:5;10993:7;10940:45;:61::i;:::-;11058:5;-1:-1:-1;;;;;11039:34:179;11048:8;11039:34;11065:7;11039:34;;;;1560:25:264;;1548:2;1533:18;;1414:177;11039:34:179;;;;;;;;9796:1284;;;;;9720:1360;;;:::o;1413:897:180:-;1480:13;1590:35;1607:9;:17;;;1590:16;:35::i;:::-;1710:40;1730:9;:19;;;1710;:40::i;:::-;1843:9;:25;;;1978:33;1995:9;:15;;;1978:33;;:16;:33::i;:::-;2119:34;2136:9;:16;;;2119:34;;:16;:34::i;:::-;2240;2257:9;:16;;;2240;:34::i;:::-;1512:791;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;1505:798;;1413:897;;;:::o;2357:1143::-;2420:13;2600:280;;;;;;;;;;;;;;-1:-1:-1;;;2600:280:180;;;2648:5;;;;;;;;;;;;2706:15;:13;:15::i;:::-;2743:17;:15;:17::i;:::-;2782:24;:22;:24::i;:::-;2828:20;:18;:20::i;:::-;2671:195;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;2600:6;:280::i;:::-;2894:124;;;;;;;;;;;;;;;;;;2999:5;;;;;;;;;;;;2894:8;:124::i;:::-;3032:174;;;;;;;;;;;;;;;;;;3187:5;;;;;;;;;;;;3032:8;:174::i;:::-;3220:33;3227:9;:25;;;3220:6;:33::i;:::-;3267:65;3288:9;:15;;;3280:24;;3314:9;:16;;;3306:25;;3267:12;:65::i;:::-;3346:50;3362:9;:15;;;3379:9;:16;;;3346:15;:50::i;:::-;3410:7;:5;:7::i;:::-;3443:17;;3431:30;;:11;:30::i;:::-;2452:1041;;;;;;;;;;;;;;;:::i;476:3026:47:-;534:13;766:4;:11;781:1;766:16;762:31;;-1:-1:-1;;784:9:47;;;;;;;;;-1:-1:-1;784:9:47;;;476:3026::o;762:31::-;843:19;865:6;;;;;;;;;;;;;;;;;843:28;;1274:20;1333:1;1314:4;:11;1328:1;1314:15;;;;:::i;:::-;1313:21;;;;:::i;:::-;1308:27;;:1;:27;:::i;:::-;-1:-1:-1;;;;;1297:39:47;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;1297:39:47;;1274:62;;1511:1;1504:5;1500:13;1612:2;1604:6;1600:15;1719:4;1770;1764:11;1758:4;1754:22;1682:1403;1803:6;1794:7;1791:19;1682:1403;;;1905:1;1896:7;1892:15;1881:26;;1943:7;1937:14;2586:4;2578:5;2574:2;2570:14;2566:25;2556:8;2552:40;2546:47;2535:9;2527:67;2639:1;2628:9;2624:17;2611:30;;2729:4;2721:5;2717:2;2713:14;2709:25;2699:8;2695:40;2689:47;2678:9;2670:67;2782:1;2771:9;2767:17;2754:30;;2871:4;2863:5;2860:1;2856:13;2852:24;2842:8;2838:39;2832:46;2821:9;2813:66;2924:1;2913:9;2909:17;2896:30;;3005:4;2998:5;2994:16;2984:8;2980:31;2974:38;2963:9;2955:58;;3058:1;3047:9;3043:17;3030:30;;1682:1403;;;1686:104;;3243:1;3236:4;3230:11;3226:19;3263:1;3258:120;;;;3396:1;3391:71;;;;3219:243;;3258:120;3310:4;3306:1;3295:9;3291:17;3283:32;3359:4;3355:1;3344:9;3340:17;3332:32;3258:120;;3391:71;3443:4;3439:1;3428:9;3424:17;3416:32;3219:243;-1:-1:-1;3489:6:47;;476:3026;-1:-1:-1;;;;;476:3026:47:o;758:361:172:-;827:7;;906:13;917:2;906:8;:13;:::i;:::-;:20;;922:4;906:20;:::i;:::-;899:28;;;-1:-1:-1;933:18:172;962:13;973:2;962:8;:13;:::i;:::-;961:22;;979:4;961:22;:::i;:::-;1063:51;;-1:-1:-1;;;;;;30876:15:264;;;1063:51:172;;;30864:28:264;954:30:172;;;;;30921:15:264;;;30908:11;;;30901:36;-1:-1:-1;;;;;;30966:35:264;;30953:11;;;30946:56;954:30:172;;-1:-1:-1;31018:11:264;;1063:51:172;;;;;;;;;;;;1056:59;;;:::i;20989:266:179:-;21106:7;21180:9;:7;:9::i;:::-;21201:34;;;-1:-1:-1;;;;;31643:32:264;;21201:34:179;;;31625:51:264;31695:14;31745:15;;;31725:18;;;31718:43;;;;31797:15;;;31777:18;;;31770:43;31598:18;;21201:34:179;;;-1:-1:-1;;21201:34:179;;;;;;;;;;21191:45;;21201:34;21191:45;;;;-1:-1:-1;;;;;;32021:39:264;;;21163:74:179;;;32009:52:264;32077:11;;;32070:27;;;;32113:12;;21163:74:179;;;-1:-1:-1;;21163:74:179;;;;;;;;;21153:85;;21163:74;21153:85;;;;;20989:266;-1:-1:-1;;;;20989:266:179:o;5435:1379::-;5718:8;5714:76;;;5742:37;5762:8;5772:6;5742:19;:37::i;:::-;;5714:76;5892:22;;;;5953:34;;-1:-1:-1;;;5953:34:179;;5981:4;5953:34;;;2552:51:264;-1:-1:-1;;;;;5892:22:179;;;;5868:15;;5892:22;;5953:19;;2525:18:264;;5953:34:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;5929:58;-1:-1:-1;6001:62:179;-1:-1:-1;;;;;6001:26:179;;6028:10;6048:4;6055:7;6001:26;:62::i;:::-;6176:23;6192:7;6176:13;:23;:::i;:::-;6139:34;;-1:-1:-1;;;6139:34:179;;6167:4;6139:34;;;2552:51:264;-1:-1:-1;;;;;6139:19:179;;;;;2525:18:264;;6139:34:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:60;6135:146;;;6243:22;;;;6226:40;;-1:-1:-1;;;6226:40:179;;-1:-1:-1;;;;;6243:22:179;;;6226:40;;;2552:51:264;2525:18;;6226:40:179;2406:203:264;6135:146:179;5854:437;;6362:8;6358:450;;;6390:14;;;;;-1:-1:-1;;;;;6390:14:179;6386:56;;6427:15;;-1:-1:-1;;;6427:15:179;;;;;;;;;;;6386:56;6512:14;;6541:31;;-1:-1:-1;;;6541:31:179;;-1:-1:-1;;;;;11942:32:264;;;6541:31:179;;;11924:51:264;11991:18;;;11984:34;;;6512:14:179;;;;;;;;;;6541:17;;11897:18:264;;6541:31:179;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6372:211;6358:450;;;6667:13;;;:24;;;;;;6768:29;6774:3;6779:8;6684:7;6768:5;:29::i;:::-;5435:1379;;;;;:::o;129:1494:158:-;218:13;;;499:12;;;;602:25;621:6;608:9;602:25;:::i;:::-;595:33;;;-1:-1:-1;643:11:158;657:15;595:33;666:6;657:15;:::i;:::-;:27;;675:9;657:27;:::i;:::-;643:41;-1:-1:-1;726:11:158;753:7;741:8;643:41;741:1;:8;:::i;:::-;740:20;;;;:::i;:::-;726:34;-1:-1:-1;811:1:158;789:14;726:34;789:7;:14;:::i;:::-;:18;;806:1;789:18;:::i;:::-;788:24;;;;:::i;:::-;781:31;;:4;:31;:::i;:::-;774:38;-1:-1:-1;826:12:158;863:9;850:8;774:38;857:1;850:8;:::i;:::-;842:17;;:4;:17;:::i;:::-;841:31;;;;:::i;:::-;826:46;-1:-1:-1;917:1:158;901:12;826:46;901:4;:12;:::i;:::-;900:18;;;;:::i;:::-;893:25;;:4;:25;:::i;:::-;:30;;921:2;893:30;:::i;:::-;886:37;-1:-1:-1;937:13:158;967:4;954:9;886:37;954:2;:9;:::i;:::-;953:18;;;;:::i;:::-;937:34;-1:-1:-1;985:11:158;1024:2;1007:13;937:34;1007:4;:13;:::i;:::-;1006:20;;;;:::i;:::-;999:27;;:4;:27;:::i;:::-;985:41;-1:-1:-1;1047:11:158;1056:2;1047:6;:11;:::i;:::-;1040:18;-1:-1:-1;1094:9:158;1040:18;1094:2;:9;:::i;:::-;1081:10;:6;1090:1;1081:10;:::i;:::-;:22;;;;:::i;:::-;1072:31;-1:-1:-1;1153:4:158;1145:5;1132:9;1139:2;1132:4;:9;:::i;:::-;1125:17;;:3;:17;:::i;:::-;:25;;;;:::i;:::-;:32;;;;:::i;:::-;1117:40;-1:-1:-1;1223:6:158;;-1:-1:-1;1258:4:158;-1:-1:-1;1284:21:158;;-1:-1:-1;1308:23:158;;-1:-1:-1;1317:13:158;;-1:-1:-1;1324:6:158;;-1:-1:-1;1117:40:158;1317:13;:::i;:::-;1308:8;:23::i;:::-;1284:47;;1341:22;1386:2;1378:5;:10;:77;;1440:15;1449:5;1440:8;:15::i;:::-;1378:77;;;1420:15;1429:5;1420:8;:15::i;:::-;1398:38;;;;;;;;:::i;:::-;;;;;;;;;;;;;1378:77;1341:114;;1465:20;1506:2;1500:3;:8;:71;;1558:13;1567:3;1558:8;:13::i;:::-;1500:71;;;1540:13;1549:3;1540:8;:13::i;:::-;1518:36;;;;;;;;:::i;:::-;;;;;;;;;;;;;1500:71;1590:7;;1599:8;;-1:-1:-1;1590:7:158;;-1:-1:-1;129:1494:158;-1:-1:-1;;;;;;129:1494:158:o;9633:10091:163:-;9900:11;;10177:4;10171:11;-1:-1:-1;;;10672:79:163;;10800:21;;;10795:3;10791:31;;;9914:1;10775:14;;;10768:55;;;;-1:-1:-1;;;11540:4:163;11531:14;;11503:148;-1:-1:-1;;;10818:2:163;12452:14;;12424:148;9900:15;;12612:21;;12605:4;12596:14;;12589:45;;;-1:-1:-1;;;13549:4:163;13540:14;;13512:148;13693:4;13684:14;;13677:45;-1:-1:-1;;;14088:4:163;14079:14;;14051:148;14243:4;14239:25;;;14232:4;14223:14;;;14216:49;;;;-1:-1:-1;;;15873:4:163;15864:14;;15836:148;9754:16;;9900:11;10020:18;;;;9900:11;;10020:4;16481:10;;;16632:13;;16672:276;16690:2;16679:7;:13;16672:276;;16838:14;;16822:31;;-1:-1:-1;;16694:13:163;;;;16900:2;16889:13;;;;16920;16672:276;;;16961:12;17002:1;16991:7;16986:2;:12;16978:3;:21;:25;16976:28;16961:43;;17141:4;17131:7;17125:14;17121:25;17112:7;17105:42;17185:7;17174:18;;;;17318:11;17313:3;17309:21;17300:7;17293:38;17573:23;17567:4;17560:37;17731:4;17725;17719;17716:1;17708:28;17839:5;17829:241;;17951:10;17945:4;17938:24;18047:4;18041;18034:18;17829:241;18147:5;18141:4;18134:19;18367:6;18361:4;18354:20;18457:4;18451;18443:19;18508:4;18502;18492:21;18480:33;;19374:4;19319;19248:12;19183:3;19136:1;19081:5;19028;18994:431;18962:485;18930:8;18918:21;18911:29;18887:578;18884:810;;;19575:10;19569:4;19562:24;19671:4;19665;19658:18;18884:810;;17475:2233;;;;;;;9633:10091;;;;;:::o;3116:1607:62:-;3228:12;3398:4;3392:11;-1:-1:-1;;;3521:17:62;3514:93;-1:-1:-1;;;;;3658:2:62;3654:51;3650:1;3631:17;3627:25;3620:86;3792:6;3787:2;3768:17;3764:26;3757:42;4644:2;4641:1;4637:2;4618:17;4615:1;4608:5;4601;4596:51;4165:16;4158:24;4152:2;4134:16;4131:24;4127:1;4123;4117:8;4114:15;4110:46;4107:76;3907:754;3896:765;;;4689:7;4681:35;;;;-1:-1:-1;;;4681:35:62;;34044:2:264;4681:35:62;;;34026:21:264;34083:2;34063:18;;;34056:30;-1:-1:-1;;;34102:18:264;;;34095:45;34157:18;;4681:35:62;33842:339:264;636:696:48;692:13;741:14;758:17;769:5;758:10;:17::i;:::-;778:1;758:21;741:38;;793:20;827:6;-1:-1:-1;;;;;816:18:48;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;816:18:48;-1:-1:-1;793:41:48;-1:-1:-1;954:28:48;;;970:2;954:28;1009:280;-1:-1:-1;;1040:5:48;-1:-1:-1;;;1174:2:48;1163:14;;1158:30;1040:5;1145:44;1233:2;1224:11;;;-1:-1:-1;1253:21:48;1009:280;1253:21;-1:-1:-1;1309:6:48;636:696;-1:-1:-1;;;636:696:48:o;2677:149::-;2735:13;2767:52;-1:-1:-1;;;;;2779:22:48;;374:2;2767:11;:52::i;9155:186:180:-;9203:13;9247:87;9280:30;;;;;;;;;;;;;;-1:-1:-1;;;9280:30:180;;;;;;;;;;;;;;;;-1:-1:-1;;;9280:30:180;;;:8;:30::i;:::-;9266:45;;;;;;;;:::i;:::-;;;;;;;;;;;;;9313:20;:18;:20::i;:::-;9247:18;:87::i;9347:287::-;9397:13;9429:198;9492:32;;;;;;;;;;;;;;-1:-1:-1;;;9492:32:180;;;;;;;;;;;;;;;;-1:-1:-1;;;9492:32:180;;;:8;:32::i;:::-;9526:43;;;;;;;;;;;;;;-1:-1:-1;;;9526:43:180;;;;;;;;;;;;;;;;-1:-1:-1;;;9526:43:180;;;:8;:43::i;:::-;9461:122;;;;;;;;;:::i;9640:308::-;9697:13;9729:212;9792:39;;;;;;;;;;;;;;-1:-1:-1;;;9792:39:180;;;;;;;;;;;;;;;;-1:-1:-1;;;9792:39:180;;;:8;:39::i;:::-;9833:43;;;;;;;;;;;;;;-1:-1:-1;;;9833:43:180;;;;;;;;;;;;;;;;-1:-1:-1;;;9833:43:180;;;:8;:43::i;:::-;9761:129;;;;;;;;;:::i;:::-;;;;;;;;;;;;;9904:27;:25;:27::i;9954:481::-;10007:13;10039:389;10102:35;;;;;;;;;;;;;;-1:-1:-1;;;10102:35:180;;;;;;;;;;;;;;;;-1:-1:-1;;;10102:35:180;;;:8;:35::i;:::-;10139:43;;;;;;;;;;;;;;-1:-1:-1;;;10139:43:180;;;;;;;;;;;;;;;;-1:-1:-1;;;10139:43:180;;;:8;:43::i;:::-;10071:125;;;;;;;;;:::i;:::-;;;;;;;;;;;;;10241:40;10258:2;10262:11;;;;;;;;;;;;;-1:-1:-1;;;10262:11:180;;;10275:5;;;;;;;;;;;;10241:16;:40::i;:::-;10299:46;10316:2;10320:17;;;;;;;;;;;;;-1:-1:-1;;;10320:17:180;;;10339:5;;;;;;;;;;;;10299:16;:46::i;:::-;10363:41;10380:2;10384:12;;;;;;;;;;;;;-1:-1:-1;;;10384:12:180;;;10398:5;;;;;;;;;;;;10363:16;:41::i;:::-;10210:208;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;10039:18;:389::i;6778:241:157:-;6910:13;6961:4;6972:6;6985:9;7002:4;6942:70;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;6935:77;;6778:241;;;;;:::o;4829:174::-;4935:13;4967:29;;;;;;;;;;;;;;-1:-1:-1;;;4967:29:157;;;4978:6;4986:9;4967:2;:29::i;3550:318:180:-;3611:13;3670:88;3727:11;;;;;;;;;;;;;;;;;3679:60;;;;;;;;:::i;:::-;;;;-1:-1:-1;;3679:60:180;;;;;;3670:88;;;;;;;;;-1:-1:-1;;;3679:60:180;3670:88;;;3679:60;3670:8;:88::i;:::-;3772:79;3830:11;;;;;;;;;;;;;;;;;3781:61;;;;;;;;:::i;:::-;;;;;;;;;;;;;3844:6;3772:8;:79::i;:::-;3643:218;;;;;;;;;:::i;4880:2113::-;4953:13;5000:15;4953:13;;4978:19;5171:20;;;;;5217:59;;5275:1;5217:59;;;5260:11;5266:5;5260:3;:11;:::i;:::-;5229:19;5243:5;5229:11;:19;:::i;:::-;5228:27;;5252:3;5228:27;:::i;:::-;5227:45;;;;:::i;:::-;5206:70;;5355:3;5344:8;:14;:31;;5367:8;5344:31;;;5361:3;5344:31;5333:42;;5401:254;5528:7;:30;;;;;;;;;;;;;;;-1:-1:-1;;;5528:30:180;;;;;;5538:11;;;;;;;;;;;;;-1:-1:-1;;;5538:11:180;;;5528:30;5427:191;;;;;;;;:::i;:::-;;;;-1:-1:-1;;5427:191:180;;;;;;;5636:5;;;;;-1:-1:-1;5636:5:180;;5427:191;5401:8;:254::i;:::-;5390:265;;5679;5808:8;5820:3;5808:15;:39;;;;;;;;;;;;;;;-1:-1:-1;;;5808:39:180;;;;;;5826:12;;;;;;;;;;;;;-1:-1:-1;;;5826:12:180;;;5808:39;5705:202;;;;;;;;:::i;5679:265::-;5670:274;-1:-1:-1;5965:11:180;;-1:-1:-1;5998:3:180;5980:14;5986:8;5980:3;:14;:::i;:::-;5979:22;;;;:::i;:::-;5965:36;-1:-1:-1;6011:21:180;6035:26;6052:8;5965:36;6052:2;:8;:::i;:::-;6035:16;:26::i;:::-;6011:50;;6072:26;6101:224;6195:7;6123:173;;;;;;;;:::i;6101:224::-;6072:253;;6336:28;6367:122;6413:7;6391:81;;;;;;;;:::i;:::-;;;;-1:-1:-1;;6391:81:180;;;;;;;6474:5;;;;;-1:-1:-1;6474:5:180;;6391:81;6367:10;:122::i;:::-;6336:153;;6500:24;6527:133;6549:82;;;;;;41490:66:264;41478:79;;41587:66;41582:2;41573:12;;41566:88;-1:-1:-1;;;41679:2:264;41670:12;;41663:34;41722:2;41713:12;;41276:455;6527:133:180;6500:160;;6678:308;6697:5;;;;;;;;;;;;6747:8;6773:10;6801:12;6842:2;6831:8;:13;:38;;6852:17;6865:3;6852:12;:17::i;:::-;6831:38;;;;;;;;;;;;;;;;6887:6;6922:1;6911:8;:12;:29;;;;6938:2;6927:8;:13;6911:29;:51;;6948:14;6911:51;;;;;;;;;;;;;;;;6716:260;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;6678:5;:308::i;:::-;6671:315;4880:2113;-1:-1:-1;;;;;;;;;;;;4880:2113:180:o;7645:414::-;7724:13;7750:19;7771:20;7795:32;7811:6;7819:7;7795:15;:32::i;:::-;7749:78;;;;7872:77;7929:11;;;;;;;;;;;;;;;;;7881:60;;;;;;;;:::i;:::-;;;;;;;;;;;;;7943:5;7872:8;:77::i;:::-;7963:79;8021:11;;;;;;;;;;;;;;;;;7972:61;;;;;;;;:::i;7963:79::-;7845:207;;;;;;;;;:::i;:::-;;;;;;;;;;;;;7838:214;;;;7645:414;;;;:::o;3874:590::-;3914:13;3973:122;;;;;;;;;;;;;;;;;;4076:5;;;;;;;;;;;;3973:8;:122::i;:::-;4109:162;;;;;;;;;;;;;;;;;;4252:5;;;;;;;;;;;;4109:8;:162::i;:::-;4285;;;;;;;;;;;;;;;;;;4428:5;;;;;;;;;;;;4285:8;:162::i;:::-;3946:511;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;3939:518;;3874:590;:::o;4470:404::-;4531:13;4590:84;4648:11;;;;;;;;;;;;;;;;;4599:61;;;;;;;;:::i;:::-;;;;;;;;;;;;;4662:11;4590:84;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:8;:84::i;:::-;4688:169;4762:11;;;;;;;;;;;;;;;;;4714:60;;;;;;;;:::i;:::-;;;;;;;;;;;;;4814:28;4834:7;4814:19;:28::i;:::-;4792:51;;;;;;;;:::i;:::-;;;;;;;;;;;;;4688:8;:169::i;1328:1782:62:-;1466:12;1636:4;1630:11;-1:-1:-1;;;1759:17:62;1752:93;-1:-1:-1;;;;;1896:4:62;1892:53;1888:1;1869:17;1865:25;1858:88;-1:-1:-1;;;;;2038:2:62;2034:51;2029:2;2010:17;2006:26;1999:87;2172:6;2167:2;2148:17;2144:26;2137:42;3026:2;3023:1;3018:3;2999:17;2996:1;2989:5;2982;2977:52;2545:16;2538:24;2532:2;2514:16;2511:24;2507:1;2503;2497:8;2494:15;2490:46;2487:76;2287:756;2276:767;;;3071:7;3063:40;;;;-1:-1:-1;;;3063:40:62;;45670:2:264;3063:40:62;;;45652:21:264;45709:2;45689:18;;;45682:30;-1:-1:-1;;;45728:18:264;;;45721:50;45788:18;;3063:40:62;45468:344:264;262:466:160;306:13;331:2;337:1;331:7;327:40;;-1:-1:-1;;350:10:160;;;;;;;;;;;;-1:-1:-1;;;350:10:160;;;;;262:466::o;327:40::-;384:2;372:9;409:54;416:6;;409:54;;434:5;;;;:::i;:::-;;-1:-1:-1;449:7:160;;-1:-1:-1;454:2:160;449:7;;:::i;:::-;;;409:54;;;468:17;498:3;-1:-1:-1;;;;;488:14:160;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;488:14:160;-1:-1:-1;468:34:160;-1:-1:-1;520:3:160;529:172;536:7;;529:172;;559:5;563:1;559;:5;:::i;:::-;555:9;-1:-1:-1;574:10:160;605:7;610:2;605;:7;:::i;:::-;604:14;;616:2;604:14;:::i;:::-;599:19;;:2;:19;:::i;:::-;588:31;;:2;:31;:::i;:::-;574:46;;630:9;649:4;642:12;;630:24;;674:2;664:4;669:1;664:7;;;;;;;;:::i;:::-;;;;:12;-1:-1:-1;;;;;664:12:160;;;;;;;;-1:-1:-1;686:8:160;692:2;686:8;;:::i;:::-;;;545:156;;529:172;;;-1:-1:-1;720:4:160;262:466;-1:-1:-1;;;;262:466:160:o;12337:916:50:-;12390:7;;-1:-1:-1;;;12465:17:50;;12461:103;;-1:-1:-1;;;12502:17:50;;;-1:-1:-1;12547:2:50;12537:12;12461:103;12590:8;12581:5;:17;12577:103;;12627:8;12618:17;;;-1:-1:-1;12663:2:50;12653:12;12577:103;12706:8;12697:5;:17;12693:103;;12743:8;12734:17;;;-1:-1:-1;12779:2:50;12769:12;12693:103;12822:7;12813:5;:16;12809:100;;12858:7;12849:16;;;-1:-1:-1;12893:1:50;12883:11;12809:100;12935:7;12926:5;:16;12922:100;;12971:7;12962:16;;;-1:-1:-1;13006:1:50;12996:11;12922:100;13048:7;13039:5;:16;13035:100;;13084:7;13075:16;;;-1:-1:-1;13119:1:50;13109:11;13035:100;13161:7;13152:5;:16;13148:66;;13198:1;13188:11;13240:6;12337:916;-1:-1:-1;;12337:916:50:o;2002:523:48:-;2077:13;2123:5;2102:18;2170:10;2174:6;2170:1;:10;:::i;:::-;:14;;2183:1;2170:14;:::i;:::-;-1:-1:-1;;;;;2160:25:48;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;2160:25:48;;2138:47;;-1:-1:-1;;;2195:6:48;2202:1;2195:9;;;;;;;;:::i;:::-;;;;:15;-1:-1:-1;;;;;2195:15:48;;;;;;;;;-1:-1:-1;;;2220:6:48;2227:1;2220:9;;;;;;;;:::i;:::-;;;;:15;-1:-1:-1;;;;;2220:15:48;;;;;;;;-1:-1:-1;2250:9:48;2262:10;2266:6;2262:1;:10;:::i;:::-;:14;;2275:1;2262:14;:::i;:::-;2250:26;;2245:138;2282:1;2278;:5;2245:138;;;-1:-1:-1;;;2325:10:48;2338:3;2325:16;2316:26;;;;;;;:::i;:::-;;;;2304:6;2311:1;2304:9;;;;;;;;:::i;:::-;;;;:38;-1:-1:-1;;;;;2304:38:48;;;;;;;;-1:-1:-1;2371:1:48;2356:16;;;;;2285:3;;;:::i;:::-;;;2245:138;;;-1:-1:-1;2396:15:48;;2392:96;;2434:43;;-1:-1:-1;;;2434:43:48;;;;;46404:25:264;;;46445:18;;;46438:34;;;46377:18;;2434:43:48;46230:248:264;7308:157:157;7385:13;7431:4;7447;7417:41;;;;;;;;;:::i;:::-;;;;;;;;;;;;;7410:48;;7308:157;;;;:::o;8114:511:180:-;8167:13;8226:39;8243:1;8246:11;;;;;;;;;;;;;-1:-1:-1;;;8246:11:180;;;8259:5;;;;;;;;;;;;8226:16;:39::i;:::-;8279:46;8296:2;8300:17;;;;;;;;;;;;;-1:-1:-1;;;8300:17:180;;;8319:5;;;;;;;;;;;;8279:16;:46::i;:::-;8339:41;8356:2;8360:12;;;;;;;;;;;;;-1:-1:-1;;;8360:12:180;;;8374:5;;;;;;;;;;;;8339:16;:41::i;:::-;8394:48;8411:2;8415:19;;;;;;;;;;;;;-1:-1:-1;;;8415:19:180;;;8436:5;;;;;;;;;;;;8394:16;:48::i;:::-;8456:42;8473:2;8477:13;;;;;;;;;;;;;-1:-1:-1;;;8477:13:180;;;8492:5;;;;;;;;;;;;8456:16;:42::i;:::-;8512;8529:2;8533:13;;;;;;;;;;;;;-1:-1:-1;;;8533:13:180;;;8548:5;;;;;;;;;;;;8512:16;:42::i;:::-;8568:40;8585:3;8590:10;;;;;;;;;;;;;-1:-1:-1;;;8590:10:180;;;8602:5;;;;;;;;;;;;8568:16;:40::i;:::-;8199:419;;;;;;;;;;;;;;:::i;5685:194:157:-;5801:13;5833:39;;;;;;;;;;;;;;-1:-1:-1;;;5833:39:157;;;5854:6;5862:9;5833:2;:39::i;8631:518:180:-;8691:13;8750:38;8767:1;8770:10;;;;;;;;;;;;;-1:-1:-1;;;8770:10:180;;;8782:5;;;;;;;;;;;;8750:16;:38::i;:::-;8802:42;8819:2;8823:13;;;;;;;;;;;;;-1:-1:-1;;;8823:13:180;;;8838:5;;;;;;;;;;;;8802:16;:42::i;:::-;8858;8875:2;8879:13;;;;;;;;;;;;;-1:-1:-1;;;8879:13:180;;;8894:5;;;;;;;;;;;;8858:16;:42::i;:::-;8914:48;8931:2;8935:19;;;;;;;;;;;;;-1:-1:-1;;;8935:19:180;;;8956:5;;;;;;;;;;;;8914:16;:48::i;:::-;8976:41;8993:2;8997:12;;;;;;;;;;;;;-1:-1:-1;;;8997:12:180;;;9011:5;;;;;;;;;;;;8976:16;:41::i;:::-;9031:46;9048:2;9052:17;;;;;;;;;;;;;-1:-1:-1;;;9052:17:180;;;9071:5;;;;;;;;;;;;9031:16;:46::i;:::-;9091:41;9108:3;9113:11;;;;;;;;;;;;;-1:-1:-1;;;9113:11:180;;;9126:5;;;;;;;;;;;;5885:439:157;6023:13;6055:262;;;;;;;;;;;;;;-1:-1:-1;;;6055:262:157;;;6122:29;;;;;;;;;;;;;;-1:-1:-1;;;6122:29:157;;;6141:9;6122:4;:29::i;:::-;6190:58;;;;;;;;;;;;;;-1:-1:-1;;;6190:58:157;;;6219:22;6234:6;6219:14;:22::i;:::-;6205:42;;;;;;;;:::i;:::-;;;;;;;;;;;;;6190:4;:58::i;:::-;6287:6;6091:216;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;6055:2;:262::i;3845:174::-;3951:13;3983:29;;;;;;;;;;;;;;-1:-1:-1;;;3983:29:157;;;3994:6;4002:9;3983:2;:29::i;4025:174::-;4131:13;4163:29;;;;;;;;;;;;;;-1:-1:-1;;;4163:29:157;;;4174:6;4182:9;4163:2;:29::i;4205:178::-;4313:13;4345:31;;;;;;;;;;;;;;-1:-1:-1;;;4345:31:157;;;4358:6;4366:9;4345:2;:31::i;6999:640:180:-;7057:13;7089:543;7111:128;;;;;;50591:66:264;50579:79;;50688:66;50683:2;50674:12;;50667:88;-1:-1:-1;;;50780:2:264;50771:12;;50764:68;50857:2;50848:12;;50377:489;7111:128:180;;;;-1:-1:-1;;7111:128:180;;;;;;7253:369;;;;;;;;;-1:-1:-1;;;7111:128:180;7253:369;;;7111:128;7253:369;;7392:31;7420:2;7409:8;7414:3;7409:2;:8;:::i;:::-;:13;;;;:::i;7392:31::-;7477:39;7507:3;7496:7;7500:3;7496:1;:7;:::i;:::-;7495:15;;;;:::i;:::-;7494:21;;7514:1;7494:21;:::i;7477:39::-;7304:281;;;;;;;;;:::i;:::-;;;;-1:-1:-1;;7304:281:180;;;;;;;7603:5;;;;;-1:-1:-1;7603:5:180;;7304:281;7253:6;:369::i;:::-;7089:8;:543::i;3491:168:157:-;3594:13;3626:26;;;;;;;;;;;;;;-1:-1:-1;;;3626:26:157;;;3634:6;3642:9;3626:2;:26::i;10484:549:180:-;10580:13;10595;10621:23;10646:24;10672:22;10710:31;10735:5;10710:24;:31::i;:::-;10620:121;;;;;;10752:21;10775:22;10799:20;10835:29;10860:3;10835:24;:29::i;:::-;10751:113;;;;;;10910:9;10926:10;10943:8;10896:56;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;10980:7;10994:8;11009:6;10966:50;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;10875:151;;;;;;;;;;10484:549;;;;;:::o;1705:174:48:-;1764:13;1820:42;1832:5;1839:18;1851:5;1839:11;:18::i;:::-;1860:1;1839:22;1820:11;:42::i;2776:569:157:-;2829:27;2872:2;2878:1;2872:7;2868:48;;-1:-1:-1;;2895:10:157;;;;;;;;;;;;-1:-1:-1;;;2895:10:157;;;;;2776:569::o;2868:48::-;2937:2;2925:9;2970:66;2977:6;;2970:66;;2999:5;;;;:::i;:::-;;-1:-1:-1;3018:7:157;;-1:-1:-1;3023:2:157;3018:7;;:::i;:::-;;;2970:66;;;3045:17;3075:3;-1:-1:-1;;;;;3065:14:157;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;3065:14:157;-1:-1:-1;3045:34:157;-1:-1:-1;3101:3:157;3114:196;3121:7;;3114:196;;3148:5;3152:1;3148;:5;:::i;:::-;3144:9;-1:-1:-1;3167:10:157;3198:7;3203:2;3198;:7;:::i;:::-;3197:14;;3209:2;3197:14;:::i;:::-;3192:19;;:2;:19;:::i;:::-;3181:31;;:2;:31;:::i;:::-;3167:46;;3227:9;3246:4;3239:12;;3227:24;;3275:2;3265:4;3270:1;3265:7;;;;;;;;:::i;:::-;;;;:12;-1:-1:-1;;;;;3265:12:157;;;;;;;;-1:-1:-1;3291:8:157;3297:2;3291:8;;:::i;:::-;;;3130:180;;3114:196;;7119:159;7196:13;7247:4;7258:6;7228:43;;;;;;;;;:::i;13915:663:50:-;13969:7;;14053:3;14044:12;;;:16;14040:98;;14090:3;14080:13;;;;;14121:2;14111:12;14040:98;14164:2;14155:11;;;:15;14151:95;;14200:2;14190:12;;;;;14230:1;14220:11;14151:95;14272:2;14263:11;;;:15;14259:95;;14308:2;14298:12;;;;;14338:1;14328:11;14259:95;14380:2;14371:11;;;:15;14367:95;;14416:2;14406:12;;;;;14446:1;14436:11;14367:95;14488:1;14479:10;;;:14;14475:64;;14523:1;14513:11;14565:6;13915:663;-1:-1:-1;;13915:663:50:o;14:180:264:-;73:6;126:2;114:9;105:7;101:23;97:32;94:52;;;142:1;139;132:12;94:52;-1:-1:-1;165:23:264;;14:180;-1:-1:-1;14:180:264:o;199:250::-;284:1;294:113;308:6;305:1;302:13;294:113;;;384:11;;;378:18;365:11;;;358:39;330:2;323:10;294:113;;;-1:-1:-1;;441:1:264;423:16;;416:27;199:250::o;454:282::-;507:3;545:5;539:12;572:6;567:3;560:19;588:76;657:6;650:4;645:3;641:14;634:4;627:5;623:16;588:76;:::i;:::-;718:2;697:15;-1:-1:-1;;693:29:264;684:39;;;;725:4;680:50;;454:282;-1:-1:-1;;454:282:264:o;741:231::-;890:2;879:9;872:21;853:4;910:56;962:2;951:9;947:18;939:6;910:56;:::i;977:173::-;1045:20;;-1:-1:-1;;;;;1094:31:264;;1084:42;;1074:70;;1140:1;1137;1130:12;1074:70;977:173;;;:::o;1155:254::-;1223:6;1231;1284:2;1272:9;1263:7;1259:23;1255:32;1252:52;;;1300:1;1297;1290:12;1252:52;1323:29;1342:9;1323:29;:::i;:::-;1313:39;1399:2;1384:18;;;;1371:32;;-1:-1:-1;;;1155:254:264:o;1596:286::-;1654:6;1707:2;1695:9;1686:7;1682:23;1678:32;1675:52;;;1723:1;1720;1713:12;1675:52;1749:23;;-1:-1:-1;;;;;;1801:32:264;;1791:43;;1781:71;;1848:1;1845;1838:12;2079:322;2156:6;2164;2172;2225:2;2213:9;2204:7;2200:23;2196:32;2193:52;;;2241:1;2238;2231:12;2193:52;2264:29;2283:9;2264:29;:::i;:::-;2254:39;2340:2;2325:18;;2312:32;;-1:-1:-1;2391:2:264;2376:18;;;2363:32;;2079:322;-1:-1:-1;;;2079:322:264:o;2614:127::-;2675:10;2670:3;2666:20;2663:1;2656:31;2706:4;2703:1;2696:15;2730:4;2727:1;2720:15;2746:275;2817:2;2811:9;2882:2;2863:13;;-1:-1:-1;;2859:27:264;2847:40;;-1:-1:-1;;;;;2902:34:264;;2938:22;;;2899:62;2896:88;;;2964:18;;:::i;:::-;3000:2;2993:22;2746:275;;-1:-1:-1;2746:275:264:o;3026:186::-;3074:4;-1:-1:-1;;;;;3099:6:264;3096:30;3093:56;;;3129:18;;:::i;:::-;-1:-1:-1;3195:2:264;3174:15;-1:-1:-1;;3170:29:264;3201:4;3166:40;;3026:186::o;3217:462::-;3259:5;3312:3;3305:4;3297:6;3293:17;3289:27;3279:55;;3330:1;3327;3320:12;3279:55;3366:6;3353:20;3397:48;3413:31;3441:2;3413:31;:::i;:::-;3397:48;:::i;:::-;3470:2;3461:7;3454:19;3516:3;3509:4;3504:2;3496:6;3492:15;3488:26;3485:35;3482:55;;;3533:1;3530;3523:12;3482:55;3598:2;3591:4;3583:6;3579:17;3572:4;3563:7;3559:18;3546:55;3646:1;3621:16;;;3639:4;3617:27;3610:38;;;;3625:7;3217:462;-1:-1:-1;;;3217:462:264:o;3684:160::-;3749:20;;3805:13;;3798:21;3788:32;;3778:60;;3834:1;3831;3824:12;3849:462;3932:6;3940;3948;4001:2;3989:9;3980:7;3976:23;3972:32;3969:52;;;4017:1;4014;4007:12;3969:52;4040:29;4059:9;4040:29;:::i;:::-;4030:39;;4120:2;4109:9;4105:18;4092:32;-1:-1:-1;;;;;4139:6:264;4136:30;4133:50;;;4179:1;4176;4169:12;4133:50;4202:49;4243:7;4234:6;4223:9;4219:22;4202:49;:::i;:::-;4192:59;;;4270:35;4301:2;4290:9;4286:18;4270:35;:::i;:::-;4260:45;;3849:462;;;;;:::o;4595:248::-;4663:6;4671;4724:2;4712:9;4703:7;4699:23;4695:32;4692:52;;;4740:1;4737;4730:12;4692:52;-1:-1:-1;;4763:23:264;;;4833:2;4818:18;;;4805:32;;-1:-1:-1;4595:248:264:o;5037:254::-;5102:6;5110;5163:2;5151:9;5142:7;5138:23;5134:32;5131:52;;;5179:1;5176;5169:12;5131:52;5202:29;5221:9;5202:29;:::i;:::-;5192:39;;5250:35;5281:2;5270:9;5266:18;5250:35;:::i;:::-;5240:45;;5037:254;;;;;:::o;5296:328::-;5373:6;5381;5389;5442:2;5430:9;5421:7;5417:23;5413:32;5410:52;;;5458:1;5455;5448:12;5410:52;5481:29;5500:9;5481:29;:::i;:::-;5471:39;;5529:38;5563:2;5552:9;5548:18;5529:38;:::i;:::-;5519:48;;5614:2;5603:9;5599:18;5586:32;5576:42;;5296:328;;;;;:::o;5629:706::-;5806:2;5795:9;5788:21;5865:6;5859:13;5852:21;5845:29;5840:2;5829:9;5825:18;5818:57;5769:4;5922:2;5914:6;5910:15;5904:22;5962:1;5958;5953:3;5949:11;5945:19;6018:2;6004:12;6000:21;5995:2;5984:9;5980:18;5973:49;6086:2;6080;6072:6;6068:15;6062:22;6058:31;6053:2;6042:9;6038:18;6031:59;;;6145:2;6137:6;6133:15;6127:22;6121:3;6110:9;6106:19;6099:51;6199:3;6191:6;6187:16;6181:23;6242:4;6235;6224:9;6220:20;6213:34;6264:65;6324:3;6313:9;6309:19;6293:14;6264:65;:::i;6340:582::-;6600:14;;6593:22;6575:41;;-1:-1:-1;;;;;6690:15:264;;;6685:2;6670:18;;6663:43;6742:15;;6737:2;6722:18;;6715:43;6789:2;6774:18;;6767:34;;;6643:3;6832;6817:19;;6810:32;;;6556:4;;6859:57;;6896:19;;6888:6;6859:57;:::i;7294:260::-;7362:6;7370;7423:2;7411:9;7402:7;7398:23;7394:32;7391:52;;;7439:1;7436;7429:12;7391:52;7462:29;7481:9;7462:29;:::i;:::-;7452:39;;7510:38;7544:2;7533:9;7529:18;7510:38;:::i;7559:338::-;7701:2;7686:18;;7734:1;7723:13;;7713:144;;7779:10;7774:3;7770:20;7767:1;7760:31;7814:4;7811:1;7804:15;7842:4;7839:1;7832:15;7713:144;7866:25;;;7559:338;:::o;7902:394::-;7979:6;7987;8040:2;8028:9;8019:7;8015:23;8011:32;8008:52;;;8056:1;8053;8046:12;8008:52;8079:29;8098:9;8079:29;:::i;:::-;8069:39;;8159:2;8148:9;8144:18;8131:32;-1:-1:-1;;;;;8178:6:264;8175:30;8172:50;;;8218:1;8215;8208:12;8172:50;8241:49;8282:7;8273:6;8262:9;8258:22;8241:49;:::i;:::-;8231:59;;;7902:394;;;;;:::o;8544:391::-;8627:6;8635;8643;8651;8704:3;8692:9;8683:7;8679:23;8675:33;8672:53;;;8721:1;8718;8711:12;8672:53;8744:29;8763:9;8744:29;:::i;:::-;8734:39;;8820:2;8809:9;8805:18;8792:32;8782:42;;8871:2;8860:9;8856:18;8843:32;8833:42;;8894:35;8925:2;8914:9;8910:18;8894:35;:::i;:::-;8884:45;;8544:391;;;;;;;:::o;9290:606::-;9391:6;9399;9407;9415;9423;9476:3;9464:9;9455:7;9451:23;9447:33;9444:53;;;9493:1;9490;9483:12;9444:53;9516:29;9535:9;9516:29;:::i;:::-;9506:39;;9564:38;9598:2;9587:9;9583:18;9564:38;:::i;:::-;9554:48;;9653:2;9642:9;9638:18;9625:32;-1:-1:-1;;;;;9672:6:264;9669:30;9666:50;;;9712:1;9709;9702:12;9666:50;9735:49;9776:7;9767:6;9756:9;9752:22;9735:49;:::i;:::-;9725:59;;;9831:2;9820:9;9816:18;9803:32;9793:42;;9854:36;9885:3;9874:9;9870:19;9854:36;:::i;:::-;9844:46;;9290:606;;;;;;;;:::o;9901:322::-;9978:6;9986;9994;10047:2;10035:9;10026:7;10022:23;10018:32;10015:52;;;10063:1;10060;10053:12;10015:52;10099:9;10086:23;10076:33;;10128:38;10162:2;10151:9;10147:18;10128:38;:::i;10228:397::-;10314:6;10322;10330;10338;10391:3;10379:9;10370:7;10366:23;10362:33;10359:53;;;10408:1;10405;10398:12;10359:53;10431:29;10450:9;10431:29;:::i;:::-;10421:39;;10479:38;10513:2;10502:9;10498:18;10479:38;:::i;:::-;10228:397;;10469:48;;-1:-1:-1;;;;10564:2:264;10549:18;;10536:32;;10615:2;10600:18;10587:32;;10228:397::o;10630:380::-;10709:1;10705:12;;;;10752;;;10773:61;;10827:4;10819:6;10815:17;10805:27;;10773:61;10880:2;10872:6;10869:14;10849:18;10846:38;10843:161;;10926:10;10921:3;10917:20;10914:1;10907:31;10961:4;10958:1;10951:15;10989:4;10986:1;10979:15;11015:171;11093:13;;11146:14;11135:26;;11125:37;;11115:65;;11176:1;11173;11166:12;11191:554;11293:6;11346:2;11334:9;11325:7;11321:23;11317:32;11314:52;;;11362:1;11359;11352:12;11314:52;11395:2;11389:9;11437:2;11429:6;11425:15;11506:6;11494:10;11491:22;-1:-1:-1;;;;;11458:10:264;11455:34;11452:62;11449:88;;;11517:18;;:::i;:::-;11553:2;11546:22;11592:39;11621:9;11592:39;:::i;:::-;11584:6;11577:55;11665:48;11709:2;11698:9;11694:18;11665:48;:::i;:::-;11660:2;11648:15;;11641:73;11652:6;11191:554;-1:-1:-1;;;11191:554:264:o;12029:273::-;12097:6;12150:2;12138:9;12129:7;12125:23;12121:32;12118:52;;;12166:1;12163;12156:12;12118:52;12198:9;12192:16;12248:4;12241:5;12237:16;12230:5;12227:27;12217:55;;12268:1;12265;12258:12;12307:184;12377:6;12430:2;12418:9;12409:7;12405:23;12401:32;12398:52;;;12446:1;12443;12436:12;12398:52;-1:-1:-1;12469:16:264;;12307:184;-1:-1:-1;12307:184:264:o;12496:127::-;12557:10;12552:3;12548:20;12545:1;12538:31;12588:4;12585:1;12578:15;12612:4;12609:1;12602:15;12628:125;12693:9;;;12714:10;;;12711:36;;;12727:18;;:::i;12758:128::-;12825:9;;;12846:11;;;12843:37;;;12860:18;;:::i;12891:179::-;12959:14;13006:10;;;12994;;;12990:27;;13029:12;;;13026:38;;;13044:18;;:::i;13075:648::-;13155:6;13208:2;13196:9;13187:7;13183:23;13179:32;13176:52;;;13224:1;13221;13214:12;13176:52;13257:9;13251:16;-1:-1:-1;;;;;13282:6:264;13279:30;13276:50;;;13322:1;13319;13312:12;13276:50;13345:22;;13398:4;13390:13;;13386:27;-1:-1:-1;13376:55:264;;13427:1;13424;13417:12;13376:55;13456:2;13450:9;13481:48;13497:31;13525:2;13497:31;:::i;13481:48::-;13552:2;13545:5;13538:17;13592:7;13587:2;13582;13578;13574:11;13570:20;13567:33;13564:53;;;13613:1;13610;13603:12;13564:53;13626:67;13690:2;13685;13678:5;13674:14;13669:2;13665;13661:11;13626:67;:::i;13728:198::-;13770:3;13808:5;13802:12;13823:65;13881:6;13876:3;13869:4;13862:5;13858:16;13823:65;:::i;:::-;13904:16;;;;;13728:198;-1:-1:-1;;13728:198:264:o;14015:1871::-;-1:-1:-1;;;14782:45:264;;14850:13;;14764:3;;14872:75;14850:13;14935:2;14926:12;;14919:4;14907:17;;14872:75;:::i;:::-;-1:-1:-1;;;15006:2:264;14966:16;;;14998:11;;;14991:71;15087:13;;15109:76;15087:13;15171:2;15163:11;;15156:4;15144:17;;15109:76;:::i;:::-;15250:34;15245:2;15204:17;;;;15237:11;;;15230:55;15314:66;15309:2;15301:11;;15294:87;-1:-1:-1;;;15405:2:264;15397:11;;15390:59;15474:13;;15496:77;15474:13;15558:3;15550:12;;15543:4;15531:17;;15496:77;:::i;:::-;15639:66;15633:3;15592:17;;;;15625:12;;;15618:88;-1:-1:-1;;;15730:3:264;15722:12;;15715:30;15767:39;15801:3;15793:12;;15785:6;15767:39;:::i;:::-;-1:-1:-1;;;13981:27:264;;15878:1;15867:13;;;-1:-1:-1;;;;;;;14015:1871:264:o;15891:451::-;16143:31;16138:3;16131:44;16113:3;16204:6;16198:13;16220:75;16288:6;16283:2;16278:3;16274:12;16267:4;16259:6;16255:17;16220:75;:::i;:::-;16315:16;;;;16333:2;16311:25;;15891:451;-1:-1:-1;;15891:451:264:o;16347:1338::-;16925:3;16963:6;16957:13;16979:66;17038:6;17033:3;17026:4;17018:6;17014:17;16979:66;:::i;:::-;-1:-1:-1;;;17067:16:264;;;17092:18;;;17135:13;;17157:78;17135:13;17222:1;17211:13;;17204:4;17192:17;;17157:78;:::i;:::-;17265:8;17258:5;17254:20;17244:30;;;-1:-1:-1;;;17324:2:264;17320:1;17316:2;17312:10;17305:22;17358:6;17352:13;17374:75;17440:8;17436:1;17432:2;17428:10;17421:4;17413:6;17409:17;17374:75;:::i;:::-;17509:1;17468:17;;17501:10;;;17494:22;17541:13;;17563:75;17541:13;17625:1;17617:10;;17610:4;17598:17;;17563:75;:::i;:::-;17658:17;17677:1;17654:25;;16347:1338;-1:-1:-1;;;;;;16347:1338:264:o;17815:544::-;17916:2;17911:3;17908:11;17905:448;;;17952:1;17977:5;17973:2;17966:17;18022:4;18018:2;18008:19;18092:2;18080:10;18076:19;18073:1;18069:27;18063:4;18059:38;18128:4;18116:10;18113:20;18110:47;;;-1:-1:-1;18151:4:264;18110:47;18206:2;18201:3;18197:12;18194:1;18190:20;18184:4;18180:31;18170:41;;18261:82;18279:2;18272:5;18269:13;18261:82;;;18324:17;;;18305:1;18294:13;18261:82;;;18265:3;;;17815:544;;;:::o;18535:1348::-;18659:3;18653:10;-1:-1:-1;;;;;18678:6:264;18675:30;18672:56;;;18708:18;;:::i;:::-;18737:96;18826:6;18786:38;18818:4;18812:11;18786:38;:::i;:::-;18780:4;18737:96;:::i;:::-;18888:4;;18952:2;18941:14;;18969:1;18964:662;;;;19670:1;19687:6;19684:89;;;-1:-1:-1;19739:19:264;;;19733:26;19684:89;-1:-1:-1;;18492:1:264;18488:11;;;18484:24;18480:29;18470:40;18516:1;18512:11;;;18467:57;19786:81;;18934:943;;18964:662;17762:1;17755:14;;;17799:4;17786:18;;-1:-1:-1;;19000:20:264;;;19117:236;19131:7;19128:1;19125:14;19117:236;;;19220:19;;;19214:26;19199:42;;19312:27;;;;19280:1;19268:14;;;;19147:19;;19117:236;;;19121:3;19381:6;19372:7;19369:19;19366:201;;;19442:19;;;19436:26;-1:-1:-1;;19525:1:264;19521:14;;;19537:3;19517:24;19513:37;19509:42;19494:58;19479:74;;19366:201;-1:-1:-1;;;;;19613:1:264;19597:14;;;19593:22;19580:36;;-1:-1:-1;18535:1348:264:o;19888:1426::-;20001:3;19995:4;19992:13;19989:26;;20008:5;;19888:1426::o;19989:26::-;20038:37;20070:3;20064:10;20038:37;:::i;:::-;-1:-1:-1;;;;;20090:6:264;20087:30;20084:56;;;20120:18;;:::i;:::-;20149:96;20238:6;20198:38;20230:4;20224:11;20198:38;:::i;20149:96::-;20271:1;20299:2;20291:6;20288:14;20316:1;20311:746;;;;21101:1;21118:6;21115:89;;;-1:-1:-1;21170:19:264;;;21164:26;21115:89;-1:-1:-1;;18492:1:264;18488:11;;;18484:24;18480:29;18470:40;18516:1;18512:11;;;18467:57;21217:81;;20281:1027;;20311:746;17762:1;17755:14;;;17799:4;17786:18;;-1:-1:-1;;20347:20:264;;;17762:1;17755:14;;;17799:4;17786:18;;20509:9;20531:251;20545:7;20542:1;20539:14;20531:251;;;20627:21;;;20621:28;20606:44;;20677:1;20750:18;;;;20705:15;;;;20568:4;20561:12;20531:251;;;20535:3;20810:6;20801:7;20798:19;20795:203;;;20871:21;;20865:28;-1:-1:-1;;20968:3:264;20956:1;20952:14;;;20948:24;20944:37;20940:42;20925:58;20910:74;;;-1:-1:-1;;21044:1:264;21028:14;;;21024:22;21011:36;;-1:-1:-1;19888:1426:264:o;21716:297::-;21834:12;;21881:4;21870:16;;;21864:23;;21834:12;21899:16;;21896:111;;;-1:-1:-1;;21973:4:264;21969:17;;;;21966:1;21962:25;21958:38;21947:50;;21716:297;-1:-1:-1;21716:297:264:o;23919:2800::-;25466:66;25461:3;25454:79;25572:7;25567:3;25563:17;25558:2;25553:3;25549:12;25542:39;25436:3;25610:6;25604:13;25626:73;25692:6;25687:2;25682:3;25678:12;25673:2;25665:6;25661:15;25626:73;:::i;:::-;-1:-1:-1;;;25758:2:264;25718:16;;;25750:11;;;25743:37;25809:66;25804:2;25796:11;;25789:87;-1:-1:-1;;;25900:2:264;25892:11;;25885:41;25951:13;;25973:74;25951:13;26033:2;26025:11;;26020:2;26008:15;;25973:74;:::i;:::-;26066:17;26092:42;26130:2;26122:11;;-1:-1:-1;;;22736:29:264;;22686:81;26092:42;22849:66;26220:2;26212:11;;22837:79;-1:-1:-1;;;22932:12:264;;;22925:58;26156:69;22999:12;;;26174:6;26156:69;:::i;:::-;-1:-1:-1;;;22736:29:264;;26143:82;-1:-1:-1;23099:66:264;26359:1;26348:13;;23087:79;23196:66;23182:12;;;23175:88;26292:71;23279:12;;;26318:44;26310:6;26292:71;:::i;:::-;-1:-1:-1;;;22736:29:264;;26279:84;-1:-1:-1;23379:66:264;26497:1;26486:13;;23367:79;23476:66;23462:12;;;23455:88;26430:71;23559:12;;;26448:6;26430:71;:::i;:::-;-1:-1:-1;;;22736:29:264;;26417:84;-1:-1:-1;23659:66:264;26635:1;26624:13;;23647:79;-1:-1:-1;;;23742:12:264;;;23735:46;26568:71;23797:12;;;26586:6;26568:71;:::i;:::-;-1:-1:-1;;;23878:30:264;;26711:1;26700:13;;;-1:-1:-1;;;;;;;;;23919:2800:264:o;26724:910::-;26999:3;27037:6;27031:13;27053:66;27112:6;27107:3;27100:4;27092:6;27088:17;27053:66;:::i;:::-;27182:13;;27141:16;;;;27204:70;27182:13;27141:16;27251:4;27239:17;;27204:70;:::i;:::-;27341:13;;27296:20;;;27363:70;27341:13;27296:20;27410:4;27398:17;;27363:70;:::i;:::-;27500:13;;27455:20;;;27522:70;27500:13;27455:20;27569:4;27557:17;;27522:70;:::i;:::-;27608:20;;26724:910;-1:-1:-1;;;;;;26724:910:264:o;27717:1986::-;28405:66;28400:3;28393:79;28502:66;28497:2;28492:3;28488:12;28481:88;28599:66;28594:2;28589:3;28585:12;28578:88;28705:20;28700:3;28696:30;28691:2;28686:3;28682:12;28675:52;28375:3;28746;28778:6;28772:13;28794:73;28860:6;28855:2;28850:3;28846:12;28841:2;28833:6;28829:15;28794:73;:::i;:::-;28927:13;;28886:16;;;;28949:74;28927:13;29001:11;;;28996:2;28984:15;;28949:74;:::i;:::-;29084:13;;29042:17;;;29106:74;29084:13;29158:11;;;29153:2;29141:15;;29106:74;:::i;:::-;29241:13;;29199:17;;;29263:74;29241:13;29315:11;;;29310:2;29298:15;;29263:74;:::i;:::-;29398:13;;29356:17;;;29420:74;29398:13;29472:11;;;29467:2;29455:15;;29420:74;:::i;:::-;29516:107;29542:80;29568:53;29617:2;29606:8;29602:2;29598:17;29594:26;29586:6;29568:53;:::i;:::-;29560:6;29542:80;:::i;29516:107::-;29503:120;;;;29632:36;29662:5;-1:-1:-1;;;27689:21:264;;27639:73;29632:36;29695:1;29684:13;;27717:1986;-1:-1:-1;;;;;;;;;;27717:1986:264:o;29708:127::-;29769:10;29764:3;29760:20;29757:1;29750:31;29800:4;29797:1;29790:15;29824:4;29821:1;29814:15;29840:120;29880:1;29906;29896:35;;29911:18;;:::i;:::-;-1:-1:-1;29945:9:264;;29840:120::o;29965:168::-;30038:9;;;30069;;30086:15;;;30080:22;;30066:37;30056:71;;30107:18;;:::i;30138:165::-;30176:1;30210:4;30207:1;30203:12;30234:3;30224:37;;30241:18;;:::i;:::-;30293:3;30286:4;30283:1;30279:12;30275:22;30270:27;;;30138:165;;;;:::o;30308:148::-;30396:4;30375:12;;;30389;;;30371:31;;30414:13;;30411:39;;;30430:18;;:::i;30461:157::-;30491:1;30525:4;30522:1;30518:12;30549:3;30539:37;;30556:18;;:::i;:::-;30608:3;30601:4;30598:1;30594:12;30590:22;30585:27;;;30461:157;;;;:::o;31040:367::-;31157:12;;31205:4;31194:16;;31188:23;-1:-1:-1;;;;;;31274:11:264;;;;31157:12;31188:23;31308:1;31297:13;;31294:107;;;31388:2;31382;31372:6;31369:1;31365:14;31362:1;31358:22;31354:31;31350:2;31346:40;31342:49;31333:58;;31294:107;;;;31040:367;;;:::o;32136:282::-;32174:1;32215;32212;32201:16;32251:1;32248;32237:16;32272:3;32262:37;;32279:18;;:::i;:::-;-1:-1:-1;;32315:28:264;;-1:-1:-1;;32345:15:264;;32311:50;32308:76;;;32364:18;;:::i;:::-;32398:14;;;32136:282;-1:-1:-1;;;32136:282:264:o;32423:216::-;32487:9;;;32515:11;;;32462:3;32545:9;;32573:10;;32569:19;;32598:10;;32590:19;;32566:44;32563:70;;;32613:18;;:::i;:::-;32563:70;;32423:216;;;;:::o;32644:237::-;32716:9;;;32683:7;32741:9;;-1:-1:-1;;;32752:18:264;;32737:34;32734:60;;;32774:18;;:::i;:::-;32847:1;32838:7;32833:16;32830:1;32827:23;32823:1;32816:9;32813:38;32803:72;;32855:18;;:::i;32886:193::-;32925:1;32951;32941:35;;32956:18;;:::i;:::-;-1:-1:-1;;;32992:18:264;;-1:-1:-1;;33012:13:264;;32988:38;32985:64;;;33029:18;;:::i;:::-;-1:-1:-1;33063:10:264;;32886:193::o;33084:200::-;33150:9;;;33123:4;33178:9;;33206:10;;33218:12;;;33202:29;33241:12;;;33233:21;;33199:56;33196:82;;;33258:18;;:::i;33289:112::-;33321:1;33347;33337:35;;33352:18;;:::i;:::-;-1:-1:-1;33386:9:264;;33289:112::o;33406:431::-;-1:-1:-1;;;33663:3:264;33656:16;33638:3;33701:6;33695:13;33717:74;33784:6;33780:1;33775:3;33771:11;33764:4;33756:6;33752:17;33717:74;:::i;:::-;33811:16;;;;33829:1;33807:24;;33406:431;-1:-1:-1;;33406:431:264:o;34186:289::-;34317:3;34355:6;34349:13;34371:66;34430:6;34425:3;34418:4;34410:6;34406:17;34371:66;:::i;:::-;34453:16;;;;;34186:289;-1:-1:-1;;34186:289:264:o;34480:496::-;34659:3;34697:6;34691:13;34713:66;34772:6;34767:3;34760:4;34752:6;34748:17;34713:66;:::i;:::-;34842:13;;34801:16;;;;34864:70;34842:13;34801:16;34911:4;34899:17;;34864:70;:::i;:::-;34950:20;;34480:496;-1:-1:-1;;;;34480:496:264:o;34981:703::-;35208:3;35246:6;35240:13;35262:66;35321:6;35316:3;35309:4;35301:6;35297:17;35262:66;:::i;:::-;35391:13;;35350:16;;;;35413:70;35391:13;35350:16;35460:4;35448:17;;35413:70;:::i;:::-;35550:13;;35505:20;;;35572:70;35550:13;35505:20;35619:4;35607:17;;35572:70;:::i;:::-;35658:20;;34981:703;-1:-1:-1;;;;;34981:703:264:o;35689:1568::-;-1:-1:-1;;;36439:3:264;36432:16;36414:3;36477:6;36471:13;36493:74;36560:6;36556:1;36551:3;36547:11;36540:4;36532:6;36528:17;36493:74;:::i;:::-;-1:-1:-1;;;36626:1:264;36586:16;;;36618:10;;;36611:23;36659:13;;36681:75;36659:13;36743:1;36735:10;;36728:4;36716:17;;36681:75;:::i;:::-;36783:8;36779:2;36775:17;36765:27;;;-1:-1:-1;;;36842:2:264;36838:1;36834:2;36830:10;36823:22;36876:6;36870:13;36892:75;36958:8;36954:1;36950:2;36946:10;36939:4;36931:6;36927:17;36892:75;:::i;:::-;-1:-1:-1;;;37027:1:264;36986:17;;;;37019:10;;;37012:24;37061:13;;37083:75;37061:13;37145:1;37137:10;;37130:4;37118:17;;37083:75;:::i;:::-;37218:1;37177:17;;37210:10;;;37203:22;37249:1;37241:10;;35689:1568;-1:-1:-1;;;;;;35689:1568:264:o;37262:486::-;37514:66;37509:3;37502:79;37484:3;37610:6;37604:13;37626:75;37694:6;37689:2;37684:3;37680:12;37673:4;37665:6;37661:17;37626:75;:::i;:::-;37721:16;;;;37739:2;37717:25;;37262:486;-1:-1:-1;;37262:486:264:o;37753:::-;38005:66;38000:3;37993:79;37975:3;38101:6;38095:13;38117:75;38185:6;38180:2;38175:3;38171:12;38164:4;38156:6;38152:17;38117:75;:::i;:::-;38212:16;;;;38230:2;38208:25;;37753:486;-1:-1:-1;;37753:486:264:o;38244:747::-;38597:66;38592:3;38585:79;38703:22;38698:3;38694:32;38689:2;38684:3;38680:12;38673:54;38567:3;38756:6;38750:13;38772:73;38838:6;38833:2;38828:3;38824:12;38819:2;38811:6;38807:15;38772:73;:::i;:::-;-1:-1:-1;;;38904:2:264;38864:16;;;;38896:11;;;38889:69;-1:-1:-1;38982:2:264;38974:11;;38244:747;-1:-1:-1;38244:747:264:o;38996:751::-;39349:66;39344:3;39337:79;39455:26;39450:3;39446:36;39441:2;39436:3;39432:12;39425:58;39319:3;39512:6;39506:13;39528:73;39594:6;39589:2;39584:3;39580:12;39575:2;39567:6;39563:15;39528:73;:::i;:::-;-1:-1:-1;;;39660:2:264;39620:16;;;;39652:11;;;39645:69;-1:-1:-1;39738:2:264;39730:11;;38996:751;-1:-1:-1;38996:751:264:o;39752:787::-;-1:-1:-1;;;40093:66:264;;40182:13;;40075:3;;40204:75;40182:13;40267:2;40258:12;;40251:4;40239:17;;40204:75;:::i;:::-;40343:66;40338:2;40298:16;;;;40330:11;;;40323:87;-1:-1:-1;40439:66:264;40434:2;40426:11;;40419:87;40530:2;40522:11;;39752:787;-1:-1:-1;39752:787:264:o;40544:727::-;-1:-1:-1;;;40884:33:264;;40940:13;;40866:3;;40962:74;40940:13;41025:1;41016:11;;41009:4;40997:17;;40962:74;:::i;:::-;41099:66;41095:1;41055:16;;;;41087:10;;;41080:86;-1:-1:-1;;;;41190:2:264;41182:11;;41175:63;41262:2;41254:11;;40544:727;-1:-1:-1;40544:727:264:o;41736:1335::-;42107:3;42145:6;42139:13;42171:4;42184:64;42241:6;42236:3;42231:2;42223:6;42219:15;42184:64;:::i;:::-;42311:13;;42270:16;;;;42333:68;42311:13;42270:16;42368:15;;;42333:68;:::i;:::-;42468:13;;42423:20;;;42490:68;42468:13;42423:20;42525:15;;;42490:68;:::i;:::-;42625:13;;42580:20;;;42647:68;42625:13;42580:20;42682:15;;;42647:68;:::i;:::-;42782:13;;42737:20;;;42804:68;42782:13;42737:20;42839:15;;;42804:68;:::i;:::-;42939:13;;42894:20;;;42961:68;42939:13;42894:20;42996:15;;;42961:68;:::i;:::-;43045:20;;;;;41736:1335;-1:-1:-1;;;;;;;;;41736:1335:264:o;43076:486::-;43328:66;43323:3;43316:79;43298:3;43424:6;43418:13;43440:75;43508:6;43503:2;43498:3;43494:12;43487:4;43479:6;43475:17;43440:75;:::i;43567:486::-;43819:66;43814:3;43807:79;43789:3;43915:6;43909:13;43931:75;43999:6;43994:2;43989:3;43985:12;43978:4;43970:6;43966:17;43931:75;:::i;44058:486::-;44310:66;44305:3;44298:79;44280:3;44406:6;44400:13;44422:75;44490:6;44485:2;44480:3;44476:12;44469:4;44461:6;44457:17;44422:75;:::i;44549:486::-;44801:66;44796:3;44789:79;44771:3;44897:6;44891:13;44913:75;44981:6;44976:2;44971:3;44967:12;44960:4;44952:6;44948:17;44913:75;:::i;45040:423::-;-1:-1:-1;;;45286:3:264;45279:19;45261:3;45327:6;45321:13;45343:74;45410:6;45406:1;45401:3;45397:11;45390:4;45382:6;45378:17;45343:74;:::i;:::-;45437:16;;;;45455:1;45433:24;;45040:423;-1:-1:-1;;45040:423:264:o;45817:135::-;45856:3;45877:17;;;45874:43;;45897:18;;:::i;:::-;-1:-1:-1;45944:1:264;45933:13;;45817:135::o;45957:127::-;46018:10;46013:3;46009:20;46006:1;45999:31;46049:4;46046:1;46039:15;46073:4;46070:1;46063:15;46089:136;46128:3;46156:5;46146:39;;46165:18;;:::i;:::-;-1:-1:-1;;;46201:18:264;;46089:136::o;46483:916::-;46932:3;46970:6;46964:13;46986:66;47045:6;47040:3;47033:4;47025:6;47021:17;46986:66;:::i;:::-;-1:-1:-1;;;47074:16:264;;;47099:18;;;-1:-1:-1;;;47144:1:264;47133:13;;47126:35;47186:13;;47208:78;47186:13;47273:1;47262:13;;47255:4;47243:17;;47208:78;:::i;:::-;-1:-1:-1;;;47349:1:264;47305:20;;;;47341:10;;;47334:33;47391:1;47383:10;;46483:916;-1:-1:-1;;;;46483:916:264:o;47404:1540::-;47823:3;47861:6;47855:13;47887:4;47900:64;47957:6;47952:3;47947:2;47939:6;47935:15;47900:64;:::i;:::-;48027:13;;47986:16;;;;48049:68;48027:13;47986:16;48084:15;;;48049:68;:::i;:::-;48184:13;;48139:20;;;48206:68;48184:13;48139:20;48241:15;;;48206:68;:::i;:::-;48341:13;;48296:20;;;48363:68;48341:13;48296:20;48398:15;;;48363:68;:::i;:::-;48498:13;;48453:20;;;48520:68;48498:13;48453:20;48555:15;;;48520:68;:::i;:::-;48655:13;;48610:20;;;48677:68;48655:13;48610:20;48712:15;;;48677:68;:::i;:::-;48812:13;;48767:20;;;48834:68;48812:13;48767:20;48869:15;;;48834:68;:::i;:::-;48918:20;;;;;47404:1540;-1:-1:-1;;;;;;;;;;47404:1540:264:o;48949:441::-;49170:3;49208:6;49202:13;49224:66;49283:6;49278:3;49271:4;49263:6;49259:17;49224:66;:::i;:::-;-1:-1:-1;;;49312:16:264;;49337:18;;;-1:-1:-1;49382:1:264;49371:13;;48949:441;-1:-1:-1;48949:441:264:o;49395:977::-;49802:3;49840:6;49834:13;49856:66;49915:6;49910:3;49903:4;49895:6;49891:17;49856:66;:::i;:::-;49953:6;49948:3;49944:16;49931:29;;-1:-1:-1;;;50005:2:264;49998:5;49991:17;50039:6;50033:13;50055:78;50124:8;50120:1;50113:5;50109:13;50102:4;50094:6;50090:17;50055:78;:::i;:::-;50196:1;50152:20;;50188:10;;;50181:22;50228:13;;50250:75;50228:13;50312:1;50304:10;;50297:4;50285:17;;50250:75;:::i;:::-;50345:17;50364:1;50341:25;;49395:977;-1:-1:-1;;;;;49395:977:264:o;50871:1049::-;51352:66;51347:3;51340:79;51322:3;51448:6;51442:13;51464:75;51532:6;51527:2;51522:3;51518:12;51511:4;51503:6;51499:17;51464:75;:::i;:::-;-1:-1:-1;;;51598:2:264;51558:16;;;51590:11;;;51583:49;51657:13;;51679:76;51657:13;51741:2;51733:11;;51726:4;51714:17;;51679:76;:::i;:::-;51820:66;51815:2;51774:17;;;;51807:11;;;51800:87;51911:2;51903:11;;50871:1049;-1:-1:-1;;;;50871:1049:264:o;51925:977::-;52332:3;52370:6;52364:13;52386:66;52445:6;52440:3;52433:4;52425:6;52421:17;52386:66;:::i;:::-;52483:6;52478:3;52474:16;52461:29;;-1:-1:-1;;;52535:2:264;52528:5;52521:17;52569:6;52563:13;52585:78;52654:8;52650:1;52643:5;52639:13;52632:4;52624:6;52620:17;52585:78;:::i;52907:892::-;-1:-1:-1;;;53381:3:264;53374:16;53356:3;53419:6;53413:13;53435:74;53502:6;53498:1;53493:3;53489:11;53482:4;53474:6;53470:17;53435:74;:::i;:::-;-1:-1:-1;;;53568:1:264;53528:16;;;53560:10;;;53553:23;53601:13;;53623:75;53601:13;53685:1;53677:10;;53670:4;53658:17;;53623:75;:::i;:::-;-1:-1:-1;;;53758:1:264;53717:17;;;;53750:10;;;53743:24;53791:1;53783:10;;52907:892;-1:-1:-1;;;;52907:892:264:o",
    linkReferences: {},
    immutableReferences: {
      "88907": [
        {
          start: 689,
          length: 32
        },
        {
          start: 6081,
          length: 32
        }
      ],
      "93442": [
        {
          start: 6615,
          length: 32
        }
      ],
      "93445": [
        {
          start: 7491,
          length: 32
        },
        {
          start: 8052,
          length: 32
        }
      ]
    }
  },
  methodIdentifiers: {
    "INIT()": "ea643914",
    "PARENT()": "122b83f9",
    "TYPE()": "bb24fe8a",
    "VEECODE()": "d61735ca",
    "allowance(address,address,uint256)": "598af9e7",
    "approve(address,uint256,uint256)": "426a8493",
    "balanceOf(address,uint256)": "00fdd58e",
    "computeId(address,bytes)": "dbad2d9a",
    "decimals(uint256)": "3f47e662",
    "deploy(address,bytes,bool)": "1f54245b",
    "exercise(uint256,uint256)": "a86265bb",
    "exerciseCost(uint256,uint256)": "6aacff4e",
    "getTokenMetadata(uint256)": "60316801",
    "getTokenVestingParams(uint256)": "b2416661",
    "isOperator(address,address)": "b6363cf2",
    "mint(address,address,bytes,uint256,bool)": "e40d88f8",
    "mint(address,uint256,uint256,bool)": "dbf110a7",
    "name(uint256)": "00ad800c",
    "reclaim(uint256)": "2dabbeed",
    "redeem(uint256,uint256)": "7cbc2373",
    "redeemMax(uint256)": "f904eed8",
    "redeemable(address,uint256)": "67627b62",
    "setOperator(address,bool)": "558a7297",
    "supportsInterface(bytes4)": "01ffc9a7",
    "symbol(uint256)": "4e41a1fb",
    "tokenMetadata(uint256)": "6914db60",
    "tokenURI(uint256)": "c87b56dd",
    "totalSupply(uint256)": "bd85b039",
    "transfer(address,uint256,uint256)": "095bcdb6",
    "transferFrom(address,address,uint256,uint256)": "fe99049a",
    "transform(uint256,address,uint256)": "f6e9936a",
    "unwrap(uint256,uint256)": "6e286671",
    "userClaimed(address,uint256)": "fcbf8b24",
    "validate(address,bytes)": "caf92785",
    "wrap(uint256,uint256)": "25ded586"
  },
  rawMetadata: '{"compiler":{"version":"0.8.19+commit.7dd6d404"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"address","name":"parent_","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"BrokenInvariant","type":"error"},{"inputs":[],"name":"Derivative_NotImplemented","type":"error"},{"inputs":[],"name":"InsufficientBalance","type":"error"},{"inputs":[],"name":"InvalidParams","type":"error"},{"inputs":[{"internalType":"address","name":"parent_","type":"address"}],"name":"Module_InvalidParent","type":"error"},{"inputs":[],"name":"Module_OnlyInternal","type":"error"},{"inputs":[{"internalType":"address","name":"caller_","type":"address"}],"name":"Module_OnlyParent","type":"error"},{"inputs":[],"name":"NotPermitted","type":"error"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"length","type":"uint256"}],"name":"StringsInsufficientHexLength","type":"error"},{"inputs":[{"internalType":"address","name":"token_","type":"address"}],"name":"UnsupportedToken","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint48","name":"start","type":"uint48"},{"indexed":false,"internalType":"uint48","name":"expiry","type":"uint48"},{"indexed":false,"internalType":"address","name":"baseToken","type":"address"}],"name":"DerivativeCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"OperatorSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Redeemed","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"caller","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"address","name":"wrappedToken","type":"address"}],"name":"Unwrapped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"address","name":"wrappedToken","type":"address"}],"name":"Wrapped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"address","name":"wrappedToken","type":"address"}],"name":"WrappedDerivativeCreated","type":"event"},{"inputs":[],"name":"INIT","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"PARENT","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TYPE","outputs":[{"internalType":"enum Module.Type","name":"","type":"uint8"}],"stateMutability":"pure","type":"function"},{"inputs":[],"name":"VEECODE","outputs":[{"internalType":"Veecode","name":"","type":"bytes7"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"underlyingToken_","type":"address"},{"internalType":"bytes","name":"params_","type":"bytes"}],"name":"computeId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"underlyingToken_","type":"address"},{"internalType":"bytes","name":"params_","type":"bytes"},{"internalType":"bool","name":"wrapped_","type":"bool"}],"name":"deploy","outputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"},{"internalType":"address","name":"wrappedAddress_","type":"address"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"exercise","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"exerciseCost","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getTokenMetadata","outputs":[{"components":[{"internalType":"bool","name":"exists","type":"bool"},{"internalType":"address","name":"wrapped","type":"address"},{"internalType":"address","name":"underlyingToken","type":"address"},{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"internalType":"struct IDerivative.Token","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"getTokenVestingParams","outputs":[{"components":[{"internalType":"uint48","name":"start","type":"uint48"},{"internalType":"uint48","name":"expiry","type":"uint48"}],"internalType":"struct ILinearVesting.VestingParams","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"isOperator","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to_","type":"address"},{"internalType":"uint256","name":"tokenId_","type":"uint256"},{"internalType":"uint256","name":"amount_","type":"uint256"},{"internalType":"bool","name":"wrapped_","type":"bool"}],"name":"mint","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to_","type":"address"},{"internalType":"address","name":"underlyingToken_","type":"address"},{"internalType":"bytes","name":"params_","type":"bytes"},{"internalType":"uint256","name":"amount_","type":"uint256"},{"internalType":"bool","name":"wrapped_","type":"bool"}],"name":"mint","outputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"},{"internalType":"address","name":"wrappedAddress_","type":"address"},{"internalType":"uint256","name":"amountCreated_","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"reclaim","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"redeem","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"redeemMax","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner_","type":"address"},{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"redeemable","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setOperator","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenMetadata","outputs":[{"internalType":"bool","name":"exists","type":"bool"},{"internalType":"address","name":"wrapped","type":"address"},{"internalType":"address","name":"underlyingToken","type":"address"},{"internalType":"uint256","name":"supply","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"transform","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"unwrap","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner_","type":"address"},{"internalType":"uint256","name":"tokenId_","type":"uint256"}],"name":"userClaimed","outputs":[{"internalType":"uint256","name":"claimed_","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"underlyingToken_","type":"address"},{"internalType":"bytes","name":"params_","type":"bytes"}],"name":"validate","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId_","type":"uint256"},{"internalType":"uint256","name":"amount_","type":"uint256"}],"name":"wrap","outputs":[],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"author":"Axis Finance","details":"This module allows for the creation of linearly vesting tokens, where the vesting             period is defined by a start and expiry timestamp. The tokens can be wrapped and             unwrapped, and the underlying tokens can be redeemed once vested.             The start timestamp enables vesting tokens to have a cliff, after which vesting commences.","errors":{"StringsInsufficientHexLength(uint256,uint256)":[{"details":"The `value` string doesn\'t fit in the specified `length`."}]},"kind":"dev","methods":{"INIT()":{"details":"This function is called when the module is installed or upgraded by the module.MUST BE GATED BY onlyParent. Used to encompass any initialization or upgrade logic."},"TYPE()":{"details":"This enables the parent contract to check that the module Keycode specifiedis of the correct type"},"approve(address,uint256,uint256)":{"details":"Vesting tokens are soulbound/not transferable"},"computeId(address,bytes)":{"params":{"params_":"The abi-encoded `VestingParams` for the derivative token"},"returns":{"_0":"            The unique token ID"}},"decimals(uint256)":{"details":"This function reverts if:             - The token ID does not exist","params":{"tokenId_":"The ID of the token"},"returns":{"_0":"uint8       The number of decimals used by the token"}},"deploy(address,bytes,bool)":{"details":"This function performs the following:             - Validates the parameters             - Deploys the derivative token if it does not already exist             This function reverts if:             - The parameters are in an invalid format             - The parameters fail validation","params":{"params_":"ABI-encoded parameters for the derivative to be created","underlyingToken_":"The address of the underlying token","wrapped_":"Whether (true) or not (false) the derivative should be wrapped in an ERC20 token for composability"},"returns":{"tokenId_":"           The ID of the newly created derivative token","wrappedAddress_":"    The address of the ERC20 wrapped derivative token, if wrapped_ is true, otherwise, it\'s the zero address."}},"exercise(uint256,uint256)":{"details":"Not implemented","params":{"amount":"The amount of derivative tokens to exercise","tokenId_":"The ID of the derivative token to exercise"}},"exerciseCost(uint256,uint256)":{"details":"Not implemented","params":{"amount":"The amount of derivative tokens to exercise","tokenId_":"The ID of the derivative token to exercise"},"returns":{"_0":"       The cost to exercise the derivative token"}},"getTokenMetadata(uint256)":{"params":{"tokenId":"The ID of the derivative token"},"returns":{"_0":"  The metadata for the derivative token"}},"getTokenVestingParams(uint256)":{"params":{"tokenId":"The ID of the derivative token"},"returns":{"_0":"  The vesting parameters"}},"mint(address,address,bytes,uint256,bool)":{"details":"This function performs the following:             - Validates the parameters             - Deploys the derivative token if it does not already exist             - Mints the derivative token to the recipient             This function reverts if:             - The parameters are in an invalid format             - The parameters fail validation             - `amount_` is 0             A derivative token can be minted after vesting expiry, which prevents mitigates problems with auctions that settle late.","params":{"amount_":"The amount of derivative tokens to create","params_":"ABI-encoded parameters for the derivative to be created","to_":"The address to mint the derivative tokens to","underlyingToken_":"The address of the underlying token","wrapped_":"Whether (true) or not (false) the derivative should be wrapped in an ERC20 token for composability"},"returns":{"amountCreated_":"     The amount of derivative tokens created","tokenId_":"           The ID of the newly created derivative token","wrappedAddress_":"    The address of the ERC20 wrapped derivative token, if wrapped_ is true, otherwise, it\'s the zero address."}},"mint(address,uint256,uint256,bool)":{"details":"This function performs the following:             - Mints the derivative token to the recipient             This function reverts if:             - `tokenId_` does not exist             - The amount to mint is 0             A derivative token can be minted after vesting expiry, which prevents mitigates problems with auctions that settle late.","params":{"amount_":"The amount of derivative tokens to create","to_":"The address to mint the derivative tokens to","tokenId_":"The ID of the derivative token","wrapped_":"Whether (true) or not (false) the derivative should be wrapped in an ERC20 token for composability"},"returns":{"_0":"tokenId_            The ID of the derivative token","_1":"wrappedAddress_     The address of the ERC20 wrapped derivative token, if wrapped_ is true, otherwise, it\'s the zero address.","_2":"amountCreated_      The amount of derivative tokens created"}},"name(uint256)":{"details":"This function reverts if:             - The token ID does not exist","params":{"tokenId_":"The ID of the token"},"returns":{"_0":"string      The name of the token"}},"reclaim(uint256)":{"details":"Not implemented","params":{"tokenId_":"The ID of the derivative token to reclaim"}},"redeem(uint256,uint256)":{"details":"This function reverts if:             - `amount_` is 0             - The redeemable amount is less than `amount_`             - The derivative token with `tokenId_` has not been deployed","params":{"amount_":"The amount of derivative tokens to redeem","tokenId_":"The ID of the derivative token to redeem"}},"redeemMax(uint256)":{"params":{"tokenId_":"The ID of the derivative token to redeem"}},"redeemable(address,uint256)":{"details":"The redeemable amount is computed as:             - The amount of tokens that have vested               - x: number of vestable tokens               - t: current timestamp               - s: start timestamp               - T: expiry timestamp               - Vested = x * (t - s) / (T - s)             - Minus the amount of tokens that have already been redeemed","params":{"owner_":"The owner of the derivative token","tokenId_":"The ID of the derivative token"},"returns":{"_0":"     The amount of redeemable tokens"}},"symbol(uint256)":{"details":"This function reverts if:             - The token ID does not exist","params":{"tokenId_":"The ID of the token"},"returns":{"_0":"string      The symbol of the token"}},"tokenURI(uint256)":{"details":"This function reverts if:             - The token ID does not exist","params":{"tokenId_":"The ID of the token"},"returns":{"_0":"string      The URI of the token"}},"totalSupply(uint256)":{"params":{"tokenId_":"The ID of the token"},"returns":{"_0":"uint256     The total supply of the token"}},"transfer(address,uint256,uint256)":{"details":"Vesting tokens are soulbound/not transferable"},"transferFrom(address,address,uint256,uint256)":{"details":"Vesting tokens are soulbound/not transferable"},"transform(uint256,address,uint256)":{"details":"Not implemented","params":{"amount_":"The amount of derivative tokens to transform","from_":"The address of the owner of the derivative token","tokenId_":"The ID of the derivative token to transform"}},"unwrap(uint256,uint256)":{"details":"This function will revert if:             - The derivative token with `tokenId_` has not been deployed             - A wrapped derivative for `tokenId_` has not been deployed             - `amount_` is 0","params":{"amount_":"The amount of derivative tokens to unwrap","tokenId_":"The ID of the derivative token to unwrap"}},"validate(address,bytes)":{"params":{"params_":"The abi-encoded `VestingParams` for the derivative token"},"returns":{"_0":"            Whether or not the params are valid"}},"wrap(uint256,uint256)":{"details":"This function will revert if:             - The derivative token with `tokenId_` has not been deployed             - `amount_` is 0","params":{"amount_":"The amount of derivative tokens to wrap","tokenId_":"The ID of the derivative token to wrap"}}},"title":"LinearVesting","version":1},"userdoc":{"errors":{"Module_InvalidParent(address)":[{"notice":"Error when the parent contract is invalid"}],"Module_OnlyInternal()":[{"notice":"Error when a module function is called by a non-internal contract"}],"Module_OnlyParent(address)":[{"notice":"Error when a module function is called by a non-parent contract"}]},"kind":"user","methods":{"INIT()":{"notice":"Initialization function for the module"},"PARENT()":{"notice":"The parent contract for this module."},"TYPE()":{"notice":"2 byte identifier for the module type"},"VEECODE()":{"notice":"7 byte, versioned identifier for the module. 2 characters from 0-9 that signify the version and 3-5 characters from A-Z."},"computeId(address,bytes)":{"notice":"Compute a unique token ID, given the parameters for the derivative"},"decimals(uint256)":{"notice":"Returns the number of decimals used by the token"},"deploy(address,bytes,bool)":{"notice":"Deploy a new derivative token. Optionally, deploys an ERC20 wrapper for composability."},"exercise(uint256,uint256)":{"notice":"Exercise a conversion of the derivative token per the specific implementation logic"},"exerciseCost(uint256,uint256)":{"notice":"Determines the cost to exercise a derivative token in the quoted token"},"getTokenMetadata(uint256)":{"notice":"Get the metadata for a derivative token"},"getTokenVestingParams(uint256)":{"notice":"Get the vesting parameters for a derivative token"},"mint(address,address,bytes,uint256,bool)":{"notice":"Mint new derivative tokens.Deploys the derivative token if it does not already exist.The module is expected to transfer the collateral token to itself."},"mint(address,uint256,uint256,bool)":{"notice":"Mint new derivative tokens for a specific token ID"},"name(uint256)":{"notice":"Returns the name of the token"},"reclaim(uint256)":{"notice":"Reclaim posted collateral for a derivative token which can no longer be exercisedAccess controlled: only callable by the derivative issuer via the auction house."},"redeem(uint256,uint256)":{"notice":"Redeem derivative tokens for underlying collateral"},"redeemMax(uint256)":{"notice":"Redeem all available derivative tokens for underlying collateral"},"redeemable(address,uint256)":{"notice":"Determines the amount of redeemable tokens for a given derivative token"},"symbol(uint256)":{"notice":"Returns the symbol of the token"},"tokenMetadata(uint256)":{"notice":"The metadata for a derivative token"},"tokenURI(uint256)":{"notice":"Returns the URI of the token"},"totalSupply(uint256)":{"notice":"Returns the total supply of the token"},"transform(uint256,address,uint256)":{"notice":"Transforms an existing derivative issued by this contract into something else. Derivative is burned and collateral sent to the auction house.Access controlled: only callable by the auction house."},"unwrap(uint256,uint256)":{"notice":"Unwrap an ERC20 derivative token into the underlying ERC6909 derivative"},"userClaimed(address,uint256)":{"notice":"Stores the amount that a user has claimed"},"validate(address,bytes)":{"notice":"Validate derivative params for the specific implementation             The parameters should be the same as what is passed into `deploy()` or `mint()`"},"wrap(uint256,uint256)":{"notice":"Wrap an existing derivative into an ERC20 token for composability             Deploys the ERC20 wrapper if it does not already exist"}},"notice":"A derivative module that allows for the creation of linearly vesting tokens","version":1}},"settings":{"compilationTarget":{"src/modules/derivatives/LinearVesting.sol":"LinearVesting"},"evmVersion":"paris","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":200},"remappings":[":@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",":@prb/test/=lib/prb-math/node_modules/@prb/test/",":@uniswap/v3-core/=lib/uniswap-v3-core/",":ds-test/=lib/forge-std/lib/ds-test/src/",":erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",":forge-std/=lib/forge-std/src/",":g-uni-v1-core/=lib/g-uni-v1-core/contracts/",":openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/",":prb-math/=lib/prb-math/src/",":solady/=lib/solady/src/",":solmate/=lib/solmate/src/",":uniswap-v2-core/=lib/uniswap-v2-core/contracts/",":uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",":uniswap-v3-core/=lib/uniswap-v3-core/contracts/",":uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"]},"sources":{"lib/openzeppelin-contracts/contracts/utils/Base64.sol":{"keccak256":"0xb05381393476339e1117800c4d3a6cba08674b1a5e6cdd7c1e45c2391b7023e6","license":"MIT","urls":["bzz-raw://ae2e81acb0eecf4460dfb88a5a5cb830bfb995c2976531d56f50c0db538d7047","dweb:/ipfs/QmT3ZQAmRwHu7DRP9FYd9UAJP6PMJRojn5zgaeD9iuYr1B"]},"lib/openzeppelin-contracts/contracts/utils/Strings.sol":{"keccak256":"0x31f34a3baec77c087d2bdbc5c277f169e505b905aeb43cfcea1734175140f621","license":"MIT","urls":["bzz-raw://b5a3bc8093b31b685ef879e8ffaaab614594cb6f98ddac4f18c411f7bbf99d0d","dweb:/ipfs/QmSFfA9pH3xo8hnWKCFKTwGi8kz68YXuAwyLXsYe6KjC3Z"]},"lib/openzeppelin-contracts/contracts/utils/math/Math.sol":{"keccak256":"0xdb6d7e26320438bdd421598eb64e6fe2b03867a4dd07c9c820994b7bec26f7b0","license":"MIT","urls":["bzz-raw://2adf1566393ddf260fb2064dd0c67be00123b8978be8b62cc45ac97aff859949","dweb:/ipfs/QmaDLzQpnitEJDAJo4squpKumr5x4D2QYetPdT3jZd8hYm"]},"lib/openzeppelin-contracts/contracts/utils/math/SignedMath.sol":{"keccak256":"0x63a4fc7046bc052edeec923181f2f886681e1e0b34c4f23ce84425acfe80a1fb","license":"MIT","urls":["bzz-raw://9cee5cb5fa0dc7d47c463f900b5fcd44abe84f6bce23433898af1221598a3a9b","dweb:/ipfs/Qmdjp7Pf6RuGgAnSxUKd9CvniN8gUG6wLH1cdvhg5L9w4z"]},"lib/solmate/src/auth/Owned.sol":{"keccak256":"0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea","license":"AGPL-3.0-only","urls":["bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4","dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"]},"lib/solmate/src/tokens/ERC20.sol":{"keccak256":"0xcdfd8db76b2a3415620e4d18cc5545f3d50de792dbf2c3dd5adb40cbe6f94b10","license":"AGPL-3.0-only","urls":["bzz-raw://57b3ab70cde374af1cf2c9888636e8de6cf660f087b1c9abd805e9271e19fa35","dweb:/ipfs/QmNrLDBAHYFjpjSd12jerm1AdBkDqEYUUaXgnT854BUZ97"]},"lib/solmate/src/tokens/ERC6909.sol":{"keccak256":"0x767ed60e11d739ed7eb9e10467eb0e0573293238b7a2a56f96b23f145297f1d2","license":"MIT","urls":["bzz-raw://e5bc9f48d84ecc46f2627b2a91948f8060f78d2f548a6c5ca1f282f8778e01e0","dweb:/ipfs/QmeATtgjaDVhxcCs6auJrC8nqCwUqntTi3WygHVRa9xg6M"]},"lib/solmate/src/utils/FixedPointMathLib.sol":{"keccak256":"0x1b62af9baf5b8e991ed7531bc87f45550ba9d61e8dbff5caf237ccaf3a3fd843","license":"AGPL-3.0-only","urls":["bzz-raw://b7b38b977c5305b18ceefbeed4c9ceaaaefa419b520de62de6604ea661f8c0a9","dweb:/ipfs/QmecMRzgfMyDVa2pvBqMMDLYBappaj7Aa3qcMoQYEQrhWi"]},"lib/solmate/src/utils/SafeTransferLib.sol":{"keccak256":"0x6ab948013c2c7ca6351e593600425b0ec6df9035320280c678e735bce16e996b","license":"AGPL-3.0-only","urls":["bzz-raw://2ab977d0eeb2bf458f9798250215c646d2f3b1f90b5a7e2b506fdf3335c0f060","dweb:/ipfs/QmYPRoPhNtBAmCSq7imN1scMVpKNQvMTpoqab3tXUx5Tnv"]},"src/interfaces/modules/IDerivative.sol":{"keccak256":"0x953a79012815f4b3315303720b1758d3b6f3666174d5259849609bb1c11f948f","license":"AGPL-3.0-or-later","urls":["bzz-raw://1abc79c0a872cfb4eaf7cadf5794fd509aa401a86fd27bc4c78084f125164daf","dweb:/ipfs/QmSd58DqwwjnXehKFu9DLUFToTVHmWNWstnEMSZ1EX96Yd"]},"src/interfaces/modules/derivatives/ILinearVesting.sol":{"keccak256":"0x4786c481106dd2cb1777bb935ecedc8180b62ed4048f6f6952daf9b5641520ff","license":"AGPL-3.0-or-later","urls":["bzz-raw://ee03aac28046689e32b3e4905a721d6c5261efce6cd8194b13396c1f9650d6e4","dweb:/ipfs/QmSqJjZqU7vLpuzKxZrpUQj9ybh5uaBFxfCZ39ewkQqwV8"]},"src/lib/ERC6909Metadata.sol":{"keccak256":"0x45cbf0d8d04f5628d34d7eb4bb5e13b7664b1ae03456f2ca2d2eb259d199f9e6","license":"UNLICENSED","urls":["bzz-raw://f7cfbc4fd542200d756f16457917157d838df10aa5f253f205d33a865ca6b0e6","dweb:/ipfs/QmTrgxTzer1yuvy4VoRkyMBtgigfq9kHU6xNHfy9J5Du11"]},"src/lib/SVG.sol":{"keccak256":"0x9ebbe6e5a83b118af5fdffc65cdbb646a1b444a27036e53e51541589a2d6c3d7","license":"MIT","urls":["bzz-raw://eaea614b412634e83a9a0727bb3a4015de27779ab90611aed9be7eacbbacc495","dweb:/ipfs/QmbU6FrCk9rh27JLBF7orNAhD5X5gJzjfH3NkdorPUgABx"]},"src/lib/Timestamp.sol":{"keccak256":"0x8698230543af14affc4b58fb64aabed2116c1c8a41ac94309e2ec0241f0fb129","license":"MIT","urls":["bzz-raw://5c1a9cee00e32f1b66518e686890fa39969155a8738236bc91eb2f6151bb2b99","dweb:/ipfs/QmXiq4CVSHddc9c49gdqxAD23XqXeA5eqGbCqFHsuwdjXT"]},"src/lib/Uint2Str.sol":{"keccak256":"0xd5bed46248c82664844898fee717cf46ac94df59f7dc67c8db626ef666e7ce52","license":"UNLICENSED","urls":["bzz-raw://56ff374909e3030e11301a6fd3c16a893e85a0fd3ffa042ee877b850336a8b0f","dweb:/ipfs/QmewNgdjU2EzjdgtRii9MENC43J9P33DpBkqznpHNFrF1W"]},"src/lib/clones/Clone.sol":{"keccak256":"0x56f39ad54b1d26569bd281a4da2fa0deb54bad7cf05f5bfacb488cd050c9027e","license":"BSD","urls":["bzz-raw://bb9530726000c21fd93b42412cd528dfc37f0270966362a672b486bf43e41368","dweb:/ipfs/QmWrL3YjSzXMBFFW7o5d22HZrxk25sdru7XowLoqukZN3M"]},"src/lib/clones/CloneERC20.sol":{"keccak256":"0xbd7e0d8863ad7c758ac5b8940ad1fb52bfa75d54ad5e23726db6fa2717811bc7","license":"BSD","urls":["bzz-raw://3de09440ec47fc9f80297fc21beb4264858ed66451302046a486e59b0a9c29c8","dweb:/ipfs/QmfJQ14a59gf8sah6tfuHeKAUKX4eECd9ktdGwuW7x7hVX"]},"src/lib/clones/ClonesWithImmutableArgs.sol":{"keccak256":"0x19e9432ce100392e198e8cf8ad985add8441028b8be9704b66de64da052bd79d","license":"BSD","urls":["bzz-raw://fb89861ef99a1f89a25498aa648d73c3f694f5c18dc92e8e93dffdf454a9a04e","dweb:/ipfs/QmV6T5Fj6WUNHFSAqDPkvdXRRoQv76LpeigbGY6r2Hzxn8"]},"src/modules/Derivative.sol":{"keccak256":"0x35e7d822254ccf75e0216b8783dfd8c9a431eaa40a90c1254635f161646573e0","license":"BSL-1.1","urls":["bzz-raw://83e5ac5f6f4c0e339841cefc19fc2aec65951dd1b8a3000819d8d9a344964f58","dweb:/ipfs/QmRW2xsdfc8zHvr2XWXK5n2rxnpqYxD9rBwJ9eLWWSrYMP"]},"src/modules/Keycode.sol":{"keccak256":"0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e","license":"AGPL-3.0-or-later","urls":["bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd","dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"]},"src/modules/Modules.sol":{"keccak256":"0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689","license":"AGPL-3.0-or-later","urls":["bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee","dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"]},"src/modules/derivatives/LinearVesting.sol":{"keccak256":"0xbf198f3928f8151f8a876069129822b7cd9da93d933faf12b006ecdc4f31df8d","license":"BSL-1.1","urls":["bzz-raw://bd723cb82a9d7d07d5874f4f0e52d2b1a8844e778b366d64d7c99dcf46a4d086","dweb:/ipfs/QmbzKMPXXBTo8zuRWJ55oFbanGPExacvkVVm3T9ELDdGbE"]},"src/modules/derivatives/LinearVestingCard.sol":{"keccak256":"0x91a3c829f911b0173da7b968953222224ad17b5a07dd95b54b5ebfd41625f266","license":"BSL-1.1","urls":["bzz-raw://6100c9f1f11748695d5e660ccd1470588e199289ddef7029a86d962f99a73491","dweb:/ipfs/QmYcHf299r34cbMvrSbcztb4XUYyxiSk6jqTsn1VYsVHMX"]},"src/modules/derivatives/SoulboundCloneERC20.sol":{"keccak256":"0x4d7fe1d97c69ee3b098b156c5aae174fa1543e234230a7b5d0537594b27046f0","license":"BSL-1.1","urls":["bzz-raw://d635de27ea6c5aa6de0dd41b6c005d6259cbe4ac4e5dca3e589fad4a42da4a36","dweb:/ipfs/QmdtwdodoKQS3eRuaVwHqAKppV5Y9nQ2e6pEbycVRDmUVo"]}},"version":1}',
  metadata: {
    compiler: {
      version: "0.8.19+commit.7dd6d404"
    },
    language: "Solidity",
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: "address",
              name: "parent_",
              type: "address"
            }
          ],
          stateMutability: "nonpayable",
          type: "constructor"
        },
        {
          inputs: [],
          type: "error",
          name: "BrokenInvariant"
        },
        {
          inputs: [],
          type: "error",
          name: "Derivative_NotImplemented"
        },
        {
          inputs: [],
          type: "error",
          name: "InsufficientBalance"
        },
        {
          inputs: [],
          type: "error",
          name: "InvalidParams"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "parent_",
              type: "address"
            }
          ],
          type: "error",
          name: "Module_InvalidParent"
        },
        {
          inputs: [],
          type: "error",
          name: "Module_OnlyInternal"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller_",
              type: "address"
            }
          ],
          type: "error",
          name: "Module_OnlyParent"
        },
        {
          inputs: [],
          type: "error",
          name: "NotPermitted"
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "value",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "length",
              type: "uint256"
            }
          ],
          type: "error",
          name: "StringsInsufficientHexLength"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "token_",
              type: "address"
            }
          ],
          type: "error",
          name: "UnsupportedToken"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "owner",
              type: "address",
              indexed: true
            },
            {
              internalType: "address",
              name: "spender",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "id",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            }
          ],
          type: "event",
          name: "Approval",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "uint48",
              name: "start",
              type: "uint48",
              indexed: false
            },
            {
              internalType: "uint48",
              name: "expiry",
              type: "uint48",
              indexed: false
            },
            {
              internalType: "address",
              name: "baseToken",
              type: "address",
              indexed: false
            }
          ],
          type: "event",
          name: "DerivativeCreated",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "owner",
              type: "address",
              indexed: true
            },
            {
              internalType: "address",
              name: "operator",
              type: "address",
              indexed: true
            },
            {
              internalType: "bool",
              name: "approved",
              type: "bool",
              indexed: false
            }
          ],
          type: "event",
          name: "OperatorSet",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "address",
              name: "owner",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            }
          ],
          type: "event",
          name: "Redeemed",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "caller",
              type: "address",
              indexed: false
            },
            {
              internalType: "address",
              name: "from",
              type: "address",
              indexed: true
            },
            {
              internalType: "address",
              name: "to",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "id",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            }
          ],
          type: "event",
          name: "Transfer",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "address",
              name: "owner",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            },
            {
              internalType: "address",
              name: "wrappedToken",
              type: "address",
              indexed: false
            }
          ],
          type: "event",
          name: "Unwrapped",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "address",
              name: "owner",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            },
            {
              internalType: "address",
              name: "wrappedToken",
              type: "address",
              indexed: false
            }
          ],
          type: "event",
          name: "Wrapped",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256",
              indexed: true
            },
            {
              internalType: "address",
              name: "wrappedToken",
              type: "address",
              indexed: false
            }
          ],
          type: "event",
          name: "WrappedDerivativeCreated",
          anonymous: false
        },
        {
          inputs: [],
          stateMutability: "nonpayable",
          type: "function",
          name: "INIT"
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "PARENT",
          outputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "TYPE",
          outputs: [
            {
              internalType: "enum Module.Type",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "pure",
          type: "function",
          name: "VEECODE",
          outputs: [
            {
              internalType: "Veecode",
              name: "",
              type: "bytes7"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "allowance",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "approve",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "underlyingToken_",
              type: "address"
            },
            {
              internalType: "bytes",
              name: "params_",
              type: "bytes"
            }
          ],
          stateMutability: "pure",
          type: "function",
          name: "computeId",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "decimals",
          outputs: [
            {
              internalType: "uint8",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "underlyingToken_",
              type: "address"
            },
            {
              internalType: "bytes",
              name: "params_",
              type: "bytes"
            },
            {
              internalType: "bool",
              name: "wrapped_",
              type: "bool"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "deploy",
          outputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            },
            {
              internalType: "address",
              name: "wrappedAddress_",
              type: "address"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "exercise"
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "exerciseCost",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getTokenMetadata",
          outputs: [
            {
              internalType: "struct IDerivative.Token",
              name: "",
              type: "tuple",
              components: [
                {
                  internalType: "bool",
                  name: "exists",
                  type: "bool"
                },
                {
                  internalType: "address",
                  name: "wrapped",
                  type: "address"
                },
                {
                  internalType: "address",
                  name: "underlyingToken",
                  type: "address"
                },
                {
                  internalType: "uint256",
                  name: "supply",
                  type: "uint256"
                },
                {
                  internalType: "bytes",
                  name: "data",
                  type: "bytes"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "getTokenVestingParams",
          outputs: [
            {
              internalType: "struct ILinearVesting.VestingParams",
              name: "",
              type: "tuple",
              components: [
                {
                  internalType: "uint48",
                  name: "start",
                  type: "uint48"
                },
                {
                  internalType: "uint48",
                  name: "expiry",
                  type: "uint48"
                }
              ]
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "isOperator",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "to_",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            },
            {
              internalType: "bool",
              name: "wrapped_",
              type: "bool"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "mint",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "to_",
              type: "address"
            },
            {
              internalType: "address",
              name: "underlyingToken_",
              type: "address"
            },
            {
              internalType: "bytes",
              name: "params_",
              type: "bytes"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            },
            {
              internalType: "bool",
              name: "wrapped_",
              type: "bool"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "mint",
          outputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            },
            {
              internalType: "address",
              name: "wrappedAddress_",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amountCreated_",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "name",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "reclaim"
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "redeem"
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "redeemMax"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "owner_",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "redeemable",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "operator",
              type: "address"
            },
            {
              internalType: "bool",
              name: "approved",
              type: "bool"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "setOperator",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "bytes4",
              name: "interfaceId",
              type: "bytes4"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "supportsInterface",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "symbol",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "tokenMetadata",
          outputs: [
            {
              internalType: "bool",
              name: "exists",
              type: "bool"
            },
            {
              internalType: "address",
              name: "wrapped",
              type: "address"
            },
            {
              internalType: "address",
              name: "underlyingToken",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "supply",
              type: "uint256"
            },
            {
              internalType: "bytes",
              name: "data",
              type: "bytes"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "tokenURI",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "totalSupply",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "transfer",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "transferFrom",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "transform"
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "unwrap"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "owner_",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "userClaimed",
          outputs: [
            {
              internalType: "uint256",
              name: "claimed_",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "underlyingToken_",
              type: "address"
            },
            {
              internalType: "bytes",
              name: "params_",
              type: "bytes"
            }
          ],
          stateMutability: "pure",
          type: "function",
          name: "validate",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "uint256",
              name: "tokenId_",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "amount_",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "wrap"
        }
      ],
      devdoc: {
        kind: "dev",
        methods: {
          "INIT()": {
            details: "This function is called when the module is installed or upgraded by the module.MUST BE GATED BY onlyParent. Used to encompass any initialization or upgrade logic."
          },
          "TYPE()": {
            details: "This enables the parent contract to check that the module Keycode specifiedis of the correct type"
          },
          "approve(address,uint256,uint256)": {
            details: "Vesting tokens are soulbound/not transferable"
          },
          "computeId(address,bytes)": {
            params: {
              params_: "The abi-encoded `VestingParams` for the derivative token"
            },
            returns: {
              _0: "            The unique token ID"
            }
          },
          "decimals(uint256)": {
            details: "This function reverts if:             - The token ID does not exist",
            params: {
              tokenId_: "The ID of the token"
            },
            returns: {
              _0: "uint8       The number of decimals used by the token"
            }
          },
          "deploy(address,bytes,bool)": {
            details: "This function performs the following:             - Validates the parameters             - Deploys the derivative token if it does not already exist             This function reverts if:             - The parameters are in an invalid format             - The parameters fail validation",
            params: {
              params_: "ABI-encoded parameters for the derivative to be created",
              underlyingToken_: "The address of the underlying token",
              wrapped_: "Whether (true) or not (false) the derivative should be wrapped in an ERC20 token for composability"
            },
            returns: {
              tokenId_: "           The ID of the newly created derivative token",
              wrappedAddress_: "    The address of the ERC20 wrapped derivative token, if wrapped_ is true, otherwise, it's the zero address."
            }
          },
          "exercise(uint256,uint256)": {
            details: "Not implemented",
            params: {
              amount: "The amount of derivative tokens to exercise",
              tokenId_: "The ID of the derivative token to exercise"
            }
          },
          "exerciseCost(uint256,uint256)": {
            details: "Not implemented",
            params: {
              amount: "The amount of derivative tokens to exercise",
              tokenId_: "The ID of the derivative token to exercise"
            },
            returns: {
              _0: "       The cost to exercise the derivative token"
            }
          },
          "getTokenMetadata(uint256)": {
            params: {
              tokenId: "The ID of the derivative token"
            },
            returns: {
              _0: "  The metadata for the derivative token"
            }
          },
          "getTokenVestingParams(uint256)": {
            params: {
              tokenId: "The ID of the derivative token"
            },
            returns: {
              _0: "  The vesting parameters"
            }
          },
          "mint(address,address,bytes,uint256,bool)": {
            details: "This function performs the following:             - Validates the parameters             - Deploys the derivative token if it does not already exist             - Mints the derivative token to the recipient             This function reverts if:             - The parameters are in an invalid format             - The parameters fail validation             - `amount_` is 0             A derivative token can be minted after vesting expiry, which prevents mitigates problems with auctions that settle late.",
            params: {
              amount_: "The amount of derivative tokens to create",
              params_: "ABI-encoded parameters for the derivative to be created",
              to_: "The address to mint the derivative tokens to",
              underlyingToken_: "The address of the underlying token",
              wrapped_: "Whether (true) or not (false) the derivative should be wrapped in an ERC20 token for composability"
            },
            returns: {
              amountCreated_: "     The amount of derivative tokens created",
              tokenId_: "           The ID of the newly created derivative token",
              wrappedAddress_: "    The address of the ERC20 wrapped derivative token, if wrapped_ is true, otherwise, it's the zero address."
            }
          },
          "mint(address,uint256,uint256,bool)": {
            details: "This function performs the following:             - Mints the derivative token to the recipient             This function reverts if:             - `tokenId_` does not exist             - The amount to mint is 0             A derivative token can be minted after vesting expiry, which prevents mitigates problems with auctions that settle late.",
            params: {
              amount_: "The amount of derivative tokens to create",
              to_: "The address to mint the derivative tokens to",
              tokenId_: "The ID of the derivative token",
              wrapped_: "Whether (true) or not (false) the derivative should be wrapped in an ERC20 token for composability"
            },
            returns: {
              _0: "tokenId_            The ID of the derivative token",
              _1: "wrappedAddress_     The address of the ERC20 wrapped derivative token, if wrapped_ is true, otherwise, it's the zero address.",
              _2: "amountCreated_      The amount of derivative tokens created"
            }
          },
          "name(uint256)": {
            details: "This function reverts if:             - The token ID does not exist",
            params: {
              tokenId_: "The ID of the token"
            },
            returns: {
              _0: "string      The name of the token"
            }
          },
          "reclaim(uint256)": {
            details: "Not implemented",
            params: {
              tokenId_: "The ID of the derivative token to reclaim"
            }
          },
          "redeem(uint256,uint256)": {
            details: "This function reverts if:             - `amount_` is 0             - The redeemable amount is less than `amount_`             - The derivative token with `tokenId_` has not been deployed",
            params: {
              amount_: "The amount of derivative tokens to redeem",
              tokenId_: "The ID of the derivative token to redeem"
            }
          },
          "redeemMax(uint256)": {
            params: {
              tokenId_: "The ID of the derivative token to redeem"
            }
          },
          "redeemable(address,uint256)": {
            details: "The redeemable amount is computed as:             - The amount of tokens that have vested               - x: number of vestable tokens               - t: current timestamp               - s: start timestamp               - T: expiry timestamp               - Vested = x * (t - s) / (T - s)             - Minus the amount of tokens that have already been redeemed",
            params: {
              owner_: "The owner of the derivative token",
              tokenId_: "The ID of the derivative token"
            },
            returns: {
              _0: "     The amount of redeemable tokens"
            }
          },
          "symbol(uint256)": {
            details: "This function reverts if:             - The token ID does not exist",
            params: {
              tokenId_: "The ID of the token"
            },
            returns: {
              _0: "string      The symbol of the token"
            }
          },
          "tokenURI(uint256)": {
            details: "This function reverts if:             - The token ID does not exist",
            params: {
              tokenId_: "The ID of the token"
            },
            returns: {
              _0: "string      The URI of the token"
            }
          },
          "totalSupply(uint256)": {
            params: {
              tokenId_: "The ID of the token"
            },
            returns: {
              _0: "uint256     The total supply of the token"
            }
          },
          "transfer(address,uint256,uint256)": {
            details: "Vesting tokens are soulbound/not transferable"
          },
          "transferFrom(address,address,uint256,uint256)": {
            details: "Vesting tokens are soulbound/not transferable"
          },
          "transform(uint256,address,uint256)": {
            details: "Not implemented",
            params: {
              amount_: "The amount of derivative tokens to transform",
              from_: "The address of the owner of the derivative token",
              tokenId_: "The ID of the derivative token to transform"
            }
          },
          "unwrap(uint256,uint256)": {
            details: "This function will revert if:             - The derivative token with `tokenId_` has not been deployed             - A wrapped derivative for `tokenId_` has not been deployed             - `amount_` is 0",
            params: {
              amount_: "The amount of derivative tokens to unwrap",
              tokenId_: "The ID of the derivative token to unwrap"
            }
          },
          "validate(address,bytes)": {
            params: {
              params_: "The abi-encoded `VestingParams` for the derivative token"
            },
            returns: {
              _0: "            Whether or not the params are valid"
            }
          },
          "wrap(uint256,uint256)": {
            details: "This function will revert if:             - The derivative token with `tokenId_` has not been deployed             - `amount_` is 0",
            params: {
              amount_: "The amount of derivative tokens to wrap",
              tokenId_: "The ID of the derivative token to wrap"
            }
          }
        },
        version: 1
      },
      userdoc: {
        kind: "user",
        methods: {
          "INIT()": {
            notice: "Initialization function for the module"
          },
          "PARENT()": {
            notice: "The parent contract for this module."
          },
          "TYPE()": {
            notice: "2 byte identifier for the module type"
          },
          "VEECODE()": {
            notice: "7 byte, versioned identifier for the module. 2 characters from 0-9 that signify the version and 3-5 characters from A-Z."
          },
          "computeId(address,bytes)": {
            notice: "Compute a unique token ID, given the parameters for the derivative"
          },
          "decimals(uint256)": {
            notice: "Returns the number of decimals used by the token"
          },
          "deploy(address,bytes,bool)": {
            notice: "Deploy a new derivative token. Optionally, deploys an ERC20 wrapper for composability."
          },
          "exercise(uint256,uint256)": {
            notice: "Exercise a conversion of the derivative token per the specific implementation logic"
          },
          "exerciseCost(uint256,uint256)": {
            notice: "Determines the cost to exercise a derivative token in the quoted token"
          },
          "getTokenMetadata(uint256)": {
            notice: "Get the metadata for a derivative token"
          },
          "getTokenVestingParams(uint256)": {
            notice: "Get the vesting parameters for a derivative token"
          },
          "mint(address,address,bytes,uint256,bool)": {
            notice: "Mint new derivative tokens.Deploys the derivative token if it does not already exist.The module is expected to transfer the collateral token to itself."
          },
          "mint(address,uint256,uint256,bool)": {
            notice: "Mint new derivative tokens for a specific token ID"
          },
          "name(uint256)": {
            notice: "Returns the name of the token"
          },
          "reclaim(uint256)": {
            notice: "Reclaim posted collateral for a derivative token which can no longer be exercisedAccess controlled: only callable by the derivative issuer via the auction house."
          },
          "redeem(uint256,uint256)": {
            notice: "Redeem derivative tokens for underlying collateral"
          },
          "redeemMax(uint256)": {
            notice: "Redeem all available derivative tokens for underlying collateral"
          },
          "redeemable(address,uint256)": {
            notice: "Determines the amount of redeemable tokens for a given derivative token"
          },
          "symbol(uint256)": {
            notice: "Returns the symbol of the token"
          },
          "tokenMetadata(uint256)": {
            notice: "The metadata for a derivative token"
          },
          "tokenURI(uint256)": {
            notice: "Returns the URI of the token"
          },
          "totalSupply(uint256)": {
            notice: "Returns the total supply of the token"
          },
          "transform(uint256,address,uint256)": {
            notice: "Transforms an existing derivative issued by this contract into something else. Derivative is burned and collateral sent to the auction house.Access controlled: only callable by the auction house."
          },
          "unwrap(uint256,uint256)": {
            notice: "Unwrap an ERC20 derivative token into the underlying ERC6909 derivative"
          },
          "userClaimed(address,uint256)": {
            notice: "Stores the amount that a user has claimed"
          },
          "validate(address,bytes)": {
            notice: "Validate derivative params for the specific implementation             The parameters should be the same as what is passed into `deploy()` or `mint()`"
          },
          "wrap(uint256,uint256)": {
            notice: "Wrap an existing derivative into an ERC20 token for composability             Deploys the ERC20 wrapper if it does not already exist"
          }
        },
        version: 1
      }
    },
    settings: {
      remappings: [
        "@openzeppelin/contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "@openzeppelin/contracts/=lib/openzeppelin-contracts/contracts/",
        "@prb/test/=lib/prb-math/node_modules/@prb/test/",
        "@uniswap/v3-core/=lib/uniswap-v3-core/",
        "ds-test/=lib/forge-std/lib/ds-test/src/",
        "erc4626-tests/=lib/openzeppelin-contracts/lib/erc4626-tests/",
        "forge-std/=lib/forge-std/src/",
        "g-uni-v1-core/=lib/g-uni-v1-core/contracts/",
        "openzeppelin-contracts-upgradeable/=lib/openzeppelin-contracts-upgradeable/contracts/",
        "openzeppelin-contracts/=lib/openzeppelin-contracts/",
        "openzeppelin/=lib/openzeppelin-contracts/contracts/",
        "prb-math/=lib/prb-math/src/",
        "solady/=lib/solady/src/",
        "solmate/=lib/solmate/src/",
        "uniswap-v2-core/=lib/uniswap-v2-core/contracts/",
        "uniswap-v2-periphery/=lib/uniswap-v2-periphery/contracts/",
        "uniswap-v3-core/=lib/uniswap-v3-core/contracts/",
        "uniswap-v3-periphery/=lib/uniswap-v3-periphery/contracts/"
      ],
      optimizer: {
        enabled: true,
        runs: 200
      },
      metadata: {
        bytecodeHash: "ipfs"
      },
      compilationTarget: {
        "src/modules/derivatives/LinearVesting.sol": "LinearVesting"
      },
      evmVersion: "paris",
      libraries: {}
    },
    sources: {
      "lib/openzeppelin-contracts/contracts/utils/Base64.sol": {
        keccak256: "0xb05381393476339e1117800c4d3a6cba08674b1a5e6cdd7c1e45c2391b7023e6",
        urls: [
          "bzz-raw://ae2e81acb0eecf4460dfb88a5a5cb830bfb995c2976531d56f50c0db538d7047",
          "dweb:/ipfs/QmT3ZQAmRwHu7DRP9FYd9UAJP6PMJRojn5zgaeD9iuYr1B"
        ],
        license: "MIT"
      },
      "lib/openzeppelin-contracts/contracts/utils/Strings.sol": {
        keccak256: "0x31f34a3baec77c087d2bdbc5c277f169e505b905aeb43cfcea1734175140f621",
        urls: [
          "bzz-raw://b5a3bc8093b31b685ef879e8ffaaab614594cb6f98ddac4f18c411f7bbf99d0d",
          "dweb:/ipfs/QmSFfA9pH3xo8hnWKCFKTwGi8kz68YXuAwyLXsYe6KjC3Z"
        ],
        license: "MIT"
      },
      "lib/openzeppelin-contracts/contracts/utils/math/Math.sol": {
        keccak256: "0xdb6d7e26320438bdd421598eb64e6fe2b03867a4dd07c9c820994b7bec26f7b0",
        urls: [
          "bzz-raw://2adf1566393ddf260fb2064dd0c67be00123b8978be8b62cc45ac97aff859949",
          "dweb:/ipfs/QmaDLzQpnitEJDAJo4squpKumr5x4D2QYetPdT3jZd8hYm"
        ],
        license: "MIT"
      },
      "lib/openzeppelin-contracts/contracts/utils/math/SignedMath.sol": {
        keccak256: "0x63a4fc7046bc052edeec923181f2f886681e1e0b34c4f23ce84425acfe80a1fb",
        urls: [
          "bzz-raw://9cee5cb5fa0dc7d47c463f900b5fcd44abe84f6bce23433898af1221598a3a9b",
          "dweb:/ipfs/Qmdjp7Pf6RuGgAnSxUKd9CvniN8gUG6wLH1cdvhg5L9w4z"
        ],
        license: "MIT"
      },
      "lib/solmate/src/auth/Owned.sol": {
        keccak256: "0xfedb27d14c508342c33eb067c9a02eabcdb0f9dcf93b04ded1001f580d12d0ea",
        urls: [
          "bzz-raw://1ff52bbee698b9cf9e4574615e6550be0887ccf355f6571e23d6f25b332e79b4",
          "dweb:/ipfs/QmVorA2apojVRStzS7h8aFccR3Uv32G6HVtBtFHZrE7YXx"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/tokens/ERC20.sol": {
        keccak256: "0xcdfd8db76b2a3415620e4d18cc5545f3d50de792dbf2c3dd5adb40cbe6f94b10",
        urls: [
          "bzz-raw://57b3ab70cde374af1cf2c9888636e8de6cf660f087b1c9abd805e9271e19fa35",
          "dweb:/ipfs/QmNrLDBAHYFjpjSd12jerm1AdBkDqEYUUaXgnT854BUZ97"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/tokens/ERC6909.sol": {
        keccak256: "0x767ed60e11d739ed7eb9e10467eb0e0573293238b7a2a56f96b23f145297f1d2",
        urls: [
          "bzz-raw://e5bc9f48d84ecc46f2627b2a91948f8060f78d2f548a6c5ca1f282f8778e01e0",
          "dweb:/ipfs/QmeATtgjaDVhxcCs6auJrC8nqCwUqntTi3WygHVRa9xg6M"
        ],
        license: "MIT"
      },
      "lib/solmate/src/utils/FixedPointMathLib.sol": {
        keccak256: "0x1b62af9baf5b8e991ed7531bc87f45550ba9d61e8dbff5caf237ccaf3a3fd843",
        urls: [
          "bzz-raw://b7b38b977c5305b18ceefbeed4c9ceaaaefa419b520de62de6604ea661f8c0a9",
          "dweb:/ipfs/QmecMRzgfMyDVa2pvBqMMDLYBappaj7Aa3qcMoQYEQrhWi"
        ],
        license: "AGPL-3.0-only"
      },
      "lib/solmate/src/utils/SafeTransferLib.sol": {
        keccak256: "0x6ab948013c2c7ca6351e593600425b0ec6df9035320280c678e735bce16e996b",
        urls: [
          "bzz-raw://2ab977d0eeb2bf458f9798250215c646d2f3b1f90b5a7e2b506fdf3335c0f060",
          "dweb:/ipfs/QmYPRoPhNtBAmCSq7imN1scMVpKNQvMTpoqab3tXUx5Tnv"
        ],
        license: "AGPL-3.0-only"
      },
      "src/interfaces/modules/IDerivative.sol": {
        keccak256: "0x953a79012815f4b3315303720b1758d3b6f3666174d5259849609bb1c11f948f",
        urls: [
          "bzz-raw://1abc79c0a872cfb4eaf7cadf5794fd509aa401a86fd27bc4c78084f125164daf",
          "dweb:/ipfs/QmSd58DqwwjnXehKFu9DLUFToTVHmWNWstnEMSZ1EX96Yd"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/interfaces/modules/derivatives/ILinearVesting.sol": {
        keccak256: "0x4786c481106dd2cb1777bb935ecedc8180b62ed4048f6f6952daf9b5641520ff",
        urls: [
          "bzz-raw://ee03aac28046689e32b3e4905a721d6c5261efce6cd8194b13396c1f9650d6e4",
          "dweb:/ipfs/QmSqJjZqU7vLpuzKxZrpUQj9ybh5uaBFxfCZ39ewkQqwV8"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/lib/ERC6909Metadata.sol": {
        keccak256: "0x45cbf0d8d04f5628d34d7eb4bb5e13b7664b1ae03456f2ca2d2eb259d199f9e6",
        urls: [
          "bzz-raw://f7cfbc4fd542200d756f16457917157d838df10aa5f253f205d33a865ca6b0e6",
          "dweb:/ipfs/QmTrgxTzer1yuvy4VoRkyMBtgigfq9kHU6xNHfy9J5Du11"
        ],
        license: "UNLICENSED"
      },
      "src/lib/SVG.sol": {
        keccak256: "0x9ebbe6e5a83b118af5fdffc65cdbb646a1b444a27036e53e51541589a2d6c3d7",
        urls: [
          "bzz-raw://eaea614b412634e83a9a0727bb3a4015de27779ab90611aed9be7eacbbacc495",
          "dweb:/ipfs/QmbU6FrCk9rh27JLBF7orNAhD5X5gJzjfH3NkdorPUgABx"
        ],
        license: "MIT"
      },
      "src/lib/Timestamp.sol": {
        keccak256: "0x8698230543af14affc4b58fb64aabed2116c1c8a41ac94309e2ec0241f0fb129",
        urls: [
          "bzz-raw://5c1a9cee00e32f1b66518e686890fa39969155a8738236bc91eb2f6151bb2b99",
          "dweb:/ipfs/QmXiq4CVSHddc9c49gdqxAD23XqXeA5eqGbCqFHsuwdjXT"
        ],
        license: "MIT"
      },
      "src/lib/Uint2Str.sol": {
        keccak256: "0xd5bed46248c82664844898fee717cf46ac94df59f7dc67c8db626ef666e7ce52",
        urls: [
          "bzz-raw://56ff374909e3030e11301a6fd3c16a893e85a0fd3ffa042ee877b850336a8b0f",
          "dweb:/ipfs/QmewNgdjU2EzjdgtRii9MENC43J9P33DpBkqznpHNFrF1W"
        ],
        license: "UNLICENSED"
      },
      "src/lib/clones/Clone.sol": {
        keccak256: "0x56f39ad54b1d26569bd281a4da2fa0deb54bad7cf05f5bfacb488cd050c9027e",
        urls: [
          "bzz-raw://bb9530726000c21fd93b42412cd528dfc37f0270966362a672b486bf43e41368",
          "dweb:/ipfs/QmWrL3YjSzXMBFFW7o5d22HZrxk25sdru7XowLoqukZN3M"
        ],
        license: "BSD"
      },
      "src/lib/clones/CloneERC20.sol": {
        keccak256: "0xbd7e0d8863ad7c758ac5b8940ad1fb52bfa75d54ad5e23726db6fa2717811bc7",
        urls: [
          "bzz-raw://3de09440ec47fc9f80297fc21beb4264858ed66451302046a486e59b0a9c29c8",
          "dweb:/ipfs/QmfJQ14a59gf8sah6tfuHeKAUKX4eECd9ktdGwuW7x7hVX"
        ],
        license: "BSD"
      },
      "src/lib/clones/ClonesWithImmutableArgs.sol": {
        keccak256: "0x19e9432ce100392e198e8cf8ad985add8441028b8be9704b66de64da052bd79d",
        urls: [
          "bzz-raw://fb89861ef99a1f89a25498aa648d73c3f694f5c18dc92e8e93dffdf454a9a04e",
          "dweb:/ipfs/QmV6T5Fj6WUNHFSAqDPkvdXRRoQv76LpeigbGY6r2Hzxn8"
        ],
        license: "BSD"
      },
      "src/modules/Derivative.sol": {
        keccak256: "0x35e7d822254ccf75e0216b8783dfd8c9a431eaa40a90c1254635f161646573e0",
        urls: [
          "bzz-raw://83e5ac5f6f4c0e339841cefc19fc2aec65951dd1b8a3000819d8d9a344964f58",
          "dweb:/ipfs/QmRW2xsdfc8zHvr2XWXK5n2rxnpqYxD9rBwJ9eLWWSrYMP"
        ],
        license: "BSL-1.1"
      },
      "src/modules/Keycode.sol": {
        keccak256: "0x87bc46fae1fa972055e50731999516b0f6a311a9a6e4edd908624dd90b4eab3e",
        urls: [
          "bzz-raw://028e26252256a74ff0e65890eb1058682094b88af647948a2d7b22085e8470cd",
          "dweb:/ipfs/QmScfjAA3mHzKdTmRtdsfdVvcKF3xTtXYVZt5rHTDQywfu"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/Modules.sol": {
        keccak256: "0xd4444ffe31b384d7c9b3e0d7d94da5dd40a4b028ed22f2877aa375536a48f689",
        urls: [
          "bzz-raw://9f69b6ffe34283147f4864276ad514890fadc72f412970ae770c57cbe3dffdee",
          "dweb:/ipfs/QmcCT9SGp23rYWov7cMSnuqzqtHf7MebegD6PezE3mRR5v"
        ],
        license: "AGPL-3.0-or-later"
      },
      "src/modules/derivatives/LinearVesting.sol": {
        keccak256: "0xbf198f3928f8151f8a876069129822b7cd9da93d933faf12b006ecdc4f31df8d",
        urls: [
          "bzz-raw://bd723cb82a9d7d07d5874f4f0e52d2b1a8844e778b366d64d7c99dcf46a4d086",
          "dweb:/ipfs/QmbzKMPXXBTo8zuRWJ55oFbanGPExacvkVVm3T9ELDdGbE"
        ],
        license: "BSL-1.1"
      },
      "src/modules/derivatives/LinearVestingCard.sol": {
        keccak256: "0x91a3c829f911b0173da7b968953222224ad17b5a07dd95b54b5ebfd41625f266",
        urls: [
          "bzz-raw://6100c9f1f11748695d5e660ccd1470588e199289ddef7029a86d962f99a73491",
          "dweb:/ipfs/QmYcHf299r34cbMvrSbcztb4XUYyxiSk6jqTsn1VYsVHMX"
        ],
        license: "BSL-1.1"
      },
      "src/modules/derivatives/SoulboundCloneERC20.sol": {
        keccak256: "0x4d7fe1d97c69ee3b098b156c5aae174fa1543e234230a7b5d0537594b27046f0",
        urls: [
          "bzz-raw://d635de27ea6c5aa6de0dd41b6c005d6259cbe4ac4e5dca3e589fad4a42da4a36",
          "dweb:/ipfs/QmdtwdodoKQS3eRuaVwHqAKppV5Y9nQ2e6pEbycVRDmUVo"
        ],
        license: "BSL-1.1"
      }
    },
    version: 1
  },
  ast: {
    absolutePath: "src/modules/derivatives/LinearVesting.sol",
    id: 95103,
    exportedSymbols: {
      Base64: [50215],
      ClonesWithImmutableArgs: [86889],
      DerivativeModule: [88078],
      ERC20: [56264],
      ERC6909: [56583],
      ERC6909Metadata: [84408],
      FixedPointMathLib: [56742],
      IDerivative: [83049],
      ILinearVesting: [83448],
      LinearVesting: [95102],
      LinearVestingCard: [95946],
      Module: [88991],
      SafeTransferLib: [56853],
      SoulboundCloneERC20: [96086],
      Timestamp: [85782],
      Veecode: [88084],
      toKeycode: [88103],
      wrapVeecode: [88165]
    },
    nodeType: "SourceUnit",
    src: "36:28851:179",
    nodes: [
      {
        id: 93388,
        nodeType: "PragmaDirective",
        src: "36:23:179",
        nodes: [],
        literals: ["solidity", "0.8", ".19"]
      },
      {
        id: 93390,
        nodeType: "ImportDirective",
        src: "61:47:179",
        nodes: [],
        absolutePath: "lib/solmate/src/tokens/ERC20.sol",
        file: "solmate/tokens/ERC20.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 56265,
        symbolAliases: [
          {
            foreign: {
              id: 93389,
              name: "ERC20",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 56264,
              src: "69:5:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93392,
        nodeType: "ImportDirective",
        src: "109:51:179",
        nodes: [],
        absolutePath: "lib/solmate/src/tokens/ERC6909.sol",
        file: "solmate/tokens/ERC6909.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 56584,
        symbolAliases: [
          {
            foreign: {
              id: 93391,
              name: "ERC6909",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 56583,
              src: "117:7:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93394,
        nodeType: "ImportDirective",
        src: "161:66:179",
        nodes: [],
        absolutePath: "lib/solmate/src/utils/SafeTransferLib.sol",
        file: "solmate/utils/SafeTransferLib.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 56854,
        symbolAliases: [
          {
            foreign: {
              id: 93393,
              name: "SafeTransferLib",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 56853,
              src: "169:15:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93396,
        nodeType: "ImportDirective",
        src: "228:83:179",
        nodes: [],
        absolutePath: "src/lib/clones/ClonesWithImmutableArgs.sol",
        file: "src/lib/clones/ClonesWithImmutableArgs.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 86890,
        symbolAliases: [
          {
            foreign: {
              id: 93395,
              name: "ClonesWithImmutableArgs",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 86889,
              src: "236:23:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93398,
        nodeType: "ImportDirective",
        src: "312:48:179",
        nodes: [],
        absolutePath: "src/lib/Timestamp.sol",
        file: "src/lib/Timestamp.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 85783,
        symbolAliases: [
          {
            foreign: {
              id: 93397,
              name: "Timestamp",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 85782,
              src: "320:9:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93400,
        nodeType: "ImportDirective",
        src: "361:60:179",
        nodes: [],
        absolutePath: "src/lib/ERC6909Metadata.sol",
        file: "src/lib/ERC6909Metadata.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 84409,
        symbolAliases: [
          {
            foreign: {
              id: 93399,
              name: "ERC6909Metadata",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 84408,
              src: "369:15:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93402,
        nodeType: "ImportDirective",
        src: "422:70:179",
        nodes: [],
        absolutePath: "lib/solmate/src/utils/FixedPointMathLib.sol",
        file: "solmate/utils/FixedPointMathLib.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 56743,
        symbolAliases: [
          {
            foreign: {
              id: 93401,
              name: "FixedPointMathLib",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 56742,
              src: "430:17:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93404,
        nodeType: "ImportDirective",
        src: "493:77:179",
        nodes: [],
        absolutePath: "lib/openzeppelin-contracts/contracts/utils/Base64.sol",
        file: "lib/openzeppelin-contracts/contracts/utils/Base64.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 50216,
        symbolAliases: [
          {
            foreign: {
              id: 93403,
              name: "Base64",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 50215,
              src: "501:6:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93406,
        nodeType: "ImportDirective",
        src: "572:67:179",
        nodes: [],
        absolutePath: "src/interfaces/modules/IDerivative.sol",
        file: "src/interfaces/modules/IDerivative.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 83050,
        symbolAliases: [
          {
            foreign: {
              id: 93405,
              name: "IDerivative",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 83049,
              src: "580:11:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93408,
        nodeType: "ImportDirective",
        src: "640:85:179",
        nodes: [],
        absolutePath: "src/interfaces/modules/derivatives/ILinearVesting.sol",
        file: "src/interfaces/modules/derivatives/ILinearVesting.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 83449,
        symbolAliases: [
          {
            foreign: {
              id: 93407,
              name: "ILinearVesting",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 83448,
              src: "648:14:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93410,
        nodeType: "ImportDirective",
        src: "726:60:179",
        nodes: [],
        absolutePath: "src/modules/Derivative.sol",
        file: "src/modules/Derivative.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 88079,
        symbolAliases: [
          {
            foreign: {
              id: 93409,
              name: "DerivativeModule",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88078,
              src: "734:16:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93415,
        nodeType: "ImportDirective",
        src: "787:80:179",
        nodes: [],
        absolutePath: "src/modules/Modules.sol",
        file: "src/modules/Modules.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 88992,
        symbolAliases: [
          {
            foreign: {
              id: 93411,
              name: "Module",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88991,
              src: "795:6:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 93412,
              name: "Veecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88084,
              src: "803:7:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 93413,
              name: "toKeycode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88103,
              src: "812:9:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          },
          {
            foreign: {
              id: 93414,
              name: "wrapVeecode",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 88165,
              src: "823:11:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93417,
        nodeType: "ImportDirective",
        src: "868:84:179",
        nodes: [],
        absolutePath: "src/modules/derivatives/SoulboundCloneERC20.sol",
        file: "src/modules/derivatives/SoulboundCloneERC20.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 96087,
        symbolAliases: [
          {
            foreign: {
              id: 93416,
              name: "SoulboundCloneERC20",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 96086,
              src: "876:19:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 93419,
        nodeType: "ImportDirective",
        src: "953:80:179",
        nodes: [],
        absolutePath: "src/modules/derivatives/LinearVestingCard.sol",
        file: "src/modules/derivatives/LinearVestingCard.sol",
        nameLocation: "-1:-1:-1",
        scope: 95103,
        sourceUnit: 95947,
        symbolAliases: [
          {
            foreign: {
              id: 93418,
              name: "LinearVestingCard",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 95946,
              src: "961:17:179",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 95102,
        nodeType: "ContractDefinition",
        src: "1574:27312:179",
        nodes: [
          {
            id: 93430,
            nodeType: "UsingForDirective",
            src: "1658:32:179",
            nodes: [],
            global: false,
            libraryName: {
              id: 93427,
              name: "SafeTransferLib",
              nameLocations: ["1664:15:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 56853,
              src: "1664:15:179"
            },
            typeName: {
              id: 93429,
              nodeType: "UserDefinedTypeName",
              pathNode: {
                id: 93428,
                name: "ERC20",
                nameLocations: ["1684:5:179"],
                nodeType: "IdentifierPath",
                referencedDeclaration: 56264,
                src: "1684:5:179"
              },
              referencedDeclaration: 56264,
              src: "1684:5:179",
              typeDescriptions: {
                typeIdentifier: "t_contract$_ERC20_$56264",
                typeString: "contract ERC20"
              }
            }
          },
          {
            id: 93433,
            nodeType: "UsingForDirective",
            src: "1695:42:179",
            nodes: [],
            global: false,
            libraryName: {
              id: 93431,
              name: "ClonesWithImmutableArgs",
              nameLocations: ["1701:23:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 86889,
              src: "1701:23:179"
            },
            typeName: {
              id: 93432,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "1729:7:179",
              stateMutability: "nonpayable",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            }
          },
          {
            id: 93436,
            nodeType: "UsingForDirective",
            src: "1742:27:179",
            nodes: [],
            global: false,
            libraryName: {
              id: 93434,
              name: "Timestamp",
              nameLocations: ["1748:9:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 85782,
              src: "1748:9:179"
            },
            typeName: {
              id: 93435,
              name: "uint48",
              nodeType: "ElementaryTypeName",
              src: "1762:6:179",
              typeDescriptions: {
                typeIdentifier: "t_uint48",
                typeString: "uint48"
              }
            }
          },
          {
            id: 93439,
            nodeType: "UsingForDirective",
            src: "1774:36:179",
            nodes: [],
            global: false,
            libraryName: {
              id: 93437,
              name: "FixedPointMathLib",
              nameLocations: ["1780:17:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 56742,
              src: "1780:17:179"
            },
            typeName: {
              id: 93438,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "1802:7:179",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            }
          },
          {
            id: 93442,
            nodeType: "VariableDeclaration",
            src: "1865:51:179",
            nodes: [],
            constant: false,
            mutability: "immutable",
            name: "_VESTING_PARAMS_LEN",
            nameLocation: "1892:19:179",
            scope: 95102,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_uint256",
              typeString: "uint256"
            },
            typeName: {
              id: 93440,
              name: "uint256",
              nodeType: "ElementaryTypeName",
              src: "1865:7:179",
              typeDescriptions: {
                typeIdentifier: "t_uint256",
                typeString: "uint256"
              }
            },
            value: {
              hexValue: "3634",
              id: 93441,
              isConstant: false,
              isLValue: false,
              isPure: true,
              kind: "number",
              lValueRequested: false,
              nodeType: "Literal",
              src: "1914:2:179",
              typeDescriptions: {
                typeIdentifier: "t_rational_64_by_1",
                typeString: "int_const 64"
              },
              value: "64"
            },
            visibility: "internal"
          },
          {
            id: 93445,
            nodeType: "VariableDeclaration",
            src: "2010:42:179",
            nodes: [],
            constant: false,
            documentation: {
              id: 93443,
              nodeType: "StructuredDocumentation",
              src: "1923:82:179",
              text: "@notice     Stores the clonable implementation of the wrapped derivative token"
            },
            mutability: "immutable",
            name: "_IMPLEMENTATION",
            nameLocation: "2037:15:179",
            scope: 95102,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_address",
              typeString: "address"
            },
            typeName: {
              id: 93444,
              name: "address",
              nodeType: "ElementaryTypeName",
              src: "2010:7:179",
              stateMutability: "nonpayable",
              typeDescriptions: {
                typeIdentifier: "t_address",
                typeString: "address"
              }
            },
            visibility: "internal"
          },
          {
            id: 93452,
            nodeType: "VariableDeclaration",
            src: "2121:91:179",
            nodes: [],
            constant: false,
            documentation: {
              id: 93446,
              nodeType: "StructuredDocumentation",
              src: "2059:57:179",
              text: "@notice     Stores the amount that a user has claimed"
            },
            functionSelector: "fcbf8b24",
            mutability: "mutable",
            name: "userClaimed",
            nameLocation: "2201:11:179",
            scope: 95102,
            stateVariable: true,
            storageLocation: "default",
            typeDescriptions: {
              typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
              typeString: "mapping(address => mapping(uint256 => uint256))"
            },
            typeName: {
              id: 93451,
              keyName: "owner_",
              keyNameLocation: "2137:6:179",
              keyType: {
                id: 93447,
                name: "address",
                nodeType: "ElementaryTypeName",
                src: "2129:7:179",
                typeDescriptions: {
                  typeIdentifier: "t_address",
                  typeString: "address"
                }
              },
              nodeType: "Mapping",
              src: "2121:72:179",
              typeDescriptions: {
                typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
                typeString: "mapping(address => mapping(uint256 => uint256))"
              },
              valueName: "",
              valueNameLocation: "-1:-1:-1",
              valueType: {
                id: 93450,
                keyName: "tokenId_",
                keyNameLocation: "2163:8:179",
                keyType: {
                  id: 93448,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2155:7:179",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                },
                nodeType: "Mapping",
                src: "2147:45:179",
                typeDescriptions: {
                  typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                  typeString: "mapping(uint256 => uint256)"
                },
                valueName: "claimed_",
                valueNameLocation: "2183:8:179",
                valueType: {
                  id: 93449,
                  name: "uint256",
                  nodeType: "ElementaryTypeName",
                  src: "2175:7:179",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  }
                }
              }
            },
            visibility: "public"
          },
          {
            id: 93473,
            nodeType: "FunctionDefinition",
            src: "2265:177:179",
            nodes: [],
            body: {
              id: 93472,
              nodeType: "Block",
              src: "2330:112:179",
              nodes: [],
              statements: [
                {
                  expression: {
                    id: 93470,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 93462,
                      name: "_IMPLEMENTATION",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93445,
                      src: "2383:15:179",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 93467,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "NewExpression",
                            src: "2409:23:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_creation_nonpayable$__$returns$_t_contract$_SoulboundCloneERC20_$96086_$",
                              typeString: "function () returns (contract SoulboundCloneERC20)"
                            },
                            typeName: {
                              id: 93466,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 93465,
                                name: "SoulboundCloneERC20",
                                nameLocations: ["2413:19:179"],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 96086,
                                src: "2413:19:179"
                              },
                              referencedDeclaration: 96086,
                              src: "2413:19:179",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                                typeString: "contract SoulboundCloneERC20"
                              }
                            }
                          },
                          id: 93468,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "2409:25:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                            typeString: "contract SoulboundCloneERC20"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                            typeString: "contract SoulboundCloneERC20"
                          }
                        ],
                        id: 93464,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "2401:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 93463,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "2401:7:179",
                          typeDescriptions: {}
                        }
                      },
                      id: 93469,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2401:34:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "2383:52:179",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 93471,
                  nodeType: "ExpressionStatement",
                  src: "2383:52:179"
                }
              ]
            },
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    id: 93457,
                    name: "parent_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 93454,
                    src: "2301:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  }
                ],
                id: 93458,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 93456,
                  name: "Module",
                  nameLocations: ["2294:6:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 88991,
                  src: "2294:6:179"
                },
                nodeType: "ModifierInvocation",
                src: "2294:15:179"
              },
              {
                arguments: [],
                id: 93460,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 93459,
                  name: "LinearVestingCard",
                  nameLocations: ["2310:17:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 95946,
                  src: "2310:17:179"
                },
                nodeType: "ModifierInvocation",
                src: "2310:19:179"
              }
            ],
            name: "",
            nameLocation: "-1:-1:-1",
            parameters: {
              id: 93455,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93454,
                  mutability: "mutable",
                  name: "parent_",
                  nameLocation: "2285:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 93473,
                  src: "2277:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93453,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "2277:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2276:17:179"
            },
            returnParameters: {
              id: 93461,
              nodeType: "ParameterList",
              parameters: [],
              src: "2330:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 93485,
            nodeType: "FunctionDefinition",
            src: "2475:91:179",
            nodes: [],
            body: {
              id: 93484,
              nodeType: "Block",
              src: "2527:39:179",
              nodes: [],
              statements: [
                {
                  expression: {
                    expression: {
                      id: 93481,
                      name: "Type",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88904,
                      src: "2544:4:179",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_enum$_Type_$88904_$",
                        typeString: "type(enum Module.Type)"
                      }
                    },
                    id: 93482,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    lValueRequested: false,
                    memberLocation: "2549:10:179",
                    memberName: "Derivative",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 88901,
                    src: "2544:15:179",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_Type_$88904",
                      typeString: "enum Module.Type"
                    }
                  },
                  functionReturnParameters: 93480,
                  id: 93483,
                  nodeType: "Return",
                  src: "2537:22:179"
                }
              ]
            },
            baseFunctions: [88975],
            documentation: {
              id: 93474,
              nodeType: "StructuredDocumentation",
              src: "2448:22:179",
              text: "@inheritdoc Module"
            },
            functionSelector: "bb24fe8a",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "TYPE",
            nameLocation: "2484:4:179",
            overrides: {
              id: 93476,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "2503:8:179"
            },
            parameters: {
              id: 93475,
              nodeType: "ParameterList",
              parameters: [],
              src: "2488:2:179"
            },
            returnParameters: {
              id: 93480,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93479,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93485,
                  src: "2521:4:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_enum$_Type_$88904",
                    typeString: "enum Module.Type"
                  },
                  typeName: {
                    id: 93478,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 93477,
                      name: "Type",
                      nameLocations: ["2521:4:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 88904,
                      src: "2521:4:179"
                    },
                    referencedDeclaration: 88904,
                    src: "2521:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_enum$_Type_$88904",
                      typeString: "enum Module.Type"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2520:6:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: false,
            visibility: "public"
          },
          {
            id: 93501,
            nodeType: "FunctionDefinition",
            src: "2599:114:179",
            nodes: [],
            body: {
              id: 93500,
              nodeType: "Block",
              src: "2657:56:179",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            hexValue: "4c4956",
                            id: 93495,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "string",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "2696:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_stringliteral_8a6a05eb28b2986dc96328ade98f9eea853bf08db0e6db2bf42fe8e0d0adaee9",
                              typeString: 'literal_string "LIV"'
                            },
                            value: "LIV"
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_stringliteral_8a6a05eb28b2986dc96328ade98f9eea853bf08db0e6db2bf42fe8e0d0adaee9",
                              typeString: 'literal_string "LIV"'
                            }
                          ],
                          id: 93494,
                          name: "toKeycode",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 88103,
                          src: "2686:9:179",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_bytes5_$returns$_t_userDefinedValueType$_Keycode_$88082_$",
                            typeString: "function (bytes5) pure returns (Keycode)"
                          }
                        },
                        id: 93496,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "2686:16:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_userDefinedValueType$_Keycode_$88082",
                          typeString: "Keycode"
                        }
                      },
                      {
                        hexValue: "31",
                        id: 93497,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "2704:1:179",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        },
                        value: "1"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_userDefinedValueType$_Keycode_$88082",
                          typeString: "Keycode"
                        },
                        {
                          typeIdentifier: "t_rational_1_by_1",
                          typeString: "int_const 1"
                        }
                      ],
                      id: 93493,
                      name: "wrapVeecode",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88165,
                      src: "2674:11:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_userDefinedValueType$_Keycode_$88082_$_t_uint8_$returns$_t_userDefinedValueType$_Veecode_$88084_$",
                        typeString: "function (Keycode,uint8) pure returns (Veecode)"
                      }
                    },
                    id: 93498,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "2674:32:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                      typeString: "Veecode"
                    }
                  },
                  functionReturnParameters: 93492,
                  id: 93499,
                  nodeType: "Return",
                  src: "2667:39:179"
                }
              ]
            },
            baseFunctions: [88983],
            documentation: {
              id: 93486,
              nodeType: "StructuredDocumentation",
              src: "2572:22:179",
              text: "@inheritdoc Module"
            },
            functionSelector: "d61735ca",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "VEECODE",
            nameLocation: "2608:7:179",
            overrides: {
              id: 93488,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "2630:8:179"
            },
            parameters: {
              id: 93487,
              nodeType: "ParameterList",
              parameters: [],
              src: "2615:2:179"
            },
            returnParameters: {
              id: 93492,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93491,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93501,
                  src: "2648:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                    typeString: "Veecode"
                  },
                  typeName: {
                    id: 93490,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 93489,
                      name: "Veecode",
                      nameLocations: ["2648:7:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 88084,
                      src: "2648:7:179"
                    },
                    referencedDeclaration: 88084,
                    src: "2648:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                      typeString: "Veecode"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2647:9:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: false,
            visibility: "public"
          },
          {
            id: 93517,
            nodeType: "ModifierDefinition",
            src: "2762:139:179",
            nodes: [],
            body: {
              id: 93516,
              nodeType: "Block",
              src: "2806:95:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 93510,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 93505,
                          name: "tokenMetadata",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 88048,
                          src: "2820:13:179",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                            typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                          }
                        },
                        id: 93507,
                        indexExpression: {
                          id: 93506,
                          name: "tokenId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93503,
                          src: "2834:8:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "2820:23:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage",
                          typeString: "struct IDerivative.Token storage ref"
                        }
                      },
                      id: 93508,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "2844:6:179",
                      memberName: "exists",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82868,
                      src: "2820:30:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "66616c7365",
                      id: 93509,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "2854:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    src: "2820:39:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93514,
                  nodeType: "IfStatement",
                  src: "2816:67:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 93511,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "2868:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 93512,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "2868:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93513,
                    nodeType: "RevertStatement",
                    src: "2861:22:179"
                  }
                },
                {
                  id: 93515,
                  nodeType: "PlaceholderStatement",
                  src: "2893:1:179"
                }
              ]
            },
            name: "onlyValidTokenId",
            nameLocation: "2771:16:179",
            parameters: {
              id: 93504,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93503,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "2796:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93517,
                  src: "2788:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93502,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2788:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2787:18:179"
            },
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93537,
            nodeType: "ModifierDefinition",
            src: "2907:172:179",
            nodes: [],
            body: {
              id: 93536,
              nodeType: "Block",
              src: "2954:125:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 93529,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        baseExpression: {
                          id: 93521,
                          name: "tokenMetadata",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 88048,
                          src: "2968:13:179",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                            typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                          }
                        },
                        id: 93523,
                        indexExpression: {
                          id: 93522,
                          name: "tokenId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93519,
                          src: "2982:8:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "2968:23:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage",
                          typeString: "struct IDerivative.Token storage ref"
                        }
                      },
                      id: 93524,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "2992:7:179",
                      memberName: "wrapped",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82870,
                      src: "2968:31:179",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 93527,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "3011:1:179",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 93526,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "3003:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 93525,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "3003:7:179",
                          typeDescriptions: {}
                        }
                      },
                      id: 93528,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "3003:10:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "2968:45:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93534,
                  nodeType: "IfStatement",
                  src: "2964:98:179",
                  trueBody: {
                    id: 93533,
                    nodeType: "Block",
                    src: "3015:47:179",
                    statements: [
                      {
                        errorCall: {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 93530,
                            name: "InvalidParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83429,
                            src: "3036:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 93531,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "3036:15:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93532,
                        nodeType: "RevertStatement",
                        src: "3029:22:179"
                      }
                    ]
                  }
                },
                {
                  id: 93535,
                  nodeType: "PlaceholderStatement",
                  src: "3071:1:179"
                }
              ]
            },
            name: "onlyDeployedWrapped",
            nameLocation: "2916:19:179",
            parameters: {
              id: 93520,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93519,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "2944:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93537,
                  src: "2936:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93518,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "2936:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "2935:18:179"
            },
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93554,
            nodeType: "FunctionDefinition",
            src: "3221:122:179",
            nodes: [],
            body: {
              id: 93553,
              nodeType: "Block",
              src: "3305:38:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 93550,
                      name: "NotPermitted",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83427,
                      src: "3322:12:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 93551,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3322:14:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93552,
                  nodeType: "RevertStatement",
                  src: "3315:21:179"
                }
              ]
            },
            baseFunctions: [56358],
            documentation: {
              id: 93538,
              nodeType: "StructuredDocumentation",
              src: "3127:89:179",
              text: "@inheritdoc ERC6909\n @dev        Vesting tokens are soulbound/not transferable"
            },
            functionSelector: "095bcdb6",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "transfer",
            nameLocation: "3230:8:179",
            overrides: {
              id: 93546,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "3281:8:179"
            },
            parameters: {
              id: 93545,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93540,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93554,
                  src: "3239:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93539,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3239:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93542,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93554,
                  src: "3248:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93541,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3248:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93544,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93554,
                  src: "3257:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93543,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3257:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3238:27:179"
            },
            returnParameters: {
              id: 93549,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93548,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93554,
                  src: "3299:4:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93547,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "3299:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3298:6:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "public"
          },
          {
            id: 93573,
            nodeType: "FunctionDefinition",
            src: "3443:173:179",
            nodes: [],
            body: {
              id: 93572,
              nodeType: "Block",
              src: "3578:38:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 93569,
                      name: "NotPermitted",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83427,
                      src: "3595:12:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 93570,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3595:14:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93571,
                  nodeType: "RevertStatement",
                  src: "3588:21:179"
                }
              ]
            },
            baseFunctions: [56445],
            documentation: {
              id: 93555,
              nodeType: "StructuredDocumentation",
              src: "3349:89:179",
              text: "@inheritdoc ERC6909\n @dev        Vesting tokens are soulbound/not transferable"
            },
            functionSelector: "fe99049a",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "transferFrom",
            nameLocation: "3452:12:179",
            overrides: {
              id: 93565,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "3554:8:179"
            },
            parameters: {
              id: 93564,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93557,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93573,
                  src: "3474:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93556,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3474:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93559,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93573,
                  src: "3491:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93558,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3491:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93561,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93573,
                  src: "3508:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93560,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3508:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93563,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93573,
                  src: "3525:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93562,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3525:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3464:74:179"
            },
            returnParameters: {
              id: 93568,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93567,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93573,
                  src: "3572:4:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93566,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "3572:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3571:6:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "public"
          },
          {
            id: 93590,
            nodeType: "FunctionDefinition",
            src: "3716:121:179",
            nodes: [],
            body: {
              id: 93589,
              nodeType: "Block",
              src: "3799:38:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 93586,
                      name: "NotPermitted",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83427,
                      src: "3816:12:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 93587,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "3816:14:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93588,
                  nodeType: "RevertStatement",
                  src: "3809:21:179"
                }
              ]
            },
            baseFunctions: [56478],
            documentation: {
              id: 93574,
              nodeType: "StructuredDocumentation",
              src: "3622:89:179",
              text: "@inheritdoc ERC6909\n @dev        Vesting tokens are soulbound/not transferable"
            },
            functionSelector: "426a8493",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "approve",
            nameLocation: "3725:7:179",
            overrides: {
              id: 93582,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "3775:8:179"
            },
            parameters: {
              id: 93581,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93576,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93590,
                  src: "3733:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93575,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "3733:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93578,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93590,
                  src: "3742:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93577,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3742:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93580,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93590,
                  src: "3751:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93579,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "3751:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3732:27:179"
            },
            returnParameters: {
              id: 93585,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93584,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93590,
                  src: "3793:4:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93583,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "3793:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "3792:6:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "public"
          },
          {
            id: 93638,
            nodeType: "FunctionDefinition",
            src: "4284:642:179",
            nodes: [],
            body: {
              id: 93637,
              nodeType: "Block",
              src: "4471:455:179",
              nodes: [],
              statements: [
                {
                  assignments: [93607],
                  declarations: [
                    {
                      constant: false,
                      id: 93607,
                      mutability: "mutable",
                      name: "params",
                      nameLocation: "4531:6:179",
                      nodeType: "VariableDeclaration",
                      scope: 93637,
                      src: "4510:27:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 93606,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 93605,
                          name: "VestingParams",
                          nameLocations: ["4510:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "4510:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "4510:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93611,
                  initialValue: {
                    arguments: [
                      {
                        id: 93609,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93595,
                        src: "4561:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      ],
                      id: 93608,
                      name: "_decodeVestingParams",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94584,
                      src: "4540:20:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_struct$_VestingParams_$83438_memory_ptr_$",
                        typeString: "function (bytes memory) pure returns (struct ILinearVesting.VestingParams memory)"
                      }
                    },
                    id: 93610,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "4540:29:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4510:59:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 93617,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      arguments: [
                        {
                          id: 93613,
                          name: "underlyingToken_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93593,
                          src: "4625:16:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 93614,
                          name: "params",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93607,
                          src: "4643:6:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        ],
                        id: 93612,
                        name: "_validate",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94478,
                        src: "4615:9:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_address_$_t_struct$_VestingParams_$83438_memory_ptr_$returns$_t_bool_$",
                          typeString: "function (address,struct ILinearVesting.VestingParams memory) pure returns (bool)"
                        }
                      },
                      id: 93615,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "4615:35:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "66616c7365",
                      id: 93616,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "4654:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    src: "4615:44:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93622,
                  nodeType: "IfStatement",
                  src: "4611:97:179",
                  trueBody: {
                    id: 93621,
                    nodeType: "Block",
                    src: "4661:47:179",
                    statements: [
                      {
                        errorCall: {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 93618,
                            name: "InvalidParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83429,
                            src: "4682:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 93619,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "4682:15:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93620,
                        nodeType: "RevertStatement",
                        src: "4675:22:179"
                      }
                    ]
                  }
                },
                {
                  assignments: [93624, 93626],
                  declarations: [
                    {
                      constant: false,
                      id: 93624,
                      mutability: "mutable",
                      name: "tokenId",
                      nameLocation: "4778:7:179",
                      nodeType: "VariableDeclaration",
                      scope: 93637,
                      src: "4770:15:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 93623,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "4770:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 93626,
                      mutability: "mutable",
                      name: "wrappedAddress",
                      nameLocation: "4795:14:179",
                      nodeType: "VariableDeclaration",
                      scope: 93637,
                      src: "4787:22:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      typeName: {
                        id: 93625,
                        name: "address",
                        nodeType: "ElementaryTypeName",
                        src: "4787:7:179",
                        stateMutability: "nonpayable",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93632,
                  initialValue: {
                    arguments: [
                      {
                        id: 93628,
                        name: "underlyingToken_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93593,
                        src: "4841:16:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 93629,
                        name: "params",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93607,
                        src: "4859:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      {
                        id: 93630,
                        name: "wrapped_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93597,
                        src: "4867:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 93627,
                      name: "_deployIfNeeded",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94773,
                      src: "4825:15:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_struct$_VestingParams_$83438_memory_ptr_$_t_bool_$returns$_t_uint256_$_t_address_$",
                        typeString: "function (address,struct ILinearVesting.VestingParams memory,bool) returns (uint256,address)"
                      }
                    },
                    id: 93631,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "4825:51:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_address_$",
                      typeString: "tuple(uint256,address)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "4769:107:179"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 93633,
                        name: "tokenId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93624,
                        src: "4895:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 93634,
                        name: "wrappedAddress",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93626,
                        src: "4904:14:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    id: 93635,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "4894:25:179",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_address_$",
                      typeString: "tuple(uint256,address)"
                    }
                  },
                  functionReturnParameters: 93604,
                  id: 93636,
                  nodeType: "Return",
                  src: "4887:32:179"
                }
              ]
            },
            baseFunctions: [82907],
            documentation: {
              id: 93591,
              nodeType: "StructuredDocumentation",
              src: "3898:381:179",
              text: "@inheritdoc IDerivative\n @dev        This function performs the following:\n             - Validates the parameters\n             - Deploys the derivative token if it does not already exist\n             This function reverts if:\n             - The parameters are in an invalid format\n             - The parameters fail validation"
            },
            functionSelector: "1f54245b",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "deploy",
            nameLocation: "4293:6:179",
            overrides: {
              id: 93599,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "4410:8:179"
            },
            parameters: {
              id: 93598,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93593,
                  mutability: "mutable",
                  name: "underlyingToken_",
                  nameLocation: "4317:16:179",
                  nodeType: "VariableDeclaration",
                  scope: 93638,
                  src: "4309:24:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93592,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "4309:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93595,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "4356:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 93638,
                  src: "4343:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 93594,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "4343:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93597,
                  mutability: "mutable",
                  name: "wrapped_",
                  nameLocation: "4378:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93638,
                  src: "4373:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93596,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "4373:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4299:93:179"
            },
            returnParameters: {
              id: 93604,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93601,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "4436:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93638,
                  src: "4428:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93600,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "4428:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93603,
                  mutability: "mutable",
                  name: "wrappedAddress_",
                  nameLocation: "4454:15:179",
                  nodeType: "VariableDeclaration",
                  scope: 93638,
                  src: "4446:23:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93602,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "4446:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "4427:43:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 93754,
            nodeType: "FunctionDefinition",
            src: "5435:1379:179",
            nodes: [],
            body: {
              id: 93753,
              nodeType: "Block",
              src: "5598:1216:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    id: 93653,
                    name: "wrapped_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 93650,
                    src: "5718:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93660,
                  nodeType: "IfStatement",
                  src: "5714:76:179",
                  trueBody: {
                    id: 93659,
                    nodeType: "Block",
                    src: "5728:62:179",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 93655,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93643,
                              src: "5762:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 93656,
                              name: "token_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93648,
                              src: "5772:6:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            ],
                            id: 93654,
                            name: "_deployWrapIfNeeded",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94892,
                            src: "5742:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_struct$_Token_$82877_storage_ptr_$returns$_t_address_$",
                              typeString: "function (uint256,struct IDerivative.Token storage pointer) returns (address)"
                            }
                          },
                          id: 93657,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "5742:37:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        id: 93658,
                        nodeType: "ExpressionStatement",
                        src: "5742:37:179"
                      }
                    ]
                  }
                },
                {
                  id: 93709,
                  nodeType: "Block",
                  src: "5854:437:179",
                  statements: [
                    {
                      assignments: [93663],
                      declarations: [
                        {
                          constant: false,
                          id: 93663,
                          mutability: "mutable",
                          name: "baseToken",
                          nameLocation: "5874:9:179",
                          nodeType: "VariableDeclaration",
                          scope: 93709,
                          src: "5868:15:179",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_ERC20_$56264",
                            typeString: "contract ERC20"
                          },
                          typeName: {
                            id: 93662,
                            nodeType: "UserDefinedTypeName",
                            pathNode: {
                              id: 93661,
                              name: "ERC20",
                              nameLocations: ["5868:5:179"],
                              nodeType: "IdentifierPath",
                              referencedDeclaration: 56264,
                              src: "5868:5:179"
                            },
                            referencedDeclaration: 56264,
                            src: "5868:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ERC20_$56264",
                              typeString: "contract ERC20"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 93668,
                      initialValue: {
                        arguments: [
                          {
                            expression: {
                              id: 93665,
                              name: "token_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93648,
                              src: "5892:6:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 93666,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "5899:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "5892:22:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 93664,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "5886:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 93667,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "5886:29:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "5868:47:179"
                    },
                    {
                      assignments: [93670],
                      declarations: [
                        {
                          constant: false,
                          id: 93670,
                          mutability: "mutable",
                          name: "balanceBefore",
                          nameLocation: "5937:13:179",
                          nodeType: "VariableDeclaration",
                          scope: 93709,
                          src: "5929:21:179",
                          stateVariable: false,
                          storageLocation: "default",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          typeName: {
                            id: 93669,
                            name: "uint256",
                            nodeType: "ElementaryTypeName",
                            src: "5929:7:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          visibility: "internal"
                        }
                      ],
                      id: 93678,
                      initialValue: {
                        arguments: [
                          {
                            arguments: [
                              {
                                id: 93675,
                                name: "this",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -28,
                                src: "5981:4:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_contract$_LinearVesting_$95102",
                                  typeString: "contract LinearVesting"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_contract$_LinearVesting_$95102",
                                  typeString: "contract LinearVesting"
                                }
                              ],
                              id: 93674,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "5973:7:179",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_address_$",
                                typeString: "type(address)"
                              },
                              typeName: {
                                id: 93673,
                                name: "address",
                                nodeType: "ElementaryTypeName",
                                src: "5973:7:179",
                                typeDescriptions: {}
                              }
                            },
                            id: 93676,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "5973:13:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          expression: {
                            id: 93671,
                            name: "baseToken",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93663,
                            src: "5953:9:179",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ERC20_$56264",
                              typeString: "contract ERC20"
                            }
                          },
                          id: 93672,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "5963:9:179",
                          memberName: "balanceOf",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 55907,
                          src: "5953:19:179",
                          typeDescriptions: {
                            typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                            typeString: "function (address) view external returns (uint256)"
                          }
                        },
                        id: 93677,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "5953:34:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "VariableDeclarationStatement",
                      src: "5929:58:179"
                    },
                    {
                      expression: {
                        arguments: [
                          {
                            expression: {
                              id: 93682,
                              name: "msg",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -15,
                              src: "6028:3:179",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_message",
                                typeString: "msg"
                              }
                            },
                            id: 93683,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6032:6:179",
                            memberName: "sender",
                            nodeType: "MemberAccess",
                            src: "6028:10:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          {
                            arguments: [
                              {
                                id: 93686,
                                name: "this",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -28,
                                src: "6048:4:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_contract$_LinearVesting_$95102",
                                  typeString: "contract LinearVesting"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_contract$_LinearVesting_$95102",
                                  typeString: "contract LinearVesting"
                                }
                              ],
                              id: 93685,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "6040:7:179",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_address_$",
                                typeString: "type(address)"
                              },
                              typeName: {
                                id: 93684,
                                name: "address",
                                nodeType: "ElementaryTypeName",
                                src: "6040:7:179",
                                typeDescriptions: {}
                              }
                            },
                            id: 93687,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6040:13:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          {
                            id: 93688,
                            name: "amount_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93645,
                            src: "6055:7:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            },
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            },
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          expression: {
                            id: 93679,
                            name: "baseToken",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93663,
                            src: "6001:9:179",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ERC20_$56264",
                              typeString: "contract ERC20"
                            }
                          },
                          id: 93681,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "6011:16:179",
                          memberName: "safeTransferFrom",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 56812,
                          src: "6001:26:179",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_address_$_t_uint256_$returns$__$attached_to$_t_contract$_ERC20_$56264_$",
                            typeString: "function (contract ERC20,address,address,uint256)"
                          }
                        },
                        id: 93689,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "6001:62:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_tuple$__$",
                          typeString: "tuple()"
                        }
                      },
                      id: 93690,
                      nodeType: "ExpressionStatement",
                      src: "6001:62:179"
                    },
                    {
                      condition: {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 93701,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  id: 93695,
                                  name: "this",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: "6167:4:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_LinearVesting_$95102",
                                    typeString: "contract LinearVesting"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_LinearVesting_$95102",
                                    typeString: "contract LinearVesting"
                                  }
                                ],
                                id: 93694,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "6159:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 93693,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "6159:7:179",
                                  typeDescriptions: {}
                                }
                              },
                              id: 93696,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "6159:13:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            expression: {
                              id: 93691,
                              name: "baseToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93663,
                              src: "6139:9:179",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            id: 93692,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6149:9:179",
                            memberName: "balanceOf",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 55907,
                            src: "6139:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                              typeString: "function (address) view external returns (uint256)"
                            }
                          },
                          id: 93697,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6139:34:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "<",
                        rightExpression: {
                          commonType: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          },
                          id: 93700,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            id: 93698,
                            name: "balanceBefore",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93670,
                            src: "6176:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "+",
                          rightExpression: {
                            id: 93699,
                            name: "amount_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93645,
                            src: "6192:7:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "6176:23:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "6139:60:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      id: 93708,
                      nodeType: "IfStatement",
                      src: "6135:146:179",
                      trueBody: {
                        id: 93707,
                        nodeType: "Block",
                        src: "6201:80:179",
                        statements: [
                          {
                            errorCall: {
                              arguments: [
                                {
                                  expression: {
                                    id: 93703,
                                    name: "token_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93648,
                                    src: "6243:6:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                      typeString: "struct IDerivative.Token storage pointer"
                                    }
                                  },
                                  id: 93704,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "6250:15:179",
                                  memberName: "underlyingToken",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82872,
                                  src: "6243:22:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                ],
                                id: 93702,
                                name: "UnsupportedToken",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 83433,
                                src: "6226:16:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_function_error_pure$_t_address_$returns$__$",
                                  typeString: "function (address) pure"
                                }
                              },
                              id: 93705,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "functionCall",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "6226:40:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_tuple$__$",
                                typeString: "tuple()"
                              }
                            },
                            id: 93706,
                            nodeType: "RevertStatement",
                            src: "6219:47:179"
                          }
                        ]
                      }
                    }
                  ]
                },
                {
                  condition: {
                    id: 93710,
                    name: "wrapped_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 93650,
                    src: "6362:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 93751,
                    nodeType: "Block",
                    src: "6589:219:179",
                    statements: [
                      {
                        id: 93744,
                        nodeType: "UncheckedBlock",
                        src: "6639:67:179",
                        statements: [
                          {
                            expression: {
                              id: 93742,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 93738,
                                  name: "token_",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 93648,
                                  src: "6667:6:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                    typeString: "struct IDerivative.Token storage pointer"
                                  }
                                },
                                id: 93740,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "6674:6:179",
                                memberName: "supply",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 82874,
                                src: "6667:13:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "+=",
                              rightHandSide: {
                                id: 93741,
                                name: "amount_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 93645,
                                src: "6684:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "6667:24:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 93743,
                            nodeType: "ExpressionStatement",
                            src: "6667:24:179"
                          }
                        ]
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 93746,
                              name: "to_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93641,
                              src: "6774:3:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 93747,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93643,
                              src: "6779:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 93748,
                              name: "amount_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93645,
                              src: "6789:7:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            id: 93745,
                            name: "_mint",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 56552,
                            src: "6768:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$",
                              typeString: "function (address,uint256,uint256)"
                            }
                          },
                          id: 93749,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6768:29:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93750,
                        nodeType: "ExpressionStatement",
                        src: "6768:29:179"
                      }
                    ]
                  },
                  id: 93752,
                  nodeType: "IfStatement",
                  src: "6358:450:179",
                  trueBody: {
                    id: 93737,
                    nodeType: "Block",
                    src: "6372:211:179",
                    statements: [
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          id: 93717,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            expression: {
                              id: 93711,
                              name: "token_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93648,
                              src: "6390:6:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 93712,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6397:7:179",
                            memberName: "wrapped",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82870,
                            src: "6390:14:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            arguments: [
                              {
                                hexValue: "30",
                                id: 93715,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "6416:1:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_rational_0_by_1",
                                  typeString: "int_const 0"
                                },
                                value: "0"
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_rational_0_by_1",
                                  typeString: "int_const 0"
                                }
                              ],
                              id: 93714,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "6408:7:179",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_address_$",
                                typeString: "type(address)"
                              },
                              typeName: {
                                id: 93713,
                                name: "address",
                                nodeType: "ElementaryTypeName",
                                src: "6408:7:179",
                                typeDescriptions: {}
                              }
                            },
                            id: 93716,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6408:10:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "6390:28:179",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 93721,
                        nodeType: "IfStatement",
                        src: "6386:56:179",
                        trueBody: {
                          errorCall: {
                            arguments: [],
                            expression: {
                              argumentTypes: [],
                              id: 93718,
                              name: "InvalidParams",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 83429,
                              src: "6427:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_error_pure$__$returns$__$",
                                typeString: "function () pure"
                              }
                            },
                            id: 93719,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "6427:15:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_tuple$__$",
                              typeString: "tuple()"
                            }
                          },
                          id: 93720,
                          nodeType: "RevertStatement",
                          src: "6420:22:179"
                        }
                      },
                      {
                        assignments: [93724],
                        declarations: [
                          {
                            constant: false,
                            id: 93724,
                            mutability: "mutable",
                            name: "wrappedToken",
                            nameLocation: "6477:12:179",
                            nodeType: "VariableDeclaration",
                            scope: 93737,
                            src: "6457:32:179",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                              typeString: "contract SoulboundCloneERC20"
                            },
                            typeName: {
                              id: 93723,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 93722,
                                name: "SoulboundCloneERC20",
                                nameLocations: ["6457:19:179"],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 96086,
                                src: "6457:19:179"
                              },
                              referencedDeclaration: 96086,
                              src: "6457:19:179",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                                typeString: "contract SoulboundCloneERC20"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 93729,
                        initialValue: {
                          arguments: [
                            {
                              expression: {
                                id: 93726,
                                name: "token_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 93648,
                                src: "6512:6:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 93727,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "6519:7:179",
                              memberName: "wrapped",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82870,
                              src: "6512:14:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 93725,
                            name: "SoulboundCloneERC20",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 96086,
                            src: "6492:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_SoulboundCloneERC20_$96086_$",
                              typeString: "type(contract SoulboundCloneERC20)"
                            }
                          },
                          id: 93728,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6492:35:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                            typeString: "contract SoulboundCloneERC20"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "6457:70:179"
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 93733,
                              name: "to_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93641,
                              src: "6559:3:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 93734,
                              name: "amount_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93645,
                              src: "6564:7:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              id: 93730,
                              name: "wrappedToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93724,
                              src: "6541:12:179",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                                typeString: "contract SoulboundCloneERC20"
                              }
                            },
                            id: 93732,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "6554:4:179",
                            memberName: "mint",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 95986,
                            src: "6541:17:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$",
                              typeString: "function (address,uint256) external"
                            }
                          },
                          id: 93735,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "6541:31:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93736,
                        nodeType: "ExpressionStatement",
                        src: "6541:31:179"
                      }
                    ]
                  }
                }
              ]
            },
            documentation: {
              id: 93639,
              nodeType: "StructuredDocumentation",
              src: "4932:498:179",
              text: "@notice     Mints the derivative token to the recipient, assuming that the derivative token has already been deployed\n @param      to_         The address of the recipient of the derivative token\n @param      tokenId_    The ID of the derivative token\n @param      amount_     The amount of the derivative token to mint\n @param      token_      The metadata for the derivative token\n @param      wrapped_    Whether or not to wrap the derivative token"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_mintDeployed",
            nameLocation: "5444:13:179",
            parameters: {
              id: 93651,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93641,
                  mutability: "mutable",
                  name: "to_",
                  nameLocation: "5475:3:179",
                  nodeType: "VariableDeclaration",
                  scope: 93754,
                  src: "5467:11:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93640,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "5467:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93643,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "5496:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93754,
                  src: "5488:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93642,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5488:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93645,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "5522:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 93754,
                  src: "5514:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93644,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "5514:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93648,
                  mutability: "mutable",
                  name: "token_",
                  nameLocation: "5553:6:179",
                  nodeType: "VariableDeclaration",
                  scope: 93754,
                  src: "5539:20:179",
                  stateVariable: false,
                  storageLocation: "storage",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                    typeString: "struct IDerivative.Token"
                  },
                  typeName: {
                    id: 93647,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 93646,
                      name: "Token",
                      nameLocations: ["5539:5:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82877,
                      src: "5539:5:179"
                    },
                    referencedDeclaration: 82877,
                    src: "5539:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                      typeString: "struct IDerivative.Token"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93650,
                  mutability: "mutable",
                  name: "wrapped_",
                  nameLocation: "5574:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93754,
                  src: "5569:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93649,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "5569:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "5457:131:179"
            },
            returnParameters: {
              id: 93652,
              nodeType: "ParameterList",
              parameters: [],
              src: "5598:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 93831,
            nodeType: "FunctionDefinition",
            src: "7458:946:179",
            nodes: [],
            body: {
              id: 93830,
              nodeType: "Block",
              src: "7749:655:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 93777,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93775,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93763,
                      src: "7787:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 93776,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "7798:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "7787:12:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93781,
                  nodeType: "IfStatement",
                  src: "7783:40:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 93778,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "7808:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 93779,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "7808:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93780,
                    nodeType: "RevertStatement",
                    src: "7801:22:179"
                  }
                },
                {
                  assignments: [93784],
                  declarations: [
                    {
                      constant: false,
                      id: 93784,
                      mutability: "mutable",
                      name: "params",
                      nameLocation: "7884:6:179",
                      nodeType: "VariableDeclaration",
                      scope: 93830,
                      src: "7863:27:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 93783,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 93782,
                          name: "VestingParams",
                          nameLocations: ["7863:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "7863:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "7863:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93788,
                  initialValue: {
                    arguments: [
                      {
                        id: 93786,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93761,
                        src: "7914:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      ],
                      id: 93785,
                      name: "_decodeVestingParams",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94584,
                      src: "7893:20:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_struct$_VestingParams_$83438_memory_ptr_$",
                        typeString: "function (bytes memory) pure returns (struct ILinearVesting.VestingParams memory)"
                      }
                    },
                    id: 93787,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "7893:29:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "7863:59:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 93794,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      arguments: [
                        {
                          id: 93790,
                          name: "underlyingToken_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93759,
                          src: "7978:16:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 93791,
                          name: "params",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93784,
                          src: "7996:6:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        ],
                        id: 93789,
                        name: "_validate",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94478,
                        src: "7968:9:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_address_$_t_struct$_VestingParams_$83438_memory_ptr_$returns$_t_bool_$",
                          typeString: "function (address,struct ILinearVesting.VestingParams memory) pure returns (bool)"
                        }
                      },
                      id: 93792,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "7968:35:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "66616c7365",
                      id: 93793,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "8007:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    src: "7968:44:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93799,
                  nodeType: "IfStatement",
                  src: "7964:97:179",
                  trueBody: {
                    id: 93798,
                    nodeType: "Block",
                    src: "8014:47:179",
                    statements: [
                      {
                        errorCall: {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 93795,
                            name: "InvalidParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83429,
                            src: "8035:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 93796,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "8035:15:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93797,
                        nodeType: "RevertStatement",
                        src: "8028:22:179"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 93807,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      components: [
                        {
                          id: 93800,
                          name: "tokenId_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93769,
                          src: "8123:8:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        null
                      ],
                      id: 93801,
                      isConstant: false,
                      isInlineArray: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "TupleExpression",
                      src: "8122:11:179",
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_uint256_$__$",
                        typeString: "tuple(uint256,)"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 93803,
                          name: "underlyingToken_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93759,
                          src: "8152:16:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        {
                          id: 93804,
                          name: "params",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93784,
                          src: "8170:6:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        {
                          id: 93805,
                          name: "wrapped_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93765,
                          src: "8178:8:179",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          },
                          {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        ],
                        id: 93802,
                        name: "_deployIfNeeded",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94773,
                        src: "8136:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_struct$_VestingParams_$83438_memory_ptr_$_t_bool_$returns$_t_uint256_$_t_address_$",
                          typeString: "function (address,struct ILinearVesting.VestingParams memory,bool) returns (uint256,address)"
                        }
                      },
                      id: 93806,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "8136:51:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$_t_uint256_$_t_address_$",
                        typeString: "tuple(uint256,address)"
                      }
                    },
                    src: "8122:65:179",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93808,
                  nodeType: "ExpressionStatement",
                  src: "8122:65:179"
                },
                {
                  assignments: [93811],
                  declarations: [
                    {
                      constant: false,
                      id: 93811,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "8249:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 93830,
                      src: "8235:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 93810,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 93809,
                          name: "Token",
                          nameLocations: ["8235:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "8235:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "8235:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93815,
                  initialValue: {
                    baseExpression: {
                      id: 93812,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "8257:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 93814,
                    indexExpression: {
                      id: 93813,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93769,
                      src: "8271:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "8257:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "8235:45:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 93817,
                        name: "to_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93757,
                        src: "8305:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 93818,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93769,
                        src: "8310:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 93819,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93763,
                        src: "8320:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 93820,
                        name: "token",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93811,
                        src: "8329:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        }
                      },
                      {
                        id: 93821,
                        name: "wrapped_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93765,
                        src: "8336:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 93816,
                      name: "_mintDeployed",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93754,
                      src: "8291:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_uint256_$_t_struct$_Token_$82877_storage_ptr_$_t_bool_$returns$__$",
                        typeString: "function (address,uint256,uint256,struct IDerivative.Token storage pointer,bool)"
                      }
                    },
                    id: 93822,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "8291:54:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93823,
                  nodeType: "ExpressionStatement",
                  src: "8291:54:179"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 93824,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93769,
                        src: "8364:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 93825,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93811,
                          src: "8374:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 93826,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "8380:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "8374:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 93827,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93763,
                        src: "8389:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    id: 93828,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "8363:34:179",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_address_$_t_uint256_$",
                      typeString: "tuple(uint256,address,uint256)"
                    }
                  },
                  functionReturnParameters: 93774,
                  id: 93829,
                  nodeType: "Return",
                  src: "8356:41:179"
                }
              ]
            },
            baseFunctions: [82927],
            documentation: {
              id: 93755,
              nodeType: "StructuredDocumentation",
              src: "6820:633:179",
              text: "@inheritdoc IDerivative\n @dev        This function performs the following:\n             - Validates the parameters\n             - Deploys the derivative token if it does not already exist\n             - Mints the derivative token to the recipient\n             This function reverts if:\n             - The parameters are in an invalid format\n             - The parameters fail validation\n             - `amount_` is 0\n             A derivative token can be minted after vesting expiry, which prevents mitigates problems with auctions that settle late."
            },
            functionSelector: "e40d88f8",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "mint",
            nameLocation: "7467:4:179",
            overrides: {
              id: 93767,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "7652:8:179"
            },
            parameters: {
              id: 93766,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93757,
                  mutability: "mutable",
                  name: "to_",
                  nameLocation: "7489:3:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7481:11:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93756,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "7481:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93759,
                  mutability: "mutable",
                  name: "underlyingToken_",
                  nameLocation: "7510:16:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7502:24:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93758,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "7502:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93761,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "7549:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7536:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 93760,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "7536:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93763,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "7574:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7566:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93762,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "7566:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93765,
                  mutability: "mutable",
                  name: "wrapped_",
                  nameLocation: "7596:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7591:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93764,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "7591:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "7471:139:179"
            },
            returnParameters: {
              id: 93774,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93769,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "7686:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7678:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93768,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "7678:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93771,
                  mutability: "mutable",
                  name: "wrappedAddress_",
                  nameLocation: "7704:15:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7696:23:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93770,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "7696:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93773,
                  mutability: "mutable",
                  name: "amountCreated_",
                  nameLocation: "7729:14:179",
                  nodeType: "VariableDeclaration",
                  scope: 93831,
                  src: "7721:22:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93772,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "7721:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "7677:67:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 93882,
            nodeType: "FunctionDefinition",
            src: "8863:458:179",
            nodes: [],
            body: {
              id: 93881,
              nodeType: "Block",
              src: "9067:254:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 93855,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93853,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93838,
                      src: "9105:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 93854,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "9116:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "9105:12:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93859,
                  nodeType: "IfStatement",
                  src: "9101:40:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 93856,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "9126:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 93857,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "9126:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 93858,
                    nodeType: "RevertStatement",
                    src: "9119:22:179"
                  }
                },
                {
                  assignments: [93862],
                  declarations: [
                    {
                      constant: false,
                      id: 93862,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "9166:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 93881,
                      src: "9152:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 93861,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 93860,
                          name: "Token",
                          nameLocations: ["9152:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "9152:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "9152:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93866,
                  initialValue: {
                    baseExpression: {
                      id: 93863,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "9174:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 93865,
                    indexExpression: {
                      id: 93864,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93836,
                      src: "9188:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "9174:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9152:45:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 93868,
                        name: "to_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93834,
                        src: "9222:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 93869,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93836,
                        src: "9227:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 93870,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93838,
                        src: "9237:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 93871,
                        name: "token",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93862,
                        src: "9246:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        }
                      },
                      {
                        id: 93872,
                        name: "wrapped_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93840,
                        src: "9253:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        },
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      ],
                      id: 93867,
                      name: "_mintDeployed",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93754,
                      src: "9208:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_uint256_$_t_struct$_Token_$82877_storage_ptr_$_t_bool_$returns$__$",
                        typeString: "function (address,uint256,uint256,struct IDerivative.Token storage pointer,bool)"
                      }
                    },
                    id: 93873,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "9208:54:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93874,
                  nodeType: "ExpressionStatement",
                  src: "9208:54:179"
                },
                {
                  expression: {
                    components: [
                      {
                        id: 93875,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93836,
                        src: "9281:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 93876,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93862,
                          src: "9291:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 93877,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "9297:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "9291:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 93878,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93838,
                        src: "9306:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    id: 93879,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "9280:34:179",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_address_$_t_uint256_$",
                      typeString: "tuple(uint256,address,uint256)"
                    }
                  },
                  functionReturnParameters: 93852,
                  id: 93880,
                  nodeType: "Return",
                  src: "9273:41:179"
                }
              ]
            },
            baseFunctions: [82945],
            documentation: {
              id: 93832,
              nodeType: "StructuredDocumentation",
              src: "8410:448:179",
              text: "@inheritdoc IDerivative\n @dev        This function performs the following:\n             - Mints the derivative token to the recipient\n             This function reverts if:\n             - `tokenId_` does not exist\n             - The amount to mint is 0\n             A derivative token can be minted after vesting expiry, which prevents mitigates problems with auctions that settle late."
            },
            functionSelector: "dbf110a7",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 93844,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 93836,
                    src: "9021:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 93845,
                kind: "modifierInvocation",
                modifierName: {
                  id: 93843,
                  name: "onlyValidTokenId",
                  nameLocations: ["9004:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "9004:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "9004:26:179"
              }
            ],
            name: "mint",
            nameLocation: "8872:4:179",
            overrides: {
              id: 93842,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "8995:8:179"
            },
            parameters: {
              id: 93841,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93834,
                  mutability: "mutable",
                  name: "to_",
                  nameLocation: "8894:3:179",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "8886:11:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93833,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "8886:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93836,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "8915:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "8907:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93835,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "8907:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93838,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "8941:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "8933:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93837,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "8933:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93840,
                  mutability: "mutable",
                  name: "wrapped_",
                  nameLocation: "8963:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "8958:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 93839,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "8958:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "8876:101:179"
            },
            returnParameters: {
              id: 93852,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93847,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "9040:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93846,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9040:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93849,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "9049:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93848,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "9049:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93851,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 93882,
                  src: "9058:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93850,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9058:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9039:27:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94005,
            nodeType: "FunctionDefinition",
            src: "9720:1360:179",
            nodes: [],
            body: {
              id: 94004,
              nodeType: "Block",
              src: "9796:1284:179",
              nodes: [],
              statements: [
                {
                  assignments: [93894],
                  declarations: [
                    {
                      constant: false,
                      id: 93894,
                      mutability: "mutable",
                      name: "tokenData",
                      nameLocation: "9820:9:179",
                      nodeType: "VariableDeclaration",
                      scope: 94004,
                      src: "9806:23:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 93893,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 93892,
                          name: "Token",
                          nameLocations: ["9806:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "9806:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "9806:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93898,
                  initialValue: {
                    baseExpression: {
                      id: 93895,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "9832:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 93897,
                    indexExpression: {
                      id: 93896,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93885,
                      src: "9846:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "9832:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9806:49:179"
                },
                {
                  assignments: [93900],
                  declarations: [
                    {
                      constant: false,
                      id: 93900,
                      mutability: "mutable",
                      name: "derivativeBalance",
                      nameLocation: "9916:17:179",
                      nodeType: "VariableDeclaration",
                      scope: 94004,
                      src: "9908:25:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 93899,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "9908:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93906,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 93901,
                        name: "balanceOf",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 56309,
                        src: "9936:9:179",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
                          typeString: "mapping(address => mapping(uint256 => uint256))"
                        }
                      },
                      id: 93903,
                      indexExpression: {
                        id: 93902,
                        name: "user_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93887,
                        src: "9946:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "9936:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                        typeString: "mapping(uint256 => uint256)"
                      }
                    },
                    id: 93905,
                    indexExpression: {
                      id: 93904,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93885,
                      src: "9953:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "9936:26:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9908:54:179"
                },
                {
                  assignments: [93908],
                  declarations: [
                    {
                      constant: false,
                      id: 93908,
                      mutability: "mutable",
                      name: "wrappedBalance",
                      nameLocation: "9980:14:179",
                      nodeType: "VariableDeclaration",
                      scope: 94004,
                      src: "9972:22:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 93907,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "9972:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93925,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      id: 93915,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 93909,
                          name: "tokenData",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93894,
                          src: "9997:9:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 93910,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "10007:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "9997:17:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        arguments: [
                          {
                            hexValue: "30",
                            id: 93913,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "10026:1:179",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            }
                          ],
                          id: 93912,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "10018:7:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_address_$",
                            typeString: "type(address)"
                          },
                          typeName: {
                            id: 93911,
                            name: "address",
                            nodeType: "ElementaryTypeName",
                            src: "10018:7:179",
                            typeDescriptions: {}
                          }
                        },
                        id: 93914,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "10018:10:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      src: "9997:31:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      arguments: [
                        {
                          id: 93922,
                          name: "user_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93887,
                          src: "10108:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        expression: {
                          arguments: [
                            {
                              expression: {
                                id: 93918,
                                name: "tokenData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 93894,
                                src: "10079:9:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 93919,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "10089:7:179",
                              memberName: "wrapped",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82870,
                              src: "10079:17:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 93917,
                            name: "SoulboundCloneERC20",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 96086,
                            src: "10059:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_SoulboundCloneERC20_$96086_$",
                              typeString: "type(contract SoulboundCloneERC20)"
                            }
                          },
                          id: 93920,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "10059:38:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                            typeString: "contract SoulboundCloneERC20"
                          }
                        },
                        id: 93921,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "10098:9:179",
                        memberName: "balanceOf",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 86381,
                        src: "10059:48:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                          typeString: "function (address) view external returns (uint256)"
                        }
                      },
                      id: 93923,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "10059:55:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 93924,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "9997:117:179",
                    trueExpression: {
                      hexValue: "30",
                      id: 93916,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "10043:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "9972:142:179"
                },
                {
                  assignments: [93927],
                  declarations: [
                    {
                      constant: false,
                      id: 93927,
                      mutability: "mutable",
                      name: "derivativeToBurn",
                      nameLocation: "10133:16:179",
                      nodeType: "VariableDeclaration",
                      scope: 94004,
                      src: "10125:24:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 93926,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "10125:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93934,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 93930,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 93928,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93889,
                        src: "10152:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: ">",
                      rightExpression: {
                        id: 93929,
                        name: "derivativeBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93900,
                        src: "10162:17:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "10152:27:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      id: 93932,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93889,
                      src: "10202:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 93933,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "10152:57:179",
                    trueExpression: {
                      id: 93931,
                      name: "derivativeBalance",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93900,
                      src: "10182:17:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "10125:84:179"
                },
                {
                  assignments: [93936],
                  declarations: [
                    {
                      constant: false,
                      id: 93936,
                      mutability: "mutable",
                      name: "wrappedToBurn",
                      nameLocation: "10227:13:179",
                      nodeType: "VariableDeclaration",
                      scope: 94004,
                      src: "10219:21:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 93935,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "10219:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 93940,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 93939,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93937,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93889,
                      src: "10243:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "-",
                    rightExpression: {
                      id: 93938,
                      name: "derivativeToBurn",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93927,
                      src: "10253:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "10243:26:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "10219:50:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 93943,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93941,
                      name: "wrappedToBurn",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93936,
                      src: "10283:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      id: 93942,
                      name: "wrappedBalance",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93908,
                      src: "10299:14:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "10283:30:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93948,
                  nodeType: "IfStatement",
                  src: "10279:89:179",
                  trueBody: {
                    id: 93947,
                    nodeType: "Block",
                    src: "10315:53:179",
                    statements: [
                      {
                        errorCall: {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 93944,
                            name: "InsufficientBalance",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83425,
                            src: "10336:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 93945,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "10336:21:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93946,
                        nodeType: "RevertStatement",
                        src: "10329:28:179"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 93955,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      baseExpression: {
                        baseExpression: {
                          id: 93949,
                          name: "userClaimed",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93452,
                          src: "10422:11:179",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
                            typeString: "mapping(address => mapping(uint256 => uint256))"
                          }
                        },
                        id: 93952,
                        indexExpression: {
                          id: 93950,
                          name: "user_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 93887,
                          src: "10434:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "10422:18:179",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                          typeString: "mapping(uint256 => uint256)"
                        }
                      },
                      id: 93953,
                      indexExpression: {
                        id: 93951,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93885,
                        src: "10441:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: true,
                      nodeType: "IndexAccess",
                      src: "10422:28:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "+=",
                    rightHandSide: {
                      id: 93954,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93889,
                      src: "10454:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "10422:39:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 93956,
                  nodeType: "ExpressionStatement",
                  src: "10422:39:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 93959,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93957,
                      name: "derivativeToBurn",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93927,
                      src: "10513:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      hexValue: "30",
                      id: 93958,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "10532:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "10513:20:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93974,
                  nodeType: "IfStatement",
                  src: "10509:183:179",
                  trueBody: {
                    id: 93973,
                    nodeType: "Block",
                    src: "10535:157:179",
                    statements: [
                      {
                        id: 93966,
                        nodeType: "UncheckedBlock",
                        src: "10549:79:179",
                        statements: [
                          {
                            expression: {
                              id: 93964,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              leftHandSide: {
                                expression: {
                                  id: 93960,
                                  name: "tokenData",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 93894,
                                  src: "10577:9:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                    typeString: "struct IDerivative.Token storage pointer"
                                  }
                                },
                                id: 93962,
                                isConstant: false,
                                isLValue: true,
                                isPure: false,
                                lValueRequested: true,
                                memberLocation: "10587:6:179",
                                memberName: "supply",
                                nodeType: "MemberAccess",
                                referencedDeclaration: 82874,
                                src: "10577:16:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              nodeType: "Assignment",
                              operator: "-=",
                              rightHandSide: {
                                id: 93963,
                                name: "derivativeToBurn",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 93927,
                                src: "10597:16:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              src: "10577:36:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            id: 93965,
                            nodeType: "ExpressionStatement",
                            src: "10577:36:179"
                          }
                        ]
                      },
                      {
                        expression: {
                          arguments: [
                            {
                              id: 93968,
                              name: "user_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93887,
                              src: "10647:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 93969,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93885,
                              src: "10654:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 93970,
                              name: "derivativeToBurn",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93927,
                              src: "10664:16:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            id: 93967,
                            name: "_burn",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 56582,
                            src: "10641:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$",
                              typeString: "function (address,uint256,uint256)"
                            }
                          },
                          id: 93971,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "10641:40:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93972,
                        nodeType: "ExpressionStatement",
                        src: "10641:40:179"
                      }
                    ]
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 93977,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 93975,
                      name: "wrappedToBurn",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93936,
                      src: "10767:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">",
                    rightExpression: {
                      hexValue: "30",
                      id: 93976,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "10783:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "10767:17:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 93988,
                  nodeType: "IfStatement",
                  src: "10763:113:179",
                  trueBody: {
                    id: 93987,
                    nodeType: "Block",
                    src: "10786:90:179",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 93983,
                              name: "user_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93887,
                              src: "10844:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              id: 93984,
                              name: "wrappedToBurn",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93936,
                              src: "10851:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            ],
                            expression: {
                              arguments: [
                                {
                                  expression: {
                                    id: 93979,
                                    name: "tokenData",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 93894,
                                    src: "10820:9:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                      typeString: "struct IDerivative.Token storage pointer"
                                    }
                                  },
                                  id: 93980,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "10830:7:179",
                                  memberName: "wrapped",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 82870,
                                  src: "10820:17:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_address",
                                    typeString: "address"
                                  }
                                ],
                                id: 93978,
                                name: "SoulboundCloneERC20",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 96086,
                                src: "10800:19:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_contract$_SoulboundCloneERC20_$96086_$",
                                  typeString: "type(contract SoulboundCloneERC20)"
                                }
                              },
                              id: 93981,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "10800:38:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                                typeString: "contract SoulboundCloneERC20"
                              }
                            },
                            id: 93982,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "10839:4:179",
                            memberName: "burn",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 96002,
                            src: "10800:43:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$",
                              typeString: "function (address,uint256) external"
                            }
                          },
                          id: 93985,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "10800:65:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 93986,
                        nodeType: "ExpressionStatement",
                        src: "10800:65:179"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 93994,
                        name: "user_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93887,
                        src: "10986:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 93995,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93889,
                        src: "10993:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        arguments: [
                          {
                            expression: {
                              id: 93990,
                              name: "tokenData",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 93894,
                              src: "10946:9:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 93991,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "10956:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "10946:25:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 93989,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "10940:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 93992,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "10940:32:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      id: 93993,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "10973:12:179",
                      memberName: "safeTransfer",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 56832,
                      src: "10940:45:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_contract$_ERC20_$56264_$_t_address_$_t_uint256_$returns$__$attached_to$_t_contract$_ERC20_$56264_$",
                        typeString: "function (contract ERC20,address,uint256)"
                      }
                    },
                    id: 93996,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "10940:61:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 93997,
                  nodeType: "ExpressionStatement",
                  src: "10940:61:179"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 93999,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93885,
                        src: "11048:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 94e3,
                        name: "user_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93887,
                        src: "11058:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94001,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93889,
                        src: "11065:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 93998,
                      name: "Redeemed",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83421,
                      src: "11039:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint256_$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (uint256,address,uint256)"
                      }
                    },
                    id: 94002,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11039:34:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94003,
                  nodeType: "EmitStatement",
                  src: "11034:39:179"
                }
              ]
            },
            documentation: {
              id: 93883,
              nodeType: "StructuredDocumentation",
              src: "9327:388:179",
              text: "@notice     Redeems the derivative token for the underlying base token\n @dev        This function assumes that validation has already been performed\n @param      tokenId_    The ID of the derivative token\n @param      user_       The address of the owner of the derivative token\n @param      amount_     The amount of the derivative token to redeem"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_redeem",
            nameLocation: "9729:7:179",
            parameters: {
              id: 93890,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 93885,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "9745:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94005,
                  src: "9737:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93884,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9737:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93887,
                  mutability: "mutable",
                  name: "user_",
                  nameLocation: "9763:5:179",
                  nodeType: "VariableDeclaration",
                  scope: 94005,
                  src: "9755:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 93886,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "9755:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 93889,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "9778:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94005,
                  src: "9770:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 93888,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "9770:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "9736:50:179"
            },
            returnParameters: {
              id: 93891,
              nodeType: "ParameterList",
              parameters: [],
              src: "9796:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94038,
            nodeType: "FunctionDefinition",
            src: "11118:411:179",
            nodes: [],
            body: {
              id: 94037,
              nodeType: "Block",
              src: "11208:321:179",
              nodes: [],
              statements: [
                {
                  assignments: [94016],
                  declarations: [
                    {
                      constant: false,
                      id: 94016,
                      mutability: "mutable",
                      name: "redeemableAmount",
                      nameLocation: "11269:16:179",
                      nodeType: "VariableDeclaration",
                      scope: 94037,
                      src: "11261:24:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94015,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "11261:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94022,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 94018,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "11299:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94019,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "11303:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "11299:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94020,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94008,
                        src: "11311:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 94017,
                      name: "redeemable",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94209,
                      src: "11288:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_address_$_t_uint256_$returns$_t_uint256_$",
                        typeString: "function (address,uint256) view returns (uint256)"
                      }
                    },
                    id: 94021,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11288:32:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "11261:59:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94025,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94023,
                      name: "redeemableAmount",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94016,
                      src: "11384:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 94024,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "11404:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "11384:21:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94029,
                  nodeType: "IfStatement",
                  src: "11380:55:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94026,
                        name: "InsufficientBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83425,
                        src: "11414:19:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94027,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "11414:21:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94028,
                    nodeType: "RevertStatement",
                    src: "11407:28:179"
                  }
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 94031,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94008,
                        src: "11483:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94032,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "11493:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94033,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "11497:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "11493:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94034,
                        name: "redeemableAmount",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94016,
                        src: "11505:16:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 94030,
                      name: "_redeem",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94005,
                      src: "11475:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (uint256,address,uint256)"
                      }
                    },
                    id: 94035,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "11475:47:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94036,
                  nodeType: "ExpressionStatement",
                  src: "11475:47:179"
                }
              ]
            },
            baseFunctions: [82951],
            documentation: {
              id: 94006,
              nodeType: "StructuredDocumentation",
              src: "11086:27:179",
              text: "@inheritdoc IDerivative"
            },
            functionSelector: "f904eed8",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94012,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94008,
                    src: "11198:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94013,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94011,
                  name: "onlyValidTokenId",
                  nameLocations: ["11181:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "11181:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "11181:26:179"
              }
            ],
            name: "redeemMax",
            nameLocation: "11127:9:179",
            overrides: {
              id: 94010,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "11172:8:179"
            },
            parameters: {
              id: 94009,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94008,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "11145:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94038,
                  src: "11137:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94007,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11137:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11136:18:179"
            },
            returnParameters: {
              id: 94014,
              nodeType: "ParameterList",
              parameters: [],
              src: "11208:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94080,
            nodeType: "FunctionDefinition",
            src: "11798:517:179",
            nodes: [],
            body: {
              id: 94079,
              nodeType: "Block",
              src: "11924:391:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94052,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94050,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94043,
                      src: "11938:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 94051,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "11949:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "11938:12:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94056,
                  nodeType: "IfStatement",
                  src: "11934:40:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94053,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "11959:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94054,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "11959:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94055,
                    nodeType: "RevertStatement",
                    src: "11952:22:179"
                  }
                },
                {
                  assignments: [94058],
                  declarations: [
                    {
                      constant: false,
                      id: 94058,
                      mutability: "mutable",
                      name: "redeemableAmount",
                      nameLocation: "12030:16:179",
                      nodeType: "VariableDeclaration",
                      scope: 94079,
                      src: "12022:24:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94057,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "12022:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94064,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 94060,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "12060:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94061,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "12064:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "12060:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94062,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94041,
                        src: "12072:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 94059,
                      name: "redeemable",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94209,
                      src: "12049:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_address_$_t_uint256_$returns$_t_uint256_$",
                        typeString: "function (address,uint256) view returns (uint256)"
                      }
                    },
                    id: 94063,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "12049:32:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12022:59:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94067,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94065,
                      name: "redeemableAmount",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94058,
                      src: "12174:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 94066,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94043,
                      src: "12193:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "12174:26:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94071,
                  nodeType: "IfStatement",
                  src: "12170:60:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94068,
                        name: "InsufficientBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83425,
                        src: "12209:19:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94069,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "12209:21:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94070,
                    nodeType: "RevertStatement",
                    src: "12202:28:179"
                  }
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 94073,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94041,
                        src: "12278:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94074,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "12288:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94075,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "12292:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "12288:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94076,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94043,
                        src: "12300:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 94072,
                      name: "_redeem",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94005,
                      src: "12270:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (uint256,address,uint256)"
                      }
                    },
                    id: 94077,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "12270:38:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94078,
                  nodeType: "ExpressionStatement",
                  src: "12270:38:179"
                }
              ]
            },
            baseFunctions: [82959],
            documentation: {
              id: 94039,
              nodeType: "StructuredDocumentation",
              src: "11535:258:179",
              text: "@inheritdoc IDerivative\n @dev        This function reverts if:\n             - `amount_` is 0\n             - The redeemable amount is less than `amount_`\n             - The derivative token with `tokenId_` has not been deployed"
            },
            functionSelector: "7cbc2373",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94047,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94041,
                    src: "11914:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94048,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94046,
                  name: "onlyValidTokenId",
                  nameLocations: ["11897:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "11897:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "11897:26:179"
              }
            ],
            name: "redeem",
            nameLocation: "11807:6:179",
            overrides: {
              id: 94045,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "11888:8:179"
            },
            parameters: {
              id: 94044,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94041,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "11831:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94080,
                  src: "11823:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94040,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11823:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94043,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "11857:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94080,
                  src: "11849:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94042,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "11849:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "11813:57:179"
            },
            returnParameters: {
              id: 94049,
              nodeType: "ParameterList",
              parameters: [],
              src: "11924:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94209,
            nodeType: "FunctionDefinition",
            src: "12792:1518:179",
            nodes: [],
            body: {
              id: 94208,
              nodeType: "Block",
              src: "12942:1368:179",
              nodes: [],
              statements: [
                {
                  assignments: [94096],
                  declarations: [
                    {
                      constant: false,
                      id: 94096,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "12998:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "12984:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94095,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94094,
                          name: "Token",
                          nameLocations: ["12984:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "12984:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "12984:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94100,
                  initialValue: {
                    baseExpression: {
                      id: 94097,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "13006:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94099,
                    indexExpression: {
                      id: 94098,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94085,
                      src: "13020:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "13006:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "12984:45:179"
                },
                {
                  assignments: [94103],
                  declarations: [
                    {
                      constant: false,
                      id: 94103,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "13060:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "13039:25:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 94102,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94101,
                          name: "VestingParams",
                          nameLocations: ["13039:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "13039:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "13039:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94111,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 94106,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94096,
                          src: "13078:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94107,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "13084:4:179",
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82876,
                        src: "13078:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        }
                      },
                      {
                        components: [
                          {
                            id: 94108,
                            name: "VestingParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83438,
                            src: "13091:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                              typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                            }
                          }
                        ],
                        id: 94109,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "13090:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 94104,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "13067:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 94105,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "13071:6:179",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "13067:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94110,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "13067:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13039:67:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94116,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94112,
                        name: "block",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -4,
                        src: "13160:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_block",
                          typeString: "block"
                        }
                      },
                      id: 94113,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "13166:9:179",
                      memberName: "timestamp",
                      nodeType: "MemberAccess",
                      src: "13160:15:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<=",
                    rightExpression: {
                      expression: {
                        id: 94114,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94103,
                        src: "13179:4:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      id: 94115,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "13184:5:179",
                      memberName: "start",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83435,
                      src: "13179:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "13160:29:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94119,
                  nodeType: "IfStatement",
                  src: "13156:43:179",
                  trueBody: {
                    expression: {
                      hexValue: "30",
                      id: 94117,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "13198:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    functionReturnParameters: 94093,
                    id: 94118,
                    nodeType: "Return",
                    src: "13191:8:179"
                  }
                },
                {
                  assignments: [94121],
                  declarations: [
                    {
                      constant: false,
                      id: 94121,
                      mutability: "mutable",
                      name: "derivativeBalance",
                      nameLocation: "13242:17:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "13234:25:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94120,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13234:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94127,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 94122,
                        name: "balanceOf",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 56309,
                        src: "13262:9:179",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
                          typeString: "mapping(address => mapping(uint256 => uint256))"
                        }
                      },
                      id: 94124,
                      indexExpression: {
                        id: 94123,
                        name: "owner_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94083,
                        src: "13272:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "13262:17:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                        typeString: "mapping(uint256 => uint256)"
                      }
                    },
                    id: 94126,
                    indexExpression: {
                      id: 94125,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94085,
                      src: "13280:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "13262:27:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13234:55:179"
                },
                {
                  assignments: [94129],
                  declarations: [
                    {
                      constant: false,
                      id: 94129,
                      mutability: "mutable",
                      name: "wrappedBalance",
                      nameLocation: "13307:14:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "13299:22:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94128,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13299:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94146,
                  initialValue: {
                    condition: {
                      commonType: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      },
                      id: 94136,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 94130,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94096,
                          src: "13336:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94131,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "13342:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "13336:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        arguments: [
                          {
                            hexValue: "30",
                            id: 94134,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "number",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "13361:1:179",
                            typeDescriptions: {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            },
                            value: "0"
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_rational_0_by_1",
                              typeString: "int_const 0"
                            }
                          ],
                          id: 94133,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "13353:7:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_address_$",
                            typeString: "type(address)"
                          },
                          typeName: {
                            id: 94132,
                            name: "address",
                            nodeType: "ElementaryTypeName",
                            src: "13353:7:179",
                            typeDescriptions: {}
                          }
                        },
                        id: 94135,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "13353:10:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      src: "13336:27:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    falseExpression: {
                      arguments: [
                        {
                          id: 94143,
                          name: "owner_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94083,
                          src: "13415:6:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        expression: {
                          arguments: [
                            {
                              expression: {
                                id: 94139,
                                name: "token",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94096,
                                src: "13390:5:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 94140,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "13396:7:179",
                              memberName: "wrapped",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82870,
                              src: "13390:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 94138,
                            name: "SoulboundCloneERC20",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 96086,
                            src: "13370:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_SoulboundCloneERC20_$96086_$",
                              typeString: "type(contract SoulboundCloneERC20)"
                            }
                          },
                          id: 94141,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "13370:34:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                            typeString: "contract SoulboundCloneERC20"
                          }
                        },
                        id: 94142,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "13405:9:179",
                        memberName: "balanceOf",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 86381,
                        src: "13370:44:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                          typeString: "function (address) view external returns (uint256)"
                        }
                      },
                      id: 94144,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "13370:52:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    id: 94145,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "Conditional",
                    src: "13336:86:179",
                    trueExpression: {
                      hexValue: "30",
                      id: 94137,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "13366:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13299:123:179"
                },
                {
                  assignments: [94148],
                  declarations: [
                    {
                      constant: false,
                      id: 94148,
                      mutability: "mutable",
                      name: "claimedBalance",
                      nameLocation: "13440:14:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "13432:22:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94147,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13432:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94154,
                  initialValue: {
                    baseExpression: {
                      baseExpression: {
                        id: 94149,
                        name: "userClaimed",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 93452,
                        src: "13457:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
                          typeString: "mapping(address => mapping(uint256 => uint256))"
                        }
                      },
                      id: 94151,
                      indexExpression: {
                        id: 94150,
                        name: "owner_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94083,
                        src: "13469:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "13457:19:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                        typeString: "mapping(uint256 => uint256)"
                      }
                    },
                    id: 94153,
                    indexExpression: {
                      id: 94152,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94085,
                      src: "13477:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "13457:29:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13432:54:179"
                },
                {
                  assignments: [94156],
                  declarations: [
                    {
                      constant: false,
                      id: 94156,
                      mutability: "mutable",
                      name: "totalAmount",
                      nameLocation: "13504:11:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "13496:19:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94155,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13496:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94162,
                  initialValue: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94161,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      id: 94159,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        id: 94157,
                        name: "derivativeBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94121,
                        src: "13518:17:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "+",
                      rightExpression: {
                        id: 94158,
                        name: "wrappedBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94129,
                        src: "13538:14:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      src: "13518:34:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "+",
                    rightExpression: {
                      id: 94160,
                      name: "claimedBalance",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94148,
                      src: "13555:14:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "13518:51:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "13496:73:179"
                },
                {
                  assignments: [94164],
                  declarations: [
                    {
                      constant: false,
                      id: 94164,
                      mutability: "mutable",
                      name: "vested",
                      nameLocation: "13693:6:179",
                      nodeType: "VariableDeclaration",
                      scope: 94208,
                      src: "13685:14:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      },
                      typeName: {
                        id: 94163,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "13685:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94165,
                  nodeType: "VariableDeclarationStatement",
                  src: "13685:14:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94170,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94166,
                        name: "block",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -4,
                        src: "13776:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_block",
                          typeString: "block"
                        }
                      },
                      id: 94167,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "13782:9:179",
                      memberName: "timestamp",
                      nodeType: "MemberAccess",
                      src: "13776:15:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">=",
                    rightExpression: {
                      expression: {
                        id: 94168,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94103,
                        src: "13795:4:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      id: 94169,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "13800:6:179",
                      memberName: "expiry",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83437,
                      src: "13795:11:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "13776:30:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  falseBody: {
                    id: 94192,
                    nodeType: "Block",
                    src: "13939:112:179",
                    statements: [
                      {
                        expression: {
                          id: 94190,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 94176,
                            name: "vested",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94164,
                            src: "13953:6:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                commonType: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                id: 94183,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftExpression: {
                                  expression: {
                                    id: 94179,
                                    name: "block",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: -4,
                                    src: "13985:5:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_magic_block",
                                      typeString: "block"
                                    }
                                  },
                                  id: 94180,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "13991:9:179",
                                  memberName: "timestamp",
                                  nodeType: "MemberAccess",
                                  src: "13985:15:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint256",
                                    typeString: "uint256"
                                  }
                                },
                                nodeType: "BinaryOperation",
                                operator: "-",
                                rightExpression: {
                                  expression: {
                                    id: 94181,
                                    name: "data",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94103,
                                    src: "14003:4:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                      typeString: "struct ILinearVesting.VestingParams memory"
                                    }
                                  },
                                  id: 94182,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "14008:5:179",
                                  memberName: "start",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83435,
                                  src: "14003:10:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint48",
                                    typeString: "uint48"
                                  }
                                },
                                src: "13985:28:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              {
                                commonType: {
                                  typeIdentifier: "t_uint48",
                                  typeString: "uint48"
                                },
                                id: 94188,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                lValueRequested: false,
                                leftExpression: {
                                  expression: {
                                    id: 94184,
                                    name: "data",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94103,
                                    src: "14015:4:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                      typeString: "struct ILinearVesting.VestingParams memory"
                                    }
                                  },
                                  id: 94185,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "14020:6:179",
                                  memberName: "expiry",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83437,
                                  src: "14015:11:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint48",
                                    typeString: "uint48"
                                  }
                                },
                                nodeType: "BinaryOperation",
                                operator: "-",
                                rightExpression: {
                                  expression: {
                                    id: 94186,
                                    name: "data",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94103,
                                    src: "14029:4:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                      typeString: "struct ILinearVesting.VestingParams memory"
                                    }
                                  },
                                  id: 94187,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "14034:5:179",
                                  memberName: "start",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83435,
                                  src: "14029:10:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint48",
                                    typeString: "uint48"
                                  }
                                },
                                src: "14015:24:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint48",
                                  typeString: "uint48"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                },
                                {
                                  typeIdentifier: "t_uint48",
                                  typeString: "uint48"
                                }
                              ],
                              expression: {
                                id: 94177,
                                name: "totalAmount",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94156,
                                src: "13962:11:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_uint256",
                                  typeString: "uint256"
                                }
                              },
                              id: 94178,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "13974:10:179",
                              memberName: "mulDivDown",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 56673,
                              src: "13962:22:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$attached_to$_t_uint256_$",
                                typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
                              }
                            },
                            id: 94189,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "13962:78:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "13953:87:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 94191,
                        nodeType: "ExpressionStatement",
                        src: "13953:87:179"
                      }
                    ]
                  },
                  id: 94193,
                  nodeType: "IfStatement",
                  src: "13772:279:179",
                  trueBody: {
                    id: 94175,
                    nodeType: "Block",
                    src: "13808:45:179",
                    statements: [
                      {
                        expression: {
                          id: 94173,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            id: 94171,
                            name: "vested",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94164,
                            src: "13822:6:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            id: 94172,
                            name: "totalAmount",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94156,
                            src: "13831:11:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          src: "13822:20:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        id: 94174,
                        nodeType: "ExpressionStatement",
                        src: "13822:20:179"
                      }
                    ]
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94196,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94194,
                      name: "vested",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94164,
                      src: "14130:6:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 94195,
                      name: "claimedBalance",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94148,
                      src: "14139:14:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "14130:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94201,
                  nodeType: "IfStatement",
                  src: "14126:78:179",
                  trueBody: {
                    id: 94200,
                    nodeType: "Block",
                    src: "14155:49:179",
                    statements: [
                      {
                        errorCall: {
                          arguments: [],
                          expression: {
                            argumentTypes: [],
                            id: 94197,
                            name: "BrokenInvariant",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83423,
                            src: "14176:15:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_error_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 94198,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "14176:17:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 94199,
                        nodeType: "RevertStatement",
                        src: "14169:24:179"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    id: 94204,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 94202,
                      name: "vested",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94164,
                      src: "14255:6:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "-=",
                    rightHandSide: {
                      id: 94203,
                      name: "claimedBalance",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94148,
                      src: "14265:14:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "14255:24:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 94205,
                  nodeType: "ExpressionStatement",
                  src: "14255:24:179"
                },
                {
                  expression: {
                    id: 94206,
                    name: "vested",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94164,
                    src: "14297:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 94093,
                  id: 94207,
                  nodeType: "Return",
                  src: "14290:13:179"
                }
              ]
            },
            baseFunctions: [82969],
            documentation: {
              id: 94081,
              nodeType: "StructuredDocumentation",
              src: "12321:466:179",
              text: "@inheritdoc IDerivative\n @dev        The redeemable amount is computed as:\n             - The amount of tokens that have vested\n               - x: number of vestable tokens\n               - t: current timestamp\n               - s: start timestamp\n               - T: expiry timestamp\n               - Vested = x * (t - s) / (T - s)\n             - Minus the amount of tokens that have already been redeemed"
            },
            functionSelector: "67627b62",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94089,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94085,
                    src: "12914:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94090,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94088,
                  name: "onlyValidTokenId",
                  nameLocations: ["12897:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "12897:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "12897:26:179"
              }
            ],
            name: "redeemable",
            nameLocation: "12801:10:179",
            overrides: {
              id: 94087,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "12888:8:179"
            },
            parameters: {
              id: 94086,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94083,
                  mutability: "mutable",
                  name: "owner_",
                  nameLocation: "12829:6:179",
                  nodeType: "VariableDeclaration",
                  scope: 94209,
                  src: "12821:14:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94082,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "12821:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94085,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "12853:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94209,
                  src: "12845:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94084,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "12845:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "12811:56:179"
            },
            returnParameters: {
              id: 94093,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94092,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94209,
                  src: "12933:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94091,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "12933:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "12932:9:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: true,
            visibility: "public"
          },
          {
            id: 94224,
            nodeType: "FunctionDefinition",
            src: "14384:125:179",
            nodes: [],
            body: {
              id: 94223,
              nodeType: "Block",
              src: "14446:63:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        id: 94218,
                        name: "IDerivative",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83049,
                        src: "14463:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_IDerivative_$83049_$",
                          typeString: "type(contract IDerivative)"
                        }
                      },
                      id: 94220,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "14475:25:179",
                      memberName: "Derivative_NotImplemented",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82866,
                      src: "14463:37:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94221,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14463:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94222,
                  nodeType: "RevertStatement",
                  src: "14456:46:179"
                }
              ]
            },
            baseFunctions: [82977],
            documentation: {
              id: 94210,
              nodeType: "StructuredDocumentation",
              src: "14316:63:179",
              text: "@inheritdoc IDerivative\n @dev        Not implemented"
            },
            functionSelector: "a86265bb",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "exercise",
            nameLocation: "14393:8:179",
            overrides: {
              id: 94216,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "14437:8:179"
            },
            parameters: {
              id: 94215,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94212,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94224,
                  src: "14402:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94211,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14402:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94214,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94224,
                  src: "14411:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94213,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14411:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14401:18:179"
            },
            returnParameters: {
              id: 94217,
              nodeType: "ParameterList",
              parameters: [],
              src: "14446:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94239,
            nodeType: "FunctionDefinition",
            src: "14583:140:179",
            nodes: [],
            body: {
              id: 94238,
              nodeType: "Block",
              src: "14672:51:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      id: 94235,
                      name: "Derivative_NotImplemented",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 82866,
                      src: "14689:25:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94236,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14689:27:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94237,
                  nodeType: "RevertStatement",
                  src: "14682:34:179"
                }
              ]
            },
            baseFunctions: [82987],
            documentation: {
              id: 94225,
              nodeType: "StructuredDocumentation",
              src: "14515:63:179",
              text: "@inheritdoc IDerivative\n @dev        Not implemented"
            },
            functionSelector: "6aacff4e",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "exerciseCost",
            nameLocation: "14592:12:179",
            overrides: {
              id: 94231,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "14645:8:179"
            },
            parameters: {
              id: 94230,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94227,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94239,
                  src: "14605:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94226,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14605:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94229,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94239,
                  src: "14614:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94228,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14614:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14604:18:179"
            },
            returnParameters: {
              id: 94234,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94233,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94239,
                  src: "14663:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94232,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14663:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14662:9:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94252,
            nodeType: "FunctionDefinition",
            src: "14797:115:179",
            nodes: [],
            body: {
              id: 94251,
              nodeType: "Block",
              src: "14849:63:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        id: 94246,
                        name: "IDerivative",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83049,
                        src: "14866:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_IDerivative_$83049_$",
                          typeString: "type(contract IDerivative)"
                        }
                      },
                      id: 94248,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "14878:25:179",
                      memberName: "Derivative_NotImplemented",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82866,
                      src: "14866:37:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94249,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "14866:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94250,
                  nodeType: "RevertStatement",
                  src: "14859:46:179"
                }
              ]
            },
            baseFunctions: [82993],
            documentation: {
              id: 94240,
              nodeType: "StructuredDocumentation",
              src: "14729:63:179",
              text: "@inheritdoc IDerivative\n @dev        Not implemented"
            },
            functionSelector: "2dabbeed",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "reclaim",
            nameLocation: "14806:7:179",
            overrides: {
              id: 94244,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "14840:8:179"
            },
            parameters: {
              id: 94243,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94242,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94252,
                  src: "14814:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94241,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "14814:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "14813:9:179"
            },
            returnParameters: {
              id: 94245,
              nodeType: "ParameterList",
              parameters: [],
              src: "14849:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94269,
            nodeType: "FunctionDefinition",
            src: "14986:135:179",
            nodes: [],
            body: {
              id: 94268,
              nodeType: "Block",
              src: "15058:63:179",
              nodes: [],
              statements: [
                {
                  errorCall: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        id: 94263,
                        name: "IDerivative",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83049,
                        src: "15075:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_contract$_IDerivative_$83049_$",
                          typeString: "type(contract IDerivative)"
                        }
                      },
                      id: 94265,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "15087:25:179",
                      memberName: "Derivative_NotImplemented",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82866,
                      src: "15075:37:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_error_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94266,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "15075:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94267,
                  nodeType: "RevertStatement",
                  src: "15068:46:179"
                }
              ]
            },
            baseFunctions: [83003],
            documentation: {
              id: 94253,
              nodeType: "StructuredDocumentation",
              src: "14918:63:179",
              text: "@inheritdoc IDerivative\n @dev        Not implemented"
            },
            functionSelector: "f6e9936a",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "transform",
            nameLocation: "14995:9:179",
            overrides: {
              id: 94261,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "15049:8:179"
            },
            parameters: {
              id: 94260,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94255,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94269,
                  src: "15005:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94254,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15005:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94257,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94269,
                  src: "15014:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94256,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "15014:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94259,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94269,
                  src: "15023:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94258,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15023:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15004:27:179"
            },
            returnParameters: {
              id: 94262,
              nodeType: "ParameterList",
              parameters: [],
              src: "15058:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94347,
            nodeType: "FunctionDefinition",
            src: "15327:819:179",
            nodes: [],
            body: {
              id: 94346,
              nodeType: "Block",
              src: "15421:725:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94283,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94281,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94274,
                      src: "15435:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 94282,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "15446:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "15435:12:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94287,
                  nodeType: "IfStatement",
                  src: "15431:40:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94284,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "15456:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94285,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "15456:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94286,
                    nodeType: "RevertStatement",
                    src: "15449:22:179"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94295,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      baseExpression: {
                        baseExpression: {
                          id: 94288,
                          name: "balanceOf",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56309,
                          src: "15486:9:179",
                          typeDescriptions: {
                            typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_uint256_$_t_uint256_$_$",
                            typeString: "mapping(address => mapping(uint256 => uint256))"
                          }
                        },
                        id: 94291,
                        indexExpression: {
                          expression: {
                            id: 94289,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: "15496:3:179",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 94290,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "15500:6:179",
                          memberName: "sender",
                          nodeType: "MemberAccess",
                          src: "15496:10:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        nodeType: "IndexAccess",
                        src: "15486:21:179",
                        typeDescriptions: {
                          typeIdentifier: "t_mapping$_t_uint256_$_t_uint256_$",
                          typeString: "mapping(uint256 => uint256)"
                        }
                      },
                      id: 94293,
                      indexExpression: {
                        id: 94292,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94272,
                        src: "15508:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      nodeType: "IndexAccess",
                      src: "15486:31:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 94294,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94274,
                      src: "15520:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "15486:41:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94299,
                  nodeType: "IfStatement",
                  src: "15482:75:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94296,
                        name: "InsufficientBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83425,
                        src: "15536:19:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94297,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "15536:21:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94298,
                    nodeType: "RevertStatement",
                    src: "15529:28:179"
                  }
                },
                {
                  id: 94307,
                  nodeType: "UncheckedBlock",
                  src: "15646:76:179",
                  statements: [
                    {
                      expression: {
                        id: 94305,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          expression: {
                            baseExpression: {
                              id: 94300,
                              name: "tokenMetadata",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 88048,
                              src: "15670:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                                typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                              }
                            },
                            id: 94302,
                            indexExpression: {
                              id: 94301,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94272,
                              src: "15684:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "15670:23:179",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Token_$82877_storage",
                              typeString: "struct IDerivative.Token storage ref"
                            }
                          },
                          id: 94303,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: true,
                          memberLocation: "15694:6:179",
                          memberName: "supply",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82874,
                          src: "15670:30:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "-=",
                        rightHandSide: {
                          id: 94304,
                          name: "amount_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94274,
                          src: "15704:7:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "15670:41:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 94306,
                      nodeType: "ExpressionStatement",
                      src: "15670:41:179"
                    }
                  ]
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 94309,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "15775:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94310,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "15779:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "15775:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94311,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94272,
                        src: "15787:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 94312,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94274,
                        src: "15797:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 94308,
                      name: "_burn",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56582,
                      src: "15769:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256,uint256)"
                      }
                    },
                    id: 94313,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "15769:36:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94314,
                  nodeType: "ExpressionStatement",
                  src: "15769:36:179"
                },
                {
                  assignments: [94317],
                  declarations: [
                    {
                      constant: false,
                      id: 94317,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "15883:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94346,
                      src: "15869:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94316,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94315,
                          name: "Token",
                          nameLocations: ["15869:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "15869:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "15869:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94321,
                  initialValue: {
                    baseExpression: {
                      id: 94318,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "15891:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94320,
                    indexExpression: {
                      id: 94319,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94272,
                      src: "15905:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "15891:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "15869:45:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 94323,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94272,
                        src: "15944:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 94324,
                        name: "token",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94317,
                        src: "15954:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        }
                      ],
                      id: 94322,
                      name: "_deployWrapIfNeeded",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94892,
                      src: "15924:19:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_struct$_Token_$82877_storage_ptr_$returns$_t_address_$",
                        typeString: "function (uint256,struct IDerivative.Token storage pointer) returns (address)"
                      }
                    },
                    id: 94325,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "15924:36:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  id: 94326,
                  nodeType: "ExpressionStatement",
                  src: "15924:36:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 94332,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "16050:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94333,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16054:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "16050:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94334,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94274,
                        src: "16062:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        arguments: [
                          {
                            expression: {
                              id: 94328,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94317,
                              src: "16030:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94329,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "16036:7:179",
                            memberName: "wrapped",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82870,
                            src: "16030:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 94327,
                          name: "SoulboundCloneERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 96086,
                          src: "16010:19:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_SoulboundCloneERC20_$96086_$",
                            typeString: "type(contract SoulboundCloneERC20)"
                          }
                        },
                        id: 94330,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "16010:34:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                          typeString: "contract SoulboundCloneERC20"
                        }
                      },
                      id: 94331,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "16045:4:179",
                      memberName: "mint",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 95986,
                      src: "16010:39:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256) external"
                      }
                    },
                    id: 94335,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16010:60:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94336,
                  nodeType: "ExpressionStatement",
                  src: "16010:60:179"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 94338,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94272,
                        src: "16094:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94339,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "16104:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94340,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16108:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "16104:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94341,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94274,
                        src: "16116:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94342,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94317,
                          src: "16125:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94343,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16131:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "16125:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 94337,
                      name: "Wrapped",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83403,
                      src: "16086:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint256_$_t_address_$_t_uint256_$_t_address_$returns$__$",
                        typeString: "function (uint256,address,uint256,address)"
                      }
                    },
                    id: 94344,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16086:53:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94345,
                  nodeType: "EmitStatement",
                  src: "16081:58:179"
                }
              ]
            },
            baseFunctions: [83011],
            documentation: {
              id: 94270,
              nodeType: "StructuredDocumentation",
              src: "15127:195:179",
              text: "@inheritdoc IDerivative\n @dev        This function will revert if:\n             - The derivative token with `tokenId_` has not been deployed\n             - `amount_` is 0"
            },
            functionSelector: "25ded586",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94278,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94272,
                    src: "15411:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94279,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94277,
                  name: "onlyValidTokenId",
                  nameLocations: ["15394:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "15394:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "15394:26:179"
              }
            ],
            name: "wrap",
            nameLocation: "15336:4:179",
            overrides: {
              id: 94276,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "15385:8:179"
            },
            parameters: {
              id: 94275,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94272,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "15349:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94347,
                  src: "15341:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94271,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15341:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94274,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "15367:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94347,
                  src: "15359:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94273,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "15359:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "15340:35:179"
            },
            returnParameters: {
              id: 94280,
              nodeType: "ParameterList",
              parameters: [],
              src: "15421:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 94427,
            nodeType: "FunctionDefinition",
            src: "16432:791:179",
            nodes: [],
            body: {
              id: 94426,
              nodeType: "Block",
              src: "16580:643:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94364,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94362,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94352,
                      src: "16594:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "30",
                      id: 94363,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "number",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "16605:1:179",
                      typeDescriptions: {
                        typeIdentifier: "t_rational_0_by_1",
                        typeString: "int_const 0"
                      },
                      value: "0"
                    },
                    src: "16594:12:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94368,
                  nodeType: "IfStatement",
                  src: "16590:40:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94365,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "16615:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94366,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "16615:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94367,
                    nodeType: "RevertStatement",
                    src: "16608:22:179"
                  }
                },
                {
                  assignments: [94371],
                  declarations: [
                    {
                      constant: false,
                      id: 94371,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "16655:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94426,
                      src: "16641:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94370,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94369,
                          name: "Token",
                          nameLocations: ["16641:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "16641:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "16641:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94375,
                  initialValue: {
                    baseExpression: {
                      id: 94372,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "16663:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94374,
                    indexExpression: {
                      id: 94373,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94350,
                      src: "16677:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "16663:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "16641:45:179"
                },
                {
                  assignments: [94378],
                  declarations: [
                    {
                      constant: false,
                      id: 94378,
                      mutability: "mutable",
                      name: "wrappedToken",
                      nameLocation: "16716:12:179",
                      nodeType: "VariableDeclaration",
                      scope: 94426,
                      src: "16696:32:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                        typeString: "contract SoulboundCloneERC20"
                      },
                      typeName: {
                        id: 94377,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94376,
                          name: "SoulboundCloneERC20",
                          nameLocations: ["16696:19:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 96086,
                          src: "16696:19:179"
                        },
                        referencedDeclaration: 96086,
                        src: "16696:19:179",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                          typeString: "contract SoulboundCloneERC20"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94383,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 94380,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94371,
                          src: "16751:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94381,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16757:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "16751:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 94379,
                      name: "SoulboundCloneERC20",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 96086,
                      src: "16731:19:179",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_SoulboundCloneERC20_$96086_$",
                        typeString: "type(contract SoulboundCloneERC20)"
                      }
                    },
                    id: 94382,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "16731:34:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                      typeString: "contract SoulboundCloneERC20"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "16696:69:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94390,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      arguments: [
                        {
                          expression: {
                            id: 94386,
                            name: "msg",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: -15,
                            src: "16803:3:179",
                            typeDescriptions: {
                              typeIdentifier: "t_magic_message",
                              typeString: "msg"
                            }
                          },
                          id: 94387,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "16807:6:179",
                          memberName: "sender",
                          nodeType: "MemberAccess",
                          src: "16803:10:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        ],
                        expression: {
                          id: 94384,
                          name: "wrappedToken",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94378,
                          src: "16780:12:179",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                            typeString: "contract SoulboundCloneERC20"
                          }
                        },
                        id: 94385,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "16793:9:179",
                        memberName: "balanceOf",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 86381,
                        src: "16780:22:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
                          typeString: "function (address) view external returns (uint256)"
                        }
                      },
                      id: 94388,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "16780:34:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "<",
                    rightExpression: {
                      id: 94389,
                      name: "amount_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94352,
                      src: "16817:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "16780:44:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94394,
                  nodeType: "IfStatement",
                  src: "16776:78:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94391,
                        name: "InsufficientBalance",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83425,
                        src: "16833:19:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94392,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "16833:21:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94393,
                    nodeType: "RevertStatement",
                    src: "16826:28:179"
                  }
                },
                {
                  id: 94401,
                  nodeType: "UncheckedBlock",
                  src: "16910:58:179",
                  statements: [
                    {
                      expression: {
                        id: 94399,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftHandSide: {
                          expression: {
                            id: 94395,
                            name: "token",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94371,
                            src: "16934:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                              typeString: "struct IDerivative.Token storage pointer"
                            }
                          },
                          id: 94397,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: true,
                          memberLocation: "16940:6:179",
                          memberName: "supply",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 82874,
                          src: "16934:12:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "Assignment",
                        operator: "+=",
                        rightHandSide: {
                          id: 94398,
                          name: "amount_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94352,
                          src: "16950:7:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "16934:23:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      id: 94400,
                      nodeType: "ExpressionStatement",
                      src: "16934:23:179"
                    }
                  ]
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 94405,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "17041:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94406,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17045:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "17041:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94407,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94352,
                        src: "17053:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      expression: {
                        id: 94402,
                        name: "wrappedToken",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94378,
                        src: "17023:12:179",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_SoulboundCloneERC20_$96086",
                          typeString: "contract SoulboundCloneERC20"
                        }
                      },
                      id: 94404,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "17036:4:179",
                      memberName: "burn",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 96002,
                      src: "17023:17:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256) external"
                      }
                    },
                    id: 94408,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "17023:38:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94409,
                  nodeType: "ExpressionStatement",
                  src: "17023:38:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          id: 94411,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "17115:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94412,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17119:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "17115:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94413,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94350,
                        src: "17127:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        id: 94414,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94352,
                        src: "17137:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 94410,
                      name: "_mint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56552,
                      src: "17109:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256,uint256)"
                      }
                    },
                    id: 94415,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "17109:36:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94416,
                  nodeType: "ExpressionStatement",
                  src: "17109:36:179"
                },
                {
                  eventCall: {
                    arguments: [
                      {
                        id: 94418,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94350,
                        src: "17171:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94419,
                          name: "msg",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -15,
                          src: "17181:3:179",
                          typeDescriptions: {
                            typeIdentifier: "t_magic_message",
                            typeString: "msg"
                          }
                        },
                        id: 94420,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17185:6:179",
                        memberName: "sender",
                        nodeType: "MemberAccess",
                        src: "17181:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94421,
                        name: "amount_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94352,
                        src: "17193:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94422,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94371,
                          src: "17202:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94423,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "17208:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "17202:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 94417,
                      name: "Unwrapped",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 83413,
                      src: "17161:9:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_event_nonpayable$_t_uint256_$_t_address_$_t_uint256_$_t_address_$returns$__$",
                        typeString: "function (uint256,address,uint256,address)"
                      }
                    },
                    id: 94424,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "17161:55:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 94425,
                  nodeType: "EmitStatement",
                  src: "17156:60:179"
                }
              ]
            },
            baseFunctions: [83019],
            documentation: {
              id: 94348,
              nodeType: "StructuredDocumentation",
              src: "16152:275:179",
              text: "@inheritdoc IDerivative\n @dev        This function will revert if:\n             - The derivative token with `tokenId_` has not been deployed\n             - A wrapped derivative for `tokenId_` has not been deployed\n             - `amount_` is 0"
            },
            functionSelector: "6e286671",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94356,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94350,
                    src: "16540:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94357,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94355,
                  name: "onlyValidTokenId",
                  nameLocations: ["16523:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "16523:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "16523:26:179"
              },
              {
                arguments: [
                  {
                    id: 94359,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94350,
                    src: "16570:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94360,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94358,
                  name: "onlyDeployedWrapped",
                  nameLocations: ["16550:19:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93537,
                  src: "16550:19:179"
                },
                nodeType: "ModifierInvocation",
                src: "16550:29:179"
              }
            ],
            name: "unwrap",
            nameLocation: "16441:6:179",
            overrides: {
              id: 94354,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "16514:8:179"
            },
            parameters: {
              id: 94353,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94350,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "16465:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94427,
                  src: "16457:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94349,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "16457:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94352,
                  mutability: "mutable",
                  name: "amount_",
                  nameLocation: "16491:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94427,
                  src: "16483:15:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94351,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "16483:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "16447:57:179"
            },
            returnParameters: {
              id: 94361,
              nodeType: "ParameterList",
              parameters: [],
              src: "16580:0:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "external"
          },
          {
            id: 94478,
            nodeType: "FunctionDefinition",
            src: "18098:648:179",
            nodes: [],
            body: {
              id: 94477,
              nodeType: "Block",
              src: "18222:524:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 94446,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      commonType: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      },
                      id: 94441,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 94438,
                          name: "data_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94433,
                          src: "18285:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 94439,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18291:5:179",
                        memberName: "start",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83435,
                        src: "18285:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        hexValue: "30",
                        id: 94440,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "18300:1:179",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "18285:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "||",
                    rightExpression: {
                      commonType: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      },
                      id: 94445,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      leftExpression: {
                        expression: {
                          id: 94442,
                          name: "data_",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94433,
                          src: "18305:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 94443,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "18311:6:179",
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83437,
                        src: "18305:12:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      nodeType: "BinaryOperation",
                      operator: "==",
                      rightExpression: {
                        hexValue: "30",
                        id: 94444,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "number",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "18321:1:179",
                        typeDescriptions: {
                          typeIdentifier: "t_rational_0_by_1",
                          typeString: "int_const 0"
                        },
                        value: "0"
                      },
                      src: "18305:17:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    src: "18285:37:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94449,
                  nodeType: "IfStatement",
                  src: "18281:55:179",
                  trueBody: {
                    expression: {
                      hexValue: "66616c7365",
                      id: 94447,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "18331:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    functionReturnParameters: 94437,
                    id: 94448,
                    nodeType: "Return",
                    src: "18324:12:179"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    },
                    id: 94454,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94450,
                        name: "data_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94433,
                        src: "18446:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      id: 94451,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "18452:5:179",
                      memberName: "start",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83435,
                      src: "18446:11:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      expression: {
                        id: 94452,
                        name: "data_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94433,
                        src: "18461:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      id: 94453,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "18467:6:179",
                      memberName: "expiry",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83437,
                      src: "18461:12:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "18446:27:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94457,
                  nodeType: "IfStatement",
                  src: "18442:45:179",
                  trueBody: {
                    expression: {
                      hexValue: "66616c7365",
                      id: 94455,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "18482:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    functionReturnParameters: 94437,
                    id: 94456,
                    nodeType: "Return",
                    src: "18475:12:179"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    },
                    id: 94462,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94458,
                        name: "data_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94433,
                        src: "18565:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      id: 94459,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "18571:5:179",
                      memberName: "start",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83435,
                      src: "18565:11:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: ">=",
                    rightExpression: {
                      expression: {
                        id: 94460,
                        name: "data_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94433,
                        src: "18580:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      },
                      id: 94461,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "18586:6:179",
                      memberName: "expiry",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 83437,
                      src: "18580:12:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint48",
                        typeString: "uint48"
                      }
                    },
                    src: "18565:27:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94465,
                  nodeType: "IfStatement",
                  src: "18561:45:179",
                  trueBody: {
                    expression: {
                      hexValue: "66616c7365",
                      id: 94463,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "18601:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    functionReturnParameters: 94437,
                    id: 94464,
                    nodeType: "Return",
                    src: "18594:12:179"
                  }
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 94471,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      id: 94466,
                      name: "underlyingToken_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94430,
                      src: "18673:16:179",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 94469,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "18701:1:179",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 94468,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "18693:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 94467,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "18693:7:179",
                          typeDescriptions: {}
                        }
                      },
                      id: 94470,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "18693:10:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "18673:30:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94474,
                  nodeType: "IfStatement",
                  src: "18669:48:179",
                  trueBody: {
                    expression: {
                      hexValue: "66616c7365",
                      id: 94472,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "18712:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    functionReturnParameters: 94437,
                    id: 94473,
                    nodeType: "Return",
                    src: "18705:12:179"
                  }
                },
                {
                  expression: {
                    hexValue: "74727565",
                    id: 94475,
                    isConstant: false,
                    isLValue: false,
                    isPure: true,
                    kind: "bool",
                    lValueRequested: false,
                    nodeType: "Literal",
                    src: "18735:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    value: "true"
                  },
                  functionReturnParameters: 94437,
                  id: 94476,
                  nodeType: "Return",
                  src: "18728:11:179"
                }
              ]
            },
            documentation: {
              id: 94428,
              nodeType: "StructuredDocumentation",
              src: "17229:864:179",
              text: "@notice     Validates the parameters for a derivative token\n @dev        This function performs the following checks:\n             - The start and expiry times are not 0\n             - The start time is before the expiry time\n             - The underlying token is not the zero address\n             The start and expiry times do not have to be before the current block timestamp,\n             as it is possible to deploy and mint derivative tokens after the vesting expiry. Otherwise, it would be possible to brick funds by delaying the auction settlement.\n @param      underlyingToken_    The address of the underlying token\n @param      data_               The parameters for the derivative token\n @return     bool                True if the parameters are valid, otherwise false"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_validate",
            nameLocation: "18107:9:179",
            parameters: {
              id: 94434,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94430,
                  mutability: "mutable",
                  name: "underlyingToken_",
                  nameLocation: "18134:16:179",
                  nodeType: "VariableDeclaration",
                  scope: 94478,
                  src: "18126:24:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94429,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "18126:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94433,
                  mutability: "mutable",
                  name: "data_",
                  nameLocation: "18181:5:179",
                  nodeType: "VariableDeclaration",
                  scope: 94478,
                  src: "18160:26:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                    typeString: "struct ILinearVesting.VestingParams"
                  },
                  typeName: {
                    id: 94432,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94431,
                      name: "VestingParams",
                      nameLocations: ["18160:13:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83438,
                      src: "18160:13:179"
                    },
                    referencedDeclaration: 83438,
                    src: "18160:13:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                      typeString: "struct ILinearVesting.VestingParams"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18116:76:179"
            },
            returnParameters: {
              id: 94437,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94436,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94478,
                  src: "18216:4:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 94435,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "18216:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18215:6:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94502,
            nodeType: "FunctionDefinition",
            src: "18881:282:179",
            nodes: [],
            body: {
              id: 94501,
              nodeType: "Block",
              src: "19005:158:179",
              nodes: [],
              statements: [
                {
                  assignments: [94491],
                  declarations: [
                    {
                      constant: false,
                      id: 94491,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "19069:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 94501,
                      src: "19048:25:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 94490,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94489,
                          name: "VestingParams",
                          nameLocations: ["19048:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "19048:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "19048:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94495,
                  initialValue: {
                    arguments: [
                      {
                        id: 94493,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94483,
                        src: "19097:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      ],
                      id: 94492,
                      name: "_decodeVestingParams",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94584,
                      src: "19076:20:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_struct$_VestingParams_$83438_memory_ptr_$",
                        typeString: "function (bytes memory) pure returns (struct ILinearVesting.VestingParams memory)"
                      }
                    },
                    id: 94494,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19076:29:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19048:57:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 94497,
                        name: "underlyingToken_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94481,
                        src: "19133:16:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 94498,
                        name: "data",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94491,
                        src: "19151:4:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                          typeString: "struct ILinearVesting.VestingParams memory"
                        }
                      ],
                      id: 94496,
                      name: "_validate",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94478,
                      src: "19123:9:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_address_$_t_struct$_VestingParams_$83438_memory_ptr_$returns$_t_bool_$",
                        typeString: "function (address,struct ILinearVesting.VestingParams memory) pure returns (bool)"
                      }
                    },
                    id: 94499,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19123:33:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  functionReturnParameters: 94488,
                  id: 94500,
                  nodeType: "Return",
                  src: "19116:40:179"
                }
              ]
            },
            baseFunctions: [83029],
            documentation: {
              id: 94479,
              nodeType: "StructuredDocumentation",
              src: "18752:124:179",
              text: "@inheritdoc IDerivative\n @param      params_     The abi-encoded `VestingParams` for the derivative token"
            },
            functionSelector: "caf92785",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "validate",
            nameLocation: "18890:8:179",
            overrides: {
              id: 94485,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "18981:8:179"
            },
            parameters: {
              id: 94484,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94481,
                  mutability: "mutable",
                  name: "underlyingToken_",
                  nameLocation: "18916:16:179",
                  nodeType: "VariableDeclaration",
                  scope: 94502,
                  src: "18908:24:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94480,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "18908:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94483,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "18955:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94502,
                  src: "18942:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 94482,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "18942:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18898:70:179"
            },
            returnParameters: {
              id: 94488,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94487,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94502,
                  src: "18999:4:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 94486,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "18999:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "18998:6:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: false,
            visibility: "public"
          },
          {
            id: 94525,
            nodeType: "FunctionDefinition",
            src: "19252:238:179",
            nodes: [],
            body: {
              id: 94524,
              nodeType: "Block",
              src: "19409:81:179",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        expression: {
                          baseExpression: {
                            id: 94516,
                            name: "tokenMetadata",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 88048,
                            src: "19437:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                              typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                            }
                          },
                          id: 94518,
                          indexExpression: {
                            id: 94517,
                            name: "tokenId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94505,
                            src: "19451:8:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "19437:23:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage",
                            typeString: "struct IDerivative.Token storage ref"
                          }
                        },
                        id: 94519,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "19461:4:179",
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82876,
                        src: "19437:28:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        }
                      },
                      {
                        components: [
                          {
                            id: 94520,
                            name: "VestingParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83438,
                            src: "19468:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                              typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                            }
                          }
                        ],
                        id: 94521,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "19467:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 94514,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "19426:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 94515,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "19430:6:179",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "19426:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94522,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19426:57:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  functionReturnParameters: 94513,
                  id: 94523,
                  nodeType: "Return",
                  src: "19419:64:179"
                }
              ]
            },
            baseFunctions: [83447],
            documentation: {
              id: 94503,
              nodeType: "StructuredDocumentation",
              src: "19217:30:179",
              text: "@inheritdoc ILinearVesting"
            },
            functionSelector: "b2416661",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94508,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94505,
                    src: "19356:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94509,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94507,
                  name: "onlyValidTokenId",
                  nameLocations: ["19339:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "19339:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "19339:26:179"
              }
            ],
            name: "getTokenVestingParams",
            nameLocation: "19261:21:179",
            parameters: {
              id: 94506,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94505,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "19291:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94525,
                  src: "19283:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94504,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "19283:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19282:18:179"
            },
            returnParameters: {
              id: 94513,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94512,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94525,
                  src: "19383:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                    typeString: "struct ILinearVesting.VestingParams"
                  },
                  typeName: {
                    id: 94511,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94510,
                      name: "VestingParams",
                      nameLocations: ["19383:13:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83438,
                      src: "19383:13:179"
                    },
                    referencedDeclaration: 83438,
                    src: "19383:13:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                      typeString: "struct ILinearVesting.VestingParams"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19382:22:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: false,
            visibility: "external"
          },
          {
            id: 94559,
            nodeType: "FunctionDefinition",
            src: "19625:398:179",
            nodes: [],
            body: {
              id: 94558,
              nodeType: "Block",
              src: "19763:260:179",
              nodes: [],
              statements: [
                {
                  assignments: [94538],
                  declarations: [
                    {
                      constant: false,
                      id: 94538,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "19827:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 94558,
                      src: "19806:25:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 94537,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94536,
                          name: "VestingParams",
                          nameLocations: ["19806:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "19806:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "19806:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94542,
                  initialValue: {
                    arguments: [
                      {
                        id: 94540,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94530,
                        src: "19855:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      ],
                      id: 94539,
                      name: "_decodeVestingParams",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94584,
                      src: "19834:20:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_struct$_VestingParams_$83438_memory_ptr_$",
                        typeString: "function (bytes memory) pure returns (struct ILinearVesting.VestingParams memory)"
                      }
                    },
                    id: 94541,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19834:29:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19806:57:179"
                },
                {
                  assignments: [94545],
                  declarations: [
                    {
                      constant: false,
                      id: 94545,
                      mutability: "mutable",
                      name: "underlyingToken",
                      nameLocation: "19879:15:179",
                      nodeType: "VariableDeclaration",
                      scope: 94558,
                      src: "19873:21:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ERC20_$56264",
                        typeString: "contract ERC20"
                      },
                      typeName: {
                        id: 94544,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94543,
                          name: "ERC20",
                          nameLocations: ["19873:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 56264,
                          src: "19873:5:179"
                        },
                        referencedDeclaration: 56264,
                        src: "19873:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94549,
                  initialValue: {
                    arguments: [
                      {
                        id: 94547,
                        name: "underlyingToken_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94528,
                        src: "19903:16:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 94546,
                      name: "ERC20",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56264,
                      src: "19897:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                        typeString: "type(contract ERC20)"
                      }
                    },
                    id: 94548,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19897:23:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "19873:47:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 94551,
                        name: "underlyingToken",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94545,
                        src: "19975:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        expression: {
                          id: 94552,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94538,
                          src: "19992:4:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 94553,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "19997:5:179",
                        memberName: "start",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83435,
                        src: "19992:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      {
                        expression: {
                          id: 94554,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94538,
                          src: "20004:4:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 94555,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "20009:6:179",
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83437,
                        src: "20004:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        },
                        {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      ],
                      id: 94550,
                      name: "_computeId",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94617,
                      src: "19964:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_contract$_ERC20_$56264_$_t_uint48_$_t_uint48_$returns$_t_uint256_$",
                        typeString: "function (contract ERC20,uint48,uint48) pure returns (uint256)"
                      }
                    },
                    id: 94556,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "19964:52:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 94535,
                  id: 94557,
                  nodeType: "Return",
                  src: "19957:59:179"
                }
              ]
            },
            baseFunctions: [83039],
            documentation: {
              id: 94526,
              nodeType: "StructuredDocumentation",
              src: "19496:124:179",
              text: "@inheritdoc IDerivative\n @param      params_     The abi-encoded `VestingParams` for the derivative token"
            },
            functionSelector: "dbad2d9a",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "computeId",
            nameLocation: "19634:9:179",
            overrides: {
              id: 94532,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "19736:8:179"
            },
            parameters: {
              id: 94531,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94528,
                  mutability: "mutable",
                  name: "underlyingToken_",
                  nameLocation: "19661:16:179",
                  nodeType: "VariableDeclaration",
                  scope: 94559,
                  src: "19653:24:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94527,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "19653:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94530,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "19700:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94559,
                  src: "19687:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 94529,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "19687:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19643:70:179"
            },
            returnParameters: {
              id: 94535,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94534,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94559,
                  src: "19754:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94533,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "19754:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "19753:9:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: true,
            visibility: "external"
          },
          {
            id: 94584,
            nodeType: "FunctionDefinition",
            src: "20262:261:179",
            nodes: [],
            body: {
              id: 94583,
              nodeType: "Block",
              src: "20387:136:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    },
                    id: 94571,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94568,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94562,
                        src: "20401:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      },
                      id: 94569,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "20409:6:179",
                      memberName: "length",
                      nodeType: "MemberAccess",
                      src: "20401:14:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "!=",
                    rightExpression: {
                      id: 94570,
                      name: "_VESTING_PARAMS_LEN",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 93442,
                      src: "20419:19:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "20401:37:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94575,
                  nodeType: "IfStatement",
                  src: "20397:65:179",
                  trueBody: {
                    errorCall: {
                      arguments: [],
                      expression: {
                        argumentTypes: [],
                        id: 94572,
                        name: "InvalidParams",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 83429,
                        src: "20447:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_error_pure$__$returns$__$",
                          typeString: "function () pure"
                        }
                      },
                      id: 94573,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "20447:15:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_tuple$__$",
                        typeString: "tuple()"
                      }
                    },
                    id: 94574,
                    nodeType: "RevertStatement",
                    src: "20440:22:179"
                  }
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 94578,
                        name: "params_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94562,
                        src: "20491:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        }
                      },
                      {
                        components: [
                          {
                            id: 94579,
                            name: "VestingParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83438,
                            src: "20501:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                              typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                            }
                          }
                        ],
                        id: 94580,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "20500:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_memory_ptr",
                          typeString: "bytes memory"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 94576,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "20480:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 94577,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "20484:6:179",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "20480:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94581,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "20480:36:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  functionReturnParameters: 94567,
                  id: 94582,
                  nodeType: "Return",
                  src: "20473:43:179"
                }
              ]
            },
            documentation: {
              id: 94560,
              nodeType: "StructuredDocumentation",
              src: "20088:169:179",
              text: "@notice     Decodes the ABI-encoded `VestingParams` for a derivative token\n @dev        This function will revert if the parameters are not the correct length"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_decodeVestingParams",
            nameLocation: "20271:20:179",
            parameters: {
              id: 94563,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94562,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "20305:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94584,
                  src: "20292:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_bytes_memory_ptr",
                    typeString: "bytes"
                  },
                  typeName: {
                    id: 94561,
                    name: "bytes",
                    nodeType: "ElementaryTypeName",
                    src: "20292:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bytes_storage_ptr",
                      typeString: "bytes"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "20291:22:179"
            },
            returnParameters: {
              id: 94567,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94566,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94584,
                  src: "20361:20:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                    typeString: "struct ILinearVesting.VestingParams"
                  },
                  typeName: {
                    id: 94565,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94564,
                      name: "VestingParams",
                      nameLocations: ["20361:13:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83438,
                      src: "20361:13:179"
                    },
                    referencedDeclaration: 83438,
                    src: "20361:13:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                      typeString: "struct ILinearVesting.VestingParams"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "20360:22:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94617,
            nodeType: "FunctionDefinition",
            src: "20989:266:179",
            nodes: [],
            body: {
              id: 94616,
              nodeType: "Block",
              src: "21115:140:179",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                arguments: [],
                                expression: {
                                  argumentTypes: [],
                                  id: 94602,
                                  name: "VEECODE",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [93501],
                                  referencedDeclaration: 93501,
                                  src: "21180:7:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_internal_pure$__$returns$_t_userDefinedValueType$_Veecode_$88084_$",
                                    typeString: "function () pure returns (Veecode)"
                                  }
                                },
                                id: 94603,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "21180:9:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                                  typeString: "Veecode"
                                }
                              },
                              {
                                arguments: [
                                  {
                                    arguments: [
                                      {
                                        id: 94607,
                                        name: "base_",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 94588,
                                        src: "21212:5:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_contract$_ERC20_$56264",
                                          typeString: "contract ERC20"
                                        }
                                      },
                                      {
                                        id: 94608,
                                        name: "start_",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 94590,
                                        src: "21219:6:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint48",
                                          typeString: "uint48"
                                        }
                                      },
                                      {
                                        id: 94609,
                                        name: "expiry_",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 94592,
                                        src: "21227:7:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint48",
                                          typeString: "uint48"
                                        }
                                      }
                                    ],
                                    expression: {
                                      argumentTypes: [
                                        {
                                          typeIdentifier: "t_contract$_ERC20_$56264",
                                          typeString: "contract ERC20"
                                        },
                                        {
                                          typeIdentifier: "t_uint48",
                                          typeString: "uint48"
                                        },
                                        {
                                          typeIdentifier: "t_uint48",
                                          typeString: "uint48"
                                        }
                                      ],
                                      expression: {
                                        id: 94605,
                                        name: "abi",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: -1,
                                        src: "21201:3:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_magic_abi",
                                          typeString: "abi"
                                        }
                                      },
                                      id: 94606,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: true,
                                      lValueRequested: false,
                                      memberLocation: "21205:6:179",
                                      memberName: "encode",
                                      nodeType: "MemberAccess",
                                      src: "21201:10:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                                        typeString: "function () pure returns (bytes memory)"
                                      }
                                    },
                                    id: 94610,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    kind: "functionCall",
                                    lValueRequested: false,
                                    nameLocations: [],
                                    names: [],
                                    nodeType: "FunctionCall",
                                    src: "21201:34:179",
                                    tryCall: false,
                                    typeDescriptions: {
                                      typeIdentifier: "t_bytes_memory_ptr",
                                      typeString: "bytes memory"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_bytes_memory_ptr",
                                      typeString: "bytes memory"
                                    }
                                  ],
                                  id: 94604,
                                  name: "keccak256",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -8,
                                  src: "21191:9:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
                                    typeString: "function (bytes memory) pure returns (bytes32)"
                                  }
                                },
                                id: 94611,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "21191:45:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_bytes32",
                                  typeString: "bytes32"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_userDefinedValueType$_Veecode_$88084",
                                  typeString: "Veecode"
                                },
                                {
                                  typeIdentifier: "t_bytes32",
                                  typeString: "bytes32"
                                }
                              ],
                              expression: {
                                id: 94600,
                                name: "abi",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -1,
                                src: "21163:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_abi",
                                  typeString: "abi"
                                }
                              },
                              id: 94601,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              memberLocation: "21167:12:179",
                              memberName: "encodePacked",
                              nodeType: "MemberAccess",
                              src: "21163:16:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
                                typeString: "function () pure returns (bytes memory)"
                              }
                            },
                            id: 94612,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "21163:74:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          ],
                          id: 94599,
                          name: "keccak256",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: -8,
                          src: "21153:9:179",
                          typeDescriptions: {
                            typeIdentifier: "t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$",
                            typeString: "function (bytes memory) pure returns (bytes32)"
                          }
                        },
                        id: 94613,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "21153:85:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_bytes32",
                          typeString: "bytes32"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes32",
                          typeString: "bytes32"
                        }
                      ],
                      id: 94598,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      nodeType: "ElementaryTypeNameExpression",
                      src: "21132:7:179",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_uint256_$",
                        typeString: "type(uint256)"
                      },
                      typeName: {
                        id: 94597,
                        name: "uint256",
                        nodeType: "ElementaryTypeName",
                        src: "21132:7:179",
                        typeDescriptions: {}
                      }
                    },
                    id: 94614,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "21132:116:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  functionReturnParameters: 94596,
                  id: 94615,
                  nodeType: "Return",
                  src: "21125:123:179"
                }
              ]
            },
            documentation: {
              id: 94585,
              nodeType: "StructuredDocumentation",
              src: "20529:455:179",
              text: "@notice     Computes the ID of a derivative token\n @dev        The ID is computed as the hash of the parameters and hashed again with the module identifier.\n @param      base_       The address of the underlying token\n @param      start_      The timestamp at which the vesting starts\n @param      expiry_     The timestamp at which the vesting expires\n @return     uint256     The ID of the derivative token"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_computeId",
            nameLocation: "20998:10:179",
            parameters: {
              id: 94593,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94588,
                  mutability: "mutable",
                  name: "base_",
                  nameLocation: "21024:5:179",
                  nodeType: "VariableDeclaration",
                  scope: 94617,
                  src: "21018:11:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_contract$_ERC20_$56264",
                    typeString: "contract ERC20"
                  },
                  typeName: {
                    id: 94587,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94586,
                      name: "ERC20",
                      nameLocations: ["21018:5:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 56264,
                      src: "21018:5:179"
                    },
                    referencedDeclaration: 56264,
                    src: "21018:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94590,
                  mutability: "mutable",
                  name: "start_",
                  nameLocation: "21046:6:179",
                  nodeType: "VariableDeclaration",
                  scope: 94617,
                  src: "21039:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint48",
                    typeString: "uint48"
                  },
                  typeName: {
                    id: 94589,
                    name: "uint48",
                    nodeType: "ElementaryTypeName",
                    src: "21039:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94592,
                  mutability: "mutable",
                  name: "expiry_",
                  nameLocation: "21069:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94617,
                  src: "21062:14:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint48",
                    typeString: "uint48"
                  },
                  typeName: {
                    id: 94591,
                    name: "uint48",
                    nodeType: "ElementaryTypeName",
                    src: "21062:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21008:74:179"
            },
            returnParameters: {
              id: 94596,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94595,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94617,
                  src: "21106:7:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94594,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "21106:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21105:9:179"
            },
            scope: 95102,
            stateMutability: "pure",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94673,
            nodeType: "FunctionDefinition",
            src: "21615:474:179",
            nodes: [],
            body: {
              id: 94672,
              nodeType: "Block",
              src: "21750:339:179",
              nodes: [],
              statements: [
                {
                  assignments: [94631, 94633, 94635],
                  declarations: [
                    {
                      constant: false,
                      id: 94631,
                      mutability: "mutable",
                      name: "year",
                      nameLocation: "21810:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 94672,
                      src: "21796:18:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string"
                      },
                      typeName: {
                        id: 94630,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "21796:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 94633,
                      mutability: "mutable",
                      name: "month",
                      nameLocation: "21830:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94672,
                      src: "21816:19:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string"
                      },
                      typeName: {
                        id: 94632,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "21816:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string"
                        }
                      },
                      visibility: "internal"
                    },
                    {
                      constant: false,
                      id: 94635,
                      mutability: "mutable",
                      name: "day",
                      nameLocation: "21851:3:179",
                      nodeType: "VariableDeclaration",
                      scope: 94672,
                      src: "21837:17:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string"
                      },
                      typeName: {
                        id: 94634,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "21837:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94639,
                  initialValue: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        id: 94636,
                        name: "expiry_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94623,
                        src: "21858:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      id: 94637,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "21866:14:179",
                      memberName: "toPaddedString",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 85781,
                      src: "21858:22:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_pure$_t_uint48_$returns$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_string_memory_ptr_$attached_to$_t_uint48_$",
                        typeString: "function (uint48) pure returns (string memory,string memory,string memory)"
                      }
                    },
                    id: 94638,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "21858:24:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_string_memory_ptr_$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                      typeString: "tuple(string memory,string memory,string memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "21795:87:179"
                },
                {
                  expression: {
                    components: [
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                arguments: [],
                                expression: {
                                  argumentTypes: [],
                                  expression: {
                                    id: 94644,
                                    name: "base_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94621,
                                    src: "21938:5:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_contract$_ERC20_$56264",
                                      typeString: "contract ERC20"
                                    }
                                  },
                                  id: 94645,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "21944:4:179",
                                  memberName: "name",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 55897,
                                  src: "21938:10:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_external_view$__$returns$_t_string_memory_ptr_$",
                                    typeString: "function () view external returns (string memory)"
                                  }
                                },
                                id: 94646,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "21938:12:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              },
                              {
                                hexValue: "20",
                                id: 94647,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "string",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "21952:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_stringliteral_681afa780d17da29203322b473d3f210a7d621259a4e6ce9e403f5a266ff719a",
                                  typeString: 'literal_string " "'
                                },
                                value: " "
                              },
                              {
                                id: 94648,
                                name: "year",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94631,
                                src: "21957:4:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              },
                              {
                                hexValue: "2d",
                                id: 94649,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "string",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "21963:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                value: "-"
                              },
                              {
                                id: 94650,
                                name: "month",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94633,
                                src: "21968:5:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              },
                              {
                                hexValue: "2d",
                                id: 94651,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "string",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "21975:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                value: "-"
                              },
                              {
                                id: 94652,
                                name: "day",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94635,
                                src: "21980:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                },
                                {
                                  typeIdentifier: "t_stringliteral_681afa780d17da29203322b473d3f210a7d621259a4e6ce9e403f5a266ff719a",
                                  typeString: 'literal_string " "'
                                },
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                },
                                {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                },
                                {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              ],
                              expression: {
                                id: 94642,
                                name: "abi",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -1,
                                src: "21921:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_abi",
                                  typeString: "abi"
                                }
                              },
                              id: 94643,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              memberLocation: "21925:12:179",
                              memberName: "encodePacked",
                              nodeType: "MemberAccess",
                              src: "21921:16:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
                                typeString: "function () pure returns (bytes memory)"
                              }
                            },
                            id: 94653,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "21921:63:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          ],
                          id: 94641,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "21914:6:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_string_storage_ptr_$",
                            typeString: "type(string storage pointer)"
                          },
                          typeName: {
                            id: 94640,
                            name: "string",
                            nodeType: "ElementaryTypeName",
                            src: "21914:6:179",
                            typeDescriptions: {}
                          }
                        },
                        id: 94654,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "21914:71:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory"
                        }
                      },
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                arguments: [],
                                expression: {
                                  argumentTypes: [],
                                  expression: {
                                    id: 94659,
                                    name: "base_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94621,
                                    src: "22023:5:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_contract$_ERC20_$56264",
                                      typeString: "contract ERC20"
                                    }
                                  },
                                  id: 94660,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "22029:6:179",
                                  memberName: "symbol",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 55899,
                                  src: "22023:12:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_external_view$__$returns$_t_string_memory_ptr_$",
                                    typeString: "function () view external returns (string memory)"
                                  }
                                },
                                id: 94661,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "22023:14:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              },
                              {
                                hexValue: "20",
                                id: 94662,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "string",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "22039:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_stringliteral_681afa780d17da29203322b473d3f210a7d621259a4e6ce9e403f5a266ff719a",
                                  typeString: 'literal_string " "'
                                },
                                value: " "
                              },
                              {
                                id: 94663,
                                name: "year",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94631,
                                src: "22044:4:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              },
                              {
                                hexValue: "2d",
                                id: 94664,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "string",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "22050:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                value: "-"
                              },
                              {
                                id: 94665,
                                name: "month",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94633,
                                src: "22055:5:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              },
                              {
                                hexValue: "2d",
                                id: 94666,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "string",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "22062:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                value: "-"
                              },
                              {
                                id: 94667,
                                name: "day",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94635,
                                src: "22067:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                },
                                {
                                  typeIdentifier: "t_stringliteral_681afa780d17da29203322b473d3f210a7d621259a4e6ce9e403f5a266ff719a",
                                  typeString: 'literal_string " "'
                                },
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                },
                                {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                },
                                {
                                  typeIdentifier: "t_stringliteral_d3b8281179950f98149eefdb158d0e1acb56f56e8e343aa9fefafa7e36959561",
                                  typeString: 'literal_string "-"'
                                },
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              ],
                              expression: {
                                id: 94657,
                                name: "abi",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -1,
                                src: "22006:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_abi",
                                  typeString: "abi"
                                }
                              },
                              id: 94658,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              memberLocation: "22010:12:179",
                              memberName: "encodePacked",
                              nodeType: "MemberAccess",
                              src: "22006:16:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
                                typeString: "function () pure returns (bytes memory)"
                              }
                            },
                            id: 94668,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "22006:65:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          ],
                          id: 94656,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          lValueRequested: false,
                          nodeType: "ElementaryTypeNameExpression",
                          src: "21999:6:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_string_storage_ptr_$",
                            typeString: "type(string storage pointer)"
                          },
                          typeName: {
                            id: 94655,
                            name: "string",
                            nodeType: "ElementaryTypeName",
                            src: "21999:6:179",
                            typeDescriptions: {}
                          }
                        },
                        id: 94669,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "21999:73:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory"
                        }
                      }
                    ],
                    id: 94670,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "21900:182:179",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                      typeString: "tuple(string memory,string memory)"
                    }
                  },
                  functionReturnParameters: 94629,
                  id: 94671,
                  nodeType: "Return",
                  src: "21893:189:179"
                }
              ]
            },
            documentation: {
              id: 94618,
              nodeType: "StructuredDocumentation",
              src: "21261:349:179",
              text: "@notice     Computes the name and symbol of a derivative token\n @param      base_       The address of the underlying token\n @param      expiry_     The timestamp at which the vesting expires\n @return     string      The name of the derivative token\n @return     string      The symbol of the derivative token"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_computeNameAndSymbol",
            nameLocation: "21624:21:179",
            parameters: {
              id: 94624,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94621,
                  mutability: "mutable",
                  name: "base_",
                  nameLocation: "21661:5:179",
                  nodeType: "VariableDeclaration",
                  scope: 94673,
                  src: "21655:11:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_contract$_ERC20_$56264",
                    typeString: "contract ERC20"
                  },
                  typeName: {
                    id: 94620,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94619,
                      name: "ERC20",
                      nameLocations: ["21655:5:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 56264,
                      src: "21655:5:179"
                    },
                    referencedDeclaration: 56264,
                    src: "21655:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94623,
                  mutability: "mutable",
                  name: "expiry_",
                  nameLocation: "21683:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94673,
                  src: "21676:14:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint48",
                    typeString: "uint48"
                  },
                  typeName: {
                    id: 94622,
                    name: "uint48",
                    nodeType: "ElementaryTypeName",
                    src: "21676:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint48",
                      typeString: "uint48"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21645:51:179"
            },
            returnParameters: {
              id: 94629,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94626,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94673,
                  src: "21720:13:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 94625,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "21720:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94628,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94673,
                  src: "21735:13:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 94627,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "21735:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "21719:30:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94773,
            nodeType: "FunctionDefinition",
            src: "22723:1141:179",
            nodes: [],
            body: {
              id: 94772,
              nodeType: "Block",
              src: "22910:954:179",
              nodes: [],
              statements: [
                {
                  assignments: [94690],
                  declarations: [
                    {
                      constant: false,
                      id: 94690,
                      mutability: "mutable",
                      name: "underlyingToken",
                      nameLocation: "22958:15:179",
                      nodeType: "VariableDeclaration",
                      scope: 94772,
                      src: "22952:21:179",
                      stateVariable: false,
                      storageLocation: "default",
                      typeDescriptions: {
                        typeIdentifier: "t_contract$_ERC20_$56264",
                        typeString: "contract ERC20"
                      },
                      typeName: {
                        id: 94689,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94688,
                          name: "ERC20",
                          nameLocations: ["22952:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 56264,
                          src: "22952:5:179"
                        },
                        referencedDeclaration: 56264,
                        src: "22952:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94694,
                  initialValue: {
                    arguments: [
                      {
                        id: 94692,
                        name: "underlyingToken_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94676,
                        src: "22982:16:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      ],
                      id: 94691,
                      name: "ERC20",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 56264,
                      src: "22976:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                        typeString: "type(contract ERC20)"
                      }
                    },
                    id: 94693,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "typeConversion",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "22976:23:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_contract$_ERC20_$56264",
                      typeString: "contract ERC20"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "22952:47:179"
                },
                {
                  expression: {
                    id: 94703,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftHandSide: {
                      id: 94695,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94684,
                      src: "23009:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    nodeType: "Assignment",
                    operator: "=",
                    rightHandSide: {
                      arguments: [
                        {
                          id: 94697,
                          name: "underlyingToken",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94690,
                          src: "23031:15:179",
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_ERC20_$56264",
                            typeString: "contract ERC20"
                          }
                        },
                        {
                          expression: {
                            id: 94698,
                            name: "params_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94679,
                            src: "23048:7:179",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                              typeString: "struct ILinearVesting.VestingParams memory"
                            }
                          },
                          id: 94699,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "23056:5:179",
                          memberName: "start",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83435,
                          src: "23048:13:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        },
                        {
                          expression: {
                            id: 94700,
                            name: "params_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94679,
                            src: "23063:7:179",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                              typeString: "struct ILinearVesting.VestingParams memory"
                            }
                          },
                          id: 94701,
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "23071:6:179",
                          memberName: "expiry",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 83437,
                          src: "23063:14:179",
                          typeDescriptions: {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_contract$_ERC20_$56264",
                            typeString: "contract ERC20"
                          },
                          {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          },
                          {
                            typeIdentifier: "t_uint48",
                            typeString: "uint48"
                          }
                        ],
                        id: 94696,
                        name: "_computeId",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94617,
                        src: "23020:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_function_internal_pure$_t_contract$_ERC20_$56264_$_t_uint48_$_t_uint48_$returns$_t_uint256_$",
                          typeString: "function (contract ERC20,uint48,uint48) pure returns (uint256)"
                        }
                      },
                      id: 94702,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      kind: "functionCall",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "23020:58:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    src: "23009:69:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  id: 94704,
                  nodeType: "ExpressionStatement",
                  src: "23009:69:179"
                },
                {
                  assignments: [94707],
                  declarations: [
                    {
                      constant: false,
                      id: 94707,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "23151:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94772,
                      src: "23137:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94706,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94705,
                          name: "Token",
                          nameLocations: ["23137:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "23137:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "23137:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94711,
                  initialValue: {
                    baseExpression: {
                      id: 94708,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "23159:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94710,
                    indexExpression: {
                      id: 94709,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94684,
                      src: "23173:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "23159:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "23137:45:179"
                },
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    },
                    id: 94715,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94712,
                        name: "token",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94707,
                        src: "23196:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        }
                      },
                      id: 94713,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "23202:6:179",
                      memberName: "exists",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82868,
                      src: "23196:12:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      hexValue: "66616c7365",
                      id: 94714,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "bool",
                      lValueRequested: false,
                      nodeType: "Literal",
                      src: "23212:5:179",
                      typeDescriptions: {
                        typeIdentifier: "t_bool",
                        typeString: "bool"
                      },
                      value: "false"
                    },
                    src: "23196:21:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94758,
                  nodeType: "IfStatement",
                  src: "23192:488:179",
                  trueBody: {
                    id: 94757,
                    nodeType: "Block",
                    src: "23219:461:179",
                    statements: [
                      {
                        expression: {
                          id: 94720,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 94716,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94707,
                              src: "23270:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94718,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "23276:6:179",
                            memberName: "exists",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82868,
                            src: "23270:12:179",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            hexValue: "74727565",
                            id: 94719,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "bool",
                            lValueRequested: false,
                            nodeType: "Literal",
                            src: "23285:4:179",
                            typeDescriptions: {
                              typeIdentifier: "t_bool",
                              typeString: "bool"
                            },
                            value: "true"
                          },
                          src: "23270:19:179",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 94721,
                        nodeType: "ExpressionStatement",
                        src: "23270:19:179"
                      },
                      {
                        expression: {
                          id: 94726,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 94722,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94707,
                              src: "23303:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94724,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "23309:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "23303:21:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            id: 94725,
                            name: "underlyingToken_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94676,
                            src: "23327:16:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "23303:40:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        id: 94727,
                        nodeType: "ExpressionStatement",
                        src: "23303:40:179"
                      },
                      {
                        expression: {
                          id: 94740,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 94728,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94707,
                              src: "23357:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94730,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "23363:4:179",
                            memberName: "data",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82876,
                            src: "23357:10:179",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_storage",
                              typeString: "bytes storage ref"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    expression: {
                                      id: 94734,
                                      name: "params_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 94679,
                                      src: "23403:7:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                        typeString: "struct ILinearVesting.VestingParams memory"
                                      }
                                    },
                                    id: 94735,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "23411:5:179",
                                    memberName: "start",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 83435,
                                    src: "23403:13:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    }
                                  },
                                  {
                                    expression: {
                                      id: 94736,
                                      name: "params_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 94679,
                                      src: "23426:7:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                        typeString: "struct ILinearVesting.VestingParams memory"
                                      }
                                    },
                                    id: 94737,
                                    isConstant: false,
                                    isLValue: true,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "23434:6:179",
                                    memberName: "expiry",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 83437,
                                    src: "23426:14:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    },
                                    {
                                      typeIdentifier: "t_uint48",
                                      typeString: "uint48"
                                    }
                                  ],
                                  id: 94733,
                                  name: "VestingParams",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 83438,
                                  src: "23381:13:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                                    typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                                  }
                                },
                                id: 94738,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "structConstructorCall",
                                lValueRequested: false,
                                nameLocations: ["23396:5:179", "23418:6:179"],
                                names: ["start", "expiry"],
                                nodeType: "FunctionCall",
                                src: "23381:61:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                  typeString: "struct ILinearVesting.VestingParams memory"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                  typeString: "struct ILinearVesting.VestingParams memory"
                                }
                              ],
                              expression: {
                                id: 94731,
                                name: "abi",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -1,
                                src: "23370:3:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_abi",
                                  typeString: "abi"
                                }
                              },
                              id: 94732,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              memberLocation: "23374:6:179",
                              memberName: "encode",
                              nodeType: "MemberAccess",
                              src: "23370:10:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$",
                                typeString: "function () pure returns (bytes memory)"
                              }
                            },
                            id: 94739,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "23370:73:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          },
                          src: "23357:86:179",
                          typeDescriptions: {
                            typeIdentifier: "t_bytes_storage",
                            typeString: "bytes storage ref"
                          }
                        },
                        id: 94741,
                        nodeType: "ExpressionStatement",
                        src: "23357:86:179"
                      },
                      {
                        expression: {
                          id: 94746,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            baseExpression: {
                              id: 94742,
                              name: "tokenMetadata",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 88048,
                              src: "23516:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                                typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                              }
                            },
                            id: 94744,
                            indexExpression: {
                              id: 94743,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94684,
                              src: "23530:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            nodeType: "IndexAccess",
                            src: "23516:23:179",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Token_$82877_storage",
                              typeString: "struct IDerivative.Token storage ref"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            id: 94745,
                            name: "token",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94707,
                            src: "23542:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                              typeString: "struct IDerivative.Token storage pointer"
                            }
                          },
                          src: "23516:31:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage",
                            typeString: "struct IDerivative.Token storage ref"
                          }
                        },
                        id: 94747,
                        nodeType: "ExpressionStatement",
                        src: "23516:31:179"
                      },
                      {
                        eventCall: {
                          arguments: [
                            {
                              id: 94749,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94684,
                              src: "23611:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              expression: {
                                id: 94750,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94679,
                                src: "23621:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                  typeString: "struct ILinearVesting.VestingParams memory"
                                }
                              },
                              id: 94751,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "23629:5:179",
                              memberName: "start",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83435,
                              src: "23621:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint48",
                                typeString: "uint48"
                              }
                            },
                            {
                              expression: {
                                id: 94752,
                                name: "params_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94679,
                                src: "23636:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                  typeString: "struct ILinearVesting.VestingParams memory"
                                }
                              },
                              id: 94753,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "23644:6:179",
                              memberName: "expiry",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83437,
                              src: "23636:14:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint48",
                                typeString: "uint48"
                              }
                            },
                            {
                              id: 94754,
                              name: "underlyingToken_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94676,
                              src: "23652:16:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_uint48",
                                typeString: "uint48"
                              },
                              {
                                typeIdentifier: "t_uint48",
                                typeString: "uint48"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 94748,
                            name: "DerivativeCreated",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83387,
                            src: "23593:17:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_event_nonpayable$_t_uint256_$_t_uint48_$_t_uint48_$_t_address_$returns$__$",
                              typeString: "function (uint256,uint48,uint48,address)"
                            }
                          },
                          id: 94755,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "23593:76:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 94756,
                        nodeType: "EmitStatement",
                        src: "23588:81:179"
                      }
                    ]
                  }
                },
                {
                  condition: {
                    id: 94759,
                    name: "wrapped_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94681,
                    src: "23744:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94766,
                  nodeType: "IfStatement",
                  src: "23740:75:179",
                  trueBody: {
                    id: 94765,
                    nodeType: "Block",
                    src: "23754:61:179",
                    statements: [
                      {
                        expression: {
                          arguments: [
                            {
                              id: 94761,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94684,
                              src: "23788:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              id: 94762,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94707,
                              src: "23798:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            ],
                            id: 94760,
                            name: "_deployWrapIfNeeded",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94892,
                            src: "23768:19:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_nonpayable$_t_uint256_$_t_struct$_Token_$82877_storage_ptr_$returns$_t_address_$",
                              typeString: "function (uint256,struct IDerivative.Token storage pointer) returns (address)"
                            }
                          },
                          id: 94763,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "23768:36:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        id: 94764,
                        nodeType: "ExpressionStatement",
                        src: "23768:36:179"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    components: [
                      {
                        id: 94767,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94684,
                        src: "23833:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 94768,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94707,
                          src: "23843:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94769,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "23849:7:179",
                        memberName: "wrapped",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82870,
                        src: "23843:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      }
                    ],
                    id: 94770,
                    isConstant: false,
                    isInlineArray: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "TupleExpression",
                    src: "23832:25:179",
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_uint256_$_t_address_$",
                      typeString: "tuple(uint256,address)"
                    }
                  },
                  functionReturnParameters: 94687,
                  id: 94771,
                  nodeType: "Return",
                  src: "23825:32:179"
                }
              ]
            },
            documentation: {
              id: 94674,
              nodeType: "StructuredDocumentation",
              src: "22095:623:179",
              text: "@notice     Deploys the derivative token if it does not already exist\n @dev        If the derivative token does not exist, it will be deployed using a token id\n             computed from the parameters.\n @param      underlyingToken_    The address of the underlying token\n @param      params_             The parameters for the derivative token\n @param      wrapped_            Whether or not to wrap the derivative token\n @return     tokenId_            The ID of the derivative token\n @return     wrappedAddress_     The address of the wrapped derivative token"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_deployIfNeeded",
            nameLocation: "22732:15:179",
            parameters: {
              id: 94682,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94676,
                  mutability: "mutable",
                  name: "underlyingToken_",
                  nameLocation: "22765:16:179",
                  nodeType: "VariableDeclaration",
                  scope: 94773,
                  src: "22757:24:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94675,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "22757:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94679,
                  mutability: "mutable",
                  name: "params_",
                  nameLocation: "22812:7:179",
                  nodeType: "VariableDeclaration",
                  scope: 94773,
                  src: "22791:28:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                    typeString: "struct ILinearVesting.VestingParams"
                  },
                  typeName: {
                    id: 94678,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94677,
                      name: "VestingParams",
                      nameLocations: ["22791:13:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 83438,
                      src: "22791:13:179"
                    },
                    referencedDeclaration: 83438,
                    src: "22791:13:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                      typeString: "struct ILinearVesting.VestingParams"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94681,
                  mutability: "mutable",
                  name: "wrapped_",
                  nameLocation: "22834:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94773,
                  src: "22829:13:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_bool",
                    typeString: "bool"
                  },
                  typeName: {
                    id: 94680,
                    name: "bool",
                    nodeType: "ElementaryTypeName",
                    src: "22829:4:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "22747:101:179"
            },
            returnParameters: {
              id: 94687,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94684,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "22875:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94773,
                  src: "22867:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94683,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "22867:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94686,
                  mutability: "mutable",
                  name: "wrappedAddress_",
                  nameLocation: "22893:15:179",
                  nodeType: "VariableDeclaration",
                  scope: 94773,
                  src: "22885:23:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94685,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "22885:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "22866:43:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94892,
            nodeType: "FunctionDefinition",
            src: "24285:1335:179",
            nodes: [],
            body: {
              id: 94891,
              nodeType: "Block",
              src: "24418:1202:179",
              nodes: [],
              statements: [
                {
                  condition: {
                    commonType: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    },
                    id: 94790,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    lValueRequested: false,
                    leftExpression: {
                      expression: {
                        id: 94784,
                        name: "token_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 94779,
                        src: "24482:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token storage pointer"
                        }
                      },
                      id: 94785,
                      isConstant: false,
                      isLValue: true,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "24489:7:179",
                      memberName: "wrapped",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 82870,
                      src: "24482:14:179",
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    nodeType: "BinaryOperation",
                    operator: "==",
                    rightExpression: {
                      arguments: [
                        {
                          hexValue: "30",
                          id: 94788,
                          isConstant: false,
                          isLValue: false,
                          isPure: true,
                          kind: "number",
                          lValueRequested: false,
                          nodeType: "Literal",
                          src: "24508:1:179",
                          typeDescriptions: {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          },
                          value: "0"
                        }
                      ],
                      expression: {
                        argumentTypes: [
                          {
                            typeIdentifier: "t_rational_0_by_1",
                            typeString: "int_const 0"
                          }
                        ],
                        id: 94787,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "24500:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_address_$",
                          typeString: "type(address)"
                        },
                        typeName: {
                          id: 94786,
                          name: "address",
                          nodeType: "ElementaryTypeName",
                          src: "24500:7:179",
                          typeDescriptions: {}
                        }
                      },
                      id: 94789,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      kind: "typeConversion",
                      lValueRequested: false,
                      nameLocations: [],
                      names: [],
                      nodeType: "FunctionCall",
                      src: "24500:10:179",
                      tryCall: false,
                      typeDescriptions: {
                        typeIdentifier: "t_address",
                        typeString: "address"
                      }
                    },
                    src: "24482:28:179",
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 94887,
                  nodeType: "IfStatement",
                  src: "24478:1104:179",
                  trueBody: {
                    id: 94886,
                    nodeType: "Block",
                    src: "24512:1070:179",
                    statements: [
                      {
                        condition: {
                          commonType: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          },
                          id: 94796,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftExpression: {
                            id: 94791,
                            name: "_IMPLEMENTATION",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 93445,
                            src: "24600:15:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "BinaryOperation",
                          operator: "==",
                          rightExpression: {
                            arguments: [
                              {
                                hexValue: "30",
                                id: 94794,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                kind: "number",
                                lValueRequested: false,
                                nodeType: "Literal",
                                src: "24627:1:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_rational_0_by_1",
                                  typeString: "int_const 0"
                                },
                                value: "0"
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_rational_0_by_1",
                                  typeString: "int_const 0"
                                }
                              ],
                              id: 94793,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "24619:7:179",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_address_$",
                                typeString: "type(address)"
                              },
                              typeName: {
                                id: 94792,
                                name: "address",
                                nodeType: "ElementaryTypeName",
                                src: "24619:7:179",
                                typeDescriptions: {}
                              }
                            },
                            id: 94795,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "24619:10:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "24600:29:179",
                          typeDescriptions: {
                            typeIdentifier: "t_bool",
                            typeString: "bool"
                          }
                        },
                        id: 94800,
                        nodeType: "IfStatement",
                        src: "24596:57:179",
                        trueBody: {
                          errorCall: {
                            arguments: [],
                            expression: {
                              argumentTypes: [],
                              id: 94797,
                              name: "InvalidParams",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 83429,
                              src: "24638:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_error_pure$__$returns$__$",
                                typeString: "function () pure"
                              }
                            },
                            id: 94798,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "24638:15:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_tuple$__$",
                              typeString: "tuple()"
                            }
                          },
                          id: 94799,
                          nodeType: "RevertStatement",
                          src: "24631:22:179"
                        }
                      },
                      {
                        assignments: [94803],
                        declarations: [
                          {
                            constant: false,
                            id: 94803,
                            mutability: "mutable",
                            name: "data",
                            nameLocation: "24723:4:179",
                            nodeType: "VariableDeclaration",
                            scope: 94886,
                            src: "24702:25:179",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                              typeString: "struct ILinearVesting.VestingParams"
                            },
                            typeName: {
                              id: 94802,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 94801,
                                name: "VestingParams",
                                nameLocations: ["24702:13:179"],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 83438,
                                src: "24702:13:179"
                              },
                              referencedDeclaration: 83438,
                              src: "24702:13:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                                typeString: "struct ILinearVesting.VestingParams"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 94811,
                        initialValue: {
                          arguments: [
                            {
                              expression: {
                                id: 94806,
                                name: "token_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94779,
                                src: "24741:6:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 94807,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "24748:4:179",
                              memberName: "data",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82876,
                              src: "24741:11:179",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_storage",
                                typeString: "bytes storage ref"
                              }
                            },
                            {
                              components: [
                                {
                                  id: 94808,
                                  name: "VestingParams",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: 83438,
                                  src: "24755:13:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                                    typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                                  }
                                }
                              ],
                              id: 94809,
                              isConstant: false,
                              isInlineArray: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "TupleExpression",
                              src: "24754:15:179",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                                typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_bytes_storage",
                                typeString: "bytes storage ref"
                              },
                              {
                                typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                                typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                              }
                            ],
                            expression: {
                              id: 94804,
                              name: "abi",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -1,
                              src: "24730:3:179",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_abi",
                                typeString: "abi"
                              }
                            },
                            id: 94805,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "24734:6:179",
                            memberName: "decode",
                            nodeType: "MemberAccess",
                            src: "24730:10:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                              typeString: "function () pure"
                            }
                          },
                          id: 94810,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "24730:40:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "24702:68:179"
                      },
                      {
                        assignments: [94814],
                        declarations: [
                          {
                            constant: false,
                            id: 94814,
                            mutability: "mutable",
                            name: "baseToken",
                            nameLocation: "24790:9:179",
                            nodeType: "VariableDeclaration",
                            scope: 94886,
                            src: "24784:15:179",
                            stateVariable: false,
                            storageLocation: "default",
                            typeDescriptions: {
                              typeIdentifier: "t_contract$_ERC20_$56264",
                              typeString: "contract ERC20"
                            },
                            typeName: {
                              id: 94813,
                              nodeType: "UserDefinedTypeName",
                              pathNode: {
                                id: 94812,
                                name: "ERC20",
                                nameLocations: ["24784:5:179"],
                                nodeType: "IdentifierPath",
                                referencedDeclaration: 56264,
                                src: "24784:5:179"
                              },
                              referencedDeclaration: 56264,
                              src: "24784:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 94819,
                        initialValue: {
                          arguments: [
                            {
                              expression: {
                                id: 94816,
                                name: "token_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94779,
                                src: "24808:6:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 94817,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "24815:15:179",
                              memberName: "underlyingToken",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82872,
                              src: "24808:22:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 94815,
                            name: "ERC20",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 56264,
                            src: "24802:5:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                              typeString: "type(contract ERC20)"
                            }
                          },
                          id: 94818,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "typeConversion",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "24802:29:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_contract$_ERC20_$56264",
                            typeString: "contract ERC20"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "24784:47:179"
                      },
                      {
                        assignments: [94821, 94823],
                        declarations: [
                          {
                            constant: false,
                            id: 94821,
                            mutability: "mutable",
                            name: "name_",
                            nameLocation: "24910:5:179",
                            nodeType: "VariableDeclaration",
                            scope: 94886,
                            src: "24896:19:179",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_string_memory_ptr",
                              typeString: "string"
                            },
                            typeName: {
                              id: 94820,
                              name: "string",
                              nodeType: "ElementaryTypeName",
                              src: "24896:6:179",
                              typeDescriptions: {
                                typeIdentifier: "t_string_storage_ptr",
                                typeString: "string"
                              }
                            },
                            visibility: "internal"
                          },
                          {
                            constant: false,
                            id: 94823,
                            mutability: "mutable",
                            name: "symbol_",
                            nameLocation: "24931:7:179",
                            nodeType: "VariableDeclaration",
                            scope: 94886,
                            src: "24917:21:179",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_string_memory_ptr",
                              typeString: "string"
                            },
                            typeName: {
                              id: 94822,
                              name: "string",
                              nodeType: "ElementaryTypeName",
                              src: "24917:6:179",
                              typeDescriptions: {
                                typeIdentifier: "t_string_storage_ptr",
                                typeString: "string"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 94829,
                        initialValue: {
                          arguments: [
                            {
                              id: 94825,
                              name: "baseToken",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94814,
                              src: "24980:9:179",
                              typeDescriptions: {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              }
                            },
                            {
                              expression: {
                                id: 94826,
                                name: "data",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94803,
                                src: "24991:4:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                  typeString: "struct ILinearVesting.VestingParams memory"
                                }
                              },
                              id: 94827,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "24996:6:179",
                              memberName: "expiry",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 83437,
                              src: "24991:11:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint48",
                                typeString: "uint48"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_contract$_ERC20_$56264",
                                typeString: "contract ERC20"
                              },
                              {
                                typeIdentifier: "t_uint48",
                                typeString: "uint48"
                              }
                            ],
                            id: 94824,
                            name: "_computeNameAndSymbol",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 94673,
                            src: "24958:21:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_internal_view$_t_contract$_ERC20_$56264_$_t_uint48_$returns$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                              typeString: "function (contract ERC20,uint48) view returns (string memory,string memory)"
                            }
                          },
                          id: 94828,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "24958:45:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                            typeString: "tuple(string memory,string memory)"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "24895:108:179"
                      },
                      {
                        assignments: [94831],
                        declarations: [
                          {
                            constant: false,
                            id: 94831,
                            mutability: "mutable",
                            name: "wrappedTokenData",
                            nameLocation: "25030:16:179",
                            nodeType: "VariableDeclaration",
                            scope: 94886,
                            src: "25017:29:179",
                            stateVariable: false,
                            storageLocation: "memory",
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes"
                            },
                            typeName: {
                              id: 94830,
                              name: "bytes",
                              nodeType: "ElementaryTypeName",
                              src: "25017:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_bytes_storage_ptr",
                                typeString: "bytes"
                              }
                            },
                            visibility: "internal"
                          }
                        ],
                        id: 94866,
                        initialValue: {
                          arguments: [
                            {
                              arguments: [
                                {
                                  arguments: [
                                    {
                                      id: 94838,
                                      name: "name_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 94821,
                                      src: "25097:5:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_string_memory_ptr",
                                        typeString: "string memory"
                                      }
                                    }
                                  ],
                                  expression: {
                                    argumentTypes: [
                                      {
                                        typeIdentifier: "t_string_memory_ptr",
                                        typeString: "string memory"
                                      }
                                    ],
                                    id: 94837,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "25091:5:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_bytes_storage_ptr_$",
                                      typeString: "type(bytes storage pointer)"
                                    },
                                    typeName: {
                                      id: 94836,
                                      name: "bytes",
                                      nodeType: "ElementaryTypeName",
                                      src: "25091:5:179",
                                      typeDescriptions: {}
                                    }
                                  },
                                  id: 94839,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "typeConversion",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "25091:12:179",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_bytes_memory_ptr",
                                    typeString: "bytes memory"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_bytes_memory_ptr",
                                    typeString: "bytes memory"
                                  }
                                ],
                                id: 94835,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "25083:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_bytes32_$",
                                  typeString: "type(bytes32)"
                                },
                                typeName: {
                                  id: 94834,
                                  name: "bytes32",
                                  nodeType: "ElementaryTypeName",
                                  src: "25083:7:179",
                                  typeDescriptions: {}
                                }
                              },
                              id: 94840,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "25083:21:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_bytes32",
                                typeString: "bytes32"
                              }
                            },
                            {
                              arguments: [
                                {
                                  arguments: [
                                    {
                                      id: 94845,
                                      name: "symbol_",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 94823,
                                      src: "25144:7:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_string_memory_ptr",
                                        typeString: "string memory"
                                      }
                                    }
                                  ],
                                  expression: {
                                    argumentTypes: [
                                      {
                                        typeIdentifier: "t_string_memory_ptr",
                                        typeString: "string memory"
                                      }
                                    ],
                                    id: 94844,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "25138:5:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_bytes_storage_ptr_$",
                                      typeString: "type(bytes storage pointer)"
                                    },
                                    typeName: {
                                      id: 94843,
                                      name: "bytes",
                                      nodeType: "ElementaryTypeName",
                                      src: "25138:5:179",
                                      typeDescriptions: {}
                                    }
                                  },
                                  id: 94846,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "typeConversion",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "25138:14:179",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_bytes_memory_ptr",
                                    typeString: "bytes memory"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_bytes_memory_ptr",
                                    typeString: "bytes memory"
                                  }
                                ],
                                id: 94842,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "25130:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_bytes32_$",
                                  typeString: "type(bytes32)"
                                },
                                typeName: {
                                  id: 94841,
                                  name: "bytes32",
                                  nodeType: "ElementaryTypeName",
                                  src: "25130:7:179",
                                  typeDescriptions: {}
                                }
                              },
                              id: 94847,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "25130:23:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_bytes32",
                                typeString: "bytes32"
                              }
                            },
                            {
                              arguments: [
                                {
                                  arguments: [],
                                  expression: {
                                    argumentTypes: [],
                                    expression: {
                                      id: 94850,
                                      name: "baseToken",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 94814,
                                      src: "25187:9:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_contract$_ERC20_$56264",
                                        typeString: "contract ERC20"
                                      }
                                    },
                                    id: 94851,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    lValueRequested: false,
                                    memberLocation: "25197:8:179",
                                    memberName: "decimals",
                                    nodeType: "MemberAccess",
                                    referencedDeclaration: 55901,
                                    src: "25187:18:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_function_external_view$__$returns$_t_uint8_$",
                                      typeString: "function () view external returns (uint8)"
                                    }
                                  },
                                  id: 94852,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  kind: "functionCall",
                                  lValueRequested: false,
                                  nameLocations: [],
                                  names: [],
                                  nodeType: "FunctionCall",
                                  src: "25187:20:179",
                                  tryCall: false,
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint8",
                                    typeString: "uint8"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint8",
                                    typeString: "uint8"
                                  }
                                ],
                                id: 94849,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "25181:5:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint8_$",
                                  typeString: "type(uint8)"
                                },
                                typeName: {
                                  id: 94848,
                                  name: "uint8",
                                  nodeType: "ElementaryTypeName",
                                  src: "25181:5:179",
                                  typeDescriptions: {}
                                }
                              },
                              id: 94853,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "25181:27:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint8",
                                typeString: "uint8"
                              }
                            },
                            {
                              arguments: [
                                {
                                  expression: {
                                    id: 94856,
                                    name: "data",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94803,
                                    src: "25245:4:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                                      typeString: "struct ILinearVesting.VestingParams memory"
                                    }
                                  },
                                  id: 94857,
                                  isConstant: false,
                                  isLValue: true,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "25250:6:179",
                                  memberName: "expiry",
                                  nodeType: "MemberAccess",
                                  referencedDeclaration: 83437,
                                  src: "25245:11:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_uint48",
                                    typeString: "uint48"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_uint48",
                                    typeString: "uint48"
                                  }
                                ],
                                id: 94855,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "25238:6:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_uint64_$",
                                  typeString: "type(uint64)"
                                },
                                typeName: {
                                  id: 94854,
                                  name: "uint64",
                                  nodeType: "ElementaryTypeName",
                                  src: "25238:6:179",
                                  typeDescriptions: {}
                                }
                              },
                              id: 94858,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "25238:19:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              }
                            },
                            {
                              arguments: [
                                {
                                  id: 94861,
                                  name: "this",
                                  nodeType: "Identifier",
                                  overloadedDeclarations: [],
                                  referencedDeclaration: -28,
                                  src: "25303:4:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_contract$_LinearVesting_$95102",
                                    typeString: "contract LinearVesting"
                                  }
                                }
                              ],
                              expression: {
                                argumentTypes: [
                                  {
                                    typeIdentifier: "t_contract$_LinearVesting_$95102",
                                    typeString: "contract LinearVesting"
                                  }
                                ],
                                id: 94860,
                                isConstant: false,
                                isLValue: false,
                                isPure: true,
                                lValueRequested: false,
                                nodeType: "ElementaryTypeNameExpression",
                                src: "25295:7:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_type$_t_address_$",
                                  typeString: "type(address)"
                                },
                                typeName: {
                                  id: 94859,
                                  name: "address",
                                  nodeType: "ElementaryTypeName",
                                  src: "25295:7:179",
                                  typeDescriptions: {}
                                }
                              },
                              id: 94862,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              kind: "typeConversion",
                              lValueRequested: false,
                              nameLocations: [],
                              names: [],
                              nodeType: "FunctionCall",
                              src: "25295:13:179",
                              tryCall: false,
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            {
                              expression: {
                                id: 94863,
                                name: "token_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94779,
                                src: "25335:6:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 94864,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "25342:15:179",
                              memberName: "underlyingToken",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82872,
                              src: "25335:22:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_bytes32",
                                typeString: "bytes32"
                              },
                              {
                                typeIdentifier: "t_bytes32",
                                typeString: "bytes32"
                              },
                              {
                                typeIdentifier: "t_uint8",
                                typeString: "uint8"
                              },
                              {
                                typeIdentifier: "t_uint64",
                                typeString: "uint64"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            expression: {
                              id: 94832,
                              name: "abi",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: -1,
                              src: "25049:3:179",
                              typeDescriptions: {
                                typeIdentifier: "t_magic_abi",
                                typeString: "abi"
                              }
                            },
                            id: 94833,
                            isConstant: false,
                            isLValue: false,
                            isPure: true,
                            lValueRequested: false,
                            memberLocation: "25053:12:179",
                            memberName: "encodePacked",
                            nodeType: "MemberAccess",
                            src: "25049:16:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_abiencodepacked_pure$__$returns$_t_bytes_memory_ptr_$",
                              typeString: "function () pure returns (bytes memory)"
                            }
                          },
                          id: 94865,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "25049:336:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_bytes_memory_ptr",
                            typeString: "bytes memory"
                          }
                        },
                        nodeType: "VariableDeclarationStatement",
                        src: "25017:368:179"
                      },
                      {
                        expression: {
                          id: 94878,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          leftHandSide: {
                            expression: {
                              id: 94867,
                              name: "token_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94779,
                              src: "25399:6:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94869,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: true,
                            memberLocation: "25406:7:179",
                            memberName: "wrapped",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82870,
                            src: "25399:14:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          nodeType: "Assignment",
                          operator: "=",
                          rightHandSide: {
                            arguments: [
                              {
                                id: 94872,
                                name: "wrappedTokenData",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94831,
                                src: "25439:16:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_bytes_memory_ptr",
                                  typeString: "bytes memory"
                                }
                              },
                              {
                                arguments: [
                                  {
                                    id: 94875,
                                    name: "tokenId_",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 94776,
                                    src: "25465:8:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_uint256",
                                      typeString: "uint256"
                                    }
                                  ],
                                  id: 94874,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: true,
                                  lValueRequested: false,
                                  nodeType: "ElementaryTypeNameExpression",
                                  src: "25457:7:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_type$_t_bytes32_$",
                                    typeString: "type(bytes32)"
                                  },
                                  typeName: {
                                    id: 94873,
                                    name: "bytes32",
                                    nodeType: "ElementaryTypeName",
                                    src: "25457:7:179",
                                    typeDescriptions: {}
                                  }
                                },
                                id: 94876,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "typeConversion",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "25457:17:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_bytes32",
                                  typeString: "bytes32"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_bytes_memory_ptr",
                                  typeString: "bytes memory"
                                },
                                {
                                  typeIdentifier: "t_bytes32",
                                  typeString: "bytes32"
                                }
                              ],
                              expression: {
                                id: 94870,
                                name: "_IMPLEMENTATION",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 93445,
                                src: "25416:15:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_address",
                                  typeString: "address"
                                }
                              },
                              id: 94871,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "25432:6:179",
                              memberName: "clone3",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 86878,
                              src: "25416:22:179",
                              typeDescriptions: {
                                typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_bytes_memory_ptr_$_t_bytes32_$returns$_t_address_$attached_to$_t_address_$",
                                typeString: "function (address,bytes memory,bytes32) returns (address)"
                              }
                            },
                            id: 94877,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "functionCall",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "25416:59:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          src: "25399:76:179",
                          typeDescriptions: {
                            typeIdentifier: "t_address",
                            typeString: "address"
                          }
                        },
                        id: 94879,
                        nodeType: "ExpressionStatement",
                        src: "25399:76:179"
                      },
                      {
                        eventCall: {
                          arguments: [
                            {
                              id: 94881,
                              name: "tokenId_",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94776,
                              src: "25546:8:179",
                              typeDescriptions: {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              }
                            },
                            {
                              expression: {
                                id: 94882,
                                name: "token_",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: 94779,
                                src: "25556:6:179",
                                typeDescriptions: {
                                  typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                  typeString: "struct IDerivative.Token storage pointer"
                                }
                              },
                              id: 94883,
                              isConstant: false,
                              isLValue: true,
                              isPure: false,
                              lValueRequested: false,
                              memberLocation: "25563:7:179",
                              memberName: "wrapped",
                              nodeType: "MemberAccess",
                              referencedDeclaration: 82870,
                              src: "25556:14:179",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            }
                          ],
                          expression: {
                            argumentTypes: [
                              {
                                typeIdentifier: "t_uint256",
                                typeString: "uint256"
                              },
                              {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            ],
                            id: 94880,
                            name: "WrappedDerivativeCreated",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83393,
                            src: "25521:24:179",
                            typeDescriptions: {
                              typeIdentifier: "t_function_event_nonpayable$_t_uint256_$_t_address_$returns$__$",
                              typeString: "function (uint256,address)"
                            }
                          },
                          id: 94884,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          kind: "functionCall",
                          lValueRequested: false,
                          nameLocations: [],
                          names: [],
                          nodeType: "FunctionCall",
                          src: "25521:50:179",
                          tryCall: false,
                          typeDescriptions: {
                            typeIdentifier: "t_tuple$__$",
                            typeString: "tuple()"
                          }
                        },
                        id: 94885,
                        nodeType: "EmitStatement",
                        src: "25516:55:179"
                      }
                    ]
                  }
                },
                {
                  expression: {
                    expression: {
                      id: 94888,
                      name: "token_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94779,
                      src: "25599:6:179",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token storage pointer"
                      }
                    },
                    id: 94889,
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    memberLocation: "25606:7:179",
                    memberName: "wrapped",
                    nodeType: "MemberAccess",
                    referencedDeclaration: 82870,
                    src: "25599:14:179",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  functionReturnParameters: 94783,
                  id: 94890,
                  nodeType: "Return",
                  src: "25592:21:179"
                }
              ]
            },
            documentation: {
              id: 94774,
              nodeType: "StructuredDocumentation",
              src: "23870:410:179",
              text: "@notice     Deploys the wrapped derivative token if it does not already exist\n @dev        If the wrapped derivative token does not exist, it will be deployed\n @param      tokenId_            The ID of the derivative token\n @param      token_              The metadata for the derivative token\n @return     wrappedAddress      The address of the wrapped derivative token"
            },
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "_deployWrapIfNeeded",
            nameLocation: "24294:19:179",
            parameters: {
              id: 94780,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94776,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "24331:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94892,
                  src: "24323:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94775,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "24323:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 94779,
                  mutability: "mutable",
                  name: "token_",
                  nameLocation: "24363:6:179",
                  nodeType: "VariableDeclaration",
                  scope: 94892,
                  src: "24349:20:179",
                  stateVariable: false,
                  storageLocation: "storage",
                  typeDescriptions: {
                    typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                    typeString: "struct IDerivative.Token"
                  },
                  typeName: {
                    id: 94778,
                    nodeType: "UserDefinedTypeName",
                    pathNode: {
                      id: 94777,
                      name: "Token",
                      nameLocations: ["24349:5:179"],
                      nodeType: "IdentifierPath",
                      referencedDeclaration: 82877,
                      src: "24349:5:179"
                    },
                    referencedDeclaration: 82877,
                    src: "24349:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                      typeString: "struct IDerivative.Token"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "24313:62:179"
            },
            returnParameters: {
              id: 94783,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94782,
                  mutability: "mutable",
                  name: "wrappedAddress",
                  nameLocation: "24402:14:179",
                  nodeType: "VariableDeclaration",
                  scope: 94892,
                  src: "24394:22:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 94781,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "24394:7:179",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "24393:24:179"
            },
            scope: 95102,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "internal"
          },
          {
            id: 94936,
            nodeType: "FunctionDefinition",
            src: "25808:409:179",
            nodes: [],
            body: {
              id: 94935,
              nodeType: "Block",
              src: "25956:261:179",
              nodes: [],
              statements: [
                {
                  assignments: [94906],
                  declarations: [
                    {
                      constant: false,
                      id: 94906,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "25980:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94935,
                      src: "25966:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94905,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94904,
                          name: "Token",
                          nameLocations: ["25966:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "25966:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "25966:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94910,
                  initialValue: {
                    baseExpression: {
                      id: 94907,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "25988:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94909,
                    indexExpression: {
                      id: 94908,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94895,
                      src: "26002:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "25988:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "25966:45:179"
                },
                {
                  assignments: [94913],
                  declarations: [
                    {
                      constant: false,
                      id: 94913,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "26042:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 94935,
                      src: "26021:25:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 94912,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94911,
                          name: "VestingParams",
                          nameLocations: ["26021:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "26021:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "26021:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94921,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 94916,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94906,
                          src: "26060:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94917,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "26066:4:179",
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82876,
                        src: "26060:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        }
                      },
                      {
                        components: [
                          {
                            id: 94918,
                            name: "VestingParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83438,
                            src: "26073:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                              typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                            }
                          }
                        ],
                        id: 94919,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "26072:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 94914,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "26049:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 94915,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "26053:6:179",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "26049:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94920,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "26049:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "26021:67:179"
                },
                {
                  assignments: [94923, null],
                  declarations: [
                    {
                      constant: false,
                      id: 94923,
                      mutability: "mutable",
                      name: "name_",
                      nameLocation: "26114:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94935,
                      src: "26100:19:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string"
                      },
                      typeName: {
                        id: 94922,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "26100:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string"
                        }
                      },
                      visibility: "internal"
                    },
                    null
                  ],
                  id: 94932,
                  initialValue: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 94926,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94906,
                              src: "26152:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94927,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "26158:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "26152:21:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 94925,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "26146:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 94928,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "26146:28:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        expression: {
                          id: 94929,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94913,
                          src: "26176:4:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 94930,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "26181:6:179",
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83437,
                        src: "26176:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      ],
                      id: 94924,
                      name: "_computeNameAndSymbol",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94673,
                      src: "26124:21:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_contract$_ERC20_$56264_$_t_uint48_$returns$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                        typeString: "function (contract ERC20,uint48) view returns (string memory,string memory)"
                      }
                    },
                    id: 94931,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "26124:64:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                      typeString: "tuple(string memory,string memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "26099:89:179"
                },
                {
                  expression: {
                    id: 94933,
                    name: "name_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94923,
                    src: "26205:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory"
                    }
                  },
                  functionReturnParameters: 94903,
                  id: 94934,
                  nodeType: "Return",
                  src: "26198:12:179"
                }
              ]
            },
            baseFunctions: [84375],
            documentation: {
              id: 94893,
              nodeType: "StructuredDocumentation",
              src: "25676:127:179",
              text: "@inheritdoc ERC6909Metadata\n @dev        This function reverts if:\n             - The token ID does not exist"
            },
            functionSelector: "00ad800c",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94899,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94895,
                    src: "25910:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94900,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94898,
                  name: "onlyValidTokenId",
                  nameLocations: ["25893:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "25893:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "25893:26:179"
              }
            ],
            name: "name",
            nameLocation: "25817:4:179",
            overrides: {
              id: 94897,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "25876:8:179"
            },
            parameters: {
              id: 94896,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94895,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "25830:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94936,
                  src: "25822:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94894,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "25822:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "25821:18:179"
            },
            returnParameters: {
              id: 94903,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94902,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94936,
                  src: "25937:13:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 94901,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "25937:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "25936:15:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          },
          {
            id: 94980,
            nodeType: "FunctionDefinition",
            src: "26355:416:179",
            nodes: [],
            body: {
              id: 94979,
              nodeType: "Block",
              src: "26505:266:179",
              nodes: [],
              statements: [
                {
                  assignments: [94950],
                  declarations: [
                    {
                      constant: false,
                      id: 94950,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "26529:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 94979,
                      src: "26515:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94949,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94948,
                          name: "Token",
                          nameLocations: ["26515:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "26515:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "26515:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94954,
                  initialValue: {
                    baseExpression: {
                      id: 94951,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "26537:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94953,
                    indexExpression: {
                      id: 94952,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94939,
                      src: "26551:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "26537:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "26515:45:179"
                },
                {
                  assignments: [94957],
                  declarations: [
                    {
                      constant: false,
                      id: 94957,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "26591:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 94979,
                      src: "26570:25:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 94956,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94955,
                          name: "VestingParams",
                          nameLocations: ["26570:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "26570:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "26570:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94965,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 94960,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94950,
                          src: "26609:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 94961,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "26615:4:179",
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82876,
                        src: "26609:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        }
                      },
                      {
                        components: [
                          {
                            id: 94962,
                            name: "VestingParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83438,
                            src: "26622:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                              typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                            }
                          }
                        ],
                        id: 94963,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "26621:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 94958,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "26598:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 94959,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "26602:6:179",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "26598:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 94964,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "26598:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "26570:67:179"
                },
                {
                  assignments: [null, 94967],
                  declarations: [
                    null,
                    {
                      constant: false,
                      id: 94967,
                      mutability: "mutable",
                      name: "symbol_",
                      nameLocation: "26665:7:179",
                      nodeType: "VariableDeclaration",
                      scope: 94979,
                      src: "26651:21:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string"
                      },
                      typeName: {
                        id: 94966,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "26651:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94976,
                  initialValue: {
                    arguments: [
                      {
                        arguments: [
                          {
                            expression: {
                              id: 94970,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94950,
                              src: "26704:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 94971,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "26710:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "26704:21:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 94969,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "26698:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 94972,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "26698:28:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      {
                        expression: {
                          id: 94973,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 94957,
                          src: "26728:4:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 94974,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "26733:6:179",
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83437,
                        src: "26728:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        },
                        {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      ],
                      id: 94968,
                      name: "_computeNameAndSymbol",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94673,
                      src: "26676:21:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_view$_t_contract$_ERC20_$56264_$_t_uint48_$returns$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                        typeString: "function (contract ERC20,uint48) view returns (string memory,string memory)"
                      }
                    },
                    id: 94975,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "26676:64:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$_t_string_memory_ptr_$_t_string_memory_ptr_$",
                      typeString: "tuple(string memory,string memory)"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "26648:92:179"
                },
                {
                  expression: {
                    id: 94977,
                    name: "symbol_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94967,
                    src: "26757:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory"
                    }
                  },
                  functionReturnParameters: 94947,
                  id: 94978,
                  nodeType: "Return",
                  src: "26750:14:179"
                }
              ]
            },
            baseFunctions: [84383],
            documentation: {
              id: 94937,
              nodeType: "StructuredDocumentation",
              src: "26223:127:179",
              text: "@inheritdoc ERC6909Metadata\n @dev        This function reverts if:\n             - The token ID does not exist"
            },
            functionSelector: "4e41a1fb",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94943,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94939,
                    src: "26459:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94944,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94942,
                  name: "onlyValidTokenId",
                  nameLocations: ["26442:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "26442:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "26442:26:179"
              }
            ],
            name: "symbol",
            nameLocation: "26364:6:179",
            overrides: {
              id: 94941,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "26425:8:179"
            },
            parameters: {
              id: 94940,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94939,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "26379:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 94980,
                  src: "26371:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94938,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "26371:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "26370:18:179"
            },
            returnParameters: {
              id: 94947,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94946,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 94980,
                  src: "26486:13:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 94945,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "26486:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "26485:15:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          },
          {
            id: 95007,
            nodeType: "FunctionDefinition",
            src: "26909:263:179",
            nodes: [],
            body: {
              id: 95006,
              nodeType: "Block",
              src: "27053:119:179",
              nodes: [],
              statements: [
                {
                  assignments: [94994],
                  declarations: [
                    {
                      constant: false,
                      id: 94994,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "27077:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 95006,
                      src: "27063:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 94993,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 94992,
                          name: "Token",
                          nameLocations: ["27063:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "27063:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "27063:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 94998,
                  initialValue: {
                    baseExpression: {
                      id: 94995,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "27085:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 94997,
                    indexExpression: {
                      id: 94996,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 94983,
                      src: "27099:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "27085:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27063:45:179"
                },
                {
                  expression: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        arguments: [
                          {
                            expression: {
                              id: 95e3,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 94994,
                              src: "27132:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 95001,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "27138:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "27132:21:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 94999,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "27126:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 95002,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "27126:28:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      id: 95003,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "27155:8:179",
                      memberName: "decimals",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 55901,
                      src: "27126:37:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_external_view$__$returns$_t_uint8_$",
                        typeString: "function () view external returns (uint8)"
                      }
                    },
                    id: 95004,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "27126:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8"
                    }
                  },
                  functionReturnParameters: 94991,
                  id: 95005,
                  nodeType: "Return",
                  src: "27119:46:179"
                }
              ]
            },
            baseFunctions: [84391],
            documentation: {
              id: 94981,
              nodeType: "StructuredDocumentation",
              src: "26777:127:179",
              text: "@inheritdoc ERC6909Metadata\n @dev        This function reverts if:\n             - The token ID does not exist"
            },
            functionSelector: "3f47e662",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 94987,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 94983,
                    src: "27015:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 94988,
                kind: "modifierInvocation",
                modifierName: {
                  id: 94986,
                  name: "onlyValidTokenId",
                  nameLocations: ["26998:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "26998:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "26998:26:179"
              }
            ],
            name: "decimals",
            nameLocation: "26918:8:179",
            overrides: {
              id: 94985,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "26981:8:179"
            },
            parameters: {
              id: 94984,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94983,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "26935:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 95007,
                  src: "26927:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 94982,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "26927:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "26926:18:179"
            },
            returnParameters: {
              id: 94991,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 94990,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 95007,
                  src: "27042:5:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8"
                  },
                  typeName: {
                    id: 94989,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "27042:5:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "27041:7:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          },
          {
            id: 95101,
            nodeType: "FunctionDefinition",
            src: "27369:1515:179",
            nodes: [],
            body: {
              id: 95100,
              nodeType: "Block",
              src: "27521:1363:179",
              nodes: [],
              statements: [
                {
                  assignments: [95021],
                  declarations: [
                    {
                      constant: false,
                      id: 95021,
                      mutability: "mutable",
                      name: "token",
                      nameLocation: "27545:5:179",
                      nodeType: "VariableDeclaration",
                      scope: 95100,
                      src: "27531:19:179",
                      stateVariable: false,
                      storageLocation: "storage",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                        typeString: "struct IDerivative.Token"
                      },
                      typeName: {
                        id: 95020,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 95019,
                          name: "Token",
                          nameLocations: ["27531:5:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 82877,
                          src: "27531:5:179"
                        },
                        referencedDeclaration: 82877,
                        src: "27531:5:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                          typeString: "struct IDerivative.Token"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 95025,
                  initialValue: {
                    baseExpression: {
                      id: 95022,
                      name: "tokenMetadata",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 88048,
                      src: "27553:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_mapping$_t_uint256_$_t_struct$_Token_$82877_storage_$",
                        typeString: "mapping(uint256 => struct IDerivative.Token storage ref)"
                      }
                    },
                    id: 95024,
                    indexExpression: {
                      id: 95023,
                      name: "tokenId_",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 95010,
                      src: "27567:8:179",
                      typeDescriptions: {
                        typeIdentifier: "t_uint256",
                        typeString: "uint256"
                      }
                    },
                    isConstant: false,
                    isLValue: true,
                    isPure: false,
                    lValueRequested: false,
                    nodeType: "IndexAccess",
                    src: "27553:23:179",
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Token_$82877_storage",
                      typeString: "struct IDerivative.Token storage ref"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27531:45:179"
                },
                {
                  assignments: [95028],
                  declarations: [
                    {
                      constant: false,
                      id: 95028,
                      mutability: "mutable",
                      name: "data",
                      nameLocation: "27607:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 95100,
                      src: "27586:25:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                        typeString: "struct ILinearVesting.VestingParams"
                      },
                      typeName: {
                        id: 95027,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 95026,
                          name: "VestingParams",
                          nameLocations: ["27586:13:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 83438,
                          src: "27586:13:179"
                        },
                        referencedDeclaration: 83438,
                        src: "27586:13:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_VestingParams_$83438_storage_ptr",
                          typeString: "struct ILinearVesting.VestingParams"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 95036,
                  initialValue: {
                    arguments: [
                      {
                        expression: {
                          id: 95031,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 95021,
                          src: "27625:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 95032,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "27631:4:179",
                        memberName: "data",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82876,
                        src: "27625:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        }
                      },
                      {
                        components: [
                          {
                            id: 95033,
                            name: "VestingParams",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 83438,
                            src: "27638:13:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                              typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                            }
                          }
                        ],
                        id: 95034,
                        isConstant: false,
                        isInlineArray: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "TupleExpression",
                        src: "27637:15:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bytes_storage",
                          typeString: "bytes storage ref"
                        },
                        {
                          typeIdentifier: "t_type$_t_struct$_VestingParams_$83438_storage_ptr_$",
                          typeString: "type(struct ILinearVesting.VestingParams storage pointer)"
                        }
                      ],
                      expression: {
                        id: 95029,
                        name: "abi",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: -1,
                        src: "27614:3:179",
                        typeDescriptions: {
                          typeIdentifier: "t_magic_abi",
                          typeString: "abi"
                        }
                      },
                      id: 95030,
                      isConstant: false,
                      isLValue: false,
                      isPure: true,
                      lValueRequested: false,
                      memberLocation: "27618:6:179",
                      memberName: "decode",
                      nodeType: "MemberAccess",
                      src: "27614:10:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_abidecode_pure$__$returns$__$",
                        typeString: "function () pure"
                      }
                    },
                    id: 95035,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "27614:39:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                      typeString: "struct ILinearVesting.VestingParams memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27586:67:179"
                },
                {
                  assignments: [95038],
                  declarations: [
                    {
                      constant: false,
                      id: 95038,
                      mutability: "mutable",
                      name: "_symbol",
                      nameLocation: "27721:7:179",
                      nodeType: "VariableDeclaration",
                      scope: 95100,
                      src: "27707:21:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_string_memory_ptr",
                        typeString: "string"
                      },
                      typeName: {
                        id: 95037,
                        name: "string",
                        nodeType: "ElementaryTypeName",
                        src: "27707:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_storage_ptr",
                          typeString: "string"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 95045,
                  initialValue: {
                    arguments: [],
                    expression: {
                      argumentTypes: [],
                      expression: {
                        arguments: [
                          {
                            expression: {
                              id: 95040,
                              name: "token",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 95021,
                              src: "27737:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                                typeString: "struct IDerivative.Token storage pointer"
                              }
                            },
                            id: 95041,
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            memberLocation: "27743:15:179",
                            memberName: "underlyingToken",
                            nodeType: "MemberAccess",
                            referencedDeclaration: 82872,
                            src: "27737:21:179",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          ],
                          id: 95039,
                          name: "ERC20",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 56264,
                          src: "27731:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_type$_t_contract$_ERC20_$56264_$",
                            typeString: "type(contract ERC20)"
                          }
                        },
                        id: 95042,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "typeConversion",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "27731:28:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_contract$_ERC20_$56264",
                          typeString: "contract ERC20"
                        }
                      },
                      id: 95043,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "27760:6:179",
                      memberName: "symbol",
                      nodeType: "MemberAccess",
                      referencedDeclaration: 55899,
                      src: "27731:35:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_external_view$__$returns$_t_string_memory_ptr_$",
                        typeString: "function () view external returns (string memory)"
                      }
                    },
                    id: 95044,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "27731:37:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27707:61:179"
                },
                {
                  assignments: [95048],
                  declarations: [
                    {
                      constant: false,
                      id: 95048,
                      mutability: "mutable",
                      name: "info",
                      nameLocation: "27845:4:179",
                      nodeType: "VariableDeclaration",
                      scope: 95100,
                      src: "27833:16:179",
                      stateVariable: false,
                      storageLocation: "memory",
                      typeDescriptions: {
                        typeIdentifier: "t_struct$_Info_$95123_memory_ptr",
                        typeString: "struct LinearVestingCard.Info"
                      },
                      typeName: {
                        id: 95047,
                        nodeType: "UserDefinedTypeName",
                        pathNode: {
                          id: 95046,
                          name: "Info",
                          nameLocations: ["27833:4:179"],
                          nodeType: "IdentifierPath",
                          referencedDeclaration: 95123,
                          src: "27833:4:179"
                        },
                        referencedDeclaration: 95123,
                        src: "27833:4:179",
                        typeDescriptions: {
                          typeIdentifier: "t_struct$_Info_$95123_storage_ptr",
                          typeString: "struct LinearVestingCard.Info"
                        }
                      },
                      visibility: "internal"
                    }
                  ],
                  id: 95062,
                  initialValue: {
                    arguments: [
                      {
                        id: 95050,
                        name: "tokenId_",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 95010,
                        src: "27880:8:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      },
                      {
                        expression: {
                          id: 95051,
                          name: "token",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 95021,
                          src: "27913:5:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_Token_$82877_storage_ptr",
                            typeString: "struct IDerivative.Token storage pointer"
                          }
                        },
                        id: 95052,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "27919:15:179",
                        memberName: "underlyingToken",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 82872,
                        src: "27913:21:179",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 95053,
                        name: "_symbol",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 95038,
                        src: "27965:7:179",
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory"
                        }
                      },
                      {
                        expression: {
                          id: 95054,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 95028,
                          src: "27993:4:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 95055,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "27998:5:179",
                        memberName: "start",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83435,
                        src: "27993:10:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      {
                        expression: {
                          id: 95056,
                          name: "data",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 95028,
                          src: "28025:4:179",
                          typeDescriptions: {
                            typeIdentifier: "t_struct$_VestingParams_$83438_memory_ptr",
                            typeString: "struct ILinearVesting.VestingParams memory"
                          }
                        },
                        id: 95057,
                        isConstant: false,
                        isLValue: true,
                        isPure: false,
                        lValueRequested: false,
                        memberLocation: "28030:6:179",
                        memberName: "expiry",
                        nodeType: "MemberAccess",
                        referencedDeclaration: 83437,
                        src: "28025:11:179",
                        typeDescriptions: {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        }
                      },
                      {
                        arguments: [
                          {
                            id: 95059,
                            name: "tokenId_",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 95010,
                            src: "28070:8:179",
                            typeDescriptions: {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_uint256",
                              typeString: "uint256"
                            }
                          ],
                          id: 95058,
                          name: "totalSupply",
                          nodeType: "Identifier",
                          overloadedDeclarations: [88077],
                          referencedDeclaration: 88077,
                          src: "28058:11:179",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$",
                            typeString: "function (uint256) view returns (uint256)"
                          }
                        },
                        id: 95060,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "28058:21:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory"
                        },
                        {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        },
                        {
                          typeIdentifier: "t_uint48",
                          typeString: "uint48"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 95049,
                      name: "Info",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 95123,
                      src: "27852:4:179",
                      typeDescriptions: {
                        typeIdentifier: "t_type$_t_struct$_Info_$95123_storage_ptr_$",
                        typeString: "type(struct LinearVestingCard.Info storage pointer)"
                      }
                    },
                    id: 95061,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "structConstructorCall",
                    lValueRequested: false,
                    nameLocations: [
                      "27871:7:179",
                      "27902:9:179",
                      "27948:15:179",
                      "27986:5:179",
                      "28017:6:179",
                      "28050:6:179"
                    ],
                    names: [
                      "tokenId",
                      "baseToken",
                      "baseTokenSymbol",
                      "start",
                      "expiry",
                      "supply"
                    ],
                    nodeType: "FunctionCall",
                    src: "27852:238:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_struct$_Info_$95123_memory_ptr",
                      typeString: "struct LinearVestingCard.Info memory"
                    }
                  },
                  nodeType: "VariableDeclarationStatement",
                  src: "27833:257:179"
                },
                {
                  expression: {
                    arguments: [
                      {
                        hexValue: "646174613a6170706c69636174696f6e2f6a736f6e3b6261736536342c",
                        id: 95066,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "28201:31:179",
                        typeDescriptions: {
                          typeIdentifier: "t_stringliteral_bccab2d885f86fda81bfd84dd4248d31f8073b473d187111d36536db073076fa",
                          typeString: 'literal_string "data:application/json;base64,"'
                        },
                        value: "data:application/json;base64,"
                      },
                      {
                        arguments: [
                          {
                            arguments: [
                              {
                                arguments: [
                                  {
                                    hexValue: "7b226e616d65223a2022",
                                    id: 95074,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "string",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "28343:12:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_stringliteral_a773e20fe2bdb77cb0a7501a4c05f8a017bb76d7a29840c69b1dbdd75ee042cc",
                                      typeString: 'literal_string "{"name": ""'
                                    },
                                    value: '{"name": "'
                                  },
                                  {
                                    arguments: [
                                      {
                                        id: 95076,
                                        name: "tokenId_",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 95010,
                                        src: "28386:8:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      }
                                    ],
                                    expression: {
                                      argumentTypes: [
                                        {
                                          typeIdentifier: "t_uint256",
                                          typeString: "uint256"
                                        }
                                      ],
                                      id: 95075,
                                      name: "name",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [94936],
                                      referencedDeclaration: 94936,
                                      src: "28381:4:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_string_memory_ptr_$",
                                        typeString: "function (uint256) view returns (string memory)"
                                      }
                                    },
                                    id: 95077,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    kind: "functionCall",
                                    lValueRequested: false,
                                    nameLocations: [],
                                    names: [],
                                    nodeType: "FunctionCall",
                                    src: "28381:14:179",
                                    tryCall: false,
                                    typeDescriptions: {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    }
                                  },
                                  {
                                    hexValue: "222c20226465736372697074696f6e223a2022",
                                    id: 95078,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "string",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "28421:21:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_stringliteral_15581e6d213db261f08a7321c9994dc20595359d1b11f34d43869e8f39d563bd",
                                      typeString: 'literal_string "", "description": ""'
                                    },
                                    value: '", "description": "'
                                  },
                                  {
                                    id: 95079,
                                    name: "_symbol",
                                    nodeType: "Identifier",
                                    overloadedDeclarations: [],
                                    referencedDeclaration: 95038,
                                    src: "28468:7:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    }
                                  },
                                  {
                                    hexValue: "20536f756c626f756e64204c696e6561722056657374696e67204465726976617469766520546f6b656e2e20506f776572656420627920417869732e222c202261747472696275746573223a20",
                                    id: 95080,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "string",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "28501:79:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_stringliteral_e1e98f61ec4eb8ad3f696d027474d1afed95489345c034fc336a8bf76bd3fb37",
                                      typeString: 'literal_string " Soulbound Linear Vesting Derivative Token. Powered by Axis.", "attributes": "'
                                    },
                                    value: ' Soulbound Linear Vesting Derivative Token. Powered by Axis.", "attributes": '
                                  },
                                  {
                                    arguments: [
                                      {
                                        id: 95082,
                                        name: "info",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 95048,
                                        src: "28618:4:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_struct$_Info_$95123_memory_ptr",
                                          typeString: "struct LinearVestingCard.Info memory"
                                        }
                                      }
                                    ],
                                    expression: {
                                      argumentTypes: [
                                        {
                                          typeIdentifier: "t_struct$_Info_$95123_memory_ptr",
                                          typeString: "struct LinearVestingCard.Info memory"
                                        }
                                      ],
                                      id: 95081,
                                      name: "_attributes",
                                      nodeType: "Identifier",
                                      overloadedDeclarations: [],
                                      referencedDeclaration: 95219,
                                      src: "28606:11:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_function_internal_pure$_t_struct$_Info_$95123_memory_ptr_$returns$_t_string_memory_ptr_$",
                                        typeString: "function (struct LinearVestingCard.Info memory) pure returns (string memory)"
                                      }
                                    },
                                    id: 95083,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    kind: "functionCall",
                                    lValueRequested: false,
                                    nameLocations: [],
                                    names: [],
                                    nodeType: "FunctionCall",
                                    src: "28606:17:179",
                                    tryCall: false,
                                    typeDescriptions: {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    }
                                  },
                                  {
                                    hexValue: "2c2022696d616765223a2022646174613a696d6167652f7376672b786d6c3b6261736536342c",
                                    id: 95084,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "string",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "28649:40:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_stringliteral_efd86493c96306b2f946fd7d9f55783f749f072ec606f784fd3bbb51f6219cfa",
                                      typeString: 'literal_string ", "image": "data:image/svg+xml;base64,"'
                                    },
                                    value: ', "image": "data:image/svg+xml;base64,'
                                  },
                                  {
                                    arguments: [
                                      {
                                        arguments: [
                                          {
                                            arguments: [
                                              {
                                                id: 95090,
                                                name: "info",
                                                nodeType: "Identifier",
                                                overloadedDeclarations: [],
                                                referencedDeclaration: 95048,
                                                src: "28743:4:179",
                                                typeDescriptions: {
                                                  typeIdentifier: "t_struct$_Info_$95123_memory_ptr",
                                                  typeString: "struct LinearVestingCard.Info memory"
                                                }
                                              }
                                            ],
                                            expression: {
                                              argumentTypes: [
                                                {
                                                  typeIdentifier: "t_struct$_Info_$95123_memory_ptr",
                                                  typeString: "struct LinearVestingCard.Info memory"
                                                }
                                              ],
                                              id: 95089,
                                              name: "_render",
                                              nodeType: "Identifier",
                                              overloadedDeclarations: [],
                                              referencedDeclaration: 95290,
                                              src: "28735:7:179",
                                              typeDescriptions: {
                                                typeIdentifier: "t_function_internal_view$_t_struct$_Info_$95123_memory_ptr_$returns$_t_string_memory_ptr_$",
                                                typeString: "function (struct LinearVestingCard.Info memory) view returns (string memory)"
                                              }
                                            },
                                            id: 95091,
                                            isConstant: false,
                                            isLValue: false,
                                            isPure: false,
                                            kind: "functionCall",
                                            lValueRequested: false,
                                            nameLocations: [],
                                            names: [],
                                            nodeType: "FunctionCall",
                                            src: "28735:13:179",
                                            tryCall: false,
                                            typeDescriptions: {
                                              typeIdentifier: "t_string_memory_ptr",
                                              typeString: "string memory"
                                            }
                                          }
                                        ],
                                        expression: {
                                          argumentTypes: [
                                            {
                                              typeIdentifier: "t_string_memory_ptr",
                                              typeString: "string memory"
                                            }
                                          ],
                                          id: 95088,
                                          isConstant: false,
                                          isLValue: false,
                                          isPure: true,
                                          lValueRequested: false,
                                          nodeType: "ElementaryTypeNameExpression",
                                          src: "28729:5:179",
                                          typeDescriptions: {
                                            typeIdentifier: "t_type$_t_bytes_storage_ptr_$",
                                            typeString: "type(bytes storage pointer)"
                                          },
                                          typeName: {
                                            id: 95087,
                                            name: "bytes",
                                            nodeType: "ElementaryTypeName",
                                            src: "28729:5:179",
                                            typeDescriptions: {}
                                          }
                                        },
                                        id: 95092,
                                        isConstant: false,
                                        isLValue: false,
                                        isPure: false,
                                        kind: "typeConversion",
                                        lValueRequested: false,
                                        nameLocations: [],
                                        names: [],
                                        nodeType: "FunctionCall",
                                        src: "28729:20:179",
                                        tryCall: false,
                                        typeDescriptions: {
                                          typeIdentifier: "t_bytes_memory_ptr",
                                          typeString: "bytes memory"
                                        }
                                      }
                                    ],
                                    expression: {
                                      argumentTypes: [
                                        {
                                          typeIdentifier: "t_bytes_memory_ptr",
                                          typeString: "bytes memory"
                                        }
                                      ],
                                      expression: {
                                        id: 95085,
                                        name: "Base64",
                                        nodeType: "Identifier",
                                        overloadedDeclarations: [],
                                        referencedDeclaration: 50215,
                                        src: "28715:6:179",
                                        typeDescriptions: {
                                          typeIdentifier: "t_type$_t_contract$_Base64_$50215_$",
                                          typeString: "type(library Base64)"
                                        }
                                      },
                                      id: 95086,
                                      isConstant: false,
                                      isLValue: false,
                                      isPure: false,
                                      lValueRequested: false,
                                      memberLocation: "28722:6:179",
                                      memberName: "encode",
                                      nodeType: "MemberAccess",
                                      referencedDeclaration: 50214,
                                      src: "28715:13:179",
                                      typeDescriptions: {
                                        typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_string_memory_ptr_$",
                                        typeString: "function (bytes memory) pure returns (string memory)"
                                      }
                                    },
                                    id: 95093,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: false,
                                    kind: "functionCall",
                                    lValueRequested: false,
                                    nameLocations: [],
                                    names: [],
                                    nodeType: "FunctionCall",
                                    src: "28715:35:179",
                                    tryCall: false,
                                    typeDescriptions: {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    }
                                  },
                                  {
                                    hexValue: "227d",
                                    id: 95094,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    kind: "string",
                                    lValueRequested: false,
                                    nodeType: "Literal",
                                    src: "28776:4:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_stringliteral_835b459273672627bbafc3a2eded65187a632f4128bdc79e126c7ef579a27475",
                                      typeString: 'literal_string ""}"'
                                    },
                                    value: '"}'
                                  }
                                ],
                                expression: {
                                  argumentTypes: [
                                    {
                                      typeIdentifier: "t_stringliteral_a773e20fe2bdb77cb0a7501a4c05f8a017bb76d7a29840c69b1dbdd75ee042cc",
                                      typeString: 'literal_string "{"name": ""'
                                    },
                                    {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    },
                                    {
                                      typeIdentifier: "t_stringliteral_15581e6d213db261f08a7321c9994dc20595359d1b11f34d43869e8f39d563bd",
                                      typeString: 'literal_string "", "description": ""'
                                    },
                                    {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    },
                                    {
                                      typeIdentifier: "t_stringliteral_e1e98f61ec4eb8ad3f696d027474d1afed95489345c034fc336a8bf76bd3fb37",
                                      typeString: 'literal_string " Soulbound Linear Vesting Derivative Token. Powered by Axis.", "attributes": "'
                                    },
                                    {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    },
                                    {
                                      typeIdentifier: "t_stringliteral_efd86493c96306b2f946fd7d9f55783f749f072ec606f784fd3bbb51f6219cfa",
                                      typeString: 'literal_string ", "image": "data:image/svg+xml;base64,"'
                                    },
                                    {
                                      typeIdentifier: "t_string_memory_ptr",
                                      typeString: "string memory"
                                    },
                                    {
                                      typeIdentifier: "t_stringliteral_835b459273672627bbafc3a2eded65187a632f4128bdc79e126c7ef579a27475",
                                      typeString: 'literal_string ""}"'
                                    }
                                  ],
                                  expression: {
                                    id: 95072,
                                    isConstant: false,
                                    isLValue: false,
                                    isPure: true,
                                    lValueRequested: false,
                                    nodeType: "ElementaryTypeNameExpression",
                                    src: "28304:6:179",
                                    typeDescriptions: {
                                      typeIdentifier: "t_type$_t_string_storage_ptr_$",
                                      typeString: "type(string storage pointer)"
                                    },
                                    typeName: {
                                      id: 95071,
                                      name: "string",
                                      nodeType: "ElementaryTypeName",
                                      src: "28304:6:179",
                                      typeDescriptions: {}
                                    }
                                  },
                                  id: 95073,
                                  isConstant: false,
                                  isLValue: false,
                                  isPure: false,
                                  lValueRequested: false,
                                  memberLocation: "28311:6:179",
                                  memberName: "concat",
                                  nodeType: "MemberAccess",
                                  src: "28304:13:179",
                                  typeDescriptions: {
                                    typeIdentifier: "t_function_stringconcat_pure$__$returns$_t_string_memory_ptr_$",
                                    typeString: "function () pure returns (string memory)"
                                  }
                                },
                                id: 95095,
                                isConstant: false,
                                isLValue: false,
                                isPure: false,
                                kind: "functionCall",
                                lValueRequested: false,
                                nameLocations: [],
                                names: [],
                                nodeType: "FunctionCall",
                                src: "28304:498:179",
                                tryCall: false,
                                typeDescriptions: {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              }
                            ],
                            expression: {
                              argumentTypes: [
                                {
                                  typeIdentifier: "t_string_memory_ptr",
                                  typeString: "string memory"
                                }
                              ],
                              id: 95070,
                              isConstant: false,
                              isLValue: false,
                              isPure: true,
                              lValueRequested: false,
                              nodeType: "ElementaryTypeNameExpression",
                              src: "28277:5:179",
                              typeDescriptions: {
                                typeIdentifier: "t_type$_t_bytes_storage_ptr_$",
                                typeString: "type(bytes storage pointer)"
                              },
                              typeName: {
                                id: 95069,
                                name: "bytes",
                                nodeType: "ElementaryTypeName",
                                src: "28277:5:179",
                                typeDescriptions: {}
                              }
                            },
                            id: 95096,
                            isConstant: false,
                            isLValue: false,
                            isPure: false,
                            kind: "typeConversion",
                            lValueRequested: false,
                            nameLocations: [],
                            names: [],
                            nodeType: "FunctionCall",
                            src: "28277:543:179",
                            tryCall: false,
                            typeDescriptions: {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          }
                        ],
                        expression: {
                          argumentTypes: [
                            {
                              typeIdentifier: "t_bytes_memory_ptr",
                              typeString: "bytes memory"
                            }
                          ],
                          expression: {
                            id: 95067,
                            name: "Base64",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 50215,
                            src: "28246:6:179",
                            typeDescriptions: {
                              typeIdentifier: "t_type$_t_contract$_Base64_$50215_$",
                              typeString: "type(library Base64)"
                            }
                          },
                          id: 95068,
                          isConstant: false,
                          isLValue: false,
                          isPure: false,
                          lValueRequested: false,
                          memberLocation: "28253:6:179",
                          memberName: "encode",
                          nodeType: "MemberAccess",
                          referencedDeclaration: 50214,
                          src: "28246:13:179",
                          typeDescriptions: {
                            typeIdentifier: "t_function_internal_pure$_t_bytes_memory_ptr_$returns$_t_string_memory_ptr_$",
                            typeString: "function (bytes memory) pure returns (string memory)"
                          }
                        },
                        id: 95097,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        kind: "functionCall",
                        lValueRequested: false,
                        nameLocations: [],
                        names: [],
                        nodeType: "FunctionCall",
                        src: "28246:588:179",
                        tryCall: false,
                        typeDescriptions: {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_stringliteral_bccab2d885f86fda81bfd84dd4248d31f8073b473d187111d36536db073076fa",
                          typeString: 'literal_string "data:application/json;base64,"'
                        },
                        {
                          typeIdentifier: "t_string_memory_ptr",
                          typeString: "string memory"
                        }
                      ],
                      expression: {
                        id: 95064,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        lValueRequested: false,
                        nodeType: "ElementaryTypeNameExpression",
                        src: "28174:6:179",
                        typeDescriptions: {
                          typeIdentifier: "t_type$_t_string_storage_ptr_$",
                          typeString: "type(string storage pointer)"
                        },
                        typeName: {
                          id: 95063,
                          name: "string",
                          nodeType: "ElementaryTypeName",
                          src: "28174:6:179",
                          typeDescriptions: {}
                        }
                      },
                      id: 95065,
                      isConstant: false,
                      isLValue: false,
                      isPure: false,
                      lValueRequested: false,
                      memberLocation: "28181:6:179",
                      memberName: "concat",
                      nodeType: "MemberAccess",
                      src: "28174:13:179",
                      typeDescriptions: {
                        typeIdentifier: "t_function_stringconcat_pure$__$returns$_t_string_memory_ptr_$",
                        typeString: "function () pure returns (string memory)"
                      }
                    },
                    id: 95098,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    nameLocations: [],
                    names: [],
                    nodeType: "FunctionCall",
                    src: "28174:670:179",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory"
                    }
                  },
                  functionReturnParameters: 95018,
                  id: 95099,
                  nodeType: "Return",
                  src: "28167:677:179"
                }
              ]
            },
            baseFunctions: [84399],
            documentation: {
              id: 95008,
              nodeType: "StructuredDocumentation",
              src: "27237:127:179",
              text: "@inheritdoc ERC6909Metadata\n @dev        This function reverts if:\n             - The token ID does not exist"
            },
            functionSelector: "c87b56dd",
            implemented: true,
            kind: "function",
            modifiers: [
              {
                arguments: [
                  {
                    id: 95014,
                    name: "tokenId_",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 95010,
                    src: "27475:8:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  }
                ],
                id: 95015,
                kind: "modifierInvocation",
                modifierName: {
                  id: 95013,
                  name: "onlyValidTokenId",
                  nameLocations: ["27458:16:179"],
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 93517,
                  src: "27458:16:179"
                },
                nodeType: "ModifierInvocation",
                src: "27458:26:179"
              }
            ],
            name: "tokenURI",
            nameLocation: "27378:8:179",
            overrides: {
              id: 95012,
              nodeType: "OverrideSpecifier",
              overrides: [],
              src: "27441:8:179"
            },
            parameters: {
              id: 95011,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 95010,
                  mutability: "mutable",
                  name: "tokenId_",
                  nameLocation: "27395:8:179",
                  nodeType: "VariableDeclaration",
                  scope: 95101,
                  src: "27387:16:179",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 95009,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "27387:7:179",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "27386:18:179"
            },
            returnParameters: {
              id: 95018,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 95017,
                  mutability: "mutable",
                  name: "",
                  nameLocation: "-1:-1:-1",
                  nodeType: "VariableDeclaration",
                  scope: 95101,
                  src: "27502:13:179",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 95016,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "27502:6:179",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "27501:15:179"
            },
            scope: 95102,
            stateMutability: "view",
            virtual: false,
            visibility: "public"
          }
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 93421,
              name: "DerivativeModule",
              nameLocations: ["1600:16:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 88078,
              src: "1600:16:179"
            },
            id: 93422,
            nodeType: "InheritanceSpecifier",
            src: "1600:16:179"
          },
          {
            baseName: {
              id: 93423,
              name: "ILinearVesting",
              nameLocations: ["1618:14:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 83448,
              src: "1618:14:179"
            },
            id: 93424,
            nodeType: "InheritanceSpecifier",
            src: "1618:14:179"
          },
          {
            baseName: {
              id: 93425,
              name: "LinearVestingCard",
              nameLocations: ["1634:17:179"],
              nodeType: "IdentifierPath",
              referencedDeclaration: 95946,
              src: "1634:17:179"
            },
            id: 93426,
            nodeType: "InheritanceSpecifier",
            src: "1634:17:179"
          }
        ],
        canonicalName: "LinearVesting",
        contractDependencies: [96086],
        contractKind: "contract",
        documentation: {
          id: 93420,
          nodeType: "StructuredDocumentation",
          src: "1035:539:179",
          text: "@title      LinearVesting\n @notice     A derivative module that allows for the creation of linearly vesting tokens\n @dev        This module allows for the creation of linearly vesting tokens, where the vesting\n             period is defined by a start and expiry timestamp. The tokens can be wrapped and\n             unwrapped, and the underlying tokens can be redeemed once vested.\n             The start timestamp enables vesting tokens to have a cliff, after which vesting commences.\n @author     Axis Finance"
        },
        fullyImplemented: true,
        linearizedBaseContracts: [
          95102,
          95946,
          83448,
          88078,
          88991,
          84408,
          56583,
          83049
        ],
        name: "LinearVesting",
        nameLocation: "1583:13:179",
        scope: 95103,
        usedErrors: [
          50235,
          82866,
          83423,
          83425,
          83427,
          83429,
          83433,
          88891,
          88894,
          88899
        ]
      }
    ],
    license: "BSL-1.1"
  },
  id: 179
};

// src/abis/sources/TestnetERC20.json
var TestnetERC20_default = {
  abi: [
    {
      inputs: [
        {
          internalType: "string",
          name: "_name",
          type: "string"
        },
        {
          internalType: "string",
          name: "_symbol",
          type: "string"
        },
        {
          internalType: "uint8",
          name: "_decimals",
          type: "uint8"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "Approval",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "Transfer",
      type: "event"
    },
    {
      inputs: [],
      name: "DOMAIN_SEPARATOR",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "PERMIT_TYPEHASH",
      outputs: [
        {
          internalType: "bytes32",
          name: "",
          type: "bytes32"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        },
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "decreaseAmount",
          type: "uint256"
        }
      ],
      name: "decreaseAllowance",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "increaseAmount",
          type: "uint256"
        }
      ],
      name: "increaseAllowance",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        }
      ],
      name: "mint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "",
          type: "address"
        }
      ],
      name: "nonces",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address"
        },
        {
          internalType: "address",
          name: "spender",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256"
        },
        {
          internalType: "uint256",
          name: "deadline",
          type: "uint256"
        },
        {
          internalType: "uint8",
          name: "v",
          type: "uint8"
        },
        {
          internalType: "bytes32",
          name: "r",
          type: "bytes32"
        },
        {
          internalType: "bytes32",
          name: "s",
          type: "bytes32"
        }
      ],
      name: "permit",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address"
        },
        {
          internalType: "address",
          name: "to",
          type: "address"
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool"
        }
      ],
      stateMutability: "nonpayable",
      type: "function"
    }
  ],
  bytecode: {
    object: "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",
    sourceMap: "117:756:126:-:0;;;154:138;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;263:5;270:7;279:9;2251:4:25;:12;263:5:126;2251:4:25;:12;:::i;:::-;-1:-1:-1;2273:6:25;:16;2282:7;2273:6;:16;:::i;:::-;-1:-1:-1;2299:20:25;;;;;2349:13;2330:32;;2399:24;:22;:24::i;:::-;2372:51;;-1:-1:-1;117:756:126;;-1:-1:-1;;;;;117:756:126;5179:446:25;5244:7;5341:95;5474:4;5458:22;;;;;;:::i;:::-;;;;;;;;;;5309:295;;;5450:25:127;;;;5491:18;;5484:34;;;;5502:14:25;5534:18:127;;;5527:34;5538:13:25;5577:18:127;;;5570:34;5581:4:25;5620:19:127;;;5613:61;5422:19;;5309:295:25;;;;;;;;;;;;5282:336;;;;;;5263:355;;5179:446;:::o;14:127:127:-;75:10;70:3;66:20;63:1;56:31;106:4;103:1;96:15;130:4;127:1;120:15;146:885;200:5;253:3;246:4;238:6;234:17;230:27;220:55;;271:1;268;261:12;220:55;294:13;;-1:-1:-1;;;;;356:10:127;;;353:36;;;369:18;;:::i;:::-;444:2;438:9;412:2;498:13;;-1:-1:-1;;494:22:127;;;518:2;490:31;486:40;474:53;;;542:18;;;562:22;;;539:46;536:72;;;588:18;;:::i;:::-;628:10;624:2;617:22;663:2;655:6;648:18;685:4;675:14;;730:3;725:2;720;712:6;708:15;704:24;701:33;698:53;;;747:1;744;737:12;698:53;769:1;760:10;;779:133;793:2;790:1;787:9;779:133;;;881:14;;;877:23;;871:30;850:14;;;846:23;;839:63;804:10;;;;779:133;;;930:2;927:1;924:9;921:80;;;989:1;984:2;979;971:6;967:15;963:24;956:35;921:80;1019:6;146:885;-1:-1:-1;;;;;;146:885:127:o;1036:712::-;1142:6;1150;1158;1211:2;1199:9;1190:7;1186:23;1182:32;1179:52;;;1227:1;1224;1217:12;1179:52;1254:16;;-1:-1:-1;;;;;1319:14:127;;;1316:34;;;1346:1;1343;1336:12;1316:34;1369:61;1422:7;1413:6;1402:9;1398:22;1369:61;:::i;:::-;1359:71;;1476:2;1465:9;1461:18;1455:25;1439:41;;1505:2;1495:8;1492:16;1489:36;;;1521:1;1518;1511:12;1489:36;;1544:63;1599:7;1588:8;1577:9;1573:24;1544:63;:::i;:::-;1534:73;;;1650:2;1639:9;1635:18;1629:25;1694:4;1687:5;1683:16;1676:5;1673:27;1663:55;;1714:1;1711;1704:12;1663:55;1737:5;1727:15;;;1036:712;;;;;:::o;1753:380::-;1832:1;1828:12;;;;1875;;;1896:61;;1950:4;1942:6;1938:17;1928:27;;1896:61;2003:2;1995:6;1992:14;1972:18;1969:38;1966:161;;2049:10;2044:3;2040:20;2037:1;2030:31;2084:4;2081:1;2074:15;2112:4;2109:1;2102:15;1966:161;;1753:380;;;:::o;2264:545::-;2366:2;2361:3;2358:11;2355:448;;;2402:1;2427:5;2423:2;2416:17;2472:4;2468:2;2458:19;2542:2;2530:10;2526:19;2523:1;2519:27;2513:4;2509:38;2578:4;2566:10;2563:20;2560:47;;;-1:-1:-1;2601:4:127;2560:47;2656:2;2651:3;2647:12;2644:1;2640:20;2634:4;2630:31;2620:41;;2711:82;2729:2;2722:5;2719:13;2711:82;;;2774:17;;;2755:1;2744:13;2711:82;;;2715:3;;;2355:448;2264:545;;;:::o;2985:1352::-;3105:10;;-1:-1:-1;;;;;3127:30:127;;3124:56;;;3160:18;;:::i;:::-;3189:97;3279:6;3239:38;3271:4;3265:11;3239:38;:::i;:::-;3233:4;3189:97;:::i;:::-;3341:4;;3405:2;3394:14;;3422:1;3417:663;;;;4124:1;4141:6;4138:89;;;-1:-1:-1;4193:19:127;;;4187:26;4138:89;-1:-1:-1;;2942:1:127;2938:11;;;2934:24;2930:29;2920:40;2966:1;2962:11;;;2917:57;4240:81;;3387:944;;3417:663;2211:1;2204:14;;;2248:4;2235:18;;-1:-1:-1;;3453:20:127;;;3571:236;3585:7;3582:1;3579:14;3571:236;;;3674:19;;;3668:26;3653:42;;3766:27;;;;3734:1;3722:14;;;;3601:19;;3571:236;;;3575:3;3835:6;3826:7;3823:19;3820:201;;;3896:19;;;3890:26;-1:-1:-1;;3979:1:127;3975:14;;;3991:3;3971:24;3967:37;3963:42;3948:58;3933:74;;3820:201;-1:-1:-1;;;;;4067:1:127;4051:14;;;4047:22;4034:36;;-1:-1:-1;2985:1352:127:o;4342:844::-;4472:3;4501:1;4534:6;4528:13;4564:36;4590:9;4564:36;:::i;:::-;4619:1;4636:18;;;4663:133;;;;4810:1;4805:356;;;;4629:532;;4663:133;-1:-1:-1;;4696:24:127;;4684:37;;4769:14;;4762:22;4750:35;;4741:45;;;-1:-1:-1;4663:133:127;;4805:356;4836:6;4833:1;4826:17;4866:4;4911:2;4908:1;4898:16;4936:1;4950:165;4964:6;4961:1;4958:13;4950:165;;;5042:14;;5029:11;;;5022:35;5085:16;;;;4979:10;;4950:165;;;4954:3;;;5144:6;5139:3;5135:16;5128:23;;4629:532;-1:-1:-1;5177:3:127;;4342:844;-1:-1:-1;;;;;;4342:844:127:o;5191:489::-;117:756:126;;;;;;;;;;;;;;;;;;;;;;;;",
    linkReferences: {}
  },
  deployedBytecode: {
    object: "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",
    sourceMap: "117:756:126:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1032:18:25;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;2618:211;;;;;;:::i;:::-;;:::i;:::-;;;1300:14:127;;1293:22;1275:41;;1263:2;1248:18;2618:211:25;1135:187:127;1306:26:25;;;;;;;;;1473:25:127;;;1461:2;1446:18;1306:26:25;1327:177:127;3214:592:25;;;;;;:::i;:::-;;:::i;1647:145::-;;1697:95;1647:145;;1084:31;;;;;;;;2196:4:127;2184:17;;;2166:36;;2154:2;2139:18;1084:31:25;2024:184:127;4996:177:25;;;:::i;393:165:126:-;;;;;;:::i;:::-;;:::i;:::-;;298:89;;;;;;:::i;:::-;;:::i;1339:44:25:-;;;;;;:::i;:::-;;;;;;;;;;;;;;1907:41;;;;;;:::i;:::-;;;;;;;;;;;;;;1057:20;;;:::i;564:307:126:-;;;;;;:::i;:::-;;:::i;2835:373:25:-;;;;;;:::i;:::-;;:::i;3997:993::-;;;;;;:::i;:::-;;:::i;1390:64::-;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;1032:18;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;2618:211::-;2718:10;2692:4;2708:21;;;:9;:21;;;;;;;;;:30;;;;;;;;;;:39;;;2763:37;2692:4;;2708:30;;2763:37;;;;2741:6;1473:25:127;;1461:2;1446:18;;1327:177;2763:37:25;;;;;;;;-1:-1:-1;2818:4:25;2618:211;;;;:::o;3214:592::-;3366:15;;;3332:4;3366:15;;;:9;:15;;;;;;;;3382:10;3366:27;;;;;;;;3455:17;3444:28;;3440:80;;3504:16;3514:6;3504:7;:16;:::i;:::-;3474:15;;;;;;;:9;:15;;;;;;;;3490:10;3474:27;;;;;;;:46;3440:80;3531:15;;;;;;;:9;:15;;;;;:25;;3550:6;;3531:15;:25;;3550:6;;3531:25;:::i;:::-;;;;-1:-1:-1;;3702:13:25;;;;;;;;:9;:13;;;;;;;:23;;;;;;3751:26;3702:13;;3751:26;;;;;;;3719:6;1473:25:127;;1461:2;1446:18;;1327:177;3751:26:25;;;;;;;;-1:-1:-1;3795:4:25;;3214:592;-1:-1:-1;;;;3214:592:25:o;4996:177::-;5053:7;5096:16;5079:13;:33;:87;;5142:24;:22;:24::i;:::-;5072:94;;4996:177;:::o;5079:87::-;-1:-1:-1;5115:24:25;;4996:177::o;393:165:126:-;513:10;503:21;;;;:9;:21;;;;;;;;;:30;;;;;;;;;;486:65;;494:7;;503:47;;536:14;;503:47;:::i;486:65::-;;393:165;;:::o;298:89::-;364:16;370:2;374:5;364;:16::i;:::-;298:89;;:::o;1057:20:25:-;;;;;;;:::i;564:307:126:-;688:10;678:21;;;;:9;:21;;;;;;;;;:30;;;;;;;;;;:48;-1:-1:-1;678:48:126;657:132;;;;;;;4463:2:127;657:132:126;;;4445:21:127;4502:2;4482:18;;;4475:30;4541:34;4521:18;;;4514:62;4612:7;4592:18;;;4585:35;4637:19;;657:132:126;;;;;;;;;826:10;816:21;;;;:9;:21;;;;;;;;;:30;;;;;;;;;;799:65;;807:7;;816:47;;849:14;;816:47;:::i;2835:373:25:-;2931:10;2905:4;2921:21;;;:9;:21;;;;;:31;;2946:6;;2921:21;2905:4;;2921:31;;2946:6;;2921:31;:::i;:::-;;;;-1:-1:-1;;3098:13:25;;;;;;;:9;:13;;;;;;;:23;;;;;;3147:32;3156:10;;3147:32;;;;3115:6;1473:25:127;;1461:2;1446:18;;1327:177;3997:993:25;4216:15;4204:8;:27;;4196:63;;;;;;;4869:2:127;4196:63:25;;;4851:21:127;4908:2;4888:18;;;4881:30;4947:25;4927:18;;;4920:53;4990:18;;4196:63:25;4667:347:127;4196:63:25;4424:14;4538:18;:16;:18::i;:::-;4639:13;;;;;;;;:6;:13;;;;;;;;;:15;;;;;;;;4588:77;;1697:95;4588:77;;;5306:25:127;5408:18;;;5401:43;;;;5480:15;;;5460:18;;;5453:43;5512:18;;;5505:34;;;5555:19;;;5548:35;;;;5599:19;;;;5592:35;;;4588:77:25;;;;;;;;;;5278:19:127;;;4588:77:25;;;4578:88;;;;;;;;5908:66:127;4468:216:25;;;5896:79:127;5991:11;;;5984:27;;;;6027:12;;;6020:28;;;;6064:12;;4468:216:25;;;;;;;;;;;;;4441:257;;4468:216;4441:257;;;;4713:24;4740:26;;;;;;;;;6314:25:127;;;6387:4;6375:17;;6355:18;;;6348:45;;;;6409:18;;;6402:34;;;6452:18;;;6445:34;;;4441:257:25;;-1:-1:-1;4713:24:25;4740:26;;6286:19:127;;4740:26:25;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;4740:26:25;;;;;;-1:-1:-1;;4789:30:25;;;;;;;:59;;;4843:5;4823:25;;:16;:25;;;4789:59;4781:86;;;;;;;6692:2:127;4781:86:25;;;6674:21:127;6731:2;6711:18;;;6704:30;6770:16;6750:18;;;6743:44;6804:18;;4781:86:25;6490:338:127;4781:86:25;4882:27;;;;;;;;:9;:27;;;;;;;;:36;;;;;;;;;;;;;:44;;;4952:31;1473:25:127;;;4882:36:25;;-1:-1:-1;4952:31:25;;;;;;1446:18:127;4952:31:25;;;;;;;3997:993;;;;;;;:::o;5179:446::-;5244:7;5341:95;5474:4;5458:22;;;;;;:::i;:::-;;;;;;;;;;5309:295;;;8474:25:127;;;;8515:18;;8508:34;;;;5502:14:25;8558:18:127;;;8551:34;5538:13:25;8601:18:127;;;8594:34;5581:4:25;8644:19:127;;;8637:84;8446:19;;5309:295:25;;;;;;;;;;;;5282:336;;;;;;5263:355;;5179:446;:::o;5819:325::-;5904:6;5889:11;;:21;;;;;;;:::i;:::-;;;;-1:-1:-1;;6056:13:25;;;;;;;:9;:13;;;;;;;;:23;;;;;;6105:32;1473:25:127;;;6105:32:25;;1446:18:127;6105:32:25;;;;;;;5819:325;;:::o;14:656:127:-;126:4;155:2;184;173:9;166:21;216:6;210:13;259:6;254:2;243:9;239:18;232:34;284:1;294:140;308:6;305:1;302:13;294:140;;;403:14;;;399:23;;393:30;369:17;;;388:2;365:26;358:66;323:10;;294:140;;;452:6;449:1;446:13;443:91;;;522:1;517:2;508:6;497:9;493:22;489:31;482:42;443:91;-1:-1:-1;586:2:127;574:15;591:66;570:88;555:104;;;;661:2;551:113;;14:656;-1:-1:-1;;;14:656:127:o;675:196::-;743:20;;803:42;792:54;;782:65;;772:93;;861:1;858;851:12;772:93;675:196;;;:::o;876:254::-;944:6;952;1005:2;993:9;984:7;980:23;976:32;973:52;;;1021:1;1018;1011:12;973:52;1044:29;1063:9;1044:29;:::i;:::-;1034:39;1120:2;1105:18;;;;1092:32;;-1:-1:-1;;;876:254:127:o;1509:328::-;1586:6;1594;1602;1655:2;1643:9;1634:7;1630:23;1626:32;1623:52;;;1671:1;1668;1661:12;1623:52;1694:29;1713:9;1694:29;:::i;:::-;1684:39;;1742:38;1776:2;1765:9;1761:18;1742:38;:::i;:::-;1732:48;;1827:2;1816:9;1812:18;1799:32;1789:42;;1509:328;;;;;:::o;2213:186::-;2272:6;2325:2;2313:9;2304:7;2300:23;2296:32;2293:52;;;2341:1;2338;2331:12;2293:52;2364:29;2383:9;2364:29;:::i;:::-;2354:39;2213:186;-1:-1:-1;;;2213:186:127:o;2404:693::-;2515:6;2523;2531;2539;2547;2555;2563;2616:3;2604:9;2595:7;2591:23;2587:33;2584:53;;;2633:1;2630;2623:12;2584:53;2656:29;2675:9;2656:29;:::i;:::-;2646:39;;2704:38;2738:2;2727:9;2723:18;2704:38;:::i;:::-;2694:48;;2789:2;2778:9;2774:18;2761:32;2751:42;;2840:2;2829:9;2825:18;2812:32;2802:42;;2894:3;2883:9;2879:19;2866:33;2939:4;2932:5;2928:16;2921:5;2918:27;2908:55;;2959:1;2956;2949:12;2908:55;2404:693;;;;-1:-1:-1;2404:693:127;;;;2982:5;3034:3;3019:19;;3006:33;;-1:-1:-1;3086:3:127;3071:19;;;3058:33;;2404:693;-1:-1:-1;;2404:693:127:o;3102:260::-;3170:6;3178;3231:2;3219:9;3210:7;3206:23;3202:32;3199:52;;;3247:1;3244;3237:12;3199:52;3270:29;3289:9;3270:29;:::i;:::-;3260:39;;3318:38;3352:2;3341:9;3337:18;3318:38;:::i;:::-;3308:48;;3102:260;;;;;:::o;3367:437::-;3446:1;3442:12;;;;3489;;;3510:61;;3564:4;3556:6;3552:17;3542:27;;3510:61;3617:2;3609:6;3606:14;3586:18;3583:38;3580:218;;3654:77;3651:1;3644:88;3755:4;3752:1;3745:15;3783:4;3780:1;3773:15;3580:218;;3367:437;;;:::o;3809:184::-;3861:77;3858:1;3851:88;3958:4;3955:1;3948:15;3982:4;3979:1;3972:15;3998:125;4038:4;4066:1;4063;4060:8;4057:34;;;4071:18;;:::i;:::-;-1:-1:-1;4108:9:127;;3998:125::o;4128:128::-;4168:3;4199:1;4195:6;4192:1;4189:13;4186:39;;;4205:18;;:::i;:::-;-1:-1:-1;4241:9:127;;4128:128::o;6962:1248::-;7092:3;7121:1;7154:6;7148:13;7184:3;7206:1;7234:9;7230:2;7226:18;7216:28;;7294:2;7283:9;7279:18;7316;7306:61;;7360:4;7352:6;7348:17;7338:27;;7306:61;7386:2;7434;7426:6;7423:14;7403:18;7400:38;7397:222;;7473:77;7468:3;7461:90;7574:4;7571:1;7564:15;7604:4;7599:3;7592:17;7397:222;7635:18;7662:191;;;;7867:1;7862:323;;;;7628:557;;7662:191;7710:66;7699:9;7695:82;7690:3;7683:95;7833:6;7826:14;7819:22;7811:6;7807:35;7802:3;7798:45;7791:52;;7662:191;;7862:323;6909:1;6902:14;;;6946:4;6933:18;;7960:1;7974:165;7988:6;7985:1;7982:13;7974:165;;;8066:14;;8053:11;;;8046:35;8109:16;;;;8003:10;;7974:165;;;7978:3;;8168:6;8163:3;8159:16;8152:23;;7628:557;-1:-1:-1;8201:3:127;;6962:1248;-1:-1:-1;;;;;;;;6962:1248:127:o",
    linkReferences: {},
    immutableReferences: {
      "29980": [
        {
          start: 412,
          length: 32
        }
      ],
      "29999": [
        {
          start: 1275,
          length: 32
        }
      ],
      "30001": [
        {
          start: 1328,
          length: 32
        }
      ]
    }
  },
  methodIdentifiers: {
    "DOMAIN_SEPARATOR()": "3644e515",
    "PERMIT_TYPEHASH()": "30adf81f",
    "allowance(address,address)": "dd62ed3e",
    "approve(address,uint256)": "095ea7b3",
    "balanceOf(address)": "70a08231",
    "decimals()": "313ce567",
    "decreaseAllowance(address,uint256)": "a457c2d7",
    "increaseAllowance(address,uint256)": "39509351",
    "mint(address,uint256)": "40c10f19",
    "name()": "06fdde03",
    "nonces(address)": "7ecebe00",
    "permit(address,address,uint256,uint256,uint8,bytes32,bytes32)": "d505accf",
    "symbol()": "95d89b41",
    "totalSupply()": "18160ddd",
    "transfer(address,uint256)": "a9059cbb",
    "transferFrom(address,address,uint256)": "23b872dd"
  },
  rawMetadata: '{"compiler":{"version":"0.8.15+commit.e14f2714"},"language":"Solidity","output":{"abi":[{"inputs":[{"internalType":"string","name":"_name","type":"string"},{"internalType":"string","name":"_symbol","type":"string"},{"internalType":"uint8","name":"_decimals","type":"uint8"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PERMIT_TYPEHASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"decreaseAmount","type":"uint256"}],"name":"decreaseAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"increaseAmount","type":"uint256"}],"name":"increaseAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}],"devdoc":{"kind":"dev","methods":{},"version":1},"userdoc":{"kind":"user","methods":{},"version":1}},"settings":{"compilationTarget":{"src/test/utils/mocks/TestnetERC20.sol":"TestnetERC20"},"evmVersion":"london","libraries":{},"metadata":{"bytecodeHash":"ipfs"},"optimizer":{"enabled":true,"runs":100000},"remappings":[":clones-with-immutable-args/=lib/clones-with-immutable-args/src/",":clones/=lib/clones-with-immutable-args/src/",":ds-test/=lib/ds-test/src/",":forge-std/=lib/forge-std/src/",":hardhat/=node_modules/hardhat/",":openzeppelin-contracts/=lib/openzeppelin-contracts/",":openzeppelin/=lib/openzeppelin-contracts/contracts/",":solidity-code-metrics/=node_modules/solidity-code-metrics/",":solmate/=lib/solmate/src/",":weird-erc20/=lib/solmate/lib/weird-erc20/src/"]},"sources":{"lib/solmate/src/tokens/ERC20.sol":{"keccak256":"0x698cdbf614109fafc2bf00057b60715fa3aba9dad447c42f4f8b749ae16ce84f","license":"AGPL-3.0-only","urls":["bzz-raw://49a39e71d6bde571d04722c90fd42591af806d29d8cbd4cd96f35e443702d899","dweb:/ipfs/QmefLxMt6w2it9daQQFdBTtPeCWDhSqhNWuxQy8e7WrNVr"]},"src/test/utils/mocks/TestnetERC20.sol":{"keccak256":"0x79413477264e48b164eaf799d9e24c570816b56125b12f00329580d6027b81f2","license":"AGPL-3.0-only","urls":["bzz-raw://d68ad226e0dea16f5e56cc4a7c8463b3e2b75e84c8190d16aaaae80787dead67","dweb:/ipfs/QmbsucvneZbfJ183gMBy73ztinwPXt2sfz1127oEu1dMz6"]}},"version":1}',
  metadata: {
    compiler: {
      version: "0.8.15+commit.e14f2714"
    },
    language: "Solidity",
    output: {
      abi: [
        {
          inputs: [
            {
              internalType: "string",
              name: "_name",
              type: "string"
            },
            {
              internalType: "string",
              name: "_symbol",
              type: "string"
            },
            {
              internalType: "uint8",
              name: "_decimals",
              type: "uint8"
            }
          ],
          stateMutability: "nonpayable",
          type: "constructor"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "owner",
              type: "address",
              indexed: true
            },
            {
              internalType: "address",
              name: "spender",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            }
          ],
          type: "event",
          name: "Approval",
          anonymous: false
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "from",
              type: "address",
              indexed: true
            },
            {
              internalType: "address",
              name: "to",
              type: "address",
              indexed: true
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256",
              indexed: false
            }
          ],
          type: "event",
          name: "Transfer",
          anonymous: false
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "DOMAIN_SEPARATOR",
          outputs: [
            {
              internalType: "bytes32",
              name: "",
              type: "bytes32"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "PERMIT_TYPEHASH",
          outputs: [
            {
              internalType: "bytes32",
              name: "",
              type: "bytes32"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            },
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "allowance",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "spender",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "approve",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "balanceOf",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "decimals",
          outputs: [
            {
              internalType: "uint8",
              name: "",
              type: "uint8"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "spender",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "decreaseAmount",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "decreaseAllowance"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "spender",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "increaseAmount",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "increaseAllowance"
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "to",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "value",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "mint"
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "name",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "",
              type: "address"
            }
          ],
          stateMutability: "view",
          type: "function",
          name: "nonces",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "owner",
              type: "address"
            },
            {
              internalType: "address",
              name: "spender",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "value",
              type: "uint256"
            },
            {
              internalType: "uint256",
              name: "deadline",
              type: "uint256"
            },
            {
              internalType: "uint8",
              name: "v",
              type: "uint8"
            },
            {
              internalType: "bytes32",
              name: "r",
              type: "bytes32"
            },
            {
              internalType: "bytes32",
              name: "s",
              type: "bytes32"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "permit"
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "symbol",
          outputs: [
            {
              internalType: "string",
              name: "",
              type: "string"
            }
          ]
        },
        {
          inputs: [],
          stateMutability: "view",
          type: "function",
          name: "totalSupply",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "to",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "transfer",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        },
        {
          inputs: [
            {
              internalType: "address",
              name: "from",
              type: "address"
            },
            {
              internalType: "address",
              name: "to",
              type: "address"
            },
            {
              internalType: "uint256",
              name: "amount",
              type: "uint256"
            }
          ],
          stateMutability: "nonpayable",
          type: "function",
          name: "transferFrom",
          outputs: [
            {
              internalType: "bool",
              name: "",
              type: "bool"
            }
          ]
        }
      ],
      devdoc: {
        kind: "dev",
        methods: {},
        version: 1
      },
      userdoc: {
        kind: "user",
        methods: {},
        version: 1
      }
    },
    settings: {
      remappings: [
        "clones-with-immutable-args/=lib/clones-with-immutable-args/src/",
        "clones/=lib/clones-with-immutable-args/src/",
        "ds-test/=lib/ds-test/src/",
        "forge-std/=lib/forge-std/src/",
        "hardhat/=node_modules/hardhat/",
        "openzeppelin-contracts/=lib/openzeppelin-contracts/",
        "openzeppelin/=lib/openzeppelin-contracts/contracts/",
        "solidity-code-metrics/=node_modules/solidity-code-metrics/",
        "solmate/=lib/solmate/src/",
        "weird-erc20/=lib/solmate/lib/weird-erc20/src/"
      ],
      optimizer: {
        enabled: true,
        runs: 1e5
      },
      metadata: {
        bytecodeHash: "ipfs"
      },
      compilationTarget: {
        "src/test/utils/mocks/TestnetERC20.sol": "TestnetERC20"
      },
      libraries: {}
    },
    sources: {
      "lib/solmate/src/tokens/ERC20.sol": {
        keccak256: "0x698cdbf614109fafc2bf00057b60715fa3aba9dad447c42f4f8b749ae16ce84f",
        urls: [
          "bzz-raw://49a39e71d6bde571d04722c90fd42591af806d29d8cbd4cd96f35e443702d899",
          "dweb:/ipfs/QmefLxMt6w2it9daQQFdBTtPeCWDhSqhNWuxQy8e7WrNVr"
        ],
        license: "AGPL-3.0-only"
      },
      "src/test/utils/mocks/TestnetERC20.sol": {
        keccak256: "0x79413477264e48b164eaf799d9e24c570816b56125b12f00329580d6027b81f2",
        urls: [
          "bzz-raw://d68ad226e0dea16f5e56cc4a7c8463b3e2b75e84c8190d16aaaae80787dead67",
          "dweb:/ipfs/QmbsucvneZbfJ183gMBy73ztinwPXt2sfz1127oEu1dMz6"
        ],
        license: "AGPL-3.0-only"
      }
    },
    version: 1
  },
  ast: {
    absolutePath: "src/test/utils/mocks/TestnetERC20.sol",
    id: 255086,
    exportedSymbols: {
      ERC20: [30350],
      TestnetERC20: [255085]
    },
    nodeType: "SourceUnit",
    src: "42:832:126",
    nodes: [
      {
        id: 255e3,
        nodeType: "PragmaDirective",
        src: "42:24:126",
        nodes: [],
        literals: ["solidity", ">=", "0.8", ".0"]
      },
      {
        id: 255002,
        nodeType: "ImportDirective",
        src: "68:47:126",
        nodes: [],
        absolutePath: "lib/solmate/src/tokens/ERC20.sol",
        file: "solmate/tokens/ERC20.sol",
        nameLocation: "-1:-1:-1",
        scope: 255086,
        sourceUnit: 30351,
        symbolAliases: [
          {
            foreign: {
              id: 255001,
              name: "ERC20",
              nodeType: "Identifier",
              overloadedDeclarations: [],
              referencedDeclaration: 30350,
              src: "76:5:126",
              typeDescriptions: {}
            },
            nameLocation: "-1:-1:-1"
          }
        ],
        unitAlias: ""
      },
      {
        id: 255085,
        nodeType: "ContractDefinition",
        src: "117:756:126",
        nodes: [
          {
            id: 255019,
            nodeType: "FunctionDefinition",
            src: "154:138:126",
            nodes: [],
            body: {
              id: 255018,
              nodeType: "Block",
              src: "290:2:126",
              nodes: [],
              statements: []
            },
            implemented: true,
            kind: "constructor",
            modifiers: [
              {
                arguments: [
                  {
                    id: 255013,
                    name: "_name",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 255006,
                    src: "263:5:126",
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory"
                    }
                  },
                  {
                    id: 255014,
                    name: "_symbol",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 255008,
                    src: "270:7:126",
                    typeDescriptions: {
                      typeIdentifier: "t_string_memory_ptr",
                      typeString: "string memory"
                    }
                  },
                  {
                    id: 255015,
                    name: "_decimals",
                    nodeType: "Identifier",
                    overloadedDeclarations: [],
                    referencedDeclaration: 255010,
                    src: "279:9:126",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8"
                    }
                  }
                ],
                id: 255016,
                kind: "baseConstructorSpecifier",
                modifierName: {
                  id: 255012,
                  name: "ERC20",
                  nodeType: "IdentifierPath",
                  referencedDeclaration: 30350,
                  src: "257:5:126"
                },
                nodeType: "ModifierInvocation",
                src: "257:32:126"
              }
            ],
            name: "",
            nameLocation: "-1:-1:-1",
            parameters: {
              id: 255011,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 255006,
                  mutability: "mutable",
                  name: "_name",
                  nameLocation: "189:5:126",
                  nodeType: "VariableDeclaration",
                  scope: 255019,
                  src: "175:19:126",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 255005,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "175:6:126",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 255008,
                  mutability: "mutable",
                  name: "_symbol",
                  nameLocation: "218:7:126",
                  nodeType: "VariableDeclaration",
                  scope: 255019,
                  src: "204:21:126",
                  stateVariable: false,
                  storageLocation: "memory",
                  typeDescriptions: {
                    typeIdentifier: "t_string_memory_ptr",
                    typeString: "string"
                  },
                  typeName: {
                    id: 255007,
                    name: "string",
                    nodeType: "ElementaryTypeName",
                    src: "204:6:126",
                    typeDescriptions: {
                      typeIdentifier: "t_string_storage_ptr",
                      typeString: "string"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 255010,
                  mutability: "mutable",
                  name: "_decimals",
                  nameLocation: "241:9:126",
                  nodeType: "VariableDeclaration",
                  scope: 255019,
                  src: "235:15:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint8",
                    typeString: "uint8"
                  },
                  typeName: {
                    id: 255009,
                    name: "uint8",
                    nodeType: "ElementaryTypeName",
                    src: "235:5:126",
                    typeDescriptions: {
                      typeIdentifier: "t_uint8",
                      typeString: "uint8"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "165:91:126"
            },
            returnParameters: {
              id: 255017,
              nodeType: "ParameterList",
              parameters: [],
              src: "290:0:126"
            },
            scope: 255085,
            stateMutability: "nonpayable",
            virtual: false,
            visibility: "public"
          },
          {
            id: 255032,
            nodeType: "FunctionDefinition",
            src: "298:89:126",
            nodes: [],
            body: {
              id: 255031,
              nodeType: "Block",
              src: "354:33:126",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 255027,
                        name: "to",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 255021,
                        src: "370:2:126",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        id: 255028,
                        name: "value",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 255023,
                        src: "374:5:126",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 255026,
                      name: "_mint",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 30321,
                      src: "364:5:126",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        typeString: "function (address,uint256)"
                      }
                    },
                    id: 255029,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "364:16:126",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 255030,
                  nodeType: "ExpressionStatement",
                  src: "364:16:126"
                }
              ]
            },
            functionSelector: "40c10f19",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "mint",
            nameLocation: "307:4:126",
            parameters: {
              id: 255024,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 255021,
                  mutability: "mutable",
                  name: "to",
                  nameLocation: "320:2:126",
                  nodeType: "VariableDeclaration",
                  scope: 255032,
                  src: "312:10:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 255020,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "312:7:126",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 255023,
                  mutability: "mutable",
                  name: "value",
                  nameLocation: "332:5:126",
                  nodeType: "VariableDeclaration",
                  scope: 255032,
                  src: "324:13:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 255022,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "324:7:126",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "311:27:126"
            },
            returnParameters: {
              id: 255025,
              nodeType: "ParameterList",
              parameters: [],
              src: "354:0:126"
            },
            scope: 255085,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "public"
          },
          {
            id: 255052,
            nodeType: "FunctionDefinition",
            src: "393:165:126",
            nodes: [],
            body: {
              id: 255051,
              nodeType: "Block",
              src: "476:82:126",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        id: 255040,
                        name: "spender",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 255034,
                        src: "494:7:126",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 255048,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          baseExpression: {
                            baseExpression: {
                              id: 255041,
                              name: "allowance",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 29992,
                              src: "503:9:126",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                                typeString: "mapping(address => mapping(address => uint256))"
                              }
                            },
                            id: 255044,
                            indexExpression: {
                              expression: {
                                id: 255042,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: "513:3:126",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg"
                                }
                              },
                              id: 255043,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              src: "513:10:126",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "503:21:126",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
                              typeString: "mapping(address => uint256)"
                            }
                          },
                          id: 255046,
                          indexExpression: {
                            id: 255045,
                            name: "spender",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 255034,
                            src: "525:7:126",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "503:30:126",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "+",
                        rightExpression: {
                          id: 255047,
                          name: "increaseAmount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 255036,
                          src: "536:14:126",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "503:47:126",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 255039,
                      name: "approve",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 30065,
                      src: "486:7:126",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
                        typeString: "function (address,uint256) returns (bool)"
                      }
                    },
                    id: 255049,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "486:65:126",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 255050,
                  nodeType: "ExpressionStatement",
                  src: "486:65:126"
                }
              ]
            },
            functionSelector: "39509351",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "increaseAllowance",
            nameLocation: "402:17:126",
            parameters: {
              id: 255037,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 255034,
                  mutability: "mutable",
                  name: "spender",
                  nameLocation: "428:7:126",
                  nodeType: "VariableDeclaration",
                  scope: 255052,
                  src: "420:15:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 255033,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "420:7:126",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 255036,
                  mutability: "mutable",
                  name: "increaseAmount",
                  nameLocation: "445:14:126",
                  nodeType: "VariableDeclaration",
                  scope: 255052,
                  src: "437:22:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 255035,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "437:7:126",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "419:41:126"
            },
            returnParameters: {
              id: 255038,
              nodeType: "ParameterList",
              parameters: [],
              src: "476:0:126"
            },
            scope: 255085,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "public"
          },
          {
            id: 255084,
            nodeType: "FunctionDefinition",
            src: "564:307:126",
            nodes: [],
            body: {
              id: 255083,
              nodeType: "Block",
              src: "647:224:126",
              nodes: [],
              statements: [
                {
                  expression: {
                    arguments: [
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 255067,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          baseExpression: {
                            baseExpression: {
                              id: 255060,
                              name: "allowance",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 29992,
                              src: "678:9:126",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                                typeString: "mapping(address => mapping(address => uint256))"
                              }
                            },
                            id: 255063,
                            indexExpression: {
                              expression: {
                                id: 255061,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: "688:3:126",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg"
                                }
                              },
                              id: 255062,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              src: "688:10:126",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "678:21:126",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
                              typeString: "mapping(address => uint256)"
                            }
                          },
                          id: 255065,
                          indexExpression: {
                            id: 255064,
                            name: "spender",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 255054,
                            src: "700:7:126",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "678:30:126",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: ">=",
                        rightExpression: {
                          id: 255066,
                          name: "decreaseAmount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 255056,
                          src: "712:14:126",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "678:48:126",
                        typeDescriptions: {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        }
                      },
                      {
                        hexValue: "45524332303a2064656372656173656420616c6c6f77616e63652062656c6f77207a65726f",
                        id: 255068,
                        isConstant: false,
                        isLValue: false,
                        isPure: true,
                        kind: "string",
                        lValueRequested: false,
                        nodeType: "Literal",
                        src: "740:39:126",
                        typeDescriptions: {
                          typeIdentifier: "t_stringliteral_f8b476f7d28209d77d4a4ac1fe36b9f8259aa1bb6bddfa6e89de7e51615cf8a8",
                          typeString: 'literal_string "ERC20: decreased allowance below zero"'
                        },
                        value: "ERC20: decreased allowance below zero"
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_bool",
                          typeString: "bool"
                        },
                        {
                          typeIdentifier: "t_stringliteral_f8b476f7d28209d77d4a4ac1fe36b9f8259aa1bb6bddfa6e89de7e51615cf8a8",
                          typeString: 'literal_string "ERC20: decreased allowance below zero"'
                        }
                      ],
                      id: 255059,
                      name: "require",
                      nodeType: "Identifier",
                      overloadedDeclarations: [-18, -18],
                      referencedDeclaration: -18,
                      src: "657:7:126",
                      typeDescriptions: {
                        typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        typeString: "function (bool,string memory) pure"
                      }
                    },
                    id: 255069,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "657:132:126",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_tuple$__$",
                      typeString: "tuple()"
                    }
                  },
                  id: 255070,
                  nodeType: "ExpressionStatement",
                  src: "657:132:126"
                },
                {
                  expression: {
                    arguments: [
                      {
                        id: 255072,
                        name: "spender",
                        nodeType: "Identifier",
                        overloadedDeclarations: [],
                        referencedDeclaration: 255054,
                        src: "807:7:126",
                        typeDescriptions: {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        }
                      },
                      {
                        commonType: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        },
                        id: 255080,
                        isConstant: false,
                        isLValue: false,
                        isPure: false,
                        lValueRequested: false,
                        leftExpression: {
                          baseExpression: {
                            baseExpression: {
                              id: 255073,
                              name: "allowance",
                              nodeType: "Identifier",
                              overloadedDeclarations: [],
                              referencedDeclaration: 29992,
                              src: "816:9:126",
                              typeDescriptions: {
                                typeIdentifier: "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                                typeString: "mapping(address => mapping(address => uint256))"
                              }
                            },
                            id: 255076,
                            indexExpression: {
                              expression: {
                                id: 255074,
                                name: "msg",
                                nodeType: "Identifier",
                                overloadedDeclarations: [],
                                referencedDeclaration: -15,
                                src: "826:3:126",
                                typeDescriptions: {
                                  typeIdentifier: "t_magic_message",
                                  typeString: "msg"
                                }
                              },
                              id: 255075,
                              isConstant: false,
                              isLValue: false,
                              isPure: false,
                              lValueRequested: false,
                              memberName: "sender",
                              nodeType: "MemberAccess",
                              src: "826:10:126",
                              typeDescriptions: {
                                typeIdentifier: "t_address",
                                typeString: "address"
                              }
                            },
                            isConstant: false,
                            isLValue: true,
                            isPure: false,
                            lValueRequested: false,
                            nodeType: "IndexAccess",
                            src: "816:21:126",
                            typeDescriptions: {
                              typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
                              typeString: "mapping(address => uint256)"
                            }
                          },
                          id: 255078,
                          indexExpression: {
                            id: 255077,
                            name: "spender",
                            nodeType: "Identifier",
                            overloadedDeclarations: [],
                            referencedDeclaration: 255054,
                            src: "838:7:126",
                            typeDescriptions: {
                              typeIdentifier: "t_address",
                              typeString: "address"
                            }
                          },
                          isConstant: false,
                          isLValue: true,
                          isPure: false,
                          lValueRequested: false,
                          nodeType: "IndexAccess",
                          src: "816:30:126",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        nodeType: "BinaryOperation",
                        operator: "-",
                        rightExpression: {
                          id: 255079,
                          name: "decreaseAmount",
                          nodeType: "Identifier",
                          overloadedDeclarations: [],
                          referencedDeclaration: 255056,
                          src: "849:14:126",
                          typeDescriptions: {
                            typeIdentifier: "t_uint256",
                            typeString: "uint256"
                          }
                        },
                        src: "816:47:126",
                        typeDescriptions: {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      }
                    ],
                    expression: {
                      argumentTypes: [
                        {
                          typeIdentifier: "t_address",
                          typeString: "address"
                        },
                        {
                          typeIdentifier: "t_uint256",
                          typeString: "uint256"
                        }
                      ],
                      id: 255071,
                      name: "approve",
                      nodeType: "Identifier",
                      overloadedDeclarations: [],
                      referencedDeclaration: 30065,
                      src: "799:7:126",
                      typeDescriptions: {
                        typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
                        typeString: "function (address,uint256) returns (bool)"
                      }
                    },
                    id: 255081,
                    isConstant: false,
                    isLValue: false,
                    isPure: false,
                    kind: "functionCall",
                    lValueRequested: false,
                    names: [],
                    nodeType: "FunctionCall",
                    src: "799:65:126",
                    tryCall: false,
                    typeDescriptions: {
                      typeIdentifier: "t_bool",
                      typeString: "bool"
                    }
                  },
                  id: 255082,
                  nodeType: "ExpressionStatement",
                  src: "799:65:126"
                }
              ]
            },
            functionSelector: "a457c2d7",
            implemented: true,
            kind: "function",
            modifiers: [],
            name: "decreaseAllowance",
            nameLocation: "573:17:126",
            parameters: {
              id: 255057,
              nodeType: "ParameterList",
              parameters: [
                {
                  constant: false,
                  id: 255054,
                  mutability: "mutable",
                  name: "spender",
                  nameLocation: "599:7:126",
                  nodeType: "VariableDeclaration",
                  scope: 255084,
                  src: "591:15:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_address",
                    typeString: "address"
                  },
                  typeName: {
                    id: 255053,
                    name: "address",
                    nodeType: "ElementaryTypeName",
                    src: "591:7:126",
                    stateMutability: "nonpayable",
                    typeDescriptions: {
                      typeIdentifier: "t_address",
                      typeString: "address"
                    }
                  },
                  visibility: "internal"
                },
                {
                  constant: false,
                  id: 255056,
                  mutability: "mutable",
                  name: "decreaseAmount",
                  nameLocation: "616:14:126",
                  nodeType: "VariableDeclaration",
                  scope: 255084,
                  src: "608:22:126",
                  stateVariable: false,
                  storageLocation: "default",
                  typeDescriptions: {
                    typeIdentifier: "t_uint256",
                    typeString: "uint256"
                  },
                  typeName: {
                    id: 255055,
                    name: "uint256",
                    nodeType: "ElementaryTypeName",
                    src: "608:7:126",
                    typeDescriptions: {
                      typeIdentifier: "t_uint256",
                      typeString: "uint256"
                    }
                  },
                  visibility: "internal"
                }
              ],
              src: "590:41:126"
            },
            returnParameters: {
              id: 255058,
              nodeType: "ParameterList",
              parameters: [],
              src: "647:0:126"
            },
            scope: 255085,
            stateMutability: "nonpayable",
            virtual: true,
            visibility: "public"
          }
        ],
        abstract: false,
        baseContracts: [
          {
            baseName: {
              id: 255003,
              name: "ERC20",
              nodeType: "IdentifierPath",
              referencedDeclaration: 30350,
              src: "142:5:126"
            },
            id: 255004,
            nodeType: "InheritanceSpecifier",
            src: "142:5:126"
          }
        ],
        canonicalName: "TestnetERC20",
        contractDependencies: [],
        contractKind: "contract",
        fullyImplemented: true,
        linearizedBaseContracts: [255085, 30350],
        name: "TestnetERC20",
        nameLocation: "126:12:126",
        scope: 255086,
        usedErrors: []
      }
    ],
    license: "AGPL-3.0-only"
  },
  id: 126
};

// src/abis/sources/index.ts
var errors = [
  EncryptedMarginalPrice_default.abi,
  FixedPriceBatch_default.abi,
  LinearVesting_default.abi
].flatMap((e) => e.filter((e2) => e2.type === "error"));
var batchAuctionHouse = {
  abi: [...BatchAuctionHouse_default.abi, ...errors]
};
export {
  abis_default as abis,
  TestnetERC20_default as testnetERC20
};
//# sourceMappingURL=index.js.map